import React from "react";
import { useAuth } from "../context/Auth";
export const Wallicon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="107"
        height="62"
        style={props.style}
        className={props.className}
        viewBox="0 0 107 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_325_499)">
          <path
            opacity="0.5"
            d="M37.1494 24.8814L42.8481 35.3944L44.0263 32.2812L39.3856 23.708L37.1494 24.8814Z"
            fill="#0A0A0A"
          />
          <path
            d="M50.9508 17.5056L54.5095 15.6377L52.0088 21.2414L45.685 35.3944H42.8477L44.3384 31.5388L50.9508 17.5056Z"
            fill="#0A0A0A"
          />
          <path
            opacity="0.5"
            d="M61.6993 35.4662L63.5507 30.5091L54.5098 15.6377L52.0332 21.1935L61.6993 35.4662Z"
            fill="#0A0A0A"
          />
          <path
            d="M61.6992 35.4662H66.4361L69.1532 29.7907L74.3228 18.8946L80.2379 6.41792L83.3397 0L72.832 5.62766L61.6992 35.4662Z"
            fill="#0A0A0A"
          />
          <path
            d="M0.000130463 42.9138C-0.00679934 42.8806 -0.00654212 42.8462 0.000884895 42.8131C0.00831191 42.7799 0.0227387 42.7487 0.043207 42.7215C0.0636753 42.6943 0.0897167 42.6718 0.119601 42.6554C0.149485 42.639 0.182528 42.6292 0.216535 42.6265H4.71294C4.71294 42.6265 5.24193 42.4828 5.50642 43.9196L7.91092 52.1576C8.09518 52.88 8.31995 53.5915 8.58418 54.2889L10.0509 49.9783L11.3493 46.3623L12.3111 43.5604C12.3111 43.5604 12.5756 42.6744 13.1287 42.5546C13.8402 42.626 14.5571 42.626 15.2687 42.5546C15.6427 42.4915 16.0271 42.566 16.3501 42.7642C16.673 42.9625 16.9125 43.271 17.024 43.6323C17.024 43.6323 17.3606 45.0452 17.6732 46.027L19.6929 51.7026L20.5345 54.2889C20.5345 54.2889 20.799 54.4086 20.8471 53.8099L22.2417 48.8289L23.4199 44.5423L23.8046 43.0336C23.8757 42.8913 23.9922 42.7765 24.1357 42.7072C24.2793 42.6378 24.4419 42.6179 24.5981 42.6504H28.2529C28.2529 42.6504 28.6617 42.6504 28.5415 43.2251L27.9644 45.2367L27.0507 48.1823L25.055 54.6481L23.7565 58.9826L23.1073 61.09C23.1073 61.09 22.9871 61.545 22.6986 61.545C21.8948 61.5428 21.0918 61.5908 20.2941 61.6886C19.7164 61.7537 19.1333 61.6275 18.635 61.3294C18.3418 61.0683 18.1327 60.7267 18.0338 60.3476L17.601 58.7431C17.4379 58.1591 17.2453 57.5836 17.024 57.0189L15.1004 51.3433L14.4271 49.3318L11.8302 56.7555L10.4116 60.9223C10.3688 61.0546 10.2936 61.1742 10.1929 61.2703C10.0922 61.3665 9.96901 61.4361 9.83451 61.4731H9.30552C8.68889 61.4375 8.0707 61.4375 7.45406 61.4731H6.61249C6.32846 61.4596 6.0545 61.3641 5.82398 61.1982C5.59345 61.0324 5.41629 60.8034 5.31406 60.5392C5.04645 59.8987 4.88407 59.2195 4.83316 58.5276C4.70579 58.0149 4.54515 57.5109 4.35227 57.0189L3.39047 53.8339L2.18822 49.8347L0.216535 43.273L0.0963102 43.1294C0.0517159 43.0637 0.0191524 42.9908 0.000130463 42.9138Z"
            fill="#0A0A0A"
          />
          <path
            d="M42.4632 60.18V59.3418C42.4632 58.8149 42.2468 58.8149 42.2468 58.8149H41.8621C41.6718 58.8444 41.4773 58.8018 41.317 58.6954C41.1567 58.5889 41.0424 58.4265 40.9965 58.2402V53.7381C41.045 53.1324 41.045 52.5238 40.9965 51.9181C40.8682 51.3203 40.613 50.7567 40.2481 50.2652C39.8832 49.7737 39.4169 49.3656 38.8805 49.0683C37.6844 48.4713 36.3333 48.254 35.0093 48.4457C33.6199 48.631 32.2894 49.1218 31.114 49.8825C31.0223 49.9374 30.9528 50.0226 30.9176 50.1232C30.8824 50.2239 30.8839 50.3336 30.9217 50.4333L31.643 51.6307L32.0037 52.2773C32.2201 52.6365 32.6048 52.2773 32.6048 52.2773C33.3493 51.7166 34.2455 51.3913 35.1776 51.3433C35.8481 51.2689 36.523 51.4391 37.0772 51.8223C37.3451 52.062 37.5554 52.3587 37.6928 52.6903C37.8301 53.0219 37.8909 53.38 37.8707 53.7381C37.8707 54.1931 37.1974 54.1212 37.1974 54.1212H36.428H35.899C34.9405 54.1485 33.9848 54.2365 33.0376 54.3847C32.1318 54.5288 31.2924 54.9468 30.6331 55.582C30.2839 55.9909 30.0266 56.4695 29.8786 56.9856C29.7305 57.5018 29.6952 58.0435 29.7749 58.5744C29.8547 59.1053 30.0476 59.613 30.3408 60.0635C30.634 60.5139 31.0206 60.8966 31.4747 61.1858C32.5139 61.8562 33.7556 62.1442 34.9853 62C36.2561 61.8229 37.4231 61.2036 38.2794 60.2518C38.5345 60.7252 38.9288 61.1096 39.4095 61.3534C40.212 61.7536 41.1219 61.8879 42.0064 61.7365C42.1101 61.7295 42.2111 61.7001 42.3024 61.6505C42.3938 61.6009 42.4732 61.5322 42.5354 61.4492C42.5894 61.0253 42.565 60.5951 42.4632 60.18ZM37.8707 56.971C37.9324 57.2389 37.9324 57.5173 37.8707 57.7852C37.6735 58.2768 37.3184 58.6894 36.8608 58.9586C36.3045 59.3015 35.6635 59.4839 35.0093 59.4855C34.6287 59.5109 34.2481 59.4358 33.9061 59.2675C33.564 59.0993 33.2727 58.844 33.0617 58.5276C32.9438 58.3149 32.882 58.076 32.882 57.8331C32.882 57.5902 32.9438 57.3513 33.0617 57.1386C33.3996 56.88 33.7958 56.7074 34.2158 56.6357C34.9082 56.5126 35.6064 56.4247 36.3077 56.3723H37.2695C37.7264 56.3723 37.7023 56.5399 37.7023 56.5399L37.8707 56.971Z"
            fill="#0A0A0A"
          />
          <path
            d="M44.8438 52.2773V44.662C44.8438 44.662 44.8438 44.1831 45.4449 44.2549H47.8494C47.8494 44.2549 48.0898 44.2549 48.0898 44.5662V61.3294C48.0898 61.3993 48.062 61.4663 48.0123 61.5157C47.9627 61.5651 47.8955 61.5929 47.8253 61.5929H45.2044C45.1633 61.5961 45.122 61.5913 45.0828 61.5786C45.0437 61.5659 45.0074 61.5456 44.9761 61.5189C44.9448 61.4922 44.9191 61.4596 44.9006 61.423C44.882 61.3863 44.8708 61.3464 44.8678 61.3055L44.8438 52.2773Z"
            fill="#0A0A0A"
          />
          <path
            d="M51.3604 52.2773V44.662C51.3604 44.662 51.3604 44.1831 51.9615 44.2549H54.366C54.4039 44.2579 54.4409 44.2684 54.4747 44.2857C54.5086 44.303 54.5387 44.3268 54.5633 44.3557C54.5879 44.3847 54.6065 44.4182 54.618 44.4543C54.6295 44.4904 54.6338 44.5285 54.6305 44.5662V61.3294C54.6305 61.3993 54.6026 61.4663 54.553 61.5157C54.5034 61.5651 54.4361 61.5929 54.366 61.5929H51.721C51.68 61.5961 51.6386 61.5913 51.5994 61.5786C51.5603 61.5659 51.524 61.5456 51.4927 61.5189C51.4614 61.4922 51.4357 61.4596 51.4172 61.423C51.3986 61.3863 51.3874 61.3464 51.3844 61.3055L51.3604 52.2773Z"
            fill="#0A0A0A"
          />
          <path
            d="M57.9727 54.8397V49.0923C57.9838 49.0032 58.026 48.9208 58.0919 48.8596C58.1579 48.7983 58.2433 48.762 58.3333 48.7571H61.0264C61.0264 48.7571 61.2668 48.7571 61.2668 49.1402V61.4013C61.2668 61.4013 61.2668 61.6169 61.0985 61.6648H58.1891C58.1891 61.6648 57.9727 61.6648 57.9727 61.3774V54.8397Z"
            fill="#0A0A0A"
          />
          <path
            d="M59.6073 47.4398C60.6299 47.4398 61.4588 46.625 61.4588 45.6198C61.4588 44.6146 60.6299 43.7998 59.6073 43.7998C58.5848 43.7998 57.7559 44.6146 57.7559 45.6198C57.7559 46.625 58.5848 47.4398 59.6073 47.4398Z"
            fill="#0A0A0A"
          />
          <path
            d="M74.7794 52.7562L76.8954 51.2954C76.3368 50.5317 75.6444 49.8746 74.8515 49.3557C73.5165 48.5111 71.9153 48.187 70.3551 48.4457C68.9597 48.5764 67.6366 49.1244 66.5595 50.0176C65.4824 50.9108 64.7017 52.1076 64.3199 53.4507C64.0796 54.4099 64.0796 55.4131 64.3199 56.3723C64.5179 57.6032 65.069 58.7509 65.9068 59.677C66.9699 60.8255 68.3952 61.5775 69.9464 61.8084C70.6805 61.9676 71.4355 62.008 72.1825 61.9281C73.545 61.7824 74.8212 61.1932 75.8133 60.2518C76.1039 59.9905 76.377 59.7105 76.6309 59.4136C76.6309 59.4136 76.8713 59.246 76.6309 58.9586C76.331 58.6286 75.9823 58.3459 75.5969 58.1205L74.8996 57.5697C74.811 57.4889 74.6952 57.4441 74.575 57.4441C74.4549 57.4441 74.3391 57.4889 74.2504 57.5697C73.5697 58.3389 72.611 58.8085 71.5837 58.8758C70.5564 58.9431 69.5442 58.6027 68.7682 57.9289C68.6362 57.8215 68.5154 57.7011 68.4075 57.5697C67.7471 56.8068 67.4105 55.8181 67.4688 54.8126C67.5271 53.807 67.9759 52.8635 68.7201 52.1815C69.2162 51.7669 69.8037 51.4748 70.4346 51.3292C71.0656 51.1835 71.7222 51.1884 72.3509 51.3433C72.6294 51.4074 72.8968 51.5123 73.1443 51.6546C73.4077 51.8083 73.6571 51.9846 73.8897 52.1815L74.4187 52.7083C74.4679 52.7499 74.5281 52.7765 74.592 52.785C74.6559 52.7935 74.721 52.7835 74.7794 52.7562Z"
            fill="#0A0A0A"
          />
          <path
            d="M85.215 48.4217C83.8806 48.4734 82.591 48.915 81.5068 49.6914C80.4226 50.4679 79.5918 51.5449 79.1178 52.7883C78.6439 54.0317 78.5477 55.3864 78.8413 56.6839C79.135 57.9813 79.8054 59.164 80.7691 60.0846C81.7329 61.0053 82.9473 61.6232 84.2611 61.8613C85.5749 62.0994 86.93 61.9473 88.1576 61.4239C89.3852 60.9005 90.4311 60.0289 91.1649 58.9177C91.8986 57.8065 92.2879 56.5048 92.2842 55.1749C92.2717 54.2713 92.0798 53.3792 91.7196 52.5498C91.3594 51.7205 90.8379 50.9703 90.1852 50.3426C89.5326 49.7148 88.7617 49.2219 87.9169 48.8922C87.0721 48.5626 86.1702 48.4026 85.2631 48.4217H85.215ZM85.215 59.0304C84.4448 59.0445 83.6877 58.8308 83.0394 58.4163C82.3911 58.0019 81.8807 57.4053 81.5729 56.702C81.265 55.9987 81.1734 55.2203 81.3097 54.4651C81.446 53.71 81.8041 53.0121 82.3386 52.4596C82.8732 51.9072 83.5602 51.525 84.3128 51.3613C85.0655 51.1977 85.8499 51.26 86.567 51.5404C87.2841 51.8208 87.9016 52.3066 88.3414 52.9365C88.7813 53.5664 89.0238 54.312 89.0381 55.0791C89.051 56.0912 88.6613 57.0673 87.9539 57.7942C87.2466 58.5211 86.2793 58.9397 85.2631 58.9586L85.215 59.0304Z"
            fill="#0A0A0A"
          />
          <path
            d="M95.0732 54.1212V49.0922C95.0732 49.0922 95.0732 48.6612 95.4339 48.6612H97.9827C98.09 48.6538 98.1963 48.6865 98.2808 48.7529C98.3653 48.8193 98.4218 48.9147 98.4395 49.0204V49.7867C99.0314 49.233 99.7492 48.8304 100.531 48.6133C101.312 48.4005 102.13 48.361 102.928 48.4976C103.726 48.6341 104.484 48.9434 105.148 49.4036C105.793 49.9034 106.305 50.553 106.639 51.2954C106.815 51.7932 106.944 52.3063 107.024 52.828V61.4012C107.024 61.4012 107.024 61.5449 107.024 61.5689H104.018C104.018 61.5689 103.753 61.5689 103.778 61.0899V53.738C103.753 53.2047 103.568 52.691 103.246 52.2638C102.925 51.8367 102.481 51.5159 101.974 51.3433C101.426 51.1703 100.837 51.1719 100.29 51.3479C99.7423 51.5239 99.2637 51.8655 98.9204 52.3251C98.5126 52.9479 98.342 53.6954 98.4395 54.4325V61.1618C98.4497 61.2234 98.447 61.2865 98.4316 61.347C98.4163 61.4076 98.3886 61.4643 98.3502 61.5137C98.3119 61.5632 98.2637 61.6042 98.2088 61.6343C98.1538 61.6644 98.0932 61.6829 98.0308 61.6886H97.0449C96.5733 61.6407 96.0979 61.6407 95.6263 61.6886C95.6263 61.6886 95.0492 61.6886 95.1213 61.2336L95.0732 54.1212Z"
            fill="#0A0A0A"
          />
        </g>
        <defs>
          <clipPath id="clip0_325_499">
            <rect width="107" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const HomeIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Clock = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path d="M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const ThemeChange = (props) => {
  return (
    <React.Fragment>
      <svg
        width="74"
        height="28"
        viewBox="0 0 74 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <rect width="74" height="28" rx="14" fill="#FFFFFF" />
        <circle cx="56.5" cy="13.5" r="8.5" fill={props.color} />
      </svg>
    </React.Fragment>
  );
};
export const Invoice = (props) => {
  return (
    <React.Fragment>
      <svg
        width="22"
        height="28"
        viewBox="0 0 22 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M11.0833 25.2H0V0H18.6667V17.7545H17.5V1.14545H1.16667V24.0545H11.0833V25.2Z"
          fill={props.color}
        />
        <path
          d="M14.9329 3.7334H5.59961V4.66673H14.9329V3.7334Z"
          fill={props.color}
        />
        <path
          d="M4.66771 3.7334H3.73438V4.66673H4.66771V3.7334Z"
          fill={props.color}
        />
        <path
          d="M14.9329 6.53369H5.59961V7.46702H14.9329V6.53369Z"
          fill={props.color}
        />
        <path
          d="M4.66771 6.53369H3.73438V7.46702H4.66771V6.53369Z"
          fill={props.color}
        />
        <path
          d="M14.9329 10.2666H5.59961V11.1999H14.9329V10.2666Z"
          fill={props.color}
        />
        <path
          d="M4.66771 10.2666H3.73438V11.1999H4.66771V10.2666Z"
          fill={props.color}
        />
        <path d="M14.9329 14H5.59961V14.9333H14.9329V14Z" fill={props.color} />
        <path d="M4.66771 14H3.73438V14.9333H4.66771V14Z" fill={props.color} />
        <path
          d="M11.1996 16.8003H5.59961V17.7336H11.1996V16.8003Z"
          fill={props.color}
        />
        <path
          d="M4.66771 16.8003H3.73438V17.7336H4.66771V16.8003Z"
          fill={props.color}
        />
        <line
          x1="18.3146"
          y1="21.4663"
          x2="18.3146"
          y2="27.9996"
          stroke={props.color}
          strokeWidth="1.16036"
        />
        <line
          x1="14.9336"
          y1="24.6195"
          x2="21.4669"
          y2="24.6195"
          stroke={props.color}
          strokeWidth="1.16036"
        />
      </svg>
    </React.Fragment>
  );
};
export const BellIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="26"
        height="28"
        viewBox="0 0 26 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M10.3918 1.74964C10.5994 1.2327 10.9553 0.789985 11.4141 0.47826C11.8728 0.166536 12.4135 0 12.9668 0C13.5201 0 14.0608 0.166536 14.5195 0.47826C14.9783 0.789985 15.3342 1.2327 15.5418 1.74964C17.5955 2.31894 19.4071 3.55203 20.6983 5.25954C21.9894 6.96705 22.6888 9.05456 22.6889 11.2015V17.7766L25.2333 21.6234C25.3728 21.8342 25.453 22.0792 25.4652 22.3324C25.4774 22.5855 25.4212 22.8372 25.3025 23.0607C25.1839 23.2841 25.0073 23.4709 24.7916 23.6012C24.5759 23.7314 24.3292 23.8002 24.0777 23.8001H17.7792C17.612 24.9663 17.0335 26.0328 16.1497 26.8041C15.2658 27.5755 14.1359 28 12.9668 28C11.7977 28 10.6678 27.5755 9.78393 26.8041C8.90011 26.0328 8.3216 24.9663 8.15438 23.8001H1.85587C1.60443 23.8002 1.35769 23.7314 1.14198 23.6012C0.926274 23.4709 0.749689 23.2841 0.631066 23.0607C0.512443 22.8372 0.456234 22.5855 0.468433 22.3324C0.480632 22.0792 0.560783 21.8342 0.700334 21.6234L3.24474 17.7766V11.2015C3.24474 6.68832 6.27246 2.88632 10.3918 1.74964ZM11.0029 23.8001C11.1464 24.2098 11.4124 24.5645 11.7642 24.8155C12.1161 25.0664 12.5365 25.2011 12.9675 25.2011C13.3985 25.2011 13.8189 25.0664 14.1708 24.8155C14.5226 24.5645 14.7886 24.2098 14.932 23.8001H11.0016H11.0029ZM12.9668 4.20219C11.125 4.20219 9.35873 4.93961 8.05642 6.25222C6.7541 7.56484 6.02247 9.34513 6.02247 11.2015V18.2007C6.02253 18.4772 5.94134 18.7476 5.78914 18.9776L4.45166 21.0004H21.4805L20.1431 18.9776C19.9914 18.7474 19.9107 18.4771 19.9111 18.2007V11.2015C19.9111 9.34513 19.1795 7.56484 17.8772 6.25222C16.5749 4.93961 14.8085 4.20219 12.9668 4.20219Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const FullScreen = (props) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M1.4668 7.25V2H6.7168M1.4668 2L7.30013 7.775L1.4668 2ZM1.4668 22.9417L7.30013 17.1667L1.4668 22.9417ZM22.4668 22.9417L16.6918 17.1667L22.4668 22.9417ZM22.4085 2L16.6335 7.775L22.4085 2ZM17.2168 2H22.4668V7.25L17.2168 2ZM22.4668 17.75V23H17.2168L22.4668 17.75ZM6.7168 23H1.4668V17.75L6.7168 23Z"
          stroke={props.color}
          strokeWidth="2.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const User = (props) => {
  return (
    <React.Fragment>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <g clipPath="url(#clip0_3205_4030)">
          <path
            d="M18.2831 13.7757C20.098 12.362 21.267 10.1714 21.267 7.71417C21.2667 3.46032 17.7679 0 13.4668 0C9.16568 0 5.66691 3.46032 5.66691 7.71417C5.66691 10.1712 6.83562 12.362 8.6508 13.7757C3.86046 15.6727 0.466797 20.3078 0.466797 25.7143C0.466797 26.4249 1.04883 27 1.76682 27C2.48481 27 3.06685 26.4249 3.06685 25.7143C3.06685 20.0429 7.73243 15.4286 13.4668 15.4286C19.2012 15.4286 23.8667 20.0429 23.8667 25.7143C23.8667 26.4249 24.4488 27 25.1668 27C25.8848 27 26.4668 26.4249 26.4668 25.7143C26.4668 20.3078 23.0731 15.6727 18.2831 13.7757ZM8.26669 7.71417C8.26669 4.87836 10.5995 2.57121 13.4668 2.57121C16.3341 2.57121 18.6669 4.87836 18.6669 7.71417C18.6669 10.55 16.3341 12.8571 13.4668 12.8571C10.5995 12.8571 8.26669 10.55 8.26669 7.71417Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_3205_4030">
            <rect
              width="27"
              height="28"
              fill="white"
              transform="translate(0.466797)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const DashBoard = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <g clipPath="url(#clip0_4421_11833)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.05078 4.22917C4.05078 3.61934 4.54513 3.125 5.15495 3.125H16.6958C17.3066 3.125 17.8008 3.61954 17.8008 4.22917V12.437C17.8009 12.582 17.7723 12.7257 17.7169 12.8597C17.6614 12.9937 17.5801 13.1155 17.4776 13.2181C17.375 13.3207 17.2533 13.402 17.1193 13.4576C16.9853 13.5131 16.8417 13.5417 16.6966 13.5417H13.4419C13.432 13.5414 13.4221 13.5414 13.4122 13.5417H8.4413C8.43137 13.5414 8.42147 13.5414 8.41161 13.5417H5.15495C4.8621 13.5417 4.58126 13.4253 4.37418 13.2183C4.16711 13.0112 4.05078 12.7303 4.05078 12.4375V4.22917ZM7.62643 14.7917H5.15495C4.53058 14.7917 3.93179 14.5436 3.4903 14.1021C3.04881 13.6607 2.80078 13.0619 2.80078 12.4375V4.22917C2.80078 2.92899 3.85477 1.875 5.15495 1.875H16.6958C17.9966 1.875 19.0508 2.92879 19.0508 4.22917V12.4364C19.0509 12.7455 18.9901 13.052 18.8719 13.3376C18.7537 13.6234 18.5803 13.883 18.3617 14.1017C18.143 14.3205 17.8835 14.494 17.5978 14.6124C17.3121 14.7307 17.0059 14.7917 16.6966 14.7917H14.2271L14.8662 17.3484C14.95 17.6833 14.7464 18.0226 14.4115 18.1063C14.0766 18.19 13.7373 17.9864 13.6536 17.6516L12.9386 14.7917H10.9258H8.9149L8.19993 17.6516C8.11621 17.9864 7.77687 18.19 7.442 18.1063C7.10713 18.0226 6.90353 17.6833 6.98725 17.3484L7.62643 14.7917Z"
            fill={props.color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3004 5.8334C10.3004 5.48823 10.0205 5.2084 9.67536 5.2084C9.33019 5.2084 9.05036 5.48823 9.05036 5.8334V10.8334C9.05036 11.1786 9.33019 11.4584 9.67536 11.4584C10.0205 11.4584 10.3004 11.1786 10.3004 10.8334V5.8334ZM7.80086 8.55845C7.80086 8.21327 7.52104 7.93345 7.17586 7.93345C6.83068 7.93345 6.55086 8.21327 6.55086 8.55845V10.8335C6.55086 11.1786 6.83068 11.4585 7.17586 11.4585C7.52104 11.4585 7.80086 11.1786 7.80086 10.8335V8.55845ZM12.1761 7.44169C12.5212 7.44169 12.8011 7.72151 12.8011 8.06669V10.8334C12.8011 11.1785 12.5212 11.4584 12.1761 11.4584C11.8309 11.4584 11.5511 11.1785 11.5511 10.8334V8.06669C11.5511 7.72151 11.8309 7.44169 12.1761 7.44169ZM15.3006 6.29167C15.3006 5.94649 15.0208 5.66667 14.6756 5.66667C14.3304 5.66667 14.0506 5.94649 14.0506 6.29167V10.8333C14.0506 11.1785 14.3304 11.4583 14.6756 11.4583C15.0208 11.4583 15.3006 11.1785 15.3006 10.8333V6.29167Z"
            fill={props.color}
          />
        </g>
        <defs>
          <clipPath id="clip0_4421_11833">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0.925781)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const Dealers = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 20 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M11.5883 5.80785C12.1867 5.32913 12.572 4.58737 12.572 3.75527C12.572 2.31482 11.4185 1.14307 10.0006 1.14307C8.58261 1.14307 7.42917 2.31482 7.42917 3.75527C7.42917 4.58728 7.81446 5.32913 8.41287 5.80785C6.83364 6.45023 5.71484 8.01978 5.71484 9.85055C5.71484 10.0912 5.90672 10.2859 6.14342 10.2859C6.38012 10.2859 6.57201 10.0912 6.57201 9.85055C6.57201 7.93009 8.11011 6.36757 10.0006 6.36757C11.891 6.36757 13.4291 7.93009 13.4291 9.85055C13.4291 10.0912 13.621 10.2859 13.8577 10.2859C14.0944 10.2859 14.2863 10.0912 14.2863 9.85055C14.2863 8.01978 13.1675 6.45023 11.5883 5.80785ZM8.28624 3.75527C8.28624 2.795 9.05529 2.01374 10.0006 2.01374C10.9458 2.01374 11.7149 2.795 11.7149 3.75527C11.7149 4.71555 10.9458 5.49681 10.0006 5.49681C9.05529 5.49681 8.28624 4.71555 8.28624 3.75527Z"
          fill={props.color}
        />
        <path
          d="M17.3455 4.66478C17.9342 4.18606 18.3134 3.4443 18.3134 2.61221C18.3133 1.17175 17.1784 0 15.7833 0C14.3882 0 13.2533 1.17175 13.2533 2.61221C13.2533 3.44421 13.6324 4.18606 14.2212 4.66478C13.3223 5.03642 12.575 5.71837 12.1047 6.5817C11.7621 7.21065 12.3698 6.29332 12.3698 7.06494C12.3698 7.30558 12.5586 7.50032 12.7915 7.50032C13.0243 7.50032 13.2131 7.30558 13.2131 7.06494C13.2131 6.4849 12.548 7.58006 12.792 7.09852C13.3557 5.98571 14.4851 5.22451 15.7833 5.22451C17.6433 5.22451 19.1566 6.78702 19.1566 8.70748C19.1566 8.94812 19.3454 9.14287 19.5783 9.14287C19.8112 9.14287 20 8.94812 20 8.70748C20 6.87671 18.8992 5.30716 17.3455 4.66478ZM14.0966 2.61221C14.0966 1.65193 14.8533 0.870675 15.7833 0.870675C16.7134 0.870675 17.47 1.65193 17.47 2.61221C17.47 3.57248 16.7134 4.35374 15.7833 4.35374C14.8533 4.35374 14.0966 3.57248 14.0966 2.61221Z"
          fill={props.color}
        />
        <path
          d="M2.65448 4.66478C2.0658 4.18606 1.68662 3.4443 1.68662 2.61221C1.68671 1.17175 2.82158 0 4.2167 0C5.61182 0 6.74669 1.17175 6.74669 2.61221C6.74669 3.44421 6.3676 4.18606 5.77882 4.66478C6.67774 5.03642 7.42504 5.71837 7.89528 6.5817C8.23786 7.21065 7.63022 6.29332 7.63022 7.06494C7.63022 7.30558 7.44143 7.50032 7.20855 7.50032C6.97566 7.50032 6.78687 7.30558 6.78687 7.06494C6.78687 6.4849 7.45199 7.58006 7.20804 7.09852C6.64427 5.98571 5.51493 5.22451 4.2167 5.22451C2.35669 5.22451 0.843352 6.78702 0.843352 8.70748C0.843352 8.94812 0.654562 9.14287 0.421673 9.14287C0.188784 9.14287 -6.67572e-06 8.94812 -6.67572e-06 8.70748C-6.67572e-06 6.87671 1.10077 5.30716 2.65448 4.66478ZM5.90342 2.61221C5.90342 1.65193 5.14675 0.870675 4.2167 0.870675C3.28665 0.870675 2.52998 1.65193 2.52998 2.61221C2.52998 3.57248 3.28665 4.35374 4.2167 4.35374C5.14675 4.35374 5.90342 3.57248 5.90342 2.61221Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Order = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M16.2258 20C16.3114 20 16.3934 19.966 16.4539 19.9055C16.5144 19.845 16.5484 19.763 16.5484 19.6774V0.322581C16.5484 0.237027 16.5144 0.154977 16.4539 0.0944817C16.3934 0.0339861 16.3114 0 16.2258 0H3.32258C3.23703 0 3.15498 0.0339861 3.09448 0.0944817C3.03399 0.154977 3 0.237027 3 0.322581V19.6774C3 19.763 3.03399 19.845 3.09448 19.9055C3.15498 19.966 3.23703 20 3.32258 20H16.2258ZM3.64516 0.645161H15.9032V19.3548H3.64516V0.645161Z"
          fill={props.color}
        />
        <path
          d="M14.9342 1.29004H4.61164C4.52609 1.29004 4.44404 1.32403 4.38354 1.38452C4.32305 1.44502 4.28906 1.52707 4.28906 1.61262V15.161C4.28906 15.2466 4.32305 15.3286 4.38354 15.3891C4.44404 15.4496 4.52609 15.4836 4.61164 15.4836H14.9342C15.0198 15.4836 15.1018 15.4496 15.1623 15.3891C15.2228 15.3286 15.2568 15.2466 15.2568 15.161V1.61262C15.2568 1.52707 15.2228 1.44502 15.1623 1.38452C15.1018 1.32403 15.0198 1.29004 14.9342 1.29004ZM14.6116 14.8384H4.93422V1.9352H14.6116V14.8384Z"
          fill={props.color}
        />
        <path
          d="M9.7747 16.1289C9.5195 16.1289 9.27003 16.2046 9.05783 16.3464C8.84564 16.4881 8.68026 16.6897 8.5826 16.9254C8.48493 17.1612 8.45938 17.4207 8.50917 17.671C8.55896 17.9213 8.68185 18.1512 8.8623 18.3316C9.04276 18.5121 9.27267 18.635 9.52297 18.6848C9.77327 18.7345 10.0327 18.709 10.2685 18.6113C10.5043 18.5137 10.7058 18.3483 10.8476 18.1361C10.9893 17.9239 11.065 17.6744 11.065 17.4192C11.065 17.077 10.9291 16.7488 10.6871 16.5068C10.4451 16.2649 10.1169 16.1289 9.7747 16.1289ZM9.7747 18.0644C9.6471 18.0644 9.52236 18.0266 9.41627 17.9557C9.31017 17.8848 9.22748 17.784 9.17865 17.6661C9.12982 17.5482 9.11704 17.4185 9.14193 17.2934C9.16683 17.1682 9.22827 17.0533 9.3185 16.963C9.40873 16.8728 9.52368 16.8114 9.64883 16.7865C9.77398 16.7616 9.9037 16.7743 10.0216 16.8232C10.1395 16.872 10.2402 16.9547 10.3111 17.0608C10.382 17.1669 10.4199 17.2916 10.4199 17.4192C10.4199 17.5903 10.3519 17.7544 10.2309 17.8754C10.1099 17.9964 9.94581 18.0644 9.7747 18.0644Z"
          fill={props.color}
        />
        <path
          d="M13.645 3.54834H9.12891V4.1935H13.645V3.54834Z"
          fill={props.color}
        />
        <path
          d="M13.645 6.45166H9.12891V7.09682H13.645V6.45166Z"
          fill={props.color}
        />
        <path
          d="M13.645 12.2578H9.12891V12.903H13.645V12.2578Z"
          fill={props.color}
        />
        <path
          d="M6.54997 4.8385C6.62554 4.83854 6.69872 4.81205 6.75675 4.76366L8.69223 3.15076L8.27868 2.65527L6.56901 4.07947L6.13191 3.64269L5.67578 4.09882L6.32094 4.74398C6.35101 4.77406 6.38672 4.79789 6.42602 4.81411C6.46533 4.83033 6.50745 4.83862 6.54997 4.8385Z"
          fill={props.color}
        />
        <path
          d="M6.54997 7.74182C6.62554 7.74186 6.69872 7.71537 6.75675 7.66698L8.69223 6.05408L8.27868 5.55859L6.56901 6.98279L6.13191 6.54601L5.67578 7.00214L6.32094 7.6473C6.35101 7.67738 6.38672 7.70121 6.42602 7.71743C6.46533 7.73365 6.50745 7.74194 6.54997 7.74182Z"
          fill={props.color}
        />
        <path
          d="M6.54997 13.5485C6.62554 13.5485 6.69872 13.522 6.75675 13.4736L8.69223 11.8607L8.27868 11.3652L6.56901 12.7894L6.13191 12.3527L5.67578 12.8088L6.32094 13.4539C6.35101 13.484 6.38672 13.5078 6.42602 13.5241C6.46533 13.5403 6.50745 13.5486 6.54997 13.5485Z"
          fill={props.color}
        />
        <path
          d="M13.645 9.35498H9.12891V10.0001H13.645V9.35498Z"
          fill={props.color}
        />
        <path
          d="M6.54997 10.6451C6.62554 10.6452 6.69872 10.6187 6.75675 10.5703L8.69223 8.9574L8.27868 8.46191L6.56901 9.88611L6.13191 9.44933L5.67578 9.90546L6.32094 10.5506C6.35101 10.5807 6.38672 10.6045 6.42602 10.6207C6.46533 10.637 6.50745 10.6453 6.54997 10.6451Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Complaints = (props) => {
  return (
    <React.Fragment>
      <svg
        width="2rem"
        height="2rem"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M16.1111 0H3.88889C2.85788 0.00125703 1.86945 0.413794 1.14041 1.14712C0.411372 1.88045 0.00124967 2.8747 0 3.91178V11.7353C0.00124967 12.7724 0.411372 13.7667 1.14041 14.5C1.86945 15.2333 2.85788 15.6459 3.88889 15.6471H6.96181L9.57356 18.7993C9.62567 18.8621 9.69087 18.9126 9.76455 18.9473C9.83823 18.982 9.91859 19 9.99995 19C10.0813 19 10.1617 18.982 10.2353 18.9473C10.309 18.9126 10.3742 18.8621 10.4263 18.7993L13.0382 15.6471H16.1111C17.1421 15.6459 18.1306 15.2333 18.8596 14.5C19.5886 13.7667 19.9988 12.7724 20 11.7353V3.91178C19.9988 2.8747 19.5886 1.88045 18.8596 1.14712C18.1306 0.413794 17.1421 0.00125703 16.1111 0ZM18.8889 11.7353C18.8881 12.4761 18.5952 13.1864 18.0744 13.7102C17.5537 14.2341 16.8476 14.5287 16.1111 14.5295H12.7778C12.6964 14.5294 12.616 14.5474 12.5423 14.5821C12.4686 14.6168 12.4034 14.6674 12.3513 14.7303L10 17.5681L7.64867 14.7303C7.59658 14.6674 7.53137 14.6168 7.45768 14.5821C7.38398 14.5474 7.3036 14.5294 7.22222 14.5295H3.88889C3.15241 14.5287 2.44632 14.2341 1.92556 13.7102C1.40479 13.1864 1.11188 12.4761 1.11111 11.7353V3.91178C1.11188 3.17097 1.40479 2.46072 1.92556 1.93689C2.44632 1.41306 3.15241 1.11843 3.88889 1.11765H16.1111C16.8476 1.11843 17.5537 1.41306 18.0744 1.93689C18.5952 2.46072 18.8881 3.17097 18.8889 3.91178V11.7353Z"
          fill={props.color}
        />
        <path
          d="M10 9.99951C9.80222 9.99951 9.60888 10.0582 9.44443 10.168C9.27998 10.2779 9.15181 10.4341 9.07612 10.6168C9.00043 10.7996 8.98063 11.0006 9.01922 11.1946C9.0578 11.3886 9.15304 11.5668 9.29289 11.7066C9.43275 11.8465 9.61093 11.9417 9.80491 11.9803C9.99889 12.0189 10.2 11.9991 10.3827 11.9234C10.5654 11.8477 10.7216 11.7195 10.8315 11.5551C10.9414 11.3906 11 11.1973 11 10.9995C10.9997 10.7344 10.8943 10.4802 10.7068 10.2927C10.5193 10.1052 10.2651 9.99978 10 9.99951Z"
          fill={props.color}
        />
        <path
          d="M10 2.99902C9.73486 2.99934 9.48066 3.12587 9.29319 3.35085C9.10571 3.57582 9.00026 3.88086 9 4.19902V7.79902C9 8.11728 9.10536 8.42251 9.29289 8.64755C9.48043 8.8726 9.73478 8.99902 10 8.99902C10.2652 8.99902 10.5196 8.8726 10.7071 8.64755C10.8946 8.42251 11 8.11728 11 7.79902V4.19902C10.9997 3.88086 10.8943 3.57582 10.7068 3.35085C10.5193 3.12587 10.2651 2.99934 10 2.99902Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const ProductIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="2rem"
        width="2rem"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Search = (props) => {
  return (
    <React.Fragment>
      <svg
        className={props.css}
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9442 12.2826C15.094 10.7133 15.609 8.76779 15.3861 6.83512C15.1632 4.90245 14.219 3.12521 12.7422 1.85896C11.2654 0.592705 9.36504 -0.0691779 7.42128 0.00572919C5.47752 0.0806363 3.63371 0.886809 2.25874 2.26296C0.883763 3.63911 0.0790232 5.48376 0.00551755 7.42784C-0.0679881 9.37193 0.595161 11.2721 1.86229 12.7482C3.12942 14.2242 4.90709 15.1674 6.83964 15.3889C8.7722 15.6104 10.7171 15.094 12.2853 13.9429H12.2841C12.3197 13.9904 12.3577 14.0355 12.4005 14.0794L16.9722 18.6518C17.1948 18.8746 17.4969 18.9999 17.8119 19C18.1269 19.0001 18.429 18.8751 18.6518 18.6524C18.8746 18.4297 18.9999 18.1276 19 17.8126C19.0001 17.4975 18.8751 17.1953 18.6524 16.9725L14.0807 12.4001C14.0383 12.3572 13.9926 12.3175 13.9442 12.2814V12.2826ZM14.2505 7.71735C14.2505 8.57513 14.0816 9.42452 13.7534 10.217C13.4252 11.0095 12.9441 11.7296 12.3376 12.3361C11.7312 12.9427 11.0112 13.4238 10.2188 13.7521C9.42646 14.0803 8.57719 14.2493 7.71953 14.2493C6.86186 14.2493 6.0126 14.0803 5.22022 13.7521C4.42784 13.4238 3.70787 12.9427 3.10141 12.3361C2.49495 11.7296 2.01388 11.0095 1.68566 10.217C1.35745 9.42452 1.18852 8.57513 1.18852 7.71735C1.18852 5.98497 1.87661 4.32355 3.10141 3.09858C4.32621 1.87361 5.9874 1.18542 7.71953 1.18542C9.45166 1.18542 11.1128 1.87361 12.3376 3.09858C13.5624 4.32355 14.2505 5.98497 14.2505 7.71735Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const WhatsApp = (props) => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M4.01114 12.9963L4.25388 13.1173C5.26543 13.7223 6.39825 14.0046 7.53114 14.0046C11.0916 14.0046 14.0046 11.1006 14.0046 7.55115C14.0046 5.85713 13.3168 4.20341 12.1031 2.99336C10.8893 1.78331 9.27084 1.09766 7.53114 1.09766C3.97072 1.09766 1.05759 4.00172 1.09807 7.59151C1.09807 8.8015 1.46221 9.97124 2.06908 10.9795L2.2309 11.2216L1.5836 13.6013L4.01114 12.9963Z"
          fill="#00E676"
        />
        <path
          d="M12.8338 2.18919C11.4441 0.770295 9.52315 0 7.56129 0C3.39241 0 0.0408978 3.36485 0.081737 7.45943C0.081737 8.75674 0.449583 10.0135 1.0627 11.1486L0 15L3.96457 13.9865C5.0681 14.5946 6.29422 14.8784 7.52045 14.8784C11.6485 14.8784 15 11.5135 15 7.41898C15 5.43246 14.2234 3.56757 12.8338 2.18919ZM7.56129 13.6217C6.45775 13.6217 5.35421 13.3379 4.41415 12.7704L4.16894 12.6487L1.79839 13.2568L2.41145 10.946L2.24797 10.7028C0.449583 7.82441 1.30791 4.01351 4.25068 2.22969C7.19344 0.445939 10.9945 1.29731 12.7929 4.21622C14.5913 7.13514 13.7329 10.9054 10.7902 12.6892C9.8501 13.2973 8.70572 13.6217 7.56129 13.6217ZM11.158 9.12172L10.7084 8.91901C10.7084 8.91901 10.0545 8.63522 9.64579 8.4325C9.60489 8.4325 9.56405 8.39194 9.52315 8.39194C9.40052 8.39194 9.31878 8.4325 9.23704 8.47307C9.23704 8.47307 9.1962 8.51358 8.62399 9.16223C8.58309 9.2433 8.50135 9.28387 8.41961 9.28387H8.37872C8.33788 9.28387 8.25614 9.2433 8.21524 9.2028L8.01087 9.12172C7.56129 8.91901 7.1526 8.67572 6.8256 8.35143C6.74386 8.27035 6.62122 8.18928 6.53949 8.1082C6.25338 7.82441 5.96727 7.50006 5.76296 7.13519L5.72206 7.05412C5.68122 7.01355 5.68122 6.97304 5.64032 6.89197C5.64032 6.8109 5.64032 6.72982 5.68122 6.68925C5.68122 6.68925 5.84469 6.48654 5.96727 6.36496C6.04907 6.28382 6.0899 6.16224 6.17164 6.08117C6.25338 5.95953 6.29428 5.79738 6.25338 5.67574C6.21254 5.47302 5.72206 4.37843 5.59948 4.13521C5.51769 4.01356 5.43601 3.97306 5.31337 3.93249H4.86379C4.782 3.93249 4.70032 3.97306 4.61852 3.97306L4.57762 4.01356C4.49589 4.05413 4.41415 4.13521 4.33241 4.17571C4.25068 4.25685 4.20978 4.33786 4.12804 4.419C3.84193 4.78386 3.67846 5.2298 3.67846 5.67574C3.67846 6.00003 3.76019 6.32439 3.88283 6.60818L3.92373 6.72982C4.29157 7.50006 4.782 8.18928 5.43601 8.79737L5.59948 8.95951C5.72206 9.08116 5.84469 9.16223 5.92643 9.28381C6.78476 10.0136 7.76566 10.5406 8.8692 10.8244C8.99183 10.8649 9.15531 10.8649 9.27794 10.9055H9.68663C9.891 10.9055 10.1362 10.8244 10.2997 10.7433C10.4223 10.6623 10.5041 10.6623 10.5858 10.5812L10.6676 10.5C10.7493 10.419 10.8311 10.3785 10.9128 10.2974C10.9945 10.2163 11.0763 10.1352 11.1172 10.0541C11.1989 9.89196 11.2397 9.68924 11.2806 9.48659V9.2028C11.2806 9.2028 11.2397 9.16223 11.158 9.12172Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const Call = (props) => {
  return (
    <React.Fragment>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M13.2957 10.3082L11.2712 8.89374C11.0065 8.70911 10.697 8.61176 10.3761 8.61176C9.86586 8.61176 9.38688 8.862 9.09514 9.2807L8.62516 9.95422C7.83751 9.42596 6.9586 8.68835 6.12074 7.85065C5.28303 7.01294 4.54557 6.13403 4.01747 5.34637L4.69069 4.8764C5.03386 4.63745 5.26304 4.27948 5.33583 3.86871C5.40846 3.45825 5.31691 3.04352 5.07765 2.7002L3.66346 0.675659C3.36775 0.252686 2.89061 0 2.38691 0C2.21235 0 2.04115 0.0308228 1.87819 0.0909424C1.6931 0.159302 1.52067 0.243225 1.3516 0.349426L1.07206 0.546265C1.00218 0.600586 0.937176 0.660095 0.87492 0.722351C0.533886 1.06323 0.291882 1.49475 0.155316 2.005C-0.427418 4.18945 1.01622 7.49268 3.74754 10.224C6.04124 12.5177 8.79683 13.9426 10.9387 13.9429H10.9389C11.3057 13.9429 11.6514 13.9001 11.9667 13.8159C12.4769 13.6795 12.9085 13.4375 13.2496 13.0963C13.3116 13.0344 13.3708 12.9694 13.4343 12.8873L13.6313 12.6062C13.7276 12.4524 13.8113 12.28 13.8806 12.0935C14.1188 11.4496 13.8783 10.7153 13.2957 10.3082Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Messanger = (props) => {
  return (
    <React.Fragment>
      <svg
        width="14"
        height="22"
        viewBox="0 0 14 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M11.0132 1H3.00264C1.89661 1 1 1.89543 1 3V19C1 20.1046 1.89661 21 3.00264 21H11.0132C12.1192 21 13.0158 20.1046 13.0158 19V3C13.0158 1.89543 12.1192 1 11.0132 1Z"
          stroke={props.color}
          strokeWidth="0.711462"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.92969 19.3398H7.00874"
          stroke={props.color}
          strokeWidth="1.99605"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.07596 9.77421C6.07596 9.85808 6.04181 9.9385 5.98103 9.9978C5.92024 10.0571 5.8378 10.0904 5.75185 10.0904C5.66589 10.0904 5.58345 10.0571 5.52266 9.9978C5.46188 9.9385 5.42773 9.85808 5.42773 9.77421C5.42773 9.69035 5.46188 9.60992 5.52266 9.55062C5.58345 9.49132 5.66589 9.45801 5.75185 9.45801C5.8378 9.45801 5.92024 9.49132 5.98103 9.55062C6.04181 9.60992 6.07596 9.69035 6.07596 9.77421ZM7.3724 9.77421C7.3724 9.85808 7.33825 9.9385 7.27747 9.9978C7.21669 10.0571 7.13425 10.0904 7.04829 10.0904C6.96233 10.0904 6.87989 10.0571 6.81911 9.9978C6.75832 9.9385 6.72418 9.85808 6.72418 9.77421C6.72418 9.69035 6.75832 9.60992 6.81911 9.55062C6.87989 9.49132 6.96233 9.45801 7.04829 9.45801C7.13425 9.45801 7.21669 9.49132 7.27747 9.55062C7.33825 9.60992 7.3724 9.69035 7.3724 9.77421ZM8.34473 10.0904C8.43069 10.0904 8.51313 10.0571 8.57391 9.9978C8.63469 9.9385 8.66884 9.85808 8.66884 9.77421C8.66884 9.69035 8.63469 9.60992 8.57391 9.55062C8.51313 9.49132 8.43069 9.45801 8.34473 9.45801C8.25877 9.45801 8.17633 9.49132 8.11555 9.55062C8.05477 9.60992 8.02062 9.69035 8.02062 9.77421C8.02062 9.85808 8.05477 9.9385 8.11555 9.9978C8.17633 10.0571 8.25877 10.0904 8.34473 10.0904Z"
          fill={props.color}
        />
        <path
          d="M5.1738 12.2639L5.18022 12.2626C5.76792 12.1473 6.12696 11.9951 6.29396 11.9116C6.53982 11.9764 6.79323 12.0091 7.04769 12.0088C8.46651 12.0088 9.61686 11.0132 9.61686 9.78515C9.61686 8.55707 8.46651 7.56152 7.04769 7.56152C5.62886 7.56152 4.47852 8.55707 4.47852 9.78515C4.47852 10.3442 4.71713 10.8557 5.11117 11.2464C5.08361 11.4974 5.02715 11.7444 4.94289 11.9827L4.94193 11.9862C4.91799 12.0545 4.89185 12.122 4.86357 12.1886C4.8382 12.2477 4.88733 12.3137 4.95124 12.3036C5.02564 12.2915 5.09983 12.2783 5.1738 12.2639ZM5.43071 11.2766C5.43521 11.2301 5.42928 11.1831 5.41335 11.1392C5.39742 11.0952 5.37188 11.0552 5.33855 11.0221C4.99813 10.6841 4.79966 10.2515 4.79966 9.78515C4.79966 8.77118 5.76439 7.87918 7.04769 7.87918C8.33099 7.87918 9.29571 8.77118 9.29571 9.78515C9.29571 10.7994 8.33099 11.6911 7.04769 11.6911C6.82131 11.6914 6.59587 11.6624 6.37713 11.6047C6.30069 11.5845 6.21938 11.5928 6.1488 11.6282C6.02451 11.6905 5.75058 11.8093 5.3029 11.9119C5.36535 11.7045 5.40814 11.4918 5.43071 11.2766Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const Ban = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Checked = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Facebook = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Instagram = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Youtube = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Pinterest = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 496 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Twitter = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
      </svg>
    </React.Fragment>
  );
};
export const PdfFile = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 384 512"
        color="#fff"
        height="25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Setting = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color ? props.color : "currentColor"}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Edit = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        className={props.className}
        fill={props.color}
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"></path>
      </svg>
    </React.Fragment>
  );
};
export const View = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 496 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"></path>
      </svg>
    </React.Fragment>
  );
};
export const UpLoadFile = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={props.className}
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
      </svg>
    </React.Fragment>
  );
};
export const DeleteFile = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"></path>
      </svg>
    </React.Fragment>
  );
};
export const MarketingIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 460 512"
        height="2rem"
        width="2rem"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DownArrowCircle = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"></path>
      </svg>
    </React.Fragment>
  );
};
export const UpArrowCircle = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"></path>
      </svg>
    </React.Fragment>
  );
};
export const ThreeDots = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 192 512"
        height="1.2em"
        width="1.2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Envelope = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path>
      </svg>
    </React.Fragment>
  );
};
export const CommentDetail = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 7h10v2H7zm0 4h7v2H7z"></path>
        <path d="M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"></path>
      </svg>
    </React.Fragment>
  );
};

export const Phone = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill={props.color}
        className={props.css}
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
      </svg>
    </React.Fragment>
  );
};
export const UpdateIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        className={props.css}
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="40px"
        width="40px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="#1ffc33" d="M0 0h24v24H0z"></path>
        <path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"></path>
      </svg>
    </React.Fragment>
  );
};

export const Eye = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        onClick={props.onClick}
        fill="#FFFFFF"
        strokeWidth="0"
        viewBox="0 0 576 512"
        className={props.className}
        height="25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
      </svg>
    </React.Fragment>
  );
};

export const EyeHide = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        onClick={props.onClick}
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 640 512"
        className={props.className}
        height="25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path>
      </svg>
    </React.Fragment>
  );
};
export const Spinner = (props) => {
  return (
    <React.Fragment>
      <div className="tw_center">
        <div
          className="spinner"
          style={{ height: props.size + "px", width: props.size + "px" }}
        />
      </div>
    </React.Fragment>
  );
};

export const Danger = (props) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#f93e3e"
      className={props.className}
      viewBox="0 0 85.04 122.88"
    >
      <path d="M42.89,88.34c3.66-2.03,10.09-5.03,19.25-8.95c0.46-0.23,1.65-0.75,3.55-1.54c3.28-3.34,5.96-5.84,8.13-7.52 c2.14-1.66,3.69-2.5,4.64-2.5c1.18,0,2.04,0.38,2.62,1.11c0.55,0.73,0.84,1.86,0.84,3.4c0,1.31-0.2,3.14-0.6,5.52 c2.42,3.08,3.63,5.35,3.63,6.83c0,1.25-0.35,2.21-1.01,2.85c-0.69,0.66-1.7,0.98-3.05,0.98c-0.66,0-1.7-0.35-3.06-1.07 c-1.38-0.7-3.14-1.74-5.28-3.11c-5.19,0.96-12.62,3.89-22.31,8.78c1.24,0.73,2.13,1.27,2.71,1.63c3.37,1.92,7.55,4.5,12.51,7.73 c0.6,0.41,2.02,1.25,4.21,2.56c10.24,1.19,15.37,3.8,15.37,7.81c0,2.61-2.77,4.39-8.27,5.29c-2.59,3.16-4.73,4.76-6.43,4.76 c-2.02,0-3.98-2.67-5.91-7.99c-0.17-0.58-0.46-1.39-0.92-2.47c-7.9-6.54-14.99-11.47-21.3-14.81c-7.7,4.39-14.85,9.59-21.45,15.66 c-0.89,6.42-2.8,9.62-5.74,9.62c-1.84,0-3.98-1.8-6.4-5.43c-5.74,0-8.62-1.6-8.62-4.76c0-2.32,1.07-4.01,3.2-5.09 c2.13-1.04,6.66-2.06,13.52-3.1c5.1-3.78,11.18-7.58,18.22-11.39c-9.46-4.76-17.15-7.7-23.12-8.78c-1.41,1.25-2.71,2.18-3.89,2.82 c-1.18,0.61-2.28,0.93-3.28,0.93c-1.47,0-2.57-0.32-3.32-0.93c-0.78-0.64-1.15-1.54-1.15-2.73c0-1.07,1.24-3.28,3.72-6.57 c-0.58-2.32-0.87-4.06-0.87-5.26c0-1.71,0.35-2.96,1.01-3.81C4.73,67.98,5.7,67.57,7,67.57c1.29,0,2.97,0.84,5.04,2.56 c2.11,1.69,4.61,4.27,7.52,7.73C26.06,80.18,33.81,83.69,42.89,88.34L42.89,88.34L42.89,88.34z M52.96,60.6l-1.7,4.35 c-2.13,0.73-5.05,1.11-8.71,1.11c-1.78,0-3.43-0.09-4.9-0.29c-1.47-0.2-2.74-0.47-3.8-0.81l-1.7-4.35L20.36,54.9l-1.09-7.15 c-0.17-1.36-1.39-4.03-3.64-8.01c-1.76-2.93-2.62-7.67-2.62-14.2c0-7.61,2.74-13.78,8.19-18.48C26.67,2.35,33.79,0,42.58,0 c8.76,0,15.88,2.35,21.36,7.06c5.45,4.7,8.19,10.87,8.19,18.48c0,6.54-1.82,12.9-5.42,19.14c-0.31,0.7-0.6,1.72-0.83,3.08 l-1.09,7.15L52.96,60.6L52.96,60.6L52.96,60.6z M58.53,62.57l-2.11,8.4l-5.16,4.53c-0.89,1.74-2.07,3.08-3.58,3.95 c-1.49,0.87-3.25,1.31-5.3,1.31c-4.07,0-7-1.74-8.88-5.26l-5.14-4.53l-2.12-8.4l3.05-0.78c0.35,0.87,0.58,1.51,0.75,1.98 c1.3,2.99,2.74,4.97,4.26,5.93c1.56,0.96,4.12,1.45,7.76,1.45c4.04,0,6.86-0.46,8.39-1.36c1.56-0.91,3-2.9,4.27-6.02 c0.17-0.47,0.43-1.1,0.78-1.98L58.53,62.57L58.53,62.57L58.53,62.57z M42.64,46.3c-1.01,1.69-2.05,3.2-3.13,4.5 c-1.36,1.54-2.03,2.73-2.03,3.57c0,0.9,0.26,1.6,0.81,2.07c0.52,0.43,1.29,0.66,2.34,0.66c0.6,0,1.29-0.23,2.01-0.66 c0.72,0.43,1.41,0.66,2.02,0.66c2.11,0,3.14-0.92,3.14-2.82c0-0.79-0.66-1.95-2.01-3.49C44.63,49.44,43.59,47.96,42.64,46.3 L42.64,46.3z M23.21,39.42c0,5.43,2.33,8.16,7,8.16c4.73,0,7.1-2.93,7.1-8.77c0-4.82-2.28-7.23-6.84-7.23 c-2.41,0-4.23,0.63-5.45,1.94C23.82,34.83,23.21,36.81,23.21,39.42L23.21,39.42L23.21,39.42z M48.23,39.42 c0,5.43,2.36,8.16,7.1,8.16c4.72,0,7.08-2.93,7.08-8.77c0-2.44-0.57-4.24-1.72-5.43c-1.15-1.19-2.88-1.8-5.19-1.8 C50.66,31.58,48.23,34.19,48.23,39.42L48.23,39.42L48.23,39.42z" />
    </svg>
  );
};

export const EyeIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9603 7.26818C19.1762 5.19385 17.8149 3.39997 16.0447 2.10824C14.2745 0.816515 12.1731 0.0835725 10 0C7.82695 0.0835725 5.72547 0.816515 3.9553 2.10824C2.18512 3.39997 0.823847 5.19385 0.0397175 7.26818C-0.0132392 7.41798 -0.0132392 7.58202 0.0397175 7.73182C0.823847 9.80615 2.18512 11.6 3.9553 12.8918C5.72547 14.1835 7.82695 14.9164 10 15C12.1731 14.9164 14.2745 14.1835 16.0447 12.8918C17.8149 11.6 19.1762 9.80615 19.9603 7.73182C20.0132 7.58202 20.0132 7.41798 19.9603 7.26818ZM10 13.6364C6.46657 13.6364 2.73313 10.9568 1.37976 7.5C2.73313 4.04318 6.46657 1.36364 10 1.36364C13.5334 1.36364 17.2669 4.04318 18.6202 7.5C17.2669 10.9568 13.5334 13.6364 10 13.6364Z"
          fill={props.color}
        />
        <path
          d="M10 3C9.20888 3 8.43552 3.2346 7.77772 3.67412C7.11992 4.11365 6.60723 4.73836 6.30448 5.46927C6.00173 6.20017 5.92252 7.00444 6.07686 7.78036C6.2312 8.55628 6.61216 9.26902 7.17157 9.82843C7.73098 10.3878 8.44372 10.7688 9.21964 10.9231C9.99556 11.0775 10.7998 10.9983 11.5307 10.6955C12.2616 10.3928 12.8864 9.88008 13.3259 9.22228C13.7654 8.56448 14 7.79112 14 7C14 5.93913 13.5786 4.92172 12.8284 4.17157C12.0783 3.42143 11.0609 3 10 3ZM10 9.66667C9.47258 9.66667 8.95701 9.51027 8.51848 9.21725C8.07995 8.92423 7.73816 8.50776 7.53632 8.02049C7.33449 7.53322 7.28168 6.99704 7.38457 6.47976C7.48747 5.96248 7.74144 5.48732 8.11438 5.11438C8.48732 4.74144 8.96248 4.48747 9.47976 4.38457C9.99704 4.28168 10.5332 4.33449 11.0205 4.53632C11.5078 4.73815 11.9242 5.07995 12.2173 5.51848C12.5103 5.95701 12.6667 6.47258 12.6667 7C12.6667 7.70724 12.3857 8.38552 11.8856 8.88562C11.3855 9.38571 10.7072 9.66667 10 9.66667Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const PoliceLightIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        version="1.1"
        viewBox="0 0 752 752"
        fill={props.color}
      >
        <g>
          <path d="m555.96 513.34h-28.414v-132.6c0-83.352-68.195-151.55-151.55-151.55s-151.55 68.195-151.55 151.55v132.6h-28.414c-5.2109 0-9.4727 4.2617-9.4727 9.4727v56.828c0 5.2109 4.2617 9.4727 9.4727 9.4727h359.92c5.2109 0 9.4727-4.2617 9.4727-9.4727v-56.828c0-5.2109-4.2617-9.4727-9.4727-9.4727zm-312.56-132.6c0-72.93 59.672-132.6 132.6-132.6s132.6 59.672 132.6 132.6v132.6h-265.2zm303.09 189.43h-340.98v-37.887h340.98z" />
          <path d="m376 219.72c5.2109 0 9.4727-4.2617 9.4727-9.4727v-37.883c0-5.2109-4.2617-9.4727-9.4727-9.4727s-9.4727 4.2617-9.4727 9.4727v37.887c0.003906 5.207 4.2656 9.4688 9.4727 9.4688z" />
          <path d="m214.98 394.95c0-5.2109-4.2617-9.4727-9.4727-9.4727h-37.887c-5.2109 0-9.4727 4.2617-9.4727 9.4727 0 5.2109 4.2617 9.4727 9.4727 9.4727h37.887c5.2109 0 9.4727-4.2656 9.4727-9.4727z" />
          <path d="m584.38 385.47h-37.887c-5.2109 0-9.4727 4.2617-9.4727 9.4727 0 5.2109 4.2617 9.4727 9.4727 9.4727h37.887c5.2109 0 9.4727-4.2617 9.4727-9.4727-0.003906-5.2109-4.2656-9.4727-9.4727-9.4727z" />
          <path d="m231.09 277.5c1.8945 1.8945 4.2617 2.8398 6.6289 2.8398 2.3672 0 4.7344-0.94531 6.6289-2.8398 3.7891-3.7891 3.7891-9.4727 0-13.262l-26.992-26.992c-3.7891-3.7891-9.4727-3.7891-13.262 0-3.7891 3.7891-3.7891 9.4727 0 13.262z" />
          <path d="m514.29 280.34c2.3672 0 4.7344-0.94531 6.6289-2.8398l26.992-26.992c3.7891-3.7891 3.7891-9.4727 0-13.262-3.7891-3.7891-9.4727-3.7891-13.262 0l-26.992 26.992c-3.7891 3.7891-3.7891 9.4727 0 13.262 1.4258 1.8906 4.2656 2.8398 6.6328 2.8398z" />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const ViewImageIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 7.5C10 8.16304 9.73661 8.79893 9.26777 9.26777C8.79893 9.73661 8.16304 10 7.5 10C6.83696 10 6.20107 9.73661 5.73223 9.26777C5.26339 8.79893 5 8.16304 5 7.5C5 6.83696 5.26339 6.20107 5.73223 5.73223C6.20107 5.26339 6.83696 5 7.5 5C8.16304 5 8.79893 5.26339 9.26777 5.73223C9.73661 6.20107 10 6.83696 10 7.5Z"
          fill="white"
        />
        <path
          d="M2.5 0C1.83696 0 1.20107 0.30102 0.732233 0.836838C0.263392 1.37266 0 2.09938 0 2.85714V17.1429C0 17.9006 0.263392 18.6273 0.732233 19.1632C1.20107 19.699 1.83696 20 2.5 20H17.5C18.163 20 18.7989 19.699 19.2678 19.1632C19.7366 18.6273 20 17.9006 20 17.1429V2.85714C20 2.09938 19.7366 1.37266 19.2678 0.836838C18.7989 0.30102 18.163 0 17.5 0H2.5ZM17.5 1.42857C17.8315 1.42857 18.1495 1.57908 18.3839 1.84699C18.6183 2.1149 18.75 2.47826 18.75 2.85714V12.1429L14.0288 9.36143C13.9115 9.29432 13.7788 9.27104 13.6494 9.29488C13.5199 9.31872 13.4003 9.38848 13.3075 9.49429L8.67 14.7943L5.345 12.2629C5.22495 12.1715 5.08095 12.1304 4.93742 12.1466C4.79389 12.1627 4.65967 12.2351 4.5575 12.3514L1.25 15.7143V2.85714C1.25 2.47826 1.3817 2.1149 1.61612 1.84699C1.85054 1.57908 2.16848 1.42857 2.5 1.42857H17.5Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const CrossCircleIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 25C19.8513 25 25 19.8513 25 13.5C25 7.14873 19.8513 2 13.5 2C7.14873 2 2 7.14873 2 13.5C2 19.8513 7.14873 25 13.5 25Z"
          stroke="#FF4F4F"
          strokeWidth="2.26488"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 10L10 17"
          stroke="#FF4F4F"
          strokeWidth="2.26488"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10L17 17"
          stroke="#FF4F4F"
          strokeWidth="2.26488"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Print = () => {
  return (
    <React.Fragment>
      <svg
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#4387FF"
        />
        <path
          d="M6.25 6.17857C6.25 5.86599 6.36853 5.56622 6.5795 5.3452C6.79048 5.12417 7.07663 5 7.375 5H12.625C12.9234 5 13.2095 5.12417 13.4205 5.3452C13.6315 5.56622 13.75 5.86599 13.75 6.17857V6.57143H14.125C14.6223 6.57143 15.0992 6.77838 15.4508 7.14675C15.8025 7.51513 16 8.01475 16 8.53571V12.4643C16 12.7769 15.8815 13.0766 15.6705 13.2977C15.4595 13.5187 15.1734 13.6429 14.875 13.6429H13.75V14.8214C13.75 15.134 13.6315 15.4338 13.4205 15.6548C13.2095 15.8758 12.9234 16 12.625 16H7.375C7.07663 16 6.79048 15.8758 6.5795 15.6548C6.36853 15.4338 6.25 15.134 6.25 14.8214V13.6429H5.125C4.82663 13.6429 4.54048 13.5187 4.3295 13.2977C4.11853 13.0766 4 12.7769 4 12.4643V8.53571C4 8.01475 4.19754 7.51513 4.54917 7.14675C4.90081 6.77838 5.37772 6.57143 5.875 6.57143H6.25V6.17857ZM7 6.57143H13V6.17857C13 6.07438 12.9605 5.97445 12.8902 5.90078C12.8198 5.8271 12.7245 5.78571 12.625 5.78571H7.375C7.27554 5.78571 7.18016 5.8271 7.10984 5.90078C7.03951 5.97445 7 6.07438 7 6.17857V6.57143ZM6.25 12.8571V11.6786C6.25 11.366 6.36853 11.0662 6.5795 10.8452C6.79048 10.6242 7.07663 10.5 7.375 10.5H12.625C12.9234 10.5 13.2095 10.6242 13.4205 10.8452C13.6315 11.0662 13.75 11.366 13.75 11.6786V12.8571H14.875C14.9745 12.8571 15.0698 12.8158 15.1402 12.7421C15.2105 12.6684 15.25 12.5685 15.25 12.4643V8.53571C15.25 8.22314 15.1315 7.92336 14.9205 7.70234C14.7095 7.48131 14.4234 7.35714 14.125 7.35714H5.875C5.57663 7.35714 5.29048 7.48131 5.0795 7.70234C4.86853 7.92336 4.75 8.22314 4.75 8.53571V12.4643C4.75 12.5685 4.78951 12.6684 4.85984 12.7421C4.93016 12.8158 5.02554 12.8571 5.125 12.8571H6.25ZM7.375 11.2857C7.27554 11.2857 7.18016 11.3271 7.10984 11.4008C7.03951 11.4745 7 11.5744 7 11.6786V14.8214C7 14.9256 7.03951 15.0255 7.10984 15.0992C7.18016 15.1729 7.27554 15.2143 7.375 15.2143H12.625C12.7245 15.2143 12.8198 15.1729 12.8902 15.0992C12.9605 15.0255 13 14.9256 13 14.8214V11.6786C13 11.5744 12.9605 11.4745 12.8902 11.4008C12.8198 11.3271 12.7245 11.2857 12.625 11.2857H7.375Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const Camera = () => {
  return (
    <React.Fragment>
      <svg
        width="27"
        height="22"
        viewBox="0 0 27 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.5 3H18.7676L17.2129 0.668001C17.0761 0.462388 16.8905 0.293803 16.6727 0.177256C16.455 0.060709 16.2118 -0.000183468 15.9648 4.15232e-07H11.0348C10.7878 -0.000183468 10.5446 0.060709 10.3269 0.177256C10.1091 0.293803 9.92354 0.462388 9.7867 0.668001L8.2324 3H2.5C1.83715 3.00061 1.20161 3.2642 0.732906 3.73291C0.264197 4.20161 0.000608986 4.83715 0 5.5V19.5C0.000608986 20.1629 0.264197 20.7984 0.732906 21.2671C1.20161 21.7358 1.83715 21.9994 2.5 22H24.5C25.1629 21.9994 25.7984 21.7358 26.2671 21.2671C26.7358 20.7984 26.9994 20.1629 27 19.5V5.5C26.9994 4.83715 26.7358 4.20161 26.2671 3.73291C25.7984 3.2642 25.1629 3.00061 24.5 3ZM26 19.5C25.9995 19.8977 25.8414 20.279 25.5602 20.5602C25.279 20.8414 24.8977 20.9995 24.5 21H2.5C2.10231 20.9995 1.72104 20.8414 1.43984 20.5602C1.15863 20.279 1.00045 19.8977 1 19.5V5.5C1.00045 5.10231 1.15863 4.72104 1.43984 4.43984C1.72104 4.15863 2.10231 4.00045 2.5 4H8.5C8.5813 3.99507 8.66057 3.97261 8.73237 3.93418C8.80418 3.89574 8.86682 3.84222 8.916 3.7773L10.6191 1.2227C10.6646 1.15405 10.7265 1.09776 10.7991 1.05889C10.8717 1.02003 10.9528 0.99979 11.0352 1H15.9652C16.0476 0.99979 16.1287 1.02003 16.2013 1.05889C16.2739 1.09776 16.3358 1.15405 16.3813 1.2227L18.084 3.7773C18.1327 3.84268 18.1953 3.89653 18.2672 3.93502C18.3391 3.9735 18.4186 3.99569 18.5 4H24.5C24.8977 4.00045 25.279 4.15863 25.5602 4.43984C25.8414 4.72104 25.9995 5.10231 26 5.5V19.5Z"
          fill="#3A3A3A"
        />
        <path
          d="M13.5 7C12.4122 7 11.3488 7.32257 10.4444 7.92692C9.5399 8.53126 8.83495 9.39025 8.41867 10.3952C8.00238 11.4002 7.89346 12.5061 8.10568 13.573C8.3179 14.6399 8.84173 15.6199 9.61091 16.3891C10.3801 17.1583 11.3601 17.6821 12.427 17.8943C13.4939 18.1065 14.5998 17.9976 15.6048 17.5813C16.6098 17.1651 17.4687 16.4601 18.0731 15.5556C18.6774 14.6512 19 13.5878 19 12.5C18.9982 11.0419 18.4181 9.64398 17.3871 8.61293C16.356 7.58187 14.9581 7.00183 13.5 7ZM13.5 17C12.61 17 11.74 16.7361 10.9999 16.2416C10.2599 15.7471 9.68314 15.0443 9.34254 14.2221C9.00195 13.3998 8.91283 12.495 9.08647 11.6221C9.2601 10.7492 9.68869 9.94736 10.318 9.31802C10.9474 8.68868 11.7492 8.2601 12.6221 8.08647C13.495 7.91283 14.3998 8.00195 15.2221 8.34254C16.0443 8.68314 16.7471 9.25991 17.2416 9.99993C17.7361 10.74 18 11.61 18 12.5C17.9987 13.6931 17.5241 14.8369 16.6805 15.6805C15.8369 16.5241 14.6931 16.9987 13.5 17Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};
// export const Tick = () => {
//   return (
//     <React.Fragment>
//       <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <circle cx="10" cy="10" r="9.5625" stroke="#50F085" strokeWidth="0.875" />
//         <path d="M19.1164 0.226115C18.9191 0.111592 18.7021 0.0387619 18.4778 0.0117907C18.2535 -0.0151804 18.0263 0.00423597 17.8092 0.0689298C17.5921 0.133624 17.3894 0.242326 17.2126 0.38882C17.0358 0.535314 16.8884 0.716727 16.7789 0.922683L8.78138 12.2576L6.95514 10.3526C6.79659 10.1813 6.60692 10.0447 6.39722 9.95077C6.18752 9.8568 5.96198 9.80734 5.73375 9.80527C5.50553 9.80321 5.2792 9.84857 5.06796 9.93872C4.85672 10.0289 4.66481 10.162 4.50343 10.3304C4.34205 10.4987 4.21442 10.6989 4.12799 10.9192C4.04157 11.1396 3.99808 11.3757 4.00006 11.6138C4.00205 11.8518 4.04946 12.0871 4.13955 12.3058C4.22963 12.5246 4.36057 12.7224 4.52473 12.8878L7.96237 16.4738C8.28723 16.8135 8.72552 17 9.17757 17L9.41563 16.9821C9.67908 16.9436 9.93038 16.8419 10.1498 16.685C10.3691 16.528 10.5506 16.3201 10.6798 16.0775L19.7833 2.66455C19.8931 2.45876 19.9628 2.23245 19.9887 1.99853C20.0145 1.76462 19.996 1.52768 19.9341 1.30125C19.8721 1.07482 19.768 0.863325 19.6278 0.678853C19.4875 0.494381 19.3137 0.34054 19.1164 0.226115Z" fill="#50F085" />
//       </svg>
//     </React.Fragment>
//   )
// }
export const Whatsappweb = () => {
  return (
    <React.Fragment>
      <svg
        width="25"
        height="25"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0024 34C12.4939 34 8.16997 32.2093 4.98154 29.0218C1.79311 25.8343 0.0012569 21.5109 0 17.0024V17.0024C0 14.7696 0.439764 12.5587 1.29421 10.4958C2.14866 8.43302 3.40108 6.5587 4.97989 4.97988C6.55871 3.40106 8.43302 2.14868 10.4958 1.29423C12.5587 0.439778 14.7696 0 17.0024 0V0C19.2349 -8.68065e-08 21.4456 0.439814 23.5082 1.29432C25.5707 2.14883 27.4448 3.40129 29.0232 4.98017C30.6016 6.55904 31.8536 8.43341 32.7075 10.4962C33.5614 12.559 34.0006 14.7698 34 17.0024V17.0024C34 21.5104 32.2092 25.8338 29.0215 29.0215C25.8339 32.2092 21.5104 34 17.0024 34V34Z"
          fill="#00E676"
        />
        <path
          d="M12.0631 24.5937L12.4017 24.7625C13.8123 25.6062 15.3922 26 16.9721 26C21.9374 26 26 21.95 26 17C26 14.6375 25.0407 12.3313 23.3481 10.6437C21.6553 8.95621 19.3983 8 16.9721 8C12.0068 8 7.94412 12.05 8.00058 17.0563C8.00058 18.7437 8.5084 20.3751 9.35474 21.7812L9.58042 22.1188L8.6777 25.4375L12.0631 24.5937Z"
          fill="#00E676"
        />
        <path
          d="M24.076 9.9539L24.0907 9.96891H24.0911C25.9252 11.7959 26.95 14.2635 26.95 16.892C26.95 22.3237 22.5037 26.7879 17.0273 26.7879C15.4 26.7879 13.7736 26.4113 12.3102 25.6049L12.2929 25.5953L12.2737 25.6002L7.07113 26.9302L8.46513 21.8782L8.47048 21.8588L8.46092 21.8411C7.64675 20.3338 7.15898 18.6661 7.15899 16.9459L7.15898 16.9454C7.10481 11.5143 11.5505 7.05 17.0817 7.05C19.6846 7.05 22.2329 8.07204 24.076 9.9539ZM17.0817 25.2122H17.1317V25.212C18.6498 25.2027 20.1653 24.7685 21.4135 23.9613C25.3609 21.568 26.5116 16.5101 24.0998 12.5954C21.687 8.67926 16.588 7.53812 12.6416 9.93017C8.69373 12.3233 7.54251 17.4358 9.95489 21.2968L9.95487 21.2969L9.9558 21.2982L10.1611 21.6038L9.34952 24.6629L9.32765 24.7454L9.41028 24.7242L12.553 23.918L12.8615 24.071C14.1229 24.8322 15.6027 25.2122 17.0817 25.2122ZM19.3325 18.3532L19.3463 18.3382C19.4518 18.2859 19.5504 18.2392 19.6975 18.2392C19.7108 18.2392 19.727 18.2461 19.7571 18.2611C19.7582 18.2617 19.7595 18.2623 19.7607 18.2629C19.7824 18.2737 19.8138 18.2893 19.848 18.2927C20.1202 18.4274 20.4704 18.5877 20.7534 18.7146C20.8966 18.7789 21.0227 18.8347 21.113 18.8744L21.2194 18.921L21.248 18.9335L21.2555 18.9368L21.2573 18.9376L21.2578 18.9378L21.258 18.9379L21.258 18.9379L21.8559 19.2075C21.9071 19.2329 21.9451 19.2581 21.9701 19.2767C21.9785 19.283 21.9854 19.2884 21.9909 19.2929V19.6438C21.9363 19.9141 21.883 20.1752 21.7782 20.383C21.7282 20.4823 21.6262 20.5842 21.5152 20.6944C21.4636 20.7456 21.4118 20.7841 21.3571 20.8248L21.3561 20.8255C21.3021 20.8657 21.2453 20.908 21.1882 20.9646L21.0792 21.0727C21.0314 21.1202 20.9837 21.1442 20.9239 21.1706C20.9166 21.1738 20.9091 21.1771 20.9014 21.1804C20.8467 21.2042 20.7824 21.2321 20.708 21.281C20.4938 21.3867 20.1763 21.4906 19.9155 21.4906H19.3785C19.2943 21.4638 19.1983 21.4502 19.1075 21.4374L19.1051 21.4371C19.0086 21.4234 18.918 21.4104 18.8413 21.3851L18.8413 21.385L18.838 21.3841C17.3767 21.0083 16.0773 20.3109 14.9395 19.3447C14.8822 19.2611 14.8119 19.1919 14.7378 19.1251C14.7139 19.1036 14.6898 19.0824 14.6656 19.0611C14.6116 19.0138 14.5568 18.9657 14.5012 18.9105L14.5012 18.9105L14.2832 18.6943L14.2832 18.6943L14.2821 18.6932C13.4157 17.8877 12.7658 16.9748 12.2781 15.9543L12.2245 15.795L12.2247 15.7949L12.223 15.7911C12.0616 15.4176 11.9546 14.9919 11.9546 14.5676C11.9546 13.9861 12.1675 13.4032 12.5415 12.9252C12.5974 12.8694 12.6395 12.8138 12.6795 12.7609L12.6802 12.76C12.7197 12.7077 12.7573 12.658 12.8063 12.6086C12.8622 12.5797 12.9171 12.5389 12.9679 12.5011L12.9699 12.4997C13.0253 12.4584 13.076 12.4209 13.1257 12.3962L13.133 12.3926L13.1387 12.3869L13.1792 12.3468C13.2325 12.344 13.2844 12.3311 13.3309 12.3196L13.3336 12.3189C13.3892 12.3051 13.4377 12.2933 13.4851 12.2933H14.0764C14.1534 12.3191 14.2142 12.344 14.2681 12.3796C14.3225 12.4156 14.3719 12.4639 14.4227 12.5389C14.5047 12.7021 14.7073 13.1443 14.8969 13.5808C14.9922 13.8002 15.0839 14.0175 15.1552 14.1968C15.2272 14.3779 15.2763 14.5153 15.2888 14.5775L15.2884 14.5776L15.2904 14.5836C15.3379 14.7247 15.292 14.9224 15.19 15.0764C15.133 15.1341 15.0904 15.2045 15.0514 15.269L15.0499 15.2715C15.0084 15.3401 14.9705 15.4021 14.9211 15.4511C14.8379 15.5337 14.7414 15.6431 14.6663 15.7312C14.6287 15.7753 14.5961 15.8144 14.573 15.8424L14.5459 15.8755L14.5386 15.8845L14.5377 15.8856C14.5003 15.924 14.485 15.9768 14.4778 16.0268C14.4704 16.0776 14.4704 16.1347 14.4704 16.1872V16.1893V16.2012L14.4758 16.2118C14.4954 16.2507 14.5071 16.2811 14.518 16.3093C14.5215 16.3185 14.525 16.3274 14.5286 16.3363C14.5424 16.3706 14.558 16.4029 14.5882 16.4349L14.6393 16.5361L14.6393 16.5361L14.6403 16.538C14.916 17.0304 15.3013 17.4667 15.6841 17.8464C15.7406 17.9024 15.8105 17.9579 15.8776 18.0112L15.879 18.0123C15.9477 18.0668 16.0134 18.119 16.0656 18.1707L16.0981 18.138L16.0656 18.1707C16.5074 18.6089 17.0582 18.9362 17.6606 19.2079L17.6606 19.2079L17.6627 19.2088L17.9262 19.3133C17.9578 19.3424 17.9999 19.3694 18.0404 19.3895C18.0828 19.4105 18.1323 19.4285 18.1716 19.4285H18.2262C18.3492 19.4285 18.475 19.3682 18.5402 19.2447C18.9191 18.8153 19.1222 18.5869 19.2307 18.4659C19.2851 18.4052 19.3156 18.3715 19.3325 18.3532Z"
          fill="white"
          stroke="#ADADAD"
          strokeWidth="0.1"
        />
      </svg>
    </React.Fragment>
  );
};
export const PhoneMob = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="none"
        strokwidth="2"
        viewBox="0 0 20 22"
        height="15px"
        width="15px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <desc></desc>
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"></path>
        <path d="M15 7a2 2 0 0 1 2 2"></path>
        <path d="M15 3a6 6 0 0 1 6 6"></path>
      </svg>
    </React.Fragment>
  );
};
export const Image = (props) => {
  return (
    <React.Fragment>
      <svg
        width="61"
        height="31"
        viewBox="0 0 61 31"
        fill={props.color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="61" height="31" fill="#B9B9B9" />
        <path
          d="M27.6734 13.142C27.6734 13.3315 27.5928 13.5131 27.4495 13.6471C27.3061 13.7811 27.1117 13.8563 26.9089 13.8563C26.7062 13.8563 26.5118 13.7811 26.3684 13.6471C26.2251 13.5131 26.1445 13.3315 26.1445 13.142C26.1445 12.9526 26.2251 12.7709 26.3684 12.6369C26.5118 12.503 26.7062 12.4277 26.9089 12.4277C27.1117 12.4277 27.3061 12.503 27.4495 12.6369C27.5928 12.7709 27.6734 12.9526 27.6734 13.142Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          d="M25.951 11C25.5962 11 25.256 11.1505 25.0051 11.4184C24.7542 11.6863 24.6133 12.0497 24.6133 12.4286V19.5714C24.6133 19.9503 24.7542 20.3137 25.0051 20.5816C25.256 20.8495 25.5962 21 25.951 21H33.9773C34.3321 21 34.6724 20.8495 34.9232 20.5816C35.1741 20.3137 35.315 19.9503 35.315 19.5714V12.4286C35.315 12.0497 35.1741 11.6863 34.9232 11.4184C34.6724 11.1505 34.3321 11 33.9773 11H25.951ZM33.9773 11.7143C34.1547 11.7143 34.3248 11.7895 34.4503 11.9235C34.5757 12.0574 34.6462 12.2391 34.6462 12.4286V17.0714L32.1199 15.6807C32.0572 15.6472 31.9861 15.6355 31.9169 15.6474C31.8476 15.6594 31.7836 15.6942 31.734 15.7471L29.2525 18.3971L27.4733 17.1314C27.4091 17.0858 27.332 17.0652 27.2552 17.0733C27.1784 17.0814 27.1066 17.1175 27.0519 17.1757L25.2821 18.8571V12.4286C25.2821 12.2391 25.3526 12.0574 25.478 11.9235C25.6035 11.7895 25.7736 11.7143 25.951 11.7143H33.9773Z"
          fill="black"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const Printmob = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="#fff"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.75 10C19.75 15.3848 15.3848 19.75 10 19.75C4.61522 19.75 0.25 15.3848 0.25 10C0.25 4.61522 4.61522 0.25 10 0.25C15.3848 0.25 19.75 4.61522 19.75 10Z"
          stroke="#1FFC33"
          strokeWidth="0.5"
        />
        <path
          d="M6.25 6.17857C6.25 5.86599 6.36853 5.56622 6.5795 5.3452C6.79048 5.12417 7.07663 5 7.375 5H12.625C12.9234 5 13.2095 5.12417 13.4205 5.3452C13.6315 5.56622 13.75 5.86599 13.75 6.17857V6.57143H14.125C14.6223 6.57143 15.0992 6.77838 15.4508 7.14675C15.8025 7.51513 16 8.01475 16 8.53571V12.4643C16 12.7769 15.8815 13.0766 15.6705 13.2977C15.4595 13.5187 15.1734 13.6429 14.875 13.6429H13.75V14.8214C13.75 15.134 13.6315 15.4338 13.4205 15.6548C13.2095 15.8758 12.9234 16 12.625 16H7.375C7.07663 16 6.79048 15.8758 6.5795 15.6548C6.36853 15.4338 6.25 15.134 6.25 14.8214V13.6429H5.125C4.82663 13.6429 4.54048 13.5187 4.3295 13.2977C4.11853 13.0766 4 12.7769 4 12.4643V8.53571C4 8.01475 4.19754 7.51513 4.54917 7.14675C4.90081 6.77838 5.37772 6.57143 5.875 6.57143H6.25V6.17857ZM7 6.57143H13V6.17857C13 6.07438 12.9605 5.97445 12.8902 5.90078C12.8198 5.8271 12.7245 5.78571 12.625 5.78571H7.375C7.27554 5.78571 7.18016 5.8271 7.10984 5.90078C7.03951 5.97445 7 6.07438 7 6.17857V6.57143ZM6.25 12.8571V11.6786C6.25 11.366 6.36853 11.0662 6.5795 10.8452C6.79048 10.6242 7.07663 10.5 7.375 10.5H12.625C12.9234 10.5 13.2095 10.6242 13.4205 10.8452C13.6315 11.0662 13.75 11.366 13.75 11.6786V12.8571H14.875C14.9745 12.8571 15.0698 12.8158 15.1402 12.7421C15.2105 12.6684 15.25 12.5685 15.25 12.4643V8.53571C15.25 8.22314 15.1315 7.92336 14.9205 7.70234C14.7095 7.48131 14.4234 7.35714 14.125 7.35714H5.875C5.57663 7.35714 5.29048 7.48131 5.0795 7.70234C4.86853 7.92336 4.75 8.22314 4.75 8.53571V12.4643C4.75 12.5685 4.78951 12.6684 4.85984 12.7421C4.93016 12.8158 5.02554 12.8571 5.125 12.8571H6.25ZM7.375 11.2857C7.27554 11.2857 7.18016 11.3271 7.10984 11.4008C7.03951 11.4745 7 11.5744 7 11.6786V14.8214C7 14.9256 7.03951 15.0255 7.10984 15.0992C7.18016 15.1729 7.27554 15.2143 7.375 15.2143H12.625C12.7245 15.2143 12.8198 15.1729 12.8902 15.0992C12.9605 15.0255 13 14.9256 13 14.8214V11.6786C13 11.5744 12.9605 11.4745 12.8902 11.4008C12.8198 11.3271 12.7245 11.2857 12.625 11.2857H7.375Z"
          fill="#000"
        />
      </svg>
    </React.Fragment>
  );
};
export const Printbtn = (props) => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.75 8.75H15.625M4.375 15.625H1.25V5.625H18.75V15.625H15.625H4.375ZM4.375 11.875V18.75H15.625V11.875H4.375ZM15.625 5.625V1.25H4.375V5.625H15.625Z"
          stroke="#1FFC33"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const Close = (props) => {
  return (
    <React.Fragment>
      <svg
        onClick={props.onClick}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle r="11" transform="matrix(-1 0 0 1 11 11)" fill="black" />
        <path
          d="M15.4001 15.3996L6.6001 6.59961M15.4001 6.59961L6.6001 15.3996"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const Notification = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.31181 8.53855C2.31181 12.6812 1.3544 13.9471 0.770604 14.3153C0.28022 14.6375 0 15.1899 0 15.7422C0 16.7089 0.793956 17.4684 1.75137 17.4684H5.83791V17.5144C6.04808 18.9413 7.28571 20 8.73352 20C10.1813 20 11.419 18.9413 11.6291 17.5374V17.4914H15.2486C16.206 17.4914 17 16.7089 17 15.7652C17 15.1899 16.7198 14.6605 16.2294 14.3383C15.6456 13.9471 14.6882 12.6812 14.6882 8.56157C14.6882 4.69505 12.3063 3.15305 10.5549 2.50863C10.5783 2.37054 10.6016 2.20944 10.6016 2.07135C10.6016 0.920598 9.66758 0 8.5 0C7.33242 0 6.39835 0.920598 6.39835 2.07135C6.39835 2.20944 6.4217 2.37054 6.44505 2.50863C4.69368 3.10702 2.31181 4.67204 2.31181 8.53855ZM8.73352 19.0794C7.93956 19.0794 7.23901 18.6191 6.93544 17.9287H10.5549C10.228 18.6191 9.52747 19.0794 8.73352 19.0794ZM8.5 0.897583C9.15385 0.897583 9.66758 1.40391 9.66758 2.04833C9.66758 2.11738 9.66758 2.16341 9.64423 2.23245C8.68681 2.02532 7.79945 2.14039 7.33242 2.23245C7.33242 2.16341 7.30907 2.11738 7.30907 2.04833C7.33242 1.40391 7.84615 0.897583 8.5 0.897583ZM7.26236 3.19908H7.28571C7.28571 3.19908 7.79945 3.03797 8.52335 3.03797C8.89698 3.03797 9.29395 3.084 9.73764 3.22209H9.76099C11.5824 3.72842 13.7775 5.06329 13.7775 8.56157C13.7775 10.748 14.0343 12.4281 14.5481 13.5788H6.16483C5.90797 13.5788 5.6978 13.786 5.6978 14.0391C5.6978 14.2923 5.90797 14.4994 6.16483 14.4994H15.0385H15.0618C15.2486 14.7526 15.4588 14.9367 15.6923 15.0978C15.9258 15.2589 16.0659 15.5121 16.0659 15.7652C16.0659 16.2025 15.6923 16.5708 15.2486 16.5708H1.75137C1.30769 16.5708 0.934066 16.2025 0.934066 15.7652C0.934066 15.4891 1.07418 15.2359 1.30769 15.0978C2.59203 14.2232 3.24588 12.0368 3.24588 8.56157C3.24588 5.04028 5.41758 3.70541 7.26236 3.19908Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const DeleteIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 2.2V0H16.5V2.2H22V4.4H19.8V20.9C19.8 21.1917 19.6841 21.4715 19.4778 21.6778C19.2715 21.8841 18.9917 22 18.7 22H3.3C3.00826 22 2.72847 21.8841 2.52218 21.6778C2.31589 21.4715 2.2 21.1917 2.2 20.9V4.4H0V2.2H5.5ZM4.4 4.4V19.8H17.6V4.4H4.4ZM7.7 7.7H9.9V16.5H7.7V7.7ZM12.1 7.7H14.3V16.5H12.1V7.7Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};
export const Logout = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.32432 18.6395H2.7027C1.95946 18.6395 1.35135 18.0272 1.35135 17.2789V2.72109C1.35135 1.97279 1.95946 1.36054 2.7027 1.36054H9.32432C9.69595 1.36054 10 1.05442 10 0.680272C10 0.306122 9.69595 0 9.32432 0H2.7027C1.21622 0 0 1.22449 0 2.72109V17.2789C0 18.7755 1.21622 20 2.7027 20H9.32432C9.69595 20 10 19.6939 10 19.3197C10 18.9456 9.69595 18.6395 9.32432 18.6395Z"
          fill="#3A3A3A"
        />
        <path
          d="M16.9669 10.3801C16.9669 10.3452 16.9669 10.3452 16.9339 10.3103C16.9339 10.2754 16.9339 10.2405 16.9008 10.2405C16.8678 10.2405 16.9008 10.2056 16.8678 10.1707C16.8678 10.1358 16.8678 10.1358 16.8347 10.1358V10.066L12.6033 5.21402C12.3388 4.93477 11.9091 4.93477 11.6446 5.17911C11.3802 5.45836 11.3802 5.87723 11.6116 6.15648L14.8182 9.78672H5.66116C5.29752 9.78672 5 10.1009 5 10.4848C5 10.8688 5.29752 11.183 5.66116 11.183H14.8182L11.6116 14.8132C11.3802 15.0924 11.3802 15.5113 11.6446 15.7906C11.7769 15.9302 11.9421 16 12.1074 16C12.3058 16 12.4711 15.8953 12.6033 15.7557L16.8017 10.9735V10.9037C16.8347 10.9037 16.8347 10.9037 16.8347 10.8688C16.9008 10.8339 16.9008 10.8339 16.9008 10.799C16.9339 10.799 16.9339 10.7641 16.9339 10.7292C16.9669 10.6943 16.9669 10.6943 16.9669 10.6594C16.9669 10.6245 17 10.5546 17 10.5197C17 10.4848 16.9669 10.415 16.9669 10.3801Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};
export const OrderChecked = () => {
  return (
    <React.Fragment>
      <svg
        width="78"
        height="76"
        viewBox="0 0 78 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M71.2391 7.2359L33.9435 41.6601L20.3975 26.7163C19.0781 25.293 16.8791 25.2041 15.3837 26.4494C13.9763 27.7837 13.8884 30.0075 15.1198 31.5196L31.0408 49.132C31.7445 49.9326 32.7121 50.2884 33.6797 50.2884C34.5593 50.2884 35.3509 50.0215 36.0546 49.3989L75.989 12.484C77.3964 11.1498 77.4844 8.92598 76.2529 7.41381C74.9335 5.99059 72.7345 5.90163 71.2391 7.2359Z"
          fill="#1FFC33"
        />
        <path
          d="M37.7143 75.4286C58.5469 75.4286 75.4286 58.5469 75.4286 37.7143C75.4286 35.9184 75.3388 34.2122 75.0694 32.5061C74.8 30.5306 73.0041 29.1837 71.0286 29.4531C69.0531 29.7224 67.7061 31.5184 67.9755 33.4939C68.1551 34.9306 68.2449 36.3673 68.2449 37.7143C68.2449 54.5061 54.5061 68.2449 37.7143 68.2449C20.9224 68.2449 7.18367 54.5061 7.18367 37.7143C7.18367 20.9224 20.9224 7.18367 37.7143 7.18367C44.898 7.18367 51.902 9.69796 57.3796 14.3673C58.9061 15.6245 61.151 15.4449 62.4082 13.9184C63.6653 12.3918 63.4857 10.1469 61.9592 8.8898C55.2245 3.14286 46.6041 0 37.7143 0C16.8816 0 0 16.8816 0 37.7143C0 58.5469 16.8816 75.4286 37.7143 75.4286Z"
          fill="#1FFC33"
        />
      </svg>
    </React.Fragment>
  );
};

export const DemoImageIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.81105 3.57056C3.81105 3.81564 3.71369 4.05069 3.54039 4.22398C3.36709 4.39728 3.13205 4.49464 2.88697 4.49464C2.64189 4.49464 2.40684 4.39728 2.23355 4.22398C2.06025 4.05069 1.96289 3.81564 1.96289 3.57056C1.96289 3.32548 2.06025 3.09044 2.23355 2.91714C2.40684 2.74384 2.64189 2.64648 2.88697 2.64648C3.13205 2.64648 3.36709 2.74384 3.54039 2.91714C3.71369 3.09044 3.81105 3.32548 3.81105 3.57056Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          d="M1.38584 0.798828C1.04886 0.798828 0.725672 0.937911 0.487387 1.18548C0.249102 1.43305 0.115234 1.76882 0.115234 2.11894V8.71949C0.115234 9.06961 0.249102 9.40538 0.487387 9.65295C0.725672 9.90052 1.04886 10.0396 1.38584 10.0396H9.00948C9.34647 10.0396 9.66965 9.90052 9.90794 9.65295C10.1462 9.40538 10.2801 9.06961 10.2801 8.71949V2.11894C10.2801 1.76882 10.1462 1.43305 9.90794 1.18548C9.66965 0.937911 9.34647 0.798828 9.00948 0.798828H1.38584V0.798828ZM9.00948 1.45888C9.17798 1.45888 9.33957 1.52842 9.45871 1.65221C9.57785 1.77599 9.64479 1.94388 9.64479 2.11894V6.4093L7.24525 5.12417C7.18567 5.09316 7.11821 5.08241 7.05243 5.09342C6.98664 5.10444 6.92586 5.13667 6.87867 5.18556L4.5217 7.63436L2.83179 6.46474C2.77078 6.42254 2.69759 6.40356 2.62464 6.41102C2.5517 6.41848 2.48348 6.45192 2.43155 6.50567L0.750538 8.05944V2.11894C0.750538 1.94388 0.817471 1.77599 0.936614 1.65221C1.05576 1.52842 1.21735 1.45888 1.38584 1.45888H9.00948Z"
          fill="black"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};

// export const Print = () => {
//   return (
//       <React.Fragment>
//           <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M3.375 1.60714C3.375 1.1809 3.55279 0.772119 3.86926 0.470721C4.18572 0.169324 4.61495 0 5.0625 0H12.9375C13.3851 0 13.8143 0.169324 14.1307 0.470721C14.4472 0.772119 14.625 1.1809 14.625 1.60714V2.14286H15.1875C15.9334 2.14286 16.6488 2.42506 17.1762 2.92739C17.7037 3.42972 18 4.11103 18 4.82143V10.1786C18 10.6048 17.8222 11.0136 17.5057 11.315C17.1893 11.6164 16.7601 11.7857 16.3125 11.7857H14.625V13.3929C14.625 13.8191 14.4472 14.2279 14.1307 14.5293C13.8143 14.8307 13.3851 15 12.9375 15H5.0625C4.61495 15 4.18572 14.8307 3.86926 14.5293C3.55279 14.2279 3.375 13.8191 3.375 13.3929V11.7857H1.6875C1.23995 11.7857 0.810725 11.6164 0.494257 11.315C0.17779 11.0136 0 10.6048 0 10.1786V4.82143C0 4.11103 0.296316 3.42972 0.823762 2.92739C1.35121 2.42506 2.06658 2.14286 2.8125 2.14286H3.375V1.60714ZM13.5 1.60714C13.5 1.46506 13.4407 1.3288 13.3352 1.22834C13.2298 1.12787 13.0867 1.07143 12.9375 1.07143H5.0625C4.91332 1.07143 4.77024 1.12787 4.66475 1.22834C4.55926 1.3288 4.5 1.46506 4.5 1.60714V2.14286H13.5V1.60714ZM4.5 9.10714V13.3929C4.5 13.5349 4.55926 13.6712 4.66475 13.7717C4.77024 13.8721 4.91332 13.9286 5.0625 13.9286H12.9375C13.0867 13.9286 13.2298 13.8721 13.3352 13.7717C13.4407 13.6712 13.5 13.5349 13.5 13.3929V9.10714C13.5 8.96506 13.4407 8.8288 13.3352 8.72834C13.2298 8.62787 13.0867 8.57143 12.9375 8.57143H5.0625C4.91332 8.57143 4.77024 8.62787 4.66475 8.72834C4.55926 8.8288 4.5 8.96506 4.5 9.10714Z" fill="black" />
//           </svg>
//       </React.Fragment>
//   )
// }
export const Download = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8462 15.75C13.8462 15.5469 13.7776 15.3711 13.6406 15.2227C13.5036 15.0742 13.3413 15 13.1538 15C12.9663 15 12.8041 15.0742 12.6671 15.2227C12.53 15.3711 12.4615 15.5469 12.4615 15.75C12.4615 15.9531 12.53 16.1289 12.6671 16.2773C12.8041 16.4258 12.9663 16.5 13.1538 16.5C13.3413 16.5 13.5036 16.4258 13.6406 16.2773C13.7776 16.1289 13.8462 15.9531 13.8462 15.75ZM16.6154 15.75C16.6154 15.5469 16.5469 15.3711 16.4099 15.2227C16.2728 15.0742 16.1106 15 15.9231 15C15.7356 15 15.5733 15.0742 15.4363 15.2227C15.2993 15.3711 15.2308 15.5469 15.2308 15.75C15.2308 15.9531 15.2993 16.1289 15.4363 16.2773C15.5733 16.4258 15.7356 16.5 15.9231 16.5C16.1106 16.5 16.2728 16.4258 16.4099 16.2773C16.5469 16.1289 16.6154 15.9531 16.6154 15.75ZM18 13.125V16.875C18 17.1875 17.899 17.4531 17.6971 17.6719C17.4952 17.8906 17.25 18 16.9615 18H1.03846C0.75 18 0.504808 17.8906 0.302885 17.6719C0.100962 17.4531 0 17.1875 0 16.875V13.125C0 12.8125 0.100962 12.5469 0.302885 12.3281C0.504808 12.1094 0.75 12 1.03846 12H6.06851L7.52885 13.5938C7.94712 14.0312 8.4375 14.25 9 14.25C9.5625 14.25 10.0529 14.0312 10.4712 13.5938L11.9423 12H16.9615C17.25 12 17.4952 12.1094 17.6971 12.3281C17.899 12.5469 18 12.8125 18 13.125ZM14.4844 6.45703C14.607 6.77734 14.5565 7.05078 14.3329 7.27734L9.48678 12.5273C9.35697 12.6758 9.19471 12.75 9 12.75C8.80529 12.75 8.64303 12.6758 8.51322 12.5273L3.66707 7.27734C3.44351 7.05078 3.39303 6.77734 3.51562 6.45703C3.63822 6.15234 3.85096 6 4.15385 6H6.92308V0.75C6.92308 0.546875 6.99159 0.371094 7.12861 0.222656C7.26562 0.0742188 7.42788 0 7.61539 0H10.3846C10.5721 0 10.7344 0.0742188 10.8714 0.222656C11.0084 0.371094 11.0769 0.546875 11.0769 0.75V6H13.8462C14.149 6 14.3618 6.15234 14.4844 6.45703Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Email = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="15"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2 0H1.8C0.81 0 0.00899999 0.84375 0.00899999 1.875L0 13.125C0 14.1562 0.81 15 1.8 15H16.2C17.19 15 18 14.1562 18 13.125V1.875C18 0.84375 17.19 0 16.2 0ZM16.2 3.75L9 8.4375L1.8 3.75V1.875L9 6.5625L16.2 1.875V3.75Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Send = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.311392 0.220552C0.44572 0.103856 0.611625 0.0296026 0.78814 0.00717647C0.964655 -0.0152496 1.14386 0.0151582 1.30309 0.0945567L17.5015 8.19424C17.6513 8.26888 17.7772 8.3838 17.8653 8.52608C17.9534 8.66837 18 8.83238 18 8.99971C18 9.16704 17.9534 9.33106 17.8653 9.47334C17.7772 9.61563 17.6513 9.73054 17.5015 9.80518L1.30309 17.9049C1.14387 17.9845 0.964586 18.0152 0.787936 17.9929C0.611285 17.9707 0.445205 17.8965 0.310711 17.7799C0.176217 17.6632 0.0793545 17.5092 0.0323797 17.3375C-0.014595 17.1657 -0.00957043 16.9839 0.0468176 16.815L2.35239 9.89968H7.20022C7.43889 9.89968 7.66778 9.80486 7.83655 9.63608C8.00532 9.46731 8.10013 9.2384 8.10013 8.99971C8.10013 8.76103 8.00532 8.53212 7.83655 8.36334C7.66778 8.19457 7.43889 8.09975 7.20022 8.09975H2.35239L0.0459176 1.18441C-0.01018 1.01559 -0.0149871 0.833929 0.0321034 0.662375C0.0791939 0.490821 0.176069 0.337072 0.310492 0.220552H0.311392Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const InvoiceWhatsapp = () => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 0C4.02975 0 0 4.02975 0 9C0 10.6884 0.474256 12.2626 1.2832 13.6128L0.0805664 18L4.56152 16.8237C5.87202 17.5688 7.38487 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM5.91943 4.80176C6.06568 4.80176 6.21595 4.80087 6.3457 4.80762C6.5062 4.81137 6.68089 4.82312 6.84814 5.19287C7.04689 5.63237 7.47966 6.73493 7.53516 6.84668C7.59066 6.95843 7.62998 7.09008 7.55273 7.23633C7.47923 7.38633 7.44101 7.47711 7.33301 7.60986C7.22126 7.73886 7.09881 7.89908 6.99756 7.99658C6.88581 8.10833 6.77041 8.23086 6.89941 8.45361C7.02841 8.67636 7.47642 9.40659 8.13867 9.99609C8.98992 10.7566 9.70814 10.9903 9.93164 11.1021C10.1551 11.2138 10.2846 11.1964 10.4136 11.0464C10.5463 10.9001 10.9711 10.3983 11.1211 10.1748C11.2673 9.9513 11.4166 9.98998 11.6191 10.0635C11.8246 10.137 12.9205 10.6768 13.144 10.7886C13.3675 10.9003 13.5141 10.9556 13.5703 11.0464C13.6281 11.1401 13.6281 11.5864 13.4429 12.1069C13.2576 12.6267 12.3479 13.1293 11.9399 13.1646C11.5282 13.2028 11.1439 13.3496 9.26367 12.6094C6.99567 11.7161 5.56536 9.39316 5.45361 9.24316C5.34186 9.09691 4.54541 8.03543 4.54541 6.94043C4.54541 5.84168 5.12149 5.30358 5.32324 5.08008C5.52874 4.85658 5.76943 4.80176 5.91943 4.80176Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};

export const InventoryIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="21"
        height="30"
        viewBox="0 0 21 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.006 12.8598H18.1637H17.5304V8.51524C17.5304 8.10975 17.185 7.76219 16.782 7.76219H14.9397H13.0974H11.8596V3.30183C11.8596 2.78049 11.4279 2.34604 10.9097 2.34604H9.1538C9.03866 1.85366 8.60688 1.5061 8.08874 1.5061H7.05246V1.12957C7.05246 0.521341 6.5631 0 5.92982 0C5.29654 0 4.80719 0.492378 4.80719 1.12957V1.5061H3.77091C3.25277 1.5061 2.82098 1.85366 2.70584 2.34604H0.949923C0.431784 2.34604 0 2.78049 0 3.30183V17.378C0 17.8994 0.431784 18.3338 0.949923 18.3338H7.31153C7.34031 18.7104 7.65696 19 8.05995 19H13.558C13.7307 19 13.9034 18.9421 14.0186 18.8262C14.1337 18.9131 14.3064 19 14.4791 19H19.9772C20.3802 19 20.7256 18.6524 20.7256 18.2469V13.6128C20.7544 13.1784 20.409 12.8598 20.006 12.8598ZM16.6093 13.439H17.2425H17.8758V14.8872L17.4153 14.5396C17.3577 14.5107 17.3001 14.4817 17.2425 14.4817C17.185 14.4817 17.1274 14.5107 17.0698 14.5396L16.6093 14.8872V13.439V13.439ZM16.9547 8.48628V12.8308H16.3214H14.4791C14.4216 12.8308 14.3928 12.8308 14.3352 12.8308C14.3064 12.8308 14.3064 12.8308 14.3064 12.8308C14.2776 12.8308 14.2488 12.8598 14.2201 12.8598C14.1913 12.8598 14.1913 12.8598 14.1625 12.8887C14.1337 12.8887 14.1049 12.9177 14.0761 12.9177L14.0473 12.9466C14.0473 12.9466 14.0186 12.9466 14.0186 12.9756C14.0186 12.9756 13.9898 12.9756 13.9898 12.9466L13.961 12.9177C13.9322 12.8887 13.9034 12.8887 13.8746 12.8887C13.8458 12.8887 13.8458 12.8887 13.8171 12.8598C13.7883 12.8598 13.7595 12.8308 13.7307 12.8308H13.7019C13.6443 12.8308 13.6156 12.8308 13.558 12.8308H11.7157H11.0824V8.48628C11.0824 8.39939 11.1688 8.3125 11.2551 8.3125H11.5718H12.8096V10.3399C12.8096 10.4558 12.8671 10.5427 12.9823 10.6006C13.0686 10.6585 13.1838 10.6296 13.2701 10.5716L14.0186 9.99238L14.767 10.5716C14.8246 10.6006 14.8821 10.6296 14.9397 10.6296C14.9973 10.6296 15.0261 10.6296 15.0548 10.6006C15.1412 10.5427 15.2276 10.4558 15.2276 10.3399V8.3125H16.782C16.8971 8.3125 16.9547 8.39939 16.9547 8.48628ZM10.1901 13.439H10.8234H11.4566V14.8872L10.9961 14.5396C10.8809 14.4527 10.7658 14.4527 10.6507 14.5396L10.1901 14.8872V13.439ZM14.6806 8.3125V9.76067L14.2201 9.41311C14.1625 9.38415 14.1049 9.35518 14.0473 9.35518C13.9898 9.35518 13.9322 9.38415 13.8746 9.41311L13.4141 9.78963V8.34146H14.6806V8.3125ZM3.79969 2.08537H5.12383C5.29654 2.08537 5.41168 1.96951 5.41168 1.79573V1.12957C5.41168 0.839939 5.64197 0.579268 5.95861 0.579268C6.27525 0.579268 6.50553 0.810975 6.50553 1.12957V1.79573C6.50553 1.96951 6.62068 2.08537 6.79339 2.08537H8.11752C8.40538 2.08537 8.66445 2.31707 8.66445 2.63567C8.66445 2.9253 8.43417 3.18598 8.11752 3.18598H3.79969C3.51184 3.18598 3.25277 2.95427 3.25277 2.63567C3.25277 2.31707 3.51184 2.08537 3.79969 2.08537ZM0.604497 17.378V3.30183C0.604497 3.09908 0.77721 2.9253 0.978709 2.9253H2.70584C2.70584 2.95427 2.73463 2.98323 2.73463 3.04116C2.73463 3.07012 2.73463 3.07012 2.76341 3.09908C2.7922 3.15701 2.82098 3.21494 2.84977 3.27287C2.84977 3.27287 2.84977 3.30183 2.87855 3.30183C2.90734 3.35976 2.93613 3.38872 2.9937 3.41768C3.02248 3.44665 3.02248 3.44665 3.05127 3.47561C3.08005 3.50457 3.10884 3.53354 3.16641 3.5625C3.1952 3.59146 3.1952 3.59146 3.22398 3.59146C3.25277 3.62043 3.31034 3.62043 3.33912 3.64939C3.36791 3.64939 3.39669 3.67835 3.39669 3.67835C3.42548 3.70732 3.48305 3.70732 3.51184 3.70732C3.54062 3.70732 3.54062 3.70732 3.56941 3.73628C3.62698 3.73628 3.71334 3.76524 3.77091 3.76524H8.08874C8.14631 3.76524 8.23267 3.76524 8.29024 3.73628C8.31902 3.73628 8.31902 3.73628 8.34781 3.70732C8.40538 3.70732 8.43417 3.67835 8.49174 3.67835C8.52052 3.67835 8.54931 3.64939 8.54931 3.64939C8.57809 3.62043 8.63566 3.62043 8.66445 3.59146C8.69324 3.59146 8.69324 3.5625 8.72202 3.5625C8.75081 3.53354 8.77959 3.50457 8.83716 3.47561C8.86595 3.44665 8.86595 3.44665 8.89473 3.41768C8.92352 3.38872 8.98109 3.33079 9.00988 3.27287C9.00988 3.27287 9.00988 3.2439 9.03866 3.2439C9.06745 3.18597 9.09623 3.12805 9.12502 3.07012C9.12502 3.04116 9.12502 3.04116 9.1538 3.01219C9.1538 2.98323 9.18259 2.95427 9.18259 2.89634H10.9097C11.1112 2.89634 11.2839 3.07012 11.2839 3.27287V7.70427H11.2551C10.8522 7.70427 10.5067 8.05183 10.5067 8.45732V12.8018H9.87344H8.03117C7.9736 12.8018 7.91603 12.8018 7.85845 12.8308C7.82967 12.8308 7.82967 12.8308 7.80088 12.8598C7.7721 12.8598 7.71453 12.8887 7.68574 12.8887C7.65696 12.8887 7.65696 12.9177 7.62817 12.9177C7.59939 12.9466 7.5706 12.9466 7.54181 12.9756L7.51303 13.0046H3.62698C3.10884 13.0046 2.67706 13.439 2.67706 13.9604C2.67706 14.4817 3.10884 14.9162 3.62698 14.9162H7.31153V17.6966H0.978709C0.77721 17.7546 0.604497 17.5808 0.604497 17.378ZM7.31153 14.3948H3.62698C3.42548 14.3948 3.25277 14.221 3.25277 14.0183C3.25277 13.8155 3.42548 13.6418 3.62698 13.6418H7.31153V14.3948ZM13.5868 18.4207H8.05995C7.9736 18.4207 7.88724 18.3338 7.88724 18.2469V18.0442V14.6844V13.6128C7.88724 13.5838 7.88724 13.5549 7.91603 13.5259C7.91603 13.5259 7.91603 13.4969 7.94481 13.4969C7.94481 13.4969 7.9736 13.468 8.00238 13.468C8.03117 13.468 8.03117 13.468 8.05995 13.468H9.61437V15.4954C9.61437 15.6113 9.67194 15.6982 9.78709 15.7561C9.81587 15.7851 9.87344 15.7851 9.90223 15.7851C9.9598 15.7851 10.0174 15.7561 10.0749 15.7271L10.8234 15.1479L11.5718 15.7271C11.6581 15.7851 11.7733 15.814 11.8596 15.7561C11.946 15.6982 12.0324 15.6113 12.0324 15.4954V13.468H13.5868C13.6731 13.468 13.7595 13.5549 13.7595 13.6418V18.2759C13.7595 18.3338 13.6731 18.4207 13.5868 18.4207ZM20.1787 18.2469C20.1787 18.3338 20.0923 18.4207 20.006 18.4207H14.5079C14.4216 18.4207 14.3352 18.3338 14.3352 18.2469V13.6128C14.3352 13.5259 14.4216 13.439 14.5079 13.439H16.0623V15.4665C16.0623 15.5823 16.1199 15.6692 16.235 15.7271C16.2638 15.7561 16.3214 15.7561 16.3502 15.7561C16.4078 15.7561 16.4653 15.7271 16.5229 15.6982L17.2713 15.1189L18.0198 15.6982C18.1061 15.7561 18.2213 15.7851 18.3076 15.7271C18.394 15.6692 18.4803 15.5823 18.4803 15.4665V13.439H20.0347C20.1211 13.439 20.2075 13.5259 20.2075 13.6128V18.2469H20.1787Z"
          fill={props.color}
        />
        <path
          d="M3.5524 7.77248H8.2485C8.77353 7.77248 9.21106 7.31449 9.21106 6.7649C9.21106 6.21531 8.77353 5.75732 8.2485 5.75732H3.5524C3.02737 5.75732 2.58984 6.21531 2.58984 6.7649C2.58984 7.31449 3.02737 7.77248 3.5524 7.77248ZM3.5524 6.36798H8.2485C8.45268 6.36798 8.62769 6.55117 8.62769 6.7649C8.62769 6.97863 8.45268 7.16182 8.2485 7.16182H3.5524C3.34822 7.16182 3.17321 6.97863 3.17321 6.7649C3.17321 6.55117 3.34822 6.36798 3.5524 6.36798Z"
          fill={props.color}
        />
        <path
          d="M3.5524 11.5152H8.2485C8.77353 11.5152 9.21106 11.0572 9.21106 10.5076C9.21106 9.95799 8.77353 9.5 8.2485 9.5H3.5524C3.02737 9.5 2.58984 9.95799 2.58984 10.5076C2.58984 11.0572 3.02737 11.5152 3.5524 11.5152ZM3.5524 10.1107H8.2485C8.45268 10.1107 8.62769 10.2938 8.62769 10.5076C8.62769 10.7213 8.45268 10.9045 8.2485 10.9045H3.5524C3.34822 10.9045 3.17321 10.7213 3.17321 10.5076C3.17321 10.2938 3.34822 10.1107 3.5524 10.1107Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};

export const LargeEyeIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="24"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9603 7.26818C19.1762 5.19385 17.8149 3.39997 16.0447 2.10824C14.2745 0.816515 12.1731 0.0835725 10 0C7.82695 0.0835725 5.72547 0.816515 3.9553 2.10824C2.18512 3.39997 0.823847 5.19385 0.0397175 7.26818C-0.0132392 7.41798 -0.0132392 7.58202 0.0397175 7.73182C0.823847 9.80615 2.18512 11.6 3.9553 12.8918C5.72547 14.1835 7.82695 14.9164 10 15C12.1731 14.9164 14.2745 14.1835 16.0447 12.8918C17.8149 11.6 19.1762 9.80615 19.9603 7.73182C20.0132 7.58202 20.0132 7.41798 19.9603 7.26818ZM10 13.6364C6.46657 13.6364 2.73313 10.9568 1.37976 7.5C2.73313 4.04318 6.46657 1.36364 10 1.36364C13.5334 1.36364 17.2669 4.04318 18.6202 7.5C17.2669 10.9568 13.5334 13.6364 10 13.6364Z"
          fill={props.color}
        />
        <path
          d="M10 3C9.20888 3 8.43552 3.2346 7.77772 3.67412C7.11992 4.11365 6.60723 4.73836 6.30448 5.46927C6.00173 6.20017 5.92252 7.00444 6.07686 7.78036C6.2312 8.55628 6.61216 9.26902 7.17157 9.82843C7.73098 10.3878 8.44372 10.7688 9.21964 10.9231C9.99556 11.0775 10.7998 10.9983 11.5307 10.6955C12.2616 10.3928 12.8864 9.88008 13.3259 9.22228C13.7654 8.56448 14 7.79112 14 7C14 5.93913 13.5786 4.92172 12.8284 4.17157C12.0783 3.42143 11.0609 3 10 3ZM10 9.66667C9.47258 9.66667 8.95701 9.51027 8.51848 9.21725C8.07995 8.92423 7.73816 8.50776 7.53632 8.02049C7.33449 7.53322 7.28168 6.99704 7.38457 6.47976C7.48747 5.96248 7.74144 5.48732 8.11438 5.11438C8.48732 4.74144 8.96248 4.48747 9.47976 4.38457C9.99704 4.28168 10.5332 4.33449 11.0205 4.53632C11.5078 4.73815 11.9242 5.07995 12.2173 5.51848C12.5103 5.95701 12.6667 6.47258 12.6667 7C12.6667 7.70724 12.3857 8.38552 11.8856 8.88562C11.3855 9.38571 10.7072 9.66667 10 9.66667Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const AddDealerIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="19"
        height="15"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 7.99632C13.2439 7.99632 15 6.24103 15 3.99816C15 1.75529 13.2439 0 11 0C8.7561 0 7 1.75529 7 3.99816C7 6.24103 8.7561 8.09383 11 7.99632ZM11 1.46274C12.3659 1.46274 13.5366 2.63293 13.5366 3.99816C13.5366 5.36338 12.3659 6.53358 11 6.53358C9.63415 6.53358 8.46341 5.36338 8.46341 3.99816C8.46341 2.63293 9.53658 1.46274 11 1.46274Z"
          fill="white"
        />
        <path
          d="M11.451 9C7.33333 9 4 12.2381 4 16.2381C4 16.619 4.29412 17 4.78431 17C5.17647 17 5.56863 16.7143 5.56863 16.2381C5.66667 13.0952 8.5098 10.619 11.7451 10.7143C14.8824 10.8095 17.3333 13.2857 17.4314 16.2381C17.4314 16.619 17.7255 17 18.2157 17C18.7059 17 19 16.7143 19 16.2381C18.8039 12.2381 15.5686 9 11.451 9Z"
          fill="white"
        />
        <path
          d="M5.14286 8.18182C5.57143 8.18182 6 7.90909 6 7.54545C6 7.18182 5.67857 6.81818 5.14286 6.81818H3.75V5.72727C3.75 5.36364 3.42857 5 2.89286 5C2.46429 5 2.03571 5.27273 2.03571 5.72727V6.81818H0.857143C0.428572 6.81818 0 7.09091 0 7.54545C0 8 0.321429 8.18182 0.857143 8.18182H2.14286V9.27273C2.14286 9.63636 2.46429 10 3 10C3.53571 10 3.85714 9.72727 3.85714 9.27273V8.18182H5.14286Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const PackingOrderIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="32"
        viewBox="0 0 24 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.2381 0H0.761905C0.342857 0 0 0.342857 0 0.761905V30.6667C0 30.9333 0.152381 31.2 0.380952 31.3524C0.609524 31.4667 0.914286 31.4667 1.14286 31.3143L6.05714 28.1524L11.3905 30.2476C11.581 30.3238 11.7714 30.3238 11.9619 30.2476L15.7333 28.6857L22.9333 31.9238C23.0476 31.9619 23.1238 32 23.2381 32C23.3905 32 23.5429 31.9619 23.6571 31.8857C23.8857 31.7333 24 31.5048 24 31.2381V0.761905C24 0.342857 23.6952 0 23.2381 0ZM22.4762 30.0571L16.0381 27.1619C15.9238 27.1238 15.8476 27.0857 15.7333 27.0857C15.619 27.0857 15.5429 27.0857 15.4286 27.1619L11.619 28.7238L6.20952 26.5905C5.98095 26.5143 5.71429 26.5143 5.52381 26.6667L1.48571 29.2952V1.52381H22.4762V30.0571V30.0571ZM5.10476 4.7619C5.10476 4.34286 5.44762 4 5.86667 4H18.1333C18.5524 4 18.8952 4.34286 18.8952 4.7619C18.8952 5.18095 18.5524 5.52381 18.1333 5.52381H5.86667C5.44762 5.52381 5.10476 5.18095 5.10476 4.7619ZM5.10476 10.1333C5.10476 9.71429 5.44762 9.37143 5.86667 9.37143H18.1333C18.5524 9.37143 18.8952 9.71429 18.8952 10.1333C18.8952 10.5524 18.5524 10.8952 18.1333 10.8952H5.86667C5.44762 10.8952 5.10476 10.5524 5.10476 10.1333ZM5.10476 15.5048C5.10476 15.0857 5.44762 14.7429 5.86667 14.7429H18.1333C18.5524 14.7429 18.8952 15.0857 18.8952 15.5048C18.8952 15.9238 18.5524 16.2667 18.1333 16.2667H5.86667C5.44762 16.2667 5.10476 15.9238 5.10476 15.5048ZM12.381 22.8571C12.381 23.2762 12.0381 23.619 11.619 23.619H5.90476C5.48571 23.619 5.14286 23.2762 5.14286 22.8571C5.14286 22.4381 5.48571 22.0952 5.90476 22.0952H11.619C12.0381 22.0952 12.381 22.4381 12.381 22.8571Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};

export const DispatchIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="15"
        className={props.css}
        height="19"
        viewBox="0 0 15 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.4422 5.17203C9.3759 5.17203 9.30901 5.16508 9.24241 5.15089C7.99901 4.87777 6.68961 4.87707 5.34911 5.1488C4.93367 5.23058 4.50561 5.02671 4.32928 4.66388L3.91061 3.80627C3.87628 3.7359 3.87364 3.65524 3.90328 3.58293C3.9332 3.51061 3.99276 3.45304 4.06845 3.42342C6.25627 2.56733 8.4746 2.56705 10.663 3.42342C10.7437 3.45499 10.8059 3.5184 10.8335 3.59697C10.861 3.67568 10.8511 3.76163 10.8062 3.83283L10.227 4.75149C10.056 5.01683 9.75643 5.17203 9.4422 5.17203ZM7.32774 4.37574C8.02454 4.37574 8.70902 4.44903 9.37619 4.5956C9.50528 4.62328 9.64142 4.56751 9.71271 4.45681L10.1082 3.82949C8.2748 3.18896 6.42145 3.19327 4.58981 3.84117L4.87469 4.42511C4.93543 4.54971 5.08241 4.61897 5.225 4.59143C5.93472 4.44764 6.63739 4.37574 7.32774 4.37574Z"
          fill={props.color}
        />
        <path
          d="M5.99574 15.0175C5.94264 15.0175 5.88954 15.0042 5.8423 14.9775C5.75106 14.9262 5.69531 14.8331 5.69531 14.7327V11.5211C5.69531 11.3639 5.82969 11.2363 5.99574 11.2363H8.73103C8.89709 11.2363 9.03146 11.3639 9.03146 11.5211V14.7327C9.03146 14.8314 8.97748 14.9232 8.88887 14.9751C8.80027 15.0268 8.68966 15.0314 8.59636 14.9873L7.31424 14.3778L6.13921 14.983C6.09432 15.006 6.04503 15.0175 5.99574 15.0175ZM7.30867 13.7718C7.35473 13.7718 7.40079 13.7818 7.44334 13.8019L8.4306 14.2713V11.8059H6.29618V14.2539L7.1652 13.8063C7.2098 13.7833 7.25938 13.7718 7.30867 13.7718Z"
          fill={props.color}
        />
        <path
          d="M11.283 18.2252H3.44502C2.95828 18.2252 2.5625 17.8499 2.5625 17.3886V12.069C2.5625 11.6078 2.95828 11.2324 3.44502 11.2324H11.283C11.7697 11.2324 12.1655 11.6078 12.1655 12.069V17.3886C12.1655 17.8499 11.7697 18.2252 11.283 18.2252ZM3.44502 11.802C3.28982 11.802 3.16336 11.9218 3.16336 12.069V17.3886C3.16336 17.5358 3.28982 17.6556 3.44502 17.6556H11.283C11.4382 17.6556 11.5646 17.5358 11.5646 17.3886V12.069C11.5646 11.9218 11.4382 11.802 11.283 11.802H3.44502Z"
          fill={props.color}
        />
        <path
          d="M7.66807 11.8041H7.08012C6.98007 11.8041 6.88648 11.7569 6.83074 11.678L5.00027 9.09279C4.96682 9.04592 4.94922 8.99071 4.94922 8.93411V7.65388C4.94922 7.53859 5.02257 7.43457 5.13494 7.39063C5.24789 7.34682 5.37698 7.37116 5.46265 7.45307C5.99574 7.96121 6.67465 8.24101 7.3741 8.24101C8.07559 8.24101 8.75567 7.96121 9.28877 7.45307C9.37473 7.37116 9.50382 7.34682 9.61648 7.39063C9.72885 7.43457 9.8022 7.53859 9.8022 7.65388V8.93411C9.8022 8.99085 9.7843 9.04634 9.75086 9.09334L7.91746 11.6783C7.86171 11.757 7.76812 11.8041 7.66807 11.8041ZM7.24031 11.2345H7.50818L9.20134 8.84706V8.26159C8.65328 8.61885 8.02249 8.81062 7.3741 8.81062C6.72717 8.81062 6.09755 8.61885 5.55008 8.26173V8.84734L7.24031 11.2345Z"
          fill={props.color}
        />
        <path
          d="M5.24083 7.93922C5.16337 7.93922 5.08592 7.91099 5.02724 7.85467C4.49855 7.34791 4.11743 6.67706 3.94228 5.95128C3.4573 5.75631 3.13281 5.28641 3.13281 4.74906C3.13281 4.13661 3.55266 3.61637 4.15411 3.48384C4.31489 3.4488 4.47713 3.54364 4.51468 3.69675C4.55224 3.85 4.4519 4.00311 4.29024 4.03871C3.9678 4.10977 3.73368 4.40849 3.73368 4.74906C3.73368 5.09074 3.95607 5.38222 4.27469 5.45774C4.38853 5.48485 4.47566 5.57246 4.49708 5.68205C4.62969 6.35999 4.96973 6.9894 5.45442 7.45416C5.57119 7.56597 5.57001 7.74634 5.45207 7.85689C5.39339 7.91182 5.31711 7.93922 5.24083 7.93922Z"
          fill={props.color}
        />
        <path
          d="M9.49184 7.9364C9.41526 7.9364 9.33869 7.90886 9.28001 7.85352C9.16236 7.74268 9.16177 7.56231 9.27884 7.45078C9.76645 6.98602 10.0971 6.37302 10.2356 5.67839C10.257 5.56978 10.3433 5.48287 10.4559 5.45533C10.7754 5.37759 10.9987 5.08597 10.9987 4.74624C10.9987 4.40274 10.7619 4.10292 10.436 4.03353C10.274 3.99918 10.1722 3.84676 10.2086 3.69323C10.245 3.53984 10.406 3.44291 10.5674 3.47782C11.1656 3.60507 11.5996 4.13852 11.5996 4.74624C11.5996 5.28094 11.2751 5.75085 10.7901 5.94762C10.6117 6.68787 10.2385 7.34356 9.70484 7.8524C9.64616 7.90845 9.569 7.9364 9.49184 7.9364Z"
          fill={props.color}
        />
        <path
          d="M10.5484 3.97157C10.5096 3.97157 10.4706 3.96448 10.4336 3.95002C8.39781 3.15303 6.33321 3.15303 4.29796 3.95002C4.20496 3.98645 4.09934 3.9763 4.01631 3.92345C3.93298 3.87061 3.88281 3.78189 3.88281 3.68676V2.42308C3.88281 1.08694 5.02821 0 6.4359 0H8.29571C9.7034 0 10.8488 1.08694 10.8488 2.42308V3.68676C10.8488 3.78189 10.7986 3.87061 10.7153 3.92345C10.6651 3.9553 10.607 3.97157 10.5484 3.97157ZM7.36595 2.78131C8.32827 2.78131 9.2906 2.94457 10.2479 3.27138V2.42308C10.2479 1.40108 9.37216 0.569612 8.29571 0.569612H6.4359C5.35945 0.569612 4.48368 1.40108 4.48368 2.42308V3.27138C5.44101 2.94457 6.40334 2.78131 7.36595 2.78131Z"
          fill={props.color}
        />
        <path
          d="M0.300432 15.3654C0.134373 15.3654 0 15.2379 0 15.0806V13.2738C0 12.1152 0.67656 11.0661 1.76533 10.5357L5.1895 8.80684C5.3359 8.733 5.51781 8.7857 5.59585 8.92435C5.67389 9.06328 5.61844 9.23572 5.47174 9.3097L2.04376 11.0405C1.15215 11.4747 0.600865 12.3296 0.600865 13.2738V15.0806C0.600865 15.2379 0.466487 15.3654 0.300432 15.3654Z"
          fill={props.color}
        />
        <path
          d="M14.4283 15.3678C14.2622 15.3678 14.1279 15.2403 14.1279 15.083V13.2393C14.1279 12.3157 13.5951 11.4694 12.7372 11.0306L9.25932 9.31318C9.11204 9.24058 9.05512 9.06856 9.1317 8.92908C9.20768 8.78945 9.38929 8.73452 9.53687 8.80809L13.0185 10.5275C14.075 11.0676 14.7287 12.106 14.7287 13.2393V15.083C14.7287 15.2403 14.5943 15.3678 14.4283 15.3678Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};
export const PackersIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="16"
        className={props.css + " mb-1"}
        height="24"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.153527 14.9415L7.81686 19.9409C7.83117 19.9436 7.84587 19.9436 7.86018 19.9409H7.88683C7.9191 19.9692 7.95812 19.9887 8.00012 19.9976C8.03002 20.0008 8.06018 20.0008 8.09008 19.9976H8.11673H8.16005L15.4902 14.9982C15.5492 14.9665 15.5973 14.9178 15.6282 14.8583C15.6591 14.7988 15.6714 14.7314 15.6635 14.6649V6.74254C15.6677 6.71717 15.6677 6.69126 15.6635 6.66588C15.6654 6.65823 15.6654 6.65021 15.6635 6.64255C15.6566 6.62278 15.6477 6.60379 15.6368 6.58589C15.6378 6.57704 15.6378 6.56809 15.6368 6.55923L15.6035 6.51924L15.5768 6.49591L15.5568 6.47591L11.1321 3.44295L11.5619 2.77636L12.145 3.05299C12.2655 3.11129 12.3976 3.14203 12.5315 3.14298C12.8301 3.11502 13.1058 2.97074 13.299 2.74129C13.4922 2.51183 13.5875 2.21559 13.5644 1.91647C13.5648 1.83273 13.5581 1.7491 13.5444 1.6665C13.5031 1.37217 13.3504 1.10493 13.1179 0.919923C13.0673 0.879741 13.0126 0.845103 12.9546 0.816602C12.8782 0.778827 12.7977 0.74976 12.7147 0.729946L10.9055 0.023366C10.8676 0.00734372 10.8267 -0.000601746 10.7856 3.55128e-05C10.5348 0.0103399 10.2938 0.0997078 10.0969 0.255354C9.89999 0.411 9.75736 0.62495 9.68938 0.866596L8.99968 1.96313L8.26334 1.46652C8.20858 1.42998 8.14424 1.41048 8.07842 1.41048C8.0126 1.41048 7.94825 1.42998 7.8935 1.46652L0.156859 6.46591L0.126872 6.48924L0.100217 6.50924L0.0668982 6.55257C0.0601675 6.56066 0.0545634 6.56963 0.0502387 6.57923C0.0380513 6.59638 0.0290245 6.61556 0.0235836 6.63589C0.0184291 6.63931 0.0140071 6.64373 0.010575 6.64888C0.00714283 6.65403 0.00476923 6.65981 0.00359233 6.66588C-0.00119744 6.69345 -0.00119744 6.72164 0.00359233 6.74921V14.6649C0.00387625 14.7198 0.0177113 14.7738 0.043868 14.822C0.0700248 14.8703 0.107693 14.9113 0.153527 14.9415ZM3.36546 9.22224L4.33504 9.88882V12.7418L3.33548 12.1452L3.36546 9.22224ZM0.669969 7.3758L2.70242 8.76896L2.6691 12.3319C2.66853 12.3903 2.68331 12.4478 2.71196 12.4987C2.74062 12.5496 2.78214 12.592 2.83236 12.6218L4.4983 13.6217C4.55006 13.6511 4.60874 13.666 4.66823 13.665C4.72547 13.6649 4.7817 13.6499 4.83149 13.6217C4.88296 13.5928 4.92582 13.5507 4.95567 13.4997C4.98553 13.4488 5.00132 13.3908 5.00142 13.3317V10.3321L7.66693 12.1619V19.0477L0.669969 14.4816V7.3758ZM8.33331 19.041V12.1685L11.2354 10.0888L14.9971 7.38913V14.4849L8.33331 19.041ZM14.7505 6.74587L8.00012 11.5919L5.208 9.66552L8.87307 6.91919C8.90551 6.89623 8.93275 6.86671 8.95304 6.83253L10.7722 3.99955L14.7505 6.74587ZM12.5348 2.4764C12.3616 2.4764 12.1683 2.23643 12.1683 1.91647C12.1683 1.59651 12.3349 1.3832 12.5348 1.3832H12.5948C12.6179 1.39116 12.6402 1.4012 12.6614 1.4132C12.6823 1.42345 12.7014 1.43695 12.7181 1.45319C12.7322 1.46568 12.7456 1.47903 12.758 1.49319C12.787 1.52782 12.8116 1.56588 12.8313 1.60651V1.6265C12.8487 1.66621 12.862 1.70751 12.8713 1.74982C12.8823 1.80244 12.8879 1.85605 12.888 1.9098C12.898 2.23643 12.7047 2.4764 12.5348 2.4764ZM10.2791 1.17989C10.3043 1.14483 10.3224 1.10521 10.3324 1.06324C10.3564 0.966302 10.4068 0.877912 10.4779 0.807894C10.5491 0.737876 10.6383 0.688973 10.7356 0.66662L11.7885 1.07657C11.6734 1.21773 11.5915 1.38286 11.5486 1.55984L8.41993 6.43591L4.62825 9.2789L3.5987 8.57565L7.19713 5.93597C7.22993 5.91106 7.25812 5.88061 7.28043 5.84599L10.2791 1.17989ZM8.07009 2.13977L8.62318 2.52306L6.75399 5.4327L3.00229 8.1757L0.93652 6.74921L8.07009 2.13977Z"
          fill={props.color}
        />
        <path
          d="M11.82 11.0326C11.767 11.0072 11.7083 10.9964 11.6497 11.0011C11.5912 11.0057 11.535 11.0258 11.4867 11.0593L9.15333 12.7274C9.10778 12.7566 9.07002 12.7965 9.04331 12.8436C9.0166 12.8906 9.00173 12.9435 9 12.9976V15.333C8.99987 15.3943 9.0166 15.4544 9.04835 15.5068C9.0801 15.5591 9.12565 15.6018 9.18 15.6299C9.22774 15.6535 9.28013 15.666 9.33333 15.6666C9.40303 15.6676 9.47106 15.6453 9.52667 15.6032L11.86 13.9351C11.9031 13.9044 11.9382 13.8639 11.9626 13.8169C11.9869 13.7699 11.9998 13.7178 12 13.6649V11.3295C12.0001 11.2682 11.9834 11.2081 11.9516 11.1558C11.9199 11.1034 11.8743 11.0608 11.82 11.0326ZM11.3333 13.4947L9.66667 14.6858V13.1678L11.3333 11.9767V13.4947Z"
          fill={props.color}
        />
        <path
          d="M5.03614 14.7782L4.66797 15.334L6.61283 16.6232L6.98101 16.0674L5.03614 14.7782Z"
          fill={props.color}
        />
        <path
          d="M5.03614 16.1122L4.66797 16.668L6.61283 17.9571L6.98101 17.4014L5.03614 16.1122Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};

export const PackingWhatsappIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4288_8427)">
          <path
            d="M6.19803 22.6762L6.62948 22.8913C8.42743 23.9667 10.4409 24.4685 12.4546 24.4685C18.7829 24.4685 23.9607 19.3068 23.9607 12.9979C23.9607 9.98694 22.7381 7.04758 20.5808 4.89681C18.4234 2.74605 15.5467 1.52734 12.4546 1.52734C6.12618 1.52734 0.948313 6.6891 1.02027 13.0697C1.02027 15.2203 1.66749 17.2995 2.74616 19.0917L3.03379 19.5219L1.88327 23.7517L6.19803 22.6762Z"
            fill="#00E676"
          />
          <path
            d="M22.2452 3.79459C19.8365 1.33518 16.5068 0 13.1062 0C5.88017 0 0.0708895 5.83241 0.141677 12.9297C0.141677 15.1784 0.779277 17.3568 1.84201 19.3243L0 26L6.87192 24.2432C8.78471 25.2974 10.91 25.7893 13.0354 25.7893C20.1907 25.7893 26 19.9567 26 12.8596C26 9.41626 24.6539 6.18378 22.2453 3.79459H22.2452ZM13.1062 23.6109C11.1934 23.6109 9.28064 23.1191 7.65119 22.1353L7.22616 21.9245L3.11721 22.9785L4.17984 18.9731L3.89649 18.5515C0.779277 13.5623 2.26704 6.95674 7.36784 3.8648C12.4686 0.772961 19.0572 2.24867 22.1744 7.30812C25.2915 12.3676 23.8037 18.9027 18.7031 21.9947C17.0735 23.0487 15.0899 23.6108 13.1062 23.6108V23.6109ZM19.3405 15.811L18.5613 15.4596C18.5613 15.4596 17.4279 14.9677 16.7194 14.6163C16.6485 14.6163 16.5777 14.546 16.5068 14.546C16.2942 14.546 16.1526 14.6163 16.0109 14.6867C16.0109 14.6867 15.9401 14.7569 14.9482 15.8812C14.8774 16.0217 14.7357 16.092 14.594 16.092H14.5231C14.4523 16.092 14.3106 16.0217 14.2398 15.9515L13.8855 15.811C13.1062 15.4596 12.3978 15.0379 11.831 14.4758C11.6894 14.3353 11.4768 14.1947 11.3351 14.0542C10.8392 13.5623 10.3433 13.0001 9.98913 12.3677L9.91824 12.2271C9.84745 12.1568 9.84745 12.0866 9.77656 11.9461C9.77656 11.8056 9.77656 11.665 9.84745 11.5947C9.84745 11.5947 10.1308 11.2433 10.3433 11.0326C10.485 10.892 10.5558 10.6812 10.6975 10.5407C10.8392 10.3298 10.9101 10.0488 10.8392 9.83794C10.7684 9.48657 9.91824 7.58928 9.70577 7.16769C9.56399 6.95685 9.42241 6.88663 9.20985 6.81632H8.43057C8.28879 6.81632 8.14722 6.88663 8.00544 6.88663L7.93455 6.95684C7.79287 7.02716 7.65119 7.16769 7.50952 7.2379C7.36784 7.37853 7.29695 7.51896 7.15527 7.65959C6.65935 8.29202 6.37599 9.06498 6.37599 9.83794C6.37599 10.4001 6.51767 10.9623 6.73024 11.4542L6.80113 11.665C7.43873 13.0001 8.28879 14.1947 9.42242 15.2488L9.70577 15.5298C9.91824 15.7407 10.1308 15.8812 10.2725 16.0919C11.7602 17.3569 13.4605 18.2704 15.3733 18.7623C15.5858 18.8325 15.8692 18.8325 16.0818 18.9028H16.7902C17.1444 18.9028 17.5694 18.7623 17.8529 18.6218C18.0654 18.4812 18.207 18.4812 18.3487 18.3407L18.4905 18.2001C18.6322 18.0596 18.7738 17.9893 18.9155 17.8488C19.0572 17.7083 19.1989 17.5677 19.2698 17.4271C19.4114 17.1461 19.4822 16.7947 19.5531 16.4434V15.9515C19.5531 15.9515 19.4822 15.8812 19.3405 15.811Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4288_8427">
            <rect width="26" height="26" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PickUpIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 480 480"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <g>
            <path
              style={{ fill: "#4E4E4F" }}
              d="M250,68.5c-50.3,0-91.2,40.9-91.2,91.2c0,5,0.4,10,1.2,14.9l0,0.1c5.3,44.6,27,81.6,51.4,110.1
			c11.2,13.1,23,24.5,34,33.9c2.7,2.3,6.5,2.3,9.2,0c11.1-9.4,23.1-20.7,34.5-33.9c24.4-28.2,46-65,50.9-109.2
			c0.2-1.4,0.3-2.8,0.4-4l0-0.1c0.5-3.9,0.8-7.9,0.8-11.8C341.2,109.4,300.3,68.5,250,68.5z M250,228.4c-38.2,0-69.3-31.1-69.3-69.2
			c0-38.2,31.1-69.2,69.3-69.2c38.2,0,69.2,31.1,69.2,69.2C319.2,197.3,288.2,228.4,250,228.4z"
            />
          </g>
          <g>
            <g>
              <path
                style={{ fill: "#4D4E4E" }}
                d="M250,155.1c-0.3,0-0.5-0.1-0.8-0.2l-42.8-18.2c-0.8-0.3-1.3-1.1-1.3-1.9c0-0.8,0.5-1.6,1.3-1.9l42.7-17.3
				c0.5-0.2,1.1-0.2,1.6,0l42.8,18.5c0.8,0.3,1.3,1.1,1.2,1.9c0,0.8-0.5,1.6-1.3,1.9l-42.8,17C250.5,155,250.3,155.1,250,155.1z
				 M212.6,134.9l37.4,15.9l37.4-14.8l-37.5-16.2L212.6,134.9z"
              />
            </g>
            <g>
              <path
                style={{ fill: "#4D4E4E" }}
                d="M250,202.7c-0.4,0-0.8-0.1-1.1-0.3c-0.6-0.4-0.9-1-0.9-1.7V153c0-0.8,0.5-1.6,1.3-1.9l42.8-17
				c0.6-0.3,1.3-0.2,1.9,0.2c0.6,0.4,0.9,1,0.9,1.7v46.7c0,0.8-0.5,1.6-1.3,1.9l-42.8,17.9C250.5,202.6,250.3,202.7,250,202.7z
				 M252.1,154.4v43.1l38.7-16.2v-42.3L252.1,154.4z"
              />
            </g>
            <g>
              <g>
                <polygon
                  style={{ fill: "#4D4E4E" }}
                  points="250,153 207.2,134.8 207.2,183.2 250,200.6 				"
                />
              </g>
              <g>
                <path
                  style={{ fill: "#4D4E4E" }}
                  d="M250,202.7c-0.3,0-0.5-0.1-0.8-0.2l-42.8-17.5c-0.8-0.3-1.3-1.1-1.3-1.9v-48.3c0-0.7,0.3-1.3,0.9-1.7
					c0.6-0.4,1.3-0.4,1.9-0.2l42.8,18.2c0.8,0.3,1.3,1.1,1.3,1.9v47.6c0,0.7-0.3,1.3-0.9,1.7C250.8,202.6,250.4,202.7,250,202.7z
					 M209.3,181.8l38.7,15.8v-43.2L209.3,138V181.8z"
                />
              </g>
            </g>
            <g>
              <polygon
                style={{ fill: "#4D4E4E" }}
                points="235.2,123.5 276.9,140.7 276.9,164.7 266.9,168.4 266.9,146.6 223.2,128.4 			"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="125.8,431.5 483.9,431.5 456.3,386.4 140.5,386.4 			"
              />
            </g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="16.1,431.5 94.9,431.5 113.2,386.4 43.7,386.4 			"
              />
            </g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="54,369.7 138.9,369.7 172.4,284.8 106,284.8 			"
              />
            </g>
            <g>
              <path
                style={{ fill: "#4E4E4F" }}
                d="M332.8,369.7H153.1l28.9-84.9h20.8c12.5,15.3,25.9,28.3,38.3,38.9c2.6,2.2,5.7,3.3,8.9,3.3
				c3.1, 0, 6.3-1.1, 8.8-3.2c12.6-10.6, 26.2-23.6, 38.9-38.9h16.4L332.8, 369.7z"
              />
            </g>
            <g>
              <polygon
                style={{ fill: "#4E4E4F" }}
                points="347.1,369.7 446,369.7 394,284.8 323,284.8 			"
              />
            </g>
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const CourierAirIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 480 480"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <path
            className="st0"
            d="M172.5,239.5l-48,22.8v-59.9l48.3,33.6C174,236.9,173.9,238.8,172.5,239.5z"
          />
          <path
            className="st0"
            d="M341.6,76.8v59.8c0,2.2-1.3,4.2-3.4,5c-2,0.8-4.3,0.3-5.8-1.3l-14.4-15l-16.7,17.4c-1,1-2.4,1.6-3.8,1.6
		c-1.4,0-2.8-0.6-3.8-1.6L277,125.3l-14.4,15c-1.5,1.6-3.8,2.1-5.8,1.3c-2-0.8-3.3-2.8-3.3-5V76.8H124.4v106l13.9-5.3
		c1.7-0.7,3.6-0.7,5.3-0.1l92,31.5c2.7,0.9,5.6,0.8,8.2-0.3l68.4-28.3c13.2-5.4,27.5-7.5,41.7-6l33.6,3.5c11.7,1.2,14.6,17,4.1,22.3
		l-95.1,48c-1.9,1-3.4,2.5-4.3,4.5l-60.9,132.7c-1.6,3.5-4.6,6.2-8.3,7.5l-20.9,7.1c-1.9,0.6-3.9-1-3.5-3L218.5,285
		c0.4-2.2-1.7-4-3.8-3.2L124.4,314v109.1H473V76.8H341.6z M361.3,387.7h-10.7v-53.9h10.7V387.7z M378.3,387.7h-10.7v-53.9h10.7
		V387.7z M395.3,387.7h-10.7v-53.9h10.7V387.7z M412.3,387.7h-10.7v-53.9h10.7V387.7z M429.3,387.7h-10.7v-53.9h10.7V387.7z
		 M277,115.4c1.8,0,3.5,0.7,4.7,2l15.8,16.5l15.8-16.5c1.2-1.3,2.9-2,4.7-2c0,0,0,0,0,0c1.8,0,3.5,0.7,4.7,2l10,10.4v-51h-70.3v51
		l9.9-10.4C273.5,116.2,275.3,115.4,277,115.4z"
          />
          <g>
            <path
              className="st0"
              d="M345,173.9c3,0,6,0.2,8.9,0.5l33.6,3.5c11.7,1.2,14.6,17,4.1,22.3l-95.1,48c-1.9,1-3.4,2.5-4.3,4.5
			l-60.9,132.7c-1.6,3.5-4.6,6.2-8.3,7.5l-20.9,7.1c-0.3,0.1-0.6,0.1-0.9,0.1c-1.6,0-2.9-1.5-2.6-3.2L218.5,285
			c0.3-1.8-1.1-3.4-2.8-3.4c-0.3,0-0.6,0.1-1,0.2l-104.8,37.5c-2.2,0.8-4.4,1.1-6.6,1.1c-4.9,0-9.7-1.8-13.4-5.3l-61.2-57.6
			c-3-2.8-2-7.8,1.9-9.2l16.4-6c1.8-0.7,3.7-1,5.6-1c3.5,0,7,1.1,9.9,3.3L97.6,271c1.2,0.9,2.6,1.4,4,1.4c1,0,2-0.2,2.9-0.6
			l67.9-32.2c1.4-0.7,1.6-2.6,0.3-3.5l-63.9-44.5c-1-0.7-0.8-2.3,0.3-2.8l29.2-11.2c0.9-0.3,1.8-0.5,2.8-0.5c0.9,0,1.7,0.1,2.5,0.4
			l92,31.5c1.2,0.4,2.5,0.6,3.7,0.6c1.5,0,3-0.3,4.4-0.9l68.4-28.2C322.7,176.1,333.8,173.9,345,173.9 M345,168.9
			c-12,0-23.6,2.3-34.7,6.9L242,204c-0.8,0.3-1.6,0.5-2.5,0.5c-0.7,0-1.4-0.1-2.1-0.4l-92-31.5c-1.3-0.5-2.7-0.7-4.1-0.7
			c-1.6,0-3.1,0.3-4.6,0.9l-29.2,11.2c-2.3,0.9-3.9,2.9-4.2,5.3c-0.3,2.4,0.8,4.8,2.8,6.2l59.7,41.6l-63.3,30
			c-0.2,0.1-0.5,0.2-0.7,0.2c-0.3,0-0.6-0.1-1-0.3l-35.1-26.5c-3.7-2.8-8.3-4.3-12.9-4.3c-2.5,0-5,0.4-7.4,1.3l-16.4,6
			c-3.5,1.3-6,4.2-6.7,7.8c-0.7,3.6,0.4,7.3,3.1,9.8l61.2,57.6c4.6,4.3,10.6,6.7,16.8,6.7c2.8,0,5.6-0.5,8.3-1.4l101.3-36.3
			L193.6,396c-0.4,2.2,0.2,4.5,1.7,6.3c1.5,1.8,3.6,2.8,5.9,2.8c0.8,0,1.7-0.1,2.5-0.4l20.9-7.1c5-1.7,9-5.4,11.2-10.1l60.9-132.7
			c0.4-0.9,1.1-1.6,2-2.1l95.1-48c6.8-3.4,10.4-10.5,9-18.1c-1.4-7.5-7.2-12.9-14.8-13.7l-33.6-3.5
			C351.3,169.1,348.2,168.9,345,168.9L345,168.9z"
            />
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const CurrierSurfaceIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <g>
            <path
              className="st0"
              d="M58.5,301.6c-3.8,9.3-5.5,17.9-4.4,27c0.3,2.4-1.1,2.9-3,2.7c-8.5-0.9-16.3-4-24.4-6.2
			c-1.3-0.4-1.4-1.6-1.5-2.9c-0.2-6-0.4-11.9-0.7-17.9c-0.1-2,0.5-2.7,2.4-2.7C37.2,301.6,47.5,301.6,58.5,301.6z"
            />
            <path
              className="st0"
              d="M364.1,344.5c0,3.9-1.6,4.2-4.7,4.2c-10.3-0.1-20.6,0-30.9,0c-9.8,0-19.6,0.1-29.4-0.1c-1.6,0-5,1.5-4.6-1.4
			c0.4-2.5,0.8-6.7,5.1-6.8c3-0.1,6,0,9,0c17,0,33.9,0.1,50.9-0.1C362.7,340.2,364.1,340.8,364.1,344.5z"
            />
            <path
              className="st0"
              d="M411.3,283.9c-21.5,0-39.4,17.6-39.6,39.5c-0.2,22.9,21.1,41.3,39.5,39.2c22.2,0,39.7-17.3,39.5-39.3
			C450.6,301.8,432.8,283.9,411.3,283.9z M410.5,345.3c-12.1-0.4-21.2-10.3-20.8-22.6c0.3-11.8,10.2-21.4,21.9-21.1
			c11.7,0.3,21.6,10.6,21.4,22.4C432.7,335.6,422,345.7,410.5,345.3z"
            />
            <path
              className="st0"
              d="M468.7,281.6c-3.1-0.8-5.1-2.1-5.7-5.7c-1.3-7.4-1.5-7.4-8.8-7.4c-10.1,0-10.1,0-10.1-10.2
			c0-8.5,0-8.5,8.4-9.5c1-0.1,2.5,0.3,2.4-1.6c-0.1-2.8-5.1-9.6-8-10.7c-6.4-2.3-12.8-4.7-19.2-6.8c-2.4-0.8-4-2-5.4-4
			c-11.9-17-24-33.9-35.9-50.8c-1.7-2.5-3.6-4.1-6.8-4.4c-25.7-2.4-53.5-3.5-79.3-4.1c-4-0.1-5.4,0.6-5.4,5c0,10.1,0,20.3-0.3,30.4
			c-1,31.3-0.2,62.8-1.4,94.3c-0.2,4.5-1.5,5.5-5.7,5.4c-43.8-0.2-89.6-0.1-133.4-0.1h-5.9c5.4,16.3,6,28.2-0.4,44h5.9
			c40.6,0,81.3-0.2,121.9,0.2c7.1,0.1,11.1-1.6,12.6-8.6c1-4.8,4.1-6.1,9.1-6c20.2,0.3,40.3,0.1,60.5,0.2c3.5,0,4.6-0.8,4.1-4.5
			c-0.7-5.3-0.2-10.6,1.3-15.8c5.2-17.4,16-29.9,33.7-35c19.3-5.5,36.6-1.2,50.6,13.6c9.1,9.6,13.5,21.1,13.4,34.8
			c2.2-1.1,3.8-2.3,5.7-2.8c6.2-1.6,7.2-6.3,7.5-11.7c0.3-6.3,0.6-12.6,1.3-18.9C475.9,283.6,476.1,283.6,468.7,281.6z M339,245
			c-2.3,1.9-5.3,1.9-8,2.3c-4.4,0.6-8.9,0.7-13.3,1.1c-2.8,0.3-4.3-0.7-3.5-3.5c0.6-2.4-1.8-6.6,3.6-6.5c3.3,0.1,6.6,0,9.9,0v0.3
			c3.3,0.2,6.6,0.4,9.9,0.8c1.2,0.1,2.9-0.6,3.4,1.2C341.3,242.5,340.3,243.9,339,245z M404.6,237.2c-9.3,0-18.4-0.1-27.6,0
			c-3.1,0-3.9-2.4-5-4.2c-1.6-2.9-3.6-3.8-6.8-3.9c-15.3-0.4-30.6-1-45.9-1.3c-3.3-0.1-4.6-0.8-4.5-4.4c0.5-12.8,0.7-25.6,0.9-38.4
			c0-2.4,0.5-3.6,3.3-3.5c16.8,0.4,33.6,0.5,50.3,2.2c1.4,0.1,2.6,0.2,3.4,1.5c11,17,22.2,33.8,31.8,51.6
			C404.8,236.8,404.6,237,404.6,237.2z"
            />
            <path
              className="st0"
              d="M468.7,281.6c-3.1-0.8-5.1-2.1-5.7-5.7c-1.3-7.4-1.5-7.4-8.8-7.4c-10.1,0-10.1,0-10.1-10.2
			c0-8.5,0-8.5,8.4-9.5c1-0.1,2.5,0.3,2.4-1.6c-0.1-2.8-5.1-9.6-8-10.7c-6.4-2.3-12.8-4.7-19.2-6.8c-2.4-0.8-4-2-5.4-4
			c-11.9-17-24-33.9-35.9-50.8c-1.7-2.5-3.6-4.1-6.8-4.4c-25.7-2.4-53.5-3.5-79.3-4.1c-4-0.1-5.4,0.6-5.4,5c0,10.1,0,20.3-0.3,30.4
			c-1,31.3-0.2,62.8-1.4,94.3c-0.2,4.5-1.5,5.5-5.7,5.4c-43.8-0.2-89.6-0.1-133.4-0.1h-5.9c5.4,16.3,6,28.2-0.4,44h5.9
			c40.6,0,81.3-0.2,121.9,0.2c7.1,0.1,11.1-1.6,12.6-8.6c1-4.8,4.1-6.1,9.1-6c20.2,0.3,40.3,0.1,60.5,0.2c3.5,0,4.6-0.8,4.1-4.5
			c-0.7-5.3-0.2-10.6,1.3-15.8c5.2-17.4,16-29.9,33.7-35c19.3-5.5,36.6-1.2,50.6,13.6c9.1,9.6,13.5,21.1,13.4,34.8
			c2.2-1.1,3.8-2.3,5.7-2.8c6.2-1.6,7.2-6.3,7.5-11.7c0.3-6.3,0.6-12.6,1.3-18.9C475.9,283.6,476.1,283.6,468.7,281.6z M339,245
			c-2.3,1.9-5.3,1.9-8,2.3c-4.4,0.6-8.9,0.7-13.3,1.1c-2.8,0.3-4.3-0.7-3.5-3.5c0.6-2.4-1.8-6.6,3.6-6.5c3.3,0.1,6.6,0,9.9,0v0.3
			c3.3,0.2,6.6,0.4,9.9,0.8c1.2,0.1,2.9-0.6,3.4,1.2C341.3,242.5,340.3,243.9,339,245z M404.6,237.2c-9.3,0-18.4-0.1-27.6,0
			c-3.1,0-3.9-2.4-5-4.2c-1.6-2.9-3.6-3.8-6.8-3.9c-15.3-0.4-30.6-1-45.9-1.3c-3.3-0.1-4.6-0.8-4.5-4.4c0.5-12.8,0.7-25.6,0.9-38.4
			c0-2.4,0.5-3.6,3.3-3.5c16.8,0.4,33.6,0.5,50.3,2.2c1.4,0.1,2.6,0.2,3.4,1.5c11,17,22.2,33.8,31.8,51.6
			C404.8,236.8,404.6,237,404.6,237.2z"
            />
            <path
              className="st0"
              d="M411.3,283.9c-21.5,0-39.4,17.6-39.6,39.5c-0.2,22.9,21.1,41.3,39.5,39.2c22.2,0,39.7-17.3,39.5-39.3
			C450.6,301.8,432.8,283.9,411.3,283.9z M410.5,345.3c-12.1-0.4-21.2-10.3-20.8-22.6c0.3-11.8,10.2-21.4,21.9-21.1
			c11.7,0.3,21.6,10.6,21.4,22.4C432.7,335.6,422,345.7,410.5,345.3z"
            />
            <path
              className="st0"
              d="M54,328.6c0.3,2.4-1.1,2.9-3,2.7c-8.5-0.9-16.3-4-24.4-6.2c-1.3-0.4-1.4-1.6-1.5-2.9
			c-0.2-6-0.4-11.9-0.7-17.9c-0.1-2,0.5-2.7,2.4-2.7c10.3,0,20.6,0,31.6,0C54.7,310.8,52.9,319.5,54,328.6z"
            />
            <path
              className="st0"
              d="M364.1,344.5c0,3.9-1.6,4.2-4.7,4.2c-10.3-0.1-20.6,0-30.9,0c-9.8,0-19.6,0.1-29.4-0.1c-1.6,0-5,1.5-4.6-1.4
			c0.4-2.5,0.8-6.7,5.1-6.8c3-0.1,6,0,9,0c17,0,33.9,0.1,50.9-0.1C362.7,340.2,364.1,340.8,364.1,344.5z"
            />
          </g>
          <path
            className="st0"
            d="M124.8,290.9c-0.4-0.3-0.8-0.5-1.2-0.8c-0.4-0.2-0.7-0.5-1.1-0.7c-0.4-0.3-0.9-0.5-1.4-0.8
		c-0.4-0.2-0.8-0.4-1.3-0.7c-0.3-0.2-0.6-0.3-0.9-0.4c-0.2-0.1-0.5-0.2-0.7-0.3c-0.8-0.4-1.7-0.7-2.5-1c-0.4-0.1-0.8-0.3-1.2-0.4
		c-0.5-0.2-1-0.3-1.6-0.5c-0.4-0.1-0.8-0.2-1.3-0.3c-0.5-0.1-1.1-0.2-1.6-0.3c-0.3,0-0.5-0.1-0.8-0.1c-0.2,0-0.3,0-0.5-0.1
		c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.8-0.1-1.2-0.2c-0.4,0-0.9-0.1-1.3-0.1c-0.1,0-0.2,0-0.3,0c-0.4,0-0.9,0-1.3-0.1h0c-0.5,0-1,0-1.5,0
		c-0.5,0-1,0-1.5,0h0c-0.5,0-0.9,0-1.3,0.1c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8,0.1-1.2,0.1c-0.6,0.1-1.2,0.1-1.8,0.2
		c-0.4,0.1-0.8,0.1-1.2,0.2c-0.3,0.1-0.6,0.1-0.9,0.2c-0.4,0.1-0.9,0.2-1.3,0.3c-2,0.5-4,1.2-5.8,2c-0.2,0.1-0.5,0.2-0.7,0.3
		c-1,0.5-2,1-3,1.5c-0.3,0.2-0.6,0.3-0.9,0.5c-0.3,0.2-0.6,0.3-0.8,0.5c-0.4,0.2-0.8,0.5-1.2,0.8C70,298,63.2,310,63,323.7
		c-0.3,20.7,18.7,40.9,39.3,38.8c21,2.4,40.2-18.4,39.8-38.8C141.9,310,135.2,298,124.8,290.9z M102.9,345.5
		C91,345.7,81,335.6,81,323.7c0-11.9,10.1-22,21.8-21.9c11.7,0.1,21.4,10.1,21.5,21.8C124.3,335.4,114.5,345.4,102.9,345.5z"
          />
          <polygon
            className="st0"
            points="181.8,195.5 163.2,202.9 163.2,202.9 112.6,181.4 130.6,174.1 	"
          />
          <polygon
            className="st0"
            points="198.6,188.8 146.8,167.6 163,161 213.6,182.9 	"
          />
          <polygon
            className="st0"
            points="199.5,194.4 218.1,187.1 218.1,244.2 165.9,266 165.9,207.8 185.9,199.8 185.9,226.6 199.5,221.7 	"
          />
          <path
            className="st0"
            d="M272.3,137.3h-227c-6.2,0-11.2,5-11.2,11.2v131.2c0,6.2,5,11.2,11.2,11.2h20.2c0.7-0.8,1.4-1.5,2.1-2.3
		c9.3-9.4,21.7-14.5,35-14.5c14.9,0,28.1,6.4,37.1,16.8h137.9c3.2,0,5.8-2.6,5.8-5.8V148.5C283.5,142.3,278.5,137.3,272.3,137.3z
		 M223.7,246.1c0,1.1-0.7,2.1-1.7,2.6l-57.8,24.2c-0.1,0-0.2,0.1-0.3,0.1h0c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.4,0s-0.3,0-0.4,0
		c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.2-0.1l-57.6-23.5c-1-0.4-1.7-1.4-1.7-2.6v-65.3c0-0.1,0-0.2,0-0.4
		c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.3
		c0.2-0.3,0.5-0.5,0.7-0.7c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0l57.7-23.3c0.7-0.3,1.5-0.3,2.1,0
		l57.9,25c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.2,0.2
		c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0.1,0.2
		c0,0.2,0,0.3,0,0.5V246.1z"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const TransportIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <rect
            x="5.7"
            y="171.7"
            className="st0"
            width="366.7"
            height="103.4"
          />
          <rect
            x="377.8"
            y="205.7"
            className="st0"
            width="14.5"
            height="69.4"
          />
          <rect
            x="377.8"
            y="282.2"
            className="st0"
            width="14.5"
            height="24.5"
          />
          <path
            className="st0"
            d="M254.8,282.2h30.5c-7.4,5-12.2,13.3-12.2,22.9c0,0.5,0,1.1,0,1.6h-18.3V282.2z"
          />
          <path
            className="st0"
            d="M372.4,282.2v24.5h-44.3c0-0.5,0-1.1,0-1.6c0-9.5-4.8-17.9-12.2-22.9H372.4z"
          />
          <path
            className="st0"
            d="M5.7,282.2h26c-7.4,5-12.2,13.3-12.2,22.9c0,0.5,0,1.1,0,1.6H5.7V282.2z"
          />
          <path
            className="st0"
            d="M88.4,282.2v24.5H74.5c0-0.5,0.1-1.1,0.1-1.6c0-9.5-4.9-17.9-12.2-22.9H88.4z"
          />
          <path
            className="st0"
            d="M488.8,289.2v-29.5c0-1-0.2-2-0.6-2.9L460,196c-1.6-3.5-5.1-5.7-9-5.7h-53.7v116.5h3.8c0-0.5,0-1.1,0-1.6
		c0-15.2,12.4-27.6,27.5-27.6s27.5,12.4,27.5,27.6c0,0.5,0,1.1,0,1.6h38.2v-17.5H488.8z M440.8,233.2h-30.5v-36.5H449
		c2.6,0,5,1.5,6.1,3.9l25.7,53.6h-18L440.8,233.2z M486.3,283.9c0,1.2-1,2.3-2.2,2.3h-6.4c-1.2,0-2.3-1-2.3-2.3v-16.1
		c0-1.2,1-2.2,2.3-2.2h6.4c1.2,0,2.2,1,2.2,2.2V283.9z"
          />
          <g>
            <path
              className="st0"
              d="M429.4,328.3c-12.4,0-22.5-10.1-22.5-22.5s10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5S441.8,328.3,429.4,328.3z
			 M429.4,294.2c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5S435.7,294.2,429.4,294.2z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M299.8,328.3c-12.4,0-22.5-10.1-22.5-22.5s10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5S312.2,328.3,299.8,328.3z
			 M299.8,294.2c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5S306.2,294.2,299.8,294.2z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M47.1,328.3c-12.4,0-22.5-10.1-22.5-22.5s10.1-22.5,22.5-22.5s22.5,10.1,22.5,22.5S59.5,328.3,47.1,328.3z
			 M47.1,294.2c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5S53.4,294.2,47.1,294.2z"
            />
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const RapidoIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <path
            className="st0"
            d="M69.9,138.3l-0.6,17.9l3.8-3.7c0.5-0.5,1.1-0.7,1.8-0.7c0.6,0,1.3,0.3,1.7,0.8l5.6,6.3l6-5.9
		c0.5-0.5,1.1-0.7,1.8-0.7c0,0,0,0,0,0c0.6,0,1.3,0.3,1.7,0.8l3.5,3.9l0.6-17.9C87.1,138.9,78.5,138.6,69.9,138.3z M411.3,328
		c2.2-4.9,5.1-7.9,10.9-7.6c15.6,0.9,29.5,6,41.6,16c4,3.3,8.8,3.2,11.6,0c2.9-3.4,2.6-8.1-1.3-11.6c-11.9-10.5-25.9-17.3-41.6-18.8
		c-9.4-0.9-14.4-2.6-17.4-13.1c-6.2-21.6-18.4-40.5-32.1-58.2c-1.1-1.4-3.4-3.1-4.8-2.8c-9.1,1.9-18.1,4.3-27.1,6.5
		c-2.9,0.7-3.8,2.6-3.5,5.6c1.2,12.4,2.3,24.9,3.1,37.4c0.2,3-0.4,6.3-1.5,9.1c-3.2,8-6.7,15.9-10.2,23.8
		c-6.8,15.5-13.6,31-20.6,46.5c-0.7,1.5-2.8,3.4-4.1,3.4c-8.5-0.5-16.9-1.4-25.3-2.3c-0.7-0.1-1.3-0.7-1.8-1
		c2.2-4.4,5.2-8.2,6.2-12.6c4.1-18.5,7.9-37.1,11.4-55.8c1.6-8.8,2.8-17.7,3.3-26.6c0.4-6.6-5.9-13.2-12.4-14.4
		c-5.4-1-10.8-1.8-16.2-2.9c-10.6-2.2-21.1-4.5-31.7-6.8c-2.8-0.6-4.4-2.2-3.6-5.4c1.9-7.9,3.7-15.8,5.5-23.8c1.3-5.8,2.4-6.3,7-2.9
		c5.7,4.2,11.7,6.4,19,6.1c10.6-0.5,21.3-0.2,32,0c1.6,0,4.2,1.5,4.6,2.9c1.7,6.2,4.8,8,10.9,5.3c3.5-1.5,6.9-3.2,10.4-4.8
		c6.5-3,6.7-2.9,9.3,3.5c0.9,2.1,1.7,4.3,2.4,6.6c0.9,3.1,2.7,4.2,6,3.4c11.7-3.1,23.5-6,35.2-9.1c1.5-0.4,2.9-1.1,5.4-2.1
		c-12.1-9.5-15.8-22.2-17.3-36.8c-6.2,3.6-11.3,6.7-17.3,10.2c-2.6-6.9-5.1-13.1-7.2-19.5c-0.8-2.3-0.9-5.1-0.5-7.6
		c1.1-6.3,0.7-12.3-2.9-17.7c-3.4-5.1-9.6-5.3-13.3-0.4c-5,6.7-5.1,19.1,0.5,25.2c1.6,1.8,5.1,3.3,7.2,2.8c4.4-1.1,6.2-0.1,7,4.2
		c0.3,1.6,1.2,3.1,1.9,4.6c1.9,4.6,1.2,5.5-3.6,5.5c-22.7-0.1-45.3-0.1-68-0.2c-9.9-0.1-15.8-7.4-22.8-12.8
		c-0.6-0.5-0.4-1.9-0.8-2.8c-2-5.5-3.4-11.2-6-16.3c-8.1-15.4-27.5-22.5-43.8-16.6c-16.6,6-25.5,18.6-29.5,35.1
		c-5.2,21.6-10.2,43.4-14.7,65.2c-1.1,5.3-6.2,12.1,4,15.7c-1.9,0.7-2.6,1.3-3.3,1.3c-5.8-0.3-11.7-0.3-17.4-1.2
		c-0.2,0-0.4-0.1-0.6-0.3c-1.4-0.9-2.8-3.5-2.9-5.1c0-10,0.5-20,0.9-30c0.9-26,1.8-52,2.9-77.9c0.1-3.5-0.8-5-4.6-5.2
		c-13.6-0.4-27.1-0.9-40.7-1.4l-0.7,21.1c0,0.8-0.5,1.5-1.3,1.8c-0.8,0.3-1.6,0.1-2.1-0.5l-5.1-5.7l-6.4,6.2
		c-0.4,0.4-0.9,0.6-1.4,0.5c-0.5,0-1-0.2-1.4-0.7l-5.9-6.6l-5.5,5.4c-0.6,0.6-1.4,0.7-2.1,0.4c-0.7-0.3-1.2-1.1-1.2-1.9l0.7-21.2
		c-12.1-0.4-24.2-0.9-36.3-1.4c-3.8-0.2-5,1-5.2,4.6c-0.4,10.3-1.2,20.6-1.5,30.9c0,0.1,0,0.3,0,0.4c-0.2,4.4-0.3,8.8-0.5,13.3
		c-0.2,5.1-0.4,10.2-0.5,15.4v0c-0.2,6.6-0.4,13.1-0.7,19.7c-0.3,9.9-0.7,19.8-1,29.6c-0.2,4.1,1.3,5.7,5.5,5.7
		c11.5,0.1,23,0.5,34.5,0.8c1.4,0,2.8,0.4,4.2,0.6c0.2,0.5,0.4,0.9,0.5,1.4c-2.1,1.7-4,3.5-5.8,5.4c-7.2,7.8-11.7,17.3-14.8,27.5
		c-2.8,9.4-5,18.9-6.7,28.6c-1,5.2,1.5,9.9,6.8,11.5c6.8,2.2,13.8,3.4,20.7,5c1.4,0.3,2.6,1,3.9,1.5c-0.7,1.2-1.2,2.6-2.1,3.7
		c-10.5,12.9-17,27.4-18,44c-0.3,5,2.6,8.3,7,8.6c4.2,0.3,7.1-2.2,7.9-7.1c2.2-12.8,5.9-24.9,14.5-35c3-3.5,6.4-6.5,9.6-9.8
		c0.5,0.4,0.9,0.8,1.4,1.1c-12.5,14.4-20.2,30.5-17.7,50.1c2.5,19.7,12.6,34.5,29.5,44.5c13.7,8.2,29,10.2,43.9,5.7
		c29.1-8.6,43.6-29.5,44.6-60.2c1.3,0.9,1.9,1.1,2,1.4c2.6,10,9.6,12.4,18.9,11.2c1.3-0.2,2.7,0.2,4,0.2c44.3,1,88.6,2,132.9,3.1
		c4.2,0.1,7.5-0.3,9.5-4.5c0.6-1.2,2.3-2,4.4-3.6c2.2,18.1,9.9,32.2,23.7,42.6c14.1,10.6,30.1,13.7,47.3,10.4
		c22.6-4.3,43.4-22.3,45.7-47C483.1,350.7,457.4,329.1,411.3,328z M124.2,234l3.9,0.1l-0.7,19.8l-4-0.1L124.2,234z M118,233.8
		l3.9,0.1l-0.7,19.9l-3.9-0.1L118,233.8z M111.7,233.6l3.9,0.1l-0.7,19.8l-4-0.1L111.7,233.6z M105.5,233.4l3.9,0.1l-0.7,19.9
		l-4-0.1L105.5,233.4z M99.2,233.1l3.9,0.1l-0.7,19.8l-4-0.1L99.2,233.1z M131.6,417.9c-17,0.5-31.3-13.6-31.3-30.2
		c0-17,14.4-31.4,31.3-30.7c15.7,0.7,29.4,13.3,29.4,30.5C161.1,404.8,147.3,417.5,131.6,417.9z M271.5,286.1c0,0.1,0,0.3,0,0.4
		c0,0.1,0,0.3,0,0.4c0,0.5-0.1,1-0.2,1.5c0,0.2,0,0.3-0.1,0.5c0,0,0,0,0,0c0,0.4-0.1,0.7-0.2,1.1c0,0.3-0.1,0.5-0.1,0.8
		c-0.1,0.6-0.2,1.2-0.3,1.8c-0.1,0.7-0.3,1.5-0.4,2.2c-0.3,1.8-0.7,3.7-1.1,5.6c-0.5,2.8-1.1,5.6-1.6,8.3c-0.5,2.8-1.1,5.6-1.7,8.3
		c-0.8,3.7-1.5,7.4-2.3,11.1c-0.8,3.7-1.7,7.4-2.5,11c-1.7,6.9-0.6,12.7,3.5,18.3c-0.2,0.5-0.4,0.9-0.6,1.4
		c-2.4-0.2-4.8-0.3-7.1-0.4c-0.8-0.1-1.6-0.1-2.4-0.2c-6.6-0.6-13.3-1.1-19.8-2.1c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0-0.3-0.1-0.4-0.2
		c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3-0.1-0.5-0.3-0.8-0.5c-0.1-0.1-0.2-0.2-0.4-0.3
		c-0.1-0.1-0.2-0.2-0.3-0.2c-0.5-0.4-0.9-0.8-1.1-1.3c-0.1-0.1-0.1-0.2-0.2-0.3c-10.2-22.3-5.1-51.1,11.2-69.4
		c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.4-0.4,0.6-0.6c0,0,0.1-0.1,0.1-0.1c1-0.9,2-1.7,3.1-2.3c0.4-0.2,0.9-0.5,1.3-0.7
		c0.3-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.4-0.2,0.6-0.2c0.2-0.1,0.4-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3-0.1
		c0.2,0,0.3-0.1,0.5-0.1c0.4-0.1,0.9-0.1,1.3-0.2c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.2,0,0.5,0,0.7,0c0.3,0,0.5,0,0.8,0
		c0.5,0,0.9,0,1.4,0.1c0.2,0,0.5,0,0.7,0.1c0.7,0.1,1.5,0.2,2.3,0.3c0.3,0,0.5,0.1,0.8,0.1c2.3,0.4,4.2,0.8,5.8,1.1
		c0.5,0.1,0.9,0.2,1.3,0.3c0.5,0.1,0.9,0.2,1.3,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.9,0.3c0.5,0.2,1,0.5,1.4,0.8
		c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1
		c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2,0,0.3
		c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5C271.5,285.8,271.5,286,271.5,286.1z M451.4,388c0,0.4,0,0.8-0.1,1.3
		c0,0.2,0,0.5-0.1,0.7c-0.1,0.7-0.2,1.5-0.3,2.2c-0.1,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.2,0.7-0.2,1c0,0.1-0.1,0.2-0.1,0.4
		c0,0.1-0.1,0.2-0.1,0.4c-0.3,1-0.6,2.1-1,3c-0.1,0.3-0.2,0.6-0.3,0.8c0,0,0,0.1,0,0.1c-0.1,0.3-0.3,0.6-0.4,0.9s-0.3,0.6-0.4,0.9
		c-0.1,0.3-0.3,0.6-0.5,0.9c-0.2,0.3-0.3,0.6-0.5,0.9c-0.2,0.3-0.3,0.6-0.5,0.9c-0.3,0.4-0.5,0.8-0.8,1.2c-0.3,0.4-0.5,0.7-0.8,1.1
		c0,0,0,0-0.1,0.1c-0.2,0.3-0.5,0.6-0.8,0.9c0,0.1-0.1,0.1-0.2,0.2c-0.2,0.3-0.5,0.6-0.8,0.9c-1.2,1.3-2.5,2.5-3.9,3.6
		c-0.4,0.3-0.8,0.6-1.2,0.9c-0.3,0.2-0.6,0.4-0.9,0.6c-0.3,0.2-0.6,0.4-1,0.6c-0.3,0.2-0.7,0.4-1,0.6c-0.3,0.2-0.6,0.3-0.9,0.5
		c-0.4,0.2-0.9,0.4-1.3,0.6c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.2-0.7,0.3-1.1,0.4c0,0,0,0,0,0c-0.3,0.1-0.7,0.2-1,0.4
		c-0.2,0.1-0.5,0.2-0.8,0.2c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.7,0.2c-0.3,0.1-0.7,0.2-1,0.2c-0.4,0.1-0.9,0.2-1.3,0.2
		c-0.3,0-0.6,0.1-0.9,0.1c-0.6,0.1-1.2,0.1-1.8,0.2c-0.3,0-0.6,0-1,0c-0.3,0-0.6,0-0.9,0c-0.2,0-0.5,0-0.8,0c-0.4,0-0.8,0-1.2-0.1
		c-0.2,0-0.5,0-0.7-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.5-0.1-1-0.2-1.5-0.3c-0.4-0.1-0.7-0.2-1.1-0.2
		c-0.3-0.1-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2-0.1c-0.5-0.1-0.9-0.3-1.4-0.5c-0.4-0.1-0.8-0.3-1.1-0.4c-0.1,0-0.2-0.1-0.3-0.1
		c-0.4-0.2-0.8-0.3-1.1-0.5c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.1-0.6-0.3-0.9-0.4c-0.4-0.2-0.9-0.4-1.3-0.7c-0.4-0.2-0.7-0.4-1.1-0.6
		c-0.4-0.2-0.8-0.5-1.2-0.8c-0.4-0.3-0.8-0.6-1.2-0.8c-0.4-0.3-0.8-0.6-1.2-0.9c-0.2-0.1-0.4-0.3-0.6-0.5c-0.3-0.2-0.6-0.5-0.8-0.7
		c-0.2-0.2-0.4-0.4-0.6-0.6c-0.6-0.6-1.2-1.2-1.7-1.8c-0.3-0.3-0.6-0.7-0.9-1c-0.1-0.1-0.2-0.2-0.3-0.3c-1.1-1.3-2-2.7-2.8-4.2
		c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.2-0.5-0.4-0.7s-0.2-0.5-0.4-0.7c-0.1-0.3-0.3-0.6-0.4-1c-0.3-0.6-0.5-1.3-0.8-2
		c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.4-0.2-0.7-0.3-1c-0.1-0.3-0.1-0.6-0.2-0.9c0-0.1-0.1-0.3-0.1-0.4
		c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.7-0.1-1c-0.1-0.5-0.1-0.9-0.1-1.4c0-0.2,0-0.4,0-0.6c0-0.4,0-0.8,0-1.2
		v-0.1c0-0.3,0-0.6,0-0.9c0-0.3,0-0.7,0.1-1c0-0.3,0-0.6,0.1-0.9c0-0.1,0-0.2,0-0.3c0-0.2,0.1-0.5,0.1-0.7c0-0.3,0.1-0.6,0.2-0.9
		c0.1-0.3,0.1-0.6,0.2-0.9c0-0.1,0-0.1,0-0.2c0.1-0.5,0.2-1,0.4-1.4c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.7,0.3-1
		c0.1-0.4,0.3-0.8,0.4-1.2c0.2-0.4,0.3-0.8,0.5-1.1c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.4,0.4-0.8,0.5-1.1c0.2-0.4,0.4-0.8,0.6-1.1
		c0.1-0.2,0.3-0.5,0.4-0.7c0.3-0.5,0.6-1,0.9-1.4c0.2-0.4,0.5-0.8,0.8-1.1c0.4-0.6,0.9-1.2,1.3-1.7c0.3-0.4,0.6-0.8,1-1.1
		c0.2-0.2,0.3-0.4,0.5-0.5c0.2-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.4-0.4,0.7-0.6c0.3-0.3,0.6-0.6,0.9-0.9c0.3-0.3,0.7-0.6,1-0.9
		c0.2-0.1,0.3-0.2,0.5-0.4c0.8-0.7,1.7-1.3,2.6-1.8c0.2-0.1,0.4-0.3,0.6-0.4c0.4-0.3,0.9-0.5,1.3-0.8c0.2-0.1,0.5-0.2,0.7-0.4
		c0.2-0.1,0.3-0.2,0.5-0.2c0.2-0.1,0.4-0.2,0.7-0.3c0.4-0.2,0.7-0.3,1.1-0.5c0.3-0.1,0.6-0.2,0.9-0.4c0.5-0.2,0.9-0.3,1.4-0.5
		c0.5-0.2,0.9-0.3,1.4-0.4c0.5-0.1,1-0.2,1.4-0.3c0.2-0.1,0.5-0.1,0.7-0.1c0.2,0,0.5-0.1,0.7-0.1c0.2,0,0.4-0.1,0.6-0.1
		c0.1,0,0.1,0,0.2,0c0.2,0,0.5,0,0.8-0.1c0.2,0,0.4,0,0.7,0c0.6-0.1,1.3-0.1,1.9-0.1c1.1,0,2.1,0.1,3.1,0.2c0.5,0,1,0.1,1.5,0.2
		c0.5,0.1,1,0.2,1.5,0.3c0.5,0.1,1,0.2,1.5,0.3c0,0,0.1,0,0.1,0c0.5,0.1,0.9,0.3,1.4,0.4c0.5,0.1,0.9,0.3,1.4,0.5c0,0,0,0,0,0
		c0.4,0.1,0.8,0.3,1.1,0.4c0,0,0.1,0,0.1,0.1c0.1,0,0.3,0.1,0.4,0.2c0.4,0.2,0.8,0.3,1.1,0.5c0.5,0.2,0.9,0.4,1.3,0.7
		c0.4,0.2,0.9,0.5,1.3,0.7c0.4,0.2,0.8,0.5,1.2,0.8c0.7,0.5,1.4,1,2.1,1.6c0.2,0.1,0.4,0.3,0.6,0.5c0.2,0.2,0.4,0.3,0.6,0.5
		c0.2,0.1,0.3,0.3,0.5,0.4c0.3,0.2,0.5,0.5,0.8,0.7c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.2,0.5,0.5,0.8,0.8c0.7,0.7,1.3,1.5,1.9,2.2
		c0.2,0.3,0.5,0.6,0.7,1c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3l0,0
		c0,0,0,0,0,0.1c0.2,0.3,0.4,0.6,0.5,0.9c0.5,0.8,0.9,1.7,1.3,2.6c0.2,0.5,0.4,0.9,0.6,1.4c0.3,0.9,0.6,1.8,0.9,2.8
		c0.1,0.4,0.2,0.7,0.3,1.1c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.3,0.1,0.5l0,0c0,0,0,0,0,0c0.1,0.4,0.2,0.8,0.2,1.2
		c0.1,0.4,0.1,0.9,0.2,1.4v0c0.1,0.4,0.1,0.9,0.1,1.3c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.4,0,0.8,0,1.2
		C451.4,387.6,451.4,387.8,451.4,388z"
          />
          <path
            className="st0"
            d="M233.6,104.7c-2.5-3.6-3.6-7.5-2.9-10.8c1.7-8.5,36.5-3.8,46.8-2.2c-1.1-3.9-2.5-7.8-4.3-11.5
		c-9.6-19.6-26.2-28.2-44.5-27.1c-29.5,1.9-48.6,28.7-41.8,57.6c1.1,4.8,3.8,7.5,8.7,9.2c10,3.4,19.8,7.5,29.8,11.3
		c9.9,3.8,19.7,7.7,29.7,11.3c8,2.8,14.7,0,18.1-7.8c1.4-3.2,2.2-6.7,3.3-10.5C247.9,119.7,237.3,110.1,233.6,104.7z M253.2,105.6
		c0.2-5.6,5.3-10.2,11.6-10c3.5,0.1,7,0.7,10.5,0.5c0.7,0,2-1.3,2.5-2.3c-18.4-2.9-43.9-4.6-45,0.5c-0.6,2.8,0.3,6.1,2.6,9.3
		c3.6,5.1,13.8,14.4,41.7,18.8c0.1-0.4,0.2-0.8,0.3-1.1c-4.9-1.3-8.8-2-12.5-3.2C257.9,115.8,253,111.5,253.2,105.6z M239.8,100
		c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C243.3,98.5,241.7,100,239.8,100z"
          />
          <path
            className="st0"
            d="M244.4,279.5c-1,0.6-2.1,1.4-3.1,2.3C242.3,280.8,243.4,280,244.4,279.5z"
          />
          <path
            className="st0"
            d="M245.7,278.8c-0.4,0.2-0.9,0.4-1.3,0.7C244.8,279.2,245.3,279,245.7,278.8z"
          />
          <path
            className="st0"
            d="M254.2,358.5c0.8,0.1,1.6,0.1,2.4,0.2C255.8,358.6,255,358.5,254.2,358.5c-6.6-0.6-13.3-1-19.8-2.1
		c-0.4-0.1-0.8-0.2-1.2-0.3c0.4,0.1,0.8,0.2,1.2,0.3C241,357.4,247.6,357.9,254.2,358.5z"
          />
          <path
            className="st0"
            d="M270.1,295c0.2-0.8,0.3-1.5,0.4-2.2C270.4,293.5,270.3,294.2,270.1,295c-0.3,1.8-0.7,3.7-1.1,5.6
		C269.4,298.7,269.8,296.9,270.1,295z"
          />
          <path
            className="st0"
            d="M445.4,369.5c-0.6-0.8-1.2-1.5-1.9-2.2C444.2,368,444.8,368.7,445.4,369.5z"
          />
          <path
            className="st0"
            d="M447.7,373.1c0.5,0.8,0.9,1.7,1.3,2.6C448.6,374.9,448.2,374,447.7,373.1z"
          />
          <path
            className="st0"
            d="M450.4,379.9c-0.2-1-0.5-1.9-0.9-2.8C449.9,378,450.2,379,450.4,379.9z"
          />
          <path
            className="st0"
            d="M451,392.2c0.1-0.7,0.2-1.4,0.3-2.2C451.2,390.7,451.1,391.4,451,392.2z"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const BusIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{ enableBackground: "new 0 0 500 500", opacity: "0.3" }}
      >
        <image
          width="1000"
          height="1000"
          transform="matrix(1 0 0 1 -7192 -7192)"
        ></image>
        <g>
          <path
            className="st0"
            d="M5,300.1c0,6.3,3,9.5,9.3,9.9c23.7,1.5,47.4,3,71.1,4.5c6.9,0.4,13.9,0.8,20.8,1.4c2.2,0.2,2.8-0.5,2.8-2.7
		c-0.1-4-0.3-8,0.2-11.9c1.6-12.7,11.6-22.5,24.4-24.3c7.3-1,14.2,0.2,20.6,3.9c8.7,5.1,13.4,12.6,13.8,22.8
		c0.1,3.2,0.1,6.5,0.1,9.8c0,1.9,0.6,2.7,2.7,2.7c58.1,0,116.2,0,174.3,0c2.2,0,3-0.6,2.9-2.9c-0.1-4.4-0.4-8.9,0.3-13.2
		c2.1-12,11.6-20.9,23.7-22.9c9.4-1.5,17.9,0.7,25.3,6.8c6.2,5,9.3,11.6,9.5,19.6c0.1,3.3,0.1,6.7,0,10c0,1.9,0.7,2.7,2.7,2.7
		c17.5-0.1,35,0,52.6-0.1c4.3,0,8.2-2.4,9.1-6.3c3.5-14.2,6.2-28.7,2.8-43.1c-5-20.7-10.9-41.1-16.5-61.7c-0.2-0.6-0.3-1.2-0.6-2.3
		c1.2-0.1,2.1-0.2,2.9-0.2c5.6,0,11.2,0,16.8,0c1.1,0,2.2,0.1,3.2,0.5c4.3,1.8,7.4,4.3,6.4,9.7c-0.3,1.7-0.2,3.4,0,5.1
		c0,0.1,0.1,0.3,0.1,0.4c0.5,1.2,2,1.5,3,0.8c0.6-0.4,1-0.8,1.1-1.2c0.4-2.7,0.2-5.4,0.2-8.1c-0.2-9.1,1.3-6.5-6.4-11.3
		c-3.3-2.1-6.7-3.1-10.7-2.9c-5.7,0.2-11.4,0-17.1,0.1c-1.7,0-2.8-0.4-3.5-2c-4-10.1-14.3-16.3-25.2-16c-29.2,0.6-58.5,0.2-87.7,0.2
		c-2.4,0-4.1-0.5-5.2-2.8c-2.7-5.4-7.2-7.2-13.1-7.2c-46.5,0.1-93,0.1-139.6,0c-5.5,0-9.8,1.7-12.3,6.7c-1.3,2.6-3.2,3.3-6.1,3.3
		c-41.6-0.1-83.3-0.1-124.9-0.1c-7,0-13.9,0-20.9,0c-5.7,0-8.4,2.1-10,7.6c-2.5,9-3.2,18.3-3.2,27.6C5,241.9,5,271,5,300.1z
		 M419.6,189.1c0.1-2.8,1.5-4.4,4.1-4.4c13.8,0,19.6,3.6,25.2,14.1c3.7,6.9,6.2,14.3,7.5,22c1.7,10,2.9,20.1,4.3,30.6
		c-1.9,0.1-2.8,0.3-3.7,0.3c-10.6,0-21.1,0-31.7,0c-4.5,0-5.7-1.3-5.7-5.9c0-15.2,0-30.3,0-45.5
		C419.6,196.5,419.5,192.8,419.6,189.1z M336.7,187.8c0-2.7,0.9-3.3,3.5-3.3c22,0.1,44.1,0.1,66.1,0c2.4,0,3.3,0.6,3.3,3.2
		c-0.1,12.2-0.1,24.4,0,36.6c0,2.7-0.9,3.3-3.4,3.3c-11-0.1-22-0.1-33-0.1s-22-0.1-33,0.1c-2.7,0-3.3-0.9-3.3-3.4
		C336.8,212,336.8,199.9,336.7,187.8z M258.4,224.7c0.1-12.4,0.1-24.9,0-37.3c0-2.1,0.7-2.8,2.8-2.8c22.3,0,44.6,0,66.9-0.1
		c2.1,0,3,0.6,3,2.9c-0.1,12.4-0.1,24.7,0,37.1c0,2.4-0.7,3.1-3.1,3c-11-0.1-22-0.1-33-0.1c-11.2,0-22.4,0-33.6,0
		C259.2,227.5,258.4,227,258.4,224.7z M179.9,224.6c0.1-12.5,0.1-24.9,0-37.4c0-2.2,0.8-2.8,2.9-2.8c22.3,0,44.6,0,66.9,0
		c2.2,0,3,0.7,3,2.9c-0.1,12.4-0.1,24.7,0,37.1c0,2.5-0.9,3-3.2,3c-11.1-0.1-22.2,0-33.3,0c0,0,0,0,0,0c-11.1,0-22.2,0-33.3,0
		C180.7,227.5,179.9,226.9,179.9,224.6z M101.4,187.5c0-2.2,0.7-3,2.9-3c22.3,0.1,44.6,0.1,66.9,0c2.2,0,3,0.7,3,2.9
		c-0.1,12.4-0.1,24.7,0,37.1c0,2.5-0.9,3-3.2,2.9c-2.7,0-5.5,0-8.2,0c-5.5,0-11,0-16.6,0c-2.9,0-5.7,0-8.5,0c-0.6,0-1.2,0-1.8,0
		c-10.5,0-21,0-31.5,0c-2.2,0-3-0.5-3-2.9C101.5,212.2,101.5,199.9,101.4,187.5z M23.2,187.7c0-2.6,0.9-3.2,3.3-3.2
		c22,0.1,44.1,0.1,66.1,0c2.4,0,3.3,0.6,3.3,3.2c-0.1,12.2-0.1,24.4,0,36.6c0,2.7-0.9,3.3-3.4,3.3c-10.9-0.1-21.9,0-32.8,0v0
		c-11.1,0-22.2-0.1-33.3,0c-2.3,0-3.1-0.5-3.1-3C23.3,212.2,23.3,199.9,23.2,187.7z"
          />
          <path
            className="st0"
            d="M114.2,307.8c-0.1,13.3,10.8,24.4,24.2,24.5c13.5,0.1,24.2-10.6,24.3-24.2c0.1-13.7-10.4-24.4-24-24.4
		C125.1,283.7,114.4,294.3,114.2,307.8z M124.8,308.1c-0.1-7.5,6.2-13.8,13.8-13.8c7.5,0,13.6,6,13.6,13.5c0,7.6-6.1,13.8-13.7,13.8
		C131.1,321.6,124.9,315.5,124.8,308.1z"
          />
          <path
            className="st0"
            d="M353.1,308.2c0,13.1,10.9,24.1,24,24.1c13.9,0,24.7-10.6,24.6-24.4c0-13.5-10.8-24.2-24.3-24.1
		C363.8,283.7,353.1,294.5,353.1,308.2z M363.8,308c0-7.5,6.1-13.6,13.5-13.7c7.7,0,13.8,6,13.8,13.6c0,7.5-6.1,13.7-13.5,13.7
		C370.1,321.7,363.8,315.5,363.8,308z"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const MessageIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9601 40C13.8344 40 13.7086 40 13.5828 39.8742C13.2055 39.7484 12.954 39.3711 12.954 38.9937V30.8176H5.03068C2.2638 30.8176 0 28.5535 0 25.7862V5.03145C0 2.26415 2.2638 0 5.03068 0H35.9693C38.7362 0 41 2.26415 41 5.03145V25.6604C41 28.4277 38.7362 30.6918 35.9693 30.6918H24.5245L14.589 39.6226C14.4632 39.8742 14.2117 40 13.9601 40ZM5.03068 2.01258C3.39571 2.01258 2.01227 3.39623 2.01227 5.03145V25.6604C2.01227 27.2956 3.39571 28.6792 5.03068 28.6792H13.9601C14.4632 28.6792 14.9663 29.1824 14.9663 29.6855V36.6038L23.5184 28.9308C23.6442 28.805 23.8957 28.6792 24.1472 28.6792H35.9693C37.6043 28.6792 38.9877 27.2956 38.9877 25.6604V5.03145C38.9877 3.39623 37.6043 2.01258 35.9693 2.01258H5.03068Z"
          fill="white"
        />
        <path
          d="M30.1302 9H10.9941C10.497 9 10 8.5 10 8C10 7.5 10.497 7 10.9941 7H30.0059C30.503 7 31 7.5 31 8C31 8.5 30.6272 9 30.1302 9Z"
          fill="white"
        />
        <path
          d="M30.1302 16H10.9941C10.497 16 10 15.5 10 15C10 14.5 10.497 14 10.9941 14H30.0059C30.503 14 31 14.5 31 15C31 15.5 30.6272 16 30.1302 16Z"
          fill="white"
        />
        <path
          d="M24.0164 23H10.9836C10.4918 23 10 22.5 10 22C10 21.5 10.4918 21 10.9836 21H24.0164C24.5082 21 25 21.5 25 22C25 22.5 24.5082 23 24.0164 23Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const CopyIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"></path>
      </svg>
    </React.Fragment>
  );
};

export const WhatsappIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8514_9736)">
          <path
            d="M10.0372 34.8897L10.701 35.2206C13.4671 36.875 16.5648 37.647 19.6627 37.647C29.3986 37.647 37.3644 29.7059 37.3644 20C37.3644 15.3677 35.4835 10.8456 32.1646 7.53671C28.8454 4.22783 24.4199 2.35291 19.6627 2.35291C9.92669 2.35291 1.96075 10.2941 2.07145 20.1103C2.07145 23.419 3.06718 26.6177 4.72666 29.3749L5.16917 30.0368L3.39914 36.5442L10.0372 34.8897Z"
            fill="#00E676"
          />
          <path
            d="M34.7234 5.83783C31.0176 2.05412 25.8951 0 20.6634 0C9.54642 0 0.609061 8.97294 0.717965 19.8918C0.717965 23.3513 1.69889 26.7028 3.33386 29.7297L0.5 40L11.0722 37.2973C14.0149 38.919 17.2846 39.6758 20.5545 39.6758C31.5626 39.6758 40.5 30.7027 40.5 19.784C40.5 14.4865 38.4291 9.51351 34.7235 5.83783H34.7234ZM20.6634 36.3245C17.7207 36.3245 14.7779 35.5678 12.2711 34.0543L11.6172 33.7299L5.29571 35.3515L6.93052 29.1894L6.49459 28.5407C1.69889 20.8651 3.98776 10.7027 11.8351 5.94585C19.6825 1.18917 29.8188 3.45949 34.6145 11.2433C39.41 19.027 37.1211 29.0811 29.2739 33.838C26.7669 35.4595 23.7153 36.3243 20.6634 36.3243V36.3245ZM30.2547 24.3246L29.0558 23.784C29.0558 23.784 27.3121 23.0272 26.2221 22.4867C26.113 22.4867 26.0041 22.3785 25.8951 22.3785C25.568 22.3785 25.3501 22.4867 25.1321 22.5948C25.1321 22.5948 25.0232 22.7029 23.4973 24.4326C23.3882 24.6488 23.1703 24.757 22.9523 24.757H22.8432C22.7343 24.757 22.5164 24.6488 22.4073 24.5408L21.8623 24.3246C20.6634 23.784 19.5736 23.1353 18.7016 22.2705C18.4836 22.0543 18.1566 21.8381 17.9386 21.6219C17.1757 20.8651 16.4127 20.0002 15.8679 19.0272L15.7588 18.811C15.6499 18.7028 15.6499 18.5948 15.5409 18.3786C15.5409 18.1624 15.5409 17.9462 15.6499 17.838C15.6499 17.838 16.0859 17.2974 16.4127 16.9732C16.6308 16.7569 16.7397 16.4326 16.9577 16.2164C17.1757 15.8921 17.2847 15.4597 17.1757 15.1353C17.0668 14.5947 15.7588 11.6758 15.432 11.0272C15.2138 10.7028 14.996 10.5948 14.669 10.4866H13.4701C13.252 10.4866 13.0342 10.5948 12.8161 10.5948L12.707 10.7028C12.489 10.811 12.2711 11.0272 12.0531 11.1352C11.8351 11.3516 11.7261 11.5676 11.5081 11.784C10.7452 12.757 10.3092 13.9461 10.3092 15.1353C10.3092 16.0001 10.5272 16.865 10.8542 17.6218L10.9633 17.9462C11.9442 20.0002 13.252 21.8381 14.996 23.4596L15.432 23.892C15.7588 24.2164 16.0859 24.4326 16.3038 24.7568C18.5927 26.7029 21.2084 28.1083 24.1512 28.8651C24.4782 28.9731 24.9141 28.9731 25.2412 29.0813H26.331C26.876 29.0813 27.5299 28.8651 27.966 28.6489C28.2928 28.4327 28.5108 28.4327 28.7288 28.2165L28.9469 28.0001C29.1649 27.7839 29.3828 27.6759 29.6008 27.4597C29.8188 27.2435 30.0367 27.0273 30.1458 26.811C30.3638 26.3786 30.4727 25.838 30.5817 25.2976V24.5408C30.5817 24.5408 30.4727 24.4326 30.2547 24.3246Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_8514_9736">
            <rect
              width="40"
              height="40"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const FolderIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="#FFFFFF"
        strokeWidth="0"
        viewBox="0 0 1024 1024"
        height="4em"
        width="4em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z"></path>
      </svg>
    </React.Fragment>
  );
};

export const DownloadIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
          d="M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,12 L12,19 L19,12"
        ></path>
      </svg>
    </React.Fragment>
  );
};

export const ReloadIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        version="1.1"
        viewBox="0 0 17 17"
        height="1.8em"
        width="1.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g></g>
        <path d="M6 8h-6v-6h1v4.109c1.013-3.193 4.036-5.484 7.5-5.484 3.506 0 6.621 2.36 7.574 5.739l-0.963 0.271c-0.832-2.95-3.551-5.011-6.611-5.011-3.226 0.001-6.016 2.276-6.708 5.376h4.208v1zM11 9v1h4.208c-0.693 3.101-3.479 5.375-6.708 5.375-3.062 0-5.78-2.061-6.611-5.011l-0.963 0.271c0.952 3.379 4.067 5.739 7.574 5.739 3.459 0 6.475-2.28 7.5-5.482v4.108h1v-6h-6z"></path>
      </svg>
    </React.Fragment>
  );
};
export const WhatChat = () => {
  const { mode } = useAuth();
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M13.6288 20.4718L13.0867 21.3877C12.6035 22.204 11.3965 22.204 10.9133 21.3877L10.3712 20.4718C9.95073 19.7614 9.74049 19.4063 9.40279 19.2098C9.06509 19.0134 8.63992 19.0061 7.78958 18.9915C6.53422 18.9698 5.74689 18.8929 5.08658 18.6194C3.86144 18.1119 2.88807 17.1386 2.3806 15.9134C2 14.9946 2 13.8297 2 11.5V10.5C2 7.22657 2 5.58985 2.7368 4.38751C3.14908 3.71473 3.71473 3.14908 4.38751 2.7368C5.58985 2 7.22657 2 10.5 2H13.5C16.7734 2 18.4101 2 19.6125 2.7368C20.2853 3.14908 20.8509 3.71473 21.2632 4.38751C22 5.58985 22 7.22657 22 10.5V11.5C22 13.8297 22 14.9946 21.6194 15.9134C21.1119 17.1386 20.1386 18.1119 18.9134 18.6194C18.2531 18.8929 17.4658 18.9698 16.2104 18.9915C15.36 19.0061 14.9349 19.0134 14.5972 19.2098C14.2595 19.4062 14.0492 19.7614 13.6288 20.4718Z"
          fill={mode ? "#FFFFFF" : "#646B88"}
        />
        <path
          d="M7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H16C16.4142 8.25 16.75 8.58579 16.75 9C16.75 9.41421 16.4142 9.75 16 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9Z"
          fill={mode ? "#2C2E33" : "#FFFFFF"}
        />
        <path
          d="M7.25 12.5C7.25 12.0858 7.58579 11.75 8 11.75H13.5C13.9142 11.75 14.25 12.0858 14.25 12.5C14.25 12.9142 13.9142 13.25 13.5 13.25H8C7.58579 13.25 7.25 12.9142 7.25 12.5Z"
          fill={mode ? "#2C2E33" : "#FFFFFF"}
        />
      </svg>
    </React.Fragment>
  );
};
export const ReciptsIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="19"
        height="24"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css + " mb-1"}
      >
        <g clipPath="url(#clip0_12418_7631)">
          <path
            d="M13.1008 5.50039C12.7008 5.50039 12.3008 5.20039 12.3008 4.70039C12.3008 4.30039 12.7008 3.90039 13.0008 3.90039C13.4008 3.90039 13.8008 4.30039 13.8008 4.70039C13.8008 5.20039 13.5008 5.50039 13.1008 5.50039Z"
            fill={props.color}
          />
          <path
            d="M15.4011 5.5C15.0011 5.5 14.6011 5.1 14.7011 4.7C14.7011 4.4 15.0011 4 15.4011 4C15.8011 4 16.2011 4.4 16.2011 4.8C16.2011 5.2 15.8011 5.5 15.4011 5.5Z"
            fill={props.color}
          />
          <path
            d="M5.30078 4.8C5.30078 4.4 5.70078 4 6.10078 4C6.50078 4 6.90078 4.4 6.90078 4.8C6.90078 5.2 6.60078 5.6 6.20078 5.6C5.70078 5.5 5.30078 5.2 5.30078 4.8Z"
            fill={props.color}
          />
          <path
            d="M9.20117 4.8C9.20117 5.2 8.80117 5.5 8.40117 5.5C8.00117 5.5 7.70117 5.2 7.70117 4.8C7.70117 4.4 8.00117 4 8.40117 4C8.80117 4 9.20117 4.4 9.20117 4.8Z"
            fill={props.color}
          />
          <path
            d="M10 4.8C10 4.4 10.4 4 10.8 4C11.2 4 11.6 4.4 11.6 4.8C11.6 5.2 11.2 5.6 10.8 5.6C10.3 5.5 10 5.2 10 4.8Z"
            fill={props.color}
          />
          <path
            d="M15.9004 10.2992H14.1004C14.4004 10.4992 14.6004 10.8992 14.7004 11.3992H15.9004V11.8992H14.7004C14.6004 12.9992 13.7004 13.6992 12.3004 13.6992C13.1004 14.5992 14.0004 15.6992 15.0004 16.7992H14.0004C13.2004 15.7992 12.4004 14.8992 11.4004 13.7992V13.0992H12.0004C13.2004 13.0992 13.8004 12.5992 13.9004 11.8992H11.5004V11.3992H13.9004C13.7004 10.7992 13.2004 10.4992 12.2004 10.4992H11.4004V9.69922H15.9004V10.2992Z"
            fill={props.color}
          />
          <path
            d="M16.1008 6.90039H5.30078V8.00039H16.1008V6.90039Z"
            fill={props.color}
          />
          <path
            d="M10.0008 11.2988H5.30078V12.2988H10.0008V11.2988Z"
            fill={props.color}
          />
          <path
            d="M10.0008 13.9004H5.30078V14.9004H10.0008V13.9004Z"
            fill={props.color}
          />
          <path
            d="M18.1004 18.7992H3.40039V3.69922H1.50039C1.30039 3.69922 1.20039 3.59922 1.10039 3.49922C1.00039 3.39922 0.900391 3.29922 0.900391 3.09922C0.900391 2.49922 1.10039 1.89922 1.40039 1.39922C1.70039 0.899219 2.20039 0.499219 2.70039 0.299219C2.90039 0.199219 3.20039 0.199219 3.90039 0.199219H15.4004C16.9004 0.199219 18.1004 1.39922 18.1004 2.89922V18.7992ZM4.40039 17.7992H17.1004V2.89922C17.1004 1.99922 16.3004 1.19922 15.4004 1.19922H3.90039C3.40039 1.19922 3.10039 1.19922 3.00039 1.19922C2.70039 1.39922 2.50039 1.59922 2.30039 1.89922C2.10039 2.09922 2.10039 2.39922 2.00039 2.69922H4.40039V17.7992Z"
            fill={props.color}
          />
          <path
            d="M18.2008 18.8996H3.30078V3.79961H1.50078C1.30078 3.79961 1.10078 3.69961 1.00078 3.59961C0.900781 3.49961 0.800781 3.29961 0.800781 3.09961C0.800781 2.39961 1.00078 1.79961 1.30078 1.29961C1.60078 0.699609 2.10078 0.399609 2.60078 0.199609C2.80078 0.0996094 3.10078 0.0996094 3.90078 0.0996094H15.4008C16.9008 0.0996094 18.2008 1.39961 18.2008 2.89961V18.8996ZM3.50078 18.6996H18.0008V2.89961C18.0008 1.49961 16.8008 0.299609 15.4008 0.299609H3.90078C3.20078 0.299609 2.90078 0.299609 2.70078 0.399609C2.20078 0.599609 1.80078 0.899609 1.50078 1.39961C1.20078 1.89961 1.00078 2.49961 1.00078 3.09961C1.00078 3.19961 1.00078 3.29961 1.10078 3.39961C1.20078 3.49961 1.30078 3.49961 1.40078 3.49961H3.40078V18.6996H3.50078ZM17.2008 17.8996H4.30078V2.79961H1.90078V2.69961C2.00078 2.39961 2.10078 2.09961 2.20078 1.79961C2.40078 1.49961 2.70078 1.29961 3.00078 1.19961C3.10078 1.19961 3.20078 1.19961 3.90078 1.19961H15.4008C16.4008 1.19961 17.2008 1.99961 17.2008 2.99961V17.8996ZM4.50078 17.6996H17.0008V2.89961C17.0008 1.99961 16.3008 1.29961 15.4008 1.29961H3.90078C3.20078 1.29961 3.10078 1.29961 3.00078 1.29961C2.80078 1.39961 2.50078 1.59961 2.40078 1.89961C2.30078 2.09961 2.20078 2.29961 2.10078 2.59961H4.50078V17.6996Z"
            fill={props.color}
          />
          <path
            d="M4.40078 3.199H3.90078H3.40078C3.40078 3.199 3.40078 2.799 3.40078 2.299C3.30078 1.499 3.10078 1.399 3.10078 1.299C3.10078 1.299 3.10078 1.299 3.00078 1.299L2.80078 0.298996C3.20078 0.198996 3.50078 0.298996 3.80078 0.498996C4.20078 0.798996 4.40078 1.399 4.50078 2.199C4.40078 2.699 4.40078 3.199 4.40078 3.199Z"
            fill={props.color}
          />
          <path
            d="M4.50156 3.29939H4.40156L3.30156 3.19939V3.09939C3.30156 3.09939 3.30156 2.69939 3.30156 2.19939C3.20156 1.59939 3.00156 1.39939 3.00156 1.39939H2.90156L2.60156 0.199387H2.70156C3.10156 0.0993867 3.50156 0.199387 3.80156 0.399387C4.20156 0.699387 4.40156 1.29939 4.50156 2.09939C4.50156 2.59939 4.50156 2.99939 4.50156 3.09939V3.29939ZM3.50156 2.99939L4.30156 3.09939C4.30156 2.89939 4.30156 2.59939 4.30156 2.19939C4.20156 1.39939 4.00156 0.899387 3.70156 0.599387C3.40156 0.399387 3.10156 0.299387 2.80156 0.399387L3.00156 1.19939H3.10156C3.20156 1.29939 3.40156 1.49939 3.40156 2.19939C3.50156 2.59939 3.50156 2.89939 3.50156 2.99939Z"
            fill={props.color}
          />
        </g>
        <defs>
          <clipPath id="clip0_12418_7631">
            <rect width="19" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const CarIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8304 5.82194L14.2282 2.10319C14.1871 2.0076 14.1186 1.92614 14.0314 1.86891C13.9441 1.81167 13.8419 1.78119 13.7374 1.78125H12.1352V0.71875C12.1352 0.577854 12.0789 0.442728 11.9788 0.3431C11.8786 0.243471 11.7428 0.1875 11.6011 0.1875H7.86271V1.25H11.0671V7.92037C10.8237 8.06094 10.6108 8.24804 10.4404 8.47088C10.2701 8.69372 10.1459 8.9479 10.0748 9.21875H6.71875C6.60258 8.76281 6.33689 8.35842 5.96371 8.06956C5.59054 7.78071 5.13119 7.62387 4.65835 7.62387C4.1855 7.62387 3.72616 7.78071 3.35298 8.06956C2.97981 8.35842 2.71412 8.76281 2.59794 9.21875H1.98804V4.4375H0.919922V9.75C0.919922 9.8909 0.976189 10.026 1.07634 10.1257C1.1765 10.2253 1.31234 10.2812 1.45398 10.2812H2.59794C2.71412 10.7372 2.97981 11.1416 3.35298 11.4304C3.72616 11.7193 4.1855 11.8761 4.65835 11.8761C5.13119 11.8761 5.59054 11.7193 5.96371 11.4304C6.33689 11.1416 6.60258 10.7372 6.71875 10.2812H10.0748C10.191 10.7372 10.4567 11.1416 10.8298 11.4304C11.203 11.7193 11.6624 11.8761 12.1352 11.8761C12.608 11.8761 13.0674 11.7193 13.4406 11.4304C13.8137 11.1416 14.0794 10.7372 14.1956 10.2812H15.3396C15.4812 10.2812 15.617 10.2253 15.7172 10.1257C15.8174 10.026 15.8736 9.8909 15.8736 9.75V6.03125C15.8737 5.95928 15.8589 5.88806 15.8304 5.82194ZM4.65835 10.8125C4.44709 10.8125 4.24058 10.7502 4.06493 10.6334C3.88928 10.5167 3.75238 10.3507 3.67153 10.1566C3.59069 9.96245 3.56954 9.74882 3.61075 9.54272C3.65196 9.33661 3.75369 9.14729 3.90307 8.9987C4.05245 8.85011 4.24277 8.74891 4.44997 8.70792C4.65716 8.66692 4.87193 8.68796 5.0671 8.76838C5.26227 8.8488 5.42909 8.98498 5.54646 9.15971C5.66383 9.33443 5.72647 9.53986 5.72647 9.75C5.72605 10.0317 5.61338 10.3017 5.41316 10.5008C5.21294 10.7 4.9415 10.8121 4.65835 10.8125ZM12.1352 2.84375H13.3849L14.5299 5.5H12.1352V2.84375ZM12.1352 10.8125C11.9239 10.8125 11.7174 10.7502 11.5418 10.6334C11.3661 10.5167 11.2292 10.3507 11.1484 10.1566C11.0675 9.96245 11.0464 9.74882 11.0876 9.54272C11.1288 9.33661 11.2305 9.14729 11.3799 8.9987C11.5293 8.85011 11.7196 8.74891 11.9268 8.70792C12.134 8.66692 12.3488 8.68796 12.544 8.76838C12.7391 8.8488 12.9059 8.98498 13.0233 9.15971C13.1407 9.33443 13.2033 9.53986 13.2033 9.75C13.203 10.0317 13.0904 10.3018 12.8902 10.501C12.6899 10.7002 12.4184 10.8122 12.1352 10.8125ZM14.8055 9.21875H14.1956C14.078 8.7637 13.8118 8.36034 13.439 8.07192C13.0661 7.78349 12.6075 7.62631 12.1352 7.625V6.5625H14.8055V9.21875Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const CartIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.25258 5.33333C7.06753 5.33333 6.91231 5.26933 6.78691 5.14133C6.66151 5.01333 6.59903 4.85511 6.59947 4.66667V3.33333H5.29324C5.1082 3.33333 4.95297 3.26933 4.82758 3.14133C4.70218 3.01333 4.6397 2.85511 4.64013 2.66667C4.64013 2.47778 4.70283 2.31934 4.82823 2.19134C4.95363 2.06334 5.10863 1.99956 5.29324 2H6.59947V0.666669C6.59947 0.47778 6.66216 0.319336 6.78756 0.191336C6.91296 0.0633356 7.06796 -0.000442138 7.25258 2.30681e-06C7.43762 2.30681e-06 7.59285 0.0640023 7.71824 0.192002C7.84364 0.320002 7.90612 0.478224 7.90569 0.666669V2H9.21191C9.39696 2 9.55218 2.064 9.67758 2.192C9.80297 2.32 9.86545 2.47822 9.86502 2.66667C9.86502 2.85556 9.80232 3.014 9.67692 3.142C9.55152 3.27 9.39652 3.33378 9.21191 3.33333H7.90569V4.66667C7.90569 4.85556 7.84299 5.014 7.71759 5.142C7.59219 5.27 7.43719 5.33378 7.25258 5.33333ZM3.98702 14C3.62781 14 3.3202 13.8693 3.06418 13.608C2.80816 13.3467 2.68037 13.0329 2.6808 12.6667C2.6808 12.3 2.80881 11.986 3.06483 11.7247C3.32085 11.4633 3.62825 11.3329 3.98702 11.3333C4.34623 11.3333 4.65385 11.464 4.90987 11.7253C5.16589 11.9867 5.29368 12.3004 5.29324 12.6667C5.29324 13.0333 5.16523 13.3473 4.90922 13.6087C4.6532 13.87 4.3458 14.0004 3.98702 14ZM10.5181 14C10.1589 14 9.8513 13.8693 9.59528 13.608C9.33926 13.3467 9.21147 13.0329 9.21191 12.6667C9.21191 12.3 9.33992 11.986 9.59594 11.7247C9.85196 11.4633 10.1594 11.3329 10.5181 11.3333C10.8773 11.3333 11.185 11.464 11.441 11.7253C11.697 11.9867 11.8248 12.3004 11.8243 12.6667C11.8243 13.0333 11.6963 13.3473 11.4403 13.6087C11.1843 13.87 10.8769 14.0004 10.5181 14ZM3.98702 10.6667C3.48631 10.6667 3.10794 10.4471 2.85192 10.008C2.5959 9.56889 2.59329 9.13289 2.84408 8.7L3.72578 7.06667L1.37458 2H0.721472C0.536424 2 0.381201 1.936 0.255804 1.808C0.130407 1.68 0.0679262 1.52178 0.0683616 1.33334C0.0683616 1.14445 0.13106 0.986002 0.256457 0.858002C0.381855 0.730002 0.536859 0.666224 0.721472 0.666669H1.7991C1.91884 0.666669 2.03314 0.700002 2.14199 0.766669C2.25084 0.833336 2.33248 0.92778 2.3869 1.05L4.98302 6.66667H9.57112L11.9223 2.33334C11.9767 2.23334 12.0529 2.15267 12.1509 2.09134C12.2489 2.03 12.3577 1.99956 12.4775 2C12.7278 2 12.9157 2.10845 13.0411 2.32534C13.1665 2.54222 13.1691 2.76156 13.0489 2.98333L10.7141 7.3C10.5943 7.52222 10.4337 7.69445 10.2321 7.81667C10.0305 7.93889 9.81016 8 9.57112 8H4.70545L3.98702 9.33333H11.1712C11.3563 9.33333 11.5115 9.39733 11.6369 9.52533C11.7623 9.65333 11.8248 9.81156 11.8243 10C11.8243 10.1889 11.7617 10.3473 11.6363 10.4753C11.5109 10.6033 11.3559 10.6671 11.1712 10.6667H3.98702Z"
          fill="#7A7A7A"
        />
        <path
          d="M7.25258 5.33333C7.06753 5.33333 6.91231 5.26933 6.78691 5.14133C6.66151 5.01333 6.59903 4.85511 6.59947 4.66667V3.33333H5.29324C5.1082 3.33333 4.95297 3.26933 4.82758 3.14133C4.70218 3.01333 4.6397 2.85511 4.64013 2.66667C4.64013 2.47778 4.70283 2.31934 4.82823 2.19134C4.95363 2.06334 5.10863 1.99956 5.29324 2H6.59947V0.666669C6.59947 0.47778 6.66216 0.319336 6.78756 0.191336C6.91296 0.0633356 7.06796 -0.000442138 7.25258 2.30681e-06C7.43762 2.30681e-06 7.59285 0.0640023 7.71824 0.192002C7.84364 0.320002 7.90612 0.478224 7.90569 0.666669V2H9.21191C9.39696 2 9.55218 2.064 9.67758 2.192C9.80297 2.32 9.86545 2.47822 9.86502 2.66667C9.86502 2.85556 9.80232 3.014 9.67692 3.142C9.55152 3.27 9.39652 3.33378 9.21191 3.33333H7.90569V4.66667C7.90569 4.85556 7.84299 5.014 7.71759 5.142C7.59219 5.27 7.43719 5.33378 7.25258 5.33333ZM3.98702 14C3.62781 14 3.3202 13.8693 3.06418 13.608C2.80816 13.3467 2.68037 13.0329 2.6808 12.6667C2.6808 12.3 2.80881 11.986 3.06483 11.7247C3.32085 11.4633 3.62825 11.3329 3.98702 11.3333C4.34623 11.3333 4.65385 11.464 4.90987 11.7253C5.16589 11.9867 5.29368 12.3004 5.29324 12.6667C5.29324 13.0333 5.16523 13.3473 4.90922 13.6087C4.6532 13.87 4.3458 14.0004 3.98702 14ZM10.5181 14C10.1589 14 9.8513 13.8693 9.59528 13.608C9.33926 13.3467 9.21147 13.0329 9.21191 12.6667C9.21191 12.3 9.33992 11.986 9.59594 11.7247C9.85196 11.4633 10.1594 11.3329 10.5181 11.3333C10.8773 11.3333 11.185 11.464 11.441 11.7253C11.697 11.9867 11.8248 12.3004 11.8243 12.6667C11.8243 13.0333 11.6963 13.3473 11.4403 13.6087C11.1843 13.87 10.8769 14.0004 10.5181 14ZM3.98702 10.6667C3.48631 10.6667 3.10794 10.4471 2.85192 10.008C2.5959 9.56889 2.59329 9.13289 2.84408 8.7L3.72578 7.06667L1.37458 2H0.721472C0.536424 2 0.381201 1.936 0.255804 1.808C0.130407 1.68 0.0679262 1.52178 0.0683616 1.33334C0.0683616 1.14445 0.13106 0.986002 0.256457 0.858002C0.381855 0.730002 0.536859 0.666224 0.721472 0.666669H1.7991C1.91884 0.666669 2.03314 0.700002 2.14199 0.766669C2.25084 0.833336 2.33248 0.92778 2.3869 1.05L4.98302 6.66667H9.57112L11.9223 2.33334C11.9767 2.23334 12.0529 2.15267 12.1509 2.09134C12.2489 2.03 12.3577 1.99956 12.4775 2C12.7278 2 12.9157 2.10845 13.0411 2.32534C13.1665 2.54222 13.1691 2.76156 13.0489 2.98333L10.7141 7.3C10.5943 7.52222 10.4337 7.69445 10.2321 7.81667C10.0305 7.93889 9.81016 8 9.57112 8H4.70545L3.98702 9.33333H11.1712C11.3563 9.33333 11.5115 9.39733 11.6369 9.52533C11.7623 9.65333 11.8248 9.81156 11.8243 10C11.8243 10.1889 11.7617 10.3473 11.6363 10.4753C11.5109 10.6033 11.3559 10.6671 11.1712 10.6667H3.98702Z"
          stroke="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const SettingIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="13"
        viewBox="0 0 15 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8182 13L10.6161 12.025C10.4813 11.9708 10.3549 11.9141 10.2368 11.8547C10.1191 11.7949 9.99855 11.7217 9.87505 11.635L8.89826 11.9275L8.22461 10.8225L8.99931 10.1725C8.97685 10.0208 8.96562 9.88 8.96562 9.75C8.96562 9.62 8.97685 9.47917 8.99931 9.3275L8.22461 8.6775L8.89826 7.5725L9.87505 7.865C9.99855 7.77833 10.1191 7.7051 10.2368 7.6453C10.3549 7.58593 10.4813 7.52917 10.6161 7.475L10.8182 6.5H12.1655L12.3675 7.475C12.5023 7.52917 12.6287 7.58875 12.7468 7.65375C12.8645 7.71875 12.9851 7.8 13.1086 7.8975L14.0854 7.5725L14.759 8.71L13.9843 9.36C14.0068 9.49 14.018 9.62542 14.018 9.76625C14.018 9.90708 14.0068 10.0425 13.9843 10.1725L14.759 10.8225L14.0854 11.9275L13.1086 11.635C12.9851 11.7217 12.8645 11.7949 12.7468 11.8547C12.6287 11.9141 12.5023 11.9708 12.3675 12.025L12.1655 13H10.8182ZM11.4918 11.05C11.8623 11.05 12.1796 10.9228 12.4437 10.6684C12.7073 10.4136 12.8391 10.1075 12.8391 9.75C12.8391 9.3925 12.7073 9.08635 12.4437 8.83155C12.1796 8.57718 11.8623 8.45 11.4918 8.45C11.1213 8.45 10.8042 8.57718 10.5406 8.83155C10.2765 9.08635 10.1445 9.3925 10.1445 9.75C10.1445 10.1075 10.2765 10.4136 10.5406 10.6684C10.8042 10.9228 11.1213 11.05 11.4918 11.05Z"
          fill="#7A7A7A"
        />
        <circle cx="7.0957" cy="3.25" r="2.75" stroke="#7A7A7A" />
        <path
          d="M7.09686 7.58203C4.86359 7.67602 2.22186 8.66536 1.68019 9.20703C1.13853 9.7487 1.68019 11.9154 1.68019 11.9154C1.68019 11.9154 5.31165 11.9154 7.63853 11.9154"
          stroke="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const IndustryIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="11"
        viewBox="0 0 16 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.3384 9.49878H14.8358V1.61753L15.4434 1.48753C15.5093 1.47522 15.5721 1.44991 15.6281 1.41309C15.684 1.37626 15.732 1.32867 15.7692 1.27311C15.8063 1.21755 15.8319 1.15515 15.8445 1.08959C15.857 1.02403 15.8563 0.95663 15.8422 0.891372C15.8282 0.826113 15.8011 0.764314 15.7627 0.709616C15.7242 0.654918 15.6752 0.608428 15.6184 0.572888C15.5616 0.537348 15.4982 0.513476 15.432 0.502679C15.3658 0.491883 15.2981 0.494381 15.2329 0.510026L1.15881 3.51003C1.03756 3.53605 0.930269 3.60575 0.85757 3.70573C0.784871 3.8057 0.7519 3.92888 0.764998 4.05158C0.778097 4.17427 0.83634 4.28782 0.928525 4.37037C1.02071 4.45293 1.14033 4.49866 1.26436 4.49878C1.30006 4.49871 1.33564 4.49494 1.37055 4.48753L1.76701 4.40315V9.49878H1.26436C1.13105 9.49878 1.0032 9.55145 0.90894 9.64522C0.814676 9.73899 0.761719 9.86617 0.761719 9.99878C0.761719 10.1314 0.814676 10.2586 0.90894 10.3523C1.0032 10.4461 1.13105 10.4988 1.26436 10.4988H15.3384C15.4717 10.4988 15.5996 10.4461 15.6939 10.3523C15.7881 10.2586 15.8411 10.1314 15.8411 9.99878C15.8411 9.86617 15.7881 9.73899 15.6939 9.64522C15.5996 9.55145 15.4717 9.49878 15.3384 9.49878ZM2.7723 4.18628L13.8305 1.8319V9.49878H12.3226V5.99878C12.3226 5.86617 12.2696 5.73899 12.1753 5.64522C12.0811 5.55145 11.9532 5.49878 11.8199 5.49878H4.78288C4.64957 5.49878 4.52172 5.55145 4.42746 5.64522C4.33319 5.73899 4.28024 5.86617 4.28024 5.99878V9.49878H2.7723V4.18628ZM11.3173 7.49878H5.28553V6.49878H11.3173V7.49878ZM5.28553 8.49878H11.3173V9.49878H5.28553V8.49878Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const ArrowIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.58678 7.98103L6.58678 7.98102C6.64497 7.91174 6.72839 7.86839 6.81853 7.86006C6.90866 7.85173 6.99864 7.87904 7.06868 7.93632C7.13878 7.99363 7.18323 8.07636 7.19179 8.16647C7.20034 8.2566 7.17223 8.34619 7.11399 8.41553L4.12215 11.9778L4.12187 11.9781C4.0566 12.0551 3.9601 12.1 3.85855 12.1H3.85853C3.8084 12.1 3.75884 12.0891 3.71337 12.068C3.66793 12.047 3.62763 12.0162 3.5954 11.9779L6.58678 7.98103ZM6.58678 7.98103L4.19476 10.8295V1.55875C4.19476 1.46828 4.15833 1.3818 4.09392 1.31824C4.02955 1.25473 3.94253 1.21928 3.85208 1.21928C3.76162 1.21928 3.6746 1.25473 3.61023 1.31824C3.54582 1.3818 3.50939 1.46828 3.50939 1.55875V10.817L1.11728 7.9806C1.11728 7.98059 1.11727 7.98059 1.11727 7.98058C1.11726 7.98057 1.11725 7.98056 1.11724 7.98055C1.08839 7.94631 1.05307 7.91809 1.01332 7.89744C0.973554 7.87677 0.930111 7.86407 0.885467 7.86C0.840825 7.85594 0.795797 7.86059 0.752935 7.8737C0.710072 7.88681 0.670169 7.90815 0.635525 7.93656C0.600878 7.96497 0.572159 7.9999 0.551072 8.03941C0.529984 8.07893 0.516959 8.12221 0.51279 8.16679C0.50862 8.21137 0.513394 8.25632 0.526819 8.29904C0.540243 8.34176 0.562039 8.38137 0.590896 8.41563L0.590941 8.41568L3.59531 11.9778L6.58678 7.98103ZM12.5872 4.98595L12.6505 5.0633C12.7205 5.00596 12.7649 4.92326 12.7733 4.83321C12.7818 4.74315 12.7536 4.65366 12.6954 4.58442L12.6953 4.58432L9.24166 1.08653L9.16508 1.02221L9.16492 1.0224L6.17292 4.58447L6.17243 4.58506C6.11505 4.65445 6.08761 4.74367 6.09647 4.83326C6.10532 4.92284 6.14968 5.005 6.21939 5.062C6.28905 5.11895 6.37845 5.14625 6.46811 5.13829C6.55778 5.13033 6.64095 5.0877 6.69933 5.01922L6.69981 5.01865L9.09182 2.17048V11.4413C9.09182 11.5317 9.12826 11.6182 9.19267 11.6818C9.25703 11.7453 9.34405 11.7807 9.43451 11.7807C9.52497 11.7807 9.61199 11.7453 9.67635 11.6818C9.74076 11.6182 9.7772 11.5317 9.7772 11.4413V2.18269L12.1689 5.0186C12.169 5.0187 12.1691 5.0188 12.1692 5.0189C12.1978 5.05328 12.233 5.08166 12.2727 5.10244C12.3125 5.12329 12.356 5.13611 12.4007 5.14021C12.4455 5.14431 12.4906 5.13962 12.5335 5.12638C12.5765 5.11314 12.6164 5.09161 12.651 5.06296L12.5872 4.98595ZM12.5872 4.98595C12.6367 4.94539 12.6678 4.88708 12.6738 4.82385C12.6797 4.76062 12.66 4.69765 12.6189 4.64879L9.61475 1.08653C9.59198 1.05953 9.56349 1.03779 9.53129 1.02284L12.5872 4.98595Z"
          fill="#7A7A7A"
          stroke="#7A7A7A"
          strokeWidth="0.2"
        />
      </svg>
    </React.Fragment>
  );
};
export const UpArrowIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 8.414V18h2V8.414l4.293 4.293 1.414-1.414L12 4.586l-6.707 6.707 1.414 1.414z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DateIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.875 1.5H9.625V0.875C9.625 0.70924 9.55915 0.550268 9.44194 0.433058C9.32473 0.315848 9.16576 0.25 9 0.25C8.83424 0.25 8.67527 0.315848 8.55806 0.433058C8.44085 0.550268 8.375 0.70924 8.375 0.875V1.5H4.625V0.875C4.625 0.70924 4.55915 0.550268 4.44194 0.433058C4.32473 0.315848 4.16576 0.25 4 0.25C3.83424 0.25 3.67527 0.315848 3.55806 0.433058C3.44085 0.550268 3.375 0.70924 3.375 0.875V1.5H2.125C1.62772 1.5 1.15081 1.69754 0.799175 2.04917C0.447544 2.40081 0.25 2.87772 0.25 3.375V10.875C0.25 11.3723 0.447544 11.8492 0.799175 12.2008C1.15081 12.5525 1.62772 12.75 2.125 12.75H10.875C11.3723 12.75 11.8492 12.5525 12.2008 12.2008C12.5525 11.8492 12.75 11.3723 12.75 10.875V3.375C12.75 2.87772 12.5525 2.40081 12.2008 2.04917C11.8492 1.69754 11.3723 1.5 10.875 1.5ZM11.5 10.875C11.5 11.0408 11.4342 11.1997 11.3169 11.3169C11.1997 11.4342 11.0408 11.5 10.875 11.5H2.125C1.95924 11.5 1.80027 11.4342 1.68306 11.3169C1.56585 11.1997 1.5 11.0408 1.5 10.875V6.5H11.5V10.875ZM11.5 5.25H1.5V3.375C1.5 3.20924 1.56585 3.05027 1.68306 2.93306C1.80027 2.81585 1.95924 2.75 2.125 2.75H3.375V3.375C3.375 3.54076 3.44085 3.69973 3.55806 3.81694C3.67527 3.93415 3.83424 4 4 4C4.16576 4 4.32473 3.93415 4.44194 3.81694C4.55915 3.69973 4.625 3.54076 4.625 3.375V2.75H8.375V3.375C8.375 3.54076 8.44085 3.69973 8.55806 3.81694C8.67527 3.93415 8.83424 4 9 4C9.16576 4 9.32473 3.93415 9.44194 3.81694C9.55915 3.69973 9.625 3.54076 9.625 3.375V2.75H10.875C11.0408 2.75 11.1997 2.81585 11.3169 2.93306C11.4342 3.05027 11.5 3.20924 11.5 3.375V5.25Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const EyeTwo = () => {
  return (
    <React.Fragment>
      <svg
        width="26"
        height="21"
        viewBox="0 0 26 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.9445 10.0675C24.9251 7.31799 23.1554 4.94021 20.8542 3.22805C18.553 1.51588 15.8211 0.544368 12.9961 0.433594C10.1711 0.544368 7.43921 1.51588 5.13798 3.22805C2.83675 4.94021 1.06709 7.31799 0.0477265 10.0675C-0.0211172 10.2661 -0.0211172 10.4835 0.0477265 10.682C1.06709 13.4315 2.83675 15.8093 5.13798 17.5215C7.43921 19.2337 10.1711 20.2052 12.9961 20.3159C15.8211 20.2052 18.553 19.2337 20.8542 17.5215C23.1554 15.8093 24.9251 13.4315 25.9445 10.682C26.0133 10.4835 26.0133 10.2661 25.9445 10.0675ZM12.9961 18.5085C8.40263 18.5085 3.54916 14.9567 1.78978 10.3748C3.54916 5.79279 8.40263 2.24108 12.9961 2.24108C17.5896 2.24108 22.443 5.79279 24.2024 10.3748C22.443 14.9567 17.5896 18.5085 12.9961 18.5085Z"
          fill="#7A7A7A"
        />
        <path
          d="M12.9994 5.02344C11.9407 5.02344 10.9058 5.33738 10.0255 5.92557C9.14521 6.51376 8.45911 7.34977 8.05396 8.3279C7.6488 9.30602 7.5428 10.3823 7.74934 11.4207C7.95589 12.4591 8.4657 13.4129 9.21433 14.1615C9.96295 14.9101 10.9168 15.4199 11.9551 15.6265C12.9935 15.833 14.0698 15.727 15.0479 15.3219C16.026 14.9167 16.862 14.2306 17.4502 13.3503C18.0384 12.47 18.3524 11.4351 18.3524 10.3764C18.3524 8.95669 17.7884 7.59515 16.7845 6.59128C15.7807 5.58741 14.4191 5.02344 12.9994 5.02344ZM12.9994 13.945C12.2936 13.945 11.6037 13.7357 11.0168 13.3436C10.4299 12.9515 9.97255 12.3941 9.70245 11.742C9.43234 11.09 9.36167 10.3724 9.49937 9.68017C9.63707 8.98793 9.97695 8.35206 10.476 7.85298C10.9751 7.3539 11.611 7.01402 12.3032 6.87632C12.9955 6.73862 13.713 6.8093 14.3651 7.0794C15.0172 7.3495 15.5745 7.8069 15.9666 8.39376C16.3588 8.98061 16.5681 9.67057 16.5681 10.3764C16.5681 11.3228 16.1921 12.2305 15.5228 12.8998C14.8536 13.569 13.9459 13.945 12.9994 13.945Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const Copy = () => {
  return (
    <React.Fragment>
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.75065 9.5H1.58398V30.0833C1.58398 31.825 3.00898 33.25 4.75065 33.25H31.6673V30.0833H4.75065V9.5Z"
          fill="black"
        />
        <path
          d="M33.2493 6.0026H22.166L18.9993 2.83594H11.0827C9.34102 2.83594 7.93185 4.26094 7.93185 6.0026L7.91602 23.4193C7.91602 25.1609 9.34102 26.5859 11.0827 26.5859H33.2493C34.991 26.5859 36.416 25.1609 36.416 23.4193V9.16927C36.416 7.4276 34.991 6.0026 33.2493 6.0026Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Type = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5363 6.42188L13.7488 7.48438C13.8905 7.5434 14.0234 7.60526 14.1476 7.66996C14.2713 7.73512 14.3981 7.81493 14.528 7.90938L15.5551 7.59062L16.2634 8.79479L15.4488 9.50313C15.4724 9.64479 15.4842 9.79826 15.4842 9.96354C15.4842 10.1288 15.4724 10.2823 15.4488 10.424L16.2634 11.1323L15.5551 12.3365L14.528 12.0177C14.3981 12.1122 14.2713 12.192 14.1476 12.2571C14.0234 12.3218 13.8905 12.3837 13.7488 12.4427L13.5363 13.5052H12.1197L11.9072 12.4427C11.7655 12.3837 11.6328 12.3218 11.5091 12.2571C11.3849 12.192 11.2579 12.1122 11.128 12.0177L10.1009 12.3365L9.39258 11.1323L10.2072 10.424C10.1836 10.2823 10.1717 10.1288 10.1717 9.96354C10.1717 9.79826 10.1836 9.64479 10.2072 9.50313L9.39258 8.79479L10.1009 7.59062L11.128 7.90938C11.2579 7.81493 11.3849 7.73512 11.5091 7.66996C11.6328 7.60526 11.7655 7.5434 11.9072 7.48438L12.1197 6.42188H13.5363ZM12.828 8.54688C12.4384 8.54688 12.1048 8.68547 11.8271 8.96267C11.5499 9.24033 11.4113 9.57396 11.4113 9.96354C11.4113 10.3531 11.5499 10.6867 11.8271 10.9644C12.1048 11.2416 12.4384 11.3802 12.828 11.3802C13.2176 11.3802 13.5512 11.2416 13.8289 10.9644C14.1061 10.6867 14.2447 10.3531 14.2447 9.96354C14.2447 9.57396 14.1061 9.24033 13.8289 8.96267C13.5512 8.68547 13.2176 8.54688 12.828 8.54688Z"
          fill="#7A7A7A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7478 3.79451C14.212 1.49428 11.3124 0.41059 8.43158 0.458555C5.5557 0.506438 2.75692 1.68082 0.410156 3.79249L1.41349 4.90753C3.5239 3.00855 5.98418 1.99951 8.45655 1.95835C10.924 1.91726 13.4618 2.8389 15.7399 4.90551L16.7478 3.79451ZM4.4772 8.03296C5.70992 6.911 7.00973 6.34664 8.23048 6.32099C8.56623 6.31394 8.9039 6.34742 9.24068 6.42535C9.68006 5.98427 10.2075 5.63101 10.7945 5.39421C9.96553 4.99349 9.09132 4.80258 8.19898 4.82132C6.52768 4.85643 4.89522 5.62424 3.46755 6.92364L4.4772 8.03296ZM7.9205 9.14008C7.8982 9.32464 7.88672 9.51254 7.88672 9.70312C7.88672 10.0378 7.92211 10.3642 7.98936 10.6787C7.80683 10.7513 7.64927 10.8584 7.54696 10.971L6.43699 9.962C6.80106 9.56148 7.33901 9.25832 7.9205 9.14008Z"
          fill="#7A7A7A"
        />
      </svg>
    </React.Fragment>
  );
};
export const BlackPrint = () => {
  return (
    <React.Fragment>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.1694 4.23863H3.39488V1.79501C3.39488 1.56423 3.47308 1.37064 3.62947 1.21424C3.78586 1.05785 3.97918 0.979929 4.20942 0.980472H12.3548C12.5856 0.980472 12.7792 1.05867 12.9356 1.21506C13.092 1.37145 13.1699 1.56477 13.1694 1.79501V4.23863ZM13.1694 8.7186C13.4001 8.7186 13.5937 8.64041 13.7501 8.48401C13.9065 8.32762 13.9844 8.1343 13.9839 7.90406C13.9839 7.67328 13.9057 7.47969 13.7493 7.32329C13.5929 7.1669 13.3996 7.08898 13.1694 7.08952C12.9386 7.08952 12.745 7.16772 12.5886 7.32411C12.4322 7.4805 12.3543 7.67382 12.3548 7.90406C12.3548 8.13485 12.433 8.32844 12.5894 8.48483C12.7458 8.64122 12.9391 8.71914 13.1694 8.7186ZM5.02396 14.0131H11.5403V10.755H5.02396V14.0131ZM5.02396 15.6422C4.57596 15.6422 4.19232 15.4825 3.87302 15.1632C3.55372 14.8439 3.39434 14.4606 3.39488 14.0131V12.384H0.951262C0.720475 12.384 0.526886 12.3058 0.370494 12.1494C0.214103 11.9931 0.136179 11.7997 0.136722 11.5695V7.49679C0.136722 6.80443 0.374296 6.22394 0.849444 5.75531C1.32459 5.28667 1.90156 5.05263 2.58034 5.05317H13.9839C14.6763 5.05317 15.2568 5.28749 15.7254 5.75612C16.194 6.22475 16.4281 6.80498 16.4275 7.49679V11.5695C16.4275 11.8003 16.3493 11.9939 16.1929 12.1503C16.0365 12.3066 15.8432 12.3846 15.613 12.384H13.1694V14.0131C13.1694 14.4611 13.0097 14.8448 12.6904 15.1641C12.3711 15.4834 11.9877 15.6427 11.5403 15.6422H5.02396Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const Loadmore = (props) => {
  return (
    <React.Fragment>
      <svg
        className={props.className}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.9606 4.3582L26.9777 5.90859C24.2742 2.45273 20.0695 0.234375 15.3481 0.234375C7.19533 0.234375 0.596497 6.82617 0.58595 14.9824C0.575403 23.1457 7.18829 29.7656 15.3481 29.7656C21.7219 29.7656 27.1535 25.7227 29.2207 20.059C29.2735 19.9113 29.1961 19.7461 29.0485 19.6969L27.0551 19.0113C26.9856 18.9875 26.9095 18.9918 26.8432 19.0234C26.7768 19.0549 26.7254 19.1111 26.7 19.1801C26.6367 19.3559 26.5664 19.5316 26.4926 19.7039C25.8844 21.1453 25.0125 22.4391 23.9016 23.55C22.7996 24.654 21.4949 25.535 20.059 26.1445C18.5719 26.7738 16.9863 27.0938 15.3551 27.0938C13.7203 27.0938 12.1383 26.7738 10.6512 26.1445C9.21391 25.5376 7.90872 24.6563 6.80861 23.55C5.70365 22.4482 4.82362 21.1419 4.21759 19.7039C3.58829 18.2133 3.26837 16.6313 3.26837 14.9965C3.26837 13.3617 3.58829 11.7797 4.21759 10.2891C4.82579 8.84766 5.69767 7.55391 6.80861 6.44297C7.91954 5.33203 9.21329 4.46016 10.6512 3.84844C12.1383 3.21914 13.7238 2.89922 15.3551 2.89922C16.9899 2.89922 18.5719 3.21914 20.059 3.84844C21.4963 4.45539 22.8015 5.33667 23.9016 6.44297C24.2496 6.79102 24.5766 7.16016 24.8789 7.54688L22.7625 9.19922C22.7206 9.23161 22.6888 9.27517 22.6705 9.32487C22.6523 9.37458 22.6485 9.42842 22.6595 9.48021C22.6705 9.53199 22.6959 9.57961 22.7328 9.61759C22.7697 9.65558 22.8165 9.68238 22.868 9.69492L29.0414 11.2066C29.2172 11.2488 29.3895 11.1152 29.3895 10.9359L29.4176 4.57617C29.4141 4.34414 29.1434 4.21406 28.9606 4.3582Z"
          fill="black"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};

export const DownloadIcongrey = (props) => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8462 15.75C13.8462 15.5469 13.7776 15.3711 13.6406 15.2227C13.5036 15.0742 13.3413 15 13.1538 15C12.9663 15 12.8041 15.0742 12.6671 15.2227C12.53 15.3711 12.4615 15.5469 12.4615 15.75C12.4615 15.9531 12.53 16.1289 12.6671 16.2773C12.8041 16.4258 12.9663 16.5 13.1538 16.5C13.3413 16.5 13.5036 16.4258 13.6406 16.2773C13.7776 16.1289 13.8462 15.9531 13.8462 15.75ZM16.6154 15.75C16.6154 15.5469 16.5469 15.3711 16.4099 15.2227C16.2728 15.0742 16.1106 15 15.9231 15C15.7356 15 15.5733 15.0742 15.4363 15.2227C15.2993 15.3711 15.2308 15.5469 15.2308 15.75C15.2308 15.9531 15.2993 16.1289 15.4363 16.2773C15.5733 16.4258 15.7356 16.5 15.9231 16.5C16.1106 16.5 16.2728 16.4258 16.4099 16.2773C16.5469 16.1289 16.6154 15.9531 16.6154 15.75ZM18 13.125V16.875C18 17.1875 17.899 17.4531 17.6971 17.6719C17.4952 17.8906 17.25 18 16.9615 18H1.03846C0.75 18 0.504808 17.8906 0.302885 17.6719C0.100962 17.4531 0 17.1875 0 16.875V13.125C0 12.8125 0.100962 12.5469 0.302885 12.3281C0.504808 12.1094 0.75 12 1.03846 12H6.06851L7.52885 13.5938C7.94712 14.0312 8.4375 14.25 9 14.25C9.5625 14.25 10.0529 14.0312 10.4712 13.5938L11.9423 12H16.9615C17.25 12 17.4952 12.1094 17.6971 12.3281C17.899 12.5469 18 12.8125 18 13.125ZM14.4844 6.45703C14.607 6.77734 14.5565 7.05078 14.3329 7.27734L9.48678 12.5273C9.35697 12.6758 9.19471 12.75 9 12.75C8.80529 12.75 8.64303 12.6758 8.51322 12.5273L3.66707 7.27734C3.44351 7.05078 3.39303 6.77734 3.51562 6.45703C3.63822 6.15234 3.85096 6 4.15385 6H6.92308V0.75C6.92308 0.546875 6.99159 0.371094 7.12861 0.222656C7.26562 0.0742188 7.42788 0 7.61539 0H10.3846C10.5721 0 10.7344 0.0742188 10.8714 0.222656C11.0084 0.371094 11.0769 0.546875 11.0769 0.75V6H13.8462C14.149 6 14.3618 6.15234 14.4844 6.45703Z"
          fill={props.color}
        />
      </svg>
    </React.Fragment>
  );
};

export const OrdersIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        className={props.className}
        width="24"
        height="30"
        viewBox="0 0 24 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.2381 0.5H0.761905C0.342857 0.5 0 0.842857 0 1.2619V31.1667C0 31.4333 0.152381 31.7 0.380952 31.8524C0.609524 31.9667 0.914286 31.9667 1.14286 31.8143L6.05714 28.6524L11.3905 30.7476C11.581 30.8238 11.7714 30.8238 11.9619 30.7476L15.7333 29.1857L22.9333 32.4238C23.0476 32.4619 23.1238 32.5 23.2381 32.5C23.3905 32.5 23.5429 32.4619 23.6571 32.3857C23.8857 32.2333 24 32.0048 24 31.7381V1.2619C24 0.842857 23.6952 0.5 23.2381 0.5ZM22.4762 30.5571L16.0381 27.6619C15.9238 27.6238 15.8476 27.5857 15.7333 27.5857C15.619 27.5857 15.5429 27.5857 15.4286 27.6619L11.619 29.2238L6.20952 27.0905C5.98095 27.0143 5.71429 27.0143 5.52381 27.1667L1.48571 29.7952V2.02381H22.4762V30.5571V30.5571ZM5.10476 5.2619C5.10476 4.84286 5.44762 4.5 5.86667 4.5H18.1333C18.5524 4.5 18.8952 4.84286 18.8952 5.2619C18.8952 5.68095 18.5524 6.02381 18.1333 6.02381H5.86667C5.44762 6.02381 5.10476 5.68095 5.10476 5.2619ZM5.10476 10.6333C5.10476 10.2143 5.44762 9.87143 5.86667 9.87143H18.1333C18.5524 9.87143 18.8952 10.2143 18.8952 10.6333C18.8952 11.0524 18.5524 11.3952 18.1333 11.3952H5.86667C5.44762 11.3952 5.10476 11.0524 5.10476 10.6333ZM5.10476 16.0048C5.10476 15.5857 5.44762 15.2429 5.86667 15.2429H18.1333C18.5524 15.2429 18.8952 15.5857 18.8952 16.0048C18.8952 16.4238 18.5524 16.7667 18.1333 16.7667H5.86667C5.44762 16.7667 5.10476 16.4238 5.10476 16.0048ZM12.381 23.3571C12.381 23.7762 12.0381 24.119 11.619 24.119H5.90476C5.48571 24.119 5.14286 23.7762 5.14286 23.3571C5.14286 22.9381 5.48571 22.5952 5.90476 22.5952H11.619C12.0381 22.5952 12.381 22.9381 12.381 23.3571Z"
          fill="#3A3A3A"
        />
      </svg>
    </React.Fragment>
  );
};

export const NoImageIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.625 2.24044L19.6529 1.3125L1.375 18.7596L2.34713 19.6875L3.72213 18.375H17.875C18.2395 18.3745 18.5889 18.236 18.8467 17.99C19.1044 17.744 19.2495 17.4104 19.25 17.0625V3.55294L20.625 2.24044ZM17.875 17.0625H5.09713L10.4548 11.9483L12.0904 13.5096C12.3482 13.7556 12.6979 13.8938 13.0625 13.8938C13.4271 13.8938 13.7768 13.7556 14.0346 13.5096L15.125 12.4688L17.875 15.0918V17.0625ZM17.875 13.2352L16.0971 11.5382C15.8393 11.2921 15.4896 11.1539 15.125 11.1539C14.7604 11.1539 14.4107 11.2921 14.1529 11.5382L13.0625 12.579L11.4283 11.0191L17.875 4.86544V13.2352ZM4.125 14.4375V12.4688L7.5625 9.18947L8.50644 10.0912L9.47994 9.16191L8.53462 8.25956C8.27677 8.01351 7.9271 7.87528 7.5625 7.87528C7.1979 7.87528 6.84823 8.01351 6.59038 8.25956L4.125 10.6129V3.9375H15.125V2.625H4.125C3.76044 2.62535 3.41091 2.76374 3.15313 3.00981C2.89535 3.25587 2.75036 3.58951 2.75 3.9375V14.4375H4.125Z"
          fill="#656565"
        />
      </svg>
    </React.Fragment>
  );
};

export const BurgerIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="none"
        strokeWidth="0"
        viewBox="0 0 15 15"
        height="2.8em"
        width="2.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z"
          fill="currentColor"
        ></path>
      </svg>
    </React.Fragment>
  );
};
export const CreateOrderIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="21"
        viewBox="0 0 15 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.66156 17.1002H0.140625V0H12.8075V12.0479H12.0158V0.777283H0.932302V16.3229H7.66156V17.1002Z"
          fill="black"
        />
        <path
          d="M10.2748 2.53516H3.94141V3.1685H10.2748V2.53516Z"
          fill="black"
        />
        <path
          d="M3.30912 2.53516H2.67578V3.1685H3.30912V2.53516Z"
          fill="black"
        />
        <path
          d="M10.2748 4.43359H3.94141V5.06694H10.2748V4.43359Z"
          fill="black"
        />
        <path
          d="M3.30912 4.43359H2.67578V5.06694H3.30912V4.43359Z"
          fill="black"
        />
        <path
          d="M10.2748 6.96484H3.94141V7.59819H10.2748V6.96484Z"
          fill="black"
        />
        <path
          d="M3.30912 6.96484H2.67578V7.59819H3.30912V6.96484Z"
          fill="black"
        />
        <path d="M10.2748 9.5H3.94141V10.1333H10.2748V9.5Z" fill="black" />
        <path d="M3.30912 9.5H2.67578V10.1333H3.30912V9.5Z" fill="black" />
        <path
          d="M7.74145 11.4023H3.94141V12.0357H7.74145V11.4023Z"
          fill="black"
        />
        <path
          d="M3.30912 11.4023H2.67578V12.0357H3.30912V11.4023Z"
          fill="black"
        />
        <line
          x1="12.756"
          y1="14.5664"
          x2="12.756"
          y2="18.9998"
          stroke="black"
          strokeWidth="1.16036"
        />
        <line
          x1="10.2734"
          y1="16.5214"
          x2="14.7068"
          y2="16.5214"
          stroke="black"
          strokeWidth="1.16036"
        />
      </svg>
    </React.Fragment>
  );
};

export const CircleAddIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 11.2773C8.2125 11.2773 8.39075 11.2053 8.53475 11.0613C8.67825 10.9178 8.75 10.7398 8.75 10.5273V8.27734H11.0187C11.2312 8.27734 11.4062 8.20534 11.5438 8.06134C11.6813 7.91784 11.75 7.73984 11.75 7.52734C11.75 7.31484 11.678 7.13659 11.534 6.99259C11.3905 6.84909 11.2125 6.77734 11 6.77734H8.75V4.50859C8.75 4.29609 8.67825 4.12109 8.53475 3.98359C8.39075 3.84609 8.2125 3.77734 8 3.77734C7.7875 3.77734 7.6095 3.84909 7.466 3.99259C7.322 4.13659 7.25 4.31484 7.25 4.52734V6.77734H4.98125C4.76875 6.77734 4.59375 6.84909 4.45625 6.99259C4.31875 7.13659 4.25 7.31484 4.25 7.52734C4.25 7.73984 4.32175 7.91784 4.46525 8.06134C4.60925 8.20534 4.7875 8.27734 5 8.27734H7.25V10.5461C7.25 10.7586 7.322 10.9336 7.466 11.0711C7.6095 11.2086 7.7875 11.2773 8 11.2773ZM8 15.0273C6.9625 15.0273 5.9875 14.8303 5.075 14.4363C4.1625 14.0428 3.36875 13.5086 2.69375 12.8336C2.01875 12.1586 1.4845 11.3648 1.091 10.4523C0.697 9.53984 0.5 8.56484 0.5 7.52734C0.5 6.48984 0.697 5.51484 1.091 4.60234C1.4845 3.68984 2.01875 2.89609 2.69375 2.22109C3.36875 1.54609 4.1625 1.01159 5.075 0.617594C5.9875 0.224094 6.9625 0.0273438 8 0.0273438C9.0375 0.0273438 10.0125 0.224094 10.925 0.617594C11.8375 1.01159 12.6313 1.54609 13.3063 2.22109C13.9813 2.89609 14.5155 3.68984 14.909 4.60234C15.303 5.51484 15.5 6.48984 15.5 7.52734C15.5 8.56484 15.303 9.53984 14.909 10.4523C14.5155 11.3648 13.9813 12.1586 13.3063 12.8336C12.6313 13.5086 11.8375 14.0428 10.925 14.4363C10.0125 14.8303 9.0375 15.0273 8 15.0273ZM8 13.5273C9.6625 13.5273 11.0782 12.9431 12.2472 11.7746C13.4158 10.6056 14 9.18984 14 7.52734C14 5.86484 13.4158 4.44909 12.2472 3.28009C11.0782 2.11159 9.6625 1.52734 8 1.52734C6.3375 1.52734 4.922 2.11159 3.7535 3.28009C2.5845 4.44909 2 5.86484 2 7.52734C2 9.18984 2.5845 10.6056 3.7535 11.7746C4.922 12.9431 6.3375 13.5273 8 13.5273Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const CrossCircelIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.275 11.2523C4.4125 11.3898 4.5875 11.4586 4.8 11.4586C5.0125 11.4586 5.1875 11.3898 5.325 11.2523L7.5 9.07734L9.69375 11.2711C9.83125 11.4086 10.0033 11.4741 10.2098 11.4676C10.4157 11.4616 10.5875 11.3898 10.725 11.2523C10.8625 11.1148 10.9313 10.9398 10.9313 10.7273C10.9313 10.5148 10.8625 10.3398 10.725 10.2023L8.55 8.02734L10.7438 5.83359C10.8813 5.69609 10.9467 5.52409 10.9403 5.31759C10.9342 5.11159 10.8625 4.93984 10.725 4.80234C10.5875 4.66484 10.4125 4.59609 10.2 4.59609C9.9875 4.59609 9.8125 4.66484 9.675 4.80234L7.5 6.97734L5.30625 4.78359C5.16875 4.64609 4.997 4.58034 4.791 4.58634C4.5845 4.59284 4.4125 4.66484 4.275 4.80234C4.1375 4.93984 4.06875 5.11484 4.06875 5.32734C4.06875 5.53984 4.1375 5.71484 4.275 5.85234L6.45 8.02734L4.25625 10.2211C4.11875 10.3586 4.05325 10.5303 4.05975 10.7363C4.06575 10.9428 4.1375 11.1148 4.275 11.2523ZM7.5 15.5273C6.4625 15.5273 5.4875 15.3303 4.575 14.9363C3.6625 14.5428 2.86875 14.0086 2.19375 13.3336C1.51875 12.6586 0.9845 11.8648 0.591 10.9523C0.197 10.0398 0 9.06484 0 8.02734C0 6.98984 0.197 6.01484 0.591 5.10234C0.9845 4.18984 1.51875 3.39609 2.19375 2.72109C2.86875 2.04609 3.6625 1.51159 4.575 1.11759C5.4875 0.724094 6.4625 0.527344 7.5 0.527344C8.5375 0.527344 9.5125 0.724094 10.425 1.11759C11.3375 1.51159 12.1313 2.04609 12.8063 2.72109C13.4813 3.39609 14.0155 4.18984 14.409 5.10234C14.803 6.01484 15 6.98984 15 8.02734C15 9.06484 14.803 10.0398 14.409 10.9523C14.0155 11.8648 13.4813 12.6586 12.8063 13.3336C12.1313 14.0086 11.3375 14.5428 10.425 14.9363C9.5125 15.3303 8.5375 15.5273 7.5 15.5273ZM7.5 14.0273C9.1625 14.0273 10.5782 13.4431 11.7472 12.2746C12.9158 11.1056 13.5 9.68984 13.5 8.02734C13.5 6.36484 12.9158 4.94909 11.7472 3.78009C10.5782 2.61159 9.1625 2.02734 7.5 2.02734C5.8375 2.02734 4.422 2.61159 3.2535 3.78009C2.0845 4.94909 1.5 6.36484 1.5 8.02734C1.5 9.68984 2.0845 11.1056 3.2535 12.2746C4.422 13.4431 5.8375 14.0273 7.5 14.0273Z"
          fill="#E13537"
        />
      </svg>
    </React.Fragment>
  );
};
export const HelpCircle = (props) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        fill="#fff"
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        <g id="Layer_4">
          <path d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4 c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z"></path>
          <circle cx="10" cy="15" r="1"></circle>
          <path d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z"></path>
        </g>
      </svg>
    </React.Fragment>
  );
};
export const Hyphen = (props) => {
  return (
    <React.Fragment>
      <svg
        role="button"
        onClick={props.onClick}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        data-testid="Icon--dash"
        data-garden-id="buttons.icon"
        data-garden-version="8.13.0"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
          d="M3 8h10"
        ></path>
      </svg>
    </React.Fragment>
  );
};

export const EmailIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2 0H1.8C0.81 0 0.00899999 0.84375 0.00899999 1.875L0 13.125C0 14.1562 0.81 15 1.8 15H16.2C17.19 15 18 14.1562 18 13.125V1.875C18 0.84375 17.19 0 16.2 0ZM16.2 3.75L9 8.4375L1.8 3.75V1.875L9 6.5625L16.2 1.875V3.75Z"
          fill="#FFFFFF"
        />
      </svg>
    </React.Fragment>
  );
};

export const WhatsAppIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        width="28"
        height="28"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
        style={props.styles}
      >
        <path
          d="M4.01114 12.9963L4.25388 13.1173C5.26543 13.7223 6.39825 14.0046 7.53114 14.0046C11.0916 14.0046 14.0046 11.1006 14.0046 7.55115C14.0046 5.85713 13.3168 4.20341 12.1031 2.99336C10.8893 1.78331 9.27084 1.09766 7.53114 1.09766C3.97072 1.09766 1.05759 4.00172 1.09807 7.59151C1.09807 8.8015 1.46221 9.97124 2.06908 10.9795L2.2309 11.2216L1.5836 13.6013L4.01114 12.9963Z"
          fill="#00E676"
        />
        <path
          d="M12.8338 2.18919C11.4441 0.770295 9.52315 0 7.56129 0C3.39241 0 0.0408978 3.36485 0.081737 7.45943C0.081737 8.75674 0.449583 10.0135 1.0627 11.1486L0 15L3.96457 13.9865C5.0681 14.5946 6.29422 14.8784 7.52045 14.8784C11.6485 14.8784 15 11.5135 15 7.41898C15 5.43246 14.2234 3.56757 12.8338 2.18919ZM7.56129 13.6217C6.45775 13.6217 5.35421 13.3379 4.41415 12.7704L4.16894 12.6487L1.79839 13.2568L2.41145 10.946L2.24797 10.7028C0.449583 7.82441 1.30791 4.01351 4.25068 2.22969C7.19344 0.445939 10.9945 1.29731 12.7929 4.21622C14.5913 7.13514 13.7329 10.9054 10.7902 12.6892C9.8501 13.2973 8.70572 13.6217 7.56129 13.6217ZM11.158 9.12172L10.7084 8.91901C10.7084 8.91901 10.0545 8.63522 9.64579 8.4325C9.60489 8.4325 9.56405 8.39194 9.52315 8.39194C9.40052 8.39194 9.31878 8.4325 9.23704 8.47307C9.23704 8.47307 9.1962 8.51358 8.62399 9.16223C8.58309 9.2433 8.50135 9.28387 8.41961 9.28387H8.37872C8.33788 9.28387 8.25614 9.2433 8.21524 9.2028L8.01087 9.12172C7.56129 8.91901 7.1526 8.67572 6.8256 8.35143C6.74386 8.27035 6.62122 8.18928 6.53949 8.1082C6.25338 7.82441 5.96727 7.50006 5.76296 7.13519L5.72206 7.05412C5.68122 7.01355 5.68122 6.97304 5.64032 6.89197C5.64032 6.8109 5.64032 6.72982 5.68122 6.68925C5.68122 6.68925 5.84469 6.48654 5.96727 6.36496C6.04907 6.28382 6.0899 6.16224 6.17164 6.08117C6.25338 5.95953 6.29428 5.79738 6.25338 5.67574C6.21254 5.47302 5.72206 4.37843 5.59948 4.13521C5.51769 4.01356 5.43601 3.97306 5.31337 3.93249H4.86379C4.782 3.93249 4.70032 3.97306 4.61852 3.97306L4.57762 4.01356C4.49589 4.05413 4.41415 4.13521 4.33241 4.17571C4.25068 4.25685 4.20978 4.33786 4.12804 4.419C3.84193 4.78386 3.67846 5.2298 3.67846 5.67574C3.67846 6.00003 3.76019 6.32439 3.88283 6.60818L3.92373 6.72982C4.29157 7.50006 4.782 8.18928 5.43601 8.79737L5.59948 8.95951C5.72206 9.08116 5.84469 9.16223 5.92643 9.28381C6.78476 10.0136 7.76566 10.5406 8.8692 10.8244C8.99183 10.8649 9.15531 10.8649 9.27794 10.9055H9.68663C9.891 10.9055 10.1362 10.8244 10.2997 10.7433C10.4223 10.6623 10.5041 10.6623 10.5858 10.5812L10.6676 10.5C10.7493 10.419 10.8311 10.3785 10.9128 10.2974C10.9945 10.2163 11.0763 10.1352 11.1172 10.0541C11.1989 9.89196 11.2397 9.68924 11.2806 9.48659V9.2028C11.2806 9.2028 11.2397 9.16223 11.158 9.12172Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const EmailColorIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="30"
        height="30"
      >
        <path
          fill="#CFD8DC"
          d="M40,10H8c-2.209,0-4,1.791-4,4v20c0,2.209,1.791,4,4,4h32c2.209,0,4-1.791,4-4V14C44,11.791,42.209,10,40,10z"
        />
        <path
          fill="#78909C"
          d="M44,14.025c0-0.465-0.095-0.904-0.24-1.32L24,27.025L4.241,12.705C4.095,13.121,4,13.561,4,14.025V15l20,14.495L44,15V14.025z"
        />
      </svg>
    </React.Fragment>
  );
};

export const MessageColorIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 36 36"
        width="30"
        height="30"
      >
        <g data-name="Слой 2">
          <path
            fill="#1565c0"
            d="M14,30H30l6,6V14a4,4,0,0,0-4-4H14a4,4,0,0,0-4,4V26a4,4,0,0,0,4,4"
          />
          <path
            fill="#2196f3"
            d="M23,20H6L0,26V4A4,4,0,0,1,4,0H23a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4"
          />
          <rect width="19" height="2" x="4" y="4" fill="#e3f2fd" />
          <rect width="19" height="2" x="4" y="9" fill="#e3f2fd" />
          <rect width="10" height="2" x="4" y="14" fill="#e3f2fd" />
        </g>
      </svg>
    </React.Fragment>
  );
};
export const CopyColorIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="30"
        height="30"
      >
        <path fill="#42A5F5" d="M31 36L6 36 6 3 23 3 31 11z" />
        <path fill="#E1F5FE" d="M29.5 12L22 12 22 4.5z" />
        <path
          fill="#1565C0"
          d="M11 16H27V18H11zM11 20H23V22H11zM11 24H27V26H11zM11 28H23V30H11z"
        />
        <path fill="#90CAF9" d="M42 44L17 44 17 11 34 11 42 19z" />
        <path fill="#E1F5FE" d="M40.5 20L33 20 33 12.5z" />
        <g>
          <path
            fill="#1976D2"
            d="M22 24H37V26H22zM22 28H33V30H22zM22 32H37V34H22zM22 36H33V38H22z"
          />
        </g>
      </svg>{" "}
    </React.Fragment>
  );
};
export const WarehouseIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        className={props.css}
        stroke="currentColor"
        fill={props.color}
        strokeWidth="0"
        viewBox="0 0 576 512"
        height="3em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"></path>
      </svg>
    </React.Fragment>
  );
};
export const CloseWhiteIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 1024 1024"
        fillRule="evenodd"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372Zm128.013 198.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const RupeesIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 320 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"></path>
      </svg>
    </React.Fragment>
  );
};
export const SearchIcon = ({ color = "#FFFFFF" }) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 10.5231C0 13.314 1.10868 15.9906 3.08215 17.9641C5.05561 19.9375 7.7322 21.0462 10.5231 21.0462C12.8601 21.0491 15.1302 20.2662 16.9685 18.8232L22.7431 24.6109C22.8653 24.7342 23.0108 24.8321 23.1711 24.8988C23.3314 24.9656 23.5033 25 23.677 25C23.8506 25 24.0226 24.9656 24.1829 24.8988C24.3431 24.8321 24.4886 24.7342 24.6109 24.6109C24.7342 24.4886 24.8321 24.3431 24.8988 24.1829C24.9656 24.0226 25 23.8506 25 23.677C25 23.5033 24.9656 23.3314 24.8988 23.1711C24.8321 23.0108 24.7342 22.8653 24.6109 22.7431L18.8232 16.9685C20.2662 15.1302 21.0491 12.8601 21.0462 10.5231C21.0462 7.7322 19.9375 5.05561 17.9641 3.08215C15.9906 1.10868 13.314 0 10.5231 0C7.7322 0 5.05561 1.10868 3.08215 3.08215C1.10868 5.05561 0 7.7322 0 10.5231ZM10.5231 2.63078C12.0841 2.63078 13.61 3.09365 14.9078 3.96087C16.2057 4.82809 17.2173 6.06071 17.8147 7.50284C18.412 8.94498 18.5683 10.5319 18.2638 12.0628C17.9593 13.5938 17.2076 15.0001 16.1038 16.1038C15.0001 17.2076 13.5938 17.9593 12.0628 18.2638C10.5319 18.5683 8.94498 18.412 7.50284 17.8147C6.06071 17.2173 4.82809 16.2057 3.96087 14.9078C3.09365 13.61 2.63078 12.0841 2.63078 10.5231C2.63078 8.42993 3.46229 6.42248 4.94239 4.94239C6.42248 3.46229 8.42993 2.63078 10.5231 2.63078Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};
export const PreviousIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46.7998 3.59961L51.8398 8.99961L25.1998 35.9996L51.8398 62.9996L46.7998 68.3996L14.3998 35.9996L46.7998 3.59961Z"
          fill="#F5F5F5"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const NextIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.2002 3.59961L20.1602 8.99961L46.8002 35.9996L20.1602 62.9996L25.2002 68.3996L57.6002 35.9996L25.2002 3.59961Z"
          fill="#F5F5F5"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const DropDownBlueIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="22"
        height="10"
        viewBox="0 0 27 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M26 1L13.5 13L1 1" stroke="#74B9FF" strokeWidth="2" />
      </svg>
    </React.Fragment>
  );
};
export const DropDownIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.8em"
        width="1.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DropUpIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.8em"
        width="1.8em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 11.8284L9.17154 14.6569L7.75732 13.2426L12 9L16.2426 13.2426L14.8284 14.6569L12 11.8284Z"></path>
      </svg>{" "}
    </React.Fragment>
  );
};
export const CheckIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="15"
        height="11"
        viewBox="0 0 15 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.20685 4.48445C1.39438 4.29698 1.64868 4.19167 1.91385 4.19167C2.17901 4.19167 2.43332 4.29698 2.62085 4.48445L6.15685 8.02045L13.2268 0.949453C13.3197 0.856542 13.4299 0.782829 13.5513 0.732521C13.6726 0.682214 13.8026 0.656296 13.934 0.65625C14.0653 0.656204 14.1954 0.682029 14.3168 0.732251C14.4382 0.782473 14.5484 0.856108 14.6413 0.948953C14.7343 1.0418 14.808 1.15203 14.8583 1.27337C14.9086 1.3947 14.9345 1.52475 14.9346 1.6561C14.9346 1.78745 14.9088 1.91752 14.8586 2.03889C14.8083 2.16026 14.7347 2.27054 14.6418 2.36345L6.15685 10.8485L1.20685 5.89845C1.01938 5.71093 0.914062 5.45662 0.914062 5.19145C0.914063 4.92629 1.01938 4.67198 1.20685 4.48445Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const CheckGreenIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 8.46667L7.66667 15L21 1"
          stroke="#1FFC33"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const DoubleCheckIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="#0dcaf0"
        strokeWidth="0"
        viewBox="0 0 256 256"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M152.41,88.56l-89.6,88a12,12,0,0,1-16.82,0L7.59,138.85a12,12,0,0,1,16.82-17.13l30,29.46,81.19-79.74a12,12,0,0,1,16.82,17.12Zm96.15-17a12,12,0,0,0-17-.15L150.4,151.18l-7.88-7.74a12,12,0,0,0-16.82,17.12l16.29,16a12,12,0,0,0,16.82,0l89.6-88A12,12,0,0,0,248.56,71.59Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const LocationIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.0013 9.58464C9.44877 9.58464 8.91886 9.36514 8.52816 8.97444C8.13746 8.58374 7.91797 8.05384 7.91797 7.5013C7.91797 6.94877 8.13746 6.41886 8.52816 6.02816C8.91886 5.63746 9.44877 5.41797 10.0013 5.41797C10.5538 5.41797 11.0837 5.63746 11.4744 6.02816C11.8651 6.41886 12.0846 6.94877 12.0846 7.5013C12.0846 7.77489 12.0307 8.0458 11.9261 8.29856C11.8214 8.55132 11.6679 8.78099 11.4744 8.97444C11.281 9.1679 11.0513 9.32135 10.7986 9.42605C10.5458 9.53075 10.2749 9.58464 10.0013 9.58464ZM10.0013 1.66797C8.45421 1.66797 6.97047 2.28255 5.87651 3.37651C4.78255 4.47047 4.16797 5.95421 4.16797 7.5013C4.16797 11.8763 10.0013 18.3346 10.0013 18.3346C10.0013 18.3346 15.8346 11.8763 15.8346 7.5013C15.8346 5.95421 15.2201 4.47047 14.1261 3.37651C13.0321 2.28255 11.5484 1.66797 10.0013 1.66797Z"
          fill="black"
        />
      </svg>
    </React.Fragment>
  );
};
export const GSTIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 15 15"
        fill="none"
      >
        <circle cx="7.5" cy="7.5" r="7.5" fill="black" />
        <path
          d="M1.301 7.69C1.273 6.367 2.4 5.282 3.737 5.303C4.542 5.303 5.207 5.653 5.648 6.269L5.109 6.71C4.766 6.227 4.304 5.982 3.73 5.982C2.757 5.982 2.071 6.71 2.071 7.683C2.071 8.67 2.778 9.412 3.772 9.412C4.381 9.412 4.864 9.153 5.151 8.712V8.215H3.73V7.557H5.893V8.859C5.48 9.594 4.668 10.077 3.737 10.077C2.386 10.098 1.28 9.013 1.301 7.69ZM6.47466 9.076L6.99966 8.677C7.30766 9.125 7.67866 9.412 8.21066 9.412C8.68666 9.412 9.00866 9.16 9.00866 8.768C9.00866 8.439 8.81266 8.299 8.32966 8.075L7.81866 7.837C7.14666 7.529 6.74066 7.172 6.74066 6.556C6.74066 5.8 7.39866 5.303 8.19666 5.303C8.84766 5.303 9.40066 5.632 9.68766 6.129L9.16966 6.528C8.92466 6.164 8.58866 5.968 8.19666 5.968C7.80466 5.968 7.49666 6.164 7.49666 6.528C7.52466 6.892 7.68566 6.955 8.14066 7.186L8.65866 7.424C9.40766 7.767 9.76466 8.131 9.76466 8.74C9.76466 9.545 9.10666 10.077 8.21766 10.077C7.46166 10.077 6.83166 9.699 6.47466 9.076ZM11.7988 10V6.045H10.2448V5.38H14.1018V6.045H12.5408V10H11.7988Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const ImageIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 165 145"
        fill="none"
      >
        <path
          d="M144.375 15.7812C147.211 15.7812 149.531 18.1016 149.531 20.9375V123.998L147.92 121.903L104.092 65.1846C102.642 63.2832 100.354 62.1875 97.9688 62.1875C95.584 62.1875 93.3281 63.2832 91.8457 65.1846L65.0977 99.7959L55.2686 86.0352C53.8184 84.0049 51.498 82.8125 48.9844 82.8125C46.4707 82.8125 44.1504 84.0049 42.7002 86.0674L16.9189 122.161L15.4688 124.159V20.9375C15.4688 18.1016 17.7891 15.7812 20.625 15.7812H144.375ZM20.625 0.3125C9.24902 0.3125 0 9.56152 0 20.9375V124.062C0 135.438 9.24902 144.688 20.625 144.688H144.375C155.751 144.688 165 135.438 165 124.062V20.9375C165 9.56152 155.751 0.3125 144.375 0.3125H20.625ZM46.4062 62.1875C48.4376 62.1875 50.4491 61.7874 52.3259 61.01C54.2026 60.2326 55.9079 59.0932 57.3443 57.6568C58.7807 56.2204 59.9201 54.5151 60.6975 52.6384C61.4749 50.7616 61.875 48.7501 61.875 46.7188C61.875 44.6874 61.4749 42.6759 60.6975 40.7991C59.9201 38.9224 58.7807 37.2171 57.3443 35.7807C55.9079 34.3443 54.2026 33.2049 52.3259 32.4275C50.4491 31.6501 48.4376 31.25 46.4062 31.25C44.3749 31.25 42.3634 31.6501 40.4866 32.4275C38.6099 33.2049 36.9046 34.3443 35.4682 35.7807C34.0318 37.2171 32.8924 38.9224 32.115 40.7991C31.3376 42.6759 30.9375 44.6874 30.9375 46.7188C30.9375 48.7501 31.3376 50.7616 32.115 52.6384C32.8924 54.5151 34.0318 56.2204 35.4682 57.6568C36.9046 59.0932 38.6099 60.2326 40.4866 61.01C42.3634 61.7874 44.3749 62.1875 46.4062 62.1875Z"
          fill={mode ? "#000" : "white"}
        />
      </svg>
    </React.Fragment>
  );
};
export const VideoIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 144 144"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72 144C81.4552 144 90.8178 142.138 99.5532 138.519C108.289 134.901 116.226 129.598 122.912 122.912C129.598 116.226 134.901 108.289 138.519 99.5532C142.138 90.8178 144 81.4552 144 72C144 62.5448 142.138 53.1822 138.519 44.4468C134.901 35.7113 129.598 27.7741 122.912 21.0883C116.226 14.4025 108.289 9.09901 99.5532 5.48067C90.8178 1.86233 81.4552 -1.40893e-07 72 0C52.9044 2.84546e-07 34.5909 7.58569 21.0883 21.0883C7.58569 34.5909 0 52.9044 0 72C0 91.0956 7.58569 109.409 21.0883 122.912C34.5909 136.414 52.9044 144 72 144ZM62.264 39.92L107.416 65.008C108.663 65.701 109.701 66.7147 110.424 67.9441C111.147 69.1734 111.529 70.5738 111.529 72C111.529 73.4262 111.147 74.8266 110.424 76.0559C109.701 77.2853 108.663 78.299 107.416 78.992L62.264 104.08C60.802 104.893 59.153 105.309 57.4805 105.288C55.8079 105.268 54.1699 104.81 52.7285 103.961C51.2872 103.113 50.0927 101.902 49.2633 100.449C48.4339 98.9967 47.9984 97.3527 48 95.68V48.32C47.9984 46.6473 48.4339 45.0033 49.2633 43.5507C50.0927 42.0981 51.2872 40.8875 52.7285 40.0387C54.1699 39.1899 55.8079 38.7325 57.4805 38.7116C59.153 38.6908 60.802 39.1074 62.264 39.92Z"
          fill={mode ? "#000" : "white"}
        />
      </svg>
    </React.Fragment>
  );
};
export const DocumentIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 125 144"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.503906 14.59C0.503906 10.7764 2.01123 7.11904 4.6943 4.42245C7.37736 1.72587 11.0164 0.210938 14.8108 0.210938L93.0885 0.210938L124.497 31.7777V129.622C124.497 133.436 122.99 137.093 120.307 139.79C117.623 142.486 113.984 144.001 110.19 144.001H14.8108C11.0164 144.001 7.37736 142.486 4.6943 139.79C2.01123 137.093 0.503906 133.436 0.503906 129.622V14.59ZM29.1177 38.5262L76.8073 38.555V48.141L29.1177 48.1123V38.5262ZM95.8831 67.2651H29.1177V76.8511H95.8831V67.2651ZM95.8831 96.0807L29.1177 96.004V105.59L95.8831 105.657V96.0807Z"
          fill={mode ? "#000" : "white"}
        />
      </svg>
    </React.Fragment>
  );
};
export const LiveLocationIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 100 143"
        fill="none"
      >
        <path
          d="M49.875 67.6875C45.1508 67.6875 40.6202 65.8108 37.2797 62.4703C33.9392 59.1298 32.0625 54.5992 32.0625 49.875C32.0625 45.1508 33.9392 40.6202 37.2797 37.2797C40.6202 33.9392 45.1508 32.0625 49.875 32.0625C54.5992 32.0625 59.1298 33.9392 62.4703 37.2797C65.8108 40.6202 67.6875 45.1508 67.6875 49.875C67.6875 52.2142 67.2268 54.5304 66.3316 56.6916C65.4364 58.8527 64.1244 60.8163 62.4703 62.4703C60.8163 64.1244 58.8527 65.4364 56.6916 66.3316C54.5304 67.2268 52.2142 67.6875 49.875 67.6875ZM49.875 0C36.6473 0 23.9614 5.25467 14.608 14.608C5.25467 23.9614 0 36.6473 0 49.875C0 87.2812 49.875 142.5 49.875 142.5C49.875 142.5 99.75 87.2812 99.75 49.875C99.75 36.6473 94.4953 23.9614 85.1419 14.608C75.7886 5.25467 63.1027 0 49.875 0Z"
          fill={mode ? "#000" : "white"}
        />
      </svg>
    </React.Fragment>
  );
};
export const GotoWebsiteIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"></path>
      </svg>
    </React.Fragment>
  );
};
export const BoldIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        stroke={mode ? "#fff" : "#000"}
        fill={mode ? "#fff" : "#000"}
        strokeWidth="0"
        viewBox="0 0 20 20"
        height="20px"
        width="20px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 4.75c0-.69.56-1.25 1.25-1.25h5a4.752 4.752 0 0 1 3.888 7.479A5 5 0 0 1 14 20.5H7.25c-.69 0-1.25-.56-1.25-1.25ZM8.5 13v5H14a2.5 2.5 0 1 0 0-5Zm0-2.5h3.751A2.25 2.25 0 0 0 12.25 6H8.5Z"></path>
      </svg>
    </React.Fragment>
  );
};
export const ItalicIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        stroke={mode ? "#fff" : "#000"}
        fill={mode ? "#fff" : "#000"}
        strokeWidth="0"
        version="1.1"
        viewBox="0 0 14 14"
        height="16px"
        width="16px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 1v1h-2l-5 12h2v1h-7v-1h2l5-12h-2v-1z"></path>
      </svg>
    </React.Fragment>
  );
};
export const EmojisIcon = ({ mode }) => {
  return (
    <React.Fragment>
      <svg
        stroke={mode ? "#fff" : "#000"}
        fill={mode ? "#fff" : "#000"}
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
        <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
      </svg>
    </React.Fragment>
  );
};
export const SendMessageIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 40 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.3438 17.9409H38.4565M7.3438 17.9409L2.39405 32.7901C2.3207 32.9876 2.30558 33.2019 2.35049 33.4077C2.3954 33.6135 2.49844 33.8021 2.64738 33.951C2.79632 34.0999 2.98489 34.203 3.19068 34.2479C3.39647 34.2928 3.61082 34.2777 3.80827 34.2043L38.4565 17.9409M7.3438 17.9409L2.39405 3.09163C2.3207 2.89419 2.30558 2.67983 2.35049 2.47404C2.3954 2.26825 2.49844 2.07968 2.64738 1.93074C2.79632 1.78181 2.98489 1.67876 3.19068 1.63385C3.39647 1.58895 3.61082 1.60407 3.80827 1.67742L38.4565 17.9409"
          stroke="#D9D9D9"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const WhatsAppHeader = (props) => {
  return (
    <React.Fragment>
      <svg
        width="32"
        height="32"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.css}
      >
        <path
          d="M4.01114 12.9963L4.25388 13.1173C5.26543 13.7223 6.39825 14.0046 7.53114 14.0046C11.0916 14.0046 14.0046 11.1006 14.0046 7.55115C14.0046 5.85713 13.3168 4.20341 12.1031 2.99336C10.8893 1.78331 9.27084 1.09766 7.53114 1.09766C3.97072 1.09766 1.05759 4.00172 1.09807 7.59151C1.09807 8.8015 1.46221 9.97124 2.06908 10.9795L2.2309 11.2216L1.5836 13.6013L4.01114 12.9963Z"
          fill="#00E676"
        />
        <path
          d="M12.8338 2.18919C11.4441 0.770295 9.52315 0 7.56129 0C3.39241 0 0.0408978 3.36485 0.081737 7.45943C0.081737 8.75674 0.449583 10.0135 1.0627 11.1486L0 15L3.96457 13.9865C5.0681 14.5946 6.29422 14.8784 7.52045 14.8784C11.6485 14.8784 15 11.5135 15 7.41898C15 5.43246 14.2234 3.56757 12.8338 2.18919ZM7.56129 13.6217C6.45775 13.6217 5.35421 13.3379 4.41415 12.7704L4.16894 12.6487L1.79839 13.2568L2.41145 10.946L2.24797 10.7028C0.449583 7.82441 1.30791 4.01351 4.25068 2.22969C7.19344 0.445939 10.9945 1.29731 12.7929 4.21622C14.5913 7.13514 13.7329 10.9054 10.7902 12.6892C9.8501 13.2973 8.70572 13.6217 7.56129 13.6217ZM11.158 9.12172L10.7084 8.91901C10.7084 8.91901 10.0545 8.63522 9.64579 8.4325C9.60489 8.4325 9.56405 8.39194 9.52315 8.39194C9.40052 8.39194 9.31878 8.4325 9.23704 8.47307C9.23704 8.47307 9.1962 8.51358 8.62399 9.16223C8.58309 9.2433 8.50135 9.28387 8.41961 9.28387H8.37872C8.33788 9.28387 8.25614 9.2433 8.21524 9.2028L8.01087 9.12172C7.56129 8.91901 7.1526 8.67572 6.8256 8.35143C6.74386 8.27035 6.62122 8.18928 6.53949 8.1082C6.25338 7.82441 5.96727 7.50006 5.76296 7.13519L5.72206 7.05412C5.68122 7.01355 5.68122 6.97304 5.64032 6.89197C5.64032 6.8109 5.64032 6.72982 5.68122 6.68925C5.68122 6.68925 5.84469 6.48654 5.96727 6.36496C6.04907 6.28382 6.0899 6.16224 6.17164 6.08117C6.25338 5.95953 6.29428 5.79738 6.25338 5.67574C6.21254 5.47302 5.72206 4.37843 5.59948 4.13521C5.51769 4.01356 5.43601 3.97306 5.31337 3.93249H4.86379C4.782 3.93249 4.70032 3.97306 4.61852 3.97306L4.57762 4.01356C4.49589 4.05413 4.41415 4.13521 4.33241 4.17571C4.25068 4.25685 4.20978 4.33786 4.12804 4.419C3.84193 4.78386 3.67846 5.2298 3.67846 5.67574C3.67846 6.00003 3.76019 6.32439 3.88283 6.60818L3.92373 6.72982C4.29157 7.50006 4.782 8.18928 5.43601 8.79737L5.59948 8.95951C5.72206 9.08116 5.84469 9.16223 5.92643 9.28381C6.78476 10.0136 7.76566 10.5406 8.8692 10.8244C8.99183 10.8649 9.15531 10.8649 9.27794 10.9055H9.68663C9.891 10.9055 10.1362 10.8244 10.2997 10.7433C10.4223 10.6623 10.5041 10.6623 10.5858 10.5812L10.6676 10.5C10.7493 10.419 10.8311 10.3785 10.9128 10.2974C10.9945 10.2163 11.0763 10.1352 11.1172 10.0541C11.1989 9.89196 11.2397 9.68924 11.2806 9.48659V9.2028C11.2806 9.2028 11.2397 9.16223 11.158 9.12172Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const Doubletick = (props) => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 21 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 8L11.5 10.5L20 2"
          stroke="#F4F4F4"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <path
          d="M1 5L5.5 9.5L14 1"
          stroke="#F4F4F4"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const DoubletickActive = (props) => {
  return (
    <React.Fragment>
      <svg
        width="18"
        height="18"
        viewBox="0 0 21 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 8L11.5 10.5L20 2"
          stroke="#1baafa"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <path
          d="M1 5L5.5 9.5L14 1"
          stroke="#1baafa"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const WhatsappLocationIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 100 143"
        fill="none"
      >
        <path
          d="M49.875 67.6875C45.1508 67.6875 40.6202 65.8108 37.2797 62.4703C33.9392 59.1298 32.0625 54.5992 32.0625 49.875C32.0625 45.1508 33.9392 40.6202 37.2797 37.2797C40.6202 33.9392 45.1508 32.0625 49.875 32.0625C54.5992 32.0625 59.1298 33.9392 62.4703 37.2797C65.8108 40.6202 67.6875 45.1508 67.6875 49.875C67.6875 52.2142 67.2268 54.5304 66.3316 56.6916C65.4364 58.8527 64.1244 60.8163 62.4703 62.4703C60.8163 64.1244 58.8527 65.4364 56.6916 66.3316C54.5304 67.2268 52.2142 67.6875 49.875 67.6875ZM49.875 0C36.6473 0 23.9614 5.25467 14.608 14.608C5.25467 23.9614 0 36.6473 0 49.875C0 87.2812 49.875 142.5 49.875 142.5C49.875 142.5 99.75 87.2812 99.75 49.875C99.75 36.6473 94.4953 23.9614 85.1419 14.608C75.7886 5.25467 63.1027 0 49.875 0Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};
export const AddFile = () => {
  return (
    <React.Fragment>
      <svg
        stroke="#fff"
        fill="#fff"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="1.6em"
        width="1.6em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
      </svg>
    </React.Fragment>
  );
};

export const WhatsappEmojisIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="#fff"
        fill="#fff"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
        <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
      </svg>
    </React.Fragment>
  );
};
export const DownloadFileIcon = () => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="2em"
        width="2em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm-1 8V6h2v4h3l-4 4-4-4h3zm6 7H7v-2h10v2z"></path>
      </svg>
    </React.Fragment>
  );
};

export const WhatsappEmojisWhiteIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="#000"
        fill="#000"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
        <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"></path>
      </svg>
    </React.Fragment>
  );
};

export const AddFileDark = () => {
  return (
    <React.Fragment>
      <svg
        stroke="#000"
        fill="#000"
        strokeWidth="0"
        viewBox="0 0 448 512"
        height="1.6em"
        width="1.6em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"></path>
      </svg>
    </React.Fragment>
  );
};

export const BackArrowIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke={props.color}
        fill={props.color}
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="48"
          d="M244 400 100 256l144-144M120 256h292"
        ></path>
      </svg>{" "}
    </React.Fragment>
  );
};

export const SpinnerWhite = (props) => {
  return (
    <React.Fragment>
      <div className="tw_center">
        <div
          className={props.css}
          style={{ height: props.size + "px", width: props.size + "px" }}
        />
      </div>
    </React.Fragment>
  );
};

export const CrossRedIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="#dc3545"
        fill="#dc3545"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1.4em"
        width="1.4em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="none" strokeWidth="2" d="M7,7 L17,17 M7,17 L17,7"></path>
      </svg>
    </React.Fragment>
  );
};

export const ErickshawIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 500 500"
        style={{
          enableBackground: "new 0 0 500 500",
          opacity: "0.3",
          width: "200px",
          height: "200px",
        }}
      >
        <g>
          <path
            d="M104.6,328.5c0.5,0.6,1.5,1.1,1.5,1.7c0.1,1.7-0.2,3.3-0.4,5c-1.7-0.2-3.3-0.2-4.9-0.7c-1-0.3-1.8-1.2-3.5-2.3
		c4.4,31.1-15.5,48.7-34.8,51.4c-22.7,3.2-42.1-11.1-46.8-31.9c-3.4-14.8,0.4-27.9,10.9-38.7c10.5-10.8,23.6-14,38.4-12.3
		c-4.5-2.5-10.1-2.5-17.6-0.8c-6.2,1.4-12.4,2.6-18.6,3.7c-1.4,0.3-3-0.1-5-0.8c6.3-0.8,6-5.2,5.7-9.4c0.7,0,1.1-0.1,1.2,0
		c2.8,5,6.5,3.4,10.7,1.8c8.1-3.3,11.8-3.4,26.3-2.3c0.8-7.8,6.7-14.5,4.8-23.3c0.5-0.1,1.5-0.3,2-0.4c0.7-2.3,1.4-4.3,2-6.5
		c2,0.6,3.5,1.1,5.2,1.7c3.3-8.7,6.5-17.2,9.7-25.7c-0.3-0.3-0.5-0.5-0.8-0.8c-0.9,0.9-2,1.6-2.6,2.6c-2.4,4-3.9,8.6-8.5,11.1
		c-3.8,2-7.7,2.2-11.5,0.9c-1.4-0.5-2.9-2.2-3.2-3.6c-2-7.4-1.6-14.7,1.5-21.7c2.1-4.8,6.1-3,8.9-2.6c1.4-4.1,2.5-8.1,4.2-11.8
		c1.2-2.7,3.4-3.5,5.9-1c1.6,1.6,3.4,3,5.2,4.3c2.9,2.1,5.8,4.2,4,8.5c0.6,0.1,1.1,0.2,1.1,0.1c3.5-7.5,10.8-13.4,9.6-23
		c-0.3-2.3,1.1-4.7,1.7-7.1c0.9-3.7,2.4-7.3,2.6-11c0.4-5.8,0.8-8,4.4-10.7c5.7,5,8.5,11.5,9.3,18.9c0.1,0.8-1.5,1.9-2.5,2.6
		c-0.3,0.2-1.2-0.3-1.8-0.5c-8.2-3.3-12.2-0.4-12.2,8.6c0,1.7,0,3.4,0.4,5.4c2.2-4,5.2-1.4,7.7-1.4c3,0,5.1,1.4,5.9,4.7
		c0.3,1.4,2.7,2.1,3.5,3.5c0.8,1.3,0.8,3.1,1.2,4.7c-1.5,0.1-3.2,0.6-4.4,0.1c-2.1-1-3.8-2-6.5-1.3c-3.5,0.9-5.1-1.9-6.7-5.3
		c-2,3.2-4.1,6.3-6.1,9.4c2.3,2,4.1,3.6,6,5.3c-1.5,1.1-2.4,1.7-3.3,2.4c1,0.8,2,1.7,3.4,2.9c0,0.8,0,2.4,0,4.2
		c-1.9,0.2-3.7,0.3-5.1,0.5c1.3,1,3.8,1.8,4.1,3.1c0.8,4.1,1.9,8.8,0.7,12.5c-1.5,4.4-4.2,8.6-8.4,11.9c-2.7,2.1-4.4,4.3-8.2,4.4
		c-1.3,0-3.2,2.3-3.8,3.9c-1.1,2.9-1.4,6.1-2.1,9.5c0.9,0.4,2.1,1.1,3.3,1.2c1.8,0.1,3.7,0.1,3.5-2.8c-0.2-2.7-0.1-5.4,3.7-5.8
		c0.7-0.1,1.3-1.2,1.8-1.9c1.5-2.2,3-4.4,4.2-6.7c2.6-5.3,7-9,10.9-13.2c1-1.1,2.9-2.3,0.7-4.3c-0.2-0.2,1.6-2.7,2.8-4.5
		c0.6,2.9,1,4.9,1.4,6.7c5.2-5.2,10.4-10.3,15.5-15.4c0.5,0.4,1.1,0.8,1.6,1.3c-5.7,9.9-11.2,20-20,29.1c6.2-0.4,7.6,2.7,8.6,6.9
		c2,8.5,4.4,16.9,6.4,25.3c0.4,1.5,0.5,3.9-0.3,4.8c-3,3.4-1.2,6.2,0.7,8.8c3.5,4.7,7.1,9.3,11,13.5c3.7,4,4,9,5,13.9
		c0.2,1.1,1.4,2.9,2.1,2.9c11.4,0.2,22.7,0.1,34.3,0.1c0-18.1,0-35.6,0-52c-1.7-2-2.9-3.4-4-4.7c-0.4-0.4-1-0.8-1.5-1.1
		c-1.2-0.6-3.6-1.2-3.6-1.7c0.1-2.8-1.7-6.1,1.8-8.6c-4-3-2.1-6.2-0.3-9.6c2-3.6,3.4-7.5,5.6-10.9c0.9-1.4,3.3-2.2,5.2-2.6
		c13.2-2.2,25.8,0.4,37.8,5.8c1.2,0.5,2.4,0.9,4.6,1.7c0-7.3,2.1-14.9-0.4-20.4c-5.3-11.5-0.3-22,0-33c0-2.1,0.5-4.2,0.5-6.3
		c0.1-26.8,0.1-53.5,0.3-80.3c0-3.7,0.4-7.3,0.7-11.6c-2,0-3.5,0-5,0c-48,0-96,0-143.9,0c-1.8,0-3.6-0.4-5.4-0.6
		c0-0.5-0.1-1-0.1-1.4c0.8-0.3,1.7-1,2.5-0.9c17.8,1.3,34.5-4.8,51.6-7.6c21.3-3.5,42.7-6.6,64.3-6.6c90-0.2,180-0.1,270-0.1
		c9.1,0,15.7,3.9,19.8,12c0.7,1.3,1.7,2.5,3.1,4.5c-6.8,1.5-13.3,0.2-20.2,0.9c0,3.2,0,6.3,0,9.4c0.2,24.4,0.4,48.7,0.6,73.1
		c0,1.8-0.9,4.1,2.4,4.4c0.5,0.1,0.7,2.6,1.1,4.6c0.6-0.5,1.5-0.9,1.6-1.4c0.6-2.6,0.8-5.2,1.4-7.8c0.8-3.6,3.5-5.6,6.8-5.1
		c4.1,0.6,6.3,3.2,5.8,7.1c-2.7,20.3-3.4,40.9-8.9,60.8c-0.7,2.4-0.9,4.9-1.2,7.4c-0.9,6.5-2,7.5-8.3,7.6c0,5,0,9.9,0,14.9
		c0.5-0.1,1-0.3,1.5-0.4c0.7,1.5,2.1,3,2,4.5c-0.1,3.9,1.3,6.3,4.5,8.4c1.7,1.1,3.2,3.7,3.5,5.7c0.5,4.2,0.5,8.5,0,12.7
		c-0.2,1.7-1.7,4.2-3.2,4.7c-4,1.5-5.2,4.1-4.6,7.9c0.2,1,0.7,2.7,1.3,2.8c1.2,0.3,2.7-0.2,4-0.6c1-0.3,2.3-1.3,2.7-1
		c0.8,0.6,1.3,1.9,1.4,2.9c0.2,3.4,0.1,6.9,0.1,10.3c0,2.7-1.3,3.5-4,2.7c-0.1-1.3-0.2-2.6-0.3-4.3c-5.9,0.4-11.8,0.7-18,1.1
		c-0.9-3.9-1.8-7.7-2.8-11.7c-1.9,0.1-3.4,0.2-5.4,0.3c0.6,3.2,1.3,6.1,1.7,9c3,19.1-8.5,37.7-27,43.8c-18.4,6.1-39.1-1.9-47.7-19.1
		c-2.2-4.3-4.2-5.7-9.1-5.4c-27.8,1.4-55.6,2.3-83.4,3.4c-2.8,0.1-5.6,0.4-8.5,0.1c7.3-2.2,0-7.1,3-10.3c-10.1,0-19.3,0-28.5,0
		c-1,3.3-6.8,7.3-11.1,7.7c-6.8,0.7-13.6,0.3-20.3,2.9c-4.8,1.9-9.4-0.8-12.4-4.3c-4.6-5.3-10-5.5-16.3-5.6
		c-20.7-0.5-41.3-1.5-61.9-2.5c-3.8-0.2-7.6-1-11.4-1.5c-3-0.5-3.1-2.2-3.2-5c-0.3-4.7-1.9-9.3-3.5-13.7c-0.3-0.9-3.3-0.8-5-1.1
		C104.9,327.8,104.7,328.2,104.6,328.5z M352.3,108.1c-18.3,0-36,0-53.7,0c-1.1,11.2-0.5,13.8,4.7,22.8c1.2,2,0.6,3.4-1.8,3.5
		c-3.4,0.1-6.9,0.1-10.3,0c-2.5-0.1-3-1.8-1.5-3.5c1.9-2.1,2.5-4.6,3.6-7.1c2.4-5.4,0.6-10.5,1.2-15.7c-13.6,0-26.7,0-40,0
		c-0.4,7.4-0.7,14.5,4.5,20.4c0.6,0.6,0.9,2.1,0.5,2.8c-0.3,0.7-1.6,1.2-2.5,1.2c-3,0.1-6.1,0.1-9.1,0c-0.9,0-2.2-0.6-2.5-1.3
		c-0.3-0.8,0-2.2,0.6-2.9c5.1-6,5.1-13,4.5-20.2c-6.9,0-13.5,0-19.8,0c0,28.9,0,57.4,0,86.9c4.5-2.5,6.4,0.5,8.4,2.7
		c1.4,1.5,3.2,3.4,3.4,5.3c0.7,6.4,1.2,13,0.8,19.4c-0.3,4.2-1.5,8.8-3.8,12.2c-2,2.9-2.4,5.2-1.7,8.2c5.8,0.8,6.8,0.6,12-2.2
		c0.6-0.3,1.3-0.4,1.9-0.4c10.6-0.3,21.2-0.7,31.8-0.9c4.3-0.1,6.2,3,4,6.6c-1.8,3-2,5.5-0.7,8.8c0.8,2.1,0.4,4.7,0.5,7.1
		c0.1,4.1,0,8.1,0,12.1c9.6,1,10.3,2,8.3,11.8c-2.7,0.2-5.4,0.4-8.2,0.6c0.5,1.3,1,1.8,1.6,2c9.2,3.9,12.6,8.9,12.6,18.9
		c0,11.4,0,22.8,0,34.2c0,1.4,0.1,2.8,0.2,4.4c12.6,0,24.8,0,37,0c2.6,0,5.7,0.8,6.4-3.2c0.1-0.6,1.4-1.5,2.1-1.5
		c2.7-0.1,3.3-2.1,4.2-4.1c5.9-14,11.7-28.1,17.7-42c1.3-2.9,3.8-5.3,5.5-8c1-1.5,2.2-3.2,2.4-4.9c0.7-8.1,5.8-13.2,13.9-13.3
		c0.9,0,1.9-0.1,2.8,0c3.4,0.6,5.2-0.7,6.5-4c2-5.1,4.5-10.1,7.2-15c1.3-2.4,1.4-4-0.4-6.2c-3.2-3.9-2-7.4,2.8-9.1
		c1.3-0.5,2.8-0.7,4.3-0.7c6.2,0.2,12.4,0.5,18.6,0.9c4.7,0.4,10,0,14.1,1.9c5.4,2.5,10.5,1.3,16.2,1.8c0-3.2,0.2-5.9-0.1-8.7
		c-0.1-0.8-1.1-2.1-1.9-2.3c-3.4-0.6-4.6-3.1-4.2-5.8c1.3-7,3.1-13.8,4.7-20.7c0.5-2,1.3-4,1.4-6c0.1-25.1,0.1-50.1,0.2-75.2
		c0-3.8,0.4-7.6,0.6-11.6c-16.4,0-32.2,0-47.9,0c-1.2,8.9-0.2,13.1,4.5,20.4c1.4,2.2,0.7,3.9-1.9,4c-3.2,0.1-6.4,0-9.5,0
		c-3,0-3.3-2.3-2-3.7c2-2.2,2.2-4.9,3.5-7.1c2.7-4.6,0.8-9.1,1.4-13.7c-19,0-37.4,0-56.2,0c0,5.4-0.7,10.6,0.2,15.6
		c0.9,4.6,3.6,8.9,5.8,14c-4.6,0-8.1,0.1-11.7,0c-1.1,0-2.1-0.6-3.2-0.9c0.4-1.3,0.8-2.6,1.3-3.9c1.3-3,3.5-5.9,3.9-9
		C352.8,118.8,352.3,113.5,352.3,108.1z M411.6,373.7c16.5,0,29.9-13.3,30-29.6c0-16.1-13.3-29.6-29.5-29.9
		c-16.2-0.2-30.1,13.4-30.1,29.6C381.9,360.2,395.2,373.6,411.6,373.7z M238,244.7c0,10.5-0.1,20.5,0.1,30.5
		c0.1,2.9,2.5,1.9,4.2,1.4c1.6-0.4,3.2-1.5,4.8-1.6c12-0.4,24.1-0.6,36.1-0.9c0.7,0,1.5-0.3,2.4-0.4c0-5.7,0.2-11.3-0.1-16.8
		c-0.4-7.1-5.9-12.1-13.1-12.2c-2.8,0-5.6,0-8.3-0.1C255.4,244.7,246.7,244.7,238,244.7z M85.3,338.1c-0.2,0-0.5-0.2-0.7-0.1
		c-4.1,1.4-8.2,2.9-12.4,4.2c-2.3,0.7-3.6,1.9-4.4,4.3c-1.9,5.8-7.3,8.8-13.4,8.1c-5.2-0.7-9.7-5.5-10.4-11.1
		c-0.6-5.1,3.1-10.7,8.3-12.7c1-0.4,2.4-1,2.7-1.8c1.9-5.1,3.6-10.3,5.3-15.5c-11.3-2.5-24.3,4.1-30,14.8c-6.4,12-4.1,26.3,5.8,35.6
		c9.7,9.2,24.2,10.7,35.6,3.8C82,361.4,88.1,348.2,85.3,338.1z M226.1,263.7c-10.8-5.8-28.4-9.9-39.3-8.3c-2.9,0.4-5.8,3.1-8,5.3
		c-1.8,1.8-2.6,4.6-3.8,6.9c-2.4,4.5-0.1,7.8,5.1,8.3c14,1.2,28.1-3,42.3,0.5C223.6,272.2,224.8,267.9,226.1,263.7z M457,240.9
		c-12.5,0-23.9-0.2-35.4,0.1c-2.3,0.1-4.9,1.5-6.7,3c-5.3,4.5-7.2,11.1-10.2,17c0.8,0.4,1,0.6,1.2,0.6c12.5,0,24.9,0.1,37.4,0
		c1.5,0,3.6-1.1,4.3-2.3C450.8,253.5,453.7,247.5,457,240.9z M374.1,355.9c-1.5-2.5-2.3-5.5-3.6-5.7c-5.8-0.8-11.8-1.2-17.7-1.1
		c-4.6,0-9.2,1.3-13.8,1.4c-17.5,0.2-35,0.1-52.5,0.1c-1.4,0-2.9,0-4.4,0c-0.1,2,0.1,3.7-0.5,5.1c-1.7,3.9,0.1,4.2,3.4,4.1
		c16.9-0.7,33.9-1.3,50.8-2C348.3,357.2,360.6,356.5,374.1,355.9z M401.7,268.4c20.5,0,40.8,0,60.5,0c0.3-4.8,0.6-9.2,0.7-13.6
		c0.1-4.6,0-9.1,0-13.5c-3.8-1.3-5.3,0.2-6.5,3.1c-1.9,4.6-4.2,9.1-6.4,13.6c-1.7,3.6-4.5,5.2-8.6,5.1c-11.3-0.2-22.5,0.2-33.8-0.2
		C403.4,262.8,402.3,264.9,401.7,268.4z M204.7,319.6c1.7,6.2,6.5,9.5,11.5,8.6c5.3-1,8.9-5.5,8.6-10.7c-0.3-5.3-4.4-9.5-9.7-9.8
		c-5-0.3-9.2,3.1-9.9,7.9c6.4,0.7,6.4,0.7,6,4.1C209.1,319.6,207.1,319.6,204.7,319.6z M69.9,340.9c4.5-1.5,9.9-3.3,15.4-5.1
		c-2.8-10.3-8.8-17.3-18.8-21.3c-1.8,5.6-3.5,10.9-4.9,15.1C64.5,333.7,67,337.1,69.9,340.9z M53.8,331.8c-6.5,2.2-9.6,7.5-8.2,13.3
		c1.3,5.5,6.7,8.9,12.8,8c4.7-0.7,8.3-4.5,8.1-8.6c-5.3,0.3-10,5.9-16.2,1.4C51.4,341.4,52.5,336.8,53.8,331.8z M98.6,293.5
		c-5.1,3.6-3.5,7.8-1.9,11.9c3.9,10.2,4.5,10.9,9.7,11.2C103.7,308.9,101.2,301.3,98.6,293.5z M126.1,303.7c0.4,0,0.9,0,1.3-0.1
		c0.1-1.1,0.6-2.3,0.4-3.2c-2.4-9.6-4.8-19.1-7.5-28.6c-0.4-1.3-2-2.3-3.1-3.4c-0.4,0.3-0.8,0.6-1.2,0.9
		C119.3,280.7,122.7,292.2,126.1,303.7z M92,309.1c0.3-0.3,0.6-0.6,0.9-0.9c-1.7-11.7-3.3-11.1-14.9-10.4
		C83,301.9,87.5,305.5,92,309.1z M290.3,132.9c4.2,0,8.1,0,12.2,0c-1.6-3.1-3-5.9-4.6-8.9c-0.9,0-2.2,0-2.8,0
		C293.4,127.3,291.9,130,290.3,132.9z M347.9,136.2c4.2,0,8.1,0,12.2,0c-1.6-3-3.1-5.8-4.7-8.8c-0.7,0-2.1,0-2.5,0
		C351,130.6,349.5,133.2,347.9,136.2z M60.3,344.7c2.4-1.4,6.3-2.5,6.5-4.2c0.5-3.7-2.3-6.5-6-8.1C59.4,336.2,57.1,339.8,60.3,344.7
		z M406.8,130.8c5,0,9,0,12.9,0c-1.6-3-3.1-5.7-4.7-8.6c-0.7,0-2.1,0-3.3,0c-0.4,1.7-0.6,3.3-1.3,4.6
		C409.8,128.1,408.5,129,406.8,130.8z M69.9,226c-5.6,5.7-6.6,19.1-2.3,23.3C68.3,241.8,69.1,234.4,69.9,226z M258.6,131
		c-1.8-3.2-3.3-5.9-5.1-8.9c-0.7,0-2,0.1-2.5,0.1c-1.6,3.2-3,5.9-4.5,8.8C250.6,131,254.5,131,258.6,131z M470.6,201.7
		c-4.2,2.1-6.3,19.1-3.9,27.2C468.1,219.7,469.3,210.9,470.6,201.7z M216.6,356c0-1.6,0-2.9,0-4.2c-4.4,0-8.4,0-12.8,0
		C207.2,356.6,211.4,357.1,216.6,356z M238.4,278.6c-0.8,8.5,0.2,9.8,5.2,8.6c-0.4-2.9-0.9-5.7-1.3-8.6
		C241.1,278.6,239.8,278.6,238.4,278.6z M470.3,332.4c0.1,1.7,0.2,2.9,0.3,4.3c1.9,0,3.4,0,4.9,0c0-1.6,0-3,0-4.3
		C473.7,332.4,472.3,332.4,470.3,332.4z M472.7,317c4.2-1.2,4.7-2.2,3.6-6.8c-1.2,0.1-2.4,0.2-3.6,0.3
		C472.7,312.9,472.7,314.9,472.7,317z M89.7,316.7c1.5,2.7,3,5.2,4.4,7.9c1.2,2.4,2.2,4.8,3.3,7.3c0.3-0.2,0.6-0.4,1-0.5
		C93.8,319.3,92.5,317,89.7,316.7z M472.7,304.1c1.4,0,2.6,0,5.3,0c-1.7-2.9-2.9-5-4.1-7.1c-0.4,0.2-0.8,0.4-1.2,0.6
		C472.7,299.6,472.7,301.8,472.7,304.1z M451.7,322.1c-2,0.5-3.6,0.9-5.2,1.3c1.1,5,4.2,2.1,6.9,2.4
		C452.8,324.5,452.4,323.4,451.7,322.1z M219.5,356.5c0.4,0.2,0.7,0.4,1.1,0.6c1.2-1.6,2.3-3.2,4-5.6c-2.5,0.2-3.8,0.2-5.2,0.3
		C219.5,353.6,219.5,355.1,219.5,356.5z M101.6,321.5c2.2,1.6,4.4,3.1,6.6,4.7C108.1,322.6,107.2,322,101.6,321.5z"
          />
          <path
            d="M411.5,357.2c-7.5-0.1-13.1-5.8-13-13.5c0.1-7.4,6.1-13.2,13.5-13c7.2,0.2,12.9,6.1,12.8,13.3
		C424.8,351.6,419.1,357.3,411.5,357.2z M418.6,337.5c-1.6,2.8-2.9,5.3-4.5,7.5c-0.6,0.8-2.3,1.2-3.3,1c-1.8-0.5-2.4-1.8-1.2-3.6
		c1.5-2.3,2.7-4.8,4.1-7.3c-5.3-0.9-9.1,1.1-10.8,5.4c-1.6,4.2-0.1,9.2,3.6,11.6c3.9,2.5,8.8,2,12-1.3
		C421.8,347.2,422,342.4,418.6,337.5z"
          />
          <path
            d="M388.4,332.8c1.2-1.7,2.2-3.1,3.2-4.7c0.8-1.3,1.4-2.8,2-4c1.6-0.7,3.1-1.3,4.7-2.1c1.5-0.7,3-1.5,4.6-2.4
		C403.2,327.8,397,333.4,388.4,332.8z"
          />
          <path d="M393.9,362.5c-2.5-2.8-4.7-5.3-6.7-7.5c-0.4-3.2-0.8-6.6-1.2-10C393.7,347.1,397.1,354.6,393.9,362.5z" />
          <path
            d="M423.9,366.6c-3.5,1.5-6.6,2.7-9.8,4.1c-1.1-0.3-2.6-0.7-4.1-1c-1.7-0.3-3.4-0.5-5.1-0.8
		C408.2,362.4,417.1,361.2,423.9,366.6z"
          />
          <path d="M415.2,318.6c3.6,0.9,6.7,1.6,10,2.4c1.9,2.1,4.3,4.6,6.7,7.2C424.6,330.8,417.4,326.9,415.2,318.6z" />
          <path d="M437.2,339.4c0.2,3.7,0.3,6.9,0.5,10.4c-1.3,2.3-2.9,5.3-4.6,8.4C428.1,352.3,429.8,343.8,437.2,339.4z" />
          <path d="M32,333.5c7.9,3.8,9,16.7,1.9,21.9C30.4,348.3,29.7,341.2,32,333.5z" />
          <path d="M36.9,325.3c5.8-6,12.4-8.4,20.3-8.9c0.2,4.4-2.5,6.7-5.6,8.5C47.1,327.3,42.4,328.9,36.9,325.3z" />
          <path d="M82.2,345c-1.5,8-5.1,14-11.4,19c-2.6-4.2-1.7-8,0.2-11.4C73.3,348.5,76.1,344.8,82.2,345z" />
          <path d="M40.5,362.4c3.9-4,8.5-3.6,13.1-2.3c3.8,1.1,7.3,2.8,8.1,7.4C53.9,369.1,45.6,367.1,40.5,362.4z" />
          <path d="M81.3,335.2c-9,1.4-16.6-7.4-14.6-16.6C73.9,322.2,78.5,327.7,81.3,335.2z" />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const AllInventoryViewIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29"
        height="27"
        viewBox="0 0 29 27"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 11.1875H8V12.1134H5.707L8.854 15.0264L8.146 15.6819L5 12.7681V14.8912H4V11.1875ZM15.293 12.1134H13V11.1875H17V14.8912H16V12.7681L12.854 15.6819L12.146 15.0264L15.293 12.1134ZM8.853 19.3856L5.708 22.2986H8V23.2245H4V19.5208H5V21.644L8.146 18.7301L8.853 19.3856ZM12.853 18.7301L16 21.644V19.5208H17V23.2245H13V22.2986H15.293L12.146 19.3856L12.853 18.7301Z"
          fill={props.color}
        />
        <rect
          x="1"
          y="8.40625"
          width="19"
          height="17.5926"
          rx="1"
          stroke={props.color}
          strokeWidth="2"
        />
        <path
          d="M5 4.70312H21C22.6569 4.70312 24 6.04627 24 7.70313V22.2957"
          stroke={props.color}
          strokeWidth="1.5"
        />
        <path
          d="M10 1H24C26.2091 1 28 2.79086 28 5V17.6667"
          stroke={props.color}
          strokeWidth="1.5"
        />
      </svg>
    </React.Fragment>
  );
};
export const QuickReplyIcon = (props) => {
  return (
    <React.Fragment>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height="1.5em"
        width="1.5em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.921 11.9 1.353 8.62a.72.72 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"></path>
      </svg>
    </React.Fragment>
  );
};
export const WalliconLogo = () => {
  return (
    <React.Fragment>
      <svg
        width="200"
        height="124"
        viewBox="0 0 200 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1926_44010)">
          <path
            d="M31.0027 93.9373C30.6267 95.0646 30.326 96.0039 30.0252 96.9433C28.0328 103.031 26.0403 109.118 24.0102 115.205C23.7846 115.844 23.7846 115.844 23.1455 115.844C21.5666 115.844 19.9876 115.844 18.4087 115.844C17.732 115.844 17.732 115.844 17.544 115.168C15.4764 107.878 13.4087 100.588 11.341 93.2985C10.5891 90.6682 9.83727 88.0379 9.08539 85.4452C9.0478 85.2949 8.97261 85.1446 9.0478 84.9943C9.19817 84.8815 9.34855 84.9191 9.49892 84.9191C11.2658 84.9191 13.0328 84.9191 14.7997 84.9191C15.4012 84.9191 15.4012 84.9191 15.5516 85.5579C17.1305 91.6452 18.6719 97.77 20.2132 103.857C20.4764 104.909 20.7395 105.962 21.0403 107.089C21.341 106.826 21.341 106.488 21.4538 106.187C23.7094 99.3858 25.9275 92.5846 28.1455 85.7833C28.1831 85.633 28.2583 85.4827 28.2959 85.3324C28.3711 85.0694 28.5215 84.9567 28.7846 84.9567C30.326 84.9567 31.8298 84.9567 33.3711 84.9567C33.7846 84.9567 33.8598 85.1821 33.935 85.4827C34.4989 87.2488 35.1004 89.0149 35.6643 90.7809C37.3561 95.9664 39.0478 101.152 40.7771 106.337C40.8523 106.563 40.8523 106.863 41.1531 107.051C41.8673 104.271 42.5816 101.528 43.2583 98.8221C44.3861 94.4258 45.514 90.0294 46.6042 85.633C46.7546 84.9943 46.7922 84.9943 47.4313 84.9943C49.2358 84.9943 51.0403 84.9943 52.8448 84.9943C52.9576 85.2573 52.8448 85.4452 52.8072 85.633C49.9876 95.5155 47.1681 105.435 44.3485 115.318C44.1606 115.994 44.1606 115.994 43.4463 115.994C41.9049 115.994 40.326 115.994 38.7846 115.994C38.1079 115.994 38.1079 115.994 37.8824 115.318C35.7019 108.329 33.4839 101.528 31.2658 94.6888C31.1907 94.5009 31.1155 94.313 31.0027 93.9373Z"
            fill="white"
          />
          <path
            d="M160.586 95.2905C155.886 91.3826 148.743 91.3826 144.082 95.3281C141.262 97.6953 139.796 100.701 139.721 104.384C139.683 106.225 140.134 107.991 140.962 109.607C144.646 116.897 154.646 118.7 160.849 113.252C166.375 108.367 166.262 100.025 160.586 95.2905ZM152.428 111.298C148.706 111.373 145.548 108.329 145.51 104.497C145.473 100.514 148.518 97.6202 152.165 97.5075C155.962 97.3947 159.119 100.438 159.157 104.309C159.195 108.329 156.112 111.223 152.428 111.298Z"
            fill="white"
          />
          <path
            d="M76.4535 115.356C76.4535 114.153 76.4535 112.951 76.4535 111.711C76.4535 110.584 76.5662 110.734 75.476 110.771C74.3858 110.809 73.9723 110.358 73.9347 109.268C73.9347 109.081 73.9347 108.893 73.9347 108.705C73.9347 105.999 73.9347 103.294 73.9347 100.588C73.9347 100.062 73.9347 99.5363 73.8595 99.0102C73.258 95.8163 71.3031 93.8248 68.258 92.923C65.3632 92.0587 62.4685 92.3593 59.649 93.2987C58.1828 93.7872 56.8294 94.5387 55.5512 95.4781C56.3783 96.8684 57.1678 98.2212 57.9948 99.5739C58.3332 99.3484 58.5963 99.1981 58.8971 99.0478C60.7392 97.9957 62.6941 97.4321 64.8369 97.6199C65.9647 97.7327 66.9422 98.0709 67.6565 99.0102C68.2204 99.7242 68.3332 100.588 68.3332 101.49C68.3332 102.054 68.3332 102.054 67.8068 102.091C65.7016 102.242 63.5963 102.392 61.5287 102.542C60.0625 102.655 58.5963 102.956 57.2805 103.632C55.8144 104.384 54.7241 105.511 54.273 107.089C53.258 110.508 54.5738 113.853 57.8444 115.431C59.9873 116.483 62.2429 116.558 64.5362 115.994C66.3031 115.544 67.8069 114.604 69.085 113.101C69.8745 114.604 71.0399 115.393 72.5813 115.656C73.7843 115.882 74.9873 115.731 76.1903 115.769C76.4911 115.807 76.4535 115.581 76.4535 115.356ZM66.5662 110.884C65.852 111.373 65.0625 111.711 64.1978 111.861C63.8219 111.936 63.4084 111.936 63.0324 111.974C62.1677 111.936 61.3407 111.824 60.6264 111.373C59.649 110.771 59.273 109.832 59.5362 108.742C59.6865 108.028 60.1377 107.615 60.7768 107.314C61.4159 107.014 62.0926 106.939 62.7693 106.901C64.4234 106.751 66.1151 106.601 67.8068 106.45C68.3708 106.413 68.3332 106.413 68.3708 106.976C68.4459 108.517 67.9572 109.907 66.5662 110.884Z"
            fill="white"
          />
          <path
            d="M175.626 94.6518C175.927 94.6518 176.002 94.4639 176.152 94.3511C179.573 91.4954 184.912 91.6081 188.182 94.6142C189.912 96.2299 190.927 98.259 190.964 100.589C191.04 105.511 191.002 110.434 191.002 115.318C191.002 115.694 190.889 115.807 190.513 115.807C188.934 115.807 187.355 115.807 185.776 115.807C185.213 115.807 185.175 115.807 185.175 115.206C185.175 111.072 185.175 106.939 185.175 102.843C185.175 102.242 185.175 101.641 185.025 101.04C184.423 98.4469 182.092 97.1693 179.536 97.5827C177.13 97.9584 175.664 99.7245 175.626 102.204C175.588 104.797 175.626 107.352 175.626 109.945C175.626 111.749 175.626 113.515 175.626 115.318C175.626 115.732 175.551 115.844 175.1 115.844C173.558 115.807 171.979 115.844 170.438 115.844C169.686 115.844 169.799 115.844 169.799 115.131C169.799 108.592 169.799 102.054 169.799 95.516C169.799 94.8021 169.799 94.0881 169.799 93.3742C169.799 93.0736 169.874 92.9609 170.213 92.9609C171.904 92.9609 173.596 92.9609 175.25 92.9609C175.588 92.9609 175.626 93.1487 175.626 93.4118C175.626 93.7875 175.626 94.2009 175.626 94.6518Z"
            fill="white"
          />
          <path
            d="M137.207 97.432C135.967 98.3338 134.764 99.2356 133.561 100.1C133.147 100.4 133.11 100.4 132.771 99.9871C131.643 98.672 130.252 97.8829 128.561 97.5447C124.801 96.8684 121.155 99.5362 120.628 103.331C120.14 106.788 122.358 110.433 126.079 111.11C128.636 111.56 130.816 110.847 132.583 108.968C132.696 108.855 132.809 108.742 132.884 108.592C133.072 108.329 133.222 108.367 133.448 108.517C134.688 109.456 135.967 110.358 137.245 111.297C135.591 113.439 133.636 115.017 131.042 115.807C126.23 117.272 120.703 115.694 117.508 111.861C112.282 105.586 114.801 96.1544 122.546 93.2235C125.929 91.9459 129.35 91.9459 132.658 93.4865C134.425 94.3508 136.042 95.7787 137.207 97.432Z"
            fill="white"
          />
          <path
            d="M86.7162 100.363C86.7162 105.21 86.7162 110.02 86.7162 114.867C86.7162 115.055 86.7162 115.243 86.7162 115.431C86.7538 115.731 86.6411 115.844 86.3403 115.844C84.6486 115.844 82.9568 115.844 81.3027 115.844C80.9644 115.844 80.8892 115.694 80.9268 115.431C80.9268 115.28 80.9268 115.13 80.9268 114.942C80.9268 105.21 80.9268 95.5155 80.9268 85.7834C80.9268 84.7689 80.7764 84.844 81.829 84.844C83.22 84.844 84.611 84.844 86.002 84.844C86.829 84.844 86.7162 84.8064 86.7162 85.558C86.7162 88.2258 86.7162 90.9313 86.7162 93.5992C86.7162 95.8161 86.7162 98.0707 86.7162 100.363Z"
            fill="white"
          />
          <path
            d="M98.2212 100.25C98.2212 105.135 98.2212 110.02 98.2212 114.905C98.2212 115.055 98.2212 115.205 98.2212 115.393C98.2588 115.769 98.0708 115.807 97.7701 115.807C96.1535 115.807 94.4994 115.807 92.8829 115.807C92.5069 115.807 92.3566 115.694 92.3941 115.318C92.3941 115.205 92.3941 115.055 92.3941 114.942C92.3941 105.21 92.3941 95.4406 92.3941 85.7084C92.3941 84.769 92.2438 84.8442 93.2964 84.8442C94.725 84.8442 96.1535 84.8442 97.5445 84.8442C98.2964 84.8442 98.2212 84.8442 98.2212 85.5206C98.2212 90.443 98.2212 95.3278 98.2212 100.25Z"
            fill="white"
          />
          <path
            d="M109.765 104.345C109.765 107.915 109.765 111.485 109.765 115.055C109.765 115.844 109.877 115.806 109.088 115.806C107.547 115.806 106.043 115.806 104.501 115.806C103.975 115.806 103.938 115.806 103.938 115.242C103.938 107.99 103.938 100.738 103.938 93.486C103.938 92.96 103.938 92.96 104.501 92.96C106.043 92.96 107.622 92.96 109.163 92.96C109.727 92.96 109.765 92.96 109.765 93.5612C109.765 97.1309 109.765 100.738 109.765 104.345Z"
            fill="white"
          />
          <path
            d="M110.099 87.2491C110.099 89.1279 108.746 90.5182 106.903 90.5182C105.099 90.5182 103.633 89.0904 103.633 87.2867C103.633 85.4831 105.061 84.0928 106.903 84.0928C108.746 84.0928 110.099 85.4079 110.099 87.2491Z"
            fill="white"
          />
          <path
            opacity="0.5"
            d="M59.0156 52.0794L69.1284 70.7545L71.2337 65.2309L63.0006 50.0127L59.0156 52.0794Z"
            fill="white"
          />
          <path
            d="M83.5235 39.0039L89.8393 35.6973L85.4032 45.6548L74.1626 70.793H69.125L71.7566 63.9542L83.5235 39.0039Z"
            fill="white"
          />
          <path
            opacity="0.5"
            d="M102.626 70.8667L105.896 62.074L89.8438 35.6582L85.4453 45.5406L102.626 70.8667Z"
            fill="white"
          />
          <path
            d="M102.625 70.8676H111.046L115.858 60.7973L125.069 41.4458L130.933 29.0458L141.084 7.89062L122.399 17.8858L102.625 70.8676Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1926_44010"
            x="5.81562"
            y="7.89062"
            width="188.396"
            height="114.932"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3.2" />
            <feGaussianBlur stdDeviation="1.6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1926_44010"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1926_44010"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const DefaultLogo = ({ mode }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Background */}
    <circle cx="256" cy="256" r="256" fill={mode ? "#232529" : "#ffffff"} />

    {/* Outer ring */}
    <circle
      cx="256"
      cy="256"
      r="220"
      fill="none"
      stroke={mode ? "#ffffff" : "#656C89"}
      strokeWidth="14"
    />

    {/* Image placeholder — shifted up to make room for text */}
    <rect
      x="128"
      y="120"
      width="256"
      height="170"
      rx="8"
      fill={mode ? "#ffffff" : "#656C89"}
    />

    {/* Sun dot */}
    <circle cx="197" cy="162" r="21" fill={mode ? "#232529" : "#f5f6fa"} />

    {/* Mountains — adjusted to fit new rect */}
    <polygon
      points="148,288 233,163 294,239 324,197 384,288"
      fill={mode ? "#232529" : "#f5f6fa"}
    />

    {/* No Logo text — sits below image with clear gap */}
    <text
      x="256"
      y="390"
      textAnchor="middle"
      fontSize="50"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
      fill={mode ? "#ffffff" : "#656C89"}
      letterSpacing="3"
    >
      No Logo
    </text>
  </svg>
);

export const HomeImg = () => {
  return (
    <React.Fragment>
      <svg
        width="500"
        height="412"
        viewBox="0 0 500 412"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.6">
          <path
            d="M281.765 178.514L165.381 248.855L163.635 205.896L0 302.281L4.77174 305.201H131.048L235.095 364.712C236.608 365.685 241.729 365.685 243.242 364.712L281.765 178.514Z"
            fill="#4A5477"
          />
          <path
            d="M172.015 411.809H161.889L150.367 404.751L163.402 396.962L172.015 411.809Z"
            fill="#4A5477"
          />
          <path
            d="M445.983 295.588H432.483L417.004 286.217L434.345 275.751L445.983 295.588Z"
            fill="#4A5477"
          />
          <path
            d="M73.4366 246.057H59.9361L44.457 236.686L61.7982 226.22L73.4366 246.057Z"
            fill="#4A5477"
          />
          <path
            d="M434.696 229.384H425.502L415.027 222.933L426.782 215.875L434.696 229.384Z"
            fill="#4A5477"
          />
          <path
            d="M437.37 238.753H432.133L427.012 235.589L433.646 231.573L437.37 238.753Z"
            fill="#4A5477"
          />
          <path
            d="M461.928 342.562H456.691L451.57 339.52L458.204 335.504L461.928 342.562Z"
            fill="#4A5477"
          />
          <path
            d="M490.444 289.016C490.444 289.016 464.607 286.095 458.671 295.101C453.201 303.376 467.866 304.958 477.642 304.228C477.991 304.228 477.875 296.926 477.875 296.926L495.798 295.952C496.263 295.952 490.444 289.016 490.444 289.016Z"
            fill="#4A5477"
          />
          <path
            d="M17.8086 340.859L53.3056 362.278H84.2637L57.6118 316.763L17.8086 340.859Z"
            fill="#4A5477"
          />
          <path
            d="M286.188 370.796H271.524L254.648 360.695L273.503 349.256L286.188 370.796Z"
            fill="#4A5477"
          />
          <path
            d="M275.599 390.998H268.267L261.051 386.617L270.478 380.897L275.599 390.998Z"
            fill="#4A5477"
          />
          <path
            d="M142.451 378.22C132.908 386.861 157.698 386.618 167.59 385.887C167.939 385.887 167.823 378.342 167.823 378.342L186.212 377.369C186.794 377.369 180.742 370.31 180.742 370.31C180.742 370.31 151.529 369.945 142.451 378.22Z"
            fill="#4A5477"
          />
          <path
            d="M378.245 383.088C375.103 382.236 352.292 380.897 344.959 388.078C337.045 395.745 364.512 398.544 364.512 398.544C364.745 397.692 364.628 395.745 364.628 393.919C364.628 392.459 366.374 389.416 367.771 389.538L378.362 390.025C378.362 389.903 381.388 383.818 378.245 383.088Z"
            fill="#4A5477"
          />
        </g>
        <path
          d="M172.018 400.368L162.242 394.405L172.018 388.563L181.795 394.405L172.018 400.368Z"
          fill="url(#paint0_linear_1926_44029)"
        />
        <path
          d="M172.018 411.808L162.242 405.845V394.405L172.018 400.368V411.808Z"
          fill="#276E91"
        />
        <path
          d="M181.792 405.844L172.016 411.807V400.368L181.792 394.404V405.844Z"
          fill="#2D86A5"
        />
        <path
          d="M445.979 280.254L432.828 272.344L445.979 264.434L459.131 272.344L445.979 280.254Z"
          fill="url(#paint1_linear_1926_44029)"
        />
        <path
          d="M445.979 295.588L432.828 287.678V272.344L445.979 280.254V295.588Z"
          fill="#276E91"
        />
        <path
          d="M459.132 287.678L445.98 295.588V280.254L459.132 272.344V287.678Z"
          fill="#2D86A5"
        />
        <path
          d="M73.4443 230.723L60.293 222.813L73.4443 214.902L86.5957 222.813L73.4443 230.723Z"
          fill="url(#paint2_linear_1926_44029)"
        />
        <path
          d="M73.4443 246.057L60.293 238.146V222.812L73.4443 230.723V246.057Z"
          fill="#276E91"
        />
        <path
          d="M86.5967 238.146L73.4453 246.057V230.723L86.5967 222.812V238.146Z"
          fill="#2D86A5"
        />
        <path
          d="M434.696 218.917L425.734 213.562L434.696 208.086L443.657 213.562L434.696 218.917Z"
          fill="url(#paint3_linear_1926_44029)"
        />
        <path
          d="M434.696 229.383L425.734 223.907V213.562L434.696 218.917V229.383Z"
          fill="#276E91"
        />
        <path
          d="M443.657 223.907L434.695 229.383V218.917L443.657 213.562V223.907Z"
          fill="#2D86A5"
        />
        <path
          d="M437.375 232.789L432.254 229.747L437.375 226.704L442.379 229.747L437.375 232.789Z"
          fill="url(#paint4_linear_1926_44029)"
        />
        <path
          d="M437.375 238.752L432.254 235.588V229.746L437.375 232.789V238.752Z"
          fill="#276E91"
        />
        <path
          d="M442.376 235.588L437.371 238.752V232.789L442.376 229.746V235.588Z"
          fill="#2D86A5"
        />
        <path
          d="M461.92 337.085L457.148 334.164L461.92 331.243L466.576 334.164L461.92 337.085Z"
          fill="url(#paint5_linear_1926_44029)"
        />
        <path
          d="M461.92 342.561L457.148 339.762V334.164L461.92 337.085V342.561Z"
          fill="#276E91"
        />
        <path
          d="M466.577 339.762L461.922 342.561V337.085L466.577 334.164V339.762Z"
          fill="#2D86A5"
        />
        <path
          d="M481.591 304.96C481.358 303.864 480.776 302.891 480.195 301.917L475.656 301.309C472.513 301.795 469.604 302.404 466.578 302.891C465.181 303.134 464.366 303.012 464.25 303.986C464.25 304.108 464.25 305.203 464.25 305.325C464.25 306.177 464.948 307.028 466.461 307.15C471 307.637 475.19 307.637 479.613 307.759C480.776 307.759 481.591 307.393 481.708 306.42C481.591 306.42 481.591 304.96 481.591 304.96Z"
          fill="#276E91"
        />
        <path
          d="M499.51 293.885C499.277 293.155 498.812 292.546 498.23 292.059C495.786 289.869 494.739 289.139 493.807 288.408C491.014 286.218 488.221 286.218 487.988 288.287C487.988 288.287 487.988 289.382 487.988 289.504C487.988 289.869 488.105 290.112 488.221 290.477C488.803 291.938 494.506 297.536 495.437 298.266C495.67 298.509 496.019 298.631 496.368 298.631C497.532 298.875 501.256 298.875 499.51 293.885Z"
          fill="#276E91"
        />
        <path
          d="M481.472 304.229C481.239 303.134 480.89 301.795 480.191 300.822L475.652 300.578C472.51 301.065 469.601 300.822 466.458 301.308C463.781 301.673 462.967 305.689 466.342 306.055C470.881 306.541 475.071 306.541 479.493 306.663C481.122 306.785 481.937 306.176 481.472 304.229Z"
          fill="white"
        />
        <path
          d="M499.511 292.667C499.278 291.937 498.813 291.329 498.231 290.842C495.787 288.651 494.739 287.921 493.808 287.191C490.549 284.514 487.174 286.583 488.222 289.26C488.804 290.72 494.506 296.318 495.438 297.049C495.67 297.292 496.019 297.414 496.369 297.414C497.532 297.535 501.257 297.535 499.511 292.667Z"
          fill="white"
        />
        <path
          d="M487.872 245.327C483.915 241.919 480.424 243.502 478.096 247.761C476.932 249.83 476.118 254.333 475.768 255.793C474.605 261.148 474.372 266.868 474.372 272.344C474.372 275.143 474.488 277.942 474.488 280.863C474.605 285.852 473.906 296.319 473.906 301.308C473.906 303.62 480.424 304.229 481.122 301.917C481.588 294.615 483.566 287.313 483.45 282.567C483.45 280.985 483.101 279.402 483.101 277.82C483.101 275.265 484.032 272.952 484.846 270.519C486.476 265.894 487.872 261.269 488.92 256.523C489.851 252.872 491.247 248.126 487.872 245.327Z"
          fill="#2035A4"
        />
        <path
          d="M497.415 273.926C497.066 273.317 496.95 272.709 496.833 272.222C496.251 270.64 496.018 269.058 496.135 267.476C496.6 262.121 498.579 253.359 493.807 244.597C487.406 241.311 485.428 245.814 485.777 254.697C486.359 261.269 487.057 267.963 489.617 273.926C489.967 274.778 490.316 275.63 490.548 276.481C490.665 277.09 490.781 277.82 490.898 278.429C491.13 280.741 492.411 286.826 493.924 293.154C494.505 295.345 499.976 294.858 499.976 292.789C500.092 291.815 499.51 285.852 499.394 285C499.044 279.524 498.695 276.603 497.415 273.926Z"
          fill="#2035A4"
        />
        <path
          d="M489.155 221.839C489.039 221.961 487.06 224.395 486.827 224.395C486.595 224.395 481.357 221.352 479.146 219.283C479.03 219.892 479.146 222.447 478.797 222.934C481.008 225.368 486.595 231.088 488.573 230.601C489.155 230.479 492.065 228.167 492.647 227.802C492.763 227.68 492.879 227.68 492.879 227.559C492.879 227.315 489.155 221.961 489.155 221.839Z"
          fill="#FCBE9F"
        />
        <path
          d="M479.964 220.256C479.033 217.214 477.753 216.727 474.843 215.875C474.377 217.214 472.399 219.161 472.748 220.986C473.097 222.69 477.52 221.595 478.916 222.69C478.916 222.69 479.149 222.934 479.498 223.299C479.964 223.299 480.429 221.595 479.964 220.256Z"
          fill="#FCBE9F"
        />
        <path
          d="M472.279 210.4L457.615 219.284C457.149 219.527 456.917 220.379 457.266 220.988L463.318 233.279C463.667 233.888 464.249 234.131 464.714 234.009L464.947 233.888L472.512 210.278L472.279 210.4Z"
          fill="white"
        />
        <path
          d="M479.73 223.544L473.562 210.887C473.329 210.4 472.864 210.157 472.514 210.4L457.966 219.162C457.501 219.406 457.268 220.258 457.617 220.866L463.669 233.158C464.018 233.766 464.717 234.131 465.182 233.766L479.497 225.126C479.847 225.004 479.963 224.152 479.73 223.544Z"
          fill="#3046B2"
        />
        <path
          d="M461.692 234.008C462.507 234.738 463.787 232.669 463.438 231.696C463.322 231.453 461.459 228.897 460.296 226.95L458.783 223.907C458.317 225.246 457.386 227.436 457.619 229.14C457.852 230.722 459.365 232.426 461.692 234.008Z"
          fill="#FCBE9F"
        />
        <path
          d="M471.347 232.548C471.231 232.67 469.253 235.104 469.02 235.104C468.787 235.104 463.899 232.061 463.201 231.696C462.502 231.209 460.989 233.156 461.688 234.13C463.317 236.077 468.438 242.04 470.882 241.432C471.464 241.31 474.373 238.998 474.955 238.633C475.072 238.511 475.188 238.511 475.188 238.389C475.072 238.024 471.347 232.67 471.347 232.548Z"
          fill="#FCBE9F"
        />
        <path
          d="M480.779 223.178C479.033 224.03 476.822 224.517 476.356 226.464C476.007 227.681 476.473 228.898 476.938 230.115C479.033 236.686 479.149 240.702 477.869 247.883C477.171 251.29 495.094 252.385 494.629 245.205C493.697 234.618 496.374 232.427 498.004 226.707C498.353 225.612 498.469 224.517 498.586 223.421C498.818 217.823 495.56 214.902 491.253 217.458C487.529 219.527 484.852 221.231 480.779 223.178Z"
          fill="white"
        />
        <path
          d="M475.772 225.977C474.725 226.951 471.117 231.94 470.302 233.157C469.022 234.861 473.677 240.094 475.307 238.999C477.751 237.417 481.475 233.887 482.057 229.628C482.406 226.829 479.962 222.083 475.772 225.977Z"
          fill="white"
        />
        <path
          d="M460.408 229.262C461.106 229.992 461.455 230.844 461.921 231.696C461.921 231.574 461.921 231.452 462.037 231.331C462.27 229.992 461.804 229.627 462.153 227.801C462.27 227.193 463.201 224.759 461.921 224.759C461.455 224.759 461.222 225.489 461.106 225.854C460.99 226.341 460.873 226.828 460.757 227.314C460.641 227.923 460.408 228.41 460.059 228.897C460.291 229.14 460.291 229.14 460.408 229.262Z"
          fill="#FCBE9F"
        />
        <path
          d="M478.797 219.405V219.284C478.565 219.162 478.448 219.162 478.215 219.04C477.75 218.797 477.401 218.432 476.935 218.31C476.586 218.188 475.888 217.823 475.539 218.188C474.724 219.162 477.052 220.136 477.517 220.379C478.914 221.109 479.03 221.718 479.728 222.326C479.496 221.353 479.147 220.379 478.797 219.405Z"
          fill="#FCBE9F"
        />
        <path
          d="M485.312 208.816L485.08 209.06L480.773 207.112L481.006 206.504L485.312 208.816Z"
          fill="#2035A4"
        />
        <path
          d="M482.171 205.044C481.59 205.896 481.357 206.748 481.124 207.721C481.008 208.086 481.008 208.33 480.775 208.573C480.542 208.816 479.378 209.668 479.262 210.033C479.145 210.277 479.727 211.007 479.727 211.007C479.727 211.007 478.68 214.901 478.913 215.632C479.145 216.483 479.844 216.483 480.542 216.97C481.24 217.457 481.59 218.431 481.59 219.283C481.59 220.134 482.055 222.082 481.939 222.933C481.939 223.055 481.939 223.177 481.939 223.299C482.288 224.029 487.991 223.542 489.969 221.351C490.435 220.865 490.435 220.499 490.318 219.891C489.969 218.917 489.62 218.066 489.62 217.092C489.62 216.118 491.017 217.335 491.715 216.605C492.646 215.51 493.577 214.415 494.159 213.076C494.857 211.494 494.974 209.79 494.624 208.086C494.275 206.383 493.344 204.922 491.948 204.07C490.551 203.097 488.805 202.853 487.176 202.853C485.197 202.61 483.219 203.34 482.171 205.044Z"
          fill="#FCBE9F"
        />
        <path
          d="M495.091 208.087C495.091 207.965 495.091 207.965 495.091 208.087C495.091 206.748 494.625 205.531 493.694 204.923C493.112 204.436 492.414 204.314 491.832 203.949C490.552 203.34 489.504 202.245 488.108 201.88C484.5 200.907 482.405 202.489 481.939 204.923C481.474 206.87 484.034 207.843 483.918 210.399C483.918 211.373 483.452 212.224 483.22 213.076C483.22 213.32 483.22 213.563 483.336 213.685C483.452 213.807 483.685 213.685 483.802 213.563C484.034 213.32 484.151 212.955 484.5 212.711C484.965 212.346 485.547 212.59 485.78 213.076C486.362 214.172 485.664 215.267 484.849 216.119C484.616 216.362 484.616 216.727 484.849 216.971C485.664 217.944 487.06 218.431 488.573 218.309C489.504 218.309 490.435 217.823 491.134 217.092C492.065 216.119 493.112 214.902 493.927 213.076C494.625 211.494 495.091 209.669 495.091 208.087Z"
          fill="#455FDC"
        />
        <path
          d="M485.317 211.981L485.084 212.225L480.895 210.277L481.011 209.669L485.317 211.981Z"
          fill="#2035A4"
        />
        <path
          d="M481.008 209.912C481.008 209.791 481.125 209.669 481.125 209.547C481.125 209.426 481.125 209.304 481.125 209.304V208.209C481.125 208.209 481.125 208.209 481.008 208.33V208.209C481.008 208.087 481.008 207.965 481.008 207.965C481.008 207.844 481.008 207.844 481.008 207.965C481.008 207.965 481.008 207.965 481.008 207.844C481.008 207.722 481.008 207.6 481.008 207.6V206.505H480.892L480.426 207.965C480.31 208.209 480.31 208.452 480.194 208.695C480.194 208.817 480.194 208.939 480.077 208.939C480.077 209.061 480.077 209.182 480.077 209.182V209.304L480.194 209.182C480.194 209.182 480.194 209.061 480.194 208.939C480.194 208.817 480.194 208.817 480.31 208.695C480.31 208.452 480.426 208.209 480.543 208.087C480.543 207.965 480.659 207.844 480.659 207.722C480.659 207.6 480.776 207.478 480.776 207.357V207.235C480.776 207.357 480.776 207.844 480.776 207.844C480.776 207.844 480.776 207.965 480.776 208.087C480.776 208.209 480.776 208.33 480.659 208.452C480.543 208.695 480.543 208.939 480.426 209.182C480.543 209.061 480.543 209.061 480.543 209.061C480.543 208.939 480.659 208.939 480.659 208.817V208.695C480.659 208.817 480.659 208.939 480.659 209.061L480.31 210.034C480.194 210.278 480.194 210.521 480.077 210.764C480.077 210.886 480.077 211.008 479.961 211.008C479.961 211.129 479.961 211.251 479.961 211.251V211.981L480.077 212.103C480.077 212.103 480.194 211.86 480.31 211.616L481.008 209.912ZM480.543 210.399C480.543 210.399 480.543 210.278 480.543 210.156C480.543 210.034 480.659 209.912 480.659 209.912L481.008 208.817V209.791L480.659 211.008C480.659 211.129 480.543 211.129 480.543 211.251V210.399Z"
          fill="#2035A4"
        />
        <path
          d="M484.037 212.711C483.571 212.346 482.408 212.346 481.942 213.077C481.709 213.563 481.477 214.05 481.477 214.659L482.64 216.241C484.386 215.876 484.968 213.563 484.037 212.711Z"
          fill="#FCBE9F"
        />
        <path
          d="M258.946 23.8357C258.248 23.714 257.55 23.8357 256.851 24.2008L84.3706 128.374C82.3921 129.591 81.2283 132.634 81.9266 135.311L117.656 287.434C118.006 289.138 119.053 290.233 120.217 290.476L121.381 290.72C120.217 290.476 119.169 289.381 118.82 287.677L83.0904 135.555C82.5085 132.877 83.5559 129.835 85.5345 128.618L258.015 24.5659C258.713 24.0791 259.528 23.9574 260.11 24.2008L258.946 23.8357Z"
          fill="url(#paint6_linear_1926_44029)"
        />
        <path
          d="M298.518 179.366L262.788 27.2436C262.206 24.5663 259.995 23.471 258.016 24.688L85.6519 128.74C83.6734 129.957 82.5095 132.999 83.2078 135.677L118.938 287.799C119.52 290.477 121.731 291.572 123.709 290.355L296.074 186.303C298.052 185.086 299.1 181.922 298.518 179.366Z"
          fill="url(#paint7_linear_1926_44029)"
        />
        <path
          d="M298.518 179.366L262.788 27.2436C262.206 24.5663 259.995 23.471 258.016 24.688L85.6519 128.74C83.6734 129.957 82.5095 132.999 83.2078 135.677L118.938 287.799C119.52 290.477 121.731 291.572 123.709 290.355L296.074 186.303C298.052 185.086 299.1 181.922 298.518 179.366Z"
          fill="#2035A4"
        />
        <path
          d="M122.082 288.408V293.154C122.082 294.006 122.548 294.736 123.595 295.345L238 364.469C239.979 365.686 243.237 365.686 245.216 364.469L416.533 260.417C417.464 259.809 418.046 259.079 418.046 258.227V256.645L122.082 288.408Z"
          fill="url(#paint8_linear_1926_44029)"
        />
        <path
          d="M416.418 254.332L302.013 182.044C300.034 180.827 296.775 180.827 294.797 182.044L123.48 286.096C121.501 287.313 121.501 289.26 123.48 290.477L237.885 362.765C239.864 363.982 243.122 363.982 245.101 362.765L416.418 258.713C418.513 257.496 418.396 255.549 416.418 254.332Z"
          fill="#FFF7F5"
        />
        <path
          d="M282.227 205.531C282.227 205.409 282.227 205.287 282.227 205.287C282.227 205.166 282.227 205.044 282.227 205.044C282.11 204.679 282.343 204.314 282.809 204.07L290.723 199.324C291.537 198.837 292.701 198.837 293.516 199.324L300.15 203.34C300.615 203.584 300.732 203.949 300.732 204.314C300.732 204.435 300.732 204.557 300.732 204.557C300.732 204.679 300.732 204.8 300.732 204.8C300.848 205.166 300.615 205.531 300.15 205.774L292.236 210.52C291.421 211.007 290.257 211.007 289.442 210.52L282.809 206.504C282.227 206.261 282.11 205.896 282.227 205.531ZM295.494 198.837L302.128 202.853C302.943 203.34 304.107 203.34 304.921 202.853L312.836 198.107C313.301 197.864 313.418 197.499 313.418 197.134C313.418 197.012 313.418 196.89 313.418 196.89C313.418 196.768 313.418 196.647 313.418 196.647C313.534 196.282 313.301 195.917 312.836 195.673L306.202 191.657C305.387 191.17 304.223 191.17 303.409 191.657L295.494 196.403C295.029 196.647 294.913 197.012 294.913 197.377C294.913 197.499 294.913 197.62 294.913 197.62C294.913 197.742 294.913 197.864 294.913 197.864C294.796 198.107 295.029 198.472 295.494 198.837ZM270.006 214.171L276.64 218.187C277.455 218.674 278.619 218.674 279.433 218.187L287.348 213.441C287.813 213.198 287.929 212.833 287.929 212.467C287.929 212.346 287.929 212.224 287.929 212.224C287.929 212.102 287.929 211.981 287.929 211.981C288.046 211.616 287.813 211.25 287.348 211.007L280.714 206.991C279.899 206.504 278.735 206.504 277.92 206.991L270.006 211.737C269.541 211.981 269.424 212.346 269.424 212.711C269.424 212.833 269.424 212.954 269.424 212.954C269.424 213.076 269.424 213.198 269.424 213.198C269.424 213.563 269.541 213.928 270.006 214.171ZM174.223 300.09L180.856 304.106C181.671 304.593 182.835 304.593 183.65 304.106L191.564 299.36C192.029 299.117 192.146 298.752 192.146 298.386C192.146 298.265 192.146 298.143 192.146 298.143C192.146 298.021 192.146 297.9 192.146 297.9C192.262 297.534 192.029 297.169 191.564 296.926L184.93 292.91C184.115 292.423 182.951 292.423 182.137 292.91L174.223 297.535C173.757 297.778 173.641 298.143 173.641 298.508C173.641 298.63 173.641 298.751 173.641 298.751C173.641 298.873 173.641 298.995 173.641 298.995C173.641 299.482 173.757 299.847 174.223 300.09ZM202.038 255.184L208.672 259.2C209.487 259.686 210.651 259.686 211.465 259.2L219.379 254.453C219.845 254.21 219.961 253.845 219.961 253.48C219.961 253.358 219.961 253.236 219.961 253.236C219.961 253.115 219.961 252.993 219.961 252.993C220.078 252.628 219.845 252.263 219.379 252.019L212.746 248.003C211.931 247.517 210.767 247.517 209.952 248.003L202.038 252.75C201.573 252.993 201.456 253.358 201.456 253.723C201.456 253.845 201.456 253.967 201.456 253.967C201.456 254.088 201.456 254.21 201.456 254.21C201.456 254.453 201.573 254.818 202.038 255.184ZM227.526 239.728L234.16 243.744C234.975 244.231 236.139 244.231 236.953 243.744L244.867 238.998C245.333 238.754 245.449 238.389 245.449 238.024C245.449 237.902 245.449 237.781 245.449 237.781C245.449 237.659 245.449 237.537 245.449 237.537C245.566 237.172 245.333 236.807 244.867 236.564L238.234 232.548C237.419 232.061 236.255 232.061 235.44 232.548L227.526 237.294C227.061 237.537 226.944 237.902 226.944 238.267C226.944 238.389 226.944 238.511 226.944 238.511C226.944 238.633 226.944 238.754 226.944 238.754C226.828 239.119 227.061 239.484 227.526 239.728ZM252.898 224.394L259.532 228.41C260.347 228.897 261.51 228.897 262.325 228.41L274.313 221.23C274.778 220.986 274.894 220.621 274.894 220.256C274.894 220.134 274.894 220.013 274.894 220.013C274.894 219.891 274.894 219.769 274.894 219.769C275.011 219.404 274.778 219.039 274.313 218.796L267.679 214.78C266.864 214.293 265.7 214.293 264.885 214.78L252.898 221.96C252.432 222.203 252.316 222.568 252.316 222.934C252.316 223.055 252.316 223.177 252.316 223.177C252.316 223.299 252.316 223.42 252.316 223.42C252.316 223.785 252.549 224.15 252.898 224.394ZM240.212 232.061L246.846 236.077C247.661 236.564 248.825 236.564 249.639 236.077L257.553 231.331C258.019 231.087 258.135 230.722 258.135 230.357C258.135 230.235 258.135 230.114 258.135 230.114C258.135 229.992 258.135 229.87 258.135 229.87C258.252 229.505 258.019 229.14 257.553 228.897L250.919 224.881C250.105 224.394 248.941 224.394 248.126 224.881L240.212 229.627C239.747 229.87 239.63 230.235 239.63 230.601C239.63 230.722 239.63 230.844 239.63 230.844C239.63 230.966 239.63 231.087 239.63 231.087C239.63 231.452 239.747 231.817 240.212 232.061ZM214.724 247.395L221.358 251.411C222.173 251.898 223.336 251.898 224.151 251.411L232.065 246.665C232.531 246.421 232.647 246.056 232.647 245.691C232.647 245.569 232.647 245.448 232.647 245.448C232.647 245.326 232.647 245.204 232.647 245.204C232.764 244.839 232.531 244.474 232.065 244.231L225.431 240.215C224.617 239.728 223.453 239.728 222.638 240.215L214.724 244.961C214.259 245.204 214.142 245.569 214.142 245.934C214.142 246.056 214.142 246.178 214.142 246.178C214.142 246.3 214.142 246.421 214.142 246.421C214.142 246.786 214.259 247.151 214.724 247.395ZM268.843 229.018L275.476 233.034C276.291 233.521 277.455 233.521 278.27 233.034L286.184 228.288C286.649 228.045 286.766 227.68 286.766 227.315C286.766 227.193 286.766 227.071 286.766 227.071C286.766 226.95 286.766 226.828 286.766 226.828C286.882 226.463 286.649 226.098 286.184 225.854L279.55 221.838C278.735 221.351 277.571 221.351 276.757 221.838L268.843 226.584C268.377 226.828 268.261 227.193 268.261 227.558C268.261 227.68 268.261 227.801 268.261 227.801C268.261 227.923 268.261 228.045 268.261 228.045C268.261 228.288 268.493 228.653 268.843 229.018ZM167.123 290.476L173.757 294.492C174.572 294.979 175.736 294.979 176.55 294.492L184.464 289.746C184.93 289.502 185.046 289.137 185.046 288.772C185.046 288.651 185.046 288.529 185.046 288.529C185.046 288.407 185.046 288.285 185.046 288.285C185.163 287.92 184.93 287.555 184.464 287.312L177.83 283.296C177.016 282.809 175.852 282.809 175.037 283.296L167.123 288.042C166.658 288.285 166.541 288.651 166.541 289.016C166.541 289.137 166.541 289.259 166.541 289.259C166.541 289.381 166.541 289.502 166.541 289.502C166.541 289.868 166.658 290.233 167.123 290.476ZM256.157 236.685L262.791 240.701C263.605 241.188 264.769 241.188 265.584 240.701L273.498 235.955C273.963 235.712 274.08 235.347 274.08 234.982C274.08 234.86 274.08 234.738 274.08 234.738C274.08 234.617 274.08 234.495 274.08 234.495C274.196 234.13 273.963 233.765 273.498 233.521L266.864 229.505C266.049 229.018 264.886 229.018 264.071 229.505L256.157 234.251C255.691 234.495 255.575 234.86 255.575 235.225C255.575 235.347 255.575 235.468 255.575 235.468C255.575 235.59 255.575 235.712 255.575 235.712C255.575 236.077 255.691 236.442 256.157 236.685ZM243.471 244.352L250.105 248.368C250.919 248.855 252.083 248.855 252.898 248.368L260.812 243.622C261.278 243.379 261.394 243.014 261.394 242.649C261.394 242.527 261.394 242.405 261.394 242.405C261.394 242.284 261.394 242.162 261.394 242.162C261.51 241.797 261.278 241.432 260.812 241.188L254.178 237.172C253.364 236.685 252.2 236.685 251.385 237.172L243.471 241.918C243.005 242.162 242.889 242.527 242.889 242.892C242.889 243.014 242.889 243.135 242.889 243.135C242.889 243.257 242.889 243.379 242.889 243.379C242.889 243.744 243.005 244.109 243.471 244.352ZM230.669 252.019L237.303 256.035C238.117 256.522 239.281 256.522 240.096 256.035L248.01 251.289C248.475 251.046 248.592 250.681 248.592 250.316C248.592 250.194 248.592 250.072 248.592 250.072C248.592 249.951 248.592 249.829 248.592 249.829C248.708 249.464 248.475 249.099 248.01 248.855L241.376 244.839C240.561 244.352 239.397 244.352 238.583 244.839L230.669 249.585C230.203 249.829 230.087 250.194 230.087 250.559C230.087 250.681 230.087 250.802 230.087 250.802C230.087 250.924 230.087 251.046 230.087 251.046C230.087 251.411 230.32 251.776 230.669 252.019ZM179.809 282.809L186.443 286.825C187.258 287.312 188.421 287.312 189.236 286.825L197.15 282.079C197.616 281.835 197.732 281.47 197.732 281.105C197.732 280.984 197.732 280.862 197.732 280.862C197.732 280.74 197.732 280.618 197.732 280.618C197.848 280.253 197.616 279.888 197.15 279.645L190.516 275.629C189.702 275.142 188.538 275.142 187.723 275.629L179.809 280.375C179.343 280.618 179.227 280.984 179.227 281.349C179.227 281.47 179.227 281.592 179.227 281.592C179.227 281.714 179.227 281.835 179.227 281.835C179.227 282.079 179.343 282.444 179.809 282.809ZM192.495 275.142L199.129 279.158C199.943 279.645 201.107 279.645 201.922 279.158L209.836 274.412C210.302 274.168 210.418 273.803 210.418 273.438C210.418 273.317 210.418 273.195 210.418 273.195C210.418 273.073 210.418 272.951 210.418 272.951C210.534 272.586 210.302 272.221 209.836 271.978C200.06 266.015 203.435 266.136 192.495 272.708C192.029 272.951 191.913 273.317 191.913 273.682C191.913 273.803 191.913 273.925 191.913 273.925C191.913 274.047 191.913 274.168 191.913 274.168C191.913 274.412 192.146 274.777 192.495 275.142ZM205.297 267.353L211.931 271.369C212.746 271.856 213.909 271.856 214.724 271.369L222.638 266.623C223.104 266.38 223.22 266.015 223.22 265.65C223.22 265.528 223.22 265.406 223.22 265.406C223.22 265.284 223.22 265.163 223.22 265.163C223.337 264.798 223.104 264.433 222.638 264.189L216.004 260.173C215.19 259.686 214.026 259.686 213.211 260.173L205.297 264.919C204.831 265.163 204.715 265.528 204.715 265.893C204.715 266.015 204.715 266.136 204.715 266.136C204.715 266.258 204.715 266.38 204.715 266.38C204.715 266.745 204.831 267.11 205.297 267.353ZM217.983 259.686C224.5 263.702 225.664 264.798 227.41 263.824L235.324 259.078C235.79 258.834 235.906 258.469 235.906 258.104C235.906 257.983 235.906 257.861 235.906 257.861C235.906 257.739 235.906 257.618 235.906 257.618C236.022 257.252 235.79 256.887 235.324 256.644L228.69 252.628C227.875 252.141 226.712 252.141 225.897 252.628L217.983 257.374C217.517 257.618 217.401 257.983 217.401 258.348C217.401 258.469 217.401 258.591 217.401 258.591C217.401 258.713 217.401 258.834 217.401 258.834C217.401 259.078 217.517 259.443 217.983 259.686ZM195.288 310.678C195.288 310.556 195.288 310.435 195.288 310.435C195.288 310.313 195.288 310.191 195.288 310.191C195.404 309.826 195.172 309.461 194.706 309.218L188.072 305.201C187.258 304.715 186.094 304.715 185.279 305.201L173.292 312.382C172.826 312.625 172.71 312.99 172.71 313.355C172.71 313.477 172.71 313.599 172.71 313.599C172.71 313.72 172.71 313.842 172.71 313.842C172.593 314.207 172.826 314.572 173.292 314.816L179.925 318.832C180.74 319.318 181.904 319.318 182.719 318.832L194.706 311.651C195.172 311.408 195.404 311.043 195.288 310.678ZM179.343 306.053C179.343 305.932 179.343 305.81 179.343 305.81C179.343 305.688 179.343 305.567 179.343 305.567C179.46 305.201 179.227 304.836 178.762 304.593L172.128 300.577C171.313 300.09 170.149 300.09 169.334 300.577L161.42 305.323C160.955 305.567 160.838 305.932 160.838 306.297C160.838 306.418 160.838 306.54 160.838 306.54C160.838 306.662 160.838 306.784 160.838 306.784C160.722 307.149 160.955 307.514 161.42 307.757L168.054 311.773C168.869 312.26 170.033 312.26 170.847 311.773L178.762 307.027C179.227 306.784 179.46 306.418 179.343 306.053ZM189.352 262.851C198.896 268.692 195.637 268.814 206.694 262.12C207.159 261.877 207.276 261.512 207.276 261.147C207.276 261.025 207.276 260.903 207.276 260.903C207.276 260.782 207.276 260.66 207.276 260.66C207.392 260.295 207.159 259.93 206.694 259.686L200.06 255.67C199.245 255.184 198.081 255.184 197.267 255.67L189.352 260.417C188.887 260.66 188.771 261.025 188.771 261.39C188.771 261.512 188.771 261.634 188.771 261.634C188.771 261.755 188.771 261.877 188.771 261.877C188.654 262.12 188.887 262.485 189.352 262.851ZM322.612 233.886C322.612 233.765 322.612 233.643 322.612 233.643C322.612 233.521 322.612 233.4 322.612 233.4C322.728 233.034 322.495 232.669 322.03 232.426L315.396 228.41C314.581 227.923 313.417 227.923 312.603 228.41L304.689 233.156C304.223 233.4 304.107 233.765 304.107 234.13C304.107 234.251 304.107 234.373 304.107 234.373C304.107 234.495 304.107 234.617 304.107 234.617C303.99 234.982 304.223 235.347 304.689 235.59L311.323 239.606C312.137 240.093 313.301 240.093 314.116 239.606L322.03 234.86C322.612 234.617 322.728 234.251 322.612 233.886ZM172.128 296.439C172.128 296.318 172.128 296.196 172.128 296.196C172.128 296.074 172.128 295.952 172.128 295.952C172.244 295.587 172.011 295.222 171.546 294.979L164.912 290.963C164.097 290.476 162.933 290.476 162.119 290.963L150.131 298.143C149.666 298.386 149.549 298.751 149.549 299.117C149.549 299.238 149.549 299.36 149.549 299.36C149.549 299.482 149.549 299.603 149.549 299.603C149.433 299.968 149.666 300.334 150.131 300.577L156.765 304.593C157.58 305.08 158.744 305.08 159.558 304.593L171.546 297.413C172.128 297.169 172.244 296.804 172.128 296.439ZM176.55 270.517L183.184 274.534C183.999 275.02 185.163 275.02 185.977 274.534L193.891 269.787C194.357 269.544 194.473 269.179 194.473 268.814C194.473 268.692 194.473 268.57 194.473 268.57C194.473 268.449 194.473 268.327 194.473 268.327C194.59 267.962 194.357 267.597 193.891 267.353L187.258 263.337C186.443 262.851 185.279 262.851 184.464 263.337L176.55 268.084C176.085 268.327 175.968 268.692 175.968 269.057C175.968 269.179 175.968 269.301 175.968 269.301C175.968 269.422 175.968 269.544 175.968 269.544C175.968 269.909 176.085 270.274 176.55 270.517ZM163.864 278.185L170.498 282.201C171.313 282.687 172.477 282.687 173.292 282.201L181.206 277.454C181.671 277.211 181.788 276.846 181.788 276.481C181.788 276.359 181.788 276.237 181.788 276.237C181.788 276.116 181.788 275.994 181.788 275.994C181.904 275.629 181.671 275.264 181.206 275.02L174.572 271.004C173.757 270.518 172.593 270.518 171.779 271.004L163.864 275.751C163.399 275.994 163.283 276.359 163.283 276.724C163.283 276.846 163.283 276.968 163.283 276.968C163.283 277.089 163.283 277.211 163.283 277.211C163.283 277.576 163.399 277.941 163.864 278.185ZM156.183 291.936C156.183 291.815 156.183 291.693 156.183 291.693C156.183 291.571 156.183 291.45 156.183 291.45C156.299 291.085 156.067 290.719 155.601 290.476L148.967 286.46C148.153 285.973 146.989 285.973 146.174 286.46L138.26 291.206C137.794 291.45 137.678 291.815 137.678 292.18C137.678 292.301 137.678 292.423 137.678 292.423C137.678 292.545 137.678 292.667 137.678 292.667C137.562 293.032 137.794 293.397 138.26 293.64L144.894 297.656C145.709 298.143 146.872 298.143 147.687 297.656L155.601 292.91C156.183 292.667 156.299 292.301 156.183 291.936ZM151.179 285.851L157.812 289.868C158.627 290.354 159.791 290.354 160.606 289.868L168.52 285.121C168.985 284.878 169.102 284.513 169.102 284.148C169.102 284.026 169.102 283.904 169.102 283.904C169.102 283.783 169.102 283.661 169.102 283.661C169.218 283.296 168.985 282.931 168.52 282.687L161.886 278.671C161.071 278.184 159.907 278.184 159.093 278.671L151.179 283.418C150.713 283.661 150.597 284.026 150.597 284.391C150.597 284.513 150.597 284.634 150.597 284.634C150.597 284.756 150.597 284.878 150.597 284.878C150.48 285.243 150.713 285.608 151.179 285.851ZM359.738 225.124C359.855 224.759 359.622 224.394 359.156 224.15L352.522 220.134C351.708 219.648 350.544 219.648 349.729 220.134L341.815 224.881C341.35 225.124 341.233 225.489 341.233 225.854C341.233 225.976 341.233 226.098 341.233 226.098C341.233 226.219 341.233 226.341 341.233 226.341C341.117 226.706 341.35 227.071 341.815 227.315L348.449 231.331C349.264 231.817 350.428 231.817 351.242 231.331L359.156 226.584C359.622 226.341 359.738 225.976 359.738 225.611C359.738 225.489 359.738 225.367 359.738 225.367C359.738 225.367 359.738 225.246 359.738 225.124ZM309.344 239.971L302.71 235.955C301.896 235.468 300.732 235.468 299.917 235.955L292.003 240.701C291.537 240.945 291.421 241.31 291.421 241.675C291.421 241.797 291.421 241.918 291.421 241.918C291.421 242.04 291.421 242.162 291.421 242.162C291.305 242.527 291.537 242.892 292.003 243.135L298.637 247.151C299.451 247.638 300.615 247.638 301.43 247.151L309.344 242.405C309.81 242.162 309.926 241.797 309.926 241.432C309.926 241.31 309.926 241.188 309.926 241.188C309.926 241.067 309.926 240.945 309.926 240.945C309.926 240.58 309.693 240.215 309.344 239.971ZM334.832 224.637L328.198 220.621C327.384 220.134 326.22 220.134 325.405 220.621L317.491 225.367C317.025 225.611 316.909 225.976 316.909 226.341C316.909 226.463 316.909 226.584 316.909 226.584C316.909 226.706 316.909 226.828 316.909 226.828C316.793 227.193 317.025 227.558 317.491 227.801L324.125 231.817C324.939 232.304 326.103 232.304 326.918 231.817L334.832 227.071C335.298 226.828 335.414 226.463 335.414 226.098C335.414 225.976 335.414 225.854 335.414 225.854C335.414 225.733 335.414 225.611 335.414 225.611C335.414 225.367 335.298 225.002 334.832 224.637ZM283.856 255.305L277.222 251.289C276.407 250.802 275.244 250.802 274.429 251.289L266.515 256.035C266.049 256.279 265.933 256.644 265.933 257.009C265.933 257.131 265.933 257.252 265.933 257.252C265.933 257.374 265.933 257.496 265.933 257.496C265.817 257.861 266.049 258.226 266.515 258.469L273.149 262.485C273.963 262.972 275.127 262.972 275.942 262.485L283.856 257.739C284.322 257.496 284.438 257.131 284.438 256.766C284.438 256.644 284.438 256.522 284.438 256.522C284.438 256.4 284.438 256.279 284.438 256.279C284.438 256.035 284.322 255.67 283.856 255.305ZM329.711 218.674C329.711 218.796 329.711 218.917 329.711 218.917C329.711 219.039 329.711 219.161 329.711 219.161C329.595 219.526 329.828 219.891 330.293 220.134L336.927 224.15C337.742 224.637 338.906 224.637 339.72 224.15L347.634 219.404C348.1 219.161 348.216 218.796 348.216 218.431C348.216 218.309 348.216 218.187 348.216 218.187C348.216 218.066 348.216 217.944 348.216 217.944C348.333 217.579 348.1 217.214 347.634 216.97L341 212.954C340.186 212.467 339.022 212.467 338.207 212.954L330.293 217.7C329.828 217.944 329.711 218.309 329.711 218.674ZM232.996 286.095L226.362 282.079C225.548 281.592 224.384 281.592 223.569 282.079L215.655 286.825C215.19 287.068 215.073 287.434 215.073 287.799C215.073 287.92 215.073 288.042 215.073 288.042C215.073 288.164 215.073 288.285 215.073 288.285C214.957 288.651 215.19 289.016 215.655 289.259L222.289 293.275C223.104 293.762 224.268 293.762 225.082 293.275L232.996 288.529C233.462 288.285 233.578 287.92 233.578 287.555C233.578 287.434 233.578 287.312 233.578 287.312C233.578 287.19 233.578 287.068 233.578 287.068C233.578 286.703 233.346 286.338 232.996 286.095ZM258.368 270.761L251.734 266.745C250.919 266.258 249.756 266.258 248.941 266.745L241.027 271.491C240.561 271.734 240.445 272.1 240.445 272.465C240.445 272.586 240.445 272.708 240.445 272.708C240.445 272.83 240.445 272.951 240.445 272.951C240.329 273.317 240.561 273.682 241.027 273.925L247.661 277.941C248.475 278.428 249.639 278.428 250.454 277.941L258.368 273.195C258.834 272.951 258.95 272.586 258.95 272.221C258.95 272.1 258.95 271.978 258.95 271.978C258.95 271.856 258.95 271.734 258.95 271.734C258.95 271.369 258.834 271.004 258.368 270.761ZM245.682 278.428L239.048 274.412C238.234 273.925 237.07 273.925 236.255 274.412L228.341 279.158C227.875 279.401 227.759 279.767 227.759 280.132C227.759 280.253 227.759 280.375 227.759 280.375C227.759 280.497 227.759 280.618 227.759 280.618C227.643 280.984 227.875 281.349 228.341 281.592L234.975 285.608C235.79 286.095 236.953 286.095 237.768 285.608L245.682 280.862C246.148 280.618 246.264 280.253 246.264 279.888C246.264 279.767 246.264 279.645 246.264 279.645C246.264 279.523 246.264 279.401 246.264 279.401C246.264 279.036 246.148 278.671 245.682 278.428ZM220.194 293.762L213.56 289.746C212.746 289.259 211.582 289.259 210.767 289.746L202.853 294.492C202.387 294.735 202.271 295.101 202.271 295.466C202.271 295.587 202.271 295.709 202.271 295.709C202.271 295.831 202.271 295.952 202.271 295.952C202.155 296.318 202.387 296.683 202.853 296.926L209.487 300.942C210.302 301.429 211.465 301.429 212.28 300.942L220.194 296.196C220.66 295.952 220.776 295.587 220.776 295.222C220.776 295.101 220.776 294.979 220.776 294.979C220.776 294.857 220.776 294.735 220.776 294.735C220.776 294.37 220.66 294.005 220.194 293.762ZM207.508 301.429L200.874 297.413C200.06 296.926 198.896 296.926 198.081 297.413L190.167 302.159C189.702 302.402 189.585 302.768 189.585 303.133C189.585 303.254 189.585 303.376 189.585 303.376C189.585 303.498 189.585 303.619 189.585 303.619C189.469 303.985 189.702 304.35 190.167 304.593L196.801 308.609C197.616 309.096 198.78 309.096 199.594 308.609L207.508 303.863C207.974 303.619 208.09 303.254 208.09 302.889C208.09 302.768 208.09 302.646 208.09 302.646C208.09 302.524 208.09 302.402 208.09 302.402C208.09 302.037 207.974 301.672 207.508 301.429ZM271.17 263.094L264.536 259.078C263.722 258.591 262.558 258.591 261.743 259.078L253.829 263.824C253.363 264.067 253.247 264.433 253.247 264.798C253.247 264.919 253.247 265.041 253.247 265.041C253.247 265.163 253.247 265.284 253.247 265.284C253.131 265.65 253.363 266.015 253.829 266.258L260.463 270.274C261.278 270.761 262.441 270.761 263.256 270.274L271.17 265.528C271.636 265.285 271.752 264.919 271.752 264.554C271.752 264.433 271.752 264.311 271.752 264.311C271.752 264.189 271.752 264.067 271.752 264.067C271.752 263.702 271.519 263.337 271.17 263.094ZM296.542 247.638L289.908 243.622C289.093 243.135 287.929 243.135 287.115 243.622L279.201 248.368C278.735 248.612 278.619 248.977 278.619 249.342C278.619 249.464 278.619 249.585 278.619 249.585C278.619 249.707 278.619 249.829 278.619 249.829C278.502 250.194 278.735 250.559 279.201 250.802L285.835 254.818C286.649 255.305 287.813 255.305 288.628 254.818L296.542 250.072C297.007 249.829 297.124 249.464 297.124 249.099C297.124 248.977 297.124 248.855 297.124 248.855C297.124 248.734 297.124 248.612 297.124 248.612C297.124 248.247 297.007 247.882 296.542 247.638ZM227.294 303.376L220.66 299.36C219.845 298.873 218.681 298.873 217.866 299.36L209.952 304.106C209.487 304.35 209.37 304.715 209.37 305.08C209.37 305.202 209.37 305.323 209.37 305.323C209.37 305.445 209.37 305.567 209.37 305.567C209.254 305.932 209.487 306.297 209.952 306.54L216.586 310.556C217.401 311.043 218.565 311.043 219.379 310.556L227.294 305.81C227.759 305.567 227.875 305.201 227.875 304.836C227.875 304.715 227.875 304.593 227.875 304.593C227.875 304.471 227.875 304.35 227.875 304.35C227.992 303.985 227.759 303.619 227.294 303.376ZM240.096 295.709L233.462 291.693C232.647 291.206 231.483 291.206 230.669 291.693L222.755 296.439C222.289 296.683 222.173 297.048 222.173 297.413C222.173 297.535 222.173 297.656 222.173 297.656C222.173 297.778 222.173 297.9 222.173 297.9C222.056 298.265 222.289 298.63 222.755 298.873L229.388 302.889C230.203 303.376 231.367 303.376 232.182 302.889L240.096 298.143C240.561 297.9 240.678 297.535 240.678 297.169C240.678 297.048 240.678 296.926 240.678 296.926C240.678 296.804 240.678 296.683 240.678 296.683C240.678 296.318 240.561 295.952 240.096 295.709ZM214.608 311.043L207.974 307.027C207.159 306.54 205.995 306.54 205.181 307.027L197.267 311.773C196.801 312.017 196.685 312.382 196.685 312.747C196.685 312.868 196.685 312.99 196.685 312.99C196.685 313.112 196.685 313.234 196.685 313.234C196.568 313.599 196.801 313.964 197.267 314.207L203.9 318.223C204.715 318.71 205.879 318.71 206.694 318.223L214.608 313.477C215.073 313.234 215.19 312.868 215.19 312.503C215.19 312.382 215.19 312.26 215.19 312.26C215.19 312.138 215.19 312.017 215.19 312.017C215.19 311.651 215.073 311.286 214.608 311.043ZM201.922 318.71L195.288 314.694C194.473 314.207 193.31 314.207 192.495 314.694L184.581 319.44C184.115 319.684 183.999 320.049 183.999 320.414C183.999 320.535 183.999 320.657 183.999 320.657C183.999 320.779 183.999 320.901 183.999 320.901C183.882 321.266 184.115 321.631 184.581 321.874L191.215 325.89C192.029 326.377 193.193 326.377 194.008 325.89L201.922 321.144C202.387 320.901 202.504 320.535 202.504 320.17C202.504 320.049 202.504 319.927 202.504 319.927C202.504 319.805 202.504 319.684 202.504 319.684C202.504 319.318 202.387 318.953 201.922 318.71ZM297.473 232.913L290.839 228.897C290.024 228.41 288.861 228.41 288.046 228.897L276.058 236.077C275.593 236.32 275.476 236.685 275.476 237.05C275.476 237.172 275.476 237.294 275.476 237.294C275.476 237.416 275.476 237.537 275.476 237.537C275.36 237.902 275.593 238.267 276.058 238.511L282.692 242.527C283.507 243.014 284.671 243.014 285.485 242.527L297.473 235.347C297.938 235.103 298.055 234.738 298.055 234.373C298.055 234.251 298.055 234.13 298.055 234.13C298.055 234.008 298.055 233.886 298.055 233.886C298.055 233.521 297.938 233.156 297.473 232.913ZM320.401 247.151L313.767 243.135C312.952 242.649 311.788 242.649 310.973 243.135L298.986 250.316C298.52 250.559 298.404 250.924 298.404 251.289C298.404 251.411 298.404 251.533 298.404 251.533C298.404 251.654 298.404 251.776 298.404 251.776C298.288 252.141 298.52 252.506 298.986 252.75L305.62 256.766C306.434 257.252 307.598 257.252 308.413 256.766L320.401 249.585C320.866 249.342 320.982 248.977 320.982 248.612C320.982 248.49 320.982 248.368 320.982 248.368C320.982 248.247 320.982 248.125 320.982 248.125C321.099 247.76 320.866 247.395 320.401 247.151ZM346.47 231.817L339.837 227.801C339.022 227.315 337.858 227.315 337.043 227.801L329.129 232.548C328.664 232.791 328.547 233.156 328.547 233.521C328.547 233.643 328.547 233.765 328.547 233.765C328.547 233.886 328.547 234.008 328.547 234.008C328.431 234.373 328.664 234.738 329.129 234.982L335.763 238.998C336.578 239.484 337.742 239.484 338.556 238.998L346.47 234.251C346.936 234.008 347.052 233.643 347.052 233.278C347.052 233.156 347.052 233.034 347.052 233.034C347.052 232.913 347.052 232.791 347.052 232.791C347.052 232.426 346.936 232.061 346.47 231.817ZM333.785 239.484L327.151 235.468C326.336 234.982 325.172 234.982 324.358 235.468L316.443 240.215C315.978 240.458 315.862 240.823 315.862 241.188C315.862 241.31 315.862 241.432 315.862 241.432C315.862 241.553 315.862 241.675 315.862 241.675C315.745 242.04 315.978 242.405 316.443 242.649L323.077 246.665C323.892 247.151 325.056 247.151 325.871 246.665L333.785 241.918C334.25 241.675 334.367 241.31 334.367 240.945C334.367 240.823 334.367 240.701 334.367 240.701C334.367 240.58 334.367 240.458 334.367 240.458C334.367 240.093 334.25 239.728 333.785 239.484ZM303.874 257.252L297.24 253.236C296.425 252.75 295.262 252.75 294.447 253.236L235.557 288.772C235.091 289.016 234.975 289.381 234.975 289.746C234.975 289.868 234.975 289.989 234.975 289.989C234.975 290.111 234.975 290.233 234.975 290.233C234.858 290.598 235.091 290.963 235.557 291.206L242.191 295.222C243.005 295.709 244.169 295.709 244.984 295.222L303.874 259.686C304.34 259.443 304.456 259.078 304.456 258.713C304.456 258.591 304.456 258.469 304.456 258.469C304.456 258.348 304.456 258.226 304.456 258.226C304.456 257.861 304.34 257.496 303.874 257.252ZM255.109 258.469L248.475 254.453C247.661 253.967 246.497 253.967 245.682 254.453L237.768 259.2C237.303 259.443 237.186 259.808 237.186 260.173C237.186 260.295 237.186 260.417 237.186 260.417C237.186 260.538 237.186 260.66 237.186 260.66C237.07 261.025 237.303 261.39 237.768 261.634L244.402 265.65C245.217 266.136 246.38 266.136 247.195 265.65L255.109 260.903C255.575 260.66 255.691 260.295 255.691 259.93C255.691 259.808 255.691 259.686 255.691 259.686C255.691 259.565 255.691 259.443 255.691 259.443C255.808 259.078 255.575 258.713 255.109 258.469ZM242.423 266.136L235.79 262.12C234.975 261.634 233.811 261.634 232.996 262.12L225.082 266.867C224.617 267.11 224.5 267.475 224.5 267.84C224.5 267.962 224.5 268.084 224.5 268.084C224.5 268.205 224.5 268.327 224.5 268.327C224.384 268.692 224.617 269.057 225.082 269.301L231.716 273.317C232.531 273.803 233.695 273.803 234.509 273.317L242.423 268.57C242.889 268.327 243.005 267.962 243.005 267.597C243.005 267.475 243.005 267.353 243.005 267.353C243.005 267.232 243.005 267.11 243.005 267.11C243.005 266.745 242.889 266.38 242.423 266.136ZM267.911 250.802L261.278 246.786C260.463 246.3 259.299 246.3 258.484 246.786L250.57 251.533C250.105 251.776 249.988 252.141 249.988 252.506C249.988 252.628 249.988 252.75 249.988 252.75C249.988 252.871 249.988 252.993 249.988 252.993C249.872 253.358 250.105 253.723 250.57 253.967L257.204 257.983C258.019 258.469 259.183 258.469 259.997 257.983L267.911 253.236C268.377 252.993 268.493 252.628 268.493 252.263C268.493 252.141 268.493 252.019 268.493 252.019C268.493 251.898 268.493 251.776 268.493 251.776C268.493 251.411 268.377 251.046 267.911 250.802ZM306.551 204.314C306.551 204.435 306.551 204.557 306.551 204.557C306.551 204.679 306.551 204.8 306.551 204.8C306.434 205.166 306.667 205.531 307.133 205.774L313.767 209.79C314.581 210.277 315.745 210.277 316.56 209.79L324.474 205.044C324.939 204.8 325.056 204.435 325.056 204.07C325.056 203.949 325.056 203.827 325.056 203.827C325.056 203.705 325.056 203.584 325.056 203.584C325.172 203.218 324.939 202.853 324.474 202.61L317.84 198.594C317.025 198.107 315.862 198.107 315.047 198.594L307.133 203.34C306.667 203.705 306.434 204.07 306.551 204.314ZM280.597 243.014L273.963 238.998C273.149 238.511 271.985 238.511 271.17 238.998L263.256 243.744C262.791 243.987 262.674 244.352 262.674 244.717C262.674 244.839 262.674 244.961 262.674 244.961C262.674 245.083 262.674 245.204 262.674 245.204C262.558 245.569 262.791 245.934 263.256 246.178L269.89 250.194C270.705 250.681 271.869 250.681 272.683 250.194L280.597 245.448C281.063 245.204 281.179 244.839 281.179 244.474C281.179 244.352 281.179 244.231 281.179 244.231C281.179 244.109 281.179 243.987 281.179 243.987C281.179 243.744 281.063 243.379 280.597 243.014ZM229.738 273.803L223.104 269.787C222.289 269.301 221.125 269.301 220.311 269.787L212.396 274.534C211.931 274.777 211.815 275.142 211.815 275.507C211.815 275.629 211.815 275.751 211.815 275.751C211.815 275.872 211.815 275.994 211.815 275.994C211.698 276.359 211.931 276.724 212.396 276.968L219.03 280.984C219.845 281.47 221.009 281.47 221.824 280.984L229.738 276.237C230.203 275.994 230.32 275.629 230.32 275.264C230.32 275.142 230.32 275.02 230.32 275.02C230.32 274.899 230.32 274.777 230.32 274.777C230.32 274.412 230.203 274.047 229.738 273.803ZM204.25 289.137L197.616 285.121C196.801 284.634 195.637 284.634 194.822 285.121L186.908 289.868C186.443 290.111 186.326 290.476 186.326 290.841C186.326 290.963 186.326 291.085 186.326 291.085C186.326 291.206 186.326 291.328 186.326 291.328C186.21 291.693 186.443 292.058 186.908 292.301L193.542 296.318C194.357 296.804 195.521 296.804 196.335 296.318L204.25 291.571C204.715 291.328 204.831 290.963 204.831 290.598C204.831 290.476 204.831 290.354 204.831 290.354C204.831 290.233 204.831 290.111 204.831 290.111C204.831 289.868 204.715 289.502 204.25 289.137ZM216.935 281.47L210.302 277.454C209.487 276.968 208.323 276.968 207.508 277.454L199.594 282.201C199.129 282.444 199.012 282.809 199.012 283.174C199.012 283.296 199.012 283.418 199.012 283.418C199.012 283.539 199.012 283.661 199.012 283.661C198.896 284.026 199.129 284.391 199.594 284.634L206.228 288.651C207.043 289.137 208.207 289.137 209.021 288.651L216.935 283.904C217.401 283.661 217.517 283.296 217.517 282.931C217.517 282.809 217.517 282.687 217.517 282.687C217.517 282.566 217.517 282.444 217.517 282.444C217.634 282.079 217.401 281.714 216.935 281.47Z"
          fill="#CEC6D4"
        />
        <path
          d="M313.766 211.859L305.038 206.504C304.107 205.896 302.594 205.896 301.546 206.504L281.528 218.553C280.946 218.918 280.83 219.283 280.83 219.77C280.83 219.891 280.83 220.013 280.83 220.013C280.83 220.135 280.83 220.256 280.83 220.256C280.713 220.743 280.946 221.108 281.528 221.473L298.986 232.183C299.917 232.791 301.43 232.791 302.477 232.183L335.647 212.224C336.229 211.859 336.345 211.494 336.345 211.007C336.345 210.886 336.345 210.764 336.345 210.764C336.345 210.642 336.345 210.521 336.345 210.521C336.461 210.034 336.229 209.669 335.647 209.304L329.129 205.287C328.547 204.922 327.5 204.922 326.801 205.287L315.629 211.859C315.163 212.224 314.348 212.224 313.766 211.859Z"
          fill="#D5D0D5"
        />
        <path
          d="M335.648 208.938L329.13 204.922C328.549 204.557 327.501 204.557 326.803 204.922L315.63 211.494C315.048 211.859 314.233 211.859 313.651 211.494L304.923 206.139C303.992 205.531 302.479 205.531 301.431 206.139L281.413 218.187C280.482 218.796 280.482 219.648 281.413 220.256L298.871 230.966C299.802 231.574 301.315 231.574 302.362 230.966L335.532 211.007C336.579 210.399 336.579 209.547 335.648 208.938Z"
          fill="#FFF7F5"
        />
        <path
          opacity="0.7"
          d="M360.199 281.714L296.653 320.536C295.373 321.266 293.394 321.266 292.231 320.536L256.152 297.657C254.871 296.927 254.871 295.588 256.152 294.858L319.697 256.036C320.977 255.306 322.956 255.306 324.12 256.036L360.199 278.915C361.479 279.767 361.479 280.984 360.199 281.714Z"
          fill="#EFE8EE"
        />
        <path
          d="M256.037 295.588L319.582 256.766C320.863 256.036 322.841 256.036 324.005 256.766L360.084 279.645C360.55 279.889 360.782 280.254 360.899 280.741C361.131 280.132 360.782 279.524 360.084 279.037L324.005 256.158C322.725 255.427 320.746 255.306 319.582 256.158L256.037 294.979C255.222 295.466 254.99 296.075 255.222 296.683C255.339 296.196 255.571 295.831 256.037 295.588Z"
          fill="#C0B7C8"
        />
        <path
          d="M155.714 291.693L147.8 296.44C146.985 296.926 145.821 296.926 145.007 296.44L138.373 292.424C137.558 291.937 137.558 291.207 138.373 290.72L146.287 285.974C147.102 285.487 148.265 285.487 149.08 285.974L155.714 289.99C156.412 290.476 156.412 291.207 155.714 291.693ZM168.4 282.323L161.766 278.307C160.951 277.82 159.787 277.82 158.973 278.307L151.059 283.053C150.244 283.54 150.244 284.27 151.059 284.757L157.692 288.773C158.507 289.259 159.671 289.259 160.486 288.773L168.4 284.026C169.214 283.54 169.214 282.809 168.4 282.323ZM181.086 274.656L174.452 270.64C173.637 270.153 172.473 270.153 171.658 270.64L163.744 275.386C162.93 275.873 162.93 276.603 163.744 277.09L170.378 281.106C171.193 281.592 172.357 281.592 173.171 281.106L181.086 276.359C181.9 275.873 181.9 275.021 181.086 274.656ZM193.888 266.867L187.254 262.851C186.439 262.364 185.275 262.364 184.461 262.851L176.547 267.597C175.732 268.084 175.732 268.814 176.547 269.301L183.18 273.317C183.995 273.804 185.159 273.804 185.974 273.317L193.888 268.571C194.586 268.084 194.586 267.354 193.888 266.867ZM206.574 259.2L199.94 255.184C199.125 254.697 197.961 254.697 197.147 255.184L189.232 259.93C188.418 260.417 188.418 261.147 189.232 261.634L195.866 265.65C196.681 266.137 197.845 266.137 198.66 265.65L206.574 260.904C207.388 260.417 207.388 259.687 206.574 259.2ZM219.259 251.533L212.626 247.517C211.811 247.03 210.647 247.03 209.832 247.517L201.918 252.263C201.104 252.75 201.104 253.48 201.918 253.967L208.552 257.983C209.367 258.47 210.531 258.47 211.345 257.983L219.259 253.237C220.074 252.75 220.074 252.02 219.259 251.533ZM232.062 243.866L225.428 239.85C224.613 239.363 223.449 239.363 222.635 239.85L214.72 244.596C213.906 245.083 213.906 245.813 214.72 246.3L221.354 250.316C222.169 250.803 223.333 250.803 224.148 250.316L232.062 245.57C232.76 245.083 232.76 244.353 232.062 243.866ZM244.747 236.199L238.114 232.183C237.299 231.696 236.135 231.696 235.32 232.183L227.406 236.929C226.592 237.416 226.592 238.146 227.406 238.633L234.04 242.649C234.855 243.136 236.019 243.136 236.833 242.649L244.747 237.903C245.562 237.416 245.562 236.686 244.747 236.199ZM257.433 228.532L250.799 224.516C249.985 224.029 248.821 224.029 248.006 224.516L240.092 229.262C239.277 229.749 239.277 230.479 240.092 230.966L246.726 234.982C247.541 235.469 248.704 235.469 249.519 234.982L257.433 230.236C258.248 229.749 258.248 229.019 257.433 228.532ZM274.309 218.309L267.675 214.293C266.86 213.807 265.697 213.807 264.882 214.293L252.894 221.474C252.08 221.96 252.08 222.691 252.894 223.177L259.528 227.193C260.343 227.68 261.507 227.68 262.321 227.193L274.309 220.013C275.124 219.526 275.124 218.796 274.309 218.309ZM322.143 231.94L315.509 227.924C314.694 227.437 313.53 227.437 312.716 227.924L304.801 232.67C303.987 233.157 303.987 233.887 304.801 234.374L311.435 238.39C312.25 238.876 313.414 238.876 314.229 238.39L322.143 233.643C322.841 233.157 322.841 232.426 322.143 231.94ZM334.828 224.273L328.195 220.257C327.38 219.77 326.216 219.77 325.401 220.257L317.487 225.003C316.673 225.49 316.673 226.22 317.487 226.707L324.121 230.723C324.936 231.209 326.1 231.209 326.914 230.723L334.828 225.976C335.643 225.49 335.643 224.759 334.828 224.273ZM347.514 216.606L340.88 212.59C340.066 212.103 338.902 212.103 338.087 212.59L330.173 217.336C329.358 217.823 329.358 218.553 330.173 219.04L336.807 223.056C337.622 223.542 338.786 223.542 339.6 223.056L347.514 218.309C348.329 217.823 348.329 217.092 347.514 216.606ZM333.781 239.12L327.147 235.104C326.332 234.617 325.169 234.617 324.354 235.104L316.44 239.85C315.625 240.337 315.625 241.067 316.44 241.554L323.074 245.57C323.888 246.057 325.052 246.057 325.867 245.57L333.781 240.824C334.479 240.337 334.479 239.607 333.781 239.12ZM346.467 231.453L339.833 227.437C339.018 226.95 337.854 226.95 337.04 227.437L329.126 232.183C328.311 232.67 328.311 233.4 329.126 233.887L335.76 237.903C336.574 238.39 337.738 238.39 338.553 237.903L346.467 233.157C347.282 232.67 347.282 231.94 346.467 231.453ZM359.153 223.786L352.519 219.77C351.704 219.283 350.54 219.283 349.726 219.77L341.811 224.516C340.997 225.003 340.997 225.733 341.811 226.22L348.445 230.236C349.26 230.723 350.424 230.723 351.239 230.236L359.153 225.49C359.967 225.003 359.967 224.273 359.153 223.786ZM171.658 294.614L165.025 290.598C164.21 290.111 163.046 290.111 162.231 290.598L150.244 297.778C149.429 298.265 149.429 298.995 150.244 299.482L156.878 303.498C157.692 303.985 158.856 303.985 159.671 303.498L171.658 296.318C172.357 295.831 172.357 294.979 171.658 294.614ZM184.344 286.826L177.71 282.809C176.896 282.323 175.732 282.323 174.917 282.809L167.003 287.556C166.188 288.042 166.188 288.773 167.003 289.259L173.637 293.276C174.452 293.762 175.616 293.762 176.43 293.276L184.344 288.529C185.159 288.164 185.159 287.312 184.344 286.826ZM197.147 279.159L190.513 275.143C189.698 274.656 188.534 274.656 187.719 275.143L179.805 279.889C178.991 280.376 178.991 281.106 179.805 281.592L186.439 285.609C187.254 286.095 188.418 286.095 189.232 285.609L197.147 280.862C197.845 280.376 197.845 279.645 197.147 279.159ZM209.832 271.492L203.198 267.475C202.384 266.989 201.22 266.989 200.405 267.475L192.491 272.222C191.676 272.709 191.676 273.439 192.491 273.926L199.125 277.942C199.94 278.428 201.104 278.428 201.918 277.942L209.832 273.195C210.531 272.709 210.531 271.978 209.832 271.492ZM222.518 263.825L215.884 259.809C215.07 259.322 213.906 259.322 213.091 259.809L205.177 264.555C204.362 265.042 204.362 265.772 205.177 266.259L211.811 270.275C212.626 270.761 213.789 270.761 214.604 270.275L222.518 265.528C223.333 265.042 223.333 264.311 222.518 263.825ZM235.32 256.158L228.687 252.142C227.872 251.655 226.708 251.655 225.893 252.142L217.979 256.888C217.165 257.375 217.165 258.105 217.979 258.592L224.613 262.608C225.428 263.094 226.592 263.094 227.406 262.608L235.32 257.861C236.019 257.375 236.019 256.644 235.32 256.158ZM248.006 248.491L241.372 244.475C240.558 243.988 239.394 243.988 238.579 244.475L230.665 249.221C229.85 249.708 229.85 250.438 230.665 250.925L237.299 254.941C238.114 255.427 239.277 255.427 240.092 254.941L248.006 250.194C248.704 249.708 248.704 248.977 248.006 248.491ZM260.692 240.824L254.058 236.808C253.243 236.321 252.08 236.321 251.265 236.808L243.351 241.554C242.536 242.041 242.536 242.771 243.351 243.258L249.985 247.274C250.799 247.76 251.963 247.76 252.778 247.274L260.692 242.527C261.507 242.041 261.507 241.189 260.692 240.824ZM273.494 233.035L266.86 229.019C266.046 228.532 264.882 228.532 264.067 229.019L256.153 233.765C255.338 234.252 255.338 234.982 256.153 235.469L262.787 239.485C263.602 239.972 264.765 239.972 265.58 239.485L273.494 234.739C274.193 234.374 274.193 233.522 273.494 233.035ZM286.18 225.368L279.546 221.352C278.732 220.865 277.568 220.865 276.753 221.352L268.839 226.098C268.024 226.585 268.024 227.315 268.839 227.802L275.473 231.818C276.287 232.305 277.451 232.305 278.266 231.818L286.18 227.072C286.878 226.585 286.878 225.855 286.18 225.368ZM178.758 304.228L172.124 300.212C171.309 299.726 170.145 299.726 169.331 300.212L161.417 304.959C160.602 305.445 160.602 306.176 161.417 306.662L168.051 310.678C168.865 311.165 170.029 311.165 170.844 310.678L178.758 305.932C179.573 305.445 179.573 304.593 178.758 304.228ZM191.56 296.44L184.926 292.424C184.112 291.937 182.948 291.937 182.133 292.424L174.219 297.17C173.404 297.657 173.404 298.387 174.219 298.874L180.853 302.89C181.667 303.376 182.831 303.376 183.646 302.89L191.56 298.143C192.258 297.778 192.258 296.926 191.56 296.44ZM204.246 288.773L197.612 284.757C196.797 284.27 195.634 284.27 194.819 284.757L186.905 289.503C186.09 289.99 186.09 290.72 186.905 291.207L193.539 295.223C194.353 295.709 195.517 295.709 196.332 295.223L204.246 290.476C205.061 289.99 205.061 289.259 204.246 288.773ZM216.932 281.106L210.298 277.09C209.483 276.603 208.319 276.603 207.505 277.09L199.591 281.836C198.776 282.323 198.776 283.053 199.591 283.54L206.224 287.556C207.039 288.042 208.203 288.042 209.018 287.556L216.932 282.809C217.746 282.323 217.746 281.592 216.932 281.106ZM201.918 318.345L195.284 314.329C194.47 313.842 193.306 313.842 192.491 314.329L184.577 319.076C183.762 319.562 183.762 320.293 184.577 320.779L191.211 324.795C192.026 325.282 193.189 325.282 194.004 324.795L201.918 320.049C202.617 319.562 202.617 318.832 201.918 318.345ZM214.604 310.678L207.97 306.662C207.156 306.176 205.992 306.176 205.177 306.662L197.263 311.409C196.448 311.895 196.448 312.626 197.263 313.112L203.897 317.128C204.711 317.615 205.875 317.615 206.69 317.128L214.604 312.382C215.419 311.895 215.419 311.165 214.604 310.678ZM227.29 303.011L220.656 298.995C219.841 298.509 218.678 298.509 217.863 298.995L209.949 303.742C209.134 304.228 209.134 304.959 209.949 305.445L216.583 309.461C217.397 309.948 218.561 309.948 219.376 309.461L227.29 304.715C228.105 304.228 228.105 303.498 227.29 303.011ZM240.092 295.344L233.458 291.328C232.644 290.842 231.48 290.842 230.665 291.328L222.751 296.075C221.936 296.561 221.936 297.292 222.751 297.778L229.385 301.794C230.199 302.281 231.363 302.281 232.178 301.794L240.092 297.048C240.79 296.561 240.79 295.831 240.092 295.344ZM320.397 246.787L313.763 242.771C312.948 242.284 311.784 242.284 310.97 242.771L298.982 249.951C298.168 250.438 298.168 251.168 298.982 251.655L305.616 255.671C306.431 256.158 307.595 256.158 308.409 255.671L320.397 248.491C321.212 248.004 321.212 247.274 320.397 246.787ZM229.734 273.439L223.1 269.423C222.285 268.936 221.122 268.936 220.307 269.423L212.393 274.169C211.578 274.656 211.578 275.386 212.393 275.873L219.027 279.889C219.841 280.376 221.005 280.376 221.82 279.889L229.734 275.143C230.432 274.656 230.432 273.926 229.734 273.439ZM242.42 265.772L235.786 261.756C234.971 261.269 233.807 261.269 232.993 261.756L225.079 266.502C224.264 266.989 224.264 267.719 225.079 268.206L231.712 272.222C232.527 272.709 233.691 272.709 234.506 272.222L242.42 267.475C243.234 266.989 243.234 266.259 242.42 265.772ZM255.106 258.105L248.472 254.089C247.657 253.602 246.493 253.602 245.679 254.089L237.764 258.835C236.95 259.322 236.95 260.052 237.764 260.539L244.398 264.555C245.213 265.042 246.377 265.042 247.192 264.555L255.106 259.809C255.92 259.322 255.92 258.592 255.106 258.105ZM267.908 250.438L261.274 246.422C260.459 245.935 259.295 245.935 258.481 246.422L250.567 251.168C249.752 251.655 249.752 252.385 250.567 252.872L257.201 256.888C258.015 257.375 259.179 257.375 259.994 256.888L267.908 252.142C268.606 251.655 268.606 250.803 267.908 250.438ZM280.594 242.649L273.96 238.633C273.145 238.146 271.981 238.146 271.167 238.633L263.252 243.379C262.438 243.866 262.438 244.596 263.252 245.083L269.886 249.099C270.701 249.586 271.865 249.586 272.68 249.099L280.594 244.353C281.408 243.988 281.408 243.136 280.594 242.649ZM297.469 232.548L290.835 228.532C290.021 228.045 288.857 228.045 288.042 228.532L276.055 235.712C275.24 236.199 275.24 236.929 276.055 237.416L282.689 241.432C283.503 241.919 284.667 241.919 285.482 241.432L297.469 234.252C298.168 233.765 298.168 233.035 297.469 232.548ZM194.819 308.731L188.185 304.715C187.37 304.228 186.206 304.228 185.392 304.715L173.404 311.895C172.59 312.382 172.59 313.112 173.404 313.599L180.038 317.615C180.853 318.102 182.017 318.102 182.831 317.615L194.819 310.435C195.517 309.948 195.517 309.218 194.819 308.731ZM207.505 301.064L200.871 297.048C200.056 296.561 198.892 296.561 198.078 297.048L190.163 301.794C189.349 302.281 189.349 303.011 190.163 303.498L196.797 307.514C197.612 308.001 198.776 308.001 199.591 307.514L207.505 302.768C208.203 302.281 208.203 301.551 207.505 301.064ZM220.19 293.397L213.557 289.381C212.742 288.894 211.578 288.894 210.763 289.381L202.849 294.127C202.035 294.614 202.035 295.344 202.849 295.831L209.483 299.847C210.298 300.334 211.462 300.334 212.276 299.847L220.19 295.101C221.005 294.614 221.005 293.884 220.19 293.397ZM232.993 285.73L226.359 281.714C225.544 281.227 224.38 281.227 223.566 281.714L215.652 286.46C214.837 286.947 214.837 287.677 215.652 288.164L222.285 292.18C223.1 292.667 224.264 292.667 225.079 292.18L232.993 287.434C233.691 286.947 233.691 286.217 232.993 285.73ZM245.679 278.063L239.045 274.047C238.23 273.56 237.066 273.56 236.251 274.047L228.337 278.793C227.523 279.28 227.523 280.01 228.337 280.497L234.971 284.513C235.786 285 236.95 285 237.764 284.513L245.679 279.767C246.377 279.28 246.377 278.55 245.679 278.063ZM303.87 256.888L297.237 252.872C296.422 252.385 295.258 252.385 294.443 252.872L235.553 288.408C234.738 288.894 234.738 289.625 235.553 290.111L242.187 294.127C243.002 294.614 244.166 294.614 244.98 294.127L303.87 258.592C304.685 258.105 304.685 257.375 303.87 256.888ZM258.364 270.396L251.73 266.38C250.916 265.893 249.752 265.893 248.937 266.38L241.023 271.126C240.208 271.613 240.208 272.343 241.023 272.83L247.657 276.846C248.472 277.333 249.636 277.333 250.45 276.846L258.364 272.1C259.179 271.613 259.179 270.883 258.364 270.396ZM271.167 262.608L264.533 258.592C263.718 258.105 262.554 258.105 261.739 258.592L253.825 263.338C253.011 263.825 253.011 264.555 253.825 265.042L260.459 269.058C261.274 269.544 262.438 269.544 263.252 269.058L271.167 264.311C271.865 263.946 271.865 263.094 271.167 262.608ZM283.852 254.941L277.219 250.925C276.404 250.438 275.24 250.438 274.425 250.925L266.511 255.671C265.697 256.158 265.697 256.888 266.511 257.375L273.145 261.391C273.96 261.877 275.124 261.877 275.938 261.391L283.852 256.644C284.667 256.158 284.667 255.427 283.852 254.941ZM296.538 247.274L289.904 243.258C289.09 242.771 287.926 242.771 287.111 243.258L279.197 248.004C278.382 248.491 278.382 249.221 279.197 249.708L285.831 253.724C286.646 254.21 287.809 254.21 288.624 253.724L296.538 248.977C297.353 248.491 297.353 247.76 296.538 247.274ZM309.34 239.607L302.707 235.591C301.892 235.104 300.728 235.104 299.913 235.591L291.999 240.337C291.185 240.824 291.185 241.554 291.999 242.041L298.633 246.057C299.448 246.543 300.612 246.543 301.426 246.057L309.34 241.31C310.039 240.824 310.039 240.093 309.34 239.607ZM287.228 210.521L280.594 206.505C279.779 206.018 278.615 206.018 277.8 206.505L269.886 211.251C269.072 211.738 269.072 212.468 269.886 212.955L276.52 216.971C277.335 217.458 278.499 217.458 279.313 216.971L287.228 212.225C288.042 211.859 288.042 211.008 287.228 210.521ZM300.03 202.854L293.396 198.838C292.581 198.351 291.417 198.351 290.603 198.838L282.689 203.584C281.874 204.071 281.874 204.801 282.689 205.288L289.322 209.304C290.137 209.791 291.301 209.791 292.116 209.304L300.03 204.558C300.728 204.071 300.728 203.341 300.03 202.854ZM312.716 195.187L306.082 191.171C305.267 190.684 304.103 190.684 303.288 191.171L295.374 195.917C294.56 196.404 294.56 197.134 295.374 197.621L302.008 201.637C302.823 202.124 303.987 202.124 304.801 201.637L312.716 196.891C313.53 196.404 313.53 195.674 312.716 195.187ZM324.354 202.367L317.72 198.351C316.905 197.864 315.742 197.864 314.927 198.351L307.013 203.097C306.198 203.584 306.198 204.314 307.013 204.801L313.647 208.817C314.461 209.304 315.625 209.304 316.44 208.817L324.354 204.071C325.052 203.584 325.052 202.854 324.354 202.367Z"
          fill="#FFF7F5"
        />
        <path
          opacity="0.7"
          d="M289.905 195.186L133.486 289.624L128.016 286.338L284.435 191.9L289.905 195.186Z"
          fill="#EFE8EE"
        />
        <path
          d="M284.435 192.631L289.323 195.551L289.905 195.186L284.435 191.9L128.016 286.338L128.598 286.703L284.435 192.631Z"
          fill="#CEC6D4"
        />
        <path
          opacity="0.3"
          d="M300.263 185.816C298.052 184.477 294.444 184.477 292.233 185.816C290.021 187.154 290.021 189.345 292.233 190.683C294.444 192.022 298.052 192.022 300.263 190.683C302.474 189.345 302.474 187.154 300.263 185.816Z"
          fill="url(#paint9_linear_1926_44029)"
        />
        <path
          d="M349.496 298.874L314.93 319.806L314.465 320.658L315.396 320.779L350.078 299.847L350.66 298.752L349.496 298.874Z"
          fill="#EFE8EE"
        />
        <path
          d="M300.031 190.44C298.052 191.657 294.677 191.657 292.699 190.44C290.72 189.223 290.72 187.276 292.699 186.059C294.677 184.842 298.052 184.842 300.031 186.059C302.009 187.276 302.009 189.223 300.031 190.44Z"
          fill="#FFF7F5"
        />
        <path
          d="M129.877 298.386L136.395 302.28C137.209 302.767 137.791 302.523 137.791 301.672C137.791 300.82 137.209 299.846 136.395 299.359L129.877 295.465C129.062 294.978 128.48 295.222 128.48 296.073C128.48 296.925 129.179 298.021 129.877 298.386Z"
          fill="#8B8396"
        />
        <mask
          id="mask0_1926_44029"
          maskUnits="userSpaceOnUse"
          x="128"
          y="295"
          width="10"
          height="8"
        >
          <path
            d="M129.877 298.386L136.395 302.28C137.209 302.767 137.791 302.523 137.791 301.672C137.791 300.82 137.209 299.846 136.395 299.359L129.877 295.465C129.062 294.978 128.48 295.222 128.48 296.073C128.48 296.925 129.179 298.021 129.877 298.386Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1926_44029)">
          <path
            opacity="0.7"
            d="M135.697 301.428L136.628 302.036L139.887 300.089L138.956 299.48L135.697 301.428ZM133.719 300.211L134.65 300.819L137.909 298.872L136.978 298.263L133.719 300.211ZM131.74 299.115L132.671 299.724L135.93 297.777L134.999 297.168L131.74 299.115ZM129.762 297.898L130.693 298.507L133.952 296.56L133.02 295.951L129.762 297.898Z"
            fill="#ADA4B8"
          />
        </g>
        <path
          d="M166.772 320.536L156.996 314.573V312.747L166.772 318.71V320.536Z"
          fill="#8B8396"
        />
        <path
          d="M119.637 127.4V276.115C119.637 279.158 121.964 280.132 124.99 278.428L315.976 163.058C318.886 161.232 321.33 157.46 321.33 154.417V5.70215L119.637 127.4Z"
          fill="#3F91FF"
        />
        <path
          d="M321.333 9.47449V3.14618C321.333 0.103726 319.005 -0.869862 315.979 0.833913L124.877 116.204C121.968 118.029 119.523 121.802 119.523 124.844V131.173L321.333 9.47449Z"
          fill="#455FDC"
        />
        <path
          d="M208.907 106.591L206.113 108.173V106.956L208.907 105.374V106.591Z"
          fill="white"
        />
        <path
          d="M214.609 103.062L210.652 105.496V104.279L214.609 101.845V103.062Z"
          fill="white"
        />
        <path
          d="M227.409 95.3947L216.469 101.966V100.749L227.409 94.1777V95.3947Z"
          fill="white"
        />
        <path
          d="M233.579 91.6223L229.156 94.2996V93.0826L233.579 90.4053V91.6223Z"
          fill="white"
        />
        <path
          d="M235.328 89.3102V90.6489L242.428 86.2678V85.0508L235.328 89.3102Z"
          fill="white"
        />
        <path
          d="M248.125 82.8596L244.168 85.2935V84.0765L248.125 81.6426V82.8596Z"
          fill="white"
        />
        <path
          d="M253.25 79.8176L249.875 81.7647V80.5477L253.25 78.6006V79.8176Z"
          fill="white"
        />
        <path
          d="M212.282 107.808L206.23 111.58V110.242L212.282 106.591V107.808Z"
          fill="white"
        />
        <path
          d="M218.101 104.4L214.027 106.712V105.495L218.101 103.062V104.4Z"
          fill="white"
        />
        <path
          d="M224.736 100.385L219.848 103.305V102.088L224.736 99.0459V100.385Z"
          fill="white"
        />
        <path
          d="M229.506 97.4641L226.48 99.2895V98.0725L229.506 96.2471V97.4641Z"
          fill="white"
        />
        <path
          d="M231.254 95.151V96.368L239.983 91.135V89.918L231.254 95.151Z"
          fill="white"
        />
        <path
          d="M245.222 87.9719L241.73 90.0407V88.8237L245.222 86.7549V87.9719Z"
          fill="white"
        />
        <path
          d="M256.276 81.2785L246.965 86.8766V85.6596L256.276 80.0615V81.2785Z"
          fill="white"
        />
        <path
          d="M208.907 113.163L206.23 114.867V113.65L208.907 111.946V113.163Z"
          fill="white"
        />
        <path
          d="M214.726 109.755L210.652 112.189V110.972L214.726 108.538V109.755Z"
          fill="white"
        />
        <path
          d="M220.542 106.225L216.469 108.659V107.442L220.542 104.887V106.225Z"
          fill="white"
        />
        <path
          d="M233.579 98.3156L222.406 105.131V103.914L233.579 97.0986V98.3156Z"
          fill="white"
        />
        <path
          d="M235.328 96.0036V97.2206L242.428 92.9611V91.7441L235.328 96.0036Z"
          fill="white"
        />
        <path
          d="M248.125 89.5539L244.168 91.9879V90.6492L248.125 88.3369V89.5539Z"
          fill="white"
        />
        <path
          d="M253.25 86.3898L249.875 88.4587V87.2417L253.25 85.1729V86.3898Z"
          fill="white"
        />
        <path
          d="M212.282 114.501L206.23 118.152V116.935L212.282 113.284V114.501Z"
          fill="white"
        />
        <path
          d="M218.098 110.972L214.141 113.406V112.189L218.098 109.755V110.972Z"
          fill="white"
        />
        <path
          d="M224.736 106.956L219.848 109.999V108.782L224.736 105.739V106.956Z"
          fill="white"
        />
        <path
          d="M229.506 104.157L226.48 105.983V104.766L229.506 102.94V104.157Z"
          fill="white"
        />
        <path
          d="M231.254 101.845V103.062L239.983 97.8289V96.4902L231.254 101.845Z"
          fill="white"
        />
        <path
          d="M245.219 94.6639L241.844 96.7327V95.5158L245.219 93.3252V94.6639Z"
          fill="white"
        />
        <path
          d="M257.203 87.3635L247.078 93.5701V92.3531L257.203 86.1465V87.3635Z"
          fill="white"
        />
        <path
          d="M208.907 119.857L206.23 121.56V120.343L208.907 118.64V119.857Z"
          fill="white"
        />
        <path
          d="M214.726 116.448L210.652 118.761V117.544L214.726 115.231V116.448Z"
          fill="white"
        />
        <path
          d="M228.34 108.173L216.469 115.353V114.136L228.34 106.956V108.173Z"
          fill="white"
        />
        <path
          d="M233.58 105.009L227.645 108.538V107.321L233.58 103.792V105.009Z"
          fill="white"
        />
        <path
          d="M235.328 102.697V103.914L242.428 99.6545V98.4375L235.328 102.697Z"
          fill="white"
        />
        <path
          d="M248.125 96.2473L244.168 98.5595V97.3425L248.125 95.0303V96.2473Z"
          fill="white"
        />
        <path
          d="M253.25 93.0832L249.875 95.1521V93.9351L253.25 91.8662V93.0832Z"
          fill="white"
        />
        <path
          d="M212.282 121.195L206.23 124.845V123.628L212.282 119.978V121.195Z"
          fill="white"
        />
        <path
          d="M218.098 117.665L214.141 120.099V118.882L218.098 116.448V117.665Z"
          fill="white"
        />
        <path
          d="M221.943 115.354L219.848 116.571V115.354L221.943 114.137V115.354Z"
          fill="white"
        />
        <path
          d="M229.507 110.73L223.688 114.259V113.042L229.507 109.513V110.73Z"
          fill="white"
        />
        <path
          d="M231.367 108.538V109.755L240.096 104.401L239.98 103.184L231.367 108.538Z"
          fill="white"
        />
        <path
          d="M245.335 101.236L241.844 103.426V102.209L245.219 100.019L245.335 101.236Z"
          fill="white"
        />
        <path
          d="M258.135 93.5695L247.078 100.263V99.0459L258.135 92.3525V93.5695Z"
          fill="white"
        />
        <path
          d="M261.161 75.0711L254.992 78.722V77.5051L261.161 73.7324V75.0711Z"
          fill="white"
        />
        <path
          d="M266.863 71.5422L262.906 73.9761V72.7592L266.863 70.3252V71.5422Z"
          fill="white"
        />
        <path
          d="M279.899 63.7531L268.609 70.4465V69.2295L279.782 62.5361L279.899 63.7531Z"
          fill="white"
        />
        <path
          d="M288.158 58.6418L281.641 62.6578V61.4408L288.158 57.4248V58.6418Z"
          fill="white"
        />
        <path
          d="M289.906 56.3297V57.6683L296.075 53.8957V52.6787L289.906 56.3297Z"
          fill="white"
        />
        <path
          d="M301.895 50.4881L297.938 52.8004V51.5834L301.895 49.1494V50.4881Z"
          fill="white"
        />
        <path
          d="M264.537 76.2873L258.02 80.1816V78.9647L264.537 75.0703V76.2873Z"
          fill="white"
        />
        <path
          d="M270.238 72.759L266.281 75.1929V73.976L270.238 71.542V72.759Z"
          fill="white"
        />
        <path
          d="M276.99 68.7424L272.102 71.7848V70.5678L276.99 67.5254V68.7424Z"
          fill="white"
        />
        <path
          d="M284.088 64.4826L278.734 67.7685V66.5515L284.088 63.2656V64.4826Z"
          fill="white"
        />
        <path
          d="M285.953 62.1706V63.3876L291.307 60.1017V58.8848L285.953 62.1706Z"
          fill="white"
        />
        <path
          d="M298.987 55.4777L293.168 59.007V57.79L298.987 54.2607V55.4777Z"
          fill="white"
        />
        <path
          d="M261.161 81.6428L254.992 85.4154V84.1984L261.161 80.4258V81.6428Z"
          fill="white"
        />
        <path
          d="M266.863 78.2355L262.906 80.6695V79.3308L266.863 77.0186V78.2355Z"
          fill="white"
        />
        <path
          d="M275.011 73.2453L268.727 77.1396V75.9227L275.011 72.0283V73.2453Z"
          fill="white"
        />
        <path
          d="M288.164 65.3351L276.875 72.1503V70.9333L288.164 64.1182V65.3351Z"
          fill="white"
        />
        <path
          d="M289.906 63.023V64.24L296.191 60.5891V59.3721L289.906 63.023Z"
          fill="white"
        />
        <path
          d="M301.895 57.0598L297.938 59.4937V58.2767L301.895 55.8428V57.0598Z"
          fill="white"
        />
        <path
          d="M264.536 82.9816L258.949 86.3892V85.1722L264.536 81.7646V82.9816Z"
          fill="white"
        />
        <path
          d="M270.355 79.4523L266.281 81.8863V80.6693L270.355 78.2354V79.4523Z"
          fill="white"
        />
        <path
          d="M278.503 74.5842L272.102 78.4785V77.1398L278.503 73.3672V74.5842Z"
          fill="white"
        />
        <path
          d="M284.203 71.176L280.246 73.4882V72.2713L284.203 69.959V71.176Z"
          fill="white"
        />
        <path
          d="M285.953 68.864V70.081L291.423 66.7951V65.5781L285.953 68.864Z"
          fill="white"
        />
        <path
          d="M298.987 62.1711L293.168 65.7003V64.4834L298.987 60.9541V62.1711Z"
          fill="white"
        />
        <path
          d="M261.161 88.3361L254.992 92.1088V90.8918L261.161 87.1191V88.3361Z"
          fill="white"
        />
        <path
          d="M266.863 84.9285L262.906 87.2408V86.0238L266.863 83.5898V84.9285Z"
          fill="white"
        />
        <path
          d="M276.99 78.8439L268.727 83.8335V82.6166L276.99 77.627V78.8439Z"
          fill="white"
        />
        <path
          d="M264.534 89.674L259.879 92.4731V91.2561L264.534 88.457V89.674Z"
          fill="white"
        />
        <path
          d="M270.355 86.1457L266.281 88.5797V87.3627L270.355 84.9287V86.1457Z"
          fill="white"
        />
        <path
          d="M274.778 83.4689L272.102 85.051V83.834L274.778 82.252V83.4689Z"
          fill="white"
        />
        <path
          d="M209.02 138.597L206.227 140.301V139.084L209.02 137.38V138.597Z"
          fill="white"
        />
        <path
          d="M214.723 135.19L210.766 137.624V136.407L214.723 133.973V135.19Z"
          fill="white"
        />
        <path
          d="M227.525 127.522L216.469 134.094V132.877L227.525 126.184V127.522Z"
          fill="white"
        />
        <path
          d="M233.576 123.749L229.27 126.427V125.21L233.576 122.532V123.749Z"
          fill="white"
        />
        <path
          d="M235.441 121.438V122.655L242.424 118.396V117.179L235.441 121.438Z"
          fill="white"
        />
        <path
          d="M248.125 114.987L244.284 117.421L244.168 116.083L248.125 113.771V114.987Z"
          fill="white"
        />
        <path
          d="M253.363 111.945L249.988 113.892V112.675L253.247 110.606L253.363 111.945Z"
          fill="white"
        />
        <path
          d="M212.395 139.935L206.227 143.586V142.369L212.395 138.718V139.935Z"
          fill="white"
        />
        <path
          d="M218.098 136.406L214.141 138.84V137.623L218.098 135.189V136.406Z"
          fill="white"
        />
        <path
          d="M224.733 132.391L219.961 135.433V134.216L224.733 131.174V132.391Z"
          fill="white"
        />
        <path
          d="M229.62 129.591L226.594 131.416V130.199L229.62 128.374V129.591Z"
          fill="white"
        />
        <path
          d="M231.367 127.28V128.497L240.096 123.264V122.047L231.367 127.28Z"
          fill="white"
        />
        <path
          d="M245.335 120.099L241.844 122.168V120.951L245.335 118.882V120.099Z"
          fill="white"
        />
        <path
          d="M256.389 113.405L247.078 119.004V117.787L256.389 112.188V113.405Z"
          fill="white"
        />
        <path
          d="M261.161 107.078L255.109 110.851V109.634L261.161 105.861V107.078Z"
          fill="white"
        />
        <path
          d="M266.981 103.671L263.023 106.105V104.766L266.981 102.454V103.671Z"
          fill="white"
        />
        <path
          d="M279.899 95.8826L268.727 102.576V101.359L279.899 94.5439V95.8826Z"
          fill="white"
        />
        <path
          d="M288.278 90.7707L281.645 94.7867V93.5697L288.278 89.5537V90.7707Z"
          fill="white"
        />
        <path
          d="M290.023 88.4586V89.6755L296.192 86.0246V84.8076L290.023 88.4586Z"
          fill="white"
        />
        <path
          d="M301.898 82.4953L297.941 84.9293V83.7123L301.898 81.2783V82.4953Z"
          fill="white"
        />
        <path
          d="M264.654 108.417L258.137 112.312V111.095L264.654 107.2V108.417Z"
          fill="white"
        />
        <path
          d="M270.355 104.888L266.398 107.322V106.105L270.355 103.671V104.888Z"
          fill="white"
        />
        <path
          d="M276.99 100.871L272.102 103.914V102.575L276.99 99.6543V100.871Z"
          fill="white"
        />
        <path
          d="M284.204 96.6115L278.851 99.8974L278.734 98.5587L284.204 95.3945V96.6115Z"
          fill="white"
        />
        <path
          d="M285.949 94.3005V95.5175L291.419 92.2316V91.0146L285.949 94.3005Z"
          fill="white"
        />
        <path
          d="M299.1 87.6066L293.164 91.1359V89.9189L299.1 86.3896V87.6066Z"
          fill="white"
        />
        <path
          d="M209.02 156.363L206.227 158.067V156.85L209.02 155.146V156.363Z"
          fill="white"
        />
        <path
          d="M214.723 152.834L210.766 155.268V154.051L214.723 151.617V152.834Z"
          fill="white"
        />
        <path
          d="M227.522 145.167L216.582 151.861V150.644L227.522 143.95V145.167Z"
          fill="white"
        />
        <path
          d="M233.692 141.516L229.27 144.071V142.854L233.692 140.299V141.516Z"
          fill="white"
        />
        <path
          d="M235.441 139.205V140.422L242.541 136.162V134.945L235.441 139.205Z"
          fill="white"
        />
        <path
          d="M248.238 132.754L244.281 135.066V133.849L248.238 131.537V132.754Z"
          fill="white"
        />
        <path
          d="M253.363 129.59L249.988 131.659V130.442L253.363 128.373V129.59Z"
          fill="white"
        />
        <path
          d="M212.396 157.701L206.344 161.352V160.135L212.396 156.484V157.701Z"
          fill="white"
        />
        <path
          d="M218.214 154.173L214.141 156.607V155.39L218.214 152.956V154.173Z"
          fill="white"
        />
        <path
          d="M224.849 150.157L219.961 153.078V151.861L224.849 148.94V150.157Z"
          fill="white"
        />
        <path
          d="M229.62 147.237L226.594 149.062V147.845L229.62 146.02V147.237Z"
          fill="white"
        />
        <path
          d="M231.367 144.923V146.14L240.096 140.907V139.69L231.367 144.923Z"
          fill="white"
        />
        <path
          d="M245.335 137.744L241.844 139.813V138.596L245.335 136.527V137.744Z"
          fill="white"
        />
        <path
          d="M256.389 131.051L247.078 136.649V135.432L256.389 129.834V131.051Z"
          fill="white"
        />
        <path
          d="M209.021 163.057L206.344 164.639V163.422L209.021 161.84V163.057Z"
          fill="white"
        />
        <path
          d="M214.839 159.528L210.766 161.961V160.745L214.839 158.311V159.528Z"
          fill="white"
        />
        <path
          d="M220.655 155.999L216.582 158.555V157.216L220.655 154.782V155.999Z"
          fill="white"
        />
        <path
          d="M233.692 148.21L222.52 154.904V153.687L233.692 146.993V148.21Z"
          fill="white"
        />
        <path
          d="M235.441 145.898V147.115L242.541 142.856V141.639L235.441 145.898Z"
          fill="white"
        />
        <path
          d="M248.238 139.326L244.281 141.76V140.543L248.238 138.109V139.326Z"
          fill="white"
        />
        <path
          d="M253.363 136.283L249.988 138.352V137.135L253.363 135.066V136.283Z"
          fill="white"
        />
        <path
          d="M212.396 164.274L206.344 168.046V166.829L212.396 163.057V164.274Z"
          fill="white"
        />
        <path
          d="M218.211 160.866L214.254 163.3V162.083L218.211 159.649V160.866Z"
          fill="white"
        />
        <path
          d="M224.849 156.851L219.961 159.772V158.555L224.849 155.634V156.851Z"
          fill="white"
        />
        <path
          d="M229.62 153.93L226.594 155.755V154.538L229.62 152.713V153.93Z"
          fill="white"
        />
        <path
          d="M231.367 151.617V152.834L240.096 147.601V146.384L231.367 151.617Z"
          fill="white"
        />
        <path
          d="M245.332 144.438L241.957 146.507V145.29L245.332 143.221V144.438Z"
          fill="white"
        />
        <path
          d="M257.317 137.257L247.191 143.342V142.125L257.317 136.04V137.257Z"
          fill="white"
        />
        <path
          d="M209.021 169.75L206.344 171.332V170.115L209.021 168.533V169.75Z"
          fill="white"
        />
        <path
          d="M214.839 166.221L210.766 168.655V167.438L214.839 165.004V166.221Z"
          fill="white"
        />
        <path
          d="M228.453 158.068L216.582 165.126V163.909L228.453 156.851V158.068Z"
          fill="white"
        />
        <path
          d="M233.693 154.781L227.758 158.432V157.215L233.693 153.564V154.781Z"
          fill="white"
        />
        <path
          d="M235.441 152.591V153.808L242.541 149.549V148.332L235.441 152.591Z"
          fill="white"
        />
        <path
          d="M248.238 146.02L244.281 148.454V147.237L248.238 144.803V146.02Z"
          fill="white"
        />
        <path
          d="M253.363 142.977L249.988 144.924V143.707L253.363 141.76V142.977Z"
          fill="white"
        />
        <path
          d="M212.396 170.967L206.344 174.74V173.523L212.396 169.75V170.967Z"
          fill="white"
        />
        <path
          d="M218.211 167.56L214.254 169.994V168.655L218.211 166.343V167.56Z"
          fill="white"
        />
        <path
          d="M222.056 165.248L219.961 166.465V165.248L222.056 163.909V165.248Z"
          fill="white"
        />
        <path
          d="M229.62 160.623L223.801 164.152V162.935L229.62 159.406V160.623Z"
          fill="white"
        />
        <path
          d="M231.48 158.31V159.527L240.093 154.294V153.077L231.48 158.31Z"
          fill="white"
        />
        <path
          d="M245.449 151.131L241.957 153.2V151.983L245.332 149.914L245.449 151.131Z"
          fill="white"
        />
        <path
          d="M258.248 143.342L247.191 150.035V148.818L258.248 142.125V143.342Z"
          fill="white"
        />
        <path
          d="M261.278 124.845L255.109 128.496V127.279L261.278 123.628V124.845Z"
          fill="white"
        />
        <path
          d="M266.981 121.316L263.023 123.75V122.533L266.981 120.099V121.316Z"
          fill="white"
        />
        <path
          d="M279.899 113.528L268.727 120.343V119.004L279.899 112.311V113.528Z"
          fill="white"
        />
        <path
          d="M288.275 108.537L281.758 112.432V111.215L288.275 107.32V108.537Z"
          fill="white"
        />
        <path
          d="M290.023 106.225V107.442L296.192 103.669V102.452L290.023 106.225Z"
          fill="white"
        />
        <path
          d="M302.012 100.262L298.055 102.696V101.357L301.895 99.0449L302.012 100.262Z"
          fill="white"
        />
        <path
          d="M264.654 126.183L258.137 130.078V128.861L264.654 124.845V126.183Z"
          fill="white"
        />
        <path
          d="M270.355 122.654L266.398 125.088V123.871L270.355 121.438V122.654Z"
          fill="white"
        />
        <path
          d="M277.107 118.638L272.219 121.559V120.342L277.107 117.421V118.638Z"
          fill="white"
        />
        <path
          d="M284.205 114.257L278.852 117.543V116.326L284.205 113.04V114.257Z"
          fill="white"
        />
        <path
          d="M286.07 111.945V113.162L291.424 109.876V108.659L286.07 111.945Z"
          fill="white"
        />
        <path
          d="M299.104 105.373L293.285 108.902V107.685L299.104 104.034V105.373Z"
          fill="white"
        />
        <path
          d="M261.278 131.538L255.109 135.189V133.972L261.278 130.321V131.538Z"
          fill="white"
        />
        <path
          d="M266.981 128.009L263.023 130.443V129.226L266.981 126.792V128.009Z"
          fill="white"
        />
        <path
          d="M275.128 123.141L268.844 126.913V125.696L275.128 121.924V123.141Z"
          fill="white"
        />
        <path
          d="M288.281 115.231L276.992 122.046V120.829L288.281 114.014V115.231Z"
          fill="white"
        />
        <path
          d="M290.023 112.918V114.135L296.308 110.362V109.146L290.023 112.918Z"
          fill="white"
        />
        <path
          d="M302.012 106.955L298.055 109.268V108.051L302.012 105.738V106.955Z"
          fill="white"
        />
        <path
          d="M264.653 132.755L259.066 136.163V134.946L264.653 131.538V132.755Z"
          fill="white"
        />
        <path
          d="M270.472 129.348L266.398 131.782V130.443L270.472 128.131V129.348Z"
          fill="white"
        />
        <path
          d="M278.62 124.358L272.219 128.252V127.035L278.62 123.141V124.358Z"
          fill="white"
        />
        <path
          d="M284.32 120.95L280.363 123.263V122.046L284.32 119.733V120.95Z"
          fill="white"
        />
        <path
          d="M286.07 118.638V119.855L291.54 116.57V115.353L286.07 118.638Z"
          fill="white"
        />
        <path
          d="M299.104 111.945L293.285 115.595V114.257L299.104 110.728V111.945Z"
          fill="white"
        />
        <path
          d="M261.278 138.232L255.109 141.883V140.666L261.278 137.015V138.232Z"
          fill="white"
        />
        <path
          d="M266.981 134.702L263.023 137.136V135.919L266.981 133.485V134.702Z"
          fill="white"
        />
        <path
          d="M277.107 128.617L268.844 133.607V132.39L277.107 127.4V128.617Z"
          fill="white"
        />
        <path
          d="M288.279 121.803L278.852 127.523V126.306L288.279 120.586V121.803Z"
          fill="white"
        />
        <path
          d="M290.145 119.612V120.828L296.313 117.056V115.839L290.145 119.612Z"
          fill="white"
        />
        <path
          d="M302.012 113.649L298.055 115.961V114.744L302.012 112.432V113.649Z"
          fill="white"
        />
        <path
          d="M264.651 139.449L259.996 142.37V141.031L264.651 138.232V139.449Z"
          fill="white"
        />
        <path
          d="M270.472 136.041L266.398 138.353V137.136L270.472 134.824V136.041Z"
          fill="white"
        />
        <path
          d="M274.896 133.241L272.219 134.945V133.728L274.896 132.024V133.241Z"
          fill="white"
        />
        <path
          d="M284.323 127.644L276.758 132.147V130.93L284.323 126.427V127.644Z"
          fill="white"
        />
        <path
          d="M286.07 125.332V126.549L291.54 123.263V122.046L286.07 125.332Z"
          fill="white"
        />
        <path
          d="M299.104 118.638L293.285 122.167V120.95L299.104 117.421V118.638Z"
          fill="white"
        />
        <path
          d="M209.133 191.048L206.34 192.752V191.535L209.133 189.831V191.048Z"
          fill="white"
        />
        <path
          d="M214.836 187.641L210.879 189.953V188.736L214.836 186.424V187.641Z"
          fill="white"
        />
        <path
          d="M227.638 179.852L216.582 186.545V185.328L227.638 178.635V179.852Z"
          fill="white"
        />
        <path
          d="M233.689 176.2L229.383 178.878V177.539L233.689 174.983V176.2Z"
          fill="white"
        />
        <path
          d="M235.555 173.889V175.106L242.538 170.847V169.63L235.555 173.889Z"
          fill="white"
        />
        <path
          d="M248.235 167.439L244.395 169.751V168.534L248.235 166.222V167.439Z"
          fill="white"
        />
        <path
          d="M253.477 164.275L250.102 166.343V165.126L253.477 163.058V164.275Z"
          fill="white"
        />
        <path
          d="M212.508 192.386L206.34 196.037V194.82L212.508 191.169V192.386Z"
          fill="white"
        />
        <path
          d="M218.211 188.858L214.254 191.292V190.075L218.211 187.641V188.858Z"
          fill="white"
        />
        <path
          d="M224.962 184.842L220.074 187.763V186.546L224.962 183.625V184.842Z"
          fill="white"
        />
        <path
          d="M229.733 181.921L226.707 183.747V182.53L229.733 180.704V181.921Z"
          fill="white"
        />
        <path
          d="M231.48 179.73V180.947L240.209 175.592V174.375L231.48 179.73Z"
          fill="white"
        />
        <path
          d="M245.445 172.429L241.953 174.619V173.281L245.445 171.212V172.429Z"
          fill="white"
        />
        <path
          d="M256.502 165.857L247.191 171.455V170.117L256.502 164.519V165.857Z"
          fill="white"
        />
        <path
          d="M209.133 197.741L206.34 199.445V198.228L209.133 196.524V197.741Z"
          fill="white"
        />
        <path
          d="M214.836 194.334L210.879 196.646V195.429L214.836 192.995V194.334Z"
          fill="white"
        />
        <path
          d="M220.772 190.684L216.582 193.239V192.022L220.772 189.467V190.684Z"
          fill="white"
        />
        <path
          d="M233.805 182.894L222.516 189.587V188.37L233.688 181.677L233.805 182.894Z"
          fill="white"
        />
        <path
          d="M212.508 199.08L206.34 202.731V201.514L212.508 197.863V199.08Z"
          fill="white"
        />
        <path
          d="M218.327 195.551L214.254 197.985V196.768L218.211 194.334L218.327 195.551Z"
          fill="white"
        />
        <path
          d="M224.962 191.535L220.074 194.456V193.239L224.962 190.318V191.535Z"
          fill="white"
        />
        <path
          d="M229.733 188.614L226.707 190.44V189.223L229.733 187.397V188.614Z"
          fill="white"
        />
        <path
          d="M231.48 186.301V187.518L240.209 182.285V181.068L231.48 186.301Z"
          fill="white"
        />
        <path
          d="M261.275 159.529L255.223 163.302V161.963L261.275 158.312V159.529Z"
          fill="white"
        />
        <path
          d="M267.094 156.122L263.137 158.434V157.217L267.094 154.783V156.122Z"
          fill="white"
        />
        <path
          d="M280.013 148.212L268.84 155.027V153.81L280.013 146.995V148.212Z"
          fill="white"
        />
        <path
          d="M288.392 143.222L281.758 147.238V145.899L288.392 142.005V143.222Z"
          fill="white"
        />
        <path
          d="M290.137 140.909V142.126L296.305 138.475V137.137L290.137 140.909Z"
          fill="white"
        />
        <path
          d="M302.012 134.946L298.055 137.38V136.163L302.012 133.729V134.946Z"
          fill="white"
        />
        <path
          d="M264.767 160.868L258.25 164.763V163.546L264.767 159.651V160.868Z"
          fill="white"
        />
        <path
          d="M270.469 157.339L266.512 159.773V158.556L270.469 156.122V157.339Z"
          fill="white"
        />
        <path
          d="M277.103 153.322L272.215 156.243V155.026L277.103 152.105V153.322Z"
          fill="white"
        />
        <path
          d="M284.319 148.942L278.965 152.227V151.01L284.319 147.725V148.942Z"
          fill="white"
        />
        <path
          d="M286.062 146.752V147.969L291.533 144.683V143.466L286.062 146.752Z"
          fill="white"
        />
        <path
          d="M299.213 140.058L293.277 143.587V142.37L299.213 138.841V140.058Z"
          fill="white"
        />
        <path
          d="M261.275 166.223L255.223 169.874V168.657L261.275 165.006V166.223Z"
          fill="white"
        />
        <path
          d="M267.094 162.694L263.137 165.128V163.911L267.094 161.477V162.694Z"
          fill="white"
        />
        <path
          d="M275.241 157.825L268.84 161.72V160.503L275.241 156.608V157.825Z"
          fill="white"
        />
        <path
          d="M264.766 167.561L259.18 170.847V169.63L264.766 166.223V167.561Z"
          fill="white"
        />
        <path
          d="M270.469 164.032L266.512 166.466V165.249L270.469 162.815V164.032Z"
          fill="white"
        />
        <path
          d="M278.617 159.042L272.332 162.937V161.72L278.617 157.825V159.042Z"
          fill="white"
        />
        <path
          d="M209.017 178.026L206.34 179.729V178.512L209.017 176.809V178.026Z"
          fill="white"
        />
        <path
          d="M214.836 174.618L210.879 176.93V175.713L214.836 173.279V174.618Z"
          fill="white"
        />
        <path
          d="M227.522 166.829L216.582 173.523V172.306L227.522 165.612V166.829Z"
          fill="white"
        />
        <path
          d="M233.689 163.178L229.383 165.734V164.517L233.689 161.961V163.178Z"
          fill="white"
        />
        <path
          d="M235.438 160.867V162.084L242.537 157.824V156.607L235.438 160.867Z"
          fill="white"
        />
        <path
          d="M248.238 154.416L244.281 156.728V155.511L248.238 153.199V154.416Z"
          fill="white"
        />
        <path
          d="M253.359 151.252L249.984 153.321V152.104L253.359 150.035V151.252Z"
          fill="white"
        />
        <path
          d="M212.508 179.363L206.34 183.014V181.797L212.508 178.146V179.363Z"
          fill="white"
        />
        <path
          d="M218.211 175.835L214.254 178.269V177.052L218.211 174.618V175.835Z"
          fill="white"
        />
        <path
          d="M224.845 171.82L219.957 174.74V173.523L224.845 170.603V171.82Z"
          fill="white"
        />
        <path
          d="M229.616 168.899L226.706 170.724L226.59 169.507L229.616 167.682V168.899Z"
          fill="white"
        />
        <path
          d="M231.48 166.586V167.803L240.209 162.57V161.353L231.48 166.586Z"
          fill="white"
        />
        <path
          d="M245.445 159.406L241.953 161.475V160.258L245.445 158.189V159.406Z"
          fill="white"
        />
        <path
          d="M256.502 152.713L247.191 158.311V157.094L256.502 151.496V152.713Z"
          fill="white"
        />
        <path
          d="M261.274 146.507L255.105 150.158V148.941L261.274 145.29V146.507Z"
          fill="white"
        />
        <path
          d="M267.093 142.978L263.02 145.412V144.195L267.093 141.761V142.978Z"
          fill="white"
        />
        <path
          d="M280.013 135.19L268.84 142.005V140.788L280.013 133.973V135.19Z"
          fill="white"
        />
        <path
          d="M288.388 130.199L281.754 134.094V132.877L288.271 128.982L288.388 130.199Z"
          fill="white"
        />
        <path
          d="M290.141 127.887V129.104L296.309 125.331V124.114L290.141 127.887Z"
          fill="white"
        />
        <path
          d="M302.008 121.924L298.051 124.358V123.019L302.008 120.707V121.924Z"
          fill="white"
        />
        <path
          d="M264.647 147.846L258.246 151.74V150.523L264.647 146.507V147.846Z"
          fill="white"
        />
        <path
          d="M270.469 144.317L266.512 146.751V145.534L270.469 143.1V144.317Z"
          fill="white"
        />
        <path
          d="M277.103 140.3L272.215 143.221V142.004L277.103 139.083V140.3Z"
          fill="white"
        />
        <path
          d="M284.318 135.919L278.848 139.205V137.988L284.318 134.702V135.919Z"
          fill="white"
        />
        <path
          d="M286.066 133.607V134.946L291.536 131.66V130.321L286.066 133.607Z"
          fill="white"
        />
        <path
          d="M299.1 127.035L293.281 130.565V129.348L299.1 125.818V127.035Z"
          fill="white"
        />
        <path
          d="M149.662 142.247L140.934 147.602V146.263L149.662 141.03V142.247Z"
          fill="white"
        />
        <path
          d="M157.109 137.745L151.523 141.153L151.406 139.936L157.109 136.528V137.745Z"
          fill="white"
        />
        <path
          d="M158.855 135.433V136.65L164.442 133.364V132.147L158.855 135.433Z"
          fill="white"
        />
        <path
          d="M170.145 129.834L166.188 132.268V131.051L170.145 128.617V129.834Z"
          fill="white"
        />
        <path
          d="M180.507 123.628L171.895 128.861V127.522L180.507 122.411V123.628Z"
          fill="white"
        />
        <path
          d="M145.939 147.847L141.051 150.768V149.551L145.939 146.63V147.847Z"
          fill="white"
        />
        <path
          d="M153.154 143.465L147.684 146.751V145.534L153.154 142.248V143.465Z"
          fill="white"
        />
        <path
          d="M154.898 141.274V142.491L159.67 139.57V138.354L154.898 141.274Z"
          fill="white"
        />
        <path
          d="M167.354 134.945L161.418 138.475V137.258L167.354 133.729V134.945Z"
          fill="white"
        />
        <path
          d="M180.503 127.035L169.098 133.85V132.633L180.503 125.818V127.035Z"
          fill="white"
        />
        <path
          d="M142.214 153.444L140.934 154.174V152.957L142.214 152.227V153.444Z"
          fill="white"
        />
        <path
          d="M157.109 144.438L144.074 152.348V151.131L157.109 143.221V144.438Z"
          fill="white"
        />
        <path
          d="M158.973 142.126V143.343L164.443 140.057V138.719L158.973 142.126Z"
          fill="white"
        />
        <path
          d="M170.145 136.528L166.304 138.961L166.188 137.745L170.145 135.311V136.528Z"
          fill="white"
        />
        <path
          d="M180.504 130.321L172.008 135.433V134.216L180.504 129.104V130.321Z"
          fill="white"
        />
        <path
          d="M145.939 154.54L141.051 157.461V156.244L145.939 153.323V154.54Z"
          fill="white"
        />
        <path
          d="M153.154 150.158L147.684 153.444V152.227L153.154 148.941V150.158Z"
          fill="white"
        />
        <path
          d="M154.898 147.846V149.185L159.67 146.264V145.047L154.898 147.846Z"
          fill="white"
        />
        <path
          d="M167.354 141.639L161.534 145.168L161.418 143.951L167.354 140.422V141.639Z"
          fill="white"
        />
        <path
          d="M180.503 133.729L169.098 140.544V139.327L180.503 132.391V133.729Z"
          fill="white"
        />
        <path
          d="M150.361 155.149L140.934 160.868V159.651L150.361 153.932V155.149Z"
          fill="white"
        />
        <path
          d="M157.111 151.131L152.223 154.052V152.835L157.111 149.914V151.131Z"
          fill="white"
        />
        <path
          d="M158.973 148.82V150.037L164.443 146.629V145.412L158.973 148.82Z"
          fill="white"
        />
        <path
          d="M143.495 162.693L141.051 164.153V162.936L143.495 161.476V162.693Z"
          fill="white"
        />
        <path
          d="M153.152 156.852L145.238 161.598V160.381L153.152 155.635V156.852Z"
          fill="white"
        />
        <path
          d="M154.898 154.539V155.756L161.183 151.984V150.767L154.898 154.539Z"
          fill="white"
        />
        <path
          d="M153.852 135.31L140.934 143.221V139.326L153.852 131.416V135.31Z"
          fill="white"
        />
        <path
          d="M166.188 127.888L157.227 133.364V129.47L166.188 123.993V127.888Z"
          fill="white"
        />
        <path
          d="M214.719 94.664L206.34 99.7753V103.67L214.719 98.5583L226.591 91.3781V87.6055L214.719 94.664Z"
          fill="white"
        />
        <path
          d="M147.921 210.155L141.055 214.293V210.398L147.921 206.261V210.155Z"
          fill="white"
        />
        <path
          d="M164.564 200.054L151.18 208.087V204.192L164.564 196.16V200.054Z"
          fill="white"
        />
        <path
          d="M214.841 144.682L206.461 149.794V153.688L214.841 148.577L221.009 144.926V141.031L214.841 144.682Z"
          fill="white"
        />
        <path
          d="M149.779 162.084L140.934 167.439V166.222L149.779 160.867V162.084Z"
          fill="white"
        />
        <path
          d="M157.23 157.581L151.527 160.989V159.772L157.23 156.364V157.581Z"
          fill="white"
        />
        <path
          d="M158.973 155.269V156.608L164.559 153.2V151.983L158.973 155.269Z"
          fill="white"
        />
        <path
          d="M170.262 149.792L166.305 152.104V150.887L170.262 148.575V149.792Z"
          fill="white"
        />
        <path
          d="M180.504 143.586L172.008 148.697V147.48L180.504 142.369V143.586Z"
          fill="white"
        />
        <path
          d="M145.939 167.682L141.051 170.724V169.507L145.939 166.465V167.682Z"
          fill="white"
        />
        <path
          d="M153.154 163.423L147.684 166.709V165.492L153.154 162.206V163.423Z"
          fill="white"
        />
        <path
          d="M154.898 161.11V162.327L159.787 159.406V158.189L154.898 161.11Z"
          fill="white"
        />
        <path
          d="M149.779 169.265L140.934 174.498V173.281L149.779 167.927V169.265Z"
          fill="white"
        />
        <path
          d="M157.23 164.762L151.527 168.169V166.952L157.23 163.545V164.762Z"
          fill="white"
        />
        <path
          d="M158.973 162.451V163.668L164.559 160.26V159.043L158.973 162.451Z"
          fill="white"
        />
        <path
          d="M170.262 156.852L166.305 159.286V157.947L170.262 155.635V156.852Z"
          fill="white"
        />
        <path
          d="M180.504 150.646L172.008 155.757V154.54L180.504 149.429V150.646Z"
          fill="white"
        />
        <path
          d="M145.939 174.864L141.051 177.785V176.568L145.939 173.647V174.864Z"
          fill="white"
        />
        <path
          d="M153.151 170.483L147.797 173.768V172.551L153.151 169.266V170.483Z"
          fill="white"
        />
        <path
          d="M154.898 168.17V169.387L159.787 166.466V165.249L154.898 168.17Z"
          fill="white"
        />
        <path
          d="M167.35 161.964L161.531 165.493V164.276L167.35 160.625V161.964Z"
          fill="white"
        />
        <path
          d="M180.504 153.932L169.215 160.869V159.652L180.504 152.715V153.932Z"
          fill="white"
        />
        <path
          d="M142.33 180.341L140.934 181.193V179.976L142.33 179.124V180.341Z"
          fill="white"
        />
        <path
          d="M157.226 171.334L144.074 179.366V178.028L157.226 170.117V171.334Z"
          fill="white"
        />
        <path
          d="M158.973 169.144V170.361L164.559 166.953V165.736L158.973 169.144Z"
          fill="white"
        />
        <path
          d="M170.262 163.545L166.305 165.857V164.64L170.262 162.328V163.545Z"
          fill="white"
        />
        <path
          d="M180.504 157.339L172.008 162.45V161.233L180.504 156.122V157.339Z"
          fill="white"
        />
        <path
          d="M145.936 181.558L141.164 184.479V183.262L145.936 180.341V181.558Z"
          fill="white"
        />
        <path
          d="M153.151 177.176L147.797 180.462V179.245L153.151 175.959V177.176Z"
          fill="white"
        />
        <path
          d="M154.898 174.864V176.081L159.787 173.16V171.943L154.898 174.864Z"
          fill="white"
        />
        <path
          d="M167.35 168.535L161.531 172.065V170.848L167.35 167.318V168.535Z"
          fill="white"
        />
        <path
          d="M180.504 160.625L169.215 167.562V166.345L180.504 159.408V160.625Z"
          fill="white"
        />
        <path
          d="M150.478 182.166L141.051 187.886V186.669L150.478 180.949V182.166Z"
          fill="white"
        />
        <path
          d="M157.227 178.028L152.223 181.07V179.853L157.227 176.811V178.028Z"
          fill="white"
        />
        <path
          d="M158.973 175.716V177.054L164.559 173.647V172.43L158.973 175.716Z"
          fill="white"
        />
        <path
          d="M143.608 189.711L141.164 191.171V189.954L143.608 188.372V189.711Z"
          fill="white"
        />
        <path
          d="M153.153 183.869L145.355 188.616V187.399L153.153 182.652V183.869Z"
          fill="white"
        />
        <path
          d="M155.02 181.557V182.774L159.791 179.854V178.637L155.02 181.557Z"
          fill="white"
        />
        <path
          d="M143.613 233.643L141.285 235.103V233.886L143.613 232.426V233.643Z"
          fill="white"
        />
        <path
          d="M149.783 194.456L141.055 199.689V198.472L149.783 193.117V194.456Z"
          fill="white"
        />
        <path
          d="M157.235 189.953L151.648 193.36V192.143L157.235 188.614V189.953Z"
          fill="white"
        />
        <path
          d="M158.977 187.641V188.858L164.563 185.45V184.233L158.977 187.641Z"
          fill="white"
        />
        <path
          d="M170.266 182.042L166.309 184.354V183.137L170.266 180.825V182.042Z"
          fill="white"
        />
        <path
          d="M180.628 175.836L172.132 180.947L172.016 179.73L180.628 174.619V175.836Z"
          fill="white"
        />
        <path
          d="M146.06 200.055L141.172 202.976V201.759L146.06 198.838V200.055Z"
          fill="white"
        />
        <path
          d="M153.275 195.673L147.805 198.959V197.742L153.275 194.456V195.673Z"
          fill="white"
        />
        <path
          d="M155.02 193.36V194.577L159.791 191.656V190.439L155.02 193.36Z"
          fill="white"
        />
        <path
          d="M151.533 307.393L331.578 198.716C328.32 182.165 315.634 158.799 301.668 160.26C271.292 163.545 154.442 217.701 151.416 268.936C150.951 276.481 151.067 294.979 151.416 302.525C151.416 304.107 151.416 305.689 151.533 307.393Z"
          fill="#455FDC"
        />
        <path
          d="M273.503 211.251L270.71 194.943L214.962 168.778C214.962 168.778 215.777 186.059 214.264 197.134C213.565 202.124 214.496 207.235 217.057 211.494C224.505 223.908 243.127 237.173 265.589 225.49C265.589 225.49 275.249 220.865 273.503 211.251Z"
          fill="#FFB586"
        />
        <path
          d="M289.101 161.476C288.286 153.444 288.984 148.82 286.657 143.952C286.075 142.857 285.493 141.761 285.376 140.544C285.376 138.354 287.471 136.528 286.657 131.782C286.307 129.835 285.493 127.888 284.445 126.184C283.398 124.602 282.001 122.168 281.303 120.586C277.928 112.31 275.135 103.792 268.734 98.0717C253.138 84.0765 238.707 80.9123 227.417 81.2774C203.209 82.1293 190.058 105.617 190.524 121.316C191.222 151.497 216.826 173.89 216.826 173.89C221.947 183.26 230.56 195.795 247.319 202.367C277.811 214.415 287.006 203.219 289.915 201.15C294.222 197.864 290.148 188.372 289.799 186.303C289.566 184.599 290.846 178.758 290.032 171.334C290.032 171.334 291.196 170.36 291.545 169.874C292.127 168.535 293.64 166.71 289.101 161.476Z"
          fill="#FFC799"
        />
        <path
          d="M291.426 169.265C289.796 170.969 286.77 169.996 284.792 169.996C283.977 170.117 283.046 170.361 282.115 170.848C280.486 171.699 278.973 172.551 277.925 172.673C277.111 172.795 276.529 172.065 276.529 171.334C275.947 172.795 277.111 174.133 280.835 172.43C282.93 171.456 283.861 171.334 286.77 171.821C287.352 171.943 287.818 171.943 288.283 171.943C289.564 171.943 290.727 171.091 291.542 169.874C291.775 169.509 291.891 169.265 291.891 168.9C291.775 169.022 291.542 169.144 291.426 169.265Z"
          fill="#F0A986"
        />
        <path
          d="M273.388 116.692C257.559 127.645 229.511 128.74 224.041 142.248C221.48 148.455 223.924 155.513 225.437 162.085C225.903 164.276 225.787 167.318 223.692 167.805C222.644 168.048 221.597 167.318 220.782 166.588C218.454 164.397 216.825 161.477 214.846 158.921C212.868 156.365 210.075 154.053 206.932 154.053C204.256 153.931 204.023 162.694 201.462 161.72C196.807 153.445 174.694 121.438 194.13 103.427C193.665 95.0294 208.795 69.3511 241.033 77.2615C263.495 82.8596 277.926 100.384 277.926 108.295C278.043 112.311 276.646 114.501 273.388 116.692Z"
          fill="#2035A4"
        />
        <path
          opacity="0.4"
          d="M287.82 162.936C288.285 163.302 289.449 164.884 289.565 164.275C289.565 164.275 289.565 164.275 289.565 164.153C289.333 163.788 288.983 163.423 288.751 163.058C288.052 156.486 288.983 152.714 287.936 148.211C283.397 148.576 281.186 151.74 280.255 152.592C278.974 153.809 281.884 158.312 287.82 162.936Z"
          fill="#FFE0BA"
        />
        <path
          d="M225.788 183.138C224.624 168.778 212.753 146.629 200.184 155.27C197.158 157.338 196.692 162.085 197.856 165.736C199.02 169.387 201.231 172.794 204.373 174.741C218.456 183.625 225.788 183.138 225.788 183.138Z"
          fill="#FFC799"
        />
        <path
          opacity="0.4"
          d="M256.396 151.62C250.228 153.81 243.594 156.853 243.594 156.853C254.65 146.63 265.939 146.63 270.246 146.63C270.246 146.752 261.4 149.916 256.396 151.62Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.4"
          d="M251.159 167.44C247.551 169.144 246.852 172.429 250.228 174.863C253.021 176.932 266.289 182.044 269.198 179.731C272.922 176.811 271.642 164.397 271.526 163.302C271.409 162.085 270.827 157.582 266.87 160.746C260.353 165.979 255.581 165.371 251.159 167.44Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.4"
          d="M285.027 166.345C288.053 170.239 290.497 170.361 291.893 169.144C292.359 168.048 293.523 166.223 289.216 161.477C286.656 158.678 278.393 149.185 279.091 144.926C279.44 142.492 280.953 140.18 283.979 137.867C285.492 136.772 286.307 135.677 286.889 134.581C286.889 134.095 286.889 133.608 286.889 133.121C286.772 133.364 286.656 133.486 286.54 133.73C285.143 136.285 279.557 138.963 277.694 142.979C277.229 143.952 276.996 144.926 276.88 146.021C276.414 151.741 279.44 157.582 282.35 162.329C283.048 163.667 283.979 165.128 285.027 166.345Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.6"
          d="M291.429 164.519C290.847 163.788 290.149 163.058 289.218 162.085C285.493 158.312 282.235 153.931 279.674 149.063C279.558 148.698 279.441 148.576 279.441 148.576C279.907 153.931 287.472 165.005 289.334 165.979C290.963 166.831 292.127 165.614 291.429 164.519Z"
          fill="#FFF3C4"
        />
        <path
          d="M280.838 182.53C282.002 181.556 284.097 181.07 285.028 180.583C285.61 180.339 285.959 180.096 286.192 179.853C287.123 179.244 288.287 179.122 289.334 179.488C289.567 179.609 289.8 179.731 290.032 179.609C289.334 181.922 287.356 183.26 286.541 185.086C285.028 188.372 284.795 187.033 282.933 188.25C280.023 190.197 280.256 191.414 275.601 191.049C275.019 191.049 271.527 190.197 271.527 190.197C274.902 187.52 277.463 185.086 280.838 182.53Z"
          fill="#F0A986"
        />
        <path
          d="M289.916 180.096C288.519 184.112 287.006 188.128 283.166 190.44C279.325 192.752 275.019 190.44 271.527 190.318C274.902 188.006 280.14 184.599 284.097 182.53C287.705 180.704 289.916 180.096 289.916 180.096Z"
          fill="#7C4040"
        />
        <path
          d="M282.118 189.223C280.489 189.953 275.135 190.683 271.527 190.318C271.993 190.562 274.204 191.657 278.045 192.266C281.071 192.752 284.33 191.9 286.657 189.71C288.519 187.884 290.032 184.842 290.032 180.096C287.821 184.964 287.937 186.546 282.118 189.223Z"
          fill="#F0A986"
        />
        <path
          d="M204.375 159.163C202.862 159.528 201.582 160.989 201.116 162.571C200.651 164.153 201.116 165.978 202.047 167.317C203.211 169.021 204.608 169.021 205.19 168.534C205.422 168.291 205.422 167.926 205.655 167.804C209.147 163.91 213.802 174.619 216.246 175.471C217.294 175.836 216.712 171.09 214.966 167.317C213.918 165.005 209.496 157.946 204.375 159.163Z"
          fill="#F0A986"
        />
        <path
          opacity="0.4"
          d="M277.927 201.15C276.763 205.653 287.121 202.732 289.565 200.055C290.845 198.594 291.311 195.917 290.729 194.335C288.634 188.98 278.509 199.081 277.927 201.15Z"
          fill="#FFE0BA"
        />
        <path
          opacity="0.5"
          d="M285.843 187.154C284.912 187.884 283.748 188.615 281.886 189.467C281.536 189.588 280.955 189.832 280.256 189.953C280.14 190.075 280.023 190.197 280.023 190.318C280.838 191.292 287.821 187.154 285.843 187.154Z"
          fill="#FFE0BA"
        />
        <path
          d="M284.094 182.53C281.068 184.112 277.111 186.546 273.969 188.736C285.258 185.207 288.168 182.895 288.633 180.461C287.586 180.948 286.073 181.556 284.094 182.53Z"
          fill="white"
        />
        <path
          d="M196.923 155.634C193.082 166.222 201.345 185.693 214.264 186.91C229.859 187.032 227.997 173.037 224.04 162.936C214.729 139.205 200.531 145.776 196.923 155.634Z"
          fill="#10173F"
        />
        <path
          d="M257.093 81.8854C233.933 68.8637 179.465 93.2033 201.927 151.253C202.858 155.148 212.751 155.878 211.587 153.2C198.668 123.75 208.212 101.6 225.088 91.2561C235.911 84.6844 252.903 81.5203 262.447 86.9967C262.447 86.3882 261.05 84.1976 257.093 81.8854Z"
          fill="#10173F"
        />
        <path
          d="M216.361 165.492C212.753 157.825 206.003 153.566 201.348 155.999C196.692 158.433 195.761 166.587 199.369 174.254C202.977 181.921 209.727 186.181 214.383 183.747C219.038 181.313 219.969 173.159 216.361 165.492Z"
          fill="url(#paint10_linear_1926_44029)"
        />
        <path
          d="M255.699 201.027C233.237 201.027 219.737 183.99 219.504 183.746L221.017 182.529C221.133 182.773 237.311 203.096 263.497 198.35L263.846 200.297C261.053 200.784 258.26 201.027 255.699 201.027Z"
          fill="#10173F"
        />
        <path
          d="M273.04 197.134C273.506 199.203 271.527 201.272 268.734 202.002C265.941 202.61 263.264 201.515 262.798 199.568C262.333 197.499 264.311 195.43 267.105 194.7C269.898 193.97 272.575 195.065 273.04 197.134Z"
          fill="#10173F"
        />
        <path
          d="M146.297 310.679C145.715 310.679 145.25 310.557 144.901 310.314C143.969 309.827 143.504 308.731 143.504 307.393V141.762C143.504 138.962 145.599 135.433 148.392 133.729L356.486 8.01524C357.999 7.16335 359.396 6.91995 360.443 7.52844C361.374 8.01523 361.84 9.11052 361.84 10.4492V176.08C361.84 178.879 359.745 182.409 356.952 184.113L148.858 309.948C148.043 310.435 147.112 310.679 146.297 310.679ZM359.047 8.50203C358.465 8.50203 357.766 8.74543 357.068 9.11052L148.858 134.825C146.53 136.285 144.551 139.328 144.551 141.762V307.393C144.551 308.001 144.668 308.853 145.366 309.34C146.064 309.705 147.112 309.583 148.276 308.853L356.486 183.139C358.814 181.679 360.792 178.636 360.792 176.202V10.5709C360.792 9.9624 360.676 9.11052 359.978 8.62373C359.628 8.50203 359.396 8.50203 359.047 8.50203Z"
          fill="#99E2FF"
        />
        <path
          d="M331.461 98.679V212.832C331.461 215.022 333.207 215.874 335.418 214.536L398.265 176.566C400.476 175.227 402.222 172.428 402.222 170.116V55.9629L331.461 98.679Z"
          fill="#99E2FF"
        />
        <path
          d="M402.339 58.7622V54.016C402.339 51.8254 400.593 50.9735 398.382 52.3122L335.418 90.282C333.207 91.6207 331.461 94.4198 331.461 96.732V101.478L402.339 58.7622Z"
          fill="#455FDC"
        />
        <path
          d="M342.868 146.263L341.355 147.237V147.967L342.868 146.994V146.263ZM356.601 137.866L354.157 139.327V140.057L356.601 138.596V137.866ZM362.537 135.067L364.748 133.728V132.998L362.537 134.337V135.067ZM351.713 142.978L349.036 144.681V145.411L351.713 143.708V142.978ZM360.209 137.866L355.321 140.787V141.517L360.209 138.596V137.866ZM361.257 137.988L363.235 136.771V136.041L361.257 137.258V137.988ZM368.705 131.416L372.197 129.347V128.617L368.705 130.686V131.416ZM376.27 126.792L382.555 123.019V122.289L376.27 126.061V126.792ZM373.942 129.591L370.334 131.781V132.511L373.942 130.321V129.591ZM384.999 122.897L381.973 124.723V125.453L384.999 123.628V122.897ZM389.072 120.463L386.046 122.289V123.019L389.072 121.194V120.463ZM393.262 117.908L390.003 119.855V120.585L393.262 118.638V117.908ZM342.868 154.661L341.355 155.634V156.364L342.868 155.391V154.661ZM343.799 154.782L346.01 153.444V152.713L343.799 154.052V154.782ZM347.058 152.835L353.226 149.062V148.332L347.058 152.105V152.835ZM361.606 143.343L357.649 145.777V146.507L361.606 144.073V143.343ZM347.989 153.687L345.777 155.026V155.756L347.989 154.417V153.687ZM352.644 151.618L354.39 150.645V149.914L352.644 150.888V151.618ZM355.321 149.914L360.209 146.994V146.263L355.321 149.184V149.914ZM364.166 144.681L369.403 141.517V140.787L364.166 143.951V144.681ZM343.799 159.042L346.01 157.703V156.973L343.799 158.311V159.042ZM356.601 150.523L350.316 154.295V155.026L356.601 151.253V150.523ZM361.606 147.48L357.649 149.914V150.645L361.606 148.211V147.48ZM364.748 145.655L362.537 146.994V147.724L364.748 146.385V145.655ZM367.658 144.681V143.951L365.795 145.046V145.777L367.658 144.681ZM363.235 148.697L361.257 149.914V150.645L363.235 149.428V148.697ZM361.257 154.782L363.235 153.565V152.835L361.257 154.052V154.782ZM368.705 139.813L372.197 137.744V137.014L368.705 139.083V139.813ZM373.128 137.136L375.339 135.797V135.067L373.128 136.406V137.136ZM376.27 135.189L382.555 131.416V130.686L376.27 134.459V135.189ZM377.201 136.041L374.99 137.379V138.11L377.201 136.771V136.041ZM381.973 133.972L384.999 132.146V131.416L381.973 133.242V133.972ZM393.262 126.305L390.003 128.252V128.982L393.262 127.035V126.305ZM392.68 129.469L394.891 128.13V127.4L392.68 128.739V129.469ZM382.788 136.771V137.501L384.999 136.162V135.432L382.788 136.771ZM389.072 133.12L386.046 134.945V135.676L389.072 133.85V133.12ZM393.262 130.443L390.003 132.39V133.12L393.262 131.173V130.443ZM368.705 148.211L372.197 146.142V145.411L368.705 147.48V148.211ZM375.339 143.464L373.128 144.803V145.533L375.339 144.195V143.464ZM388.258 136.406L391.749 134.337V133.607L388.258 135.676V136.406ZM392.68 133.728L394.891 132.39V131.66L392.68 132.998V133.728ZM377.201 144.438L374.99 145.777V146.507L377.201 145.168V144.438ZM384.999 139.692L380.809 142.247V142.978L384.999 140.422V139.692ZM342.868 179.852L341.355 180.826V181.556L342.868 180.582V179.852ZM347.058 178.027L353.226 174.254V173.524L347.058 177.296V178.027ZM356.601 171.455L354.157 172.915V173.645L356.601 172.185V171.455ZM361.606 168.534L357.649 170.968V171.698L361.606 169.264V168.534ZM347.989 178.878L345.777 180.217V180.947L347.989 179.609V178.878ZM351.713 176.566L349.036 178.27V179L351.713 177.296V176.566ZM364.166 169.873L369.403 166.709V165.978L364.166 169.143V169.873ZM343.799 184.233L346.01 182.895V182.164L343.799 183.503V184.233ZM347.058 182.286L349.385 180.947V180.217L347.058 181.556V182.286ZM351.713 180.826L349.036 182.529V183.26L351.713 181.556V180.826ZM360.209 175.593L355.321 178.513V179.244L360.209 176.323V175.593ZM368.705 165.005L372.197 162.936V162.206L368.705 164.275V165.005ZM376.27 160.38L382.555 156.608V155.878L376.27 159.65V160.38ZM388.258 153.2L391.749 151.131V150.401L388.258 152.47V153.2ZM392.68 150.523L394.891 149.184V148.454L392.68 149.793V150.523ZM384.999 156.486L381.973 158.311V159.042L384.999 157.216V156.486ZM389.072 154.052L386.046 155.878V156.608L389.072 154.782V154.052ZM343.799 171.577L346.01 170.238V169.508L343.799 170.846V171.577ZM356.601 163.058L354.157 164.518V165.248L356.601 163.788V163.058ZM352.644 168.412L354.39 167.439V166.709L352.644 167.682V168.412ZM355.321 166.709L360.209 163.788V163.058L355.321 165.978V166.709ZM361.257 163.179L363.235 161.962V161.232L361.257 162.449V163.179ZM368.705 156.608L372.197 154.539V153.809L368.705 155.878V156.608ZM373.128 153.93L375.339 152.592V151.861L373.128 153.2V153.93ZM342.868 192.387L341.355 193.361V194.091L342.868 193.117V192.387ZM347.058 190.683L353.226 186.911V186.18L347.058 189.953V190.683ZM344.73 193.361L341.355 195.429V196.16L344.73 194.091V193.361ZM351.713 189.223L349.036 190.927V191.657L351.713 189.953V189.223ZM361.257 184.233L363.235 183.016V182.286L361.257 183.503V184.233ZM343.799 196.768L346.01 195.429V194.699L343.799 196.038V196.768ZM347.058 194.821L349.385 193.482V192.752L347.058 194.091V194.821ZM356.601 188.249L350.316 192.022V192.752L356.601 188.979V188.249ZM364.748 183.381L362.537 184.72V185.45L364.748 184.112V183.381ZM367.658 182.408V181.678L365.795 182.773V183.503L367.658 182.408ZM351.713 193.361L349.036 195.064V195.795L351.713 194.091V193.361ZM363.235 186.424L361.257 187.641V188.371L363.235 187.154V186.424ZM342.868 200.784L341.355 201.758V202.488L342.868 201.514V200.784ZM347.058 199.08L353.342 195.308L356.601 193.361V192.63L353.692 194.456L347.058 198.472V199.08ZM373.942 175.714L370.334 177.905V178.635L373.942 176.445V175.714ZM380.925 171.577L378.249 173.28V174.011L380.925 172.307V171.577ZM373.128 179.122L375.339 177.783V177.053L373.128 178.392V179.122ZM376.27 177.175L379.878 174.984V174.254L376.27 176.445V177.175ZM383.602 147.602L387.326 145.411V144.681L383.602 146.872V147.602ZM388.258 144.803L391.749 142.734V142.004L388.258 144.073V144.803ZM392.68 142.126L394.891 140.787V140.057L392.68 141.395V142.126ZM377.201 152.835L374.99 154.174V154.904L377.201 153.565V152.835ZM378.249 152.227V152.957L380.925 151.253V150.523L378.249 152.227ZM392.68 116.934L394.891 115.595V114.865L392.68 116.204V116.934ZM344.73 155.634L341.355 157.703V158.433L344.73 156.364V155.634ZM347.989 162.084L345.777 163.423V164.153L347.989 162.814V162.084ZM376.27 139.448L379.878 137.258V136.528L376.27 138.718V139.448ZM380.925 136.649L387.326 132.755V132.025L380.925 135.919V136.649ZM350.316 180.217L356.601 176.445V175.714L350.316 179.487V180.217ZM344.73 184.963L341.355 187.032V187.762L344.73 185.694V184.963ZM347.989 183.016L345.777 184.355V185.085L347.989 183.746V183.016ZM374.99 163.301L377.201 161.962V161.232L374.99 162.571V163.301ZM365.795 158.311L367.658 157.216V156.486L365.795 157.581V158.311ZM365.795 179.365L367.658 178.27V177.54L365.795 178.635V179.365ZM347.989 191.413L345.777 192.752V193.482L347.989 192.144V191.413ZM369.403 178.513L364.166 181.678V182.408L369.403 179.244V178.513ZM377.201 173.767L374.99 175.106V175.836L377.201 174.497V173.767ZM343.799 146.385L346.01 145.046V144.316L343.799 145.655V146.385ZM365.795 132.39V133.12L367.658 132.025V131.294L365.795 132.39ZM344.73 147.237L341.355 149.306V150.036L344.73 147.967V147.237ZM352.644 143.221L354.39 142.247V141.517L352.644 142.491V143.221ZM364.166 136.284L369.403 133.12V132.39L364.166 135.554V136.284ZM373.128 128.739L375.339 127.4V126.67L373.128 128.009V128.739ZM354.39 154.782V153.93L352.644 154.904V155.634L354.39 154.782ZM343.799 163.179L346.01 161.841V161.111L343.799 162.449V163.179ZM361.606 151.74L357.649 154.174V154.904L361.606 152.47V151.74ZM344.73 164.031L341.355 166.1V166.83L344.73 164.761V164.031ZM354.39 158.19L351.131 160.137V160.867L354.39 158.92V158.19ZM383.602 130.808L387.326 128.617V127.887L383.602 130.078V130.808ZM388.258 128.009L391.749 125.94V125.21L388.258 127.278V128.009ZM368.705 144.073L372.197 142.004V141.274L368.705 143.343V144.073ZM389.072 137.258L386.046 139.083V139.813L389.072 137.988V137.258ZM393.262 134.702L390.003 136.649V137.379L393.262 135.432V134.702ZM355.321 175.106L360.209 172.185V171.455L355.321 174.376V175.106ZM383.602 155.999L387.326 153.809V153.078L383.602 155.269V155.999ZM370.334 166.1L373.942 163.91V163.179L370.334 165.37V166.1ZM362.537 160.259L364.748 158.92V158.19L362.537 159.528V160.259ZM344.73 172.428L341.355 174.497V175.228L344.73 173.159V172.428ZM347.989 170.481L345.777 171.82V172.55L347.989 171.211V170.481ZM351.713 168.169L349.036 169.873V170.603L351.713 168.899V168.169ZM343.799 192.63L346.01 191.292V190.44L343.799 191.778V192.63ZM352.644 189.345L354.39 188.371V187.641L352.644 188.614V189.345ZM355.321 187.762L360.209 184.842V184.112L355.321 187.032V187.762ZM354.39 192.509V191.778L352.644 192.752V193.482L354.39 192.509ZM343.799 201.028L346.01 199.689V198.959L343.799 200.297V201.028ZM373.942 154.782L370.334 156.973V157.703L373.942 155.512V154.782ZM383.602 122.411L387.326 120.22V119.49L383.602 121.68V122.411ZM388.258 119.611L391.749 117.543V116.812L388.258 118.881V119.611ZM351.713 151.375L349.036 153.078V153.809L351.713 152.105V151.375ZM363.235 144.438L361.257 145.655V146.385L363.235 145.168V144.438ZM342.868 158.798L341.355 159.772V160.502L342.868 159.528V158.798ZM367.658 148.089L365.795 149.184V149.914L367.658 148.819V148.089ZM392.68 125.331L394.891 123.993V123.262L392.68 124.601V125.331ZM388.258 132.268L391.749 130.199V129.469L388.258 131.538V132.268ZM380.925 140.057L376.27 142.856V143.586L380.925 140.787V140.057ZM381.973 140.178L387.326 137.014V136.284L381.973 139.448V140.178ZM379.762 143.586V142.856L378.249 143.829V144.56L379.762 143.586ZM343.799 179.974L346.01 178.635V177.905L343.799 179.244V179.974ZM365.795 166.709L367.658 165.613V164.883L365.795 165.978V166.709ZM344.73 180.826L341.355 182.895V183.625L344.73 181.556V180.826ZM361.257 171.577L363.235 170.36V169.629L361.257 170.846V171.577ZM342.868 183.99L341.355 184.963V185.694L342.868 184.72V183.99ZM393.262 151.496L390.003 153.444V154.174L393.262 152.227V151.496ZM342.868 171.455L341.355 172.428V173.159L342.868 172.185V171.455ZM369.403 157.46L364.166 160.624V161.354L369.403 158.19V157.46ZM342.868 196.646L341.355 197.62V198.35L342.868 197.377V196.646ZM344.73 197.62L341.355 199.689V200.419L344.73 198.35V197.62ZM347.989 195.673L345.777 197.012V197.742L347.989 196.403V195.673ZM360.209 188.249L355.321 191.17V191.9L360.209 188.979V188.249ZM373.128 174.984L375.339 173.645V172.915L373.128 174.254V174.984ZM376.27 173.037L382.555 169.264V168.534L376.27 172.307V173.037ZM347.058 144.438L353.226 140.665V139.935L347.058 143.708V144.438ZM347.989 145.29L345.777 146.628V147.359L347.989 146.02V145.29ZM377.201 127.644L374.99 128.982V129.712L377.201 128.374V127.644ZM365.795 140.787V141.517L367.658 140.422V139.692L365.795 140.787ZM364.748 149.793L362.537 151.131V151.861L364.748 150.523V149.793ZM355.321 158.311L360.209 155.391V154.661L355.321 157.581V158.311ZM364.166 153.078L370.334 149.306V148.576L364.166 152.348V153.078ZM380.925 133.728L378.249 135.432V136.162L380.925 134.459V133.728ZM373.128 141.395L375.339 140.057V139.327L373.128 140.665V141.395ZM373.942 146.385L371.265 147.967V148.697L373.942 147.115V146.385ZM354.39 179.122L352.644 180.095V180.826L354.39 179.852V179.122ZM378.249 161.354L380.925 159.65V158.92L378.249 160.624V161.354ZM347.058 169.629L353.226 165.857V165.127L347.058 168.899V169.629ZM361.606 181.069L357.649 183.503V184.233L361.606 181.799V181.069ZM364.748 179.122L362.537 180.461V181.191L364.748 179.852V179.122ZM361.606 185.328L357.649 187.762V188.493L361.606 186.059V185.328ZM361.606 189.466L357.649 191.9V192.63L361.606 190.196V189.466ZM368.705 181.799L372.197 179.73V179L368.705 181.069V181.799ZM357.649 138.11L361.606 135.676V134.945L357.649 137.379V138.11ZM378.249 127.035V127.765L380.925 126.061V125.331L378.249 127.035ZM356.601 146.263L354.157 147.724V148.454L356.601 146.994V146.263ZM362.537 143.464L364.748 142.126V141.395L362.537 142.734V143.464ZM347.058 157.095L349.385 155.634V154.904L347.058 156.243V157.095ZM360.209 150.401L355.321 153.322V154.052L360.209 151.131V150.401ZM342.868 163.058L341.355 164.031V164.761L342.868 163.788V163.058ZM347.058 161.232L353.342 157.46L356.601 155.512V154.782L353.342 156.729L347.058 160.502V161.232ZM350.084 160.745L348.92 161.476V162.206L350.084 161.476V160.745ZM373.942 137.988L370.334 140.178V140.909L373.942 138.718V137.988ZM389.072 128.861L386.046 130.686V131.416L389.072 129.591V128.861ZM364.748 166.587L362.537 167.926V168.656L364.748 167.317V166.587ZM352.644 176.81L354.39 175.836V175.106L352.644 176.079V176.81ZM373.128 162.328L375.339 160.989V160.259L373.128 161.597V162.328ZM357.649 163.301L361.606 160.867V160.137L357.649 162.571V163.301ZM356.601 184.112L354.157 185.572V186.302L356.601 184.842V184.112ZM368.705 177.662L372.197 175.593V174.862L368.705 176.931V177.662ZM376.27 151.983L382.555 148.211V147.48L376.27 151.253V151.983ZM384.999 148.089L381.973 149.914V150.645L384.999 148.819V148.089ZM389.072 145.655L386.046 147.48V148.211L389.072 146.385V145.655ZM393.262 143.099L390.003 145.046V145.777L393.262 143.829V143.099ZM338.445 147.602L339.958 146.628V145.898L338.445 146.872V147.602ZM338.445 149.671L339.958 148.697V147.967L338.445 148.941V149.671ZM338.445 151.861L339.958 150.888V150.158L338.445 151.131V151.861ZM338.445 153.93L339.958 152.957V152.227L338.445 153.2V153.93ZM338.445 155.999L339.958 155.026V154.295L338.445 155.269V155.999ZM338.445 158.068L339.958 157.095V156.364L338.445 157.338V158.068ZM338.445 160.259L339.958 159.285V158.555L338.445 159.528V160.259ZM338.445 162.328L339.958 161.354V160.624L338.445 161.597V162.328ZM338.445 164.396L339.958 163.423V162.693L338.445 163.666V164.396ZM338.445 166.465L339.958 165.492V164.761L338.445 165.735V166.465ZM338.445 168.656L339.958 167.682V166.952L338.445 167.926V168.656ZM338.445 170.725L339.958 169.751V169.021L338.445 169.995V170.725ZM338.445 172.794L339.958 171.82V171.09L338.445 172.063V172.794ZM338.445 174.862L339.958 173.889V173.159L338.445 174.132V174.862ZM338.445 176.931L339.958 175.958V175.228L338.445 176.201V176.931ZM338.445 179.122L339.958 178.148V177.418L338.445 178.392V179.122ZM338.445 181.191L339.958 180.217V179.487L338.445 180.461V181.191ZM338.445 183.26L339.958 182.286V181.556L338.445 182.529V183.26ZM338.445 185.328L339.958 184.355V183.625L338.445 184.598V185.328ZM338.445 187.519L339.958 186.545V185.815L338.445 186.789V187.519ZM338.445 189.588L339.958 188.614V187.884L338.445 188.858V189.588ZM338.445 191.657L339.958 190.683V189.953L338.445 190.927V191.657ZM338.445 193.726L339.958 192.752V192.022L338.445 192.995V193.726ZM338.445 195.916L339.958 194.943V194.212L338.445 195.186V195.916ZM338.445 197.985L339.958 197.012V196.281L338.445 197.255V197.985ZM338.445 200.054L339.958 199.08V198.35L338.445 199.324V200.054ZM338.445 202.123L339.958 201.149V200.419L338.445 201.393V202.123ZM338.445 204.313L339.958 203.34V202.61L338.445 203.583V204.313Z"
          fill="#FFFCF8"
        />
        <path
          d="M340.078 104.034L342.522 102.573V103.182L341.707 103.669V106.346L340.893 106.833V104.155L340.078 104.642V104.034Z"
          fill="white"
        />
        <path
          d="M344.846 101.721L343.682 102.451V103.181L344.729 102.573V103.181L343.682 103.79V104.52L344.846 103.79V104.398L342.867 105.615V102.329L344.846 101.112V101.721Z"
          fill="white"
        />
        <path
          d="M346.825 99.8951C347.639 99.4083 348.105 99.53 348.338 100.138L347.523 100.625C347.407 100.382 347.174 100.382 346.825 100.625C346.359 100.869 346.01 101.477 346.01 102.086C346.01 102.694 346.359 102.816 346.825 102.572C347.174 102.451 347.407 102.086 347.523 101.721L348.338 101.234C348.105 102.086 347.639 102.816 346.825 103.303C345.894 103.911 345.195 103.546 345.195 102.572C345.195 101.477 345.894 100.382 346.825 99.8951Z"
          fill="white"
        />
        <path
          d="M350.783 99.4076L349.619 100.138V101.476L348.805 101.963V98.6774L349.619 98.1906V99.5293L350.783 98.7991V97.4604L351.598 96.9736V100.259L350.783 100.746V99.4076Z"
          fill="white"
        />
        <path
          d="M354.976 95.0273V98.3132L354.161 98.8L352.881 97.583V99.6519L352.066 100.139V96.7311L352.881 96.2443L354.161 97.583V95.5141L354.976 95.0273Z"
          fill="white"
        />
        <path
          d="M355.555 94.6616L356.369 94.1748V97.4607L355.555 97.9475V94.6616Z"
          fill="white"
        />
        <path
          d="M358.348 92.9576C359.163 92.4708 359.628 92.5925 359.861 93.201L359.046 93.6878C358.93 93.4444 358.697 93.4444 358.348 93.6878C357.883 93.9312 357.533 94.5397 357.533 95.1482C357.533 95.7567 357.883 95.8784 358.348 95.635C358.697 95.5133 358.93 95.1482 359.046 94.7831L359.861 94.2963C359.628 95.1482 359.163 95.8784 358.348 96.3651C357.417 96.9736 356.719 96.6086 356.719 95.635C356.719 94.5397 357.417 93.4444 358.348 92.9576Z"
          fill="white"
        />
        <path
          d="M362.305 93.3232L361.141 94.0534L360.908 94.7836L360.094 95.2704L361.258 91.2544L362.189 90.7676L363.352 93.4449L362.538 93.9317L362.305 93.3232ZM361.723 91.7411L361.374 93.2015L362.189 92.7147L361.723 91.7411Z"
          fill="white"
        />
        <path
          d="M364.401 89.3076V91.985L365.449 91.3765V91.985L363.703 93.0803V89.7944L364.401 89.3076Z"
          fill="white"
        />
        <path
          d="M343.217 116.933C341.355 118.028 339.842 118.028 339.842 116.203L342.053 114.864C342.17 115.472 342.519 115.594 343.101 115.229C343.683 114.864 344.148 114.255 344.148 113.769C344.148 112.065 339.726 115.594 339.842 112.308C339.842 110.604 341.239 108.779 342.984 107.684C344.847 106.588 346.127 106.71 346.243 108.414L343.916 109.752C343.916 109.144 343.45 109.022 342.868 109.387C342.403 109.631 341.937 110.239 341.937 110.726C341.937 112.308 346.243 109.022 346.243 112.065C346.476 113.769 345.312 115.716 343.217 116.933Z"
          fill="white"
        />
        <path
          d="M347.757 105.007L349.852 103.669V109.145C349.852 110.24 350.317 110.484 351.365 109.875C352.412 109.267 352.878 108.293 352.878 107.198V101.721L354.973 100.383V105.859C354.973 108.415 353.227 110.605 351.249 111.822C349.27 113.039 347.641 112.796 347.641 110.24V105.007H347.757Z"
          fill="white"
        />
        <path
          d="M359.977 103.425L358.696 104.277V107.563L356.602 108.901V99.7739L360.093 97.7051C362.188 96.3664 363.352 96.9749 363.352 98.6787C363.235 100.139 362.188 102.086 359.977 103.425ZM359.86 101.721C360.675 101.234 361.024 100.504 361.024 99.8956C361.024 99.2871 360.675 98.922 359.86 99.5305L358.696 100.261V102.573L359.86 101.721Z"
          fill="white"
        />
        <path
          d="M367.774 98.7999L366.493 99.6518V102.938L364.398 104.276V95.1489L367.89 93.0801C369.985 91.7414 371.149 92.3499 371.149 94.0537C371.032 95.3923 369.985 97.4612 367.774 98.7999ZM367.657 97.0961C368.472 96.6093 368.821 95.8791 368.821 95.2706C368.821 94.5404 368.472 94.297 367.657 94.9055L366.493 95.6357V97.948L367.657 97.0961Z"
          fill="white"
        />
        <path
          d="M376.269 96.9745C373.825 98.4349 371.73 97.7047 371.73 95.0273C371.73 92.2283 373.709 89.1858 376.269 87.6037C378.713 86.1433 380.692 86.8735 380.692 89.5509C380.692 92.2283 378.713 95.5141 376.269 96.9745ZM376.269 95.0273C377.666 94.1754 378.597 92.5933 378.597 91.0113C378.597 89.4292 377.666 88.9424 376.269 89.7943C374.873 90.6462 373.942 92.2283 373.942 93.8103C373.942 95.3924 374.756 95.8792 376.269 95.0273Z"
          fill="white"
        />
        <path
          d="M385.463 82.25C387.558 80.9113 388.722 81.6415 388.722 83.2235C388.722 84.3188 388.14 85.7792 386.744 86.9962L388.722 89.4301L386.278 90.8905L384.416 88.5783L383.95 88.9434V92.3509L381.855 93.6896V84.5622L385.463 82.25ZM385.347 84.1971L384.067 85.049V87.3613L385.347 86.5094C386.162 86.0226 386.511 85.4141 386.511 84.6839C386.511 83.832 386.162 83.7103 385.347 84.1971Z"
          fill="white"
        />
        <path
          d="M389.539 79.6934L396.289 75.5557V77.3811L393.962 78.8415V86.2651L391.867 87.6038V80.1802L389.539 81.6406V79.6934Z"
          fill="white"
        />
        <path
          d="M394.428 100.504C394.428 104.764 391.053 110.24 386.98 112.796C382.906 115.23 379.531 113.769 379.531 109.51C379.531 105.251 382.906 99.7741 386.98 97.2185C391.17 94.6628 394.428 96.1232 394.428 100.504Z"
          fill="#455FDC"
        />
        <path
          d="M387.562 109.753C387.562 109.632 387.678 109.51 387.795 109.388C388.959 107.928 389.89 105.494 389.89 103.303C389.89 101.113 389.075 99.6524 387.795 99.6524C387.678 99.6524 387.562 99.6524 387.562 99.5307C387.213 99.0439 386.747 98.9222 386.165 99.1656C385.7 99.2873 385.351 100.018 385.467 100.383L386.282 102.695C386.398 103.06 386.98 102.938 387.213 102.451C387.562 101.965 388.028 101.721 388.26 101.965C388.493 102.451 388.609 103.182 388.609 104.034C388.609 104.885 388.493 105.737 388.144 106.589C388.028 107.076 387.446 107.563 387.213 107.441C386.864 107.319 386.282 107.806 386.165 108.293L385.351 111.579C385.234 112.066 385.583 112.309 386.049 111.944C386.747 111.214 387.213 110.484 387.562 109.753Z"
          fill="white"
        />
        <path
          d="M351.019 118.88C355.092 116.446 358.467 117.906 358.467 122.166C358.467 126.425 355.092 131.902 351.019 134.457C346.945 136.891 343.57 135.431 343.57 131.171C343.57 126.912 346.945 121.314 351.019 118.88Z"
          fill="#CC4444"
        />
        <path
          d="M355.907 123.625C355.791 123.625 355.675 123.625 355.675 123.504C354.976 122.652 353.114 122.895 351.019 124.234C348.924 125.573 347.062 127.52 346.364 129.224C346.248 129.345 346.248 129.467 346.131 129.589C345.549 130.319 345.084 131.049 344.967 131.779C344.851 132.266 345.316 132.388 345.782 132.023L348.459 129.589C348.924 129.224 349.041 128.615 348.692 128.372C348.342 128.25 348.459 127.642 348.808 127.155C349.39 126.546 350.205 125.938 351.019 125.451C351.834 124.964 352.649 124.599 353.231 124.599C353.58 124.477 353.696 124.964 353.463 125.451C353.114 125.938 353.231 126.425 353.696 126.303L356.373 125.573C356.838 125.451 357.188 124.842 357.071 124.356C356.955 123.869 356.489 123.625 355.907 123.625Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M369.52 125.697C367.308 127.035 365.562 129.834 365.562 132.147V136.893H365.679V196.281L398.383 176.566C400.594 175.228 402.34 172.429 402.34 170.116V105.981L369.52 125.697Z"
          fill="#437B9B"
        />
        <path
          d="M373.828 138.961V208.816C373.828 211.007 375.574 211.859 377.785 210.52L425.852 181.556C428.063 180.217 429.809 177.418 429.809 175.106V105.251L373.828 138.961Z"
          fill="#455FDC"
        />
        <path
          d="M429.808 108.049V103.303C429.808 101.113 428.062 100.261 425.851 101.599L377.668 130.685C375.457 132.024 373.711 134.823 373.711 137.135V141.881L429.808 108.049Z"
          fill="#99E2FF"
        />
        <path
          d="M419.449 108.779V109.266C419.449 109.388 419.449 109.509 419.332 109.509L417.237 111.335L419.332 110.605C419.449 110.605 419.449 110.605 419.449 110.726V111.213C419.449 111.335 419.449 111.335 419.332 111.457L416.772 112.187C416.655 112.187 416.539 112.187 416.539 112.065V111.7C416.539 111.578 416.655 111.457 416.772 111.335L419.332 108.901C419.449 108.657 419.449 108.657 419.449 108.779Z"
          fill="white"
        />
        <path
          d="M420.847 111.578L420.265 111.943C420.148 112.065 420.148 111.943 420.148 111.822C420.265 111.335 420.498 110.483 420.963 109.266C421.312 108.049 421.545 107.075 421.778 106.589C421.778 106.467 421.894 106.345 422.011 106.345L422.593 105.98C422.709 105.858 422.709 105.98 422.709 106.102L420.963 111.335C420.963 111.457 420.963 111.457 420.847 111.578Z"
          fill="white"
        />
        <path
          d="M423.289 106.954V106.467C423.289 106.345 423.289 106.345 423.405 106.223L425.966 105.493C426.082 105.493 426.199 105.493 426.199 105.615V105.98C426.199 106.102 426.082 106.223 425.966 106.345L423.405 108.779C423.289 108.901 423.289 108.901 423.289 108.779V108.292C423.289 108.171 423.289 108.049 423.405 108.049L425.5 106.223L423.405 106.954C423.289 107.075 423.289 107.075 423.289 106.954Z"
          fill="white"
        />
        <path
          d="M383.134 145.046V144.559L381.737 145.411C381.621 145.411 381.621 145.532 381.621 145.654V147.966C381.621 148.088 381.621 148.088 381.737 147.966L384.531 146.263C384.647 146.263 384.647 146.141 384.647 146.019V144.194C384.647 144.072 384.647 144.072 384.531 144.194L383.134 145.046Z"
          fill="#99E2FF"
        />
        <path
          d="M391.862 141.517L386.625 144.682V143.221L391.862 140.179V141.517Z"
          fill="#99E2FF"
        />
        <path
          d="M397.216 138.231L393.492 140.422V139.083L397.216 136.893V138.231Z"
          fill="#99E2FF"
        />
        <path
          d="M383.134 151.01V150.523L381.737 151.375C381.621 151.375 381.621 151.496 381.621 151.618V153.93C381.621 154.052 381.621 154.052 381.737 153.93L384.531 152.227C384.647 152.227 384.647 152.105 384.647 151.983V150.158C384.647 150.036 384.647 150.036 384.531 150.158L383.134 151.01Z"
          fill="#99E2FF"
        />
        <path
          d="M394.074 146.02L386.625 150.523V149.184L394.074 144.682V146.02Z"
          fill="#99E2FF"
        />
        <path
          d="M403.618 132.634V132.147L402.222 132.999C402.105 132.999 402.105 133.12 402.105 133.242V135.554C402.105 135.676 402.105 135.676 402.222 135.554L405.015 133.851C405.131 133.851 405.131 133.729 405.131 133.607V131.782C405.131 131.66 405.131 131.66 405.015 131.782L403.618 132.634Z"
          fill="#99E2FF"
        />
        <path
          d="M408.739 131.295L407.109 132.268V130.93L408.739 129.956V131.295Z"
          fill="#99E2FF"
        />
        <path
          d="M414.558 127.765L410.484 130.199V128.861L414.558 126.427V127.765Z"
          fill="#99E2FF"
        />
        <path
          d="M403.622 138.596V138.11L402.226 138.962C402.109 138.962 402.109 139.083 402.109 139.205V141.517C402.109 141.639 402.109 141.639 402.226 141.517L405.019 139.813C405.135 139.813 405.135 139.692 405.135 139.57V137.745C405.135 137.623 405.135 137.623 405.019 137.745L403.622 138.596Z"
          fill="#99E2FF"
        />
        <path
          d="M412.351 135.067L407.113 138.231V136.893L412.351 133.729V135.067Z"
          fill="#99E2FF"
        />
        <path
          d="M416.192 132.634L413.98 134.094V132.634L416.192 131.295V132.634Z"
          fill="#99E2FF"
        />
        <path
          d="M383.134 156.973V156.487L381.737 157.339C381.621 157.339 381.621 157.46 381.621 157.582V159.894C381.621 160.016 381.621 160.016 381.737 159.894L384.531 158.19C384.647 158.19 384.647 158.069 384.647 157.947V156.122C384.647 156 384.647 156 384.531 156.122L383.134 156.973Z"
          fill="#99E2FF"
        />
        <path
          d="M389.767 154.54L386.625 156.487V155.148L389.767 153.201V154.54Z"
          fill="#99E2FF"
        />
        <path
          d="M394.774 151.619L391.516 153.566V152.227L394.774 150.28V151.619Z"
          fill="#99E2FF"
        />
        <path
          d="M403.622 144.56V144.074L402.226 144.925C402.109 144.925 402.109 145.047 402.109 145.169V147.481C402.109 147.603 402.109 147.603 402.226 147.481L405.019 145.777C405.135 145.777 405.135 145.656 405.135 145.534V143.708C405.135 143.587 405.135 143.587 405.019 143.708L403.622 144.56Z"
          fill="#99E2FF"
        />
        <path
          d="M410.256 142.248L407.113 144.195V142.856L410.256 140.909V142.248Z"
          fill="#99E2FF"
        />
        <path
          d="M415.142 139.206L411.883 141.275V139.936L415.142 137.867V139.206Z"
          fill="#99E2FF"
        />
        <path
          d="M383.954 161.598L381.859 162.815C381.742 162.815 381.742 162.936 381.742 163.058V166.466C381.742 166.587 381.859 166.587 381.859 166.587L384.419 165.127C384.535 165.127 384.535 165.005 384.535 164.884V161.963C384.419 161.719 384.186 161.719 383.954 161.598Z"
          fill="white"
        />
        <path
          d="M391.866 159.407L386.629 162.571V161.233L391.866 158.068V159.407Z"
          fill="white"
        />
        <path
          d="M396.41 156.608L393.5 158.434V156.973L396.41 155.27V156.608Z"
          fill="white"
        />
        <path
          d="M383.954 167.439L381.859 168.656C381.742 168.656 381.742 168.778 381.742 168.9V172.307C381.742 172.429 381.859 172.429 381.859 172.429L384.419 170.969C384.535 170.969 384.535 170.847 384.535 170.725V167.805C384.419 167.561 384.186 167.439 383.954 167.439Z"
          fill="white"
        />
        <path
          d="M390.586 165.857L386.629 168.291V166.953L390.586 164.519V165.857Z"
          fill="white"
        />
        <path
          d="M383.954 173.159L381.859 174.376C381.742 174.376 381.742 174.498 381.742 174.62V178.027C381.742 178.149 381.859 178.149 381.859 178.149L384.419 176.688C384.535 176.688 384.535 176.567 384.535 176.445V173.403C384.419 173.403 384.186 173.281 383.954 173.159Z"
          fill="white"
        />
        <path
          d="M392.448 170.603L386.629 174.133V172.794L392.448 169.265V170.603Z"
          fill="white"
        />
        <path
          d="M396.41 168.291L394.082 169.63V168.291L396.41 166.952V168.291Z"
          fill="white"
        />
        <path
          d="M383.954 179.001L381.859 180.218C381.742 180.218 381.742 180.34 381.742 180.461V183.869C381.742 183.991 381.859 183.991 381.859 183.991L384.419 182.53C384.535 182.53 384.535 182.409 384.535 182.287V179.366C384.419 179.123 384.186 179.123 383.954 179.001Z"
          fill="white"
        />
        <path
          d="M388.957 178.513L386.629 179.974V178.513L388.957 177.175V178.513Z"
          fill="white"
        />
        <path
          d="M394.78 174.984L390.59 177.54V176.201L394.78 173.646V174.984Z"
          fill="white"
        />
        <path
          d="M383.954 184.477L381.859 185.694C381.742 185.694 381.742 185.815 381.742 185.937V189.344C381.742 189.466 381.859 189.466 381.859 189.466L384.419 188.006C384.535 188.006 384.535 187.884 384.535 187.762V184.842C384.419 184.72 384.186 184.598 383.954 184.477Z"
          fill="white"
        />
        <path
          d="M391.866 182.287L386.629 185.451V184.112L391.866 180.948V182.287Z"
          fill="white"
        />
        <path
          d="M396.41 179.609L393.5 181.313V179.974L396.41 178.271V179.609Z"
          fill="white"
        />
        <path
          d="M383.954 190.319L381.859 191.536C381.742 191.536 381.742 191.658 381.742 191.78V195.187C381.742 195.309 381.859 195.309 381.859 195.309L384.419 193.849C384.535 193.849 384.535 193.727 384.535 193.605V190.684C384.419 190.441 384.186 190.441 383.954 190.319Z"
          fill="white"
        />
        <path
          d="M390.586 188.858L386.629 191.292V189.832L390.586 187.52V188.858Z"
          fill="white"
        />
        <path
          d="M404.321 149.306L402.226 150.523C402.109 150.523 402.109 150.644 402.109 150.766V154.174C402.109 154.295 402.226 154.295 402.226 154.295L404.786 152.835C404.903 152.835 404.903 152.713 404.903 152.592V149.671C404.67 149.549 404.553 149.427 404.321 149.306Z"
          fill="white"
        />
        <path
          d="M414.445 145.776L406.996 150.279V148.94L414.445 144.438V145.776Z"
          fill="white"
        />
        <path
          d="M404.321 155.146L402.226 156.363C402.109 156.363 402.109 156.485 402.109 156.607V160.014C402.109 160.136 402.226 160.136 402.226 160.136L404.786 158.676C404.903 158.676 404.903 158.554 404.903 158.432V155.512C404.67 155.268 404.553 155.268 404.321 155.146Z"
          fill="white"
        />
        <path
          d="M415.608 150.888L406.996 156.121V154.782L415.608 149.549V150.888Z"
          fill="white"
        />
        <path
          d="M404.321 160.988L402.226 162.205C402.109 162.205 402.109 162.327 402.109 162.449V165.856C402.109 165.978 402.226 165.978 402.226 165.978L404.786 164.518C404.903 164.518 404.903 164.396 404.903 164.274V161.232C404.67 161.11 404.553 160.988 404.321 160.988Z"
          fill="white"
        />
        <path
          d="M410.72 159.65L406.996 161.841V160.502L410.72 158.312V159.65Z"
          fill="white"
        />
        <path
          d="M404.321 166.708L402.226 167.925C402.109 167.925 402.109 168.047 402.109 168.168V171.576C402.109 171.698 402.226 171.698 402.226 171.698L404.786 170.237C404.903 170.237 404.903 170.116 404.903 169.994V167.073C404.67 166.951 404.553 166.83 404.321 166.708Z"
          fill="white"
        />
        <path
          d="M409.906 165.977L406.996 167.681V166.342L409.906 164.639V165.977Z"
          fill="white"
        />
        <path
          d="M415.031 162.814L411.539 164.883V163.544L415.031 161.476V162.814Z"
          fill="white"
        />
        <path
          d="M84.1424 321.024L48.7617 299.726L84.1424 278.308L119.639 299.726L84.1424 321.024Z"
          fill="url(#paint11_linear_1926_44029)"
        />
        <path
          d="M84.1424 362.4L48.7617 340.981V299.726L84.1424 321.023V362.4Z"
          fill="#276E91"
        />
        <path
          d="M119.638 340.981L84.1406 362.4V321.023L119.638 299.726V340.981Z"
          fill="#2D86A5"
        />
        <path
          d="M286.186 354.124L271.871 345.605L286.186 336.965L300.385 345.605L286.186 354.124Z"
          fill="url(#paint12_linear_1926_44029)"
        />
        <path
          d="M286.186 370.796L271.871 362.155V345.604L286.186 354.123V370.796Z"
          fill="#276E91"
        />
        <path
          d="M300.386 362.155L286.188 370.796V354.123L300.386 345.604V362.155Z"
          fill="#2D86A5"
        />
        <path
          d="M275.588 382.723L268.488 378.463L275.588 374.082L282.687 378.463L275.588 382.723Z"
          fill="url(#paint13_linear_1926_44029)"
        />
        <path
          d="M275.588 390.998L268.488 386.738V378.463L275.588 382.722V390.998Z"
          fill="#276E91"
        />
        <path
          d="M282.689 386.738L275.59 390.998V382.722L282.689 378.463V386.738Z"
          fill="#2D86A5"
        />
        <path
          d="M373.009 220.62C373.358 221.472 373.707 222.324 374.056 223.176C374.987 225.732 375.104 228.287 375.22 230.965C375.22 231.086 375.22 231.208 375.336 231.33C375.336 231.33 375.453 231.451 375.569 231.451C377.897 231.938 379.875 228.409 380.806 226.584C381.854 224.636 383.018 221.837 382.669 219.525C382.203 216.483 380.69 212.71 377.315 212.588C373.241 212.467 371.845 217.213 373.009 220.62Z"
          fill="#2035A4"
        />
        <path
          d="M421.421 296.803C420.955 295.83 415.136 290.231 414.903 288.649L411.644 289.014C412.11 289.38 411.644 290.231 411.412 290.718C411.062 291.327 411.063 291.692 411.063 292.422C411.063 293.882 412.575 294.978 413.507 296.195C415.136 298.264 416.882 299.967 417.696 300.211C418.86 300.819 421.072 300.698 421.653 299.115C421.886 298.507 421.77 297.655 421.421 296.803Z"
          fill="#276E91"
        />
        <path
          d="M410.364 295.222C410.131 294.857 409.898 294.492 410.015 294.005L406.174 293.397C405.592 293.275 405.127 293.64 404.778 294.127C404.312 295.1 403.614 296.196 404.778 297.291C405.127 297.656 410.015 302.402 411.644 303.011C414.437 303.984 417.696 302.646 416.416 300.212C415.95 298.995 410.597 295.466 410.364 295.222Z"
          fill="#276E91"
        />
        <path
          d="M421.073 295.709C420.608 294.735 415.254 288.772 415.021 287.312L411.762 287.677C412.228 288.042 412.112 288.894 411.879 289.502C411.53 290.111 411.297 290.719 411.297 291.328C411.297 292.788 412.693 293.64 413.625 294.857C415.254 296.926 417 298.629 417.814 298.873C418.978 299.481 420.724 299.603 421.306 298.021C421.539 297.291 421.422 296.439 421.073 295.709Z"
          fill="white"
        />
        <path
          d="M409.547 292.18L406.405 291.571C406.172 291.936 403.262 294.614 404.892 296.074C405.241 296.439 410.129 301.185 411.758 301.794C414.552 302.768 417.578 301.672 416.297 299.117C415.133 296.926 410.362 295.101 409.547 292.18Z"
          fill="white"
        />
        <path
          d="M415.72 287.919C414.44 284.755 411.298 275.019 410.134 270.517C410.018 269.908 409.785 269.178 409.668 267.839C409.552 266.622 409.087 265.405 408.272 264.553C401.405 257.251 390.116 253.479 387.323 249.098L383.715 262.241C388.952 266.257 402.802 268.813 403.384 269.178C403.151 273.194 403.616 277.453 405.944 280.617C407.574 282.808 411.065 288.163 411.181 288.771C411.763 290.11 416.419 289.623 415.72 287.919Z"
          fill="#2035A4"
        />
        <path
          d="M400.359 272.708C400.01 271.491 399.312 270.396 398.381 269.665C394.656 266.623 385.811 260.051 385.695 259.443C385.462 258.469 385.928 257.496 386.393 256.644C386.975 255.548 387.324 254.453 387.79 253.358C388.023 252.749 388.139 252.141 388.023 251.532C387.79 250.194 386.393 248.977 387.092 247.76L374.289 250.802C371.496 253.358 371.729 260.538 374.755 264.189C376.384 266.136 379.41 267.84 381.505 269.179C384.88 271.248 389.186 273.56 392.794 275.264C396.169 282.444 399.545 283.296 405.48 293.275C406.295 295.1 410.485 293.153 409.786 291.936C399.312 275.264 401.523 276.481 400.359 272.708Z"
          fill="#2035A4"
        />
        <path
          d="M398.843 253.965C398.261 251.531 393.49 241.065 392.791 239.483C392.791 239.483 391.278 226.583 389.649 223.906C389.067 222.932 387.903 222.446 386.856 222.689C385.11 223.297 385.226 224.393 385.459 225.975C385.692 227.557 387.438 240.579 388.136 242.039C389.765 245.081 395.119 255.304 395.235 255.547C395.934 257.13 399.309 255.548 398.843 253.965Z"
          fill="#455FDC"
        />
        <path
          d="M375.682 229.139C373.703 230.721 373.819 232.547 374.518 234.859C375.216 237.293 376.38 239.727 376.263 242.404C376.147 245.203 374.401 247.516 373.47 250.071C373.354 250.558 373.121 251.045 373.121 251.532C373.121 252.992 374.634 253.966 375.914 254.331C379.639 255.548 383.945 254.574 386.854 251.897C387.436 251.41 387.902 250.923 388.018 250.193C388.6 248.124 386.156 246.177 386.738 244.23C387.087 242.769 388.833 242.161 389.88 241.066C390.811 240.092 391.393 238.753 391.277 237.415C391.044 234.737 388.6 232.669 388.251 229.991C388.018 228.652 388.367 227.192 388.484 225.853C388.484 224.515 388.135 223.054 386.505 223.176C384.876 223.298 382.665 225.245 381.152 225.975C379.289 226.705 377.427 227.679 375.682 229.139Z"
          fill="#455FDC"
        />
        <path
          d="M385.808 225.123C385.458 224.88 384.993 224.758 384.644 224.637C384.295 224.515 382.316 222.568 382.083 222.811C381.152 224.15 381.734 225.123 380.338 226.705C378.01 229.383 384.993 234.737 386.622 229.504C386.855 228.774 387.088 228.166 387.204 227.436C387.321 226.584 386.506 225.61 385.808 225.123Z"
          fill="#F1A782"
        />
        <path
          d="M380.221 214.293C380.686 214.779 380.453 215.753 379.755 216.483C379.057 217.092 378.126 217.213 377.66 216.605C377.195 216.118 377.427 215.144 378.126 214.414C378.824 213.806 379.755 213.806 380.221 214.293Z"
          fill="#1A2C87"
        />
        <path
          d="M389.301 226.584C389.417 225.854 389.417 225.124 389.184 224.515C388.719 222.933 390.115 220.377 388.719 218.43C387.206 216.24 385.925 216.605 384.762 217.092C382.667 217.822 377.546 219.769 378.36 221.838C380.223 226.828 382.667 228.288 384.063 229.018C385.111 229.505 387.555 231.087 388.602 229.748C388.951 229.261 388.951 228.653 389.184 228.044C389.184 227.558 389.184 227.071 389.301 226.584Z"
          fill="#FABC9D"
        />
        <path
          d="M388.021 216.24C383.599 210.763 376.267 214.414 376.732 220.134C377.198 225.367 380.689 226.828 381.62 227.193C381.387 226.706 380.573 225.367 380.573 224.759C380.573 224.272 381.038 224.029 381.504 224.272C381.853 224.394 382.086 224.637 382.318 224.88C382.551 225.124 383.25 226.462 383.25 225.367C383.25 224.637 383.017 223.907 383.599 223.42C383.831 223.177 384.181 223.055 384.53 222.933C385.461 222.568 386.276 221.716 386.974 220.864C387.556 220.134 388.952 220.134 389.302 219.404C389.651 218.674 388.487 216.848 388.021 216.24Z"
          fill="#2035A4"
        />
        <path
          d="M388.599 258.955C386.271 256.643 377.775 247.881 377.775 247.881C377.775 243.013 379.521 230.234 374.633 230.234C373.12 230.234 371.956 231.938 371.607 233.52C371.374 234.616 371.258 248.611 372.655 250.315C374.749 252.749 381.616 258.833 386.155 261.024C387.552 261.876 389.53 260.172 388.599 258.955Z"
          fill="#455FDC"
        />
        <path
          d="M380.105 225.002C380.105 226.219 380.92 226.705 381.968 227.192L382.782 225.975C381.502 223.298 380.105 223.906 380.105 225.002Z"
          fill="#FABC9D"
        />
        <path
          d="M384.535 264.31V264.675C384.535 264.797 384.535 264.797 384.652 264.918L394.195 270.638C394.311 270.76 394.661 270.76 394.777 270.638L408.277 262.363C408.394 262.363 408.394 262.241 408.394 262.241V261.876L384.535 264.31Z"
          fill="#ADA4B8"
        />
        <path
          d="M408.393 261.754L398.849 256.035C398.733 255.913 398.384 255.913 398.267 256.035L384.767 264.31C384.651 264.432 384.651 264.554 384.767 264.675L394.31 270.395C394.427 270.517 394.776 270.517 394.892 270.395L408.393 262.12C408.509 261.998 408.509 261.754 408.393 261.754Z"
          fill="white"
        />
        <path
          d="M391.164 266.744L390.582 267.109C390.466 267.109 390.466 267.109 390.35 267.109L389.884 266.744C389.768 266.744 389.768 266.622 389.884 266.622L390.466 266.257C390.582 266.257 390.582 266.257 390.699 266.257L391.164 266.622C391.281 266.622 391.281 266.622 391.164 266.744ZM392.095 266.014L391.63 265.648C391.514 265.648 391.514 265.648 391.397 265.648L390.815 266.014C390.699 266.014 390.699 266.135 390.815 266.135L391.281 266.5C391.397 266.5 391.397 266.5 391.514 266.5L392.095 266.135C392.212 266.135 392.212 266.014 392.095 266.014ZM393.143 265.405L392.677 265.04C392.561 265.04 392.561 265.04 392.445 265.04L391.863 265.405C391.746 265.405 391.746 265.527 391.863 265.527L392.328 265.892C392.445 265.892 392.445 265.892 392.561 265.892L393.143 265.527V265.405ZM394.074 264.797L393.608 264.431C393.492 264.431 393.492 264.431 393.376 264.431L392.794 264.797C392.677 264.797 392.677 264.918 392.794 264.918L393.259 265.283C393.376 265.283 393.376 265.283 393.492 265.283L394.074 264.918C394.19 264.918 394.19 264.797 394.074 264.797ZM395.005 264.188L394.54 263.823C394.423 263.823 394.423 263.823 394.307 263.823L393.725 264.188C393.608 264.188 393.608 264.31 393.725 264.31L394.19 264.675C394.307 264.675 394.307 264.675 394.423 264.675L395.005 264.31C395.121 264.31 395.121 264.31 395.005 264.188ZM396.053 263.58L395.587 263.215C395.471 263.215 395.471 263.215 395.354 263.215L394.772 263.58C394.656 263.58 394.656 263.701 394.772 263.701L395.238 264.066C395.354 264.066 395.354 264.066 395.471 264.066L396.053 263.701C396.053 263.701 396.053 263.701 396.053 263.58ZM396.984 263.093L396.518 262.728C396.402 262.728 396.402 262.728 396.285 262.728L395.703 263.093C395.587 263.093 395.587 263.215 395.703 263.215L396.169 263.58C396.285 263.58 396.285 263.58 396.402 263.58L396.984 263.215C397.1 263.093 397.1 263.093 396.984 263.093ZM397.915 262.484L397.449 262.119C397.333 262.119 397.333 262.119 397.216 262.119L396.634 262.484C396.518 262.484 396.518 262.606 396.634 262.606L397.1 262.971C397.216 262.971 397.216 262.971 397.333 262.971L397.915 262.606C398.031 262.606 398.031 262.484 397.915 262.484ZM398.962 261.876L398.497 261.511C398.38 261.511 398.38 261.511 398.264 261.511L397.682 261.876C397.566 261.876 397.566 261.998 397.682 261.998L398.147 262.363C398.264 262.363 398.264 262.363 398.38 262.363L398.962 261.998V261.876ZM400.242 261.146L399.777 260.781C399.66 260.781 399.66 260.781 399.544 260.781L398.613 261.389C398.497 261.389 398.497 261.511 398.613 261.511L399.079 261.876C399.195 261.876 399.195 261.876 399.311 261.876L400.242 261.267C400.242 261.146 400.242 261.146 400.242 261.146ZM403.85 262.119L403.385 261.754C403.268 261.754 403.268 261.754 403.152 261.754L402.57 262.119C402.454 262.119 402.454 262.241 402.57 262.241L403.036 262.606C403.152 262.606 403.152 262.606 403.268 262.606L403.85 262.241C403.967 262.241 403.967 262.119 403.85 262.119ZM404.898 261.511L404.432 261.146C404.316 261.146 404.316 261.146 404.199 261.146L403.617 261.511C403.501 261.511 403.501 261.632 403.617 261.632L404.083 261.998C404.199 261.998 404.199 261.998 404.316 261.998L404.898 261.632V261.511ZM405.829 260.902L405.363 260.537C405.247 260.537 405.247 260.537 405.13 260.537L404.549 260.902C404.432 260.902 404.432 261.024 404.549 261.024L405.014 261.389C405.13 261.389 405.13 261.389 405.247 261.389L405.829 261.024C405.829 261.024 405.829 261.024 405.829 260.902ZM404.781 262.606L404.316 262.241C404.199 262.241 404.199 262.241 404.083 262.241L403.501 262.606C403.385 262.606 403.385 262.728 403.501 262.728L403.967 263.093C404.083 263.093 404.083 263.093 404.199 263.093L404.781 262.728C404.781 262.728 404.781 262.728 404.781 262.606ZM405.712 262.119L405.247 261.754C405.13 261.754 405.13 261.754 405.014 261.754L404.432 262.119C404.316 262.119 404.316 262.241 404.432 262.241L404.898 262.606C405.014 262.606 405.014 262.606 405.13 262.606L405.712 262.241C405.829 262.119 405.829 262.119 405.712 262.119ZM406.76 261.511L406.294 261.146C406.178 261.146 406.178 261.146 406.062 261.146L405.48 261.511C405.363 261.511 405.363 261.632 405.48 261.632L405.945 261.998C406.062 261.998 406.061 261.998 406.178 261.998L406.76 261.632V261.511ZM392.445 266.865L391.979 266.5C391.863 266.5 391.863 266.5 391.746 266.5L390.699 267.109C390.582 267.109 390.582 267.231 390.699 267.231L391.164 267.596C391.281 267.596 391.281 267.596 391.397 267.596L392.328 266.987C392.445 266.987 392.445 266.987 392.445 266.865ZM393.376 266.379L392.91 266.014C392.794 266.014 392.794 266.014 392.677 266.014L392.095 266.379C391.979 266.379 391.979 266.5 392.095 266.5L392.561 266.865C392.677 266.865 392.677 266.865 392.794 266.865L393.376 266.5C393.376 266.379 393.376 266.379 393.376 266.379ZM394.307 265.77L393.841 265.405C393.725 265.405 393.725 265.405 393.608 265.405L393.027 265.77C392.91 265.77 392.91 265.892 393.027 265.892L393.492 266.257C393.608 266.257 393.608 266.257 393.725 266.257L394.307 265.892C394.423 265.892 394.423 265.77 394.307 265.77ZM395.354 265.162L394.889 264.797C394.772 264.797 394.772 264.797 394.656 264.797L394.074 265.162C393.958 265.162 393.958 265.283 394.074 265.283L394.54 265.648C394.656 265.648 394.656 265.648 394.772 265.648L395.354 265.283V265.162ZM396.285 264.553L395.82 264.188C395.703 264.188 395.703 264.188 395.587 264.188L395.005 264.553C394.889 264.553 394.889 264.675 395.005 264.675L395.471 265.04C395.587 265.04 395.587 265.04 395.703 265.04L396.285 264.675V264.553ZM397.216 263.945L396.751 263.58C396.634 263.58 396.634 263.58 396.518 263.58L395.936 263.945C395.82 263.945 395.82 264.066 395.936 264.066L396.402 264.431C396.518 264.431 396.518 264.431 396.634 264.431L397.216 264.066C397.333 264.066 397.333 264.066 397.216 263.945ZM398.264 263.336L397.798 262.971C397.682 262.971 397.682 262.971 397.565 262.971L396.984 263.336C396.867 263.336 396.867 263.458 396.984 263.458L397.449 263.823C397.565 263.823 397.566 263.823 397.682 263.823L398.264 263.458C398.264 263.458 398.264 263.458 398.264 263.336ZM399.195 262.849L398.729 262.484C398.613 262.484 398.613 262.484 398.497 262.484L397.915 262.849C397.798 262.849 397.798 262.971 397.915 262.971L398.38 263.336C398.497 263.336 398.497 263.336 398.613 263.336L399.195 262.971C399.195 262.849 399.195 262.849 399.195 262.849ZM400.126 262.241L399.66 261.876C399.544 261.876 399.544 261.876 399.428 261.876L398.846 262.241C398.729 262.241 398.729 262.363 398.846 262.363L399.311 262.728C399.428 262.728 399.428 262.728 399.544 262.728L400.126 262.363C400.242 262.363 400.242 262.241 400.126 262.241ZM401.173 261.632L400.708 261.267C400.591 261.267 400.591 261.267 400.475 261.267L399.893 261.632C399.777 261.632 399.777 261.754 399.893 261.754L400.359 262.119C400.475 262.119 400.475 262.119 400.591 262.119L401.173 261.754V261.632ZM392.91 267.596L392.445 267.231C392.328 267.231 392.328 267.231 392.212 267.231L391.63 267.596C391.514 267.596 391.514 267.717 391.63 267.717L392.095 268.082C392.212 268.082 392.212 268.082 392.328 268.082L392.91 267.717C393.027 267.717 393.027 267.717 392.91 267.596ZM393.958 267.109L393.492 266.744C393.376 266.744 393.376 266.744 393.259 266.744L392.677 267.109C392.561 267.109 392.561 267.231 392.677 267.231L393.143 267.596C393.259 267.596 393.259 267.596 393.376 267.596L393.958 267.231C393.958 267.109 393.958 267.109 393.958 267.109ZM394.889 266.5L394.423 266.135C394.307 266.135 394.307 266.135 394.19 266.135L393.608 266.5C393.492 266.5 393.492 266.622 393.608 266.622L394.074 266.987C394.19 266.987 394.19 266.987 394.307 266.987L394.889 266.622C394.889 266.5 394.889 266.5 394.889 266.5ZM395.82 265.892L395.354 265.527C395.238 265.527 395.238 265.527 395.121 265.527L394.54 265.892C394.423 265.892 394.423 266.014 394.54 266.014L395.005 266.379C395.121 266.379 395.121 266.379 395.238 266.379L395.82 266.014C395.936 266.014 395.936 265.892 395.82 265.892ZM394.656 268.691L394.19 268.326C394.074 268.326 394.074 268.326 393.958 268.326L393.376 268.691C393.259 268.691 393.259 268.813 393.376 268.813L393.841 269.178C393.958 269.178 393.958 269.178 394.074 269.178L394.656 268.813C394.772 268.813 394.772 268.691 394.656 268.691ZM395.703 268.082L395.238 267.717C395.121 267.717 395.121 267.717 395.005 267.717L394.423 268.082C394.307 268.082 394.307 268.204 394.423 268.204L394.889 268.569C395.005 268.569 395.005 268.569 395.121 268.569L395.703 268.204C395.703 268.204 395.703 268.204 395.703 268.082ZM396.634 267.474L396.169 267.109C396.053 267.109 396.053 267.109 395.936 267.109L395.354 267.474C395.238 267.474 395.238 267.596 395.354 267.596L395.82 267.961C395.936 267.961 395.936 267.961 396.053 267.961L396.634 267.596C396.751 267.596 396.751 267.596 396.634 267.474ZM397.565 266.987L397.1 266.622C396.984 266.622 396.984 266.622 396.867 266.622L396.285 266.987C396.169 266.987 396.169 267.109 396.285 267.109L396.751 267.474C396.867 267.474 396.867 267.474 396.984 267.474L397.565 267.109C397.682 266.987 397.682 266.987 397.565 266.987ZM403.734 263.215L403.268 262.849C403.152 262.849 403.152 262.849 403.036 262.849L402.104 263.458C401.988 263.458 401.988 263.58 402.104 263.58L402.57 263.945C402.686 263.945 402.686 263.945 402.803 263.945L403.734 263.336C403.85 263.336 403.85 263.215 403.734 263.215ZM396.867 265.283L396.402 264.918C396.285 264.918 396.285 264.918 396.169 264.918L395.587 265.283C395.471 265.283 395.471 265.405 395.587 265.405L396.053 265.77C396.169 265.77 396.169 265.77 396.285 265.77L396.867 265.405V265.283ZM397.798 264.675L397.333 264.31C397.216 264.31 397.216 264.31 397.1 264.31L396.518 264.675C396.402 264.675 396.402 264.797 396.518 264.797L396.984 265.162C397.1 265.162 397.1 265.162 397.216 265.162L397.798 264.797C397.798 264.797 397.798 264.797 397.798 264.675ZM398.729 264.066L398.264 263.701C398.147 263.701 398.147 263.701 398.031 263.701L397.449 264.066C397.333 264.066 397.333 264.188 397.449 264.188L397.915 264.553C398.031 264.553 398.031 264.553 398.147 264.553L398.729 264.188C398.846 264.188 398.846 264.188 398.729 264.066ZM399.777 263.58L399.311 263.215C399.195 263.215 399.195 263.215 399.079 263.215L398.497 263.58C398.38 263.58 398.38 263.701 398.497 263.701L398.962 264.066C399.078 264.066 399.078 264.066 399.195 264.066L399.777 263.701C399.777 263.58 399.777 263.58 399.777 263.58ZM400.708 262.971L400.242 262.606C400.126 262.606 400.126 262.606 400.01 262.606L399.428 262.971C399.311 262.971 399.311 263.093 399.428 263.093L399.893 263.458C400.01 263.458 400.01 263.458 400.126 263.458L400.708 263.093V262.971ZM401.988 262.119L401.523 261.754C401.406 261.754 401.406 261.754 401.29 261.754L400.359 262.363C400.242 262.363 400.242 262.484 400.359 262.484L400.824 262.849C400.941 262.849 400.941 262.849 401.057 262.849L401.988 262.241C402.104 262.241 402.104 262.241 401.988 262.119ZM394.19 267.961L393.725 267.596C393.608 267.596 393.608 267.596 393.492 267.596L392.561 268.204C392.445 268.204 392.445 268.326 392.561 268.326L393.027 268.691C393.143 268.691 393.143 268.691 393.259 268.691L394.19 268.082V267.961ZM395.121 267.352L394.656 266.987C394.54 266.987 394.54 266.987 394.423 266.987L393.841 267.352C393.725 267.352 393.725 267.474 393.841 267.474L394.307 267.839C394.423 267.839 394.423 267.839 394.54 267.839L395.121 267.474C395.238 267.474 395.238 267.474 395.121 267.352ZM396.053 266.865L395.587 266.5C395.471 266.5 395.471 266.5 395.354 266.5L394.772 266.865C394.656 266.865 394.656 266.987 394.772 266.987L395.238 267.352C395.354 267.352 395.354 267.352 395.471 267.352L396.053 266.987C396.169 266.865 396.169 266.865 396.053 266.865ZM397.1 266.257L396.518 265.892C396.402 265.892 396.402 265.892 396.285 265.892L395.703 266.257C395.587 266.257 395.587 266.379 395.703 266.379L396.169 266.744C396.285 266.744 396.285 266.744 396.402 266.744L396.984 266.379C397.1 266.257 397.1 266.257 397.1 266.257ZM398.031 265.648L397.565 265.283C397.449 265.283 397.449 265.283 397.333 265.283L396.751 265.648C396.634 265.648 396.634 265.77 396.751 265.77L397.216 266.135C397.333 266.135 397.333 266.135 397.449 266.135L398.031 265.77C398.147 265.77 398.147 265.648 398.031 265.648ZM398.962 265.04L398.497 264.675C398.38 264.675 398.38 264.675 398.264 264.675L397.682 265.04C397.566 265.04 397.566 265.162 397.682 265.162L398.147 265.527C398.264 265.527 398.264 265.527 398.38 265.527L398.962 265.162C399.078 265.162 399.078 265.04 398.962 265.04ZM400.01 264.431L399.544 264.066C399.428 264.066 399.428 264.066 399.311 264.066L398.729 264.431C398.613 264.431 398.613 264.553 398.729 264.553L399.195 264.918C399.311 264.918 399.311 264.918 399.428 264.918L400.01 264.553C400.01 264.553 400.01 264.553 400.01 264.431ZM400.941 263.823L400.475 263.458C400.359 263.458 400.359 263.458 400.242 263.458L399.66 263.823C399.544 263.823 399.544 263.945 399.66 263.945L400.126 264.31C400.242 264.31 400.242 264.31 400.359 264.31L400.941 263.945C401.057 263.945 401.057 263.945 400.941 263.823ZM401.872 263.336L401.406 262.971C401.29 262.971 401.29 262.971 401.173 262.971L400.591 263.336C400.475 263.336 400.475 263.458 400.591 263.458L401.057 263.823C401.173 263.823 401.173 263.823 401.29 263.823L401.872 263.458C401.988 263.336 401.988 263.336 401.872 263.336ZM402.919 262.728L402.454 262.363C402.337 262.363 402.337 262.363 402.221 262.363L401.639 262.728C401.523 262.728 401.523 262.849 401.639 262.849L402.104 263.215C402.221 263.215 402.221 263.215 402.337 263.215L402.919 262.849V262.728ZM401.173 260.537L400.708 260.172C400.591 260.172 400.591 260.172 400.475 260.172L399.893 260.537C399.777 260.537 399.777 260.659 399.893 260.659L400.359 261.024C400.475 261.024 400.475 261.024 400.591 261.024L401.173 260.659C401.29 260.659 401.29 260.537 401.173 260.537ZM402.221 259.929L401.755 259.564C401.639 259.564 401.639 259.564 401.523 259.564L400.941 259.929C400.824 259.929 400.824 260.05 400.941 260.05L401.406 260.415C401.523 260.415 401.523 260.415 401.639 260.415L402.221 260.05V259.929ZM403.152 259.32L402.686 258.955C402.57 258.955 402.57 258.955 402.454 258.955L401.872 259.32C401.755 259.32 401.755 259.442 401.872 259.442L402.337 259.807C402.454 259.807 402.454 259.807 402.57 259.807L403.152 259.442C403.268 259.442 403.268 259.32 403.152 259.32ZM404.083 259.929L403.617 259.564C403.501 259.564 403.501 259.564 403.385 259.564L402.803 259.929C402.686 259.929 402.686 260.05 402.803 260.05L403.268 260.415C403.385 260.415 403.385 260.415 403.501 260.415L404.083 260.05C404.083 259.929 404.083 259.929 404.083 259.929Z"
          fill="#DFD7E2"
        />
        <path
          d="M394.307 265.285C394.307 265.285 394.423 265.285 394.423 265.163C394.656 264.92 394.889 264.555 395.005 264.19C395.354 262.851 394.307 261.391 393.609 260.296C393.376 259.93 393.143 259.444 392.678 259.322C392.328 259.2 391.979 259.079 391.63 259.079C390.699 258.835 389.652 259.2 388.604 258.957C387.789 258.835 385.927 260.417 386.509 261.026C388.139 262.608 390.233 262.73 390.583 262.973C391.165 263.338 391.63 264.312 391.979 264.92C392.096 265.285 392.212 265.65 392.561 265.894C392.794 266.137 393.259 266.259 393.492 266.015C393.609 265.894 393.725 265.772 393.841 265.65C393.958 265.529 394.074 265.529 394.19 265.529C394.074 265.407 394.19 265.407 394.307 265.285Z"
          fill="#FABC9D"
        />
        <path
          d="M400.128 257.009C399.43 255.792 398.964 254.94 398.615 254.332C398.033 253.237 395.705 253.967 395.938 255.062C396.055 255.549 396.636 257.861 396.753 258.348C396.986 259.2 397.102 262.242 397.917 262.486C398.615 262.729 401.525 261.877 401.408 260.66C401.292 260.66 400.943 258.47 400.128 257.009Z"
          fill="#FABC9D"
        />
        <path
          d="M394.773 270.64L398.031 261.026L397.915 260.904L394.773 270.64C394.656 270.64 394.656 270.762 394.656 270.762L394.773 270.884C394.773 270.884 394.656 270.762 394.773 270.64Z"
          fill="#ADA4B8"
        />
        <path
          d="M412.229 252.142C412.229 252.142 411.996 252.142 411.88 252.263L398.612 260.295C398.263 260.417 398.03 260.782 397.914 261.147L398.03 261.269C398.147 261.026 398.496 260.66 398.729 260.417L411.996 252.385C412.113 252.142 412.346 252.142 412.229 252.142Z"
          fill="white"
        />
        <path
          d="M411.998 252.264L398.73 260.296C398.381 260.417 398.148 260.782 398.032 261.148L394.773 270.762C394.657 271.005 394.89 271.127 395.122 270.883L408.39 262.851C408.739 262.73 408.972 262.364 409.088 261.999L412.347 252.385C412.463 252.142 412.231 252.142 411.998 252.264Z"
          fill="#DFD7E2"
        />
        <path
          d="M187.371 375.176C187.371 374.933 187.254 374.689 186.905 374.324C185.276 372.986 181.319 370.308 180.62 368.726C180.155 367.509 177.478 367.509 176.081 368.361C175.383 368.726 175.267 369.943 175.383 371.16C175.499 372.62 175.383 372.986 176.431 373.594C180.737 376.393 181.319 376.758 182.133 377.123C184.228 378.219 188.069 377.854 187.371 375.176Z"
          fill="#276E91"
        />
        <path
          d="M165.607 374.324C165.491 374.202 164.792 374.08 164.559 373.959C163.745 373.594 162.232 374.08 161.301 374.202C160.719 374.202 159.904 385.277 161.534 386.494C163.047 387.711 166.538 387.954 167.236 385.763C167.585 385.033 165.956 377.001 165.607 374.324Z"
          fill="#276E91"
        />
        <path
          d="M187.371 373.838C187.371 373.595 187.254 373.351 186.905 372.986C185.276 371.648 181.319 368.97 180.62 367.388C180.155 366.171 177.478 366.171 176.081 367.023C175.383 367.388 175.267 368.605 175.383 369.822C175.499 371.283 175.383 371.648 176.431 372.256C180.737 375.055 181.319 375.42 182.133 375.785C184.228 376.881 188.069 376.637 187.371 373.838Z"
          fill="white"
        />
        <path
          d="M165.607 373.109C165.491 372.987 164.792 372.865 164.559 372.744C163.745 372.379 162.232 372.865 161.301 372.987C160.719 372.987 159.904 384.062 161.534 385.279C163.047 386.496 166.538 386.739 167.236 384.549C167.585 383.697 165.956 375.786 165.607 373.109Z"
          fill="white"
        />
        <path
          d="M180.155 322.117C178.991 321.508 169.098 322.847 167.12 322.847C166.421 322.847 164.559 322.847 163.861 323.82C162.814 325.159 161.184 331.001 161.301 336.355C161.301 338.546 161.417 341.223 161.766 347.43C161.766 347.795 161.766 348.038 161.766 348.403C161.766 350.716 161.533 353.028 160.951 355.218C160.602 356.801 160.137 359.235 160.137 361.912C160.137 364.224 160.602 373.717 160.602 373.717C160.835 376.272 166.538 375.907 166.654 373.717C166.654 373.717 168.167 361.668 168.749 358.383C169.098 356.679 169.447 355.097 169.564 354.61C170.029 352.906 172.706 338.424 172.706 338.424L174.452 346.821C174.685 347.917 174.685 349.134 174.568 350.229C174.568 350.351 174.568 350.472 174.568 350.594C174.336 353.271 174.452 356.07 174.801 358.748C174.917 359.6 175.034 360.33 175.034 361.425C175.034 362.764 175.267 366.658 175.383 367.388C175.383 369.701 181.668 369.457 181.668 367.51C181.784 362.155 181.784 358.018 181.9 354.975C182.017 352.906 182.133 348.038 182.25 346.821C182.832 337.085 181.551 322.968 180.155 322.117Z"
          fill="white"
        />
        <path
          d="M193.659 327.957C193.659 327.957 192.611 326.983 192.146 326.01C191.68 325.036 195.986 326.01 195.637 324.671C195.404 323.576 191.564 324.306 190.516 323.576C190.051 323.211 185.628 311.162 185.628 310.797C185.279 308.972 184.581 304.104 184.581 304.104C184.581 304.104 183.999 302.765 183.3 303.252C181.555 304.591 179.693 305.929 177.598 306.538C178.761 309.58 179.925 312.379 180.507 313.84C180.856 314.692 186.792 324.549 187.025 325.401C187.141 326.01 187.607 327.713 187.839 328.322C188.189 329.417 189.702 330.391 190.749 330.634C191.68 330.878 194.241 329.539 195.637 328.444L193.659 327.957Z"
          fill="#FBBD9E"
        />
        <path
          d="M177.133 309.337C177.831 311.528 186.095 308.85 186.327 307.025C186.095 303.252 181.905 289.135 177.133 290.474C177.133 290.474 170.848 291.082 177.133 309.337Z"
          fill="#1A2C87"
        />
        <path
          d="M162 299.602C158.857 303.739 162.698 309.946 163.629 313.597C164.676 317.491 163.745 320.412 163.163 324.915C162.465 331.121 181.668 331.487 181.086 324.915C181.086 324.915 181.086 324.915 181.086 324.793C180.505 318.221 180.621 311.65 181.552 305.2C181.785 303.983 181.901 302.644 182.134 301.184C182.25 300.575 182.25 299.845 182.25 299.115C182.25 298.141 182.134 297.533 182.018 296.681C181.785 295.464 179.69 292.543 178.526 292.178C174.802 290.839 163.163 298.02 162 299.602Z"
          fill="#1A2C87"
        />
        <path
          d="M176.899 301.428C176.55 302.036 175.968 302.401 175.386 302.645C174.106 303.01 172.826 302.888 171.778 302.158C170.265 301.184 169.102 299.481 169.334 297.047C169.334 296.803 169.451 296.56 169.684 296.317C170.498 295.465 171.429 294.004 172.011 291.205C172.128 290.353 173.175 289.867 173.873 290.475C176.201 292.422 178.063 296.073 178.063 297.777C177.83 298.385 177.598 300.211 176.899 301.428Z"
          fill="#F2A883"
        />
        <path
          d="M198.778 327.227L198.545 326.618L185.859 329.052L186.092 329.661C186.092 329.782 186.209 329.782 186.325 329.782L194.006 330.634C194.355 330.634 194.937 330.513 195.17 330.269L198.429 327.592C198.778 327.47 198.778 327.348 198.778 327.227Z"
          fill="white"
        />
        <path
          d="M198.311 326.983L195.052 329.661C194.703 329.904 194.238 330.148 193.888 330.026L186.207 329.174C185.858 329.174 185.858 328.931 186.207 328.687L189.466 326.01C189.815 325.766 190.281 325.523 190.63 325.645L198.311 326.497C198.66 326.497 198.66 326.74 198.311 326.983Z"
          fill="#2035A4"
        />
        <path
          d="M191.331 330.393C190.866 330.393 190.4 330.028 190.168 329.663C190.051 329.419 189.818 329.176 189.702 328.932C190.051 329.054 190.75 329.054 191.099 329.054C191.564 329.054 192.612 328.324 191.797 328.081C191.099 327.837 189.353 327.229 188.305 326.742C188.073 326.62 187.607 326.377 187.374 326.377C187.142 326.255 186.792 326.255 186.56 326.377C185.978 326.498 185.629 326.62 185.163 326.498C181.788 324.795 174.572 319.927 172.826 318.831C172.594 318.71 172.361 318.345 172.245 317.98C171.895 316.154 171.663 314.207 171.43 312.26C171.313 311.408 170.382 311.043 169.8 311.53C168.055 312.868 166.193 314.207 164.098 314.815C165.261 317.858 166.425 320.657 167.007 322.117C167.356 322.969 167.938 323.578 168.637 324.064C171.546 325.89 179.577 328.202 183.301 329.541C184.581 330.149 186.676 332.583 187.724 332.583C189.237 332.583 192.612 331.975 193.659 330.636L191.331 330.393Z"
          fill="#FBBD9E"
        />
        <path
          d="M163.399 317.614C164.097 319.804 172.36 317.127 172.593 315.301C172.36 311.529 168.17 297.412 163.399 298.75C163.399 298.629 157.114 299.237 163.399 317.614Z"
          fill="#1A2C87"
        />
        <path
          d="M180.51 286.946C179.346 284.999 177.833 284.025 175.622 283.903C175.04 283.903 173.992 284.39 173.527 284.634C171.432 285.485 171.083 289.015 170.966 291.084C170.85 293.639 170.966 296.56 172.596 298.507C175.738 302.401 179.346 302.888 179.695 300.454C179.695 300.211 179.695 299.967 179.928 299.846C180.044 299.846 180.044 299.846 180.161 299.724C180.51 299.602 180.626 299.116 180.626 298.751C180.626 298.385 180.626 298.02 180.51 297.777C180.51 297.534 180.394 297.29 180.394 297.047C180.51 296.438 180.859 296.073 181.208 295.586C181.907 294.369 181.79 292.544 181.674 291.327C181.674 289.745 181.325 288.284 180.51 286.946Z"
          fill="#FBBD9E"
        />
        <path
          d="M180.972 285.728C178.761 283.173 175.618 282.929 173.407 284.268C167.821 285.607 167.937 292.3 171.196 296.681C170.847 295.586 172.36 294.856 172.476 295.221C173.058 296.316 173.174 297.046 173.756 297.168C174.222 297.168 173.873 296.194 175.269 295.586C175.502 295.464 179.575 295.464 181.438 293.76C181.554 293.639 181.67 293.517 181.787 293.274C182.252 292.422 183.649 288.892 180.972 285.728Z"
          fill="#2035A4"
        />
        <path
          d="M172.128 294.612C171.197 293.517 169.568 294.977 172.128 298.02C172.361 298.385 172.71 298.628 173.059 298.385C173.99 298.02 172.71 295.342 172.128 294.612Z"
          fill="#FBBD9E"
        />
        <path
          d="M382.089 388.564C382.089 387.712 381.624 386.982 380.926 386.495C380.693 386.373 380.46 386.13 380.227 385.886C378.831 384.548 376.27 382.6 375.921 382.479C373.361 381.384 370.684 383.331 371.382 384.548C372.313 385.886 377.434 391.119 377.9 391.363C379.413 392.215 382.206 391.484 382.089 390.146C382.089 389.781 382.089 389.172 382.089 388.564Z"
          fill="#276E91"
        />
        <path
          d="M368.123 396.596C367.891 396.109 363.934 395.501 363.934 395.501C363.235 395.379 361.49 395.136 360.558 395.136C357.998 395.014 355.321 395.014 354.506 395.744C353.925 396.231 353.808 396.961 354.157 397.691C354.739 398.908 356.136 400.247 365.912 401.951C366.96 402.194 367.891 401.951 368.473 401.586C368.938 401.342 369.404 400.855 369.171 400.003C368.705 398.908 368.24 396.961 368.123 396.596Z"
          fill="#276E91"
        />
        <path
          d="M382.089 387.105C382.089 386.253 381.624 385.523 380.926 385.036C380.693 384.914 380.46 384.671 380.227 384.427C378.831 383.089 376.27 381.142 375.921 381.02C373.361 379.925 370.684 381.872 371.382 383.089C372.313 384.427 377.434 389.66 377.9 389.904C379.413 390.756 382.206 390.025 382.089 388.687C382.089 388.2 382.089 387.713 382.089 387.105Z"
          fill="white"
        />
        <path
          d="M368.123 395.137C367.891 394.65 363.934 394.042 363.934 394.042C363.235 393.92 361.49 393.677 360.558 393.677C357.998 393.555 355.321 393.555 354.506 394.285C353.925 394.772 353.808 395.502 354.157 396.232C354.739 397.449 356.136 398.788 365.912 400.492C366.96 400.735 367.891 400.492 368.473 400.127C368.938 399.883 369.404 399.396 369.171 398.544C368.705 397.449 368.24 395.502 368.123 395.137Z"
          fill="white"
        />
        <path
          d="M362.07 341.711C361.837 343.901 361.139 366.659 361.255 367.876C361.488 370.431 361.488 375.908 361.488 379.802C361.488 384.792 361.837 395.014 361.837 395.014C361.953 397.448 367.54 397.935 368.122 395.745L370.1 380.411C370.682 377.003 369.984 374.204 369.984 370.797C370.333 366.294 373.359 352.907 375.221 345.24C375.454 344.145 374.988 343.049 374.407 342.076C371.846 337.938 363.35 336.964 362.07 341.711Z"
          fill="#2035A4"
        />
        <path
          d="M382.087 363.251C381.272 358.383 382.669 353.028 382.552 348.16C382.436 345.361 382.32 340.737 381.272 337.573C381.156 337.329 381.039 337.329 380.807 337.451C377.199 339.277 374.056 339.033 372.427 342.076L370.914 345.605C371.496 349.986 372.194 354.854 373.358 359.722C373.824 361.912 374.056 364.103 374.638 366.902C374.871 368.119 375.104 369.458 375.22 370.675C375.569 373.23 375.569 374.569 375.569 374.691C375.686 377.246 376.384 379.437 376.5 385.157C376.733 387.347 381.971 387.956 381.971 386.009C381.971 384.305 382.32 382.114 382.552 381.019C383.484 376.394 383.949 373.352 383.251 368.727C382.902 366.415 382.436 365.442 382.087 363.251Z"
          fill="#2035A4"
        />
        <path
          d="M343.101 317.25C342.984 317.128 342.868 317.006 342.868 316.885C342.752 316.154 342.519 313.842 344.148 311.408C345.661 309.096 347.407 312.99 347.407 312.99L345.428 319.075L343.101 317.25Z"
          fill="#FCBE9F"
        />
        <path
          d="M345.776 317.858L340.073 303.985C339.957 303.741 340.073 303.498 340.19 303.376L347.871 298.387H347.987H347.638H347.522L339.84 303.376C339.724 303.498 339.608 303.741 339.724 303.985L345.427 317.858C345.543 318.102 345.66 318.102 345.776 318.102H346.125C346.009 318.102 345.892 318.102 345.776 317.858Z"
          fill="white"
        />
        <path
          d="M354.155 312.382L348.452 298.508C348.336 298.265 348.103 298.143 347.987 298.265L340.305 303.254C340.189 303.376 340.072 303.619 340.189 303.863L345.892 317.736C346.008 317.98 346.241 318.101 346.357 317.98L354.038 312.99C354.155 312.99 354.155 312.625 354.155 312.382Z"
          fill="#2035A4"
        />
        <path
          d="M368.123 317.979C366.144 317.006 362.653 315.058 361.838 314.328L359.627 311.529C359.161 310.921 358.579 310.556 357.881 310.434C354.738 309.947 355.088 310.069 353.924 310.556C353.342 310.677 352.876 311.042 352.76 311.286C352.527 311.651 351.945 311.773 351.596 312.016C351.247 312.259 351.131 312.746 351.363 313.111C351.596 313.355 351.945 313.355 352.294 313.233C355.088 312.868 357.299 313.841 357.299 314.207C357.299 314.45 356.601 314.693 354.971 314.815C354.622 314.815 354.273 314.693 354.04 314.937C353.807 315.058 353.575 315.545 353.807 315.789C353.924 315.91 353.924 315.91 354.04 315.91C354.855 316.275 355.786 316.154 356.601 316.275C357.299 316.275 357.997 316.519 358.579 316.884C359.161 317.249 359.743 317.614 360.325 318.101C361.605 319.074 367.191 323.699 367.657 323.942C367.541 321.874 368.123 320.048 368.123 317.979Z"
          fill="#FCBE9F"
        />
        <path
          d="M359.859 315.546C357.532 317.858 352.644 324.916 352.644 324.916C352.644 324.916 347.29 318.953 345.544 316.641C345.661 315.059 345.544 314.329 346.475 312.99C347.057 312.138 346.359 311.773 345.777 312.138C344.264 313.112 343.449 313.842 342.867 315.546C342.751 316.032 342.635 317.249 343.449 318.953C344.613 321.752 350.665 331.975 352.993 331.975C355.902 331.975 362.187 324.43 363.002 323.456C364.049 322.239 360.441 314.937 359.859 315.546Z"
          fill="#FCBE9F"
        />
        <path
          d="M360.91 313.476C358 314.571 357.884 317.492 358.582 319.561C358.815 320.291 359.048 320.048 359.397 320.656C361.608 325.767 362.539 331.487 362.306 337.085C362.19 339.154 362.074 340.98 361.957 341.953C361.259 348.16 383.139 347.186 381.51 338.546C380.695 334.651 380.113 328.566 381.277 325.159C382.324 321.63 383.256 318.1 383.954 314.571C385.234 308.121 377.32 309.46 375.574 309.582C373.712 309.582 364.751 311.894 360.91 313.476Z"
          fill="white"
        />
        <path
          d="M359.507 314.207C358.227 315.424 355.201 319.683 353.804 321.63C352.64 323.213 357.994 329.054 360.089 327.715C360.904 327.229 364.512 322.239 365.093 321.63C368.469 317.736 362.649 311.164 359.507 314.207Z"
          fill="white"
        />
        <path
          d="M370.447 313.719C373.24 313.232 375.451 311.894 375.218 310.677C375.218 310.312 374.636 309.947 374.171 309.703C371.61 310.19 365.558 311.772 365.209 312.015C364.977 312.259 364.977 312.502 364.977 312.624C365.209 313.719 367.537 314.206 370.447 313.719Z"
          fill="#FBBD9E"
        />
        <path
          d="M363.93 299.36C363.93 299.603 362.65 301.064 362.534 301.307C362.301 301.672 362.883 302.402 362.883 302.524C362.883 303.011 362.766 303.376 362.65 303.863C362.417 304.715 362.301 305.688 362.65 306.418C363.116 307.27 364.396 307.392 364.978 308.244C365.21 308.487 365.327 308.852 365.443 309.217L366.025 311.895C366.723 314.207 374.754 312.017 374.172 310.313C373.706 309.217 373.59 307.757 373.823 307.514C374.288 306.905 374.987 305.932 375.569 304.593C376.965 301.307 376.034 297.413 373.125 295.466C372.077 294.735 370.797 294.37 369.284 294.249C368.004 294.127 366.025 294.492 364.861 296.439C364.396 297.169 364.163 298.143 363.93 299.36Z"
          fill="#FBBD9E"
        />
        <path
          d="M366.375 300.577C366.724 300.82 366.84 301.429 366.607 301.794C366.375 302.402 366.025 303.011 366.142 303.254C366.142 303.376 366.375 303.498 366.491 303.498C366.607 303.498 366.724 303.376 366.84 303.254C367.888 302.037 369.517 303.498 367.888 305.445C366.142 307.514 367.189 308.852 368.935 309.461C371.146 310.191 373.94 308.852 375.103 306.662C375.918 305.201 376.5 303.498 376.733 301.794C377.198 296.926 373.59 293.153 368.586 293.031C364.512 292.91 364.28 296.317 364.396 297.534C364.512 298.751 365.676 299.847 366.375 300.577Z"
          fill="#2035A4"
        />
        <path
          d="M97.5355 331.124C97.7683 331.854 102.54 336.6 102.889 336.965C105.799 339.399 109.29 337.087 107.312 334.409C106.73 333.679 101.958 327.959 101.609 327.594C101.376 327.351 101.027 326.986 100.678 326.864C99.8632 326.499 99.0485 326.864 98.2338 327.229C96.8372 327.959 97.4191 330.637 97.5355 331.124Z"
          fill="white"
        />
        <path
          d="M108.012 335.627C107.546 337.087 105.218 337.696 103.123 335.992C102.774 335.627 98.0026 330.881 97.7698 330.15C97.6534 329.907 97.537 329.299 97.537 328.568C97.3043 329.542 97.6534 330.759 97.6534 331.124C97.8862 331.854 102.658 336.6 103.007 336.966C105.451 339.034 108.361 337.696 108.012 335.627Z"
          fill="#276E91"
        />
        <path
          d="M101.492 331.002C102.423 331.245 103.122 330.88 102.889 330.028C102.773 329.541 102.074 328.69 101.842 328.081L101.609 326.499C101.26 326.256 98.4664 326.012 98.1173 326.134C98.1173 326.134 98.0009 327.108 98.0009 328.203C97.8845 328.811 98.9319 330.393 101.492 331.002Z"
          fill="#FBBD9E"
        />
        <path
          d="M97.0599 341.712C97.409 342.442 102.646 346.58 102.995 346.945C106.138 349.014 109.397 346.336 107.185 343.902C106.603 343.172 101.133 338.061 100.784 337.818C100.435 337.574 100.086 337.331 99.7367 337.209C98.8056 336.966 98.1073 337.452 97.2927 337.818C96.0124 338.669 96.8271 341.225 97.0599 341.712Z"
          fill="white"
        />
        <path
          d="M107.887 344.999C107.538 346.459 105.326 347.433 102.999 345.972C102.533 345.729 97.2957 341.469 97.063 340.739C96.9466 340.496 96.7138 339.887 96.7138 339.157C96.5975 340.131 97.063 341.348 97.1794 341.591C97.5285 342.321 102.766 346.459 103.115 346.824C105.675 348.65 108.352 346.946 107.887 344.999Z"
          fill="#276E91"
        />
        <path
          d="M101.948 340.738C102.297 340.616 102.53 340.13 102.297 339.764C101.831 339.034 100.784 338.182 100.551 337.574C100.435 337.209 100.435 336.844 100.318 336.6C100.086 335.262 98.9217 335.505 97.9906 335.992C97.4087 336.357 97.0595 336.844 96.9432 337.574C96.8268 338.182 97.0595 339.156 97.6415 339.643C99.0381 340.616 100.784 341.103 101.948 340.738Z"
          fill="#FBBD9E"
        />
        <path
          d="M86.8242 262C86.8242 262.608 86.9406 263.339 86.9406 263.947C87.5225 268.45 90.083 278.551 90.083 278.551L96.3677 292.546C96.9496 293.52 99.6264 292.424 99.1609 290.964C98.2298 287.8 94.8547 275.265 94.8547 275.265C94.8547 275.265 93.3417 261.635 93.1089 260.661C92.6434 259.323 91.5959 256.767 89.3847 257.132C87.2898 257.497 86.9406 260.174 86.8242 262Z"
          fill="white"
        />
        <path
          d="M93.6828 271.25C92.2862 267.721 87.98 265.287 89.6093 257.498C87.1653 256.768 74.2467 264.557 73.1992 267.356C73.1992 267.356 77.1563 276.483 78.0873 282.325C78.5529 285.245 77.7382 288.166 76.9235 290.965C76.8071 295.711 91.2387 293.521 91.1223 287.679C91.0059 285.124 91.1223 281.229 91.1223 279.526C91.1223 278.43 92.4025 276.605 92.8681 275.753C94.0319 273.928 94.2647 272.589 93.6828 271.25Z"
          fill="#2035A4"
        />
        <path
          d="M74.9456 300.093C75.5275 303.987 77.0405 305.204 79.9501 307.76C91.9376 318.47 92.9851 317.496 92.7523 318.956C92.1704 322.242 92.2868 325.528 93.4506 328.692C94.8472 332.221 96.0111 333.56 96.593 337.089C97.0585 338.671 101.365 337.941 101.016 336.603C99.619 330.396 99.619 326.867 99.619 320.173C99.619 318.104 99.619 315.792 98.9207 313.967C97.8732 311.411 91.7049 306.178 90.1919 303.744C90.1919 303.744 98.5715 307.517 103.227 312.506C100.783 318.47 100.084 319.565 97.7568 326.867C97.5241 328.814 101.365 329.909 102.063 328.449C103.576 324.798 108.115 317.861 111.025 314.088C112.305 312.385 111.025 309.707 109.744 308.003C109.279 307.395 108.697 306.665 108.231 306.178C104.74 302.162 95.4291 292.913 93.567 291.087C92.6359 289.505 91.7049 287.68 91.3557 286.463C91.7049 290.844 81.3467 293.886 77.5061 289.505C75.4111 293.278 74.4801 297.051 74.9456 300.093Z"
          fill="#2035A4"
        />
        <path
          d="M72.1562 270.884C72.1562 271.493 72.2726 272.223 72.2726 272.831C72.7382 275.752 73.902 280.985 74.7167 284.271C75.1822 286.218 76.3461 288.044 77.859 289.261L88.3336 297.414C89.2647 298.023 91.1268 295.832 90.5449 295.102C87.6353 292.425 80.1867 284.271 80.1867 284.271C80.1867 284.271 78.6737 270.641 78.441 269.667C77.9754 268.328 76.928 265.773 74.7167 266.138C72.6218 266.381 72.2726 269.18 72.1562 270.884Z"
          fill="white"
        />
        <path
          d="M80.7688 243.502C78.3247 243.259 75.6479 245.449 75.4151 248.126C75.2987 249.952 76.3462 251.169 77.3937 251.777C78.9066 252.751 79.2558 251.777 80.4196 251.412C81.3507 251.047 84.9586 247.518 84.7258 246.788C84.7258 246.788 84.0275 243.745 80.7688 243.502Z"
          fill="#2035A4"
        />
        <path
          d="M79.7184 263.338C80.0675 265.894 86.1195 268.45 86.3523 264.677C86.3523 263.46 86.4686 262.365 86.7014 261.148C87.2833 258.957 86.9342 256.767 84.0246 256.28C80.3003 255.671 81.3478 257.862 81.2314 259.444C80.8822 262 79.602 262.73 79.7184 263.338Z"
          fill="#F3A984"
        />
        <path
          d="M77.9724 249.344C77.5068 250.074 77.3904 251.048 77.5068 251.899C77.856 255.915 82.8605 262.244 86.4684 263.826C89.4943 265.164 89.7271 260.54 89.9599 256.524C89.9599 255.672 89.9599 254.333 89.9599 253.238C89.8435 250.804 88.6797 248.492 86.7011 247.275C85.1881 246.301 83.326 245.936 81.5803 246.788C80.8819 247.031 78.3215 248.614 77.9724 249.344Z"
          fill="#FBBD9E"
        />
        <path
          d="M77.1598 251.047C76.3451 255.185 80.5349 258.714 80.5349 258.714C82.1643 259.444 81.1168 254.576 83.2117 254.698C88.449 254.941 89.1473 252.629 89.3801 252.142C89.4964 251.899 89.7292 252.264 89.7292 252.264C89.3801 244.84 78.5564 243.137 77.1598 251.047Z"
          fill="#2035A4"
        />
        <path
          d="M79.0214 257.498C79.3706 258.35 81.3491 260.053 81.8147 259.932C82.3966 259.81 81.8147 258.106 81.6983 257.62C81.1164 255.551 78.3231 255.794 79.0214 257.498Z"
          fill="#FBBD9E"
        />
        <path
          d="M94.9609 308.489L110.324 298.996V299.361L94.9609 308.854V308.489Z"
          fill="url(#paint14_linear_1926_44029)"
        />
        <path
          d="M84.0234 301.674L99.5025 292.182L110.326 298.753L94.9635 308.246L84.0234 301.674Z"
          fill="#ECE7E2"
        />
        <path
          opacity="0.2"
          d="M98.8012 297.9L93.7967 300.942C93.6804 301.064 93.4476 301.064 93.4476 300.942L90.1889 298.995C90.0725 298.874 90.0725 298.874 90.1889 298.752L95.1933 295.709C95.3097 295.588 95.5425 295.588 95.5425 295.709L98.8012 297.657C98.9176 297.657 98.9176 297.778 98.8012 297.9Z"
          fill="#C9C6C1"
        />
        <path
          d="M95.0787 295.709C95.1951 295.588 95.4279 295.588 95.4279 295.709L98.6866 297.657C98.6866 297.657 98.803 297.657 98.803 297.778C98.803 297.778 98.803 297.657 98.6866 297.657L95.4279 295.709C95.3115 295.588 95.0787 295.588 95.0787 295.709Z"
          fill="#C9C6C1"
        />
        <path
          d="M91.3581 304.228L90.6598 304.594C90.5434 304.594 90.5434 304.594 90.427 304.594L89.8451 304.228C89.7287 304.228 89.7287 304.107 89.8451 304.107L90.5434 303.742C90.6598 303.742 90.6598 303.742 90.7762 303.742L91.3581 304.107V304.228ZM92.4055 303.498L91.8236 303.133C91.7072 303.133 91.7072 303.133 91.5909 303.133L90.8926 303.498C90.7762 303.498 90.7762 303.62 90.8926 303.62L91.4745 303.985C91.5909 303.985 91.5909 303.985 91.7072 303.985L92.4055 303.62C92.4055 303.498 92.4055 303.498 92.4055 303.498ZM93.453 302.768L92.8711 302.403C92.7547 302.403 92.7547 302.403 92.6383 302.403L91.94 302.768C91.8236 302.768 91.8236 302.89 91.94 302.89L92.5219 303.255C92.6383 303.255 92.6383 303.255 92.7547 303.255L93.453 302.89C93.5694 302.89 93.5694 302.89 93.453 302.768ZM94.5004 302.16L93.9185 301.795C93.8021 301.795 93.8022 301.795 93.6858 301.795L92.9875 302.16C92.8711 302.16 92.8711 302.281 92.9875 302.281L93.5694 302.646C93.6858 302.646 93.6858 302.646 93.8021 302.646L94.5004 302.281C94.6168 302.281 94.6168 302.16 94.5004 302.16ZM95.6643 301.429L95.0824 301.186C94.966 301.186 94.966 301.186 94.8496 301.186L94.1513 301.551C94.0349 301.551 94.0349 301.673 94.1513 301.673L94.7332 302.038C94.8496 302.038 94.8496 302.038 94.966 302.038L95.6643 301.673C95.6643 301.551 95.6643 301.551 95.6643 301.429ZM96.7117 300.821L96.1298 300.456C96.0134 300.456 96.0134 300.456 95.897 300.456L95.1987 300.821C95.0824 300.821 95.0824 300.943 95.1987 300.943L95.7807 301.308C95.8971 301.308 95.8971 301.308 96.0134 301.308L96.7117 300.943V300.821ZM97.7592 300.212L97.1773 299.847C97.0609 299.847 97.0609 299.847 96.9445 299.847L96.2462 300.212C96.1298 300.212 96.1298 300.334 96.2462 300.334L96.8281 300.699C96.9445 300.699 96.9445 300.699 97.0609 300.699L97.7592 300.334C97.8756 300.212 97.8756 300.212 97.7592 300.212ZM98.8066 299.482L98.2247 299.117C98.1083 299.117 98.1083 299.117 97.992 299.117L97.2937 299.482C97.1773 299.482 97.1773 299.604 97.2937 299.604L97.8756 299.969C97.992 299.969 97.992 299.969 98.1083 299.969L98.8066 299.604C98.923 299.604 98.923 299.482 98.8066 299.482ZM99.9705 298.874L99.3886 298.509C99.2722 298.509 99.2722 298.509 99.1558 298.509L98.4575 298.874C98.3411 298.874 98.3411 298.995 98.4575 298.995L99.0394 299.361C99.1558 299.361 99.1558 299.361 99.2722 299.361L99.9705 298.995V298.874ZM101.367 298.022L100.785 297.657C100.669 297.657 100.669 297.657 100.552 297.657L99.505 298.265C99.3886 298.265 99.3886 298.387 99.505 298.387L100.087 298.752C100.203 298.752 100.203 298.752 100.32 298.752L101.367 298.144C101.367 298.022 101.367 298.022 101.367 298.022ZM105.441 299.117L104.859 298.752C104.742 298.752 104.742 298.752 104.626 298.752L103.928 299.117C103.811 299.117 103.811 299.239 103.928 299.239L104.509 299.604C104.626 299.604 104.626 299.604 104.742 299.604L105.441 299.239V299.117ZM106.488 298.387L105.906 298.022C105.79 298.022 105.79 298.022 105.673 298.022L104.975 298.387C104.859 298.387 104.859 298.509 104.975 298.509L105.557 298.874C105.673 298.874 105.673 298.874 105.79 298.874L106.488 298.509C106.604 298.509 106.604 298.509 106.488 298.387ZM107.535 297.778L106.954 297.413C106.837 297.413 106.837 297.413 106.721 297.413L106.022 297.778C105.906 297.778 105.906 297.9 106.022 297.9L106.604 298.265C106.721 298.265 106.721 298.265 106.837 298.265L107.535 297.9C107.652 297.9 107.652 297.778 107.535 297.778ZM106.372 299.726L105.79 299.361C105.673 299.361 105.673 299.361 105.557 299.361L104.859 299.726C104.742 299.726 104.742 299.847 104.859 299.847L105.441 300.212C105.557 300.212 105.557 300.212 105.673 300.212L106.372 299.847C106.488 299.726 106.488 299.726 106.372 299.726ZM107.535 298.995L106.954 298.63C106.837 298.63 106.837 298.63 106.721 298.63L106.022 298.995C105.906 298.995 105.906 299.117 106.022 299.117L106.604 299.482C106.721 299.482 106.721 299.482 106.837 299.482L107.535 299.117V298.995ZM108.583 298.387L108.001 298.022C107.885 298.022 107.885 298.022 107.768 298.022L107.07 298.387C106.954 298.387 106.954 298.509 107.07 298.509L107.652 298.874C107.768 298.874 107.768 298.874 107.885 298.874L108.583 298.509V298.387ZM92.6383 304.472L92.0564 304.107C91.94 304.107 91.94 304.107 91.8236 304.107L90.7762 304.715C90.6598 304.715 90.6598 304.837 90.7762 304.837L91.3581 305.202C91.4745 305.202 91.4745 305.202 91.5909 305.202L92.6383 304.594C92.7547 304.594 92.7547 304.472 92.6383 304.472ZM93.6858 303.863L93.1038 303.498C92.9875 303.498 92.9875 303.498 92.8711 303.498L92.1728 303.863C92.0564 303.863 92.0564 303.985 92.1728 303.985L92.7547 304.35C92.8711 304.35 92.8711 304.35 92.9875 304.35L93.6858 303.985C93.8022 303.985 93.8022 303.863 93.6858 303.863ZM94.8496 303.133L94.2677 302.768C94.1513 302.768 94.1513 302.768 94.0349 302.768L93.3366 303.133C93.2202 303.133 93.2202 303.255 93.3366 303.255L93.9185 303.62C94.0349 303.62 94.0349 303.62 94.1513 303.62L94.8496 303.255C94.8496 303.255 94.8496 303.255 94.8496 303.133ZM95.897 302.525L95.3151 302.16C95.1987 302.16 95.1988 302.16 95.0824 302.16L94.3841 302.525C94.2677 302.525 94.2677 302.646 94.3841 302.646L94.966 303.011C95.0824 303.011 95.0824 303.011 95.1987 303.011L95.897 302.646C96.0134 302.646 96.0134 302.525 95.897 302.525ZM96.9445 301.795L96.3626 301.429C96.2462 301.429 96.2462 301.429 96.1298 301.429L95.4315 301.795C95.3151 301.795 95.3151 301.916 95.4315 301.916L96.0134 302.281C96.1298 302.281 96.1298 302.281 96.2462 302.281L96.9445 301.916C97.0609 301.916 97.0609 301.916 96.9445 301.795ZM98.1083 301.186L97.5264 300.821C97.41 300.821 97.41 300.821 97.2937 300.821L96.5954 301.186C96.479 301.186 96.479 301.308 96.5954 301.308L97.1773 301.673C97.2937 301.673 97.2937 301.673 97.41 301.673L98.1083 301.308V301.186ZM99.1558 300.578L98.5739 300.212C98.4575 300.212 98.4575 300.212 98.3411 300.212L97.6428 300.578C97.5264 300.578 97.5264 300.699 97.6428 300.699L98.2247 301.064C98.3411 301.064 98.3411 301.064 98.4575 301.064L99.1558 300.699C99.1558 300.578 99.1558 300.578 99.1558 300.578ZM100.203 299.847L99.6213 299.482C99.505 299.482 99.5049 299.482 99.3886 299.482L98.6903 299.847C98.5739 299.847 98.5739 299.969 98.6903 299.969L99.2722 300.334C99.3886 300.334 99.3886 300.334 99.505 300.334L100.203 299.969C100.32 299.969 100.32 299.969 100.203 299.847ZM101.251 299.239L100.669 298.874C100.552 298.874 100.552 298.874 100.436 298.874L99.7377 299.239C99.6213 299.239 99.6213 299.361 99.7377 299.361L100.32 299.726C100.436 299.726 100.436 299.726 100.552 299.726L101.251 299.361C101.367 299.361 101.367 299.239 101.251 299.239ZM102.415 298.509L101.833 298.144C101.716 298.144 101.716 298.144 101.6 298.144L100.902 298.509C100.785 298.509 100.785 298.63 100.902 298.63L101.483 298.995C101.6 298.995 101.6 298.995 101.716 298.995L102.415 298.63C102.415 298.63 102.415 298.63 102.415 298.509ZM93.3366 305.324L92.7547 304.959C92.6383 304.959 92.6383 304.959 92.5219 304.959L91.8236 305.324C91.7072 305.324 91.7072 305.445 91.8236 305.445L92.4055 305.811C92.5219 305.811 92.5219 305.811 92.6383 305.811L93.3366 305.445V305.324ZM94.3841 304.594L93.8021 304.228C93.6858 304.228 93.6858 304.228 93.5694 304.228L92.8711 304.594C92.7547 304.594 92.7547 304.715 92.8711 304.715L93.453 305.08C93.5694 305.08 93.5694 305.08 93.6858 305.08L94.3841 304.715C94.3841 304.715 94.3841 304.715 94.3841 304.594ZM95.4315 303.985L94.8496 303.62C94.7332 303.62 94.7332 303.62 94.6168 303.62L93.9185 303.985C93.8021 303.985 93.8021 304.107 93.9185 304.107L94.5004 304.472C94.6168 304.472 94.6168 304.472 94.7332 304.472L95.4315 304.107C95.5479 304.107 95.5479 303.985 95.4315 303.985ZM96.479 303.255L95.897 302.89C95.7807 302.89 95.7807 302.89 95.6643 302.89L94.966 303.255C94.8496 303.255 94.8496 303.377 94.966 303.377L95.5479 303.742C95.6643 303.742 95.6643 303.742 95.7807 303.742L96.479 303.377C96.5954 303.377 96.5954 303.377 96.479 303.255ZM95.1987 306.419L94.6168 306.054C94.5004 306.054 94.5005 306.054 94.3841 306.054L93.6858 306.419C93.5694 306.419 93.5694 306.541 93.6858 306.541L94.2677 306.906C94.3841 306.906 94.3841 306.906 94.5004 306.906L95.1987 306.541C95.3151 306.541 95.3151 306.541 95.1987 306.419ZM96.3626 305.811L95.7807 305.445C95.6643 305.445 95.6643 305.445 95.5479 305.445L94.8496 305.811C94.7332 305.811 94.7332 305.932 94.8496 305.932L95.4315 306.297C95.5479 306.297 95.5479 306.297 95.6643 306.297L96.3626 305.932V305.811ZM97.41 305.08L96.8281 304.715C96.7117 304.715 96.7117 304.715 96.5954 304.715L95.897 305.08C95.7807 305.08 95.7807 305.202 95.897 305.202L96.479 305.567C96.5954 305.567 96.5954 305.567 96.7117 305.567L97.41 305.202C97.41 305.202 97.41 305.202 97.41 305.08ZM98.4575 304.472L97.8756 304.107C97.7592 304.107 97.7592 304.107 97.6428 304.107L96.9445 304.472C96.8281 304.472 96.8281 304.594 96.9445 304.594L97.5264 304.959C97.6428 304.959 97.6428 304.959 97.7592 304.959L98.4575 304.594C98.5739 304.594 98.5739 304.472 98.4575 304.472ZM105.324 300.334L104.742 299.969C104.626 299.969 104.626 299.969 104.509 299.969L103.462 300.578C103.346 300.578 103.346 300.699 103.462 300.699L104.044 301.064C104.16 301.064 104.16 301.064 104.277 301.064L105.324 300.456V300.334ZM97.6428 302.646L97.0609 302.281C96.9445 302.281 96.9445 302.281 96.8281 302.281L96.1298 302.646C96.0134 302.646 96.0134 302.768 96.1298 302.768L96.7117 303.133C96.8281 303.133 96.8281 303.133 96.9445 303.133L97.6428 302.768V302.646ZM98.6903 302.038L98.1083 301.673C97.992 301.673 97.992 301.673 97.8756 301.673L97.1773 302.038C97.0609 302.038 97.0609 302.16 97.1773 302.16L97.7592 302.525C97.8756 302.525 97.8756 302.525 97.992 302.525L98.6903 302.16C98.6903 302.038 98.6903 302.038 98.6903 302.038ZM99.7377 301.308L99.1558 300.943C99.0394 300.943 99.0394 300.943 98.923 300.943L98.2247 301.308C98.1083 301.308 98.1083 301.429 98.2247 301.429L98.8066 301.795C98.923 301.795 98.923 301.795 99.0394 301.795L99.7377 301.429C99.8541 301.429 99.8541 301.429 99.7377 301.308ZM100.785 300.699L100.203 300.334C100.087 300.334 100.087 300.334 99.9705 300.334L99.2722 300.699C99.1558 300.699 99.1558 300.821 99.2722 300.821L99.8541 301.186C99.9705 301.186 99.9705 301.186 100.087 301.186L100.785 300.821C100.902 300.821 100.902 300.699 100.785 300.699ZM101.949 299.969L101.367 299.604C101.251 299.604 101.251 299.604 101.134 299.604L100.436 299.969C100.32 299.969 100.32 300.091 100.436 300.091L101.018 300.456C101.134 300.456 101.134 300.456 101.251 300.456L101.949 300.091C101.949 300.091 101.949 300.091 101.949 299.969ZM103.346 299.117L102.764 298.752C102.647 298.752 102.647 298.752 102.531 298.752L101.483 299.361C101.367 299.361 101.367 299.482 101.483 299.482L102.065 299.847C102.182 299.847 102.182 299.847 102.298 299.847L103.346 299.239C103.346 299.239 103.346 299.239 103.346 299.117ZM94.6168 305.689L94.0349 305.324C93.9185 305.324 93.9185 305.324 93.8021 305.324L92.7547 305.932C92.6383 305.932 92.6383 306.054 92.7547 306.054L93.3366 306.419C93.453 306.419 93.453 306.419 93.5694 306.419L94.6168 305.811C94.7332 305.811 94.7332 305.689 94.6168 305.689ZM95.6643 304.959L95.0824 304.594C94.966 304.594 94.966 304.594 94.8496 304.594L94.1513 304.959C94.0349 304.959 94.0349 305.08 94.1513 305.08L94.7332 305.445C94.8496 305.445 94.8496 305.445 94.966 305.445L95.6643 305.08C95.7807 305.08 95.7807 305.08 95.6643 304.959ZM96.8281 304.35L96.2462 303.985C96.1298 303.985 96.1298 303.985 96.0134 303.985L95.3151 304.35C95.1987 304.35 95.1987 304.472 95.3151 304.472L95.897 304.837C96.0134 304.837 96.0134 304.837 96.1298 304.837L96.8281 304.472V304.35ZM97.8756 303.62L97.2937 303.255C97.1773 303.255 97.1773 303.255 97.0609 303.255L96.3626 303.62C96.2462 303.62 96.2462 303.742 96.3626 303.742L96.9445 304.107C97.0609 304.107 97.0609 304.107 97.1773 304.107L97.8756 303.742C97.8756 303.742 97.8756 303.742 97.8756 303.62ZM98.923 303.011L98.3411 302.646C98.2247 302.646 98.2247 302.646 98.1083 302.646L97.41 303.011C97.2937 303.011 97.2937 303.133 97.41 303.133L97.992 303.498C98.1083 303.498 98.1083 303.498 98.2247 303.498L98.923 303.133C99.0394 303.133 99.0394 303.011 98.923 303.011ZM103.928 301.186L103.346 300.821C103.229 300.821 103.229 300.821 103.113 300.821L98.1083 303.863C97.992 303.863 97.992 303.985 98.1083 303.985L98.6903 304.35C98.8066 304.35 98.8067 304.35 98.923 304.35L103.928 301.308V301.186ZM99.9705 302.403L99.3886 302.038C99.2722 302.038 99.2722 302.038 99.1558 302.038L98.5739 302.403C98.4575 302.403 98.4575 302.525 98.5739 302.525L99.1558 302.89C99.2722 302.89 99.2722 302.89 99.3886 302.89L100.087 302.525C100.087 302.525 100.087 302.403 99.9705 302.403ZM101.134 301.673L100.552 301.308C100.436 301.308 100.436 301.308 100.32 301.308L99.6213 301.673C99.505 301.673 99.505 301.795 99.6213 301.795L100.203 302.16C100.32 302.16 100.32 302.16 100.436 302.16L101.134 301.795C101.134 301.795 101.134 301.794 101.134 301.673ZM102.182 301.064L101.6 300.699C101.483 300.699 101.483 300.699 101.367 300.699L100.669 301.064C100.552 301.064 100.552 301.186 100.669 301.186L101.251 301.551C101.367 301.551 101.367 301.551 101.483 301.551L102.182 301.186C102.298 301.186 102.298 301.064 102.182 301.064ZM103.229 300.334L102.647 299.969C102.531 299.969 102.531 299.969 102.415 299.969L101.716 300.334C101.6 300.334 101.6 300.456 101.716 300.456L102.298 300.821C102.415 300.821 102.415 300.821 102.531 300.821L103.229 300.456C103.346 300.456 103.346 300.456 103.229 300.334ZM104.277 299.726L103.695 299.361C103.578 299.361 103.578 299.361 103.462 299.361L102.764 299.726C102.647 299.726 102.647 299.847 102.764 299.847L103.346 300.212C103.462 300.212 103.462 300.212 103.578 300.212L104.277 299.847C104.393 299.847 104.393 299.726 104.277 299.726ZM102.415 297.292L101.833 296.927C101.716 296.927 101.716 296.927 101.6 296.927L100.902 297.292C100.785 297.292 100.785 297.413 100.902 297.413L101.483 297.778C101.6 297.778 101.6 297.778 101.716 297.778L102.415 297.413C102.531 297.413 102.531 297.292 102.415 297.292ZM103.578 296.683L102.996 296.318C102.88 296.318 102.88 296.318 102.764 296.318L102.065 296.683C101.949 296.683 101.949 296.805 102.065 296.805L102.647 297.17C102.764 297.17 102.764 297.17 102.88 297.17L103.578 296.805V296.683ZM104.626 295.953L104.044 295.588C103.928 295.588 103.928 295.588 103.811 295.588L103.113 295.953C102.996 295.953 102.996 296.075 103.113 296.075L103.695 296.44C103.811 296.44 103.811 296.44 103.928 296.44L104.626 296.075C104.626 296.075 104.626 296.075 104.626 295.953ZM105.557 296.561L104.975 296.196C104.859 296.196 104.859 296.196 104.742 296.196L104.044 296.561C103.928 296.561 103.928 296.683 104.044 296.683L104.626 297.048C104.742 297.048 104.742 297.048 104.859 297.048L105.557 296.683C105.673 296.683 105.673 296.561 105.557 296.561ZM106.604 297.17L106.022 296.805C106.022 296.805 105.906 296.805 105.79 296.805L104.859 297.413H104.742L104.044 296.927C103.928 296.927 103.811 296.927 103.695 296.927L101.949 297.9C101.833 297.9 101.833 298.022 101.949 298.022L103.462 298.874C103.578 298.874 103.695 298.874 103.811 298.874L106.604 297.17Z"
          fill="#FBFFFB"
        />
        <path
          d="M99.7374 299.604L115.1 290.111L110.561 299.117L95.082 308.609L99.7374 299.604Z"
          fill="url(#paint15_linear_1926_44029)"
        />
        <path
          d="M99.5039 299.361L114.867 289.868L115.099 290.112L99.7367 299.604L99.5039 299.361Z"
          fill="#ECE7E2"
        />
        <path
          d="M99.5025 299.36L99.7352 299.604L95.0799 308.609L94.9635 308.488V308.853L84.0234 302.281V301.673L94.9635 308.244L99.5025 299.36Z"
          fill="#C9C6C1"
        />
        <path
          d="M93.2226 296.927C93.6881 297.414 95.0847 300.578 94.7355 301.43C94.5028 301.916 92.9898 302.403 92.4079 302.282C92.2915 302.282 92.1751 302.16 92.0587 302.16C91.9423 302.038 91.9423 301.916 91.9423 301.795C91.5932 300.943 90.7785 299.848 90.7785 299.848C90.7785 299.848 89.731 298.631 88.8 297.414L88.6836 297.292C88.6836 297.17 88.6836 297.17 88.6836 297.048C88.9164 296.44 89.3819 295.831 89.9638 295.466C90.0802 295.466 90.1966 295.345 90.4293 295.345C91.244 295.345 92.6406 296.318 93.2226 296.927Z"
          fill="#FBBD9E"
        />
        <path
          d="M97.8797 297.656C98.1125 298.387 99.3927 298.508 99.5091 298.387C99.9746 298.265 100.789 297.9 100.789 297.413C100.789 295.466 100.789 294.37 100.324 293.032C100.207 292.667 99.6255 291.693 99.1599 291.206C98.578 290.598 96.5995 291.571 96.7159 292.18C96.7159 292.302 97.065 293.519 97.2978 294.492C97.4142 295.709 97.5306 296.561 97.8797 297.656Z"
          fill="#FBBD9E"
        />
        <path
          d="M156.423 34.3013C160.263 31.989 163.289 33.8145 163.289 38.439L163.406 65.6994C163.406 70.2022 160.38 75.8004 156.539 78.1126L155.957 78.4777V92.3513L148.625 82.9805L99.6276 112.553C95.7869 114.865 92.7609 113.04 92.7609 108.415L92.6445 81.1551C92.6445 76.6522 95.6705 71.0541 99.5112 68.7419L156.423 34.3013Z"
          fill="#99E2FF"
        />
        <path
          d="M86.7104 175.837C82.8697 178.149 79.8438 183.747 79.8438 188.25L79.9601 215.51C79.9601 220.013 83.1025 221.96 86.8268 219.648L148.743 182.287L156.075 191.658V177.784L156.657 177.419C160.498 175.107 163.524 169.63 163.524 165.006L163.407 137.745C163.407 133.242 160.265 131.295 156.541 133.608L86.7104 175.837Z"
          fill="#99E2FF"
        />
        <path
          d="M128.258 100.748C132.098 98.4353 135.124 100.261 135.124 104.885L135.241 132.146C135.241 136.649 132.215 142.247 128.374 144.559L57.1471 187.518L49.8149 205.773V192.021L49.233 192.386C45.3924 194.699 42.3664 192.873 42.3664 188.249L42.25 160.988C42.25 156.364 45.276 150.887 49.1166 148.575L128.258 100.748Z"
          fill="white"
        />
        <path
          d="M95.3167 193.36C95.0839 193.969 94.7347 194.699 94.1528 195.307C93.6873 195.916 92.989 196.524 92.1743 196.889L90.5449 197.863V202.122L88.5664 203.218V192.143L92.1743 190.074C92.8726 189.588 93.5709 189.466 94.0364 189.466C94.502 189.466 94.9675 189.588 95.2003 189.953C95.433 190.318 95.5494 190.805 95.5494 191.413C95.6658 192.143 95.5494 192.752 95.3167 193.36ZM93.3381 194.09C93.5709 193.604 93.6873 193.238 93.6873 192.752C93.6873 191.656 93.1054 191.413 92.0579 192.021L90.5449 192.873V196.038L92.0579 195.186C92.6398 194.942 93.1054 194.577 93.3381 194.09Z"
          fill="#2035A4"
        />
        <path
          d="M98.9269 186.301V192.995C98.9269 193.725 99.0433 194.212 99.3925 194.455C99.7416 194.699 100.207 194.577 100.789 194.212C101.371 193.847 101.837 193.36 102.186 192.751C102.535 192.143 102.651 191.535 102.651 190.804V184.111L104.513 183.016V189.709C104.513 190.683 104.397 191.535 104.048 192.386C103.699 193.238 103.233 193.968 102.651 194.699C102.069 195.307 101.371 195.916 100.673 196.281C99.9744 196.646 99.2761 196.889 98.6942 196.889C98.1123 196.889 97.6467 196.646 97.2976 196.281C96.9484 195.794 96.832 195.185 96.832 194.212V187.518L98.9269 186.301Z"
          fill="#2035A4"
        />
        <path
          d="M111.258 189.954L109.163 186.911L108.232 187.398V191.536L106.37 192.631L106.254 181.8L109.745 179.853C110.444 179.488 111.026 179.244 111.608 179.244C112.073 179.244 112.539 179.366 112.771 179.731C113.004 180.096 113.121 180.583 113.121 181.191C113.121 181.921 113.004 182.652 112.655 183.382C112.306 184.112 111.84 184.842 111.142 185.451L113.353 188.493L111.258 189.954ZM108.349 185.816L109.862 184.964C110.327 184.721 110.793 184.355 111.026 183.869C111.258 183.504 111.375 183.017 111.375 182.53C111.375 182.043 111.258 181.678 111.026 181.556C110.793 181.435 110.444 181.556 109.862 181.8L108.349 182.652V185.816Z"
          fill="#2035A4"
        />
        <path
          d="M115.1 179.486C115.449 178.391 116.031 177.417 116.729 176.565C117.428 175.714 118.242 174.983 119.057 174.497C120.104 173.888 120.919 173.766 121.734 173.888C122.432 174.01 123.014 174.618 123.363 175.47L121.268 176.687C121.035 176.322 120.803 176.079 120.337 176.079C119.988 176.079 119.522 176.2 119.057 176.444C118.475 176.687 118.126 177.174 117.66 177.661C117.311 178.148 116.962 178.756 116.729 179.486C116.496 180.095 116.38 180.825 116.38 181.555C116.38 182.285 116.496 182.772 116.729 183.259C116.962 183.624 117.311 183.867 117.66 183.989C118.126 183.989 118.591 183.867 119.057 183.624C119.522 183.381 119.988 183.015 120.337 182.529C120.686 182.042 121.035 181.555 121.152 180.825L123.247 179.608C123.014 180.825 122.432 182.042 121.734 183.015C121.035 184.111 120.104 184.841 119.057 185.449C118.242 185.936 117.428 186.18 116.729 186.18C116.031 186.18 115.449 185.815 115.1 185.206C114.634 184.598 114.518 183.746 114.518 182.772C114.402 181.677 114.634 180.582 115.1 179.486Z"
          fill="#2035A4"
        />
        <path
          d="M131.978 167.316L132.094 177.661L130.348 178.634V174.253L126.624 176.444V180.947L124.878 182.042L124.762 171.576L126.507 170.602V174.862L130.232 172.671V168.412L131.978 167.316Z"
          fill="#2035A4"
        />
        <path
          d="M139.077 171.576L135.702 173.524L135.12 175.836L133.258 176.931L136.284 164.761L138.262 163.666L141.405 172.185L139.659 173.28L139.077 171.576ZM138.495 170.238L137.215 166.708L136.051 171.698L138.495 170.238Z"
          fill="#2035A4"
        />
        <path
          d="M143.852 170.482C143.386 170.482 143.037 170.36 142.688 170.117C142.455 169.873 142.223 169.387 142.223 168.778L144.085 167.683C144.085 168.048 144.201 168.291 144.434 168.413C144.667 168.535 145.016 168.413 145.365 168.291C145.714 168.048 146.063 167.805 146.296 167.439C146.529 167.074 146.645 166.709 146.645 166.344C146.645 166.101 146.529 165.857 146.412 165.736C146.296 165.614 146.063 165.614 145.831 165.614C145.598 165.614 145.249 165.736 144.899 165.736C144.318 165.857 143.852 165.979 143.619 165.979C143.27 165.979 142.921 165.857 142.688 165.614C142.455 165.371 142.339 164.884 142.339 164.275C142.339 163.667 142.455 163.058 142.688 162.45C142.921 161.841 143.27 161.355 143.736 160.868C144.201 160.381 144.667 160.016 145.249 159.651C146.063 159.164 146.762 159.042 147.344 159.164C147.925 159.407 148.158 159.894 148.275 160.746L146.412 161.841C146.412 161.476 146.296 161.233 146.063 161.233C145.831 161.111 145.481 161.233 145.132 161.355C144.783 161.598 144.55 161.841 144.318 162.085C144.085 162.45 144.085 162.815 144.085 163.18C144.085 163.423 144.201 163.667 144.318 163.789C144.434 163.91 144.667 163.91 144.899 163.91C145.132 163.91 145.481 163.789 145.831 163.789C146.412 163.667 146.762 163.667 147.111 163.545C147.46 163.545 147.809 163.667 148.042 163.91C148.275 164.154 148.391 164.64 148.391 165.249C148.391 165.736 148.275 166.344 148.042 166.953C147.809 167.561 147.46 168.17 146.994 168.656C146.529 169.143 146.063 169.63 145.365 169.995C144.899 170.239 144.318 170.482 143.852 170.482Z"
          fill="#2035A4"
        />
        <path
          d="M151.297 157.825V160.38L154.09 158.798V160.38L151.297 161.962V164.64L154.439 162.814V164.396L149.667 167.195L149.551 157.094L154.323 154.417V155.999L151.297 157.825Z"
          fill="#2035A4"
        />
        <path
          d="M63.4282 169.872C62.4972 169.872 61.6825 169.386 61.1006 168.655C60.5186 167.925 60.1695 166.83 60.0531 165.491C59.9367 164.153 60.1695 162.814 60.635 161.354C61.1005 159.893 61.7988 158.676 62.6135 157.459C63.5446 156.242 64.4757 155.39 65.6395 154.66C66.8033 153.93 67.8508 153.687 68.7819 153.687C69.7129 153.687 70.5276 154.173 71.1095 154.904C71.6915 155.634 72.0406 156.729 72.157 158.068C72.2734 159.406 72.0406 160.867 71.5751 162.205C71.1096 163.544 70.4112 164.883 69.5966 166.1C68.7819 167.317 67.7344 168.169 66.687 168.899C65.4067 169.629 64.3593 169.994 63.4282 169.872ZM68.0836 164.883C68.5491 164.153 69.0146 163.422 69.2474 162.449C69.4802 161.597 69.5966 160.623 69.5966 159.771C69.5966 158.798 69.3638 158.068 69.0146 157.581C68.6655 157.094 68.2 156.729 67.618 156.729C67.0361 156.729 66.4542 156.851 65.7559 157.337C65.0576 157.824 64.4757 158.311 63.8938 159.041C63.4282 159.771 62.9627 160.502 62.7299 161.475C62.4971 162.327 62.3808 163.301 62.4972 164.153C62.6135 165.126 62.7299 165.856 63.0791 166.343C63.4282 166.83 63.8938 167.073 64.4757 167.195C65.0576 167.195 65.6395 167.073 66.3378 166.587C67.0361 166.1 67.618 165.491 68.0836 164.883Z"
          fill="#2035A4"
        />
        <path
          d="M80.0698 160.502L77.2766 156.729L76.1127 157.459L76.3455 162.814L74.0178 164.275L73.2031 150.279L77.6257 147.602C78.5568 146.993 79.3715 146.75 79.9534 146.75C80.6517 146.75 81.1172 146.993 81.4664 147.48C81.8155 147.967 82.0483 148.575 82.0483 149.427C82.0483 150.401 81.9319 151.375 81.4664 152.348C81.0008 153.322 80.4189 154.295 79.4878 155.147L82.5138 159.042L80.0698 160.502ZM76.1127 155.147L78.0912 153.93C78.6732 153.565 79.2551 153.078 79.4878 152.47C79.837 151.861 79.9534 151.253 79.837 150.644C79.837 150.036 79.6042 149.549 79.2551 149.427C78.9059 149.306 78.4404 149.427 77.7421 149.792L75.7636 151.009L76.1127 155.147Z"
          fill="#2035A4"
        />
        <path
          d="M91.7095 139.812C92.6405 139.812 93.4552 140.178 93.9208 141.029C94.5027 141.76 94.7354 142.855 94.7354 144.315C94.7354 145.776 94.5027 147.114 94.0371 148.453C93.5716 149.792 92.8733 151.13 91.9422 152.226C91.0112 153.321 89.9637 154.295 88.7999 155.025L84.7264 157.58L84.1445 143.463L88.3343 140.908C89.6146 140.178 90.7784 139.812 91.7095 139.812ZM91.4767 149.792C92.175 148.575 92.4078 147.236 92.4078 145.776C92.4078 144.315 91.9422 143.342 91.2439 142.855C90.5456 142.368 89.6146 142.612 88.3343 143.342L86.705 144.315L87.0541 153.686L88.6835 152.713C89.9637 151.982 90.8948 151.009 91.4767 149.792Z"
          fill="#2035A4"
        />
        <path
          d="M98.8112 136.892L98.9276 140.543L102.885 138.109V140.421L98.9276 142.855L99.044 146.628L103.467 143.95V146.263L96.7163 150.4L96.3672 136.162L103.234 131.902V134.336L98.8112 136.892Z"
          fill="#2035A4"
        />
        <path
          d="M111.614 141.151L109.053 137.135L107.889 137.865V143.463L105.562 144.924L105.445 130.563L109.868 127.886C110.799 127.278 111.614 127.034 112.196 127.034C112.894 127.034 113.359 127.278 113.592 127.764C113.941 128.251 114.058 128.86 114.058 129.712C114.058 130.685 113.825 131.659 113.359 132.754C112.894 133.849 112.196 134.701 111.381 135.553L114.174 139.691L111.614 141.151ZM107.889 135.675L109.868 134.458C110.566 134.093 111.032 133.606 111.264 132.997C111.614 132.389 111.73 131.78 111.73 131.172C111.73 130.563 111.614 130.077 111.264 129.955C110.915 129.833 110.45 129.833 109.868 130.32L107.889 131.537V135.675Z"
          fill="#2035A4"
        />
        <path
          d="M118.126 136.771C117.428 136.771 116.962 136.649 116.613 136.284C116.264 135.919 116.031 135.189 116.031 134.337L118.592 132.755C118.592 133.363 118.824 133.728 119.057 133.85C119.406 133.972 119.756 133.972 120.337 133.607C120.919 133.242 121.269 132.877 121.618 132.39C121.967 131.903 122.083 131.416 122.083 130.808C122.083 130.321 121.967 130.078 121.734 129.956C121.501 129.834 121.269 129.712 120.919 129.834C120.57 129.834 120.221 129.956 119.639 130.077C118.824 130.321 118.243 130.321 117.777 130.443C117.311 130.443 116.846 130.321 116.497 129.956C116.148 129.591 116.031 128.982 116.031 128.009C116.031 127.157 116.264 126.305 116.613 125.453C116.962 124.601 117.428 123.749 118.126 123.019C118.708 122.289 119.523 121.68 120.337 121.194C121.618 120.463 122.549 120.22 123.363 120.463C124.062 120.707 124.527 121.559 124.644 122.776L122.083 124.358C122.083 123.871 121.85 123.506 121.618 123.384C121.269 123.262 120.919 123.384 120.337 123.628C119.872 123.871 119.523 124.236 119.174 124.723C118.941 125.21 118.708 125.696 118.708 126.305C118.708 126.67 118.824 126.913 119.057 127.035C119.29 127.157 119.523 127.157 119.872 127.157C120.221 127.157 120.57 127.035 121.152 126.913C121.967 126.67 122.549 126.67 123.014 126.548C123.48 126.548 123.945 126.67 124.295 127.035C124.644 127.4 124.76 128.009 124.76 128.861C124.76 129.591 124.527 130.443 124.295 131.294C123.945 132.146 123.48 132.998 122.898 133.728C122.316 134.459 121.501 135.189 120.687 135.676C119.523 136.406 118.824 136.649 118.126 136.771Z"
          fill="#2035A4"
        />
        <path
          d="M114.637 87.8499C113.939 87.8499 113.357 87.7282 113.008 87.3631C112.659 86.998 112.426 86.3895 112.426 85.5376L115.103 84.0772C115.103 84.6857 115.335 84.9291 115.685 85.1725C116.034 85.2942 116.499 85.2942 117.081 84.9291C117.663 84.564 118.129 84.1989 118.478 83.7121C118.827 83.2253 118.943 82.7385 118.943 82.2518C118.943 81.8867 118.827 81.5215 118.594 81.3999C118.361 81.2782 118.129 81.1565 117.779 81.2782C117.43 81.2782 116.965 81.3999 116.383 81.5216C115.568 81.6433 114.87 81.7649 114.404 81.7649C113.939 81.7649 113.473 81.6433 113.124 81.2782C112.775 80.9131 112.542 80.3046 112.542 79.4527C112.542 78.6008 112.775 77.7489 113.124 77.0187C113.473 76.1668 114.055 75.4366 114.637 74.7065C115.335 73.9763 116.034 73.4895 116.848 73.0027C118.129 72.2725 119.176 72.1508 119.991 72.3942C120.805 72.6376 121.271 73.3678 121.271 74.5848L118.594 76.0451C118.594 75.5583 118.361 75.315 118.012 75.1933C117.663 75.0716 117.198 75.1933 116.732 75.4366C116.266 75.68 115.917 76.0451 115.568 76.5319C115.335 77.0187 115.103 77.5055 115.103 77.9923C115.103 78.3574 115.219 78.6008 115.452 78.7225C115.685 78.8442 115.917 78.8442 116.266 78.8442C116.616 78.8442 117.081 78.7225 117.663 78.6008C118.478 78.4791 119.06 78.3574 119.642 78.3574C120.107 78.3574 120.573 78.4791 120.922 78.8442C121.271 79.2093 121.504 79.8178 121.504 80.6697C121.504 81.3999 121.387 82.2517 121.038 82.9819C120.689 83.8338 120.223 84.564 119.525 85.2942C118.827 86.0244 118.129 86.6329 117.198 87.1197C116.15 87.6065 115.335 87.8499 114.637 87.8499Z"
          fill="#2035A4"
        />
        <path
          d="M125.807 70.3244V73.7319L129.881 71.5413V73.7319L125.807 76.0442V79.6951L130.346 77.1395V79.33L123.363 83.2244V69.3508L130.346 65.5781V67.7687L125.807 70.3244Z"
          fill="#2035A4"
        />
        <path
          d="M135.007 74.5848L138.964 72.3942V74.5848L132.679 78.114L132.562 64.3621L135.007 63.0234V74.5848Z"
          fill="#2035A4"
        />
        <path
          d="M142.803 70.3244L146.644 68.1338V70.3244L140.476 73.8536L140.359 60.2234L142.687 58.8848L142.803 70.3244Z"
          fill="#2035A4"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1926_44029"
            x1="162.195"
            y1="394.443"
            x2="181.813"
            y2="394.443"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1926_44029"
            x1="432.85"
            y1="272.389"
            x2="459.103"
            y2="272.389"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1926_44029"
            x1="60.3137"
            y1="222.818"
            x2="86.5673"
            y2="222.818"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1926_44029"
            x1="425.758"
            y1="213.526"
            x2="443.625"
            y2="213.526"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1926_44029"
            x1="432.28"
            y1="229.721"
            x2="442.423"
            y2="229.721"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_1926_44029"
            x1="457.11"
            y1="334.167"
            x2="466.628"
            y2="334.167"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_1926_44029"
            x1="137.077"
            y1="161.417"
            x2="140.859"
            y2="152.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ADA4B8" />
            <stop offset="1" stopColor="#FFF7F5" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_1926_44029"
            x1="152.593"
            y1="88.1897"
            x2="234.321"
            y2="223.566"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFF7F5" />
            <stop offset="1" stopColor="#F1E9EC" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_1926_44029"
            x1="237.645"
            y1="310.9"
            x2="246.006"
            y2="310.9"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ADA4B8" />
            <stop offset="1" stopColor="#DFD7E2" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_1926_44029"
            x1="299.008"
            y1="184.936"
            x2="292.244"
            y2="192.609"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ADA4B8" />
            <stop offset="1" stopColor="#DFD7E2" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_1926_44029"
            x1="197.514"
            y1="159.07"
            x2="225.217"
            y2="185.563"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D7CEDB" />
            <stop offset="1" stopColor="#EEE6F2" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_1926_44029"
            x1="48.7261"
            y1="299.683"
            x2="119.62"
            y2="299.683"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_1926_44029"
            x1="271.875"
            y1="345.558"
            x2="300.418"
            y2="345.558"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_1926_44029"
            x1="268.482"
            y1="378.433"
            x2="282.71"
            y2="378.433"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3397BB" />
            <stop offset="1" stopColor="#5EAED7" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_1926_44029"
            x1="110.654"
            y1="303.365"
            x2="94.6672"
            y2="304.401"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B6B2AE" />
            <stop offset="1" stopColor="#BCB8B4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_1926_44029"
            x1="115.688"
            y1="298.611"
            x2="94.5317"
            y2="299.982"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B6B2AE" />
            <stop offset="1" stopColor="#BCB8B4" />
          </linearGradient>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const LogInImg = () => {
  return (
    <React.Fragment>
      <svg
        width="200"
        height="150"
        viewBox="0 0 200 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1926_44801)">
          <path
            d="M167.633 137.232H180.966V137.332H167.633V137.232Z"
            fill="#EEEEEE"
          />
          <path
            d="M129.691 138.315H133.191V138.415H129.691V138.315Z"
            fill="#EEEEEE"
          />
          <path
            d="M159.504 133.522H167.229V133.622H159.504V133.522Z"
            fill="#EEEEEE"
          />
          <path
            d="M20.9805 134.293H38.3674V134.193H20.9805V134.293Z"
            fill="#EEEEEE"
          />
          <path
            d="M41.9531 134.293H44.5025V134.193H41.9531V134.293Z"
            fill="#EEEEEE"
          />
          <path
            d="M52.7852 135.979H90.493V135.879H52.7852V135.979Z"
            fill="#EEEEEE"
          />
          <path
            d="M18.1024 0.0978622C16.8909 0.0978622 15.9053 1.07576 15.9053 2.27815V110.706C15.9053 111.909 16.8909 112.886 18.1024 112.886H95.8316C97.0428 112.886 98.0283 111.909 98.0283 110.706V2.27815C98.0283 1.07576 97.0428 0.0978622 95.8316 0.0978622H18.1024ZM95.8316 112.986H18.1024C16.8354 112.986 15.8047 111.964 15.8047 110.706V2.27815C15.8047 1.02103 16.8354 -0.0019989 18.1024 -0.0019989H95.8316C97.098 -0.0019989 98.1289 1.02103 98.1289 2.27815V110.706C98.1289 111.964 97.098 112.986 95.8316 112.986Z"
            fill="#EEEEEE"
          />
          <path
            d="M105.168 0.0978622C103.957 0.0978622 102.972 1.07576 102.972 2.27815V110.706C102.972 111.909 103.957 112.886 105.168 112.886H182.898C184.109 112.886 185.095 111.909 185.095 110.706V2.27815C185.095 1.07576 184.109 0.0978622 182.898 0.0978622H105.168ZM182.898 112.986H105.168C103.902 112.986 102.871 111.964 102.871 110.706V2.27815C102.871 1.02103 103.902 -0.0019989 105.168 -0.0019989H182.898C184.164 -0.0019989 185.195 1.02103 185.195 2.27815V110.706C185.195 111.964 184.164 112.986 182.898 112.986Z"
            fill="#EEEEEE"
          />
          <path
            d="M-0.136719 130.902H201.131V130.802H-0.136719V130.902Z"
            fill="#EEEEEE"
          />
          <path
            d="M140.781 128.482H179.093V77.8918H140.781V128.482Z"
            fill="#F8F8F9"
          />
          <path
            d="M133.469 128.482H140.777V77.8918H133.469V128.482Z"
            fill="#E9E9E8"
          />
          <path
            d="M143.266 93.9316H176.408V81.646H143.266V93.9316Z"
            fill="#FCFDFD"
          />
          <path
            d="M164.159 81.6461L164.014 83.284C163.966 83.824 163.51 84.2383 162.964 84.2383H156.71C156.164 84.2383 155.708 83.824 155.661 83.284L155.516 81.6461H164.159Z"
            fill="#EEEEEE"
          />
          <path
            d="M143.266 107.56H176.408V95.2735H143.266V107.56Z"
            fill="#FCFDFD"
          />
          <path
            d="M164.159 95.2742L164.014 96.9121C163.966 97.4525 163.51 97.8672 162.964 97.8672H156.71C156.164 97.8672 155.708 97.4525 155.661 96.9121L155.516 95.2742H164.159Z"
            fill="#EEEEEE"
          />
          <path
            d="M143.266 121.188H176.408V108.902H143.266V121.188Z"
            fill="#FCFDFD"
          />
          <path
            d="M164.159 108.902L164.014 110.539C163.966 111.08 163.51 111.494 162.964 111.494H156.71C156.164 111.494 155.708 111.08 155.661 110.539L155.516 108.902H164.159Z"
            fill="#EEEEEE"
          />
          <path
            d="M143.266 131.008H176.005L176.408 128.478H143.266V131.008Z"
            fill="#E9E9E8"
          />
          <path
            d="M136.422 131.008H143.265V128.478H136.02L136.422 131.008Z"
            fill="#E3E3E2"
          />
          <path
            d="M158.655 77.9453H171.737L170.286 61.4812H157.203L158.655 77.9453Z"
            fill="#FCFDFD"
          />
          <path
            d="M158.654 77.9463H158.03L156.578 61.4822H157.202L158.654 77.9463Z"
            fill="#EEEEEE"
          />
          <path
            d="M159.843 76.2676H170.258L169.102 63.1606H158.688L159.843 76.2676Z"
            fill="#F4F4F4"
          />
          <path
            d="M160.602 75.1885H169.302L168.337 64.2395H159.637L160.602 75.1885Z"
            fill="#E9E9E8"
          />
          <path
            d="M154.984 77.9453L155.883 67.7545H142.859L141.961 77.9453H154.984Z"
            fill="#F4F4F4"
          />
          <path
            d="M154.98 77.9453L155.879 67.7545H156.58L155.682 77.9453H154.98Z"
            fill="#E3E3E2"
          />
          <path
            d="M153.743 76.9072L154.458 68.794H144.09L143.375 76.9072H153.743Z"
            fill="#EEEEEE"
          />
          <path
            d="M152.95 76.2402L153.547 69.4629H144.886L144.289 76.2402H152.95Z"
            fill="#F8F8F9"
          />
          <path
            d="M124.908 124.158C124.908 126.859 124.481 128.605 123.762 129.726C123.221 130.569 122.249 131.043 121.242 131.043H117.302C116.295 131.043 115.324 130.569 114.783 129.726C114.064 128.605 113.637 126.859 113.637 124.158C113.637 120.241 115.358 117.106 115.919 114.601C116.122 113.7 115.448 110.936 115.448 110.936H123.096C123.096 110.936 122.422 113.7 122.625 114.601C123.187 117.106 124.908 120.241 124.908 124.158Z"
            fill="#EEEEEE"
          />
          <path
            d="M137.934 108.307C137.934 104.907 132.562 106.318 131.208 101.042C130.695 99.0429 135.065 94.5181 135.065 94.5181H121.44C121.44 94.5181 125.81 99.0429 125.297 101.042C123.943 106.318 118.57 104.907 118.57 108.307C118.57 112.052 126.149 119.853 126.514 128.633C126.547 129.418 125.089 131.044 125.089 131.044H131.416C131.416 131.044 129.958 129.418 129.991 128.633C130.356 119.853 137.934 112.052 137.934 108.307Z"
            fill="#F8F8F9"
          />
          <path
            d="M133.815 117.143C134.607 115.491 132.969 109.871 132.969 109.871H138.873C138.873 109.871 137.236 115.491 138.028 117.143C138.587 118.31 139.859 119.055 139.859 120.436V128.734C139.859 130.883 138.087 131.043 135.922 131.043C133.756 131.043 131.984 130.883 131.984 128.734V120.436C131.984 119.055 133.256 118.311 133.815 117.143Z"
            fill="#F4F4F4"
          />
          <path
            d="M69.0408 61.9493C67.4512 61.2663 65.7714 61.5962 65.2968 62.6852C64.8214 63.7737 65.7283 65.215 67.3179 65.8981C68.9071 66.5808 70.5873 66.2512 71.0623 65.1623C71.5373 64.0737 70.6304 62.632 69.0408 61.9493ZM66.3406 68.1371C62.9488 66.6795 61.0134 63.6035 62.0274 61.2802C63.041 58.9565 66.6256 58.2527 70.0177 59.7099C73.4099 61.1676 75.3453 64.2439 74.3313 66.5676C73.3177 68.8905 69.7331 69.5948 66.3406 68.1371Z"
            fill="#E9E9E8"
          />
          <path
            d="M70.3305 62.0781L68.7188 61.3855L78.4585 39.0412C78.6513 38.5998 79.1682 38.3965 79.6134 38.5874C80.0586 38.7788 80.2631 39.2917 80.0707 39.7335L70.3305 62.0781Z"
            fill="#E9E9E8"
          />
          <path
            d="M80.8197 41.8926L77.7266 40.552L78.4242 38.9525L81.5172 40.2931L80.8197 41.8926Z"
            fill="#E9E9E8"
          />
          <path
            d="M79.2929 43.6816L77.0781 42.7269L77.7761 41.1274L79.9905 42.0822L79.2929 43.6816Z"
            fill="#E9E9E8"
          />
          <path
            d="M78.6668 46.8516L76.1836 45.7842L76.8816 44.1847L79.3648 45.2521L78.6668 46.8516Z"
            fill="#E9E9E8"
          />
          <path
            d="M70.9612 59.6922L70.0756 59.3115C69.6344 59.1222 69.4316 58.6133 69.6228 58.1755L69.6288 58.1619C69.8196 57.7241 70.3324 57.5227 70.7736 57.7125L71.6588 58.0928C72.1004 58.2825 72.3032 58.791 72.112 59.2289L72.106 59.2428C71.9148 59.6807 71.4024 59.882 70.9612 59.6922Z"
            fill="#E9E9E8"
          />
          <path
            d="M135.247 59.2934C136.507 60.1259 138.231 59.7608 139.091 58.4797C139.951 57.1986 139.626 55.4793 138.367 54.6464C137.108 53.8139 135.383 54.1783 134.523 55.4593C133.663 56.7404 133.988 58.4605 135.247 59.2934ZM140.136 52.0115C142.824 53.7884 143.517 57.4583 141.681 60.1926C139.846 62.9266 136.165 63.7052 133.478 61.9283C130.79 60.1515 130.097 56.4812 131.933 53.7468C133.768 51.0129 137.448 50.2343 140.136 52.0115Z"
            fill="#E9E9E8"
          />
          <path
            d="M134.597 58.5839L136.263 59.6857L124.342 77.7895C124.036 78.2461 123.414 78.37 122.954 78.0656C122.494 77.7612 122.369 77.1452 122.676 76.6886L134.597 58.5839Z"
            fill="#E9E9E8"
          />
          <path
            d="M122.753 72.7421L126.259 75.079L124.509 77.6855L120.996 75.3447C120.492 75.0083 120.356 74.3308 120.693 73.8291L121.22 73.0437C121.559 72.5392 122.246 72.4042 122.753 72.7421Z"
            fill="#E9E9E8"
          />
          <path
            d="M91.4564 17.4167L89.6056 22.1735C89.4389 22.6018 88.9535 22.8155 88.5215 22.6501C88.0896 22.4847 87.8747 22.0026 88.0413 21.5739L89.8918 16.8171C90.4895 15.2815 89.7167 13.5478 88.1685 12.955L86.4537 12.2979C84.906 11.7051 83.1602 12.4729 82.5624 14.0092L81.8068 15.9518L80.2422 15.3522L80.9982 13.41C81.9288 11.0172 84.6479 9.82198 87.0579 10.7456L88.7727 11.4023C91.1827 12.3259 92.3871 15.0239 91.4564 17.4167Z"
            fill="#F4F4F4"
          />
          <path
            d="M84.0752 25.3263L81.1134 24.1918L82.6796 21.479C82.4824 21.0855 82.4458 20.6134 82.6185 20.17C82.9449 19.3303 83.8961 18.91 84.7422 19.2344C85.5888 19.5588 86.0106 20.5047 85.6842 21.3448C85.5119 21.7878 85.1649 22.1134 84.7503 22.2723L84.0752 25.3263ZM91.1667 18.1646C91.0431 18.0068 90.8761 17.8782 90.6748 17.8011L81.336 14.2231C81.1279 14.1436 80.9089 14.1272 80.7056 14.1675C80.3325 14.2402 80.002 14.4963 79.8546 14.8742L76.2491 24.1423C76.0213 24.7287 76.3143 25.3854 76.9053 25.6119L86.2445 29.1899C86.8354 29.416 87.4972 29.1252 87.7254 28.5388L91.3309 19.2708C91.4807 18.8861 91.4062 18.4694 91.1667 18.1646Z"
            fill="#E9E9E8"
          />
          <path
            d="M27.7031 125.632H102.224V85.8325H27.7031V125.632Z"
            fill="#E9E9E8"
          />
          <path
            d="M96.25 130.795H100.934V127.283H96.25V130.795Z"
            fill="#E9E9E8"
          />
          <path
            d="M22.0117 130.797H26.6953V82.8723H22.0117V130.797Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.1384 123.772V106.334H63.7864V123.772H29.1384ZM100.932 123.772H66.2842V87.2091H100.932V123.772ZM29.1384 87.2091H63.7864V103.855H29.1384V87.2091ZM26.6406 82.8713V130.796H29.1384V128.11H100.932V130.796H103.43V82.8713H102.181H100.932H29.1384H27.8896H26.6406Z"
            fill="#F4F4F4"
          />
          <path
            d="M66.2812 123.771H98.5873V88.9986H66.2812V123.771Z"
            fill="#F8F8F9"
          />
          <path
            d="M67.7461 105.344C67.7461 106.167 68.4183 106.834 69.2471 106.834C70.076 106.834 70.7482 106.167 70.7482 105.344C70.7482 104.522 70.076 103.855 69.2471 103.855C68.4183 103.855 67.7461 104.522 67.7461 105.344Z"
            fill="#FCFDFD"
          />
          <path
            d="M69.2471 106.833C69.8526 106.833 70.371 106.475 70.6081 105.963C70.6959 106.152 70.7482 106.361 70.7482 106.583C70.7482 107.405 70.076 108.072 69.2471 108.072C68.4183 108.072 67.7461 107.405 67.7461 106.583C67.7461 106.361 67.7984 106.152 67.8862 105.963C68.1233 106.475 68.6417 106.833 69.2471 106.833Z"
            fill="#E3E3E2"
          />
          <path
            d="M86.062 123.771H78.3547L74.6719 88.9986H82.3792L86.062 123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M76.377 123.771H74.843L71.1602 88.9986H72.6942L76.377 123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M55.9805 103.839H59.0338V88.9651H55.9805V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M43.3203 103.839H46.3731V88.9651H43.3203V103.839Z"
            fill="#F8F8F9"
          />
          <path
            d="M52.9219 103.838H55.9747V90.0099H52.9219V103.838Z"
            fill="#F8F8F9"
          />
          <path
            d="M46.375 103.839H49.4278V90.0109H46.375V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M49.4258 103.839H51.3992V88.9651H49.4258V103.839Z"
            fill="#EEEEEE"
          />
          <path
            d="M51.3984 103.839H52.9248V90.0109H51.3984V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M40.2656 103.839H43.3185V88.9651H40.2656V103.839Z"
            fill="#EEEEEE"
          />
          <path
            d="M37.2148 103.839H40.268V90.0109H37.2148V103.839Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.6602 103.839H33.7131V90.0109H30.6602V103.839Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.7148 103.839H35.6876V88.9651H33.7148V103.839Z"
            fill="#FCFDFD"
          />
          <path
            d="M35.6875 103.839H37.2141V90.0109H35.6875V103.839Z"
            fill="#EEEEEE"
          />
          <path
            d="M29.1328 103.838H30.6595V89.3167H29.1328V103.838Z"
            fill="#EEEEEE"
          />
          <path
            d="M32.1858 123.771H29.1328V108.898H32.1858V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M41.793 123.771H44.8458V108.898H41.793V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M32.1875 123.771H35.2405V109.943H32.1875V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M38.7383 123.771H41.7914V109.943H38.7383V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M36.7656 123.772H38.7387V108.899H36.7656V123.772Z"
            fill="#FCFDFD"
          />
          <path
            d="M35.2422 123.771H36.7687V109.943H35.2422V123.771Z"
            fill="#F8F8F9"
          />
          <path
            d="M44.8477 123.772H47.9005V108.899H44.8477V123.772Z"
            fill="#EEEEEE"
          />
          <path
            d="M47.8984 123.771H50.9517V109.943H47.8984V123.771Z"
            fill="#F8F8F9"
          />
          <path
            d="M54.4492 123.771H57.5024V109.943H54.4492V123.771Z"
            fill="#E9E9E8"
          />
          <path
            d="M52.4766 123.771H54.4495V108.898H52.4766V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M59.0312 123.771H61.004V108.898H59.0312V123.771Z"
            fill="#FCFDFD"
          />
          <path
            d="M50.9531 123.771H52.4795V109.943H50.9531V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M57.5039 123.771H59.0304V109.251H57.5039V123.771Z"
            fill="#EEEEEE"
          />
          <path
            d="M32.5433 57.2552C32.5433 57.2552 32.0308 57.4889 31.7965 57.9623C31.5622 58.4352 32.2891 59.3085 32.2891 59.3085C32.2891 59.3085 32.8989 59.7299 33.5051 59.4567C34.1111 59.1834 34.1111 59.1834 34.1111 59.1834C34.1111 59.1834 33.0747 57.3982 32.5716 57.3806L32.5433 57.2552Z"
            fill="#E9E9E8"
          />
          <path
            d="M35.1393 57.2413C35.2132 58.0882 34.6846 59.1559 33.9229 59.2214C33.1613 59.2869 32.4551 58.3254 32.381 57.479C32.3071 56.6321 32.9221 56.5498 33.6838 56.4843C34.4453 56.4188 35.0655 56.3948 35.1393 57.2413Z"
            fill="#E9E9E8"
          />
          <path
            d="M32.9031 56.9921C32.9031 56.9921 33.485 57.4523 34.6843 57.1838C34.6843 57.1838 32.7928 58.4358 32.9031 56.9921Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.418 56.8237C33.418 56.8237 34.0894 56.7076 34.0993 56.9863C34.0993 56.9863 34.6686 56.9547 34.5899 56.7176C34.5113 56.4805 33.418 56.8237 33.418 56.8237Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.3948 57.6875C33.114 57.6875 32.8988 57.5453 32.8984 57.1095C32.8984 57.0723 32.8999 57.0332 32.9032 56.992C32.9032 56.992 33.2519 57.2677 33.9656 57.2677C34.174 57.2677 34.4135 57.2445 34.6844 57.1838C34.6844 57.1838 33.9233 57.6875 33.3948 57.6875Z"
            fill="#EDEDEC"
          />
          <path
            d="M34.0993 56.9863C34.0939 56.8341 33.8917 56.7997 33.709 56.7997C33.5568 56.7997 33.418 56.8237 33.418 56.8237C33.418 56.8237 34.0221 56.6339 34.3644 56.6339C34.4826 56.6339 34.5697 56.6567 34.5899 56.7176C34.5949 56.7328 34.5973 56.7472 34.5973 56.7608C34.5976 56.9587 34.0993 56.9863 34.0993 56.9863Z"
            fill="#EDEDEC"
          />
          <path
            d="M32.6406 59.4904C32.883 59.8803 33.3773 60.0804 33.8355 60.0265C34.2937 59.9718 34.7064 59.6877 34.9709 59.3122C35.2354 58.9367 35.3615 58.4782 35.3904 58.0208C35.3982 57.9025 35.4074 57.6061 35.2503 57.5606C35.1062 57.5186 35.0173 57.7188 34.9505 57.8122C34.7585 58.0803 34.555 58.3315 34.3103 58.5556C34.0732 58.7726 33.811 58.9623 33.5304 59.1201C33.4517 59.1644 32.6833 59.5591 32.6406 59.4904Z"
            fill="#E9E9E8"
          />
          <path
            d="M35.9067 57.7988C36.051 58.1419 35.9982 58.5594 35.7735 58.8566C35.6258 59.0523 35.4162 59.1913 35.2055 59.3176C35.059 59.4051 34.8701 59.4885 34.7264 59.3963C34.5714 59.2968 34.5852 59.0707 34.6207 58.8909C34.6756 58.6141 34.7379 58.3385 34.808 58.0648C34.8653 57.8403 34.9 57.4648 35.0326 57.2743C35.1573 57.0953 35.3338 57.2012 35.5222 57.3314C35.6907 57.4477 35.8277 57.6102 35.9067 57.7988Z"
            fill="#E9E9E8"
          />
          <path
            d="M32.8344 59.0195C32.8187 59.0187 32.803 59.0175 32.7873 59.0159C32.7193 58.964 32.6453 58.9197 32.5674 58.8845C32.4841 58.847 32.4033 58.8126 32.3306 58.7978C32.2547 58.7239 32.1938 58.6356 32.1552 58.537C32.0759 58.336 32.0775 57.8251 32.3404 57.7604C32.4569 58.2142 32.5574 58.6261 32.8344 59.0195Z"
            fill="#EDEDEC"
          />
          <path
            d="M34.8203 59C34.9264 58.8123 35.0098 58.6121 35.0689 58.4048C35.108 58.2678 35.094 57.9282 35.1698 57.8216C35.2093 57.766 35.2439 57.7429 35.2736 57.7429C35.4184 57.7429 35.4527 58.2965 35.4139 58.422C35.3294 58.696 35.0983 58.9213 34.8203 59Z"
            fill="#EDEDEC"
          />
          <path
            d="M33.6495 59.8525C33.4865 59.8525 33.3503 59.7969 33.1933 59.7244C33.189 59.6903 33.1832 59.6567 33.1758 59.6234C33.185 59.6238 33.1943 59.6238 33.2039 59.6238C33.3906 59.6238 33.6269 59.5966 33.7569 59.4772C33.8687 59.5722 34.0153 59.6198 34.1618 59.6198C34.1832 59.6198 34.2046 59.6186 34.226 59.6166C34.2118 59.6511 34.1997 59.6863 34.1892 59.7224C34.0689 59.7652 33.9491 59.7981 33.8871 59.8161C33.7999 59.8413 33.722 59.8525 33.6495 59.8525Z"
            fill="#EDEDEC"
          />
          <path
            d="M33.0938 75.037L33.1302 63.5119L33.7259 60.0066L33.952 60.0445L33.3593 63.5339L33.3174 75.2559L33.0938 75.037Z"
            fill="#E3E3E2"
          />
          <path
            d="M33.3365 63.4532L33.1543 63.5918C32.972 63.3557 32.8077 63.0481 32.6178 62.6922C32.3237 62.1417 31.9905 61.5174 31.4844 60.9653L31.6542 60.8119C32.1797 61.3855 32.5199 62.0231 32.8203 62.5855C33.0057 62.9327 33.1659 63.2323 33.3365 63.4532Z"
            fill="#E3E3E2"
          />
          <path
            d="M33.475 61.9073C33.784 61.8266 34.0611 61.6313 34.2394 61.368C34.4421 61.0692 34.5123 60.7041 34.5784 60.3498C34.352 60.4169 34.1161 60.3845 33.8788 60.3522C33.6958 60.327 33.5122 60.3023 33.3312 60.323C32.9997 60.3606 32.6912 60.5611 32.5237 60.8475C32.3068 61.2182 32.2187 61.6389 32.4101 61.8082C32.5679 61.9485 33.0615 62.0156 33.475 61.9073Z"
            fill="#E9E9E8"
          />
          <path
            d="M31.9319 61.1118C31.5616 61.3443 31.0853 61.4034 30.6686 61.2688C30.2518 61.1338 30.13 60.5122 29.9688 60.108C30.3469 60.0309 31.307 60.0848 31.5241 60.1064C31.7418 60.1279 31.9622 60.2254 32.0792 60.4084C32.1962 60.5917 32.1745 60.8661 31.9974 60.9932L31.9319 61.1118Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.0246 61.785C30.2794 61.479 30.9074 61.2573 31.3008 61.328C31.6941 61.3991 32.0295 61.6679 32.1705 61.9875C32.0666 62.2352 31.788 62.375 31.5181 62.3946C31.2485 62.4137 30.9826 62.3342 30.7239 62.2559C30.4652 62.1776 30.1992 62.0982 29.9297 62.1173L30.0246 61.785Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.7729 59.8038C37.7729 59.8038 38.1933 60.1769 38.2773 60.6974C38.3611 61.2179 37.4076 61.8407 37.4076 61.8407C37.4076 61.8407 36.6997 62.0656 36.2013 61.6278C35.7031 61.1895 35.7031 61.1896 35.7031 61.1896C35.7031 61.1896 37.2224 59.7858 37.7087 59.9157L37.7729 59.8038Z"
            fill="#E9E9E8"
          />
          <path
            d="M35.2999 59.0324C34.9786 59.8201 35.1675 60.995 35.8761 61.2798C36.5846 61.5646 37.5447 60.8516 37.8659 60.0638C38.1875 59.2765 37.6243 59.0184 36.9158 58.7332C36.207 58.4484 35.6214 58.245 35.2999 59.0324Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.5016 59.4463C37.5016 59.4463 36.8089 59.7163 35.7422 59.1095C35.7422 59.1095 37.1792 60.8584 37.5016 59.4463Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.0631 59.1348C37.0631 59.1348 36.4559 58.8276 36.364 59.0908C36.364 59.0908 35.8289 58.8943 35.9742 58.6914C36.1197 58.4884 37.0631 59.1348 37.0631 59.1348Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.0075 59.9971C36.4715 59.9967 35.7422 59.1095 35.7422 59.1095C36.3065 59.4306 36.7661 59.5061 37.074 59.5061C37.3479 59.5061 37.5016 59.4462 37.5016 59.4462C37.4088 59.8525 37.2238 59.9971 37.0075 59.9971Z"
            fill="#EDEDEC"
          />
          <path
            d="M37.0631 59.1348C37.0631 59.1348 36.7656 58.9842 36.5555 58.9842C36.4654 58.9842 36.3915 59.0117 36.364 59.0908C36.364 59.0908 35.9489 58.9386 35.9492 58.7633C35.9492 58.7397 35.9569 58.7157 35.9742 58.6914C35.994 58.6638 36.0284 58.6518 36.0733 58.6518C36.3585 58.6518 37.0631 59.1348 37.0631 59.1348Z"
            fill="#EDEDEC"
          />
          <path
            d="M37.0154 61.9084C36.6684 62.2104 36.1367 62.2575 35.7146 62.0722C35.2926 61.8864 34.9824 61.4946 34.8409 61.0583C34.6995 60.6225 34.7149 60.1468 34.8223 59.7013C34.8501 59.5859 34.929 59.3007 35.0928 59.3027C35.2431 59.3047 35.2687 59.5216 35.3049 59.6302C35.409 59.943 35.5289 60.2422 35.6966 60.5278C35.8587 60.8047 36.053 61.0627 36.2746 61.2948C36.3367 61.3599 36.9543 61.9615 37.0154 61.9084Z"
            fill="#E9E9E8"
          />
          <path
            d="M34.3958 59.3402C34.1563 59.6263 34.083 60.0401 34.2098 60.3901C34.293 60.6201 34.452 60.8143 34.6161 60.9965C34.7303 61.1231 34.8863 61.2577 35.0509 61.2114C35.2285 61.1614 35.282 60.9417 35.3014 60.7592C35.3309 60.4783 35.3529 60.1971 35.3674 59.9151C35.379 59.6838 35.4572 59.3147 35.3867 59.0942C35.3206 58.8865 35.1204 58.936 34.9018 59.0055C34.7064 59.0678 34.5273 59.1833 34.3958 59.3402Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.1529 61.4277C37.091 61.4277 37.029 61.4202 36.9688 61.4046C37.3502 61.1094 37.5683 60.745 37.8139 60.3452C38.046 60.4838 37.896 60.9723 37.7609 61.1417C37.6164 61.3227 37.3844 61.4277 37.1529 61.4277Z"
            fill="#EDEDEC"
          />
          <path
            d="M35.0758 60.8047C34.8335 60.6481 34.6794 60.3657 34.6797 60.0788C34.6798 59.9526 34.8618 59.4681 34.9987 59.4681C35.0336 59.4681 35.0656 59.4996 35.091 59.5763C35.1319 59.7002 35.0179 60.0205 35.0148 60.1631C35.0097 60.3785 35.0302 60.5942 35.0758 60.8047Z"
            fill="#EDEDEC"
          />
          <path
            d="M36.1677 61.9932C36.0226 61.9932 35.884 61.962 35.7244 61.8573C35.5966 61.7731 35.1792 61.515 35.1958 61.3632C35.3123 61.5258 35.5142 61.6193 35.7142 61.6193C35.7947 61.6193 35.8749 61.6041 35.9491 61.5725C36.1112 61.8486 36.701 61.9356 36.701 61.9356C36.4916 61.956 36.3257 61.9932 36.1677 61.9932Z"
            fill="#EDEDEC"
          />
          <path
            d="M32.7617 73.3164L32.9059 72.8443L33.1015 72.2079L33.3273 71.4657L35.1331 65.5652L35.3589 63.8718L35.5592 62.3694L35.6009 62.0578L35.713 62.0722L35.7146 62.0738L35.8284 62.0882L35.8253 62.115L35.7852 62.409L35.5721 64.0148L35.3974 65.3235L35.3589 65.6111L35.3446 65.6574L33.3258 72.2479L33.0981 72.9873L32.9941 73.3308L32.85 73.7998L32.7617 73.3164Z"
            fill="#E3E3E2"
          />
          <path
            d="M35.1797 65.4959L35.3126 65.6816C35.5567 65.5095 35.8047 65.2634 36.0922 64.9782C36.536 64.538 37.0395 64.0386 37.6867 63.6583L37.5699 63.4626C36.8977 63.8573 36.3835 64.3674 35.9297 64.8176C35.6498 65.0948 35.4082 65.3349 35.1797 65.4959Z"
            fill="#E3E3E2"
          />
          <path
            d="M35.5046 63.9777C35.2332 63.8103 35.0264 63.5427 34.9336 63.2391C34.8286 62.8943 34.8695 62.5244 34.9113 62.1669C35.2595 62.3974 35.7282 62.3383 36.1115 62.5052C36.4172 62.6379 36.6526 62.9195 36.7279 63.2419C36.8254 63.6593 36.7851 64.0871 36.5518 64.1938C36.3597 64.2813 35.8678 64.2014 35.5046 63.9777Z"
            fill="#E9E9E8"
          />
          <path
            d="M37.2162 63.6664C37.5014 63.9968 37.9391 64.1925 38.3773 64.1854C38.8157 64.1782 39.116 63.6193 39.39 63.2798C39.0513 63.096 38.1178 62.8675 37.9038 62.8244C37.6895 62.7816 37.4497 62.8104 37.2836 62.9514C37.1176 63.0924 37.0571 63.3613 37.189 63.5338L37.2162 63.6664Z"
            fill="#E9E9E8"
          />
          <path
            d="M38.8374 64.8664C38.6847 64.5001 38.15 64.1042 37.7532 64.0575C37.3562 64.0107 36.9558 64.1697 36.7266 64.4342C36.7525 64.7014 36.9772 64.9163 37.2292 65.0134C37.4815 65.1105 37.7592 65.112 38.0296 65.1128C38.3002 65.1132 38.5777 65.1152 38.8298 65.2119L38.8374 64.8664Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.6188 59.3427C29.6188 59.3427 29.1571 59.6647 29.0123 60.1716C28.8675 60.6785 29.7405 61.408 29.7405 61.408C29.7405 61.408 30.417 61.7144 30.9635 61.3373C31.5102 60.9602 31.5102 60.9602 31.5102 60.9602C31.5102 60.9602 30.1677 59.3891 29.6694 59.4614L29.6188 59.3427Z"
            fill="#E9E9E8"
          />
          <path
            d="M32.1726 58.8659C32.3985 59.6856 32.0716 60.8305 31.3343 61.031C30.5969 61.2312 29.7281 60.4111 29.502 59.5914C29.2761 58.7716 29.866 58.5807 30.6035 58.3806C31.3408 58.1804 31.9464 58.0462 32.1726 58.8659Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.9297 59.0189C29.9297 59.0189 30.5857 59.368 31.7169 58.8899C31.7169 58.8899 30.0829 60.4586 29.9297 59.0189Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.4062 58.7619C30.4062 58.7619 31.0458 58.5278 31.1057 58.7998C31.1057 58.7998 31.6601 58.6672 31.5398 58.4487C31.4195 58.2302 30.4062 58.7619 30.4062 58.7619Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.4168 59.627C30.1725 59.627 29.9778 59.472 29.9297 59.019C29.9297 59.019 30.1608 59.142 30.5851 59.142C30.8756 59.142 31.257 59.0841 31.7169 58.8899C31.7169 58.8899 30.9491 59.627 30.4168 59.627Z"
            fill="#EDEDEC"
          />
          <path
            d="M31.1057 58.7998C31.0836 58.6999 30.9833 58.6684 30.8653 58.6684C30.6621 58.6684 30.4062 58.7619 30.4062 58.7619C30.4062 58.7619 31.1036 58.3959 31.4099 58.3959C31.4728 58.3959 31.5194 58.4115 31.5398 58.4487C31.5516 58.4699 31.5569 58.4906 31.5569 58.5102C31.5571 58.6919 31.1057 58.7998 31.1057 58.7998Z"
            fill="#EDEDEC"
          />
          <path
            d="M30.125 61.523C30.434 61.8634 30.9564 61.9724 31.3974 61.837C31.8385 61.702 32.1929 61.3489 32.3852 60.9326C32.5773 60.516 32.6182 60.0418 32.5641 59.5868C32.5501 59.4694 32.5058 59.1766 32.3429 59.1594C32.1935 59.1442 32.1423 59.3563 32.0935 59.4602C31.9531 59.7586 31.7984 60.0418 31.5984 60.3059C31.4043 60.5615 31.1809 60.7952 30.9333 61.0001C30.8641 61.0577 30.1794 61.5826 30.125 61.523Z"
            fill="#E9E9E8"
          />
          <path
            d="M33.0281 59.2775C33.2322 59.5891 33.256 60.0089 33.0887 60.3417C32.9788 60.5602 32.7978 60.7347 32.6133 60.8965C32.485 61.0088 32.3143 61.1246 32.1562 61.0591C31.9856 60.9888 31.9584 60.7643 31.9611 60.5809C31.9647 60.2985 31.9762 60.0165 31.9954 59.7349C32.0114 59.504 31.9775 59.1285 32.0734 58.9172C32.1638 58.7186 32.3566 58.7917 32.5655 58.886C32.7522 58.9703 32.9163 59.1061 33.0281 59.2775Z"
            fill="#E9E9E8"
          />
          <path
            d="M30.1321 61.0322C29.8714 61.0322 29.612 60.8932 29.4745 60.6723C29.3604 60.4882 29.2693 59.9856 29.5162 59.875C29.7127 60.3004 29.886 60.6879 30.2301 61.0254C30.1975 61.0298 30.1648 61.0322 30.1321 61.0322Z"
            fill="#EDEDEC"
          />
          <path
            d="M32.1797 60.6523C32.25 60.449 32.2957 60.2369 32.3163 60.0228C32.33 59.8806 32.2548 59.549 32.31 59.4308C32.3421 59.3621 32.3753 59.3337 32.4078 59.3337C32.5465 59.3337 32.6739 59.8506 32.6589 59.9776C32.6255 60.2629 32.4388 60.5253 32.1797 60.6523Z"
            fill="#EDEDEC"
          />
          <path
            d="M31.0531 61.7109C30.8621 61.7109 30.6792 61.6394 30.4297 61.5851C30.4297 61.5851 31.0258 61.5675 31.2193 61.3123C31.3115 61.365 31.4173 61.3906 31.5235 61.3906C31.6984 61.3906 31.8745 61.3215 31.9925 61.1924C31.9909 61.3446 31.5461 61.5527 31.4088 61.6211C31.2777 61.6866 31.164 61.7109 31.0531 61.7109Z"
            fill="#EDEDEC"
          />
          <path
            d="M33.3806 76.7363L31.33 65.3922L31.2812 61.8378L31.5107 61.8346L31.5592 65.3731L33.6404 76.9121L33.3806 76.7363Z"
            fill="#E3E3E2"
          />
          <path
            d="M31.5221 65.2978L31.3682 65.4668C31.1461 65.2675 30.929 64.9942 30.6774 64.6778C30.2885 64.1885 29.8476 63.634 29.25 63.1806L29.3892 62.9997C30.0101 63.4707 30.4601 64.0371 30.8576 64.5368C31.1028 64.8448 31.3144 65.1113 31.5221 65.2978Z"
            fill="#E3E3E2"
          />
          <path
            d="M31.3826 63.7533C31.6722 63.6186 31.9094 63.377 32.0372 63.0865C32.1825 62.7566 32.1856 62.3843 32.1862 62.0244C31.8133 62.2125 31.3548 62.0995 30.9544 62.2201C30.6354 62.3164 30.3681 62.5684 30.255 62.88C30.1088 63.2831 30.0981 63.7129 30.3173 63.8455C30.4978 63.955 30.9956 63.933 31.3826 63.7533Z"
            fill="#E9E9E8"
          />
          <path
            d="M29.7185 63.2451C29.3961 63.5399 28.9386 63.6829 28.5043 63.625C28.0697 63.5667 27.8374 62.9767 27.6055 62.6076C27.9637 62.4646 28.9177 62.3467 29.1354 62.3287C29.3532 62.3112 29.588 62.3679 29.7361 62.5273C29.8844 62.6863 29.9128 62.9603 29.7616 63.1169L29.7185 63.2451Z"
            fill="#E9E9E8"
          />
          <path
            d="M27.9632 64.2477C28.1583 63.9014 28.736 63.5714 29.1357 63.571C29.5356 63.5706 29.9144 63.7751 30.1109 64.0643C30.0532 64.3268 29.8047 64.5141 29.5429 64.5809C29.2809 64.648 29.0049 64.6176 28.7362 64.5868C28.4678 64.5557 28.1918 64.5249 27.9297 64.592L27.9632 64.2477Z"
            fill="#E9E9E8"
          />
          <path
            d="M34.2209 69.7767H31.8144C31.6338 69.7727 31.4727 69.8881 31.419 70.0591C31.2216 70.6787 30.8008 72.3081 30.8008 74.8747C30.8008 77.6941 31.5415 81.4375 31.7746 82.5433C31.8137 82.7294 31.9782 82.8636 32.1699 82.8652H33.8454C34.0369 82.8636 34.2014 82.7294 34.2406 82.5433C34.4736 81.4375 35.2147 77.6941 35.2147 74.8747C35.2147 72.3081 34.7937 70.6787 34.5963 70.0591C34.5442 69.8953 34.3937 69.7819 34.2209 69.7767Z"
            fill="#F4F4F4"
          />
          <path
            d="M178.544 144.102C178.544 146.6 143.601 148.625 100.497 148.625C57.3922 148.625 22.4492 146.6 22.4492 144.102C22.4492 141.604 57.3922 139.579 100.497 139.579C143.601 139.579 178.544 141.604 178.544 144.102Z"
            fill="#F8F8F9"
          />
          <path
            d="M48.4826 128.555C48.3457 128.546 48.239 128.431 48.2423 128.294C48.5401 116.553 49.1504 97.294 49.1822 97.1886C49.2228 97.0536 49.3661 96.98 49.5018 97.0168C49.6374 97.0567 49.7155 97.199 49.6757 97.334C49.668 97.3599 49.0518 116.686 48.7567 128.307C48.7535 128.447 48.6351 128.559 48.493 128.556L48.4826 128.555Z"
            fill="#1D2A30"
          />
          <path
            d="M46.8927 89.3496C46.9917 90.254 48.0826 93.389 48.9939 93.2907C49.9049 93.192 50.2913 89.898 50.1923 88.994C50.0932 88.0896 49.2741 87.4361 48.3631 87.5344C47.4518 87.6326 46.7936 88.446 46.8927 89.3496Z"
            fill="#4870C0"
          />
          <path
            d="M51.3147 99.2391C51.2157 98.3351 50.1248 95.2001 49.2139 95.2983C48.3025 95.3966 47.9161 98.691 48.0151 99.5954C48.1141 100.499 48.9333 101.153 49.8446 101.055C50.7556 100.956 51.4141 100.143 51.3147 99.2391Z"
            fill="#4870C0"
          />
          <path
            d="M44.1206 96.4892C45.032 96.391 48.1907 95.3084 48.0912 94.404C47.9922 93.5 44.6729 93.1161 43.7616 93.2148C42.8502 93.3131 42.1921 94.1256 42.2911 95.03C42.3905 95.9344 43.2093 96.5875 44.1206 96.4892Z"
            fill="#4870C0"
          />
          <path
            d="M54.0905 92.0992C53.1791 92.1975 50.0204 93.2801 50.1195 94.1845C50.2189 95.0885 53.5382 95.4719 54.4495 95.3737C55.3605 95.2754 56.019 94.4625 55.92 93.5581C55.8206 92.6541 55.0014 92.001 54.0905 92.0992Z"
            fill="#4870C0"
          />
          <path
            d="M44.0181 92.3502C44.7326 92.9202 47.7379 94.3715 48.3119 93.6625C48.8863 92.9534 46.8125 90.3529 46.098 89.7828C45.3835 89.2132 44.3389 89.3258 43.7645 90.0349C43.1904 90.7439 43.304 91.7802 44.0181 92.3502Z"
            fill="#4870C0"
          />
          <path
            d="M54.1896 96.239C53.4755 95.6694 50.4706 94.2185 49.8962 94.9272C49.3218 95.6362 51.3956 98.2364 52.1101 98.8064C52.8246 99.3764 53.8692 99.2638 54.4432 98.5547C55.0181 97.8457 54.9041 96.8091 54.1896 96.239Z"
            fill="#4870C0"
          />
          <path
            d="M47.1445 99.3426C47.7189 98.6339 49.1813 95.6515 48.4668 95.0818C47.7523 94.5118 45.1322 96.5703 44.5574 97.2789C43.9834 97.988 44.0969 99.0246 44.8114 99.5946C45.5259 100.165 46.5705 100.052 47.1445 99.3426Z"
            fill="#4870C0"
          />
          <path
            d="M51.0654 89.2472C50.4914 89.9562 49.0286 92.9382 49.7435 93.5079C50.4576 94.0779 53.0781 92.0199 53.6525 91.3108C54.2265 90.6018 54.113 89.5647 53.3985 88.9951C52.6844 88.4255 51.6394 88.5381 51.0654 89.2472Z"
            fill="#4870C0"
          />
          <path
            d="M48.9518 93.293C48.7458 93.293 48.5312 93.1336 48.3219 92.8767C48.177 92.4461 47.871 91.9248 47.5228 91.429C47.1831 90.6161 46.9376 89.7569 46.8929 89.3498C46.8864 89.2899 46.8832 89.2304 46.8828 89.1713C46.8824 88.3412 47.5128 87.6265 48.3633 87.5346C48.4241 87.5282 48.4845 87.525 48.5445 87.525C49.381 87.525 50.1003 88.1502 50.1925 88.9943C50.2025 89.0862 50.2078 89.2024 50.2078 89.3378C50.2078 89.802 50.1482 90.4883 50.0274 91.159C49.7948 91.7175 49.6092 92.2915 49.5609 92.7429C49.5178 92.8284 49.4727 92.9059 49.4252 92.9742C49.2976 93.1579 49.1539 93.2734 48.9941 93.291C48.98 93.2922 48.9659 93.293 48.9518 93.293Z"
            fill="#4164E3"
          />
          <path
            d="M49.6633 101.064C49.6267 101.064 49.5904 101.063 49.5542 101.061C49.3771 101.049 49.2064 101.01 49.0474 100.946C48.4971 100.726 48.0837 100.221 48.0153 99.5952C48.0052 99.5033 48 99.3867 48 99.2517C48 98.7871 48.0596 98.1012 48.1803 97.4305C48.413 96.872 48.599 96.2976 48.6469 95.8462C48.8059 95.5302 48.9947 95.3217 49.214 95.2981C49.2281 95.2965 49.2418 95.2957 49.2563 95.2957C49.4624 95.2957 49.677 95.4555 49.8863 95.712C50.0308 96.1426 50.3367 96.6639 50.6849 97.1601C51.0247 97.9726 51.2706 98.8318 51.3149 99.2389C51.3217 99.2992 51.3249 99.3587 51.3249 99.4178C51.3258 100.248 50.6954 100.962 49.8448 101.054C49.7836 101.061 49.7233 101.064 49.6633 101.064Z"
            fill="#4164E3"
          />
          <path
            d="M43.9389 96.499C43.7211 96.499 43.511 96.4563 43.3182 96.3788C42.7703 96.1583 42.3593 95.6537 42.2909 95.0298C42.2845 94.9699 42.2813 94.9099 42.2813 94.8512C42.2804 94.0207 42.9108 93.3065 43.7614 93.2146C43.8544 93.2046 43.9719 93.1994 44.1092 93.1994C44.5769 93.1994 45.2673 93.2585 45.9423 93.378C46.5055 93.6093 47.0847 93.7938 47.5396 93.8414C47.8576 93.9992 48.0673 94.1865 48.0911 94.4038C48.0927 94.4178 48.0935 94.4322 48.0935 94.4462C48.0935 94.6507 47.9325 94.8636 47.674 95.0713C47.2401 95.2147 46.7148 95.5183 46.2148 95.8643C45.3961 96.2014 44.5306 96.4451 44.1204 96.489C44.0592 96.4958 43.9989 96.499 43.9389 96.499Z"
            fill="#4164E3"
          />
          <path
            d="M54.1031 95.3887C53.6354 95.3887 52.9446 95.3296 52.2691 95.2101C51.706 94.9788 51.1267 94.7943 50.6715 94.7467C50.3535 94.5889 50.1434 94.4016 50.1196 94.1843C50.118 94.1699 50.1172 94.1559 50.1172 94.1415C50.1176 93.9374 50.2782 93.7245 50.5366 93.5172C50.9706 93.3738 51.4963 93.0702 51.9962 92.7238C52.815 92.3871 53.6804 92.1434 54.0906 92.0991C54.1518 92.0927 54.2122 92.0895 54.2722 92.0895C55.1082 92.0895 55.8276 92.7142 55.9201 93.5579C55.9266 93.6182 55.9298 93.6778 55.9298 93.7369C55.9306 94.567 55.3002 95.282 54.4497 95.3735C54.3571 95.3835 54.2396 95.3887 54.1031 95.3887Z"
            fill="#4164E3"
          />
          <path
            d="M47.7567 93.8535C47.6887 93.8535 47.617 93.8495 47.5417 93.8415C47.0869 93.794 46.5076 93.6094 45.9445 93.3781C45.1253 93.0418 44.3396 92.6068 44.0179 92.3503C43.6106 92.0252 43.3988 91.5486 43.3984 91.0672C43.398 90.7045 43.5176 90.3398 43.7643 90.035C44.0924 89.6299 44.5734 89.4198 45.0589 89.4198C45.424 89.4198 45.7911 89.5385 46.0978 89.7829C46.4195 90.0398 47.0164 90.7077 47.5236 91.4295C47.8718 91.9253 48.1777 92.4466 48.3227 92.8772C48.3794 93.0462 48.4112 93.2012 48.4112 93.3354C48.4112 93.4668 48.3802 93.5783 48.3118 93.6626C48.2031 93.7968 48.0075 93.8535 47.7567 93.8535Z"
            fill="#4164E3"
          />
          <path
            d="M53.1492 99.1699C53.0743 99.1699 52.9991 99.1647 52.9242 99.1547C52.6356 99.1156 52.3538 99.0005 52.1102 98.8064C51.9351 98.6666 51.6775 98.4041 51.3978 98.0778C51.1643 97.8053 50.9151 97.4882 50.6845 97.1602C50.3363 96.6641 50.0303 96.1428 49.8858 95.7121C49.8291 95.5436 49.7969 95.3886 49.7969 95.2543C49.7969 95.1229 49.8279 95.0119 49.8963 94.9272C50.005 94.793 50.201 94.7362 50.4518 94.7362C50.5194 94.7362 50.5915 94.7402 50.6664 94.7482C51.1216 94.7957 51.7009 94.9803 52.264 95.2116C53.0828 95.5475 53.8685 95.9826 54.1898 96.239C54.5975 96.5642 54.8093 97.0412 54.8097 97.5225C54.8101 97.8848 54.6905 98.2499 54.4433 98.5547C54.1157 98.9594 53.6347 99.1699 53.1492 99.1699Z"
            fill="#4164E3"
          />
          <path
            d="M45.8503 99.958C45.4852 99.9576 45.118 99.839 44.8113 99.5945C44.4039 99.2693 44.1918 98.7928 44.1914 98.3114C44.191 97.9487 44.3106 97.5836 44.5573 97.2788C44.8161 96.9596 45.4888 96.3672 46.2162 95.8643C46.7161 95.5183 47.2414 95.2147 47.6754 95.0713C47.8456 95.015 48.0018 94.983 48.1367 94.983C48.2691 94.983 48.3814 95.0138 48.4667 95.0817C48.602 95.1896 48.6592 95.3841 48.6592 95.6334C48.6592 95.7005 48.6551 95.7716 48.6471 95.8463C48.5992 96.2977 48.4132 96.8721 48.1805 97.4306C47.8416 98.2435 47.4032 99.0233 47.1444 99.3424C46.9363 99.5997 46.6662 99.7782 46.3723 99.8745C46.2037 99.9296 46.0274 99.958 45.8503 99.958Z"
            fill="#4164E3"
          />
          <path
            d="M50.0733 93.6064C49.9408 93.6064 49.8285 93.5757 49.7436 93.5078C49.6079 93.3999 49.5508 93.2054 49.5508 92.9561C49.5508 92.889 49.5552 92.8179 49.5629 92.7432C49.6112 92.2918 49.7967 91.7178 50.0294 91.1593C50.3683 90.346 50.8071 89.5662 51.0655 89.2471C51.3932 88.842 51.8746 88.6319 52.3601 88.6319C52.7248 88.6319 53.0923 88.7505 53.3986 88.995C53.8064 89.3198 54.0181 89.7967 54.0185 90.2781C54.0189 90.6408 53.8994 91.0059 53.6526 91.3107C53.3942 91.6299 52.7212 92.2223 51.9938 92.7252C51.4938 93.0716 50.9681 93.3752 50.5342 93.5186C50.3643 93.5749 50.2081 93.6064 50.0733 93.6064Z"
            fill="#4164E3"
          />
          <path
            d="M47.1484 94.5054C47.2659 95.576 48.2356 96.3501 49.3148 96.2335C50.394 96.1172 51.1737 95.1545 51.0562 94.0836C50.9391 93.0126 49.9689 92.2388 48.8897 92.3555C47.8105 92.4721 47.0312 93.4344 47.1484 94.5054Z"
            fill="#F8F8F9"
          />
          <path
            d="M47.3456 119.952C45.0773 120.001 41.1968 117.922 39.6701 115.893C38.1206 113.834 42.466 115.102 42.0152 113.482C41.5644 111.864 36.2153 113.077 35.2208 110.758C34.2262 108.44 38.0895 108.963 37.9329 107.777C37.7761 106.591 33.7759 106.844 32.4842 104.38C31.1925 101.917 34.7159 103.289 34.1605 102.268C33.605 101.247 29.1813 96.9561 31.0247 96.0541C32.8678 95.1513 37.0163 99.6213 38.4032 100.117C39.0134 100.336 39.4161 99.8586 39.8297 99.3813C40.3559 98.7737 40.9002 98.1661 41.9117 98.9926C43.7191 100.469 42.3887 106.944 44.5133 107.792C45.2926 108.103 45.5229 107.543 45.7737 106.983C46.0321 106.406 46.3119 105.828 47.2369 106.205C50.4258 107.505 48.2662 119.932 47.3456 119.952Z"
            fill="#4870C0"
          />
          <path
            d="M47.2707 119.953C44.143 108.289 36.5604 100.833 36.4669 100.743C36.4322 100.709 36.3872 100.692 36.342 100.692C36.2954 100.692 36.2489 100.71 36.2133 100.746C36.1443 100.816 36.1459 100.929 36.2168 100.998C36.3088 101.087 43.7787 108.437 46.896 119.936C45.4018 119.808 43.4036 118.942 41.795 117.831C40.9264 117.231 40.1716 116.559 39.6701 115.893C39.4341 115.579 39.3349 115.343 39.3347 115.162C39.3334 114.213 42.0478 114.778 42.0482 113.704C42.0482 113.637 42.0378 113.563 42.0152 113.483C41.6847 112.295 38.7188 112.631 36.7688 111.98C36.0789 111.75 35.5163 111.396 35.2424 110.807C35.235 110.791 35.2277 110.775 35.2208 110.758C35.1071 110.494 35.057 110.266 35.0568 110.069C35.0565 108.571 37.9401 108.816 37.9375 107.844C37.9375 107.823 37.9359 107.8 37.9329 107.777C37.7762 106.591 33.776 106.844 32.4842 104.38C32.2812 103.993 32.1971 103.701 32.1976 103.479C32.1995 102.394 34.2195 102.996 34.2205 102.458C34.2206 102.406 34.2019 102.344 34.1605 102.268C33.745 101.504 31.1657 98.9115 30.6631 97.2753C30.6085 97.098 30.5783 96.9318 30.5781 96.7804C30.5777 96.4612 30.7098 96.2083 31.0247 96.0541C31.193 95.9715 31.3802 95.9339 31.5829 95.9339C33.602 95.9339 37.1428 99.6665 38.4032 100.118C38.5079 100.155 38.6067 100.172 38.7004 100.172C39.1521 100.172 39.4873 99.7768 39.8297 99.3813C40.1724 98.9858 40.5226 98.5904 41.0041 98.5904C41.2625 98.5904 41.5587 98.7042 41.9118 98.9926C43.7192 100.469 42.3888 106.944 44.5134 107.792C44.6679 107.854 44.8008 107.881 44.9163 107.881C45.3849 107.881 45.5724 107.432 45.7737 106.983C45.9746 106.534 46.1887 106.084 46.7092 106.084C46.8577 106.084 47.0312 106.121 47.2369 106.205C48.1301 106.569 48.6039 107.807 48.8028 109.4C48.8132 110.046 48.8515 110.698 48.9179 111.342C48.9183 111.386 48.9183 111.431 48.9183 111.475C48.9183 112.871 48.7875 114.354 48.5943 115.683C48.4027 117.002 48.1495 118.169 47.9007 118.948C47.7014 119.573 47.505 119.949 47.3456 119.952C47.3206 119.953 47.2957 119.953 47.2707 119.953Z"
            fill="#4164E3"
          />
          <path
            d="M50.6019 117.096C50.6401 117.159 50.3004 117.478 51.4203 117.524C54.1776 117.637 59.0539 117.452 60.8851 114.964C63.4992 111.412 57.4696 111.738 58.0561 109.779C58.6422 107.82 65.1202 109.42 66.3845 106.623C67.6489 103.827 62.9376 104.372 63.1558 102.933C63.3744 101.495 68.3175 103.359 69.9466 100.392C71.576 97.426 67.258 99.0131 67.9576 97.7843C68.6573 96.5551 74.1394 91.4383 71.9182 90.2979C69.6974 89.1574 64.5462 94.4987 62.8474 95.0703C62.0766 95.3296 61.5746 94.392 61.0473 93.4549C60.4133 92.3268 59.7423 91.1987 58.523 92.1562C56.2901 93.909 57.7554 101.817 55.1514 102.799C54.0887 103.2 53.9256 102.53 53.602 101.861C53.3351 101.308 52.9583 100.756 51.8759 100.805C48.6246 100.953 47.5551 112.042 50.6019 117.096Z"
            fill="#4870C0"
          />
          <path
            d="M52.6049 117.549C52.5622 117.549 52.5199 117.549 52.4777 117.549C52.1013 117.547 51.7459 117.538 51.4202 117.524C51.2213 117.516 51.0684 117.499 50.9512 117.477C50.6409 117.418 50.5817 117.318 50.5817 117.235C50.5817 117.183 50.6051 117.137 50.6051 117.11C50.6051 117.105 50.6039 117.1 50.6018 117.096C49.6829 115.572 49.1382 113.499 48.9152 111.342C48.8488 110.698 48.8106 110.046 48.8001 109.4C48.7977 109.271 48.7969 109.142 48.7969 109.013C48.7973 104.793 49.9566 100.893 51.8759 100.805C51.9214 100.803 51.9652 100.802 52.0079 100.802C52.9897 100.802 53.3459 101.332 53.6019 101.861C53.858 102.391 54.0133 102.92 54.593 102.92C54.7464 102.92 54.9291 102.883 55.1513 102.799C57.7553 101.817 56.2901 93.9092 58.523 92.1563C58.8458 91.9026 59.1296 91.7956 59.3852 91.7956C60.0944 91.7956 60.5807 92.6253 61.0473 93.455C61.5138 94.2843 61.9606 95.1139 62.5918 95.1139C62.6739 95.1139 62.7588 95.1 62.8474 95.0704C64.3831 94.5535 68.7405 90.139 71.2032 90.139C71.4649 90.139 71.7052 90.1885 71.9181 90.298C72.2889 90.4885 72.4451 90.7897 72.4447 91.1656C72.4434 91.7193 72.1021 92.4347 71.6062 93.1941C70.4251 95.0037 68.3682 97.063 67.9576 97.7844C67.9045 97.8779 67.8803 97.955 67.8803 98.0193C67.8811 98.662 70.3148 97.9933 70.3169 99.2824C70.3173 99.5548 70.2094 99.9144 69.9465 100.393C69.1801 101.788 67.6798 102.115 66.2834 102.218C65.3033 102.292 64.3742 102.255 63.7857 102.402C63.4307 102.491 63.1996 102.647 63.1557 102.933C63.1509 102.965 63.1485 102.997 63.1485 103.027C63.1465 104.189 66.6043 103.975 66.6002 105.763C66.5998 106.009 66.5338 106.292 66.3845 106.623C66.3539 106.691 66.3201 106.756 66.2834 106.819C65.8153 107.62 64.8726 108.019 63.7857 108.25C62.2496 108.578 60.4249 108.571 59.2447 108.9C59.1706 108.92 59.099 108.942 59.0301 108.966C58.5282 109.136 58.1735 109.386 58.056 109.779C58.0286 109.871 58.0158 109.957 58.0158 110.04C58.0158 111.4 61.546 111.566 61.5456 113.389C61.5452 113.813 61.3548 114.326 60.885 114.964C60.429 115.584 59.7841 116.061 59.0301 116.426C58.5576 116.655 58.0423 116.839 57.5037 116.988C55.904 117.428 54.0999 117.549 52.6049 117.549Z"
            fill="#4164E3"
          />
          <path
            d="M48.5353 126.78L48.5204 126.779C48.4226 126.767 48.3526 126.679 48.3646 126.581C50.6281 108.199 61.2977 100.728 61.4052 100.654C61.4869 100.599 61.5984 100.619 61.6544 100.7C61.7107 100.781 61.6902 100.892 61.6085 100.947C61.5022 101.02 50.963 108.411 48.7205 126.624C48.7092 126.717 48.6279 126.784 48.5353 126.78Z"
            fill="#1D2A30"
          />
          <path
            d="M58.977 103.209C58.9041 103.206 58.8373 103.159 58.8135 103.086C58.783 102.992 58.8341 102.892 58.9287 102.861C58.9947 102.84 60.5839 102.341 63.1871 102.89C63.2841 102.911 63.3457 103.005 63.3256 103.101C63.305 103.197 63.2096 103.259 63.1126 103.238C60.6109 102.712 59.0547 103.195 59.0394 103.2L58.977 103.209Z"
            fill="#1D2A30"
          />
          <path
            d="M57.005 105.441C56.91 105.437 56.8339 105.36 56.8327 105.265C56.7776 99.7058 60.0208 95.3624 60.0534 95.3193C60.1126 95.2406 60.2257 95.2246 60.3046 95.2841C60.3839 95.3429 60.3996 95.4547 60.34 95.533C60.3082 95.5753 57.1378 99.8269 57.1914 105.262C57.1926 105.36 57.1133 105.441 57.0143 105.441H57.005Z"
            fill="#1D2A30"
          />
          <path
            d="M53.8285 110.146C53.783 110.144 53.7387 110.125 53.7053 110.09C53.6372 110.019 53.6405 109.906 53.7121 109.839C53.7363 109.816 56.1374 107.614 59.2808 108.732C59.3742 108.765 59.4225 108.867 59.3891 108.959C59.3557 109.052 59.253 109.1 59.16 109.067C56.2207 108.021 53.9806 110.077 53.9585 110.098C53.9218 110.132 53.8747 110.148 53.8285 110.146Z"
            fill="#1D2A30"
          />
          <path
            d="M52.1644 113.43C52.0976 113.427 52.0348 113.387 52.0067 113.322C51.9563 113.205 50.7809 110.41 51.4286 106.427C51.4443 106.331 51.5333 106.263 51.6343 106.28C51.7321 106.296 51.7985 106.388 51.7828 106.485C51.1521 110.359 52.3247 113.155 52.3367 113.182C52.3754 113.272 52.3331 113.377 52.2417 113.415L52.1644 113.43Z"
            fill="#1D2A30"
          />
          <path
            d="M48.6075 133.347C48.5146 133.344 48.4389 133.269 48.4361 133.175L48.2034 128.306C47.5167 112.118 36.3271 101.107 36.2144 100.998C36.1435 100.93 36.1419 100.817 36.2109 100.747C36.2807 100.676 36.3939 100.675 36.4645 100.744C36.5785 100.854 47.8689 111.958 48.5613 128.294L48.7943 133.164C48.7971 133.262 48.7199 133.344 48.6204 133.348L48.6075 133.347Z"
            fill="#1D2A30"
          />
          <path
            d="M40.8293 107.079L40.7996 107.075L40.7476 107.056L40.6897 107.033C39.2249 106.429 37.588 106.115 36.0818 106.148C35.981 106.153 35.9007 106.072 35.8985 105.974C35.8963 105.875 35.9747 105.794 36.0738 105.792C37.6294 105.759 39.3172 106.081 40.8273 106.704L40.8869 106.728L40.9179 106.742C40.9883 106.778 41.029 106.857 41.0121 106.938C40.994 107.024 40.9151 107.083 40.8293 107.079Z"
            fill="#1D2A30"
          />
          <path
            d="M42.4103 109.164L42.4014 109.163C42.3028 109.154 42.23 109.068 42.2388 108.97C42.6723 104.192 40.1786 100.261 40.1533 100.221C40.0999 100.139 40.1243 100.029 40.2076 99.9757C40.2913 99.923 40.402 99.9474 40.4552 100.03C40.4813 100.07 43.0407 104.099 42.5963 109.002C42.5874 109.097 42.5053 109.168 42.4103 109.164Z"
            fill="#1D2A30"
          />
          <path
            d="M44.043 111.933C43.9995 111.931 43.9561 111.913 43.9231 111.88C43.9049 111.862 42.0879 110.082 39.4287 110.785C39.3327 110.811 39.235 110.753 39.2092 110.659C39.1837 110.564 39.2408 110.467 39.3362 110.441C42.203 109.682 44.099 111.55 44.1783 111.63C44.2479 111.7 44.2471 111.812 44.1767 111.881C44.14 111.917 44.0913 111.934 44.043 111.933Z"
            fill="#1D2A30"
          />
          <path
            d="M46.1171 116.494L46.0415 116.474C45.9537 116.428 45.9199 116.321 45.9658 116.234C45.9783 116.21 47.2096 113.821 46.9287 110.376C46.9206 110.277 46.9943 110.192 47.0933 110.184C47.1923 110.172 47.2785 110.249 47.2861 110.347C47.5759 113.901 46.3365 116.298 46.2834 116.398C46.2504 116.462 46.1844 116.497 46.1171 116.494Z"
            fill="#1D2A30"
          />
          <path
            d="M58.6948 134.113C58.6948 139.792 56.1214 144.396 48.3279 144.396C40.8895 144.396 37.9609 139.792 37.9609 134.113C37.9609 131.972 38.624 129.979 39.7522 128.332H56.9036C58.0319 129.979 58.6948 131.972 58.6948 134.113Z"
            fill="#4870C0"
          />
          <path
            d="M48.3279 144.396C40.8895 144.396 37.9609 139.792 37.9609 134.113C37.9609 131.972 38.624 129.979 39.7522 128.332H56.9036C58.0319 129.979 58.6948 131.972 58.6948 134.113C58.6948 134.716 58.6659 135.306 58.6047 135.88C58.6011 135.913 58.5974 135.946 58.5938 135.98C58.0512 140.767 55.2467 144.396 48.3279 144.396Z"
            fill="#4164E3"
          />
          <path
            d="M118.251 139.377L122.261 138.796L121.248 129.488L117.238 130.069L118.251 139.377Z"
            fill="#F7B5BF"
          />
          <path
            d="M125.904 138.002C125.965 137.987 126.028 137.989 126.087 138.007C126.129 138.02 126.161 138.055 126.17 138.098C126.203 138.208 126.181 138.328 126.111 138.419C125.904 138.674 125.25 138.817 124.337 138.817C124.813 138.456 125.347 138.179 125.916 137.996L125.904 138.002ZM125.34 138.935C125.689 138.91 126.018 138.768 126.274 138.532C126.384 138.395 126.418 138.214 126.367 138.046C126.344 137.942 126.268 137.856 126.166 137.821C125.63 137.631 124.163 138.704 124 138.825C123.968 138.85 123.954 138.891 123.964 138.93C123.977 138.968 124.013 138.993 124.054 138.994C124.483 139.013 124.914 138.994 125.34 138.935Z"
            fill="#4870C0"
          />
          <path
            d="M124.75 137.233L124.804 137.208C124.981 137.2 125.001 137.266 125.007 137.288C125.101 137.552 124.57 138.331 124.127 138.691C124.086 138.232 124.193 137.773 124.433 137.379C124.519 137.291 124.635 137.237 124.758 137.229L124.75 137.233ZM124.076 138.998L124.109 138.982C124.554 138.692 125.356 137.679 125.205 137.241C125.159 137.143 125.075 137.017 124.807 137.033C124.612 137.036 124.427 137.121 124.3 137.267C123.866 137.762 123.952 138.851 123.953 138.896L123.993 138.982L124.076 138.998Z"
            fill="#4870C0"
          />
          <path
            d="M121.849 137.147L118.293 137.988C118.133 138.02 118.024 138.168 118.041 138.33L118.156 143.435C118.205 143.793 118.537 144.043 118.898 143.994L118.972 143.98C120.512 143.599 121.239 143.339 123.198 142.891C124.398 142.617 128.201 142.332 129.758 141.644C131.316 140.956 130.709 139.389 129.998 139.537C127.714 140.025 124.778 139.054 123.11 137.577C122.884 137.466 122.093 137.084 121.849 137.147Z"
            fill="#1D2A30"
          />
          <path
            d="M117.74 134.727L117.594 133.384H117.595L117.74 134.727Z"
            fill="#CECDCC"
          />
          <path
            d="M117.759 134.87L117.744 134.725L117.598 133.383L121.59 132.644L121.768 134.285L117.759 134.87Z"
            fill="#C48F94"
          />
          <path
            d="M123.386 132.311L115.968 133.686C115.968 133.686 112.365 128.581 111.686 124.957C110.978 121.184 111.734 108.336 111.686 108.166C109.587 101.136 103.886 82.9191 101.133 76.2156C99.609 72.5009 98.5391 69.9999 98.5391 69.9999L99.3099 69.8281L105.365 67.3666L109.778 68.1919C109.778 68.1919 123.188 95.1012 124.593 105.224C125.642 112.782 123.386 132.311 123.386 132.311Z"
            fill="#4870C0"
          />
          <path
            d="M115.968 133.686C115.968 133.686 112.365 128.581 111.686 124.957C111.458 123.743 111.382 121.59 111.382 119.221C111.381 114.458 111.688 108.827 111.688 108.218C111.688 108.189 111.688 108.171 111.686 108.166C110.828 105.293 109.369 100.55 107.755 95.4899C108.597 97.8592 109.351 100.111 109.938 102.078C109.939 102.079 109.939 102.08 109.939 102.08C109.981 102.08 109.647 93.0156 106.505 87.022L106.288 86.5446C106.855 81.7227 107.012 77.8015 107.012 74.9393C107.012 71.3912 106.77 69.4686 106.77 69.4686L100.227 69.4554L101.571 68.9089C104.777 68.8039 108.344 68.6493 109.772 68.4503C109.772 68.4503 109.776 68.3613 109.782 68.1995C110.032 68.7028 123.201 95.1975 124.593 105.224C124.791 106.648 124.871 108.498 124.871 110.562C124.871 113.68 124.689 117.288 124.452 120.657C124.152 124.9 123.767 128.766 123.551 130.802C123.548 130.836 123.544 130.869 123.541 130.902C123.446 131.797 123.386 132.311 123.386 132.311L121.588 132.644L117.596 133.384H117.594L115.968 133.686Z"
            fill="#4164E3"
          />
          <path
            d="M107.757 95.4893C107.143 93.7612 106.482 91.9707 105.805 90.1815C105.83 90.0138 105.854 89.8456 105.878 89.6794C106.51 91.6052 107.145 93.5702 107.757 95.4893Z"
            fill="#CECDCC"
          />
          <path
            d="M109.938 102.08C109.937 102.08 109.937 102.08 109.937 102.078C109.35 100.111 108.595 97.8597 107.753 95.4905C107.141 93.5714 106.507 91.6064 105.875 89.6806C106.032 88.5968 106.168 87.5518 106.286 86.5452L106.503 87.0225C109.645 93.0161 109.979 102.08 109.938 102.08Z"
            fill="#254B96"
          />
          <path
            d="M77.3828 137.184L80.9561 138.679L84.7698 130.558L81.1964 129.064L77.3828 137.184Z"
            fill="#F7B5BF"
          />
          <path
            d="M84.2497 139.974C84.3044 139.996 84.3523 140.033 84.3881 140.08C84.4131 140.114 84.4175 140.159 84.4002 140.197C84.3628 140.301 84.2778 140.38 84.1712 140.412C83.8672 140.493 83.2796 140.237 82.5751 139.725C83.1479 139.713 83.7183 139.798 84.2625 139.977L84.2497 139.974ZM83.2824 140.378C83.5662 140.554 83.9011 140.629 84.2332 140.591C84.3958 140.546 84.5258 140.426 84.581 140.268C84.6232 140.174 84.6131 140.065 84.5544 139.981C84.2485 139.534 82.5055 139.539 82.3102 139.541C82.2712 139.543 82.237 139.566 82.2225 139.602C82.2116 139.639 82.2249 139.679 82.2563 139.702C82.5767 139.958 82.9205 140.184 83.2824 140.378Z"
            fill="#4870C0"
          />
          <path
            d="M83.7952 138.733L83.8508 138.745C83.9916 138.838 83.9707 138.899 83.9623 138.92C83.8842 139.178 83.0304 139.481 82.4837 139.51C82.7132 139.133 83.0574 138.838 83.4667 138.669C83.5835 138.648 83.7038 138.672 83.8041 138.735L83.7952 138.733ZM82.2692 139.718L82.3034 139.725C82.8126 139.75 84.0093 139.418 84.1422 138.995C84.1623 138.894 84.1692 138.749 83.953 138.611C83.8004 138.504 83.6096 138.466 83.4281 138.508C82.811 138.646 82.2571 139.536 82.2322 139.571L82.2148 139.66L82.2692 139.718Z"
            fill="#4870C0"
          />
          <path
            d="M81.6028 137.039L78.3781 135.694C78.236 135.63 78.0677 135.683 77.9888 135.817L75.1698 139.823C75.004 140.127 75.1183 140.507 75.4246 140.671L75.4899 140.702C76.8963 141.271 77.6052 141.478 79.3727 142.231C80.4555 142.693 83.5539 144.606 85.1483 144.948C86.7432 145.29 87.167 143.74 86.5338 143.456C84.4918 142.551 82.7782 140.155 82.3322 138.079C82.2199 137.867 81.827 137.128 81.6028 137.039Z"
            fill="#1D2A30"
          />
          <path
            d="M82.8601 134.791L82.7969 134.763L83.2183 133.865L83.3009 133.909L82.8601 134.791Z"
            fill="#CECDCC"
          />
          <path
            d="M82.7946 134.763L79.3203 133.216L79.8774 132.099L83.2161 133.865L82.7946 134.763Z"
            fill="#C48F94"
          />
          <path
            d="M85.6688 135.162L78.552 131.397C78.552 131.397 77.187 126.369 78.552 123.162C81.1777 116.989 88.0104 107.914 88.0563 107.742C89.8793 100.638 93.0775 81.1809 94.1696 74.024C94.7762 70.0577 95.1324 69.2024 95.1324 69.2024L95.8836 69.4465L106.773 69.4681C106.773 69.4681 108.828 85.8331 100.954 111.171C98.9952 117.475 95.7129 122.717 90.3129 129.808C88.2624 132.501 85.6688 135.162 85.6688 135.162Z"
            fill="#4870C0"
          />
          <path
            d="M85.6688 135.162L83.2153 133.864L79.8767 132.098L78.5519 131.397C78.5519 131.397 77.9445 129.16 77.9453 126.719C77.9457 125.5 78.0975 124.23 78.5519 123.162C81.1777 116.989 88.0103 107.914 88.0562 107.742C89.8793 100.638 93.0774 81.1809 94.1695 74.024C94.7761 70.0577 95.1324 69.2024 95.1324 69.2024L95.8835 69.4465L106.773 69.4681C106.773 69.4681 107.014 71.3907 107.014 74.9388C107.014 77.801 106.858 81.7222 106.29 86.5441C106.172 87.5508 106.036 88.5958 105.879 89.6796C105.855 89.8457 105.831 90.0139 105.806 90.1817C105.267 93.8073 104.503 97.8443 103.431 102.243C102.74 105.074 101.922 108.055 100.954 111.171C100.947 111.194 100.94 111.216 100.933 111.239C100.299 113.267 99.5269 115.187 98.591 117.094C97.5154 119.286 96.2225 121.464 94.6727 123.772C93.7412 125.16 92.7172 126.595 91.5909 128.11C91.1787 128.665 90.7528 129.23 90.3128 129.808C90.0588 130.142 89.7972 130.474 89.5323 130.802C89.5057 130.835 89.4784 130.868 89.4518 130.902C87.6034 133.177 85.6688 135.162 85.6688 135.162Z"
            fill="#4164E3"
          />
          <path
            d="M116.422 56.0959C116.501 54.8823 117.312 53.3188 118.012 52.5966C118.237 52.3653 119.086 52.0142 119.567 51.7034C121.931 50.1638 126.664 48.2436 126.664 48.2436L128.124 49.5071C128.124 49.5071 125.241 52.2722 123.527 53.5984C123.189 53.8585 122.799 54.1753 122.388 54.5092C121.642 55.1268 118.131 57.4253 117.461 58.001L116.422 56.0959Z"
            fill="#F7B5BF"
          />
          <path
            d="M130.826 47.5292L128.125 49.5098L126.609 48.4024C126.609 48.4024 127.228 47.6207 127.863 47.0151C128.142 46.749 128.293 46.3823 128.296 45.9988C128.302 45.4084 128.391 44.7233 128.715 44.2208L128.734 44.1892C129.32 43.3136 130.689 43.5769 130.966 44.5895L131.356 46.0188C131.509 46.5825 131.299 47.1821 130.826 47.5292Z"
            fill="#F7B5BF"
          />
          <path
            d="M117.282 56.6323L116.57 57.2803C116.348 57.1037 115.996 56.8209 115.553 56.4558C112.083 53.5972 103.384 46.6632 106.852 44.6838C109.825 42.9877 112.981 48.1784 114.556 49.7375C114.876 50.0595 115.755 51.0645 116.463 52.3249C117.203 53.6483 117.753 55.2502 117.282 56.6323Z"
            fill="#1D2A30"
          />
          <path
            d="M116.464 51.7037C115.233 52.597 114.182 53.7338 113.391 55.0277C113.961 56.904 115.398 58.5362 117.209 59.3164C118.202 57.0303 118.664 54.5723 118.468 52.0904C117.84 51.9562 117.092 51.838 116.464 51.7037Z"
            fill="#1D2A30"
          />
          <path
            d="M97.3576 44.2798C96.1162 44.6756 94.6952 44.3585 93.8982 45.3827C93.1016 46.4069 92.8621 47.7587 92.8633 49.0526C92.8653 50.8522 93.2799 52.6231 93.6921 54.3755C94.1921 56.4999 94.692 58.6247 95.192 60.7494C95.5337 62.2015 95.1742 68.9549 95.5385 69.0684C95.5385 69.0684 106.918 68.8471 109.771 68.45C109.771 68.45 110.019 61.5076 110.248 59.1436C110.299 58.6187 111.101 56.3912 111.196 55.832C111.64 53.1943 110.769 51.3344 109.848 48.8213C109.848 48.8213 107.833 44.7951 106.85 44.6852C105.099 44.4887 100.817 43.1764 97.3576 44.2798Z"
            fill="#1D2A30"
          />
          <path
            d="M96.8834 47.6108C96.8432 47.3764 94.8237 43.3277 92.8879 46.158C90.1941 50.0967 90.0121 55.0422 90.0121 55.0422C90.0121 55.0422 88.3565 59.8509 89.5102 60.9007C90.6639 61.9509 91.9081 62.6269 92.7144 62.0316C93.5203 61.436 94.0431 60.246 94.0431 60.246C94.0431 60.246 97.5911 51.7314 96.8834 47.6108Z"
            fill="#1D2A30"
          />
          <path
            d="M96.7516 42.7779C95.9015 43.4359 96.0134 44.9602 96.9505 45.4891C96.715 46.3056 96.9903 47.2452 97.6304 47.8088C98.2704 48.3729 99.2429 48.5335 100.032 48.2047C99.691 48.8111 100.075 49.6124 100.665 49.9879C101.254 50.3634 101.981 50.4314 102.675 50.524C103.369 50.6163 104.102 50.7645 104.606 51.2471C105.322 50.2232 106.04 49.199 106.757 48.1752C107.036 47.7761 107.326 47.3487 107.348 46.8633C107.369 46.378 106.997 45.8431 106.51 45.8786C107.005 45.3653 107.016 44.4653 106.531 43.9412C106.047 43.4171 105.142 43.35 104.584 43.797C104.684 43.3863 104.442 42.9505 104.093 42.7092C103.744 42.468 103.309 42.3857 102.885 42.3445L96.7516 42.7779Z"
            fill="#1D2A30"
          />
          <path
            d="M98.0449 37.5649C98.6045 39.6034 99.2839 43.3619 97.9258 44.8476C97.9258 44.8476 101.769 46.3747 104.5 49.4395C105.772 48.2135 105.64 46.8365 105.25 45.8295C104.948 45.0493 104.3 44.4705 103.525 44.1437C102.029 43.5125 102.016 42.0513 102.265 40.6504L98.0449 37.5649Z"
            fill="#F7B5BF"
          />
          <path
            d="M99.4396 42.1592C99.2094 41.8672 99.0065 41.359 98.8789 41.0355L99.3004 41.1493C99.4167 41.2064 99.5379 41.262 99.6639 41.3167C99.9408 41.4369 100.218 41.5316 100.493 41.6023C100.168 41.7693 99.8905 41.9079 99.8905 41.9079L99.9021 41.9239L99.905 41.9271L99.9034 41.9275L99.4396 42.1592Z"
            fill="#C48F94"
          />
          <path
            d="M95.2966 35.8289C96.7928 38.9623 97.3588 40.3193 99.6621 41.3168C103.132 42.8243 106.673 40.3077 106.148 36.7936C105.677 33.6338 103.308 29.0395 99.625 29.0231C96.9933 28.9976 94.8389 31.0936 94.8127 33.7057C94.8055 34.4411 94.9709 35.1681 95.2966 35.8289Z"
            fill="#F7B5BF"
          />
          <path
            d="M96.9408 29.8451C95.8504 29.3397 94.4958 29.7516 93.5881 30.5441C92.6643 31.3511 92.102 32.4788 91.5626 33.5765C91.2695 34.1729 90.9741 34.7773 90.8384 35.4272C90.7023 36.0768 90.7418 36.7878 91.0876 37.3559C91.4269 37.9127 92.0581 38.2782 92.7106 38.3158C93.0858 38.3374 93.5249 38.6066 93.6465 38.9597C93.7592 39.2877 93.7057 39.6428 93.6525 39.9836C93.6014 40.3135 93.5527 40.6579 93.6574 40.975C93.8308 41.5023 94.3992 41.8223 94.9559 41.8759C95.5126 41.9294 96.0649 41.7696 96.6007 41.6114C96.9404 41.5111 97.2826 41.5691 97.5463 41.8039C97.6123 41.8627 97.6666 41.933 97.7073 42.0105C97.8739 42.3249 98.3566 42.2753 98.4954 41.9478C98.9825 40.7993 98.2736 38.9629 97.2178 37.5616C96.6575 36.8178 96.6876 37.0071 96.4679 36.1047C96.2847 35.3533 96.5617 34.57 96.901 33.8741C97.353 32.9461 97.9347 32.041 97.7552 30.9332C97.6791 30.4647 97.374 30.0456 96.9408 29.8451Z"
            fill="#1D2A30"
          />
          <path
            d="M95.3969 39.0343C95.8937 39.5584 96.5788 39.8656 97.3033 39.8883C98.2646 39.9091 98.5085 38.9991 98.0444 38.2229C97.6254 37.5231 96.6206 36.6718 95.7504 37.0102C94.8801 37.3481 94.7915 38.3807 95.3969 39.0343Z"
            fill="#F7B5BF"
          />
          <path
            d="M101.316 35.2719C101.427 35.5464 101.647 35.6914 101.821 35.6211C101.994 35.5504 102.037 35.2899 101.941 35.0235C101.845 34.7574 101.611 34.6068 101.436 34.6747C101.261 34.7426 101.211 35.0111 101.316 35.2719Z"
            fill="#1D2A30"
          />
          <path
            d="M104.262 34.0138C104.37 34.2891 104.592 34.4333 104.763 34.3634C104.935 34.2935 104.98 34.0322 104.884 33.7662C104.788 33.5001 104.554 33.3495 104.382 33.4166C104.21 33.4833 104.154 33.7534 104.262 34.0138Z"
            fill="#1D2A30"
          />
          <path
            d="M104.305 33.464L104.863 33.0299C104.863 33.0299 104.743 33.6475 104.305 33.464Z"
            fill="#1D2A30"
          />
          <path
            d="M103.5 34.6C104.184 35.2703 104.699 35.393 105.439 35.8531C105.418 36.5055 104.799 36.6553 104.799 36.6553L103.5 34.6Z"
            fill="#F46878"
          />
          <path
            d="M104.486 37.9348C104.613 37.8872 104.737 37.8293 104.855 37.7618C104.894 37.741 104.908 37.6935 104.887 37.6551L104.885 37.6511C104.862 37.6132 104.814 37.5984 104.774 37.6176C104.149 37.9771 103.389 38.017 102.73 37.7246C102.688 37.7027 102.637 37.7182 102.616 37.759C102.593 37.8001 102.609 37.8509 102.65 37.8724C103.229 38.1361 103.89 38.1589 104.486 37.9348Z"
            fill="#1D2A30"
          />
          <path
            d="M101.208 33.0966C101.204 33.1713 101.153 33.2348 101.08 33.2548C100.308 33.4821 99.9654 34.4548 99.9634 34.4624C99.9332 34.5527 99.8346 34.6014 99.7436 34.5711C99.6526 34.5411 99.6035 34.4432 99.6341 34.3529C99.6639 34.3162 100.037 33.2013 100.979 32.922C101.07 32.8961 101.166 32.948 101.194 33.0383L101.208 33.0966Z"
            fill="#1D2A30"
          />
          <path
            d="M104.766 32.6265C104.702 32.6656 104.62 32.66 104.562 32.6117C103.933 32.112 102.933 32.3864 102.926 32.3896C102.833 32.4164 102.737 32.3636 102.71 32.2722C102.683 32.1811 102.736 32.0852 102.828 32.0584C102.876 32.062 104.012 31.7313 104.78 32.3397C104.853 32.4 104.865 32.5078 104.806 32.5821L104.766 32.6265Z"
            fill="#1D2A30"
          />
          <path
            d="M101.367 34.7211L101.926 34.2898C101.926 34.2898 101.799 34.9066 101.367 34.7211Z"
            fill="#1D2A30"
          />
          <path
            d="M97.1793 29.3228C96.2998 29.3927 95.4653 29.8888 94.9887 30.6255C94.6687 31.1196 94.556 31.871 95.0294 32.2237C95.2508 32.3887 95.5426 32.4183 95.8184 32.4422C97.0441 32.5489 98.5544 31.6097 98.5544 31.6097C98.0818 29.6248 102.279 28.0884 104.348 31.1635C104.956 32.0671 104.792 32.7235 105.802 33.1409C106.278 33.3375 106.905 33.2831 107.21 33.6954C107.715 34.3801 106.744 35.5389 107.361 36.1265C107.783 36.5284 108.741 36.3746 108.799 36.9526C108.827 37.2243 108.648 37.617 108.911 37.6964C109.057 37.7404 109.191 37.6082 109.285 37.4895C109.513 37.2027 109.747 36.9027 109.825 36.546C109.903 36.1897 109.775 35.7598 109.441 35.6088C109.183 35.4926 108.503 35.6224 108.549 35.8988C108.605 36.232 108.317 34.5986 108.446 33.9814C108.559 33.4441 109.075 32.9783 108.919 32.4522C108.751 31.8906 108.079 31.6665 107.496 31.5802C106.912 31.4947 106.25 31.4244 105.891 30.9594C105.491 30.4397 105.673 29.6983 105.544 29.0568C105.381 28.241 104.695 27.6055 103.925 27.2747C101.592 26.2709 97.9828 26.4131 97.1793 29.3228Z"
            fill="#1D2A30"
          />
          <path
            d="M102.483 56.8527C100.688 57.5497 98.6622 56.6717 97.959 54.8909C97.2553 53.1104 98.1401 51.1019 99.935 50.4049C101.73 49.7078 103.754 50.5858 104.458 52.3662C105.161 54.1467 104.277 56.1556 102.483 56.8527ZM103.813 39.9807L95.7644 43.9934C93.1181 45.3124 91.9209 48.4143 93.0022 51.1507L96.8838 60.9752C97.965 63.7111 100.968 65.1812 103.814 64.3671L112.47 61.89C115.713 60.962 117.449 57.4686 116.217 54.35L111.729 42.9903C110.496 39.8717 106.829 38.4771 103.813 39.9807Z"
            fill="#4870C0"
          />
          <path
            d="M102.483 56.8527C100.688 57.5497 98.6622 56.6717 97.959 54.8909C97.2553 53.1104 98.1401 51.1019 99.935 50.4049C101.73 49.7078 103.754 50.5858 104.458 52.3662C105.161 54.1467 104.277 56.1556 102.483 56.8527ZM103.813 39.9807L95.7644 43.9934C93.1181 45.3124 91.9209 48.4143 93.0022 51.1507L96.8838 60.9752C97.965 63.7111 100.968 65.1812 103.814 64.3671L112.47 61.89C115.713 60.962 117.449 57.4686 116.217 54.35L111.729 42.9903C110.496 39.8717 106.829 38.4771 103.813 39.9807Z"
            fill="#4870C0"
          />
          <path
            d="M110.023 62.5898C110.023 62.5894 110.023 62.5894 110.023 62.589L112.466 61.89C112.646 61.8384 112.822 61.7789 112.993 61.7118C112.822 61.7789 112.648 61.8384 112.468 61.8904L110.023 62.5898Z"
            fill="white"
          />
          <path
            d="M102.226 64.5918C99.9203 64.5918 97.7651 63.2044 96.8828 60.9762L95.2734 56.9036C95.2738 56.9028 95.2742 56.902 95.2746 56.9008L96.8844 60.9758C97.7643 63.2028 99.9187 64.5914 102.224 64.5914C102.751 64.5914 103.286 64.5191 103.815 64.3677L110.028 62.5897C110.028 62.5901 110.028 62.5901 110.028 62.5905L103.815 64.3685C103.286 64.5195 102.752 64.5918 102.226 64.5918Z"
            fill="#304047"
          />
          <path
            d="M95.2697 56.9033L92.9974 51.1518C92.5454 50.0061 92.4922 48.7969 92.778 47.6812C92.6617 48.1354 92.6021 48.6052 92.6021 49.0801C92.6029 49.7712 92.731 50.4723 92.999 51.151L95.271 56.9005C95.2705 56.9017 95.2701 56.9025 95.2697 56.9033Z"
            fill="#304047"
          />
          <path
            d="M115.479 52.498L114.742 50.6325L114.808 50.7995L115.479 52.498Z"
            fill="#304047"
          />
          <path
            d="M116.613 56.3262C116.601 55.6686 116.473 55.0011 116.216 54.3496L115.484 52.4981L115.57 52.7138H115.57L116.217 54.3508C116.474 55.0023 116.601 55.6694 116.613 56.3262Z"
            fill="#304047"
          />
          <path
            d="M98.4414 42.6592L98.7007 42.5292C98.7007 42.5296 98.7007 42.53 98.7007 42.53L98.4422 42.6592H98.4414Z"
            fill="white"
          />
          <path
            d="M97.4766 43.1396L98.4406 42.6583H98.4414L97.4766 43.1396Z"
            fill="#304047"
          />
          <path
            d="M98.6992 42.5293C98.6992 42.5293 98.6992 42.5289 98.6992 42.5285L99.4403 42.158C99.4403 42.1584 99.4407 42.1584 99.4407 42.1588L98.6992 42.5293Z"
            fill="#F8BDC7"
          />
          <path
            d="M99.4418 42.1602C99.4418 42.1598 99.4414 42.1598 99.4414 42.1594L99.9045 41.9274L99.9061 41.927L99.9065 41.9278L99.4418 42.1602Z"
            fill="#CC9BA0"
          />
          <path
            d="M110.349 40.9473C109.282 39.9382 107.854 39.373 106.382 39.373C106.171 39.373 105.959 39.3845 105.746 39.4081L105.746 39.4077C105.959 39.3837 106.172 39.3722 106.384 39.3722C107.855 39.3722 109.282 39.9374 110.349 40.9473Z"
            fill="white"
          />
          <path
            d="M103.965 39.9082C104.544 39.6398 105.144 39.476 105.746 39.4089L105.745 39.4093C105.144 39.4764 104.544 39.6402 103.965 39.9082Z"
            fill="#F8BDC7"
          />
          <path
            d="M102.224 64.5908C99.9183 64.5908 97.764 63.2023 96.884 60.9752L95.2743 56.9003L93.0024 51.1507C92.7343 50.472 92.6063 49.771 92.6055 49.0799C92.6055 48.6049 92.665 48.1351 92.7814 47.6809C93.1135 46.3815 93.9045 45.209 95.0581 44.4117L95.5114 45.0077C94.1581 46.0251 93.384 47.6122 93.3852 49.262C93.3856 49.9104 93.5055 50.5679 93.7571 51.2046L97.3977 60.418C98.2233 62.5072 100.244 63.8095 102.406 63.8095C102.9 63.8095 103.401 63.7415 103.898 63.5997L108.623 62.2471L109.084 62.8523C109.084 62.8523 113.297 61.5804 113.388 61.5369C113.388 61.5197 113.228 61.2992 112.942 60.9173C113.284 60.7475 113.601 60.5442 113.892 60.3129L114.366 60.9361C114.793 60.6141 115.165 60.2374 115.478 59.8172C115.347 59.6426 115.177 59.4173 114.973 59.1485C115.571 58.274 115.903 57.2314 115.903 56.1544C115.903 55.5069 115.784 54.8474 115.53 54.2047L113.062 47.959L114.126 50.6086L114.21 50.6446L114.681 50.4608L114.749 50.633L116.217 54.3501C116.475 55.0016 116.603 55.6691 116.614 56.3266C116.614 56.327 116.614 56.3274 116.614 56.3278C116.614 56.3298 116.614 56.3314 116.614 56.333C116.614 56.3354 116.614 56.3374 116.614 56.3394C116.614 56.3406 116.614 56.3414 116.614 56.3422C116.633 57.6045 116.224 58.8269 115.479 59.8212C115.166 60.2414 114.794 60.6181 114.367 60.9401C113.956 61.2537 113.497 61.5149 112.996 61.7119C112.826 61.779 112.65 61.8385 112.47 61.89L110.027 62.5891L103.814 64.3671C103.285 64.5185 102.751 64.5908 102.224 64.5908ZM113.057 47.9462L112.412 46.3136L112.815 47.3198L113.356 47.1097L113.578 47.6729L113.093 47.8623L113.057 47.9462ZM111.989 45.2422L111.321 43.5504C110.483 41.4297 108.442 40.1586 106.306 40.1586C105.496 40.1586 104.673 40.3411 103.896 40.7286L101.85 41.7488C101.659 41.4656 101.531 41.2603 101.477 41.1464L103.814 39.9804C103.864 39.9552 103.915 39.9313 103.965 39.9077C104.748 39.545 105.572 39.3736 106.382 39.3736C107.853 39.3736 109.281 39.9388 110.349 40.9479C110.935 41.502 111.412 42.1898 111.728 42.992L112.534 45.0305L111.989 45.2422ZM96.3285 43.713L97.4766 43.1402L99.9071 41.9282L100.342 42.5002L99.4095 42.9652C99.1938 42.6416 99.0706 42.4323 99.0613 42.3636C98.8198 42.5142 97.4174 43.1921 96.3285 43.713Z"
            fill="#2846B1"
          />
          <path
            d="M101.961 57.0098C102.134 56.9714 102.307 56.9191 102.477 56.8528C103.926 56.2891 104.78 54.875 104.689 53.4134C104.694 53.4845 104.696 53.5552 104.696 53.6255C104.698 55.0096 103.857 56.3179 102.479 56.8528C102.308 56.9195 102.135 56.9714 101.961 57.0098Z"
            fill="#304047"
          />
          <path
            d="M98.8218 56.1582C98.4527 55.8163 98.1528 55.3892 97.9563 54.8915C97.9551 54.8887 97.9543 54.8863 97.9531 54.8835C97.9539 54.8855 97.9547 54.8879 97.9555 54.8899C98.1524 55.388 98.4523 55.8159 98.8218 56.1582Z"
            fill="#304047"
          />
          <path
            d="M98.7266 51.1895C99.0587 50.8567 99.4648 50.5863 99.9326 50.4045C100.181 50.3078 100.434 50.2415 100.687 50.2036C100.435 50.2419 100.182 50.3082 99.9342 50.4049C99.4656 50.5863 99.0591 50.8567 98.7266 51.1895Z"
            fill="#304047"
          />
          <path
            d="M97.9569 54.891C97.2533 53.1106 98.1381 51.102 99.933 50.405C101.727 49.7079 103.752 50.5859 104.456 52.3664C105.159 54.1468 104.275 56.1557 102.481 56.8528C100.686 57.5499 98.6601 56.6718 97.9569 54.891ZM103.894 40.7287L96.3452 44.4916C93.8635 45.7292 92.7409 48.6381 93.7548 51.2047L97.3954 60.418C98.4094 62.9842 101.226 64.3632 103.896 63.5998L112.013 61.2765C115.055 60.4061 116.684 57.1296 115.528 54.2047L111.318 43.5505C110.163 40.6264 106.723 39.3181 103.894 40.7287Z"
            fill="#4870C0"
          />
          <path
            d="M102.404 63.8096C100.241 63.8096 98.2209 62.5073 97.3953 60.4181L93.7548 51.2048C93.5032 50.568 93.3832 49.9105 93.3828 49.2621C93.3816 47.6123 94.1557 46.0253 95.509 45.0078L99.1576 49.8046C99.3359 49.7024 99.5219 49.6121 99.7195 49.5378C100.244 49.3336 100.784 49.237 101.315 49.237C103.064 49.237 104.717 50.2856 105.393 51.9997C105.549 52.392 105.642 52.793 105.679 53.1925C105.642 52.7938 105.549 52.3936 105.394 52.0021C104.717 50.2884 103.064 49.241 101.315 49.241C100.784 49.241 100.244 49.3376 99.7199 49.541C97.4686 50.4154 96.3588 52.9352 97.2415 55.1691C97.9186 56.8828 99.5714 57.9298 101.321 57.9298C101.852 57.9298 102.392 57.8335 102.916 57.6298C103.484 57.4093 103.979 57.0837 104.388 56.6847L108.621 62.2472L103.895 63.5998C103.399 63.7417 102.898 63.8096 102.404 63.8096Z"
            fill="#4164E3"
          />
          <path
            d="M112.939 60.918C110.769 58.0246 101.343 45.8716 99.4062 42.9659L100.339 42.5009L113.888 60.3136C113.598 60.5449 113.28 60.7482 112.939 60.918Z"
            fill="#4164E3"
          />
          <path
            d="M114.975 59.1484C112.307 55.6327 103.805 44.6449 101.852 41.7488L103.898 40.7286C104.675 40.3411 105.498 40.1585 106.308 40.1585C108.444 40.1585 110.484 41.4296 111.322 43.5504L111.991 45.2421L111.986 45.2437L112.414 46.3135L113.059 47.9461L113.064 47.9589L115.532 54.2046C115.786 54.8474 115.905 55.5069 115.905 56.1544C115.904 57.2314 115.572 58.274 114.975 59.1484Z"
            fill="#4164E3"
          />
          <path
            d="M141.403 37.1754L141.173 37.5936L141.045 37.8253L140.681 38.4856L140.833 40.1758C140.84 40.2481 140.831 40.3196 140.81 40.3855C140.761 40.5317 140.649 40.6535 140.499 40.7122L137.317 41.9482C137.166 42.0065 137.002 41.9933 136.865 41.9178C136.821 41.8939 136.781 41.8635 136.745 41.8268L134.946 40.012L134.942 40.0072L132.384 41.0007L132.754 41.9386L130.197 42.9325L130.807 44.4768L128.924 45.2087C128.769 45.2686 128.6 45.2578 128.456 45.1843C128.41 45.1611 128.366 45.13 128.326 45.0936L127.241 44.0806L124.684 45.074L125.294 46.6188L122.605 47.6634L123.218 49.2145C123.318 49.4678 123.192 49.7538 122.936 49.8529L115.571 52.7139L112.375 44.6254L139.017 34.276L139.434 34.4881L140.785 35.1764C141.521 35.5515 141.801 36.4555 141.403 37.1754Z"
            fill="#4870C0"
          />
          <path
            d="M115.571 52.7139L114.681 50.4605L124.921 46.4618L124.957 46.3779L124.367 44.8907L124.403 44.8072L127.193 43.7174L127.261 43.7298L128.545 44.9047C128.577 44.9342 128.612 44.9598 128.648 44.981L128.703 44.9842L130.461 44.2975L130.497 44.214L129.92 42.7623L129.957 42.6788L132.352 41.7433L132.388 41.6598L132.054 40.8189L132.09 40.7354L134.899 39.6389L134.969 39.6533L136.947 41.6258L137.04 41.7005L137.098 41.7053L140.557 40.3539L140.595 40.3116C140.606 40.2692 140.612 40.2257 140.612 40.181C140.612 40.165 140.611 40.1486 140.609 40.1326L140.456 38.4592L140.461 38.4269L140.736 37.8129L141.087 37.0475C141.091 37.0383 141.093 37.0291 141.093 37.0204C141.093 36.9856 141.063 36.9561 141.028 36.9561C141.02 36.9561 141.012 36.9576 141.004 36.9608L113.579 47.6726L113.356 47.1093L141.298 36.2546C141.298 36.2514 141.299 36.2486 141.299 36.2458C141.298 35.8831 141.004 35.6414 140.493 35.3817L139.142 34.6935L112.535 45.0297L112.375 44.6254L139.017 34.276L139.434 34.4881L140.785 35.1764C141.294 35.4357 141.585 35.9478 141.584 36.4771C141.584 36.7136 141.526 36.9533 141.403 37.1754L141.173 37.5936L141.045 37.8253L140.681 38.4856L140.833 40.1758C140.835 40.1917 140.835 40.2073 140.835 40.2233C140.835 40.2792 140.826 40.3339 140.81 40.3855C140.761 40.5317 140.649 40.6535 140.499 40.7122L137.317 41.9482C137.254 41.9726 137.188 41.9846 137.123 41.9846C137.033 41.9846 136.945 41.9618 136.865 41.9178C136.821 41.8939 136.781 41.8635 136.745 41.8268L134.946 40.012L134.942 40.0072L132.384 41.0007L132.754 41.9386L130.197 42.9325L130.807 44.4768L128.924 45.2087C128.857 45.2346 128.786 45.2474 128.717 45.2474C128.627 45.2474 128.537 45.2258 128.456 45.1843C128.41 45.1611 128.366 45.13 128.326 45.0936L127.241 44.0806L124.684 45.074L125.294 46.6188L122.605 47.6634L123.218 49.2145C123.241 49.274 123.252 49.3352 123.252 49.3951C123.252 49.5916 123.132 49.777 122.936 49.8529L115.571 52.7139Z"
            fill="#4164E3"
          />
          <path
            d="M141.298 36.2554L112.815 47.3203L111.984 45.2443L139.142 34.6943L140.493 35.3826C141.008 35.6443 141.303 35.8875 141.298 36.2554Z"
            fill="#4870C0"
          />
          <path
            d="M112.815 47.3203L112.412 46.3141L111.984 45.2443L139.142 34.6943L140.493 35.3826C141.004 35.6423 141.298 35.8839 141.299 36.2467C141.299 36.2495 141.298 36.2523 141.298 36.2554L113.356 47.1102L112.815 47.3203Z"
            fill="#2846B1"
          />
          <path
            d="M140.733 37.8132L140.458 38.4272L140.453 38.4596L140.607 40.1329C140.613 40.1941 140.607 40.2544 140.593 40.3119L140.554 40.3542L137.095 41.7056L137.038 41.7008L136.944 41.6261L134.966 39.6536L134.896 39.6392L132.088 40.7357L132.052 40.8192L132.386 41.6601L132.349 41.7436L129.954 42.6791L129.918 42.7626L130.494 44.2143L130.458 44.2978L128.701 44.9845L128.646 44.9813C128.609 44.9601 128.574 44.9345 128.542 44.905L127.258 43.7301L127.19 43.7178L124.401 44.8075L124.364 44.891L124.955 46.3782L124.918 46.4621L114.208 50.6445L114.123 50.6086L113.055 47.9461L113.091 47.8622L141.001 36.9611C141.055 36.94 141.109 36.9951 141.084 37.0478L140.733 37.8132Z"
            fill="#4870C0"
          />
          <path
            d="M114.208 50.6445L114.123 50.6086L113.06 47.9589L113.055 47.9461L113.091 47.8622L141.001 36.9612C141.01 36.958 141.018 36.9564 141.025 36.9564C141.061 36.9564 141.09 36.9859 141.09 37.0207C141.091 37.0295 141.089 37.0387 141.084 37.0478L140.733 37.8132L140.458 38.4272L140.453 38.4596L140.607 40.1329C140.608 40.1489 140.609 40.1653 140.609 40.1813C140.609 40.226 140.603 40.2696 140.593 40.3119L140.554 40.3542L137.095 41.7056L137.038 41.7008L136.944 41.6261L134.966 39.6536L134.896 39.6392L132.088 40.7357L132.052 40.8192L132.386 41.6601L132.349 41.7436L129.954 42.6791L129.918 42.7626L130.494 44.2143L130.458 44.2978L128.701 44.9845L128.646 44.9813C128.609 44.9601 128.574 44.9345 128.542 44.905L127.258 43.7301L127.19 43.7178L124.401 44.8075L124.364 44.891L124.955 46.3782L124.918 46.4621L114.678 50.4608L114.208 50.6445Z"
            fill="#2846B1"
          />
          <path
            d="M101.32 57.9297C99.5707 57.9297 97.9179 56.8827 97.2408 55.169C96.358 52.9351 97.4678 50.4153 99.7192 49.5409C100.243 49.3375 100.783 49.2409 101.314 49.2409C103.063 49.2409 104.716 50.2883 105.393 52.002C105.548 52.3935 105.641 52.7937 105.678 53.1924C105.798 54.4927 105.313 55.7758 104.384 56.6798L104.387 56.6845C103.978 57.0836 103.483 57.4092 102.915 57.6297C102.391 57.8334 101.851 57.9297 101.32 57.9297ZM97.7142 53.6318C97.7146 54.0508 97.7927 54.4771 97.9561 54.8909C98.4959 56.2571 99.8134 57.092 101.208 57.092C101.631 57.092 102.062 57.0149 102.48 56.8527C103.857 56.3178 104.698 55.0096 104.697 53.6254C104.696 53.2064 104.618 52.7801 104.455 52.3663C104.129 51.541 103.519 50.9094 102.779 50.5391C102.295 50.2963 101.755 50.1656 101.203 50.1656C101.139 50.1656 101.075 50.1676 101.011 50.1708C100.651 50.1908 100.287 50.2671 99.9322 50.4049C98.5543 50.9402 97.713 52.2477 97.7142 53.6318Z"
            fill="#4164E3"
          />
          <path
            d="M114.365 60.9355L113.891 60.3124C114.311 59.9772 114.675 59.5833 114.972 59.1479C115.176 59.4168 115.346 59.6421 115.477 59.8166C115.164 60.2369 114.792 60.6136 114.365 60.9355Z"
            fill="#6489CE"
          />
          <path
            d="M99.9051 41.9277L99.9023 41.9245L99.8906 41.9085C99.8906 41.9085 100.168 41.7695 100.494 41.6021C100.508 41.6057 100.522 41.6093 100.536 41.6129L99.9051 41.9277Z"
            fill="#CC9BA0"
          />
          <path
            d="M100.535 41.6133C100.521 41.6097 100.507 41.6061 100.492 41.6025C100.864 41.4115 101.298 41.1843 101.452 41.0836L101.472 41.1427C101.472 41.1435 101.473 41.1447 101.474 41.1459L101.019 41.3724L100.535 41.6133Z"
            fill="#F8BDC7"
          />
          <path
            d="M101.023 41.373L101.477 41.1462C101.477 41.1462 101.477 41.1462 101.477 41.1466H101.477L101.023 41.373Z"
            fill="#537BC6"
          />
          <path
            d="M99.9067 41.9277L99.9062 41.9269L100.537 41.6121C100.538 41.6121 100.538 41.6121 100.538 41.6121L99.9067 41.9277Z"
            fill="#D1A5A9"
          />
          <path
            d="M100.536 41.6133C100.536 41.6133 100.536 41.6133 100.535 41.6133L101.019 41.3721L100.536 41.6133Z"
            fill="#F8C5CD"
          />
          <path
            d="M100.341 42.5L99.9062 41.928L101.021 41.3723L101.475 41.1462H101.476C101.53 41.26 101.658 41.4654 101.849 41.7486L100.341 42.5Z"
            fill="#2846B1"
          />
          <path
            d="M113.893 60.3125L100.344 42.4998L101.851 41.7484C103.804 44.6446 112.307 55.6323 114.975 59.1481C114.677 59.5835 114.314 59.9773 113.893 60.3125Z"
            fill="#2846B1"
          />
          <path
            d="M109.085 62.8525L108.625 62.2473L112.017 61.2766C112.343 61.1836 112.652 61.0625 112.944 60.9175C113.23 61.2994 113.39 61.5199 113.39 61.5371C113.299 61.5806 109.085 62.8525 109.085 62.8525Z"
            fill="#6489CE"
          />
          <path
            d="M95.0597 44.4111L95.0078 44.3428C95.0078 44.3428 95.5287 44.0968 96.1985 43.7764C96.1985 43.7772 96.1981 43.778 96.1981 43.7788L95.767 43.9937C95.5182 44.1179 95.2823 44.2573 95.0597 44.4111Z"
            fill="white"
          />
          <path
            d="M96.1953 43.7793C96.1953 43.7785 96.1957 43.7777 96.1957 43.7769C96.2293 43.7609 96.2637 43.7445 96.2981 43.7277L96.1953 43.7793Z"
            fill="#304047"
          />
          <path
            d="M95.0594 44.4121L95.0586 44.4113C95.2812 44.2575 95.5171 44.1181 95.7658 43.9939L96.3004 43.7274C96.3101 43.7226 96.3197 43.7182 96.3298 43.7134L95.7679 43.9939C95.5187 44.1181 95.2824 44.2579 95.0594 44.4121Z"
            fill="#537BC6"
          />
          <path
            d="M95.5118 45.0078L95.0586 44.4118C95.2816 44.2576 95.5179 44.1178 95.7671 43.9936L96.329 43.7131C97.4178 43.1922 98.8203 42.5143 99.0618 42.3637C99.0711 42.4324 99.1942 42.6418 99.41 42.9653L96.3479 44.4917C96.0492 44.6407 95.7699 44.8141 95.5118 45.0078Z"
            fill="#2846B1"
          />
          <path
            d="M108.624 62.248L104.391 56.6855C105.319 55.7799 105.802 54.4952 105.682 53.1933C105.645 52.7938 105.551 52.3928 105.396 52.0005C104.719 50.2864 103.067 49.2378 101.317 49.2378C100.787 49.2378 100.247 49.3344 99.7222 49.5386C99.5246 49.6129 99.3386 49.7032 99.1603 49.8054L95.5117 45.0086C95.7697 44.8149 96.0491 44.6415 96.3478 44.4925L99.4099 42.9661C101.347 45.8719 110.772 58.0249 112.942 60.9182C112.651 61.0632 112.341 61.1843 112.016 61.2773L108.624 62.248Z"
            fill="#2846B1"
          />
          <path
            d="M104.39 56.6846L104.387 56.6798C105.316 55.7758 105.8 54.4927 105.681 53.1924C105.802 54.4943 105.318 55.779 104.39 56.6846Z"
            fill="#89A8DD"
          />
          <path
            d="M96.1445 31.5514C95.6744 32.1066 95.482 32.884 95.6406 33.5923C95.7992 34.3005 96.3039 34.9241 96.9673 35.2301C97.3111 35.3883 97.6891 35.4646 98.0292 35.6303C98.3693 35.7965 98.6849 36.0893 98.7208 36.4636C98.761 36.8771 98.4535 37.2634 98.4825 37.6776C98.509 38.0571 98.8081 38.3583 99.11 38.5928C99.4119 38.8273 99.7492 39.0486 99.9155 39.3913C100.082 39.7341 99.9739 40.2418 99.6039 40.3417C99.5258 40.4599 99.496 40.7431 99.5955 40.8446C99.6949 40.9461 99.8672 40.9676 99.9887 40.8933C100.557 40.5466 100.947 39.8927 100.951 39.2307C100.956 38.5688 100.537 37.9229 99.9288 37.652C99.8189 37.4315 99.9038 37.1527 99.9956 36.9242C100.18 36.4672 100.364 36.0098 100.548 35.5524C100.621 35.3727 100.557 35.0455 100.433 34.8961C100.309 34.7463 100.123 34.6652 99.9437 34.5889L98.7574 34.084C98.309 33.8935 96.9802 32.1254 98.5581 31.6093C98.352 31.1551 97.9954 31.0129 97.5019 30.9234C97.008 30.8339 96.4678 31.1703 96.1445 31.5514Z"
            fill="#1D2A30"
          />
          <path
            d="M98.2976 29.6484C98.2582 30.1134 98.2187 30.578 98.1797 31.043C98.5726 30.4022 99.3016 29.1603 99.2762 29.2086C98.967 29.3752 98.6072 29.4814 98.2976 29.6484Z"
            fill="#1D2A30"
          />
          <path
            d="M98.8281 30.4141C99.378 29.9095 99.9274 29.405 100.477 28.9009C100.053 28.7431 99.539 28.8605 99.2274 29.1865C99.2367 29.1521 98.9823 29.9275 98.8281 30.4141Z"
            fill="#1D2A30"
          />
          <path
            d="M95.4742 68.2055C93.3271 70.8492 94.0416 72.8769 91.0781 77.5575C94.8153 80.3062 98.9127 80.7616 104.006 80.3689C104.609 79.3103 104.913 78.2062 105.515 77.1476C106.378 78.2106 107.071 79.1046 107.934 80.1676C110.604 79.7529 113.774 79.0083 115.885 77.6589C114.021 75.5374 112.864 72.8877 111.67 70.5488C111.111 69.4523 111.345 68.9905 109.86 67.5524C105.131 67.7689 100.442 67.8835 95.7125 68.1001C95.8373 68.1065 95.3494 68.1987 95.4742 68.2055Z"
            fill="#1D2A30"
          />
          <path
            d="M96.0674 67.763L95.7708 68.997C95.7277 69.0941 95.8436 69.1859 96.0026 69.1772L109.038 68.6047C109.163 68.6067 109.262 68.5332 109.267 68.4581L109.337 67.2317C109.338 67.1494 109.229 67.0799 109.093 67.0891L96.2848 67.65C96.1975 67.6468 96.1145 67.6895 96.0674 67.763Z"
            fill="#4870C0"
          />
          <path
            d="M96.0674 67.763L95.7708 68.997C95.7277 69.0941 95.8436 69.1859 96.0026 69.1772L109.038 68.6047C109.163 68.6067 109.262 68.5332 109.267 68.4581L109.337 67.2317C109.338 67.1494 109.229 67.0799 109.093 67.0891L96.2848 67.65C96.1975 67.6468 96.1145 67.6895 96.0674 67.763Z"
            fill="#4164E3"
          />
          <path
            d="M98.9355 69.1799L98.5572 69.1963C98.4851 69.1951 98.4251 69.1639 98.43 69.1192L98.5318 67.5249C98.5322 67.4802 98.5974 67.4398 98.6731 67.4374L99.0515 67.4171C99.1235 67.4183 99.1835 67.4494 99.1787 67.4982L99.0772 69.088C99.0728 69.1332 99.0076 69.1771 98.9355 69.1799Z"
            fill="#1D2A30"
          />
          <path
            d="M108.35 68.7766L107.972 68.793C107.9 68.7918 107.84 68.761 107.844 68.7159L107.946 67.1256C107.947 67.0768 108.011 67.0365 108.083 67.0341L108.462 67.0177C108.534 67.0189 108.594 67.0497 108.589 67.0948L108.488 68.6851C108.487 68.7334 108.426 68.7738 108.35 68.7766Z"
            fill="#1D2A30"
          />
          <path
            d="M100.617 61.4217C100.642 61.5395 101.654 63.1378 102.448 63.0271L102.467 63.0243C102.699 62.992 102.929 63.085 103.072 63.2688C103.391 63.6807 103.583 63.9167 103.798 64.1872C104.147 64.6262 104.754 64.7672 105.265 64.5311C105.417 64.4616 105.567 64.3845 105.716 64.3062C106.207 64.0474 106.458 63.4885 106.324 62.9528C106.178 62.3648 105.95 61.7976 105.647 61.2719C105.543 61.0921 105.425 60.9107 105.245 60.8069C105.064 60.7026 103.318 60.1785 102.64 60.2001C101.934 60.2221 101.264 61.1396 100.617 61.4217Z"
            fill="#F7B5BF"
          />
          <path
            d="M102.66 60.1489C102.66 60.1489 91.9594 56.9332 89.6512 59.0744C88.2943 60.3331 88.9351 61.5215 89.6939 62.2877C90.2583 62.8573 91.4876 62.7175 92.2919 62.6804L100.721 61.8595L102.66 60.1489Z"
            fill="#F7B5BF"
          />
          <path
            d="M96.5114 58.6792C96.4531 58.1043 96.005 57.627 95.4842 57.3693C94.9633 57.1117 94.3732 57.0354 93.7959 56.9627C92.4514 56.7937 91.107 56.6247 89.7625 56.4557C89.0798 57.3122 88.5887 58.4894 88.61 59.5812C88.631 60.6733 89.0452 61.7539 89.7609 62.584C90.4042 61.3496 91.2527 60.0789 92.509 59.4657C93.7657 58.853 95.1335 58.4311 96.5114 58.6792Z"
            fill="#1D2A30"
          />
          <path
            d="M93.7539 39.2852V39.2456C93.7799 39.238 93.7967 39.2344 93.8055 39.2344C93.8247 39.2344 93.8035 39.2524 93.7539 39.2852Z"
            fill="#304047"
          />
          <path
            d="M120.34 22.0926L123.321 27.5781L135.485 17.3278C135.592 17.2375 135.468 17.0741 135.351 17.1508L123.948 24.6201L122.19 21.2174L120.34 22.0926Z"
            fill="#4164E3"
          />
          <path
            d="M139.529 22.1191H139.267C139.267 24.4692 138.026 26.6071 135.986 28.1719C133.947 29.735 131.114 30.7101 127.979 30.7097C125.572 30.7101 123.346 30.138 121.52 29.1589L121.408 29.0986L115.611 31.5993L119.257 27.5695L119.078 27.3953C117.576 25.9344 116.692 24.1061 116.691 22.1191C116.692 19.769 117.932 17.6311 119.972 16.0664C122.012 14.5033 124.845 13.5278 127.979 13.5282C131.114 13.5278 133.947 14.5033 135.986 16.0664C138.026 17.6311 139.267 19.769 139.267 22.1191H139.529H139.79C139.791 19.5805 138.446 17.2931 136.306 15.6553C134.165 14.0151 131.223 13.0093 127.979 13.0089C124.736 13.0093 121.794 14.0151 119.653 15.6553C117.513 17.2931 116.168 19.5805 116.168 22.1191C116.168 24.2631 117.127 26.2276 118.712 27.7664L118.895 27.581L118.7 27.4077L113.617 33.0254L121.5 29.6255L121.395 29.387L121.271 29.6155C123.179 30.6386 125.488 31.229 127.979 31.229C131.223 31.2286 134.165 30.2231 136.306 28.5829C138.446 26.9451 139.791 24.6577 139.79 22.1191H139.529Z"
            fill="#4164E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_1926_44801">
            <rect width="200" height="150" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const LogInBtnIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 15V2M12 2L15 5.5M12 2L9 5.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 22.0002H16C18.8284 22.0002 20.2426 22.0002 21.1213 21.1215C22 20.2429 22 18.8286 22 16.0002V15.0002C22 12.1718 22 10.7576 21.1213 9.8789C20.3529 9.11051 19.175 9.01406 17 9.00195M7 9.00195C4.82497 9.01406 3.64706 9.11051 2.87868 9.87889C2 10.7576 2 12.1718 2 15.0002V16.0002C2 18.8286 2 20.2429 2.87868 21.1215C3.17848 21.4213 3.54062 21.6188 4 21.749"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const AdminMenuWalliconLogo = ({
  backgroundColor = "#000000",
  textColor = "#ffffff",
}) => {
  return (
    <svg
      width="74"
      height="74"
      viewBox="0 0 74 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="74" height="74" rx="37" fill={backgroundColor} />
      <g clipPath="url(#clip0_10269_68072)">
        <path
          d="M18.6484 42.2844C18.5484 42.5844 18.4684 42.8344 18.3884 43.0844C17.8584 44.7044 17.3284 46.3244 16.7884 47.9444C16.7284 48.1144 16.7284 48.1144 16.5584 48.1144C16.1384 48.1144 15.7184 48.1144 15.2984 48.1144C15.1184 48.1144 15.1184 48.1144 15.0684 47.9344C14.5184 45.9944 13.9684 44.0544 13.4184 42.1144C13.2184 41.4144 13.0184 40.7144 12.8184 40.0244C12.8084 39.9844 12.7884 39.9444 12.8084 39.9044C12.8484 39.8744 12.8884 39.8844 12.9284 39.8844C13.3984 39.8844 13.8684 39.8844 14.3384 39.8844C14.4984 39.8844 14.4984 39.8844 14.5384 40.0544C14.9584 41.6744 15.3684 43.3044 15.7784 44.9244C15.8484 45.2044 15.9184 45.4844 15.9984 45.7844C16.0784 45.7144 16.0784 45.6244 16.1084 45.5444C16.7084 43.7344 17.2984 41.9244 17.8884 40.1144C17.8984 40.0744 17.9184 40.0344 17.9284 39.9944C17.9484 39.9244 17.9884 39.8944 18.0584 39.8944C18.4684 39.8944 18.8684 39.8944 19.2784 39.8944C19.3884 39.8944 19.4084 39.9544 19.4284 40.0344C19.5784 40.5044 19.7384 40.9744 19.8884 41.4444C20.3384 42.8244 20.7884 44.2044 21.2484 45.5844C21.2684 45.6444 21.2684 45.7244 21.3484 45.7744C21.5384 45.0344 21.7284 44.3044 21.9084 43.5844C22.2084 42.4144 22.5084 41.2444 22.7984 40.0744C22.8384 39.9044 22.8484 39.9044 23.0184 39.9044C23.4984 39.9044 23.9784 39.9044 24.4584 39.9044C24.4884 39.9744 24.4584 40.0244 24.4484 40.0744C23.6984 42.7044 22.9484 45.3444 22.1984 47.9744C22.1484 48.1544 22.1484 48.1544 21.9584 48.1544C21.5484 48.1544 21.1284 48.1544 20.7184 48.1544C20.5384 48.1544 20.5384 48.1544 20.4784 47.9744C19.8984 46.1144 19.3084 44.3044 18.7184 42.4844C18.6984 42.4344 18.6784 42.3844 18.6484 42.2844Z"
          fill={textColor}
        />
        <path
          d="M53.1199 42.6459C51.8699 41.6059 49.9699 41.6059 48.7299 42.6559C47.9799 43.2859 47.5899 44.0859 47.5699 45.0659C47.5599 45.5559 47.6799 46.0259 47.8999 46.4559C48.8799 48.3959 51.5399 48.8759 53.1899 47.4259C54.6599 46.1259 54.6299 43.9059 53.1199 42.6459ZM50.9499 46.9059C49.9599 46.9259 49.1199 46.1159 49.1099 45.0959C49.0999 44.0359 49.9099 43.2659 50.8799 43.2359C51.8899 43.2059 52.7299 44.0159 52.7399 45.0459C52.7499 46.1159 51.9299 46.8859 50.9499 46.9059Z"
          fill={textColor}
        />
        <path
          d="M30.7383 47.9812C30.7383 47.6612 30.7383 47.3412 30.7383 47.0112C30.7383 46.7112 30.7683 46.7512 30.4783 46.7612C30.1883 46.7712 30.0783 46.6512 30.0683 46.3612C30.0683 46.3112 30.0683 46.2612 30.0683 46.2112C30.0683 45.4912 30.0683 44.7712 30.0683 44.0512C30.0683 43.9112 30.0683 43.7712 30.0483 43.6312C29.8883 42.7812 29.3683 42.2512 28.5583 42.0112C27.7883 41.7812 27.0183 41.8612 26.2683 42.1112C25.8783 42.2412 25.5183 42.4412 25.1783 42.6912C25.3983 43.0612 25.6083 43.4212 25.8283 43.7812C25.9183 43.7212 25.9883 43.6812 26.0683 43.6412C26.5583 43.3612 27.0783 43.2112 27.6483 43.2612C27.9483 43.2912 28.2083 43.3812 28.3983 43.6312C28.5483 43.8212 28.5783 44.0512 28.5783 44.2912C28.5783 44.4412 28.5783 44.4412 28.4383 44.4512C27.8783 44.4912 27.3183 44.5312 26.7683 44.5712C26.3783 44.6012 25.9883 44.6812 25.6383 44.8612C25.2483 45.0612 24.9583 45.3612 24.8383 45.7812C24.5683 46.6912 24.9183 47.5812 25.7883 48.0012C26.3583 48.2812 26.9583 48.3012 27.5683 48.1512C28.0383 48.0312 28.4383 47.7812 28.7783 47.3812C28.9883 47.7812 29.2983 47.9912 29.7083 48.0612C30.0283 48.1212 30.3483 48.0812 30.6683 48.0912C30.7483 48.1012 30.7383 48.0412 30.7383 47.9812ZM28.1083 46.7912C27.9183 46.9212 27.7083 47.0112 27.4783 47.0512C27.3783 47.0712 27.2683 47.0712 27.1683 47.0812C26.9383 47.0712 26.7183 47.0412 26.5283 46.9212C26.2683 46.7612 26.1683 46.5112 26.2383 46.2212C26.2783 46.0312 26.3983 45.9212 26.5683 45.8412C26.7383 45.7612 26.9183 45.7412 27.0983 45.7312C27.5383 45.6912 27.9883 45.6512 28.4383 45.6112C28.5883 45.6012 28.5783 45.6012 28.5883 45.7512C28.6083 46.1612 28.4783 46.5312 28.1083 46.7912Z"
          fill={textColor}
        />
        <path
          d="M57.117 42.4744C57.197 42.4744 57.217 42.4244 57.257 42.3944C58.167 41.6344 59.587 41.6644 60.457 42.4644C60.917 42.8944 61.187 43.4344 61.197 44.0544C61.217 45.3644 61.207 46.6744 61.207 47.9744C61.207 48.0744 61.177 48.1044 61.077 48.1044C60.657 48.1044 60.237 48.1044 59.817 48.1044C59.667 48.1044 59.657 48.1044 59.657 47.9444C59.657 46.8444 59.657 45.7444 59.657 44.6544C59.657 44.4944 59.657 44.3344 59.617 44.1744C59.457 43.4844 58.837 43.1444 58.157 43.2544C57.517 43.3544 57.127 43.8243 57.117 44.4843C57.107 45.1743 57.117 45.8544 57.117 46.5444C57.117 47.0244 57.117 47.4944 57.117 47.9744C57.117 48.0844 57.097 48.1144 56.977 48.1144C56.567 48.1044 56.147 48.1144 55.737 48.1144C55.537 48.1144 55.567 48.1144 55.567 47.9244C55.567 46.1844 55.567 44.4444 55.567 42.7044C55.567 42.5144 55.567 42.3243 55.567 42.1343C55.567 42.0543 55.587 42.0244 55.677 42.0244C56.127 42.0244 56.577 42.0244 57.017 42.0244C57.107 42.0244 57.117 42.0744 57.117 42.1444C57.117 42.2444 57.117 42.3544 57.117 42.4744Z"
          fill={textColor}
        />
        <path
          d="M46.9003 43.2106C46.5703 43.4506 46.2503 43.6906 45.9303 43.9206C45.8203 44.0006 45.8103 44.0006 45.7203 43.8906C45.4203 43.5406 45.0503 43.3306 44.6003 43.2406C43.6003 43.0606 42.6303 43.7706 42.4903 44.7806C42.3603 45.7006 42.9503 46.6706 43.9403 46.8506C44.6203 46.9706 45.2003 46.7806 45.6703 46.2806C45.7003 46.2506 45.7303 46.2206 45.7503 46.1806C45.8003 46.1106 45.8403 46.1206 45.9003 46.1606C46.2303 46.4106 46.5703 46.6506 46.9103 46.9006C46.4703 47.4706 45.9503 47.8906 45.2603 48.1006C43.9803 48.4906 42.5103 48.0706 41.6603 47.0506C40.2703 45.3806 40.9403 42.8706 43.0003 42.0906C43.9003 41.7506 44.8103 41.7506 45.6903 42.1606C46.1603 42.3906 46.5903 42.7706 46.9003 43.2106Z"
          fill={textColor}
        />
        <path
          d="M33.4671 43.9975C33.4671 45.2875 33.4671 46.5675 33.4671 47.8575C33.4671 47.9075 33.4671 47.9575 33.4671 48.0075C33.4771 48.0875 33.4471 48.1175 33.3671 48.1175C32.9171 48.1175 32.4671 48.1175 32.0271 48.1175C31.9371 48.1175 31.9171 48.0775 31.9271 48.0075C31.9271 47.9675 31.9271 47.9275 31.9271 47.8775C31.9271 45.2875 31.9271 42.7075 31.9271 40.1175C31.9271 39.8475 31.8871 39.8675 32.1671 39.8675C32.5371 39.8675 32.9071 39.8675 33.2771 39.8675C33.4971 39.8675 33.4671 39.8575 33.4671 40.0575C33.4671 40.7675 33.4671 41.4875 33.4671 42.1975C33.4671 42.7875 33.4671 43.3875 33.4671 43.9975Z"
          fill={textColor}
        />
        <path
          d="M36.5276 43.9676C36.5276 45.2676 36.5276 46.5676 36.5276 47.8676C36.5276 47.9076 36.5276 47.9476 36.5276 47.9976C36.5376 48.0976 36.4876 48.1076 36.4076 48.1076C35.9776 48.1076 35.5376 48.1076 35.1076 48.1076C35.0076 48.1076 34.9676 48.0776 34.9776 47.9776C34.9776 47.9476 34.9776 47.9076 34.9776 47.8776C34.9776 45.2876 34.9776 42.6876 34.9776 40.0976C34.9776 39.8476 34.9376 39.8676 35.2176 39.8676C35.5976 39.8676 35.9776 39.8676 36.3476 39.8676C36.5476 39.8676 36.5276 39.8676 36.5276 40.0476C36.5276 41.3576 36.5276 42.6576 36.5276 43.9676Z"
          fill={textColor}
        />
        <path
          d="M39.5998 45.0534C39.5998 46.0034 39.5998 46.9534 39.5998 47.9034C39.5998 48.1134 39.6298 48.1034 39.4198 48.1034C39.0098 48.1034 38.6098 48.1034 38.1998 48.1034C38.0598 48.1034 38.0498 48.1034 38.0498 47.9534C38.0498 46.0234 38.0498 44.0934 38.0498 42.1634C38.0498 42.0234 38.0498 42.0234 38.1998 42.0234C38.6098 42.0234 39.0298 42.0234 39.4398 42.0234C39.5898 42.0234 39.5998 42.0234 39.5998 42.1834C39.5998 43.1334 39.5998 44.0934 39.5998 45.0534Z"
          fill={textColor}
        />
        <path
          d="M39.6878 40.5041C39.6878 41.0041 39.3278 41.3741 38.8378 41.3741C38.3578 41.3741 37.9678 40.9941 37.9678 40.5141C37.9678 40.0341 38.3478 39.6641 38.8378 39.6641C39.3278 39.6641 39.6878 40.0141 39.6878 40.5041Z"
          fill={textColor}
        />
        <path
          opacity="0.5"
          d="M28.261 31.1359L30.951 36.1059L31.511 34.6359L29.321 30.5859L28.261 31.1359Z"
          fill={textColor}
        />
        <path
          d="M34.7824 27.6534L36.4624 26.7734L35.2824 29.4234L32.2924 36.1134H30.9524L31.6524 34.2934L34.7824 27.6534Z"
          fill={textColor}
        />
        <path
          opacity="0.5"
          d="M39.8622 36.1356L40.7322 33.7956L36.4622 26.7656L35.2922 29.3956L39.8622 36.1356Z"
          fill={textColor}
        />
        <path
          d="M39.8625 36.135H42.1025L43.3825 33.455L45.8325 28.305L47.3925 25.005L50.0925 19.375L45.1225 22.035L39.8625 36.135Z"
          fill={textColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_10269_68072">
          <rect
            width="50"
            height="50"
            fill="white"
            transform="translate(11.9998 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CompletedImg = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="129"
        height="129"
        viewBox="0 0 129 129"
        fill="none"
      >
        <path
          d="M112.418 110.041C109.823 112.793 107.363 114.571 105.421 115.975C82.602 132.469 55.6037 127.664 49.8637 126.489C41.3876 124.757 25.0116 121.406 13.1687 107.371C-4.74548 86.1453 -1.95491 52.7044 11.939 30.6284C14.48 26.5917 27.9066 4.17745 55.1998 0.58421C71.7164 -1.59185 90.9692 2.79684 104.913 14.564C134.18 39.2641 132.097 89.1717 112.418 110.041Z"
          fill="url(#paint0_linear_75_164)"
        />
        <path
          d="M7.04341 27.0728C6.97081 27.0363 6.9209 26.9631 6.9209 26.8808C6.9209 26.602 6.92997 26.3231 6.94359 26.0442C6.94812 25.9299 7.04795 25.8431 7.16139 25.8522C7.44271 25.8705 7.34289 26.1448 7.33835 26.89C7.33835 27.0043 7.24306 27.0957 7.12962 27.0911C7.09786 27.0911 7.07064 27.082 7.04341 27.0728Z"
          fill="#91B3FA"
        />
        <path
          d="M7.23812 23.4563C7.33341 22.9351 7.44685 22.4094 7.58297 21.8928C7.6102 21.7831 7.72364 21.7191 7.83708 21.7511C8.14109 21.8379 7.92329 21.9934 7.65104 23.5385C7.63289 23.6528 7.52399 23.726 7.41055 23.7031C7.29257 23.6757 7.21997 23.566 7.23812 23.4563ZM8.39973 19.4333C8.59938 18.9396 8.82172 18.4413 9.05767 17.9795C9.18018 17.7281 9.55226 17.9293 9.43429 18.167C9.20287 18.6333 8.98961 19.1087 8.78996 19.5933C8.74912 19.6984 8.62661 19.7487 8.5177 19.703C8.4088 19.6573 8.35889 19.5339 8.39973 19.4333ZM10.3599 15.7349C10.6549 15.296 10.9725 14.8618 11.3037 14.4457C11.4762 14.2309 11.8029 14.4915 11.635 14.7063C11.3128 15.1132 10.9997 15.5383 10.7093 15.9681C10.5551 16.1966 10.2102 15.9635 10.3599 15.7349ZM13.0462 12.8228C12.9645 12.7406 12.9645 12.608 13.0462 12.5303C13.4273 12.16 13.8266 11.8034 14.2395 11.4651C14.4483 11.2914 14.7205 11.6114 14.5072 11.7851C14.1034 12.1143 13.7132 12.4663 13.3366 12.8274C13.2594 12.9097 13.1278 12.9051 13.0462 12.8228ZM16.286 10.2353C16.2224 10.1393 16.2497 10.0113 16.3495 9.95191C16.7987 9.66847 17.2661 9.40332 17.738 9.15646C17.9785 9.02846 18.1781 9.39875 17.9376 9.52218C17.4748 9.76448 17.0165 10.0251 16.5764 10.3039C16.4765 10.3588 16.3495 10.3313 16.286 10.2353ZM20.1066 8.4753C20.0612 8.45244 20.0203 8.4113 19.9977 8.36101C19.9568 8.25587 20.0067 8.13243 20.1156 8.09586C20.6148 7.913 21.132 7.74385 21.6448 7.59756C21.7537 7.56556 21.8717 7.62956 21.9034 7.73928C21.9352 7.849 21.8762 7.96329 21.7627 7.99529C21.2591 8.13701 20.7554 8.30158 20.2654 8.48444C20.2155 8.50273 20.1565 8.49816 20.1066 8.4753ZM24.1495 7.43756C24.0905 7.41013 24.0451 7.3507 24.0315 7.28213C24.0134 7.16784 24.0905 7.06269 24.2039 7.0444C24.7348 6.96669 25.2703 6.90726 25.8057 6.86612C25.9191 6.85697 26.0235 6.94383 26.0326 7.05812C26.0416 7.17241 25.96 7.27298 25.842 7.27756C25.3202 7.31413 24.7893 7.37356 24.272 7.45127C24.2266 7.46042 24.1858 7.45585 24.1495 7.43756ZM28.2106 7.0444C28.2151 6.93012 28.3104 6.84326 28.4284 6.84783C28.9638 6.87983 29.5083 6.93012 30.0392 6.99869C30.316 7.03526 30.2661 7.4467 29.9893 7.41013C29.4675 7.34156 28.9366 7.29127 28.4102 7.25927C28.2968 7.2547 28.206 7.15869 28.2106 7.0444ZM41.1879 12.6217C40.0172 11.5611 39.7359 11.552 39.931 11.3051C39.9991 11.2137 40.1307 11.1999 40.2214 11.2731C40.6479 11.6022 41.0654 11.9542 41.4647 12.32C41.6734 12.5028 41.3966 12.8091 41.1879 12.6217ZM32.367 7.66156C32.3942 7.55185 32.5076 7.48328 32.6211 7.51528C33.1429 7.65242 33.6647 7.81243 34.1729 7.99072C34.4361 8.08215 34.3045 8.47073 34.0413 8.3793C33.5422 8.20558 33.0294 8.05015 32.5212 7.913C32.4078 7.88557 32.3397 7.77128 32.367 7.66156ZM37.8301 10.1393C36.4734 9.33475 36.1921 9.38504 36.3328 9.1016C36.419 8.92331 36.6368 9.01017 36.6095 9.01017C37.0951 9.24789 37.576 9.50847 38.0389 9.78276C38.1387 9.84219 38.1705 9.9702 38.116 10.0662C38.057 10.1622 37.9345 10.1988 37.8301 10.1393Z"
          fill="#91B3FA"
        />
        <path
          d="M43.5247 15.1264C43.0891 14.5732 42.8078 14.3721 43.0211 14.1938C43.1073 14.1206 43.2389 14.1343 43.316 14.2212C43.7924 14.7743 44.0329 15.0029 43.8197 15.1675C43.7516 15.2132 43.5973 15.2178 43.5247 15.1264Z"
          fill="#91B3FA"
        />
        <path
          d="M47.8761 30.616C47.7944 30.5794 47.7445 30.4925 47.7581 30.3965C47.7944 30.1268 47.8262 29.8525 47.8488 29.5828C47.8579 29.4685 47.9623 29.3862 48.0757 29.3999C48.1892 29.4136 48.2754 29.5142 48.2663 29.6285C48.2391 29.9028 48.2073 30.1817 48.171 30.456C48.1574 30.5702 48.0485 30.648 47.9351 30.6297C47.9169 30.6297 47.8942 30.6251 47.8761 30.616Z"
          fill="#91B3FA"
        />
        <path
          d="M18.3915 45.624C17.8742 45.3588 17.3614 45.0708 16.8669 44.7645C16.767 44.7051 16.7353 44.5771 16.7988 44.4765C16.9667 44.2022 17.062 44.4811 18.5775 45.2537C18.6819 45.3085 18.7227 45.432 18.6728 45.5325C18.5775 45.7108 18.3642 45.624 18.3915 45.624ZM20.869 46.4834C20.9733 46.1817 21.1367 46.4331 22.7702 46.8629C22.8836 46.8903 22.9517 47.0046 22.9245 47.1143C22.8972 47.224 22.7838 47.2926 22.6704 47.2606C22.1122 47.1143 21.5496 46.9406 21.0005 46.744C20.8916 46.7074 20.8327 46.5886 20.869 46.4834ZM14.5572 43.1051C14.108 42.7348 13.6724 42.3416 13.255 41.9347C13.1733 41.8525 13.1688 41.7245 13.2504 41.6422C13.4773 41.4136 13.5091 41.7062 14.8204 42.7896C14.9112 42.8628 14.9248 42.9953 14.8522 43.0822C14.7751 43.1645 14.6435 43.1782 14.5572 43.1051ZM25.3883 47.7817C25.3112 47.7452 25.2567 47.6583 25.2704 47.5715C25.284 47.4572 25.3838 47.3795 25.5018 47.3932C26.0644 47.4617 26.6362 47.5075 27.2033 47.5303C27.3168 47.5349 27.4121 47.6309 27.4075 47.7452C27.403 47.8595 27.3077 47.9509 27.1943 47.9463C26.618 47.9235 26.0327 47.8778 25.4564 47.8046C25.4292 47.7955 25.4065 47.7909 25.3883 47.7817ZM29.8986 47.8412C29.8351 47.8092 29.7897 47.7498 29.7807 47.6766C29.7671 47.5623 29.8487 47.4617 29.9622 47.448C30.5248 47.3932 31.092 47.3154 31.6456 47.2103C31.759 47.1874 31.8679 47.2652 31.8906 47.3749C31.9133 47.4892 31.8407 47.5943 31.7273 47.6172C31.1601 47.7223 30.5838 47.8 30.0075 47.8595C29.9712 47.864 29.9304 47.8549 29.8986 47.8412ZM34.2955 46.9132C34.2456 46.8903 34.2048 46.8492 34.1866 46.7897C34.1503 46.68 34.2047 46.5657 34.3137 46.5291C34.8491 46.3554 35.38 46.1543 35.8972 45.9348C36.0016 45.8891 36.1241 45.9394 36.174 46.0446C36.2194 46.1497 36.174 46.2731 36.0697 46.3143C35.5433 46.5383 34.9988 46.744 34.4543 46.9223C34.3999 46.9406 34.3409 46.936 34.2955 46.9132ZM38.3702 45.0525C38.3339 45.0343 38.3021 45.0068 38.2795 44.9702C38.2205 44.8697 38.2477 44.7462 38.3475 44.6868C38.8285 44.3988 39.3049 44.0879 39.7587 43.7588C39.8494 43.6902 39.981 43.7131 40.0491 43.8045C40.1171 43.8959 40.099 44.0285 40.0082 44.0925C39.5454 44.4262 39.0599 44.7462 38.5699 45.0388C38.5063 45.08 38.4292 45.0845 38.3702 45.0525ZM41.8596 42.305C41.6327 42.0719 41.9231 42.0536 43.0302 40.7964C43.2117 40.5907 43.5248 40.8696 43.3479 41.0707C42.9713 41.5004 42.572 41.9165 42.159 42.3096C42.0728 42.3919 41.9412 42.3873 41.8596 42.305ZM44.75 38.9084C44.4777 38.7301 44.7545 38.6478 45.5486 37.1758C45.6756 36.938 46.0477 37.1346 45.9161 37.3769C45.6439 37.8798 45.3489 38.3735 45.0358 38.8535C44.9723 38.9495 44.8453 38.9724 44.75 38.9084ZM46.7873 34.9448C46.6875 34.8991 46.6421 34.7848 46.6784 34.6843C46.8735 34.1585 47.0505 33.6191 47.2002 33.0797C47.232 32.9699 47.3454 32.9059 47.4589 32.9379C47.5723 32.9699 47.6358 33.0842 47.6041 33.1939C47.4498 33.7425 47.2728 34.2911 47.0686 34.8306C47.0278 34.9357 46.9098 34.9906 46.8009 34.9494C46.7964 34.9494 46.7919 34.9494 46.7873 34.9448Z"
          fill="#91B3FA"
        />
        <path
          d="M11.3495 39.8036C10.9003 39.2276 10.6689 38.9899 10.8912 38.839C11.1226 38.679 11.2179 38.9625 11.6808 39.5568C11.7534 39.6482 11.7352 39.7762 11.6445 39.8448C11.5537 39.9133 11.4221 39.8951 11.3495 39.8036Z"
          fill="#91B3FA"
        />
        <path
          d="M14.0492 34.7792L17.0395 34.6512C17.8562 35.7941 18.8545 36.8181 20.0252 37.673C19.9072 40.5576 19.6985 40.7496 19.9934 40.8776L23.3103 42.304C23.4056 42.3451 23.5191 42.3223 23.5871 42.2445L25.5746 40.0548C26.9948 40.3108 28.4196 40.3291 29.799 40.1325L31.7819 42.3954C31.85 42.4731 31.9634 42.5005 32.0587 42.464L35.3802 41.1611C35.4755 41.1245 35.539 41.0285 35.5299 40.9234L35.3484 37.9519C36.4828 37.161 37.4992 36.1872 38.3386 35.0398L41.3243 35.2729C41.4287 35.2821 41.5285 35.2226 41.5648 35.1266L42.9397 31.858C42.9805 31.762 42.9533 31.6523 42.8762 31.5791L40.6346 29.5676C40.8706 28.1596 40.8615 26.747 40.6346 25.371C42.7854 23.4372 43.0622 23.46 42.9442 23.1675C41.5421 19.9354 41.6556 19.6794 41.3289 19.6931L38.3386 19.8211C37.5219 18.6782 36.5236 17.6542 35.3529 16.7993C35.4709 13.9147 35.6796 13.7227 35.3847 13.5947C32.0632 12.2369 31.9997 11.9946 31.7864 12.2278L29.799 14.4175C28.3788 14.1615 26.954 14.1432 25.5746 14.3398C23.6144 12.1958 23.6098 11.8895 23.3103 12.0083C20.0479 13.3569 19.821 13.2289 19.8391 13.5489L20.0206 16.5204C18.8863 17.3113 17.8698 18.2851 17.0304 19.4325C14.1763 19.2679 13.9267 19.0439 13.7997 19.3457C12.4974 22.6052 12.2433 22.6737 12.4883 22.8932L14.7299 24.9047C14.4939 26.3127 14.503 27.7253 14.7299 29.1013C12.5882 31.026 12.2978 31.0122 12.4203 31.3048C13.8405 34.5369 13.7225 34.7929 14.0492 34.7792Z"
          fill="#91B3FA"
        />
        <path
          d="M24.231 26.6706C24.5124 24.7779 26.2956 23.4933 28.2059 23.8042C30.1162 24.1196 31.4412 25.9117 31.1598 27.8043C30.8785 29.6969 29.0953 30.9815 27.185 30.6707C25.2747 30.3552 23.9497 28.5632 24.231 26.6706ZM28.1152 24.4214C26.5633 24.1653 25.0841 25.1985 24.8527 26.7757C24.6213 28.33 25.7103 29.8021 27.2802 30.0581C28.8502 30.3141 30.3159 29.2581 30.5427 27.7037C30.7741 26.1494 29.6806 24.6774 28.1152 24.4214Z"
          fill="#BDD0FB"
        />
        <path
          d="M23.9864 35.2271C23.5145 35.0031 23.0653 34.738 22.6433 34.4408C22.5162 34.3494 22.4754 34.1848 22.5389 34.0522C22.548 34.0385 22.5571 34.0202 22.5661 34.0065C22.666 33.8694 22.8611 33.8374 23.0017 33.9334C23.4873 34.2763 24.0136 34.5688 24.5626 34.8066C28.71 36.5895 33.4744 34.802 35.3438 30.8247C35.3937 30.7242 35.4391 30.619 35.4799 30.5139C37.2541 26.2943 35.2122 21.4211 30.9651 19.5924C26.7225 17.7684 21.822 19.6747 20.0478 23.8851C18.9951 26.3903 19.5941 28.1778 19.4715 28.4338C19.34 28.7127 18.9225 28.6441 18.8771 28.3378C18.6321 26.6738 18.859 24.9183 19.6167 23.3045C22.8928 16.3375 33.0841 16.7352 36.0653 23.94C36.9819 26.1572 36.9819 28.5801 36.0607 30.7653C36.0154 30.8796 35.9655 30.9893 35.911 31.099C34.9627 33.1197 33.2974 34.674 31.1965 35.5014C28.9777 36.3746 26.5365 36.3289 24.3222 35.378C24.2087 35.3277 24.0998 35.2774 23.9864 35.2271Z"
          fill="#BDD0FB"
        />
        <path
          d="M50.145 22.3495C50.6442 22.953 51.2431 23.4833 51.9238 23.9084L51.9374 25.5908C51.9374 25.7782 52.0962 25.705 53.9339 26.3633C54.1018 26.4228 54.0882 26.2582 55.1046 24.9827C55.9032 25.0559 56.6972 24.9965 57.4595 24.8182L58.6529 25.9976C58.7845 26.1302 58.848 25.9656 60.604 25.1199C60.6585 25.0925 60.6857 25.0376 60.6812 24.9782L60.4634 23.3096C61.0623 22.8067 61.5887 22.2032 62.0107 21.5175C63.6079 21.4672 63.7531 21.5815 63.8121 21.4078C64.4065 19.5014 64.5426 19.4512 64.402 19.3369L63.077 18.3128C63.1496 17.5083 63.0906 16.7082 62.9137 15.9402L64.0843 14.7379C64.2159 14.6053 64.0526 14.5413 63.2131 12.7721C63.136 12.6121 63.0407 12.7356 61.4163 12.9139C60.9171 12.3104 60.3182 11.7801 59.6376 11.355L59.6239 9.67262C59.6239 9.48519 59.4651 9.55833 57.6274 8.90003C57.4595 8.84517 57.4777 8.99604 56.4567 10.2806C55.6581 10.2075 54.8641 10.2669 54.1018 10.4452L52.9084 9.26576C52.8676 9.22461 52.804 9.21547 52.7496 9.2429L50.9573 10.1435C50.9028 10.1709 50.8756 10.2258 50.8801 10.2852L51.0979 11.9538C50.499 12.4567 49.9726 13.0601 49.5506 13.7459C47.9534 13.7962 47.8082 13.6819 47.7492 13.8556C47.1548 15.7619 47.0187 15.8122 47.1594 15.9265L48.4843 16.9505C48.4117 17.7551 48.4707 18.5551 48.6477 19.3232C47.5541 20.4935 47.3681 20.5209 47.4498 20.6855L48.3436 22.4912C48.4253 22.6558 48.5251 22.5278 50.145 22.3495Z"
          fill="#91B3FA"
        />
        <path
          d="M53.689 17.4723C53.7752 16.3112 54.778 15.4426 55.9351 15.5294C57.0876 15.6163 57.9498 16.6266 57.8635 17.7923C57.7773 18.9535 56.77 19.8221 55.6175 19.7352C54.4695 19.6484 53.6028 18.6335 53.689 17.4723ZM54.3107 17.5226C54.2517 18.3364 54.8552 19.0495 55.6628 19.1089C56.9606 19.2095 57.7365 17.6643 56.888 16.6677C56.044 15.6757 54.4105 16.206 54.3107 17.5226Z"
          fill="#BDD0FB"
        />
        <path
          d="M45.2399 20.6711C45.1628 20.3968 45.0947 20.118 45.0403 19.8437C45.0176 19.7294 45.0902 19.6197 45.2036 19.5968C45.485 19.5374 45.4441 19.8574 45.6438 20.5568C45.6755 20.6666 45.612 20.7854 45.5031 20.8174C45.3897 20.8449 45.2717 20.7809 45.2399 20.6711Z"
          fill="#91B3FA"
        />
        <path
          d="M44.8361 17.0508C44.8633 16.4976 44.9359 15.917 45.0584 15.341C45.1174 15.0713 45.5213 15.1582 45.4668 15.4279C45.1537 16.9228 45.3806 17.2931 45.0358 17.2702C44.9178 17.2611 44.8316 17.1651 44.8361 17.0508ZM46.0658 12.9775C45.9614 12.9272 45.9206 12.7992 45.975 12.6987C46.2291 12.1867 46.5286 11.6884 46.8598 11.2221C47.0187 10.9981 47.359 11.2403 47.2002 11.4643C46.8825 11.9124 46.5967 12.3924 46.3516 12.8861C46.2564 13.0644 46.0431 12.973 46.0658 12.9775ZM48.7883 9.5123C48.7611 9.49858 48.7384 9.4803 48.7202 9.45744C48.6476 9.37058 48.6567 9.23801 48.7475 9.16029C49.1831 8.79 49.655 8.45627 50.1405 8.15912C50.2403 8.09969 50.3674 8.13169 50.4263 8.23227C50.4853 8.33284 50.4536 8.46084 50.3537 8.52027C49.8864 8.80371 49.4326 9.12829 49.0106 9.48487C48.9471 9.53973 48.8609 9.54887 48.7883 9.5123ZM52.6497 7.42767C52.5998 7.40482 52.5544 7.3591 52.5408 7.29967C52.5091 7.18995 52.5726 7.07109 52.6815 7.03909C53.226 6.87909 53.7932 6.75566 54.3558 6.68251C54.4693 6.6688 54.5736 6.74651 54.5873 6.86537C54.6009 6.97966 54.5237 7.08481 54.4058 7.09852C53.8613 7.17167 53.3213 7.28596 52.7949 7.44139C52.7496 7.4551 52.6951 7.45053 52.6497 7.42767ZM56.9014 6.85623C56.915 6.74194 57.0194 6.65965 57.1328 6.67337C57.7 6.74651 58.2627 6.8608 58.8117 7.01623C59.0749 7.08938 58.9614 7.49625 58.6983 7.41853C58.1719 7.26767 57.6319 7.15338 57.0829 7.08481C56.9695 7.07566 56.8878 6.97052 56.9014 6.85623Z"
          fill="#91B3FA"
        />
        <path
          d="M61.843 8.94573C61.2213 8.50229 60.9446 8.45658 61.0852 8.21428C61.1442 8.11371 61.2713 8.08171 61.3711 8.14114C61.6116 8.28743 61.8521 8.44286 62.0835 8.60743C62.1788 8.67601 62.2015 8.80401 62.1334 8.90002C62.0699 8.98687 61.9383 9.00973 61.843 8.94573Z"
          fill="#91B3FA"
        />
        <path
          d="M66.2488 16.3883C66.158 15.6203 66.0128 15.3872 66.2851 15.3323C66.3985 15.3094 66.5074 15.3826 66.5301 15.4969C66.5846 15.7757 66.6299 16.0592 66.6617 16.338C66.6753 16.4523 66.5936 16.5575 66.4802 16.5712C66.3668 16.5849 66.2624 16.5026 66.2488 16.3883Z"
          fill="#91B3FA"
        />
        <path
          d="M52.0825 27.8038C52.1959 27.4746 52.4364 27.8175 53.9156 28.0826C54.1879 28.1284 54.1153 28.5444 53.843 28.4941C53.2895 28.3935 52.7404 28.2518 52.2141 28.0689C52.1052 28.0369 52.0462 27.9181 52.0825 27.8038ZM56.3478 28.4484C56.3387 28.3341 56.4249 28.2335 56.5383 28.2244C58.0493 28.1146 58.3125 27.7992 58.3897 28.1421C58.4169 28.2564 58.3443 28.3661 58.2354 28.3935C57.6909 28.5215 57.1282 28.6038 56.5701 28.6449C56.4567 28.6495 56.3568 28.5626 56.3478 28.4484ZM60.5223 27.3512C60.3635 27.0403 60.7719 27.1043 61.9879 26.2083C62.2102 26.0437 62.4553 26.382 62.2329 26.5466C61.7792 26.8803 61.2982 27.182 60.7991 27.438C60.6993 27.4929 60.5722 27.4563 60.5223 27.3512ZM63.93 24.6905C63.6623 24.4665 64.0661 24.366 64.8375 23.0631C64.9781 22.8254 65.3366 23.0402 65.1959 23.2779C64.9101 23.7625 64.5834 24.2288 64.2249 24.6631C64.1478 24.7545 64.0162 24.7637 63.93 24.6905ZM65.8902 20.6356C66.3167 19.1727 66.1171 18.8115 66.4574 18.8573C66.5708 18.871 66.6525 18.9761 66.6343 19.0904C66.5617 19.6527 66.4438 20.2104 66.285 20.7499C66.2532 20.8596 66.1352 20.9236 66.0263 20.8916C65.9219 20.8642 65.8584 20.7499 65.8902 20.6356Z"
          fill="#91B3FA"
        />
        <path
          d="M49.7503 26.8518C49.5143 26.6964 49.2829 26.5272 49.0606 26.3535C48.9698 26.2804 48.9517 26.1524 49.0243 26.0609C49.2013 25.8324 49.3737 26.0975 49.9772 26.5044C50.0725 26.5684 50.0997 26.6964 50.0362 26.7924C49.9726 26.8884 49.8456 26.9113 49.7503 26.8518Z"
          fill="#91B3FA"
        />
        <path
          d="M53.1942 22.0747C53.0218 21.9741 52.99 21.7776 53.0762 21.6358C53.1624 21.485 53.3576 21.4393 53.5028 21.5261C53.7795 21.6907 54.0745 21.8278 54.3785 21.9284C54.4466 21.9376 56.0211 22.5913 57.8361 21.6861C61.4298 19.8804 61.0623 14.5637 57.2508 13.2791C55.0591 12.5385 52.6905 13.5945 51.724 15.6471C50.7485 17.718 51.8148 18.8106 51.1523 18.9569C50.9844 18.9935 50.8165 18.8883 50.7802 18.7192C50.5806 17.8049 50.6305 16.8494 50.9254 15.958C51.8239 13.2516 54.746 11.775 57.4413 12.6848C60.3454 13.6631 61.7928 16.9957 60.4588 19.8392C59.3789 22.1296 56.7199 23.3867 54.1743 22.5273C53.834 22.413 53.5028 22.2621 53.1942 22.0747Z"
          fill="#BDD0FB"
        />
        <path
          d="M56.5022 102.137L54.2017 122.928H80.8959L77.4202 102.137H56.5022Z"
          fill="url(#paint1_linear_75_164)"
        />
        <path
          d="M0.5 40.6036V97.8028C0.5 102.507 4.22077 106.356 8.88989 106.475C29.6264 107.014 102.15 108.322 121.888 108.025C125.282 107.975 128.027 105.241 128.127 101.821C128.508 88.5317 129.125 56.5812 126.838 41.7465C126.357 38.6241 123.739 36.2881 120.604 36.1875C103.23 35.6298 26.3503 33.8514 6.62113 34.2949C3.21798 34.3772 0.5 37.175 0.5 40.6036Z"
          fill="url(#paint2_linear_75_164)"
        />
        <path
          d="M4.06201 40.3306V94.6726C4.06201 97.4201 6.2491 99.6601 8.97615 99.7013L119.048 101.073C121.752 101.114 123.966 98.9241 123.975 96.1995L124.161 42.3421C124.17 40.3946 122.628 38.7991 120.695 38.7534L8.00059 36.4585C5.84526 36.3991 4.06201 38.15 4.06201 40.3306Z"
          fill="#7D97F4"
        />
        <path
          d="M7.18848 42.0541V93.0589C7.18848 95.6372 9.2712 97.7401 11.8667 97.7767L116.675 99.0613C119.247 99.0979 121.357 97.0453 121.366 94.4852L121.543 43.9376C121.552 42.109 120.082 40.6141 118.244 40.5684L10.941 38.4152C8.88097 38.3649 7.18848 40.0107 7.18848 42.0541Z"
          fill="#91B3FA"
        />
        <path
          d="M124.806 103.305L4.06193 101.234C3.96664 101.234 3.89404 101.156 3.89404 101.06C3.89404 100.964 3.97572 100.886 4.06647 100.891L124.81 102.962C124.905 102.962 124.978 103.039 124.978 103.135C124.973 103.231 124.901 103.305 124.806 103.305Z"
          fill="#91B3FA"
        />
        <path
          d="M65.6269 105.84C64.8419 105.84 64.2021 105.195 64.2021 104.404C64.2021 103.613 64.8419 102.969 65.6269 102.969C66.4119 102.969 67.0517 103.613 67.0517 104.404C67.0517 105.195 66.4119 105.84 65.6269 105.84ZM65.6269 103.307C65.028 103.307 64.5379 103.801 64.5379 104.404C64.5379 105.008 65.028 105.501 65.6269 105.501C66.2259 105.501 66.7159 105.008 66.7159 104.404C66.7159 103.801 66.2259 103.307 65.6269 103.307Z"
          fill="#91B3FA"
        />
        <path
          d="M86.6492 127.185H47.5766C46.5148 127.185 45.7162 126.421 45.9249 125.608L46.424 123.61C46.5738 123.011 47.2317 122.567 48.0122 122.545L85.6782 121.361C86.4904 121.333 87.2119 121.772 87.3889 122.394L88.2918 125.576C88.5278 126.398 87.7246 127.185 86.6492 127.185Z"
          fill="url(#paint3_linear_75_164)"
        />
        <path
          d="M68.6083 123.12C68.5176 123.12 68.4404 123.046 68.4404 122.95C68.4404 122.854 68.513 122.781 68.6083 122.777L70.2237 122.754C70.3144 122.758 70.3916 122.827 70.3961 122.923C70.3961 123.019 70.3235 123.092 70.2282 123.097L68.6083 123.12Z"
          fill="#91B3FA"
        />
        <path
          d="M47.368 126.126C47.3589 126.126 47.3498 126.126 47.3407 126.126C47.25 126.112 47.1865 126.025 47.2001 125.929L47.4315 124.475C47.5585 123.675 48.2346 123.085 49.0378 123.072L66.1579 122.82C66.2532 122.82 66.3258 122.893 66.3303 122.989C66.3303 123.085 66.2577 123.159 66.1624 123.163L49.0423 123.415C48.4025 123.424 47.8626 123.895 47.7627 124.53L47.5313 125.984C47.5222 126.066 47.4496 126.126 47.368 126.126Z"
          fill="#91B3FA"
        />
        <path
          d="M41.442 42.1977L54.1561 42.1017C55.894 42.088 57.287 43.4411 57.2144 45.064L55.9711 72.7493C55.9031 74.2671 54.5736 75.4694 52.9537 75.4785L41.687 75.5608C40.0081 75.5745 38.6378 74.3082 38.6242 72.7356L38.42 45.0595C38.4109 43.496 39.7631 42.2114 41.442 42.1977Z"
          fill="#BDD0FB"
        />
        <path
          opacity="0.2"
          d="M51.2976 81.0842L11.0679 81.5643C9.52059 81.5825 8.29546 82.5929 8.37259 83.7952L9.04415 94.4103C9.11675 95.544 10.3192 96.4309 11.7803 96.4309H51.343C52.8585 96.4309 54.0837 95.48 54.0837 94.3052V83.21C54.0791 82.0214 52.8268 81.066 51.2976 81.0842Z"
          fill="white"
        />
        <path
          d="M100.97 78.1312L60.7403 78.7209C59.193 78.7438 57.9678 79.9781 58.045 81.4501L58.7165 94.4379C58.7891 95.8231 59.9916 96.9111 61.4526 96.9111H101.015C102.531 96.9111 103.756 95.7454 103.756 94.3099V80.7324C103.756 79.2786 102.499 78.1083 100.97 78.1312Z"
          fill="#BDD0FB"
        />
        <path
          d="M33.4109 40.9141H12.629C10.9501 40.9141 9.58887 42.2947 9.58887 43.9999V74.0075C9.58887 75.7127 10.9501 77.0933 12.629 77.0933H33.4109C35.0898 77.0933 36.451 75.7127 36.451 74.0075V43.9999C36.451 42.2947 35.0898 40.9141 33.4109 40.9141Z"
          fill="#BDD0FB"
        />
        <path
          d="M84.7029 52.5488H63.921C62.2421 52.5488 60.8809 53.2894 60.8809 54.2037V70.2864C60.8809 71.2007 62.2421 71.9413 63.921 71.9413H84.7029C86.3818 71.9413 87.743 71.2007 87.743 70.2864V54.2037C87.743 53.2894 86.3818 52.5488 84.7029 52.5488Z"
          fill="#BDD0FB"
        />
        <path
          d="M119.356 51.1094H94.3949C92.3802 51.1094 90.7422 51.85 90.7422 52.7643V68.847C90.7422 69.7613 92.3757 70.5019 94.3949 70.5019H119.356C121.371 70.5019 123.009 69.7613 123.009 68.847V52.7643C123.009 51.85 121.371 51.1094 119.356 51.1094Z"
          fill="#BDD0FB"
        />
        <path
          d="M112.114 24.6209C103.933 24.3877 63.4583 23.03 55.1501 22.7465C54.3288 22.7191 53.6572 23.99 53.6572 25.5626V32.8405C53.6572 34.3948 54.3152 35.6566 55.1229 35.6566H112.092C112.899 35.6566 113.557 34.3948 113.557 32.8405V27.4324C113.562 25.8963 112.917 24.6437 112.114 24.6209Z"
          fill="url(#paint4_linear_75_164)"
        />
        <path
          d="M58.1491 33.906L60.3634 32.7357C60.5358 32.6443 60.74 32.6443 60.9124 32.7357L63.1222 33.9106C63.5533 34.1392 64.0615 33.7689 63.9798 33.2843L63.5624 30.8019C63.5306 30.6099 63.5941 30.4133 63.7348 30.2762L65.5271 28.5207C65.8765 28.1779 65.6859 27.579 65.2004 27.5058L62.7275 27.1401C62.5369 27.1127 62.369 26.9893 62.2828 26.8155L61.1802 24.5572C60.9624 24.1137 60.3362 24.1137 60.1229 24.5572L59.0112 26.8155C58.925 26.9893 58.7571 27.1127 58.5665 27.1401L56.0936 27.4967C55.6081 27.5653 55.413 28.1687 55.7669 28.5116L57.5547 30.2716C57.6953 30.4088 57.7589 30.6053 57.7226 30.7973L57.296 33.2797C57.2098 33.7597 57.718 34.1346 58.1491 33.906Z"
          fill="url(#paint5_linear_75_164)"
        />
        <path
          d="M69.5793 34.2361L71.7936 33.0658C71.966 32.9743 72.1702 32.9743 72.3426 33.0658L74.5524 34.2407C74.9835 34.4692 75.4917 34.0989 75.41 33.6144L74.9925 31.132C74.9608 30.94 75.0243 30.7434 75.165 30.6063L76.9573 28.8508C77.3067 28.5079 77.1161 27.9091 76.6306 27.8359L74.1576 27.4702C73.9671 27.4428 73.7992 27.3193 73.7129 27.1456L72.6103 24.8873C72.3925 24.4438 71.7663 24.4438 71.5531 24.8873L70.4414 27.1456C70.3552 27.3193 70.1873 27.4428 69.9967 27.4702L67.5238 27.8268C67.0382 27.8953 66.8431 28.4988 67.1971 28.8417L68.9848 30.6017C69.1255 30.7388 69.189 30.9354 69.1527 31.1274L68.7262 33.6098C68.64 34.0898 69.1437 34.4647 69.5793 34.2361Z"
          fill="url(#paint6_linear_75_164)"
        />
        <path
          d="M81.1046 34.2986L83.319 33.1283C83.4914 33.0368 83.6956 33.0368 83.868 33.1283L86.0778 34.3032C86.5088 34.5317 87.017 34.1614 86.9354 33.6768L86.5179 31.1945C86.4862 31.0025 86.5497 30.8059 86.6903 30.6688L88.4827 28.9133C88.8321 28.5704 88.6415 27.9716 88.156 27.8984L85.683 27.5327C85.4924 27.5053 85.3246 27.3818 85.2383 27.2081L84.1357 24.9498C83.9179 24.5063 83.2917 24.5063 83.0785 24.9498L81.9668 27.2081C81.8806 27.3818 81.7127 27.5053 81.5221 27.5327L79.0492 27.8893C78.5636 27.9578 78.3685 28.5613 78.7224 28.9042L80.5102 30.6642C80.6509 30.8014 80.7144 30.9979 80.6781 31.1899L80.2516 33.6723C80.1654 34.1523 80.6736 34.5272 81.1046 34.2986Z"
          fill="url(#paint7_linear_75_164)"
        />
        <path
          d="M92.2941 34.4314L94.5084 33.2611C94.6808 33.1696 94.885 33.1696 95.0575 33.2611L97.2672 34.436C97.6983 34.6645 98.2065 34.2942 98.1248 33.8097L97.7074 31.3273C97.6756 31.1353 97.7391 30.9387 97.8798 30.8016L99.6721 29.0461C100.022 28.7032 99.8309 28.1044 99.3454 28.0312L96.8725 27.6655C96.6819 27.6381 96.514 27.5146 96.4278 27.3409L95.3252 25.0826C95.1074 24.6391 94.4812 24.6391 94.2679 25.0826L93.1562 27.3409C93.07 27.5146 92.9021 27.6381 92.7116 27.6655L90.2386 28.0221C89.7531 28.0907 89.558 28.6941 89.9119 29.037L91.6997 30.797C91.8403 30.9342 91.9039 31.1307 91.8676 31.3227L91.441 33.8051C91.3548 34.2851 91.8585 34.66 92.2941 34.4314Z"
          fill="url(#paint8_linear_75_164)"
        />
        <path
          d="M103.683 34.4314L105.898 33.2611C106.07 33.1696 106.274 33.1696 106.447 33.2611L108.656 34.436C109.087 34.6645 109.596 34.2942 109.514 33.8097L109.097 31.3273C109.065 31.1353 109.128 30.9387 109.269 30.8016L111.061 29.0461C111.411 28.7032 111.22 28.1044 110.735 28.0312L108.262 27.6655C108.071 27.6381 107.903 27.5146 107.817 27.3409L106.714 25.0826C106.497 24.6391 105.87 24.6391 105.657 25.0826L104.545 27.3409C104.459 27.5146 104.291 27.6381 104.101 27.6655L101.628 28.0221C101.142 28.0907 100.947 28.6941 101.301 29.037L103.089 30.797C103.23 30.9342 103.293 31.1307 103.257 31.3227L102.83 33.8051C102.739 34.2851 103.248 34.66 103.683 34.4314Z"
          fill="url(#paint9_linear_75_164)"
        />
        <path
          d="M14.0718 68.047L49.9183 68.3442C51.8966 68.3624 53.512 69.9351 53.5982 71.9283L55.8171 124.309C55.8851 125.868 54.6555 127.171 53.1082 127.185L12.0208 127.596C10.5688 127.61 9.38453 126.421 9.39361 124.954L9.82467 72.2574C9.84282 69.9168 11.744 68.0287 14.0718 68.047Z"
          fill="url(#paint10_linear_75_164)"
        />
        <path
          d="M18.0236 126.778L13.4271 126.682C11.8798 126.65 10.632 125.352 10.6456 123.793L10.7046 116.799C10.7046 116.735 10.7591 116.68 10.8226 116.68C10.8861 116.684 10.9406 116.735 10.9406 116.799L10.8816 123.793C10.868 125.224 12.016 126.413 13.4362 126.445L18.0327 126.541C18.0962 126.541 18.1507 126.595 18.1462 126.659C18.1416 126.728 18.0917 126.778 18.0236 126.778Z"
          fill="#BDD0FB"
        />
        <path
          d="M10.8366 114.75C10.7731 114.75 10.7231 114.696 10.7231 114.632L10.7322 113.498C10.7322 113.434 10.7867 113.379 10.8502 113.379C10.9137 113.379 10.9682 113.434 10.9636 113.498L10.9546 114.632C10.9546 114.7 10.9001 114.75 10.8366 114.75Z"
          fill="#BDD0FB"
        />
        <path
          d="M14.1854 67.6267C19.0769 68.3353 35.8884 70.5434 49.8186 69.5833C50.4539 69.5376 50.9984 70.0268 51.0301 70.6714L53.3715 123.285C53.4033 124.008 52.8542 124.62 52.1373 124.657C46.2793 124.958 22.1669 126.106 13.5728 125.128C13.051 125.068 12.6562 124.62 12.6562 124.09L12.7878 68.8473C12.7878 68.093 13.4503 67.517 14.1854 67.6267Z"
          fill="url(#paint11_linear_75_164)"
        />
        <path
          opacity="0.6"
          d="M14.6977 68.9923C19.4031 69.6735 35.5839 71.7992 48.9878 70.8758C49.6004 70.8346 50.1267 71.3055 50.154 71.9227L52.4091 122.557C52.4409 123.252 51.91 123.842 51.2203 123.874C45.5847 124.162 22.3752 125.268 14.1078 124.326C13.6042 124.267 13.2275 123.837 13.2275 123.33L13.3546 70.1672C13.3546 69.4449 13.9898 68.8917 14.6977 68.9923Z"
          fill="white"
        />
        <g opacity="0.6">
          <path
            d="M48.2984 75.3203C48.6387 75.3249 48.9064 75.1603 48.8973 74.9591C48.8837 74.758 48.5978 74.5888 48.2575 74.5843L18.3688 74.0997C18.0285 74.0951 17.9196 74.31 18.1329 74.5797C18.3416 74.8494 18.7908 75.0734 19.1311 75.0734L48.2984 75.3203Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            d="M18.3551 76.1212C18.0148 76.1166 17.9059 76.3315 18.1192 76.6012C18.3279 76.8709 18.7771 77.0949 19.1174 77.0949L48.2847 77.3372C48.625 77.3418 48.8927 77.1772 48.8836 76.976C48.87 76.7749 48.5842 76.6057 48.2438 76.6012L18.3551 76.1212Z"
            fill="white"
          />
        </g>
        <path
          d="M23.183 94.5426C23.1785 94.5426 23.174 94.5426 23.174 94.5426L19.1401 94.602C18.5593 94.6111 18.0693 94.218 18.0012 93.6922L17.5656 90.291C17.5384 90.0899 17.5973 89.8887 17.7289 89.7241C17.8741 89.5413 18.101 89.4224 18.346 89.3996C18.6864 89.3676 19.1537 89.3173 19.6665 89.2578C20.7872 89.1344 22.0577 88.9927 22.8019 88.9653C22.8064 88.9653 22.811 88.9653 22.82 88.9653C23.3555 88.9516 23.8228 89.2716 23.9635 89.7424C24.1949 90.5196 24.2085 92.0053 24.2085 93.5825C24.1995 94.1037 23.7457 94.5288 23.183 94.5426ZM18.3687 89.7287C18.2099 89.7424 18.0693 89.8156 17.9785 89.9299C17.9059 90.0213 17.8696 90.1356 17.8878 90.2499L18.3234 93.6511C18.3687 94.0123 18.7181 94.2774 19.131 94.2728L23.1649 94.2134C23.1694 94.2134 23.1694 94.2134 23.174 94.2134C23.5597 94.2043 23.8727 93.9208 23.8727 93.5825C23.8727 92.0282 23.8591 90.5699 23.6413 89.8339C23.546 89.5093 23.1876 89.2716 22.811 89.2944C22.0759 89.3218 20.7555 89.4681 19.6982 89.5824C19.1809 89.6464 18.7136 89.6967 18.3687 89.7287Z"
          fill="white"
        />
        <path
          opacity="0.6"
          d="M18.8135 90.0583C19.6574 89.9806 21.4951 89.7475 22.3709 89.7155C22.743 89.7017 23.0697 89.9212 23.1649 90.2412C23.3464 90.8629 23.3555 92.1155 23.3555 93.2721C23.3555 93.6196 23.047 93.903 22.6613 93.9076L19.4396 93.9533C19.0449 93.9578 18.7091 93.6927 18.6637 93.3407L18.3143 90.6252C18.2735 90.3463 18.5004 90.0903 18.8135 90.0583Z"
          fill="white"
        />
        <g opacity="0.6">
          <path
            d="M26.9265 90.9225C26.5862 90.9225 26.3865 91.1923 26.4818 91.5214L26.7177 92.3397C26.813 92.6689 27.167 92.9294 27.5073 92.9249L47.241 92.4449C47.5813 92.4357 47.8445 92.1477 47.8309 91.8094L47.8173 91.5397C47.8036 91.1968 47.5087 90.918 47.1684 90.918L26.9265 90.9225Z"
            fill="white"
          />
        </g>
        <path
          d="M18.9948 90.5885C19.2897 90.4057 19.68 90.5017 19.8524 90.8034L20.6828 92.2206C20.7644 92.3623 20.9732 92.3486 21.0367 92.1977L22.9016 87.7222C22.9969 87.4982 23.3236 87.5667 23.3236 87.809C23.3372 89.1622 23.0423 91.7451 20.9459 93.9532C20.9459 93.9532 19.7526 93.5189 18.7498 91.4343C18.6091 91.1325 18.7135 90.7668 18.9948 90.5885Z"
          fill="url(#paint12_linear_75_164)"
        />
        <path
          d="M23.3373 85.4176C23.3328 85.4176 23.3283 85.4176 23.3283 85.4176L19.2944 85.477C18.7136 85.4861 18.2235 85.093 18.1555 84.5672L17.7199 81.166C17.6927 80.9649 17.7516 80.7637 17.8832 80.5991C18.0284 80.4163 18.2553 80.2974 18.5003 80.2746C18.8407 80.2426 19.308 80.1923 19.8208 80.1328C20.9415 80.0094 22.212 79.8677 22.9562 79.8403C22.9607 79.8403 22.9653 79.8403 22.9743 79.8403C23.5098 79.8266 23.9771 80.1466 24.1178 80.6174C24.3492 81.3946 24.3628 82.8803 24.3628 84.4575C24.3583 84.9741 23.9 85.4038 23.3373 85.4176ZM18.5276 80.5991C18.3687 80.6129 18.2281 80.686 18.1373 80.8003C18.0647 80.8917 18.0284 81.006 18.0466 81.1203L18.4822 84.5215C18.5276 84.8827 18.877 85.1478 19.2899 85.1433L23.3237 85.0838C23.3283 85.0838 23.3283 85.0838 23.3328 85.0838C23.7185 85.0747 24.0316 84.7912 24.0316 84.453C24.0316 82.8986 24.018 81.4403 23.8002 80.7043C23.7049 80.3797 23.3464 80.142 22.9698 80.1649C22.2347 80.1923 20.9143 80.3386 19.8571 80.4529C19.3398 80.5169 18.8679 80.5671 18.5276 80.5991Z"
          fill="white"
        />
        <path
          opacity="0.6"
          d="M18.9678 80.9333C19.8117 80.8556 21.6494 80.6225 22.5252 80.5905C22.8973 80.5767 23.224 80.7962 23.3192 81.1162C23.5007 81.7379 23.5098 82.9905 23.5098 84.1471C23.5098 84.4946 23.2013 84.778 22.8156 84.7826L19.5939 84.8283C19.1992 84.8329 18.8634 84.5677 18.818 84.2157L18.4686 81.5002C18.4278 81.2168 18.6547 80.9607 18.9678 80.9333Z"
          fill="white"
        />
        <g opacity="0.6">
          <path
            d="M27.0808 81.7936C26.7405 81.7936 26.5408 82.0634 26.6361 82.3925L26.872 83.2108C26.9673 83.54 27.3213 83.8005 27.6616 83.796L47.3953 83.316C47.7356 83.3068 47.9988 83.0188 47.9852 82.6805L47.9715 82.4108C47.9579 82.0679 47.663 81.7891 47.3227 81.7891L27.0808 81.7936Z"
            fill="white"
          />
        </g>
        <path
          d="M19.154 81.4635C19.4489 81.2807 19.8392 81.3767 20.0116 81.6784L20.8419 83.0956C20.9236 83.2373 21.1323 83.2236 21.1959 83.0727L23.0608 78.5972C23.1561 78.3732 23.4828 78.4417 23.4828 78.684C23.4964 80.0372 23.2015 82.6201 21.1051 84.8282C21.1051 84.8282 19.9118 84.3939 18.909 82.3093C18.7683 82.003 18.8727 81.6372 19.154 81.4635Z"
          fill="url(#paint13_linear_75_164)"
        />
        <path
          d="M23.392 103.253C23.3875 103.253 23.383 103.253 23.383 103.253L19.3491 103.313C18.7683 103.322 18.2782 102.929 18.2102 102.403L17.7746 99.002C17.7473 98.8008 17.8063 98.5997 17.9379 98.4351C18.0831 98.2522 18.31 98.1334 18.555 98.1105C18.8953 98.0785 19.3627 98.0282 19.8754 97.9688C20.9962 97.8453 22.2667 97.7036 23.0109 97.6762C23.0154 97.6762 23.02 97.6762 23.029 97.6762C23.5645 97.6625 24.0318 97.9825 24.1725 98.4534C24.4039 99.2305 24.4175 100.716 24.4175 102.293C24.4084 102.815 23.9547 103.24 23.392 103.253ZM18.5777 98.4397C18.4189 98.4534 18.2782 98.5265 18.1875 98.6408C18.1149 98.7322 18.0786 98.8465 18.0922 98.9608L18.5278 102.362C18.5732 102.723 18.9226 102.988 19.3355 102.984L23.3693 102.924C23.3739 102.924 23.3739 102.924 23.3784 102.924C23.7641 102.915 24.0772 102.632 24.0772 102.293C24.0772 100.739 24.0636 99.2808 23.8458 98.5448C23.7505 98.2202 23.392 97.9871 23.0154 98.0054C22.2803 98.0328 20.9599 98.1791 19.9027 98.2934C19.3899 98.3574 18.9226 98.4077 18.5777 98.4397Z"
          fill="white"
        />
        <path
          opacity="0.6"
          d="M19.0224 98.7653C19.8664 98.6876 21.7041 98.4545 22.5799 98.4225C22.9519 98.4088 23.2786 98.6282 23.3739 98.9482C23.5554 99.5699 23.5645 100.823 23.5645 101.979C23.5645 102.327 23.256 102.61 22.8703 102.615L19.6486 102.66C19.2539 102.665 18.9181 102.4 18.8727 102.048L18.5233 99.3322C18.4825 99.0534 18.7093 98.7974 19.0224 98.7653Z"
          fill="white"
        />
        <g opacity="0.6">
          <path
            d="M27.1306 99.6302C26.7903 99.6302 26.5906 99.9 26.6859 100.229L26.9218 101.047C27.0171 101.377 27.3711 101.637 27.7114 101.633L47.4451 101.153C47.7854 101.143 48.0486 100.855 48.035 100.513L48.0214 100.243C48.0077 99.9 47.7128 99.6211 47.3725 99.6211L27.1306 99.6302Z"
            fill="white"
          />
        </g>
        <path
          d="M19.2038 99.2995C19.4987 99.1166 19.889 99.2126 20.0614 99.5143L20.8918 100.932C20.9734 101.073 21.1822 101.06 21.2457 100.909L23.1106 96.4331C23.2059 96.2091 23.5326 96.2777 23.5326 96.52C23.5462 97.8731 23.2513 100.456 21.1549 102.664C21.1549 102.664 19.9616 102.23 18.9588 100.145C18.8181 99.8435 18.9225 99.4778 19.2038 99.2995Z"
          fill="url(#paint14_linear_75_164)"
        />
        <path
          d="M23.2104 111.629C23.2059 111.629 23.2013 111.629 23.2013 111.629L19.1675 111.688C18.5866 111.697 18.0966 111.304 18.0285 110.778L17.5929 107.377C17.5657 107.176 17.6247 106.975 17.7563 106.81C17.9015 106.627 18.1284 106.508 18.3734 106.486C18.7137 106.454 19.1811 106.403 19.6938 106.344C20.7601 106.225 22.0851 106.079 22.8338 106.051C23.3647 106.038 23.8502 106.348 23.9908 106.828C24.2223 107.606 24.2359 109.091 24.2359 110.668C24.2313 111.185 23.773 111.615 23.2104 111.629ZM18.4006 106.81C18.2418 106.824 18.1011 106.897 18.0104 107.011C17.9378 107.103 17.9015 107.217 17.9196 107.331L18.3552 110.732C18.4006 111.094 18.75 111.359 19.1629 111.354L23.1968 111.295C23.5779 111.276 23.9046 111.007 23.9046 110.664C23.9046 109.11 23.891 107.656 23.6732 106.915C23.5779 106.591 23.2195 106.362 22.8428 106.376C22.1078 106.403 20.7873 106.55 19.7301 106.664C19.2128 106.728 18.7409 106.778 18.4006 106.81Z"
          fill="white"
        />
        <path
          opacity="0.6"
          d="M18.8452 107.14C19.6892 107.063 21.5269 106.829 22.4026 106.797C22.7747 106.784 23.1014 107.003 23.1967 107.323C23.3782 107.945 23.3873 109.198 23.3873 110.354C23.3873 110.702 23.0787 110.985 22.693 110.99L19.4714 111.035C19.0766 111.04 18.7408 110.775 18.6955 110.423L18.3461 107.707C18.3052 107.424 18.5321 107.168 18.8452 107.14Z"
          fill="white"
        />
        <g opacity="0.6">
          <path
            d="M26.9538 108.001C26.6135 108.001 26.4138 108.27 26.5091 108.6L26.7451 109.418C26.8404 109.747 27.1943 110.008 27.5346 110.003L47.2683 109.523C47.6086 109.514 47.8718 109.226 47.8582 108.888L47.8446 108.618C47.831 108.275 47.536 107.996 47.1957 107.996L26.9538 108.001Z"
            fill="white"
          />
        </g>
        <path
          d="M19.027 107.674C19.322 107.492 19.7122 107.588 19.8846 107.889L20.715 109.306C20.7967 109.448 21.0054 109.435 21.0689 109.284L22.9338 104.808C23.0291 104.584 23.3558 104.653 23.3558 104.895C23.3694 106.248 23.0745 108.831 20.9782 111.039C20.9782 111.039 19.7848 110.605 18.782 108.52C18.6413 108.214 18.7457 107.848 19.027 107.674Z"
          fill="url(#paint15_linear_75_164)"
        />
        <path
          d="M22.9609 120.257C22.9563 120.257 22.9518 120.257 22.9518 120.257L18.9179 120.316C18.3371 120.326 17.8471 119.932 17.779 119.407L17.3434 116.005C17.3162 115.804 17.3752 115.603 17.5068 115.439C17.652 115.256 17.8788 115.137 18.1239 115.114C18.4642 115.082 18.9316 115.032 19.4443 114.972C20.5651 114.849 21.8356 114.707 22.5797 114.68C23.1288 114.675 23.5961 114.977 23.7368 115.457C23.9682 116.234 23.9818 117.72 23.9818 119.297C23.9818 119.818 23.5235 120.243 22.9609 120.257ZM18.1511 115.443C17.9923 115.457 17.8516 115.53 17.7609 115.644C17.6883 115.736 17.652 115.85 17.6656 115.964L18.1012 119.366C18.1466 119.727 18.4959 119.992 18.9089 119.987L22.9427 119.928C22.9473 119.928 22.9473 119.928 22.9518 119.928C23.3375 119.919 23.6506 119.635 23.6506 119.297C23.6506 117.743 23.637 116.284 23.4192 115.548C23.3239 115.224 22.9654 115 22.5888 115.009C21.8537 115.036 20.5333 115.183 19.4761 115.297C18.9633 115.361 18.4914 115.411 18.1511 115.443Z"
          fill="white"
        />
        <path
          opacity="0.6"
          d="M18.5913 115.773C19.4353 115.695 21.273 115.462 22.1487 115.43C22.5208 115.417 22.8475 115.636 22.9428 115.956C23.1243 116.578 23.1334 117.83 23.1334 118.987C23.1334 119.334 22.8248 119.618 22.4391 119.622L19.2175 119.668C18.8227 119.673 18.4869 119.408 18.4415 119.056L18.0922 116.34C18.0513 116.061 18.2782 115.805 18.5913 115.773Z"
          fill="white"
        />
        <g opacity="0.6">
          <path
            d="M26.7043 116.637C26.364 116.637 26.1643 116.907 26.2596 117.236L26.4956 118.055C26.5909 118.384 26.9448 118.644 27.2851 118.64L47.0188 118.16C47.3591 118.151 47.6223 117.863 47.6087 117.524L47.5951 117.255C47.5815 116.912 47.2865 116.633 46.9462 116.633L26.7043 116.637Z"
            fill="white"
          />
        </g>
        <path
          d="M18.777 116.307C19.072 116.124 19.4622 116.22 19.6346 116.522L20.465 117.939C20.5467 118.081 20.7554 118.067 20.8189 117.916L22.6838 113.441C22.7791 113.217 23.1058 113.285 23.1058 113.528C23.1194 114.881 22.8245 117.464 20.7282 119.672C20.7282 119.672 19.5348 119.238 18.532 117.153C18.3913 116.847 18.4957 116.481 18.777 116.307Z"
          fill="url(#paint16_linear_75_164)"
        />
        <path
          d="M34.2773 61.0799C32.9887 60.161 31.8634 60.1702 31.0693 60.3987C30.3433 60.609 29.8714 61.3085 29.9349 62.0628L30.248 65.8252L34.3136 66.2229C34.3091 66.2229 36.8002 62.8765 34.2773 61.0799ZM32.4623 64.0971C31.9042 64.0926 31.4504 63.6308 31.455 63.0685C31.4595 62.5062 31.9178 62.0491 32.4759 62.0536C33.034 62.0582 33.4878 62.5199 33.4833 63.0822C33.4787 63.6445 33.025 64.1017 32.4623 64.0971Z"
          fill="url(#paint17_linear_75_164)"
        />
        <path
          d="M30.5926 64.3341C30.52 64.3066 30.4701 64.2426 30.461 64.1603L30.4111 63.5615C30.402 63.4518 30.4837 63.3512 30.5972 63.342C30.7061 63.3329 30.8059 63.4152 30.815 63.5295L30.8649 64.1283C30.8739 64.2381 30.7923 64.3386 30.6788 64.3478C30.6471 64.3523 30.6198 64.3478 30.5926 64.3341ZM30.4928 63.1637C30.4202 63.1363 30.3703 63.0723 30.3612 62.99L30.3249 62.5374C30.2614 61.7648 30.7469 61.0563 31.482 60.8414C31.9856 60.6951 32.5029 60.6814 33.0202 60.7911C33.1291 60.814 33.1972 60.9237 33.1745 61.0334C33.1518 61.1431 33.0429 61.2117 32.934 61.1888C32.4802 61.0928 32.031 61.1065 31.5909 61.2345C31.0418 61.3946 30.6743 61.9294 30.7242 62.5054L30.7605 62.958C30.7696 63.0677 30.6879 63.1683 30.5745 63.1775C30.5518 63.1775 30.52 63.1729 30.4928 63.1637Z"
          fill="#BDD0FB"
        />
        <path
          d="M24.6714 68.2078L24.685 66.3197C24.6895 65.666 25.2295 65.1494 25.8784 65.1768L38.8058 65.73C39.3775 65.7528 39.8403 66.2146 39.8721 66.7906L39.9674 68.6055L24.6714 68.2078Z"
          fill="url(#paint18_linear_75_164)"
        />
        <path
          d="M28.9547 65.9291C28.8912 65.9291 28.8413 65.8743 28.8413 65.8103C28.8413 65.7463 28.8958 65.6914 28.9593 65.6914L29.5174 65.696C29.5855 65.696 29.6354 65.7508 29.6354 65.8148C29.6354 65.8788 29.5809 65.9337 29.5174 65.9337L28.9547 65.9291Z"
          fill="#BDD0FB"
        />
        <path
          d="M25.3064 67.7071C25.2293 67.6797 25.1748 67.602 25.1748 67.5151L25.1793 66.7517C25.1839 66.4362 25.3064 66.1437 25.5287 65.9242C25.7511 65.7048 26.046 65.5859 26.3546 65.5859L28.401 65.6042C28.5099 65.6042 28.6006 65.6957 28.6006 65.8099C28.6006 65.9242 28.5099 66.0111 28.3965 66.0111L26.35 65.9928C25.928 65.9882 25.5832 66.3311 25.5786 66.7563L25.5741 67.5197C25.5741 67.634 25.4834 67.7209 25.3699 67.7209C25.3518 67.7209 25.3291 67.7163 25.3064 67.7071Z"
          fill="#BDD0FB"
        />
        <path
          d="M20.6239 67.4805L43.2389 67.6679C44.0512 67.6725 44.7409 68.2714 44.8724 69.0805L44.8906 69.1903C45.0358 70.0771 44.3552 70.8772 43.4613 70.8726L20.2609 70.6806C19.73 70.676 19.308 70.2234 19.3352 69.6886L19.3942 68.6417C19.4351 67.9879 19.975 67.4759 20.6239 67.4805Z"
          fill="url(#paint19_linear_75_164)"
        />
        <path
          d="M106.996 127.02C108.235 127.129 110.385 127.303 112.082 127.376C113.103 127.422 113.689 127.321 114.029 127.184C114.029 127.221 114.029 127.257 114.024 127.294C114.015 127.472 113.87 127.618 113.693 127.628C110.49 127.806 107.94 127.692 107.032 127.632C106.846 127.618 106.733 127.417 106.828 127.253C106.873 127.175 106.932 127.097 106.996 127.02Z"
          fill="url(#paint20_linear_75_164)"
        />
        <path
          d="M112.083 127.38C110.386 127.307 108.235 127.129 106.996 127.024C108.217 125.515 112.083 124.5 112.083 124.5H113.176C113.929 125.593 114.038 126.63 114.029 127.188C113.689 127.321 113.104 127.421 112.083 127.38Z"
          fill="url(#paint21_linear_75_164)"
        />
        <path
          d="M113.357 122.699L113.253 124.738C113.244 124.958 113.076 125.145 112.858 125.177C112.64 125.209 112.345 125.214 112.037 125.108C111.846 125.044 111.706 124.884 111.669 124.683L111.315 122.699H113.357Z"
          fill="url(#paint22_linear_75_164)"
        />
        <path
          d="M127.556 127.361C128.091 127.284 128.336 127.005 128.44 126.703C128.44 126.708 128.44 126.708 128.44 126.712C128.517 127.028 128.336 127.357 127.968 127.517C127.524 127.704 127.043 127.736 126.666 127.723C126.262 127.704 125.89 127.54 125.691 127.27L125.686 127.265C126.09 127.467 126.657 127.489 127.556 127.361Z"
          fill="url(#paint23_linear_75_164)"
        />
        <path
          d="M125.019 122.688H125.922C127.297 122.66 128.154 125.577 128.44 126.706C128.34 127.008 128.095 127.287 127.555 127.364C126.657 127.492 126.09 127.465 125.686 127.264C124.946 126.281 124.579 124.841 124.402 124C124.198 123.044 125.019 122.688 125.019 122.688Z"
          fill="url(#paint24_linear_75_164)"
        />
        <path
          d="M125.804 120.793L126.303 122.8C126.367 123.047 126.249 123.298 126.022 123.417C125.741 123.563 125.346 123.714 124.987 123.668C124.815 123.646 124.674 123.527 124.62 123.367L123.885 121.259L125.804 120.793Z"
          fill="url(#paint25_linear_75_164)"
        />
        <path
          d="M126.398 121.375C125.777 121.933 123.748 122.006 123.748 122.006C116.452 104.369 113.471 101.859 113.471 101.859C114.524 108.516 113.639 123.259 113.639 123.259C112.436 123.794 110.884 123.259 110.884 123.259C110.785 112.36 109.124 102.856 107.159 95.3587C112.091 95.249 114.71 93.5483 115.567 92.8672C119.683 99.5416 126.398 121.375 126.398 121.375Z"
          fill="url(#paint26_linear_75_164)"
        />
        <path
          d="M114.32 72.5826C115.254 77.273 114.919 85.6663 114.701 89.4927C114.637 90.567 115.386 92.0619 115.989 93.0768C116.085 93.2368 116.026 93.4425 115.862 93.5248C114.855 94.046 111.434 95.6643 107.472 95.87C107.209 95.8837 106.973 95.7009 106.905 95.4449C103.965 84.3909 100.553 77.3278 100.553 77.3278C104.314 71.2614 114.32 72.5826 114.32 72.5826Z"
          fill="url(#paint27_linear_75_164)"
        />
        <path
          d="M112.976 101.443C113.017 101.443 113.058 101.434 113.099 101.407C113.208 101.338 113.244 101.197 113.176 101.082C113.135 101.018 112.191 99.4823 110.286 98.5543C110.168 98.4994 110.032 98.5451 109.973 98.664C109.918 98.7829 109.963 98.92 110.081 98.9794C111.86 99.8435 112.768 101.315 112.777 101.329C112.822 101.402 112.899 101.443 112.976 101.443Z"
          fill="#91B3FA"
        />
        <path
          d="M120.173 86.0402C119.874 88.2254 118.989 90.6072 117.215 93.1398L116.543 92.5867C116.543 92.5867 117.319 89.4095 116.879 85.8025C117.972 85.5831 119.261 85.8071 120.173 86.0402Z"
          fill="url(#paint28_linear_75_164)"
        />
        <path
          d="M113.276 78.3657L114.32 72.5781C114.32 72.5781 121.285 77.9406 120.173 86.0368C119.261 85.8036 117.972 85.5842 116.879 85.799C116.561 83.2024 115.608 80.3818 113.276 78.3657Z"
          fill="url(#paint29_linear_75_164)"
        />
        <path
          d="M100.548 77.3281L103.234 83.1614C102.798 86.6815 100.92 88.2038 98.8961 88.789C98.7691 87.1844 98.3652 85.8861 97.9932 84.99C100.584 82.2974 100.548 77.3281 100.548 77.3281Z"
          fill="url(#paint30_linear_75_164)"
        />
        <path
          d="M97.9978 84.9883C98.3699 85.8843 98.7737 87.1826 98.9008 88.7872C93.5011 90.8993 92.0718 86.8032 92.0718 86.8032L93.07 86.6249C95.3206 86.8626 96.8952 86.1312 97.9978 84.9883Z"
          fill="url(#paint31_linear_75_164)"
        />
        <path
          d="M103.025 70.1225L104.323 74.9272C104.468 75.4667 105.049 75.7593 105.566 75.549C106.125 75.325 106.828 75.0187 107.436 74.6895C108.085 74.3375 108.289 73.4963 107.876 72.8792L105.176 68.8242L103.025 70.1225Z"
          fill="url(#paint32_linear_75_164)"
        />
        <path
          d="M89.5947 83.5859L122.85 95.7783C124.243 96.2903 124.91 97.8903 124.298 99.2526L124.198 99.4766C123.653 100.679 122.242 101.209 121.049 100.652L88.7598 85.602L89.5947 83.5859Z"
          fill="url(#paint33_linear_75_164)"
        />
        <path
          opacity="0.23"
          d="M74.3074 92.4952C83.3741 92.4952 90.7242 85.2231 90.7242 76.2525C90.7242 67.2819 83.3741 60.0098 74.3074 60.0098C65.2407 60.0098 57.8906 67.2819 57.8906 76.2525C57.8906 85.2231 65.2407 92.4952 74.3074 92.4952Z"
          fill="white"
        />
        <path
          d="M56.0439 76.251C56.0439 86.2307 64.2206 94.3223 74.312 94.3223C84.399 94.3223 92.5801 86.2307 92.5801 76.251C92.5801 66.2713 84.4035 58.1797 74.312 58.1797C64.2206 58.1797 56.0439 66.2668 56.0439 76.251ZM58.7256 76.251C58.7256 67.7388 65.7043 60.8358 74.3075 60.8358C82.9107 60.8358 89.8894 67.7388 89.8894 76.251C89.8894 84.7632 82.9107 91.6663 74.3075 91.6663C65.7043 91.6663 58.7256 84.7632 58.7256 76.251Z"
          fill="url(#paint34_linear_75_164)"
        />
        <path
          d="M91.187 78.443C91.1825 78.443 91.1825 78.443 91.1779 78.443C91.1371 78.4384 91.1053 78.3973 91.1099 78.3562C91.1643 77.9356 91.2006 77.5058 91.2233 77.0761C91.2233 77.035 91.2641 76.9984 91.305 77.003C91.3458 77.003 91.3821 77.0395 91.3776 77.0853C91.3549 77.515 91.3186 77.9539 91.2641 78.379C91.2596 78.4156 91.2233 78.443 91.187 78.443ZM91.06 73.3914C91.0237 73.3914 90.9919 73.364 90.9828 73.3274C90.7786 72.18 90.4519 71.0508 90.0072 69.9719C87.4027 63.6129 81.2407 59.5031 74.3029 59.5031C71.0676 59.5031 67.9231 60.4083 65.2096 62.1226C65.1733 62.1454 65.128 62.1363 65.1007 62.0997C65.0781 62.0632 65.0871 62.0129 65.1234 61.99C67.8641 60.262 71.0358 59.3477 74.2983 59.3477C81.2997 59.3477 87.5161 63.4941 90.1434 69.9125C90.5881 71.0005 90.9193 72.1434 91.128 73.3C91.1371 73.3412 91.1099 73.3823 91.0645 73.3914C91.069 73.3914 91.0645 73.3914 91.06 73.3914Z"
          fill="#BDD0FB"
        />
        <path
          d="M116.82 92.4865L113.675 92.2305L112.314 93.4968C112.314 93.4968 112.636 93.9448 113.643 93.6888C114.651 93.4328 116.03 93.3688 116.03 93.3688C116.03 93.3688 117.419 93.9997 117.437 92.8202L116.82 92.4865Z"
          fill="url(#paint35_linear_75_164)"
        />
        <path
          d="M92.4712 87.5533C92.1989 87.7682 91.2687 87.3202 90.697 87.0139C90.4202 86.863 90.2841 86.5339 90.3794 86.2322C90.5155 85.7979 90.7469 85.2356 91.0283 85.1624C91.4956 85.0436 93.5874 86.671 92.4712 87.5533Z"
          fill="url(#paint36_linear_75_164)"
        />
        <path
          d="M122.192 100.137C122.16 100.137 122.128 100.118 122.119 100.086C122.106 100.045 122.128 99.9995 122.169 99.9857C123.127 99.652 123.63 99.108 123.662 98.372C123.694 97.6268 123.226 96.932 122.5 96.6485L118.507 95.0805C118.467 95.0668 118.448 95.021 118.462 94.9799C118.476 94.9388 118.521 94.9205 118.562 94.9342L122.555 96.5022C123.344 96.8131 123.853 97.5674 123.816 98.3766C123.78 99.1857 123.245 99.7755 122.219 100.132C122.21 100.137 122.201 100.137 122.192 100.137Z"
          fill="#BDD0FB"
        />
        <path
          d="M117.3 94.6026C117.291 94.6026 117.282 94.6026 117.273 94.598L116.756 94.3969C116.715 94.3832 116.697 94.3375 116.711 94.2963C116.724 94.2552 116.77 94.2369 116.81 94.2506L117.328 94.4518C117.368 94.4655 117.387 94.5112 117.373 94.5523C117.359 94.5843 117.332 94.6026 117.3 94.6026Z"
          fill="#BDD0FB"
        />
        <path
          d="M102.744 65.4043C102.744 65.4043 101.669 67.8912 101.596 69.1941C101.523 70.497 101.247 71.3473 102.744 71.6079C104.241 71.8685 105.503 71.1187 106.188 69.8204C106.188 69.8204 107.259 67.8181 107.018 66.9952C106.778 66.1769 102.744 65.4043 102.744 65.4043Z"
          fill="url(#paint37_linear_75_164)"
        />
        <path
          d="M105.675 68.8863H105.485C105.485 68.8863 106.265 67.2726 105.58 66.9892C104.895 66.7057 102.181 66.148 101.596 65.1788C101.033 64.2417 101.537 63.0348 102.29 62.6965C102.34 62.6736 102.395 62.6965 102.417 62.7422L102.481 62.861C102.522 62.9433 102.644 62.9296 102.667 62.8428C102.69 62.7605 102.803 62.7422 102.848 62.8153C103.03 63.1033 103.515 63.5788 104.813 63.8211C106.66 64.1639 107.88 64.9182 107.912 66.2028C107.912 66.2851 107.998 66.3308 108.071 66.2851C108.207 66.2028 108.425 66.1617 108.715 66.4086C109.224 66.8383 109.015 67.9537 107.903 68.8726C107.849 68.9183 107.849 69.0006 107.908 69.0372C108.107 69.1698 108.411 69.4852 107.631 69.9058C106.832 70.3355 106.365 70.2898 106.183 70.2441C106.134 70.2304 106.102 70.1892 106.106 70.1389L106.174 69.0006C106.179 68.9412 106.134 68.8909 106.075 68.8909H105.675V68.8863Z"
          fill="url(#paint38_linear_75_164)"
        />
        <path
          d="M105.63 69.1254C105.63 69.1254 106.038 67.5391 106.746 67.9825C107.454 68.426 106.379 69.7609 105.811 69.8203L105.63 69.1254Z"
          fill="url(#paint39_linear_75_164)"
        />
        <path
          d="M65.532 70.2916C68.2999 73.0299 70.6867 75.8734 72.7739 78.8083C75.8821 71.6722 79.1945 65.0389 82.7792 59.0821L91.5729 56.1289C85.5153 64.0834 79.0584 75.942 73.5408 87.8326C69.5478 82.1639 65.5638 76.5089 62.687 74.5019L65.532 70.2916Z"
          fill="url(#paint40_linear_75_164)"
        />
        <path
          d="M32.7847 43.7028C33.5379 44.4754 34.0234 45.5178 34.2457 46.8298H31.9361C31.7637 46.2995 31.5051 45.8789 31.1512 45.5772C30.7972 45.2755 30.3798 45.12 29.8943 45.12C29.2545 45.12 28.7417 45.4172 28.347 46.0161C27.9567 46.6149 27.7616 47.4104 27.7616 48.4115C27.7616 49.4127 27.9567 50.2036 28.347 50.7979C28.7372 51.3876 29.2545 51.6848 29.8943 51.6848C30.3798 51.6848 30.7972 51.5339 31.1512 51.2276C31.5051 50.9259 31.7683 50.5099 31.9361 49.9887H34.2457C34.0234 51.2916 33.5379 52.3294 32.7847 53.1065C32.0314 53.8837 31.0785 54.2723 29.9306 54.2723C29.0548 54.2723 28.2834 54.0254 27.6164 53.5317C26.9539 53.0379 26.4412 52.3476 26.0782 51.4562C25.7152 50.5647 25.5337 49.5499 25.5337 48.4115C25.5337 47.2732 25.7152 46.2583 26.0782 45.3669C26.4412 44.4754 26.9539 43.7851 27.6164 43.2914C28.2789 42.7977 29.0503 42.5508 29.9306 42.5508C31.0831 42.5462 32.0314 42.9348 32.7847 43.7028Z"
          fill="url(#paint41_linear_75_164)"
        />
        <path
          d="M42.0864 43.2413C42.7807 43.7442 43.3252 44.4482 43.729 45.3442C44.1283 46.2402 44.328 47.2505 44.328 48.3797C44.328 49.5089 44.1238 50.5238 43.7199 51.4244C43.3161 52.325 42.767 53.029 42.0728 53.5318C41.3786 54.0347 40.6117 54.2907 39.7677 54.2907C38.9238 54.2907 38.1569 54.0393 37.4627 53.5318C36.7684 53.029 36.2194 52.325 35.8155 51.4244C35.4117 50.5238 35.2075 49.5089 35.2075 48.3797C35.2075 47.2505 35.4117 46.2402 35.8155 45.3442C36.2194 44.4482 36.7684 43.7487 37.4627 43.2413C38.1569 42.7384 38.9238 42.4824 39.7677 42.4824C40.6163 42.4824 41.3922 42.7339 42.0864 43.2413ZM38.0616 45.9614C37.6396 46.5511 37.4309 47.3603 37.4309 48.3797C37.4309 49.39 37.6396 50.1946 38.0616 50.7889C38.4836 51.3878 39.0508 51.6849 39.7677 51.6849C40.4756 51.6849 41.0428 51.3878 41.4648 50.7889C41.8913 50.19 42.1046 49.39 42.1046 48.3797C42.1046 47.3694 41.8958 46.5648 41.4738 45.9705C41.0519 45.3716 40.4847 45.0745 39.7677 45.0745C39.0508 45.0745 38.4836 45.3671 38.0616 45.9614Z"
          fill="url(#paint42_linear_75_164)"
        />
        <path
          d="M55.7084 42.7422V54.1756H53.5213V47.0257L51.5792 54.1756H49.6871L47.7314 47.012V54.1756H45.5488V42.7422H48.2169L50.6581 50.7058L53.0448 42.7422H55.7084Z"
          fill="url(#paint43_linear_75_164)"
        />
        <path
          d="M59.3974 50.1392V54.1759H57.2148V42.6602H60.7541C61.825 42.6602 62.6463 42.9985 63.2044 43.6796C63.767 44.3562 64.0484 45.2751 64.0484 46.4225C64.0484 47.1403 63.9213 47.7757 63.6717 48.338C63.4222 48.8957 63.0501 49.3392 62.5555 49.6592C62.0609 49.9792 61.462 50.1392 60.7541 50.1392H59.3974ZM61.825 46.4225C61.825 45.4122 61.3848 44.9094 60.5091 44.9094H59.3974V47.9037H60.5091C61.3848 47.9083 61.825 47.41 61.825 46.4225Z"
          fill="url(#paint44_linear_75_164)"
        />
        <path
          d="M67.3061 52.041H70.2192V54.1759H65.1235V42.6602H67.3061V52.041Z"
          fill="url(#paint45_linear_75_164)"
        />
        <path
          d="M73.4088 44.8774V47.2866H76.4625V49.3895H73.4088V51.945H76.8437V54.1759H71.2217V42.6602H76.8437V44.8728H73.4088V44.8774Z"
          fill="url(#paint46_linear_75_164)"
        />
        <path
          d="M84.576 42.6602V44.8728H82.1257V54.1713H79.9295V44.8728H77.502V42.6602H84.576Z"
          fill="url(#paint47_linear_75_164)"
        />
        <path
          d="M87.6793 44.8774V47.2866H90.733V49.3895H87.6793V51.945H91.1142V54.1759H85.4922V42.6602H91.1142V44.8728H87.6793V44.8774Z"
          fill="url(#paint48_linear_75_164)"
        />
        <path
          d="M99.9085 51.401C99.5273 52.2741 98.9828 52.9553 98.275 53.4444C97.5626 53.9336 96.7277 54.1759 95.7657 54.1759H92.3535V42.6602H95.7657C96.7368 42.6602 97.5762 42.8979 98.2841 43.3779C98.9919 43.8579 99.5319 44.5299 99.913 45.3985C100.29 46.2671 100.48 47.2683 100.48 48.3929C100.476 49.522 100.285 50.5278 99.9085 51.401ZM97.5581 50.8204C98.03 50.2444 98.2659 49.4352 98.2659 48.3929C98.2659 47.3506 98.03 46.5414 97.5581 45.9654C97.0862 45.3894 96.4237 45.1014 95.5706 45.1014H94.5361V51.6798H95.5706C96.4237 51.6844 97.0862 51.3964 97.5581 50.8204Z"
          fill="url(#paint49_linear_75_164)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_75_164"
            x1="143.52"
            y1="165.828"
            x2="29.4425"
            y2="25.205"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#DAE3FE" />
            <stop offset="1" stop-color="#E9EFFD" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_75_164"
            x1="74.0995"
            y1="98.8283"
            x2="55.5329"
            y2="145.249"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_75_164"
            x1="78.4107"
            y1="28.531"
            x2="53.7203"
            y2="102.051"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_75_164"
            x1="47.0376"
            y1="146.513"
            x2="75.5661"
            y2="116.572"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_75_164"
            x1="116.109"
            y1="-13.9966"
            x2="54.8972"
            y2="66.1674"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_75_164"
            x1="44.401"
            y1="0.439563"
            x2="73.3983"
            y2="51.0646"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_75_164"
            x1="52.8969"
            y1="-4.42556"
            x2="81.8942"
            y2="46.1994"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_75_164"
            x1="61.5806"
            y1="-9.40067"
            x2="90.578"
            y2="41.2243"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_75_164"
            x1="69.98"
            y1="-14.2113"
            x2="98.9774"
            y2="36.4137"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_75_164"
            x1="78.5858"
            y1="-19.1403"
            x2="107.583"
            y2="31.4847"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_75_164"
            x1="48.5881"
            y1="73.7216"
            x2="-1.71086"
            y2="150.456"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4F52FF" />
            <stop offset="1" stop-color="#4042E2" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_75_164"
            x1="37.8882"
            y1="88.4961"
            x2="-7.24597"
            y2="158.866"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF928E" />
            <stop offset="1" stop-color="#FEB3B1" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_75_164"
            x1="339.254"
            y1="-742.064"
            x2="358.727"
            y2="-792.241"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_75_164"
            x1="336.352"
            y1="-743.19"
            x2="355.825"
            y2="-793.367"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_75_164"
            x1="342.335"
            y1="-740.866"
            x2="361.808"
            y2="-791.043"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_75_164"
            x1="344.968"
            y1="-739.843"
            x2="364.441"
            y2="-790.019"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_75_164"
            x1="347.623"
            y1="-738.816"
            x2="367.097"
            y2="-788.993"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_75_164"
            x1="41.0944"
            y1="59.4986"
            x2="16.9556"
            y2="70.252"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_75_164"
            x1="40.1174"
            y1="57.1212"
            x2="23.293"
            y2="78.7142"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_75_164"
            x1="38.0288"
            y1="58.4398"
            x2="26.3378"
            y2="79.3324"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_75_164"
            x1="114.028"
            y1="127.373"
            x2="106.79"
            y2="127.373"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4F52FF" />
            <stop offset="1" stop-color="#4042E2" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_75_164"
            x1="114.029"
            y1="125.943"
            x2="106.995"
            y2="125.943"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_75_164"
            x1="113.36"
            y1="123.948"
            x2="111.321"
            y2="123.948"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_75_164"
            x1="128.456"
            y1="127.214"
            x2="125.683"
            y2="127.214"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4F52FF" />
            <stop offset="1" stop-color="#4042E2" />
          </linearGradient>
          <linearGradient
            id="paint24_linear_75_164"
            x1="128.436"
            y1="125.066"
            x2="124.365"
            y2="125.066"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint25_linear_75_164"
            x1="126.32"
            y1="122.236"
            x2="123.884"
            y2="122.236"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint26_linear_75_164"
            x1="130.877"
            y1="52.241"
            x2="117.928"
            y2="103.038"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4F52FF" />
            <stop offset="1" stop-color="#4042E2" />
          </linearGradient>
          <linearGradient
            id="paint27_linear_75_164"
            x1="114.485"
            y1="75.3968"
            x2="92.6759"
            y2="109.845"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint28_linear_75_164"
            x1="115.158"
            y1="86.4569"
            x2="123.888"
            y2="94.1298"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint29_linear_75_164"
            x1="118.214"
            y1="77.7581"
            x2="96.4054"
            y2="112.206"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint30_linear_75_164"
            x1="107.964"
            y1="71.2691"
            x2="86.155"
            y2="105.717"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint31_linear_75_164"
            x1="98.8992"
            y1="87.1882"
            x2="92.0688"
            y2="87.1882"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint32_linear_75_164"
            x1="105.538"
            y1="68.7991"
            x2="105.614"
            y2="81.6499"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint33_linear_75_164"
            x1="124.524"
            y1="92.2304"
            x2="88.7561"
            y2="92.2304"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint34_linear_75_164"
            x1="92.5748"
            y1="76.2493"
            x2="56.0422"
            y2="76.2493"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint35_linear_75_164"
            x1="111.733"
            y1="90.3539"
            x2="120.463"
            y2="98.027"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint36_linear_75_164"
            x1="92.7946"
            y1="86.3805"
            x2="90.3485"
            y2="86.3805"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint37_linear_75_164"
            x1="102.519"
            y1="67.5936"
            x2="108.693"
            y2="72.2828"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint38_linear_75_164"
            x1="106.833"
            y1="63.8553"
            x2="101.221"
            y2="71.0274"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#09005D" />
            <stop offset="1" stop-color="#1A0F91" />
          </linearGradient>
          <linearGradient
            id="paint39_linear_75_164"
            x1="103.281"
            y1="66.5905"
            x2="109.455"
            y2="71.2797"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FEBBBA" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint40_linear_75_164"
            x1="66.1578"
            y1="86.856"
            x2="98.0859"
            y2="25.1061"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FE7062" />
            <stop offset="1" stop-color="#FF928E" />
          </linearGradient>
          <linearGradient
            id="paint41_linear_75_164"
            x1="25.5381"
            y1="48.4114"
            x2="34.2491"
            y2="48.4114"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint42_linear_75_164"
            x1="35.2069"
            y1="48.3871"
            x2="44.3266"
            y2="48.3871"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint43_linear_75_164"
            x1="45.5531"
            y1="48.4596"
            x2="55.7074"
            y2="48.4596"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint44_linear_75_164"
            x1="57.2147"
            y1="48.4191"
            x2="64.0481"
            y2="48.4191"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint45_linear_75_164"
            x1="65.1208"
            y1="48.4191"
            x2="70.2171"
            y2="48.4191"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint46_linear_75_164"
            x1="71.2259"
            y1="48.4191"
            x2="76.8459"
            y2="48.4191"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint47_linear_75_164"
            x1="77.4976"
            y1="48.4191"
            x2="84.5737"
            y2="48.4191"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint48_linear_75_164"
            x1="85.493"
            y1="48.4191"
            x2="91.113"
            y2="48.4191"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
          <linearGradient
            id="paint49_linear_75_164"
            x1="92.3526"
            y1="48.4191"
            x2="100.476"
            y2="48.4191"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4042E2" />
            <stop offset="1" stop-color="#4F52FF" />
          </linearGradient>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const NavbarSearchIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.28125 10.8142C5.28128 8.1738 7.14649 5.90116 9.73613 5.38614C12.3258 4.87113 14.9187 6.25721 15.9289 8.69667C16.9392 11.1362 16.0855 13.9495 13.89 15.4162C11.6944 16.8829 8.76852 16.5944 6.90173 14.7271C5.86412 13.6893 5.28123 12.2817 5.28125 10.8142Z"
          stroke={color}
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3477 16.3477L18.7198 18.7198"
          stroke={color}
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarSearchDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.2793 10.8147C5.27933 8.17429 7.14454 5.90164 9.73418 5.38663C12.3239 4.87162 14.9167 6.2577 15.9269 8.69716C16.9372 11.1366 16.0835 13.95 13.888 15.4167C11.6925 16.8834 8.76656 16.5949 6.89978 14.7276C5.86217 13.6898 5.27928 12.2822 5.2793 10.8147Z"
          stroke="white"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3477 16.3481L18.7198 18.7203"
          stroke="white"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarWhatsAppIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1054_36798)">
          <path
            d="M8.00971 25.6929L8.4945 25.9353C10.5145 27.1473 12.7768 27.7128 15.0392 27.7128C22.1494 27.7128 27.9669 21.8954 27.9669 14.7851C27.9669 11.3916 26.5933 8.07888 24.1693 5.65494C21.7454 3.23099 18.5135 1.85742 15.0392 1.85742C7.92891 1.85742 2.11144 7.67489 2.19224 14.8659C2.19224 17.2899 2.91942 19.633 4.13139 21.653L4.45459 22.1378L3.16182 26.9049L8.00971 25.6929Z"
            fill="#00E676"
          />
          <path
            d="M25.5425 4.3631C22.7954 1.53517 18.9979 0 15.1195 0C6.87813 0 0.252673 6.70625 0.333471 14.8669C0.333471 17.4524 1.06066 19.9572 2.27263 22.2195L0.171875 29.8953L8.0093 27.8754C10.1909 29.0874 12.6148 29.6529 15.0387 29.6529C23.1994 29.6529 29.8248 22.9467 29.8248 14.7861C29.8248 10.827 28.2896 7.11024 25.5425 4.3631ZM15.1195 27.1482C12.938 27.1482 10.7564 26.5826 8.89808 25.4514L8.41329 25.209L3.727 26.421L4.93897 21.8155L4.61578 21.3307C1.06065 15.5941 2.75742 7.99902 8.57489 4.4439C14.3924 0.88878 21.9066 2.58554 25.4617 8.40301C29.0168 14.2205 27.3201 21.7347 21.5026 25.2898C19.6442 26.5018 17.3819 27.1482 15.1195 27.1482ZM22.2298 18.1796L21.341 17.7756C21.341 17.7756 20.0482 17.21 19.2402 16.806C19.1595 16.806 19.0787 16.7252 18.9979 16.7252C18.7555 16.7252 18.5939 16.806 18.4323 16.8868C18.4323 16.8868 18.3515 16.9676 17.2203 18.2604C17.1395 18.422 16.9779 18.5028 16.8163 18.5028H16.7355C16.6547 18.5028 16.4931 18.422 16.4123 18.3412L16.0083 18.1796C15.1195 17.7756 14.3116 17.2908 13.6652 16.6444C13.5036 16.4828 13.2612 16.3212 13.0996 16.1596C12.534 15.5941 11.9684 14.9477 11.5644 14.2205L11.4836 14.0589C11.4028 13.9781 11.4028 13.8973 11.322 13.7357C11.322 13.5741 11.322 13.4125 11.4028 13.3317C11.4028 13.3317 11.726 12.9277 11.9684 12.6853C12.13 12.5237 12.2108 12.2813 12.3724 12.1197C12.534 11.8773 12.6148 11.5541 12.534 11.3117C12.4532 10.9078 11.4836 8.72621 11.2412 8.24142C11.0796 7.99902 10.918 7.91822 10.6756 7.83742H10.4332C10.2716 7.83742 10.0293 7.83742 9.78686 7.83742C9.62526 7.83742 9.46367 7.91822 9.30207 7.91822L9.22127 7.99902C9.05968 8.07982 8.89808 8.24142 8.73648 8.32221C8.57489 8.48381 8.49409 8.64541 8.33249 8.807C7.76691 9.53419 7.44371 10.423 7.44371 11.3117C7.44371 11.9581 7.60531 12.6045 7.8477 13.1701L7.9285 13.4125C8.65569 14.9477 9.62526 16.3212 10.918 17.5332L11.2412 17.8564C11.4836 18.0988 11.726 18.2604 11.8876 18.5028C13.5844 19.9572 15.5235 21.0075 17.7051 21.5731C17.9475 21.6539 18.2707 21.6539 18.5131 21.7347C18.7555 21.7347 19.0787 21.7347 19.321 21.7347C19.725 21.7347 20.2098 21.5731 20.533 21.4115C20.7754 21.2499 20.937 21.2499 21.0986 21.0883L21.2602 20.9267C21.4218 20.7651 21.5834 20.6843 21.745 20.5227C21.9066 20.3611 22.0682 20.1995 22.149 20.038C22.3106 19.7148 22.3914 19.3108 22.4722 18.9068C22.4722 18.7452 22.4722 18.5028 22.4722 18.3412C22.4722 18.3412 22.3914 18.2604 22.2298 18.1796Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_36798">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const NavbarSaleOrderIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.28247 22.5H25C24.9956 23.662 24.973 24.5285 24.8582 25.2133C24.7216 26.0285 24.4717 26.4602 24.0886 26.7677C23.7054 27.0752 23.1674 27.2758 22.1514 27.3854C21.1055 27.4983 19.7192 27.5 17.7317 27.5H12.1933C10.2057 27.5 8.81957 27.4983 7.7737 27.3854C6.7577 27.2758 6.21966 27.0752 5.83645 26.7677C5.45324 26.4602 5.20339 26.0285 5.06679 25.2133C5.05652 25.152 5.04701 25.0893 5.03816 25.025C4.98806 24.661 4.96301 24.4789 5.1212 24.0496C5.27939 23.6205 5.34796 23.5531 5.48514 23.4184C5.89189 23.0189 6.44977 22.7231 7.09151 22.5851C7.4544 22.5071 7.92795 22.5 9.28247 22.5Z"
          fill="#AEB2C2"
        />
        <path
          d="M5.90897 3.91665C6.29072 3.53169 6.82669 3.2807 7.83879 3.14347C8.88065 3.00221 10.2615 3 12.2414 3H17.7586C19.7385 3 21.1194 3.00221 22.1612 3.14347C23.1734 3.2807 23.7092 3.53169 24.091 3.91665C24.4727 4.30163 24.7216 4.8421 24.8577 5.86275C24.9977 6.91341 25 8.30592 25 10.3025V23H9.28247C7.92795 23 7.4544 23.0071 7.09151 23.0851C6.44977 23.2231 5.89189 23.5189 5.48514 23.9184C5.34796 24.0531 5.27939 24.1205 5.1212 24.5496C5.03044 24.7959 5 24.9609 5 25.1254V10.3025C5 8.30592 5.0022 6.91341 5.14228 5.86275C5.27835 4.8421 5.52724 4.30163 5.90897 3.91665Z"
          fill="#646B88"
        />
        <path
          opacity="0.5"
          d="M9.0625 5.9375C9.0625 5.41974 9.48224 5 10 5H20C20.5177 5 20.9375 5.41974 20.9375 5.9375C20.9375 6.45526 20.5177 6.875 20 6.875H10C9.48224 6.875 9.0625 6.45526 9.0625 5.9375Z"
          fill="#F8F9FC"
        />
        <path
          opacity="0.5"
          d="M10 9.375C9.48224 9.375 9.0625 9.79475 9.0625 10.3125C9.0625 10.8303 9.48224 11.25 10 11.25H16.25C16.7677 11.25 17.1875 10.8303 17.1875 10.3125C17.1875 9.79475 16.7677 9.375 16.25 9.375H10Z"
          fill="#F8F9FC"
        />
        <path
          opacity="0.5"
          d="M20 12.5C17.9337 12.5 16.25 14.1837 16.25 16.25C16.25 18.3162 17.9337 20 20 20C22.0662 20 23.75 18.3162 23.75 16.25C23.75 14.1837 22.0662 12.5 20 12.5ZM21.5 16.5312H20.2812V17.75C20.2812 17.9037 20.1537 18.0312 20 18.0312C19.8463 18.0312 19.7188 17.9037 19.7188 17.75V16.5312H18.5C18.3463 16.5312 18.2188 16.4037 18.2188 16.25C18.2188 16.0963 18.3463 15.9688 18.5 15.9688H19.7188V14.75C19.7188 14.5963 19.8463 14.4688 20 14.4688C20.1537 14.4688 20.2812 14.5963 20.2812 14.75V15.9688H21.5C21.6537 15.9688 21.7812 16.0963 21.7812 16.25C21.7812 16.4037 21.6537 16.5312 21.5 16.5312Z"
          fill="#F8F9FC"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarSaleOrderDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.28247 22.5H25C24.9956 23.662 24.973 24.5285 24.8582 25.2133C24.7216 26.0285 24.4717 26.4602 24.0886 26.7677C23.7054 27.0752 23.1674 27.2758 22.1514 27.3854C21.1055 27.4983 19.7192 27.5 17.7317 27.5H12.1933C10.2057 27.5 8.81957 27.4983 7.7737 27.3854C6.7577 27.2758 6.21966 27.0752 5.83645 26.7677C5.45324 26.4602 5.20339 26.0285 5.06679 25.2133C5.05652 25.152 5.04701 25.0893 5.03816 25.025C4.98806 24.661 4.96301 24.4789 5.1212 24.0496C5.27939 23.6205 5.34796 23.5531 5.48514 23.4184C5.89189 23.0189 6.44977 22.7231 7.09151 22.5851C7.4544 22.5071 7.92795 22.5 9.28247 22.5Z"
          fill="#232529"
        />
        <path
          d="M5.90897 3.41665C6.29072 3.03169 6.82669 2.7807 7.83879 2.64347C8.88065 2.50221 10.2615 2.5 12.2414 2.5H17.7586C19.7385 2.5 21.1194 2.50221 22.1612 2.64347C23.1734 2.7807 23.7092 3.03169 24.091 3.41665C24.4727 3.80163 24.7216 4.3421 24.8577 5.36275C24.9977 6.41341 25 7.80592 25 9.80253V22.5H9.28247C7.92795 22.5 7.4544 22.5071 7.09151 22.5851C6.44977 22.7231 5.89189 23.0189 5.48514 23.4184C5.34796 23.5531 5.27939 23.6205 5.1212 24.0496C5.03044 24.2959 5 24.4609 5 24.6254V9.80253C5 7.80592 5.0022 6.41341 5.14228 5.36275C5.27835 4.3421 5.52724 3.80163 5.90897 3.41665Z"
          fill="white"
        />
        <path
          d="M9.0625 5.9375C9.0625 5.41974 9.48224 5 10 5H20C20.5177 5 20.9375 5.41974 20.9375 5.9375C20.9375 6.45526 20.5177 6.875 20 6.875H10C9.48224 6.875 9.0625 6.45526 9.0625 5.9375Z"
          fill="#2C2E33"
        />
        <path
          d="M10 9.375C9.48224 9.375 9.0625 9.79475 9.0625 10.3125C9.0625 10.8303 9.48224 11.25 10 11.25H16.25C16.7677 11.25 17.1875 10.8303 17.1875 10.3125C17.1875 9.79475 16.7677 9.375 16.25 9.375H10Z"
          fill="#2C2E33"
        />
        <path
          d="M20 12.5C17.9337 12.5 16.25 14.1837 16.25 16.25C16.25 18.3162 17.9337 20 20 20C22.0662 20 23.75 18.3162 23.75 16.25C23.75 14.1837 22.0662 12.5 20 12.5ZM21.5 16.5312H20.2812V17.75C20.2812 17.9037 20.1537 18.0312 20 18.0312C19.8463 18.0312 19.7188 17.9037 19.7188 17.75V16.5312H18.5C18.3463 16.5312 18.2188 16.4037 18.2188 16.25C18.2188 16.0963 18.3463 15.9688 18.5 15.9688H19.7188V14.75C19.7188 14.5963 19.8463 14.4688 20 14.4688C20.1537 14.4688 20.2812 14.5963 20.2812 14.75V15.9688H21.5C21.6537 15.9688 21.7812 16.0963 21.7812 16.25C21.7812 16.4037 21.6537 16.5312 21.5 16.5312Z"
          fill="#2C2E33"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarSunIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 15C21.25 18.4517 18.4517 21.25 15 21.25C11.5482 21.25 8.75 18.4517 8.75 15C8.75 11.5482 11.5482 8.75 15 8.75C18.4517 8.75 21.25 11.5482 21.25 15Z"
          fill="#646B88"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V5C15.9375 5.51776 15.5177 5.9375 15 5.9375C14.4822 5.9375 14.0625 5.51776 14.0625 5V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H5C5.51776 14.0625 5.9375 14.4822 5.9375 15C5.9375 15.5177 5.51776 15.9375 5 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM24.0625 15C24.0625 14.4822 24.4822 14.0625 25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H25C24.4822 15.9375 24.0625 15.5177 24.0625 15ZM15 24.0625C15.5177 24.0625 15.9375 24.4822 15.9375 25V27.5C15.9375 28.0177 15.5177 28.4375 15 28.4375C14.4822 28.4375 14.0625 28.0177 14.0625 27.5V25C14.0625 24.4822 14.4822 24.0625 15 24.0625Z"
          fill="#646B88"
        />
        <g opacity="0.5">
          <path
            d="M4.58545 4.64499C4.93483 4.26286 5.52783 4.23633 5.90995 4.5857L8.68748 7.12517C9.0696 7.47455 9.09614 8.06755 8.74676 8.44968C8.39739 8.8318 7.80439 8.85835 7.42228 8.50898L4.64475 5.96949C4.26263 5.62011 4.23608 5.02711 4.58545 4.64499Z"
            fill="#646B88"
          />
          <path
            d="M25.4148 4.64474C25.7641 5.02687 25.7376 5.61987 25.3555 5.96924L22.5779 8.50873C22.1958 8.85811 21.6028 8.83156 21.2534 8.44943C20.904 8.06731 20.9306 7.47431 21.3128 7.12493L24.0903 4.58546C24.4724 4.23608 25.0654 4.26262 25.4148 4.64474Z"
            fill="#646B88"
          />
          <path
            d="M21.2825 21.2804C21.6486 20.9143 22.2421 20.9144 22.6082 21.2805L25.3857 24.0584C25.7518 24.4245 25.7518 25.018 25.3857 25.3841C25.0196 25.7503 24.426 25.7503 24.0598 25.384L21.2823 22.6063C20.9162 22.24 20.9163 21.6465 21.2825 21.2804Z"
            fill="#646B88"
          />
          <path
            d="M8.71804 21.2805C9.08415 21.6465 9.08415 22.2401 8.71804 22.6062L5.94026 25.384C5.57414 25.7501 4.98055 25.7501 4.61444 25.384C4.24831 25.0178 4.24831 24.4243 4.61444 24.0582L7.39221 21.2803C7.75832 20.9143 8.35192 20.9143 8.71804 21.2805Z"
            fill="#646B88"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const NavbarSunDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 15C21.25 18.4517 18.4517 21.25 15 21.25C11.5482 21.25 8.75 18.4517 8.75 15C8.75 11.5482 11.5482 8.75 15 8.75C18.4517 8.75 21.25 11.5482 21.25 15Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V5C15.9375 5.51776 15.5177 5.9375 15 5.9375C14.4822 5.9375 14.0625 5.51776 14.0625 5V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H5C5.51776 14.0625 5.9375 14.4822 5.9375 15C5.9375 15.5177 5.51776 15.9375 5 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM24.0625 15C24.0625 14.4822 24.4822 14.0625 25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H25C24.4822 15.9375 24.0625 15.5177 24.0625 15ZM15 24.0625C15.5177 24.0625 15.9375 24.4822 15.9375 25V27.5C15.9375 28.0177 15.5177 28.4375 15 28.4375C14.4822 28.4375 14.0625 28.0177 14.0625 27.5V25C14.0625 24.4822 14.4822 24.0625 15 24.0625Z"
          fill="white"
        />
        <g opacity="0.5">
          <path
            d="M4.58545 4.64474C4.93483 4.26262 5.52783 4.23608 5.90995 4.58546L8.68748 7.12493C9.0696 7.47431 9.09614 8.06731 8.74676 8.44943C8.39739 8.83156 7.80439 8.85811 7.42228 8.50873L4.64475 5.96924C4.26263 5.61987 4.23608 5.02687 4.58545 4.64474Z"
            fill="white"
          />
          <path
            d="M25.4148 4.64474C25.7641 5.02687 25.7376 5.61987 25.3555 5.96924L22.5779 8.50873C22.1958 8.85811 21.6028 8.83156 21.2534 8.44943C20.904 8.06731 20.9306 7.47431 21.3128 7.12493L24.0903 4.58546C24.4724 4.23608 25.0654 4.26262 25.4148 4.64474Z"
            fill="white"
          />
          <path
            d="M21.2825 21.2814C21.6486 20.9152 22.2421 20.9154 22.6082 21.2815L25.3857 24.0594C25.7518 24.4255 25.7518 25.019 25.3857 25.3851C25.0196 25.7512 24.426 25.7512 24.0598 25.385L21.2823 22.6072C20.9162 22.241 20.9163 21.6475 21.2825 21.2814Z"
            fill="white"
          />
          <path
            d="M8.71804 21.2814C9.08415 21.6474 9.08415 22.2411 8.71804 22.6072L5.94026 25.3849C5.57414 25.7511 4.98055 25.7511 4.61444 25.3849C4.24831 25.0188 4.24831 24.4253 4.61444 24.0592L7.39221 21.2813C7.75832 20.9153 8.35192 20.9153 8.71804 21.2814Z"
            fill="white"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};
export const NavbarFullScreenIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.9375 11.5412C5.9375 12.059 6.35724 12.4787 6.875 12.4787C7.39276 12.4787 7.8125 12.059 7.8125 11.5412H5.9375ZM7.8125 6.875C7.8125 6.35724 7.39276 5.9375 6.875 5.9375C6.35724 5.9375 5.9375 6.35724 5.9375 6.875H7.8125ZM6.875 5.9375C6.35724 5.9375 5.9375 6.35724 5.9375 6.875C5.9375 7.39276 6.35724 7.8125 6.875 7.8125V5.9375ZM11.5412 7.8125C12.059 7.8125 12.4787 7.39276 12.4787 6.875C12.4787 6.35724 12.059 5.9375 11.5412 5.9375V7.8125ZM7.53791 6.21209C7.1718 5.84597 6.5782 5.84597 6.21209 6.21209C5.84597 6.5782 5.84597 7.1718 6.21209 7.53791L7.53791 6.21209ZM12.4621 13.7879C12.8282 14.154 13.4217 14.154 13.7879 13.7879C14.154 13.4217 14.154 12.8282 13.7879 12.4621L12.4621 13.7879ZM19.7087 23.4375C19.191 23.4375 18.7712 23.8572 18.7712 24.375C18.7712 24.8927 19.191 25.3125 19.7087 25.3125V23.4375ZM24.375 25.3125C24.8927 25.3125 25.3125 24.8927 25.3125 24.375C25.3125 23.8572 24.8927 23.4375 24.375 23.4375V25.3125ZM23.4375 24.375C23.4375 24.8927 23.8572 25.3125 24.375 25.3125C24.8927 25.3125 25.3125 24.8927 25.3125 24.375H23.4375ZM25.3125 19.7087C25.3125 19.191 24.8927 18.7712 24.375 18.7712C23.8572 18.7712 23.4375 19.191 23.4375 19.7087H25.3125ZM23.7121 25.0379C24.0782 25.404 24.6717 25.404 25.0379 25.0379C25.404 24.6717 25.404 24.0782 25.0379 23.7121L23.7121 25.0379ZM18.7879 17.4621C18.4217 17.096 17.8282 17.096 17.4621 17.4621C17.096 17.8282 17.096 18.4217 17.4621 18.7879L18.7879 17.4621ZM7.8125 19.7087C7.8125 19.191 7.39276 18.7712 6.875 18.7712C6.35724 18.7712 5.9375 19.191 5.9375 19.7087H7.8125ZM5.9375 24.375C5.9375 24.8927 6.35724 25.3125 6.875 25.3125C7.39276 25.3125 7.8125 24.8927 7.8125 24.375H5.9375ZM6.875 23.4375C6.35724 23.4375 5.9375 23.8572 5.9375 24.375C5.9375 24.8927 6.35724 25.3125 6.875 25.3125V23.4375ZM11.5412 25.3125C12.059 25.3125 12.4787 24.8927 12.4787 24.375C12.4787 23.8572 12.059 23.4375 11.5412 23.4375V25.3125ZM6.21209 23.7121C5.84597 24.0782 5.84597 24.6717 6.21209 25.0379C6.5782 25.404 7.1718 25.404 7.53791 25.0379L6.21209 23.7121ZM13.7879 18.7879C14.154 18.4217 14.154 17.8282 13.7879 17.4621C13.4217 17.096 12.8282 17.096 12.4621 17.4621L13.7879 18.7879ZM19.7087 5.9375C19.191 5.9375 18.7712 6.35724 18.7712 6.875C18.7712 7.39276 19.191 7.8125 19.7087 7.8125V5.9375ZM24.375 7.8125C24.8927 7.8125 25.3125 7.39276 25.3125 6.875C25.3125 6.35724 24.8927 5.9375 24.375 5.9375V7.8125ZM25.3125 6.875C25.3125 6.35724 24.8927 5.9375 24.375 5.9375C23.8572 5.9375 23.4375 6.35724 23.4375 6.875H25.3125ZM23.4375 11.5412C23.4375 12.059 23.8572 12.4787 24.375 12.4787C24.8927 12.4787 25.3125 12.059 25.3125 11.5412H23.4375ZM25.0379 7.53791C25.404 7.1718 25.404 6.5782 25.0379 6.21209C24.6717 5.84597 24.0782 5.84597 23.7121 6.21209L25.0379 7.53791ZM17.4621 12.4621C17.096 12.8282 17.096 13.4217 17.4621 13.7879C17.8282 14.154 18.4217 14.154 18.7879 13.7879L17.4621 12.4621ZM7.8125 11.5412V6.875H5.9375V11.5412H7.8125ZM6.875 7.8125H11.5412V5.9375H6.875V7.8125ZM6.21209 7.53791L12.4621 13.7879L13.7879 12.4621L7.53791 6.21209L6.21209 7.53791ZM19.7087 25.3125H24.375V23.4375H19.7087V25.3125ZM25.3125 24.375V19.7087H23.4375V24.375H25.3125ZM25.0379 23.7121L18.7879 17.4621L17.4621 18.7879L23.7121 25.0379L25.0379 23.7121ZM5.9375 19.7087V24.375H7.8125V19.7087H5.9375ZM6.875 25.3125H11.5412V23.4375H6.875V25.3125ZM7.53791 25.0379L13.7879 18.7879L12.4621 17.4621L6.21209 23.7121L7.53791 25.0379ZM19.7087 7.8125H24.375V5.9375H19.7087V7.8125ZM23.4375 6.875V11.5412H25.3125V6.875H23.4375ZM23.7121 6.21209L17.4621 12.4621L18.7879 13.7879L25.0379 7.53791L23.7121 6.21209Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};
export const NavbarFullScreenDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1054_41578)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.4113 5.625H18.75C18.2325 5.625 17.8125 6.045 17.8125 6.5625C17.8125 7.08094 18.2325 7.5 18.75 7.5H21.2138L16.7156 11.9991L18.0413 13.3247L22.5206 8.84531L22.5 11.25C22.5 11.7684 22.92 12.1875 23.4375 12.1875C23.955 12.1875 24.375 11.7684 24.375 11.25V6.5625C24.375 6.285 24.2597 6.06096 24.0788 5.90721C23.9081 5.73284 23.6728 5.625 23.4113 5.625ZM28.125 26.25C28.125 27.2812 27.285 28.125 26.25 28.125H3.75C2.715 28.125 1.875 27.2812 1.875 26.25V3.75C1.875 2.715 2.715 1.875 3.75 1.875H26.25C27.285 1.875 28.125 2.715 28.125 3.75V26.25ZM26.25 0H3.75C1.67906 0 0 1.67906 0 3.75V26.25C0 28.3219 1.67906 30 3.75 30H26.25C28.3209 30 30 28.3219 30 26.25V3.75C30 1.67906 28.3209 0 26.25 0ZM11.9587 16.6781L7.47937 21.1594L7.5 18.75C7.5 18.2344 7.08 17.8125 6.5625 17.8125C6.045 17.8125 5.625 18.2344 5.625 18.75V23.4375C5.625 23.7188 5.74031 23.9438 5.92124 24.0938C6.09093 24.2625 6.32719 24.375 6.58875 24.375H11.25C11.7675 24.375 12.1875 23.9531 12.1875 23.4375C12.1875 22.9219 11.7675 22.5 11.25 22.5H8.78624L13.2844 18L11.9587 16.6781ZM23.4375 17.8125C22.92 17.8125 22.5 18.2344 22.5 18.75L22.5206 21.1594L18.0413 16.6781L16.7156 18L21.2138 22.5H18.75C18.2325 22.5 17.8125 22.9219 17.8125 23.4375C17.8125 23.9531 18.2325 24.375 18.75 24.375H23.4113C23.6728 24.375 23.9091 24.2625 24.0788 24.0938C24.2597 23.9438 24.375 23.7188 24.375 23.4375V18.75C24.375 18.2344 23.955 17.8125 23.4375 17.8125ZM11.25 7.5C11.7675 7.5 12.1875 7.08094 12.1875 6.5625C12.1875 6.045 11.7675 5.625 11.25 5.625H6.58875C6.32719 5.625 6.09187 5.73284 5.92124 5.90721C5.74031 6.06096 5.625 6.285 5.625 6.5625V11.25C5.625 11.7684 6.045 12.1875 6.5625 12.1875C7.08 12.1875 7.5 11.7684 7.5 11.25L7.47937 8.84531L11.9587 13.3247L13.2844 11.9991L8.78624 7.5H11.25Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1054_41578">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const NavbarNotificationIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.2341 17.575L23.8216 15.225C23.5091 14.7125 23.2341 13.725 23.2341 13.125V10.7875C23.2341 6.25 19.5466 2.5625 15.0216 2.5625C10.4841 2.575 6.79659 6.25 6.79659 10.7875V13.1125C6.79659 13.7125 6.52159 14.7 6.22159 15.2125L4.80909 17.5625C4.27159 18.475 4.14659 19.5125 4.48409 20.4125C4.82159 21.325 5.58409 22.05 6.58409 22.375C7.93409 22.825 9.29659 23.15 10.6841 23.3875C10.8216 23.4125 10.9591 23.425 11.0966 23.45C11.2716 23.475 11.4591 23.5 11.6466 23.525C11.9716 23.575 12.2966 23.6125 12.6341 23.6375C13.4216 23.7125 14.2216 23.75 15.0216 23.75C15.8091 23.75 16.5966 23.7125 17.3716 23.6375C17.6591 23.6125 17.9466 23.5875 18.2216 23.55C18.4466 23.525 18.6716 23.5 18.8966 23.4625C19.0341 23.45 19.1716 23.425 19.3091 23.4C20.7091 23.175 22.0966 22.825 23.4466 22.375C24.409 22.05 25.1466 21.325 25.4966 20.4C25.8466 19.4625 25.7466 18.4375 25.2341 17.575ZM15.9341 12.5C15.9341 13.025 15.5091 13.45 14.9841 13.45C14.4591 13.45 14.0341 13.025 14.0341 12.5V8.625C14.0341 8.1 14.4591 7.675 14.9841 7.675C15.5091 7.675 15.9341 8.1 15.9341 8.625V12.5Z"
          fill="#646B88"
        />
        <path
          d="M18.5391 25.0125C18.0141 26.4625 16.6266 27.5 15.0016 27.5C14.0141 27.5 13.0391 27.1 12.3516 26.3875C11.9516 26.0125 11.6516 25.5125 11.4766 25C11.6391 25.025 11.8016 25.0375 11.9766 25.0625C12.2641 25.1 12.5641 25.1375 12.8641 25.1625C13.5766 25.225 14.3016 25.2625 15.0266 25.2625C15.7391 25.2625 16.4516 25.225 17.1516 25.1625C17.4141 25.1375 17.6766 25.125 17.9266 25.0875C18.1266 25.0625 18.3266 25.0375 18.5391 25.0125Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarNotificationDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.236 17.576L23.8235 15.226C23.511 14.7135 23.236 13.726 23.236 13.126V10.7885C23.236 6.25098 19.5485 2.56348 15.0235 2.56348C10.486 2.57598 6.79854 6.25098 6.79854 10.7885V13.1135C6.79854 13.7135 6.52354 14.701 6.22354 15.2135L4.81104 17.5635C4.27354 18.476 4.14854 19.5135 4.48604 20.4135C4.82354 21.326 5.58604 22.051 6.58604 22.376C7.93604 22.826 9.29854 23.151 10.686 23.3885C10.8235 23.4135 10.961 23.426 11.0985 23.451C11.2735 23.476 11.461 23.501 11.6485 23.526C11.9735 23.576 12.2985 23.6135 12.636 23.6385C13.4235 23.7135 14.2235 23.751 15.0235 23.751C15.811 23.751 16.5985 23.7135 17.3735 23.6385C17.661 23.6135 17.9485 23.5885 18.2235 23.551C18.4485 23.526 18.6735 23.501 18.8985 23.4635C19.036 23.451 19.1735 23.426 19.311 23.401C20.711 23.176 22.0985 22.826 23.4485 22.376C24.411 22.051 25.1485 21.326 25.4985 20.401C25.8485 19.4635 25.7485 18.4385 25.236 17.576ZM15.936 12.501C15.936 13.026 15.511 13.451 14.986 13.451C14.461 13.451 14.036 13.026 14.036 12.501V8.62598C14.036 8.10098 14.461 7.67598 14.986 7.67598C15.511 7.67598 15.936 8.10098 15.936 8.62598V12.501Z"
          fill="white"
        />
        <path
          d="M18.5371 25.0125C18.0121 26.4625 16.6246 27.5 14.9996 27.5C14.0121 27.5 13.0371 27.1 12.3496 26.3875C11.9496 26.0125 11.6496 25.5125 11.4746 25C11.6371 25.025 11.7996 25.0375 11.9746 25.0625C12.2621 25.1 12.5621 25.1375 12.8621 25.1625C13.5746 25.225 14.2996 25.2625 15.0246 25.2625C15.7371 25.2625 16.4496 25.225 17.1496 25.1625C17.4121 25.1375 17.6746 25.125 17.9246 25.0875C18.1246 25.0625 18.3246 25.0375 18.5371 25.0125Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarArrowDownIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 10L12 15L17 10"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const NavbarArrowDownDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 10L12 15L17 10"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarArrowLeft = () => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="-4.5 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>arrow_left [#335]</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Dribbble-Light-Preview"
            transform="translate(-345.000000, -6679.000000)"
            fill="#000000"
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <path
                d="M299.633777,6519.29231 L299.633777,6519.29231 C299.228878,6518.90256 298.573377,6518.90256 298.169513,6519.29231 L289.606572,6527.55587 C288.797809,6528.33636 288.797809,6529.60253 289.606572,6530.38301 L298.231646,6538.70754 C298.632403,6539.09329 299.27962,6539.09828 299.685554,6538.71753 L299.685554,6538.71753 C300.100809,6538.32879 300.104951,6537.68821 299.696945,6537.29347 L291.802968,6529.67648 C291.398069,6529.28574 291.398069,6528.65315 291.802968,6528.26241 L299.633777,6520.70538 C300.038676,6520.31563 300.038676,6519.68305 299.633777,6519.29231"
                id="arrow_left-[#335]"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const SideBarArrowRight = () => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="-4.5 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>arrow_right [#336]</title>
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Dribbble-Light-Preview"
            transform="translate(-305.000000, -6679.000000)"
            fill="#000000"
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <path
                d="M249.365851,6538.70769 L249.365851,6538.70769 C249.770764,6539.09744 250.426289,6539.09744 250.830166,6538.70769 L259.393407,6530.44413 C260.202198,6529.66364 260.202198,6528.39747 259.393407,6527.61699 L250.768031,6519.29246 C250.367261,6518.90671 249.720021,6518.90172 249.314072,6519.28247 L249.314072,6519.28247 C248.899839,6519.67121 248.894661,6520.31179 249.302681,6520.70653 L257.196934,6528.32352 C257.601847,6528.71426 257.601847,6529.34685 257.196934,6529.73759 L249.365851,6537.29462 C248.960938,6537.68437 248.960938,6538.31795 249.365851,6538.70769"
                id="arrow_right-[#336]"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const SideBarDashBoardIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2021_3415)">
          <path
            d="M10 15H4C3.73478 15 3.48043 15.1054 3.29289 15.2929C3.10536 15.4804 3 15.7348 3 16V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V16C11 15.7348 10.8946 15.4804 10.7071 15.2929C10.5196 15.1054 10.2652 15 10 15Z"
            fill={color}
          />
          <path
            d="M10 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V12C3 12.2652 3.10536 12.5196 3.29289 12.7071C3.48043 12.8946 3.73478 13 4 13H10C10.2652 13 10.5196 12.8946 10.7071 12.7071C10.8946 12.5196 11 12.2652 11 12V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2Z"
            fill={color}
          />
          <path
            d="M20 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V8C13 8.26522 13.1054 8.51957 13.2929 8.70711C13.4804 8.89464 13.7348 9 14 9H20C20.2652 9 20.5196 8.89464 20.7071 8.70711C20.8946 8.51957 21 8.26522 21 8V3C21 2.73478 20.8946 2.48043 20.7071 2.29289C20.5196 2.10536 20.2652 2 20 2Z"
            fill={color}
          />
          <path
            d="M20 11H14C13.7348 11 13.4804 11.1054 13.2929 11.2929C13.1054 11.4804 13 11.7348 13 12V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V12C21 11.7348 20.8946 11.4804 20.7071 11.2929C20.5196 11.1054 20.2652 11 20 11Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2021_3415">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const SideBarApplicationIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 3.00098H17.25V2.25098C17.25 2.05206 17.171 1.8613 17.0303 1.72065C16.8897 1.57999 16.6989 1.50098 16.5 1.50098C16.3011 1.50098 16.1103 1.57999 15.9697 1.72065C15.829 1.8613 15.75 2.05206 15.75 2.25098V3.00098H12.75V2.25098C12.75 2.05206 12.671 1.8613 12.5303 1.72065C12.3897 1.57999 12.1989 1.50098 12 1.50098C11.8011 1.50098 11.6103 1.57999 11.4697 1.72065C11.329 1.8613 11.25 2.05206 11.25 2.25098V3.00098H8.25V2.25098C8.25 2.05206 8.17098 1.8613 8.03033 1.72065C7.88968 1.57999 7.69891 1.50098 7.5 1.50098C7.30109 1.50098 7.11032 1.57999 6.96967 1.72065C6.82902 1.8613 6.75 2.05206 6.75 2.25098V3.00098H5.25C4.85231 3.00143 4.47105 3.15961 4.18984 3.44082C3.90864 3.72202 3.75045 4.10329 3.75 4.50098V18.751C3.75091 19.5463 4.06727 20.3089 4.62968 20.8713C5.1921 21.4337 5.95463 21.7501 6.75 21.751H17.25C18.0454 21.7501 18.8079 21.4337 19.3703 20.8713C19.9327 20.3089 20.2491 19.5463 20.25 18.751V4.50098C20.2495 4.10329 20.0914 3.72202 19.8102 3.44082C19.529 3.15961 19.1477 3.00143 18.75 3.00098ZM15 15.751H9C8.80109 15.751 8.61032 15.672 8.46967 15.5313C8.32902 15.3907 8.25 15.1999 8.25 15.001C8.25 14.8021 8.32902 14.6113 8.46967 14.4706C8.61032 14.33 8.80109 14.251 9 14.251H15C15.1989 14.251 15.3897 14.33 15.5303 14.4706C15.671 14.6113 15.75 14.8021 15.75 15.001C15.75 15.1999 15.671 15.3907 15.5303 15.5313C15.3897 15.672 15.1989 15.751 15 15.751ZM15 12.751H9C8.80109 12.751 8.61032 12.672 8.46967 12.5313C8.32902 12.3907 8.25 12.1999 8.25 12.001C8.25 11.8021 8.32902 11.6113 8.46967 11.4706C8.61032 11.33 8.80109 11.251 9 11.251H15C15.1989 11.251 15.3897 11.33 15.5303 11.4706C15.671 11.6113 15.75 11.8021 15.75 12.001C15.75 12.1999 15.671 12.3907 15.5303 12.5313C15.3897 12.672 15.1989 12.751 15 12.751Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarComplaintsIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.2519 6.67692V15.8677C20.2506 16.2384 20.1027 16.5937 19.8405 16.8558C19.5783 17.118 19.2231 17.2659 18.8523 17.2672H13.5799L12.2915 19.3325C12.2651 19.395 12.2209 19.4483 12.1644 19.4857C12.1079 19.5232 12.0416 19.5432 11.9738 19.5432C11.906 19.5432 11.8397 19.5232 11.7832 19.4857C11.7267 19.4483 11.6825 19.395 11.6561 19.3325L10.3677 17.2672H5.15084C4.77984 17.2662 4.4243 17.1185 4.16185 16.8563C3.89939 16.5941 3.75133 16.2387 3.75 15.8677V6.67692C3.75133 6.30614 3.89921 5.95093 4.1614 5.68874C4.42358 5.42656 4.7788 5.27868 5.14958 5.27734H18.8523C19.2231 5.27868 19.5783 5.42656 19.8405 5.68874C20.1027 5.95093 20.2506 6.30614 20.2519 6.67692ZM12.8927 14.3241C12.893 14.1476 12.8409 13.9751 12.7431 13.8283C12.6452 13.6815 12.506 13.567 12.3431 13.4993C12.1802 13.4316 12.0008 13.4137 11.8277 13.448C11.6547 13.4823 11.4957 13.5671 11.3708 13.6918C11.246 13.8164 11.1609 13.9753 11.1264 14.1484C11.0919 14.3214 11.1095 14.5008 11.1769 14.6638C11.2444 14.8268 11.3587 14.9662 11.5054 15.0642C11.652 15.1623 11.8245 15.2146 12.0009 15.2146C12.2372 15.2146 12.4639 15.1208 12.6311 14.9539C12.7983 14.7869 12.8924 14.5604 12.8927 14.3241ZM11.3012 12.0125C11.3012 12.1981 11.3749 12.3761 11.5061 12.5073C11.6372 12.6385 11.8152 12.7122 12.0009 12.7122C12.1885 12.7122 12.3666 12.6384 12.4978 12.5071C12.629 12.3757 12.7011 12.1976 12.7011 12.0125C12.7011 11.8268 12.6295 11.6489 12.4983 11.5167C12.3671 11.3845 12.1891 11.312 12.0009 11.312C11.8144 11.312 11.6367 11.384 11.5057 11.5163C11.3747 11.6486 11.3012 11.8264 11.3012 12.0125ZM12.0009 9.77284C12.2372 9.77284 12.4639 9.67903 12.6311 9.51211C12.7983 9.34516 12.8924 9.12353 12.8927 8.88526C12.8927 8.646 12.7983 8.4244 12.6311 8.25747C12.4639 8.09053 12.2372 7.99774 12.0009 7.99774C11.8144 7.99774 11.6367 8.09053 11.5057 8.25747C11.3747 8.4244 11.3012 8.646 11.3012 8.88526C11.3012 9.1238 11.3749 9.34516 11.5061 9.51216C11.6372 9.67914 11.8152 9.77284 12.0009 9.77284Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarDealersIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10Z"
          fill={color}
        />
        <path
          d="M9 21.001C12.866 21.001 16 19.2101 16 17.001C16 14.7918 12.866 13.001 9 13.001C5.13401 13.001 2 14.7918 2 17.001C2 19.2101 5.13401 21.001 9 21.001Z"
          fill={color}
        />
        <path
          d="M21 17.001C21 18.6578 18.9645 20.0009 16.4792 20.0009C17.2114 19.2006 17.7149 18.196 17.7149 17.0023C17.7149 15.8073 17.2102 14.8018 16.4766 14.001C18.9619 14.001 21 15.3441 21 17.001Z"
          fill={color}
        />
        <path
          d="M17.9971 6.00098C17.9971 7.65784 16.6541 9.00098 14.9972 9.00098C14.6359 9.00098 14.2896 8.93712 13.9688 8.82006C14.4419 7.98797 14.7121 7.02547 14.7121 5.99987C14.7121 4.97502 14.4423 4.01319 13.9698 3.18152C14.2903 3.06471 14.6363 3.00098 14.9972 3.00098C16.6541 3.00098 17.9971 4.34413 17.9971 6.00098Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarDeliveryIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.56443 8.73049L10.0789 10.5926C10.5639 12.3481 10.8064 13.2259 11.5194 13.6252C12.2323 14.0244 13.1374 13.7892 14.9474 13.3188L16.8673 12.8199C18.6774 12.3495 19.5824 12.1143 19.9941 11.4227C20.4057 10.7312 20.1632 9.85344 19.6782 8.09788L19.1638 6.2358C18.6788 4.48023 18.4363 3.60244 17.7233 3.20319C17.0103 2.80394 16.1052 3.03915 14.2952 3.50955L12.3753 4.00849C10.5652 4.47889 9.66021 4.71409 9.24856 5.40562C8.83692 6.09714 9.07943 6.97493 9.56443 8.73049Z"
          fill={color}
        />
        <path
          d="M2.27749 5.24694C2.38823 4.84781 2.80157 4.61402 3.2007 4.72476L4.9044 5.19744C5.82129 5.45183 6.5469 6.15866 6.80003 7.07489L8.95106 14.8609L9.10935 15.4075C9.74249 15.6438 10.2863 16.0866 10.6314 16.6747L10.9414 16.579L19.8115 14.2739C20.2124 14.1697 20.6219 14.4102 20.7261 14.8111C20.8303 15.212 20.5897 15.6214 20.1888 15.7256L11.3515 18.0223L11.0228 18.1238C11.0161 19.3947 10.1392 20.5555 8.81236 20.9003C7.22189 21.3136 5.58709 20.3982 5.16092 18.8556C4.73476 17.313 5.67861 15.7274 7.26908 15.3141C7.3479 15.2936 7.42682 15.2764 7.5057 15.2623L5.35419 7.47433C5.24592 7.08242 4.92897 6.76092 4.50338 6.64284L2.79968 6.17016C2.40054 6.05942 2.16675 5.64608 2.27749 5.24694Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarDispatchIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.23737 2.28869C1.84442 2.1577 1.41968 2.37007 1.28869 2.76303C1.15771 3.15599 1.37008 3.58073 1.76303 3.71171L2.02794 3.80002C2.70435 4.02548 3.15155 4.17575 3.481 4.32901C3.79296 4.47413 3.92784 4.59093 4.01426 4.71083C4.10068 4.83073 4.16883 4.99562 4.20785 5.33746C4.24907 5.69847 4.2502 6.17024 4.2502 6.88324V9.55508C4.25018 10.9226 4.25017 12.0249 4.36673 12.8919C4.48774 13.792 4.74664 14.5499 5.34855 15.1518C5.95047 15.7537 6.70834 16.0126 7.60845 16.1336C8.47542 16.2502 9.57773 16.2502 10.9453 16.2502H18.0002C18.4144 16.2502 18.7502 15.9144 18.7502 15.5002C18.7502 15.0859 18.4144 14.7502 18.0002 14.7502H11.0002C9.56479 14.7502 8.56367 14.7486 7.80832 14.647C7.07455 14.5484 6.68598 14.3679 6.40921 14.0912C6.17403 13.856 6.00839 13.54 5.9034 13.0002H16.0222C16.9817 13.0002 17.4614 13.0002 17.8371 12.7524C18.2128 12.5047 18.4017 12.0638 18.7797 11.1819L19.2082 10.1819C20.0177 8.29314 20.4225 7.34873 19.9779 6.67446C19.5333 6.0002 18.5058 6.0002 16.4508 6.0002H5.74526C5.73936 5.69251 5.72644 5.41491 5.69817 5.16732C5.64282 4.6825 5.52222 4.23764 5.23112 3.83376C4.94002 3.42989 4.55613 3.1748 4.1137 2.96897C3.69746 2.77534 3.16814 2.59892 2.54176 2.39015L2.23737 2.28869Z"
          fill={color}
        />
        <path
          d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z"
          fill={color}
        />
        <path
          d="M16.5 18C17.3284 18 18 18.6715 18 19.5C18 20.3284 17.3284 21 16.5 21C15.6716 21 15 20.3284 15 19.5C15 18.6715 15.6716 18 16.5 18Z"
          fill={color}
        />
      </svg>{" "}
    </React.Fragment>
  );
};

export const SideBarGreetingIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6786 0.735352C6.46969 0.735352 1.42969 4.677 1.42969 9.5377C1.42969 13.9749 5.6311 17.6328 11.0876 18.2398L8.19769 23.253L16.8363 17.7104C20.9869 16.4158 23.9276 13.2478 23.9276 9.5377C23.9276 4.67559 18.8904 0.735352 12.6786 0.735352ZM12.7647 13.437H11.257V10.6939H8.51816V13.437L7.00475 13.4695V6.34147L8.51816 6.309V9.15794H11.257V6.309H12.7647V13.437ZM15.5318 13.437H14.0551V9.08876H15.5318V13.437ZM15.5756 7.82241H14.0551V6.26382H15.5756V7.82241ZM19.8109 13.4342H18.3102V11.9476H19.8109V13.4342ZM19.7897 10.6106H18.3116V6.28782H19.7897V10.6106Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarInventoryIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.6C0 3.91044 0.273928 3.24912 0.761522 2.76152C1.24912 2.27393 1.91044 2 2.6 2H21.4C22.0896 2 22.7509 2.27393 23.2385 2.76152C23.7261 3.24912 24 3.91044 24 4.6V5.4C24 6.08956 23.7261 6.75088 23.2385 7.23848C22.7509 7.72607 22.0896 8 21.4 8H21V18.6C21 19.93 19.93 21 18.6 21H5.4C4.07 21 3 19.93 3 18.6V8H2.6C1.91044 8 1.24912 7.72607 0.761522 7.23848C0.273928 6.75088 0 6.08956 0 5.4L0 4.6ZM2.6 4C2.44087 4 2.28826 4.06321 2.17574 4.17574C2.06321 4.28826 2 4.44087 2 4.6V5.4C2 5.55913 2.06321 5.71174 2.17574 5.82426C2.28826 5.93679 2.44087 6 2.6 6H21.4C21.5591 6 21.7117 5.93679 21.8243 5.82426C21.9368 5.71174 22 5.55913 22 5.4V4.6C22 4.44087 21.9368 4.28826 21.8243 4.17574C21.7117 4.06321 21.5591 4 21.4 4H2.6ZM8 10C7.73478 10 7.48043 10.1054 7.29289 10.2929C7.10536 10.4804 7 10.7348 7 11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73478 12 8 12H16C16.2652 12 16.5196 11.8946 16.7071 11.7071C16.8946 11.5196 17 11.2652 17 11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10H8Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarInvoiceIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V22L7 19L9 22L12 19L15 22L17 19L20 22V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2ZM12 16H8C7.73478 16 7.48043 15.8946 7.29289 15.7071C7.10536 15.5196 7 15.2652 7 15C7 14.7348 7.10536 14.4804 7.29289 14.2929C7.48043 14.1054 7.73478 14 8 14H12C12.2652 14 12.5196 14.1054 12.7071 14.2929C12.8946 14.4804 13 14.7348 13 15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16ZM12 12H8C7.73478 12 7.48043 11.8946 7.29289 11.7071C7.10536 11.5196 7 11.2652 7 11C7 10.7348 7.10536 10.4804 7.29289 10.2929C7.48043 10.1054 7.73478 10 8 10H12C12.2652 10 12.5196 10.1054 12.7071 10.2929C12.8946 10.4804 13 10.7348 13 11C13 11.2652 12.8946 11.5196 12.7071 11.7071C12.5196 11.8946 12.2652 12 12 12ZM16 16H15C14.7348 16 14.4804 15.8946 14.2929 15.7071C14.1054 15.5196 14 15.2652 14 15C14 14.7348 14.1054 14.4804 14.2929 14.2929C14.4804 14.1054 14.7348 14 15 14H16C16.2652 14 16.5196 14.1054 16.7071 14.2929C16.8946 14.4804 17 14.7348 17 15C17 15.2652 16.8946 15.5196 16.7071 15.7071C16.5196 15.8946 16.2652 16 16 16ZM16 12H15C14.7348 12 14.4804 11.8946 14.2929 11.7071C14.1054 11.5196 14 11.2652 14 11C14 10.7348 14.1054 10.4804 14.2929 10.2929C14.4804 10.1054 14.7348 10 15 10H16C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11C17 11.2652 16.8946 11.5196 16.7071 11.7071C16.5196 11.8946 16.2652 12 16 12ZM16 7H8C7.73478 7 7.48043 6.89464 7.29289 6.70711C7.10536 6.51957 7 6.26522 7 6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H16C16.2652 5 16.5196 5.10536 16.7071 5.29289C16.8946 5.48043 17 5.73478 17 6C17 6.26522 16.8946 6.51957 16.7071 6.70711C16.5196 6.89464 16.2652 7 16 7Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarJobsIcon = ({ color = "#646B88" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 8.25C23.2491 7.45462 22.9328 6.69206 22.3704 6.12964C21.8079 5.56722 21.0454 5.25087 20.25 5.25H18V4.5C17.9994 3.90345 17.7621 3.33152 17.3403 2.9097C16.9185 2.48787 16.3465 2.25062 15.75 2.25H8.25C7.65345 2.25062 7.08152 2.48787 6.65969 2.9097C6.23787 3.33152 6.00062 3.90345 6 4.5V5.25H3.75C2.95462 5.25087 2.19206 5.56722 1.62964 6.12964C1.06722 6.69206 0.750869 7.45462 0.75 8.25V10.5H23.25V8.25ZM16.5 5.25H7.5V4.5C7.5 4.30109 7.57902 4.11032 7.71967 3.96967C7.86032 3.82902 8.05109 3.75 8.25 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V5.25Z"
        fill={color}
      />
      <path
        d="M15.75 12.375C15.75 12.6734 15.6315 12.9595 15.4205 13.1705C15.2095 13.3815 14.9234 13.5 14.625 13.5H9.375C9.07663 13.5 8.79048 13.3815 8.5795 13.1705C8.36853 12.9595 8.25 12.6734 8.25 12.375V12.1875C8.25 12.1378 8.23025 12.0901 8.19508 12.0549C8.15992 12.0198 8.11223 12 8.0625 12H0.75V18.75C0.75 19.5456 1.06607 20.3087 1.62868 20.8713C2.19129 21.4339 2.95435 21.75 3.75 21.75H20.25C21.0456 21.75 21.8087 21.4339 22.3713 20.8713C22.9339 20.3087 23.25 19.5456 23.25 18.75V12H15.9375C15.8878 12 15.8401 12.0198 15.8049 12.0549C15.7698 12.0901 15.75 12.1378 15.75 12.1875V12.375Z"
        fill={color}
      />
    </svg>
  );
};

export const SideBarManagerIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.2016 16.4882C21.7056 16.3602 21.2896 16.2082 20.9536 16.0322C20.3936 15.7442 20.1136 15.4082 20.1136 15.0242C20.1136 14.9282 20.0736 14.8442 19.9936 14.7722C19.9136 14.7002 19.8176 14.6722 19.7056 14.6882C19.2416 14.7522 18.7456 14.5042 18.2176 13.9442C17.8976 13.5922 17.6016 13.1682 17.3296 12.6722C17.3136 12.6242 17.2816 12.6002 17.2336 12.6002C17.1856 12.6002 17.1536 12.6242 17.1376 12.6722C16.8656 13.1682 16.5696 13.5922 16.2496 13.9442C15.7216 14.5042 15.2256 14.7522 14.7616 14.6882C14.6496 14.6722 14.5536 14.7002 14.4736 14.7722C14.3936 14.8442 14.3536 14.9282 14.3536 15.0242C14.3696 15.4082 14.0976 15.7442 13.5376 16.0322C13.1856 16.2082 12.7696 16.3602 12.2896 16.4882C12.2416 16.4882 12.2096 16.5082 12.1936 16.5482C12.1776 16.5882 12.1856 16.6242 12.2176 16.6562C12.5696 17.0722 12.8496 17.4722 13.0576 17.8562C13.4096 18.5122 13.5216 19.0322 13.3936 19.4162C13.3616 19.4962 13.3656 19.5802 13.4056 19.6682C13.4456 19.7562 13.5056 19.8162 13.5856 19.8482C13.8736 19.9762 14.0736 20.3122 14.1856 20.8562C14.2656 21.1922 14.3056 21.5682 14.3056 21.9842C14.3056 22.0322 14.3256 22.0682 14.3656 22.0922C14.4056 22.1162 14.4416 22.1202 14.4736 22.1042C14.8896 21.8962 15.2896 21.7682 15.6736 21.7202C16.2656 21.6242 16.6976 21.7442 16.9696 22.0802C17.0336 22.1602 17.1216 22.2002 17.2336 22.2002C17.3456 22.2002 17.4336 22.1602 17.4976 22.0802C17.7696 21.7442 18.2096 21.6242 18.8176 21.7202C19.1856 21.7682 19.5776 21.8882 19.9936 22.0802C20.0416 22.1122 20.0816 22.1162 20.1136 22.0922C20.1456 22.0682 20.1616 22.0322 20.1616 21.9842C20.1616 21.5682 20.2016 21.1842 20.2816 20.8322C20.4096 20.3042 20.6096 19.9762 20.8816 19.8482C20.9616 19.8162 21.0216 19.7602 21.0616 19.6802C21.1016 19.6002 21.1056 19.5202 21.0736 19.4402C20.9456 19.0402 21.0576 18.5202 21.4096 17.8802C21.6176 17.4802 21.8976 17.0722 22.2496 16.6562C22.2816 16.6242 22.2896 16.5882 22.2736 16.5482C22.2576 16.5082 22.2336 16.4882 22.2016 16.4882ZM19.8736 17.3042L19.7536 17.4722C19.2256 18.1442 18.9696 18.9042 18.9856 19.7522V19.8482C18.9856 19.9122 18.9616 19.9642 18.9136 20.0042C18.8656 20.0442 18.8096 20.0642 18.7456 20.0642H18.6976L18.4336 19.9922C17.6336 19.7522 16.8336 19.7522 16.0336 19.9922L15.7696 20.0642H15.7216C15.6576 20.0642 15.6016 20.0442 15.5536 20.0042C15.5056 19.9642 15.4816 19.9122 15.4816 19.8482V19.7522C15.4976 18.9042 15.2416 18.1442 14.7136 17.4722L14.5936 17.3042C14.5456 17.2562 14.5336 17.1962 14.5576 17.1242C14.5816 17.0522 14.6336 17.0082 14.7136 16.9922C15.1776 16.8642 15.6096 16.6722 16.0096 16.4162C16.4096 16.1602 16.7456 15.8402 17.0176 15.4562L17.0416 15.4322C17.0896 15.3682 17.1536 15.3362 17.2336 15.3362C17.3136 15.3362 17.3776 15.3682 17.4256 15.4322L17.4496 15.4562C17.7216 15.8402 18.0536 16.1602 18.4456 16.4162C18.8376 16.6722 19.2736 16.8642 19.7536 16.9922C19.8336 17.0082 19.8856 17.0522 19.9096 17.1242C19.9336 17.1962 19.9216 17.2562 19.8736 17.3042ZM12.7936 21.2402C12.7776 21.1762 12.7376 21.1282 12.6736 21.0962C12.3376 20.9362 12.0936 20.6842 11.9416 20.3402C11.7896 19.9962 11.7696 19.6482 11.8816 19.2962C11.9456 19.0722 11.9296 18.8562 11.8336 18.6482C11.6256 18.2642 11.3776 17.9042 11.0896 17.5682C10.9296 17.3762 10.8216 17.1522 10.7656 16.8962C10.7096 16.6402 10.7176 16.3842 10.7896 16.1282C10.8616 15.8722 10.9976 15.6522 11.1976 15.4682C11.3976 15.2842 11.6376 15.1602 11.9176 15.0962C12.1976 15.0322 12.4736 14.9442 12.7456 14.8322C12.8096 14.7842 12.8496 14.7202 12.8656 14.6402C12.8656 14.5762 12.8416 14.5202 12.7936 14.4722L11.9776 13.2242C11.8816 13.0962 11.7696 12.9762 11.6416 12.8642C11.6096 12.8322 11.5976 12.8002 11.6056 12.7682C11.6136 12.7362 11.6336 12.7042 11.6656 12.6722C12.6256 12.2242 13.4096 11.5602 14.0176 10.6802C14.6416 9.75216 14.9536 8.76016 14.9536 7.70416C14.9536 6.69616 14.7056 5.76816 14.2096 4.92016C13.7136 4.07216 13.0416 3.40016 12.1936 2.90416C11.3456 2.40816 10.4216 2.16016 9.42162 2.16016C8.42162 2.16016 7.49762 2.40816 6.64962 2.90416C5.80162 3.40016 5.12962 4.07216 4.63362 4.92016C4.13762 5.76816 3.88962 6.69616 3.88962 7.70416C3.88962 8.76016 4.20162 9.75216 4.82562 10.6802C5.43362 11.5442 6.21762 12.2082 7.17762 12.6722C7.20962 12.6882 7.22562 12.7162 7.22562 12.7562C7.22562 12.7962 7.21762 12.8322 7.20162 12.8642C7.07362 12.9762 6.96162 13.0962 6.86562 13.2242C5.45762 15.3202 4.40162 16.9602 3.69762 18.1442C3.40962 18.6562 3.26562 19.0722 3.26562 19.3922C3.26562 19.8402 3.54162 20.2522 4.09362 20.6282C4.64562 21.0042 5.39362 21.3002 6.33762 21.5162C7.28162 21.7322 8.31362 21.8402 9.43362 21.8402C10.5856 21.8402 11.6576 21.7202 12.6496 21.4802C12.6976 21.4642 12.7336 21.4362 12.7576 21.3962C12.7816 21.3562 12.7936 21.3042 12.7936 21.2402Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarMarketingIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7975 4.80047C9.22524 4.80358 7.71699 5.42374 6.59727 6.52754C5.47755 7.63133 4.83584 9.13055 4.81021 10.7026C4.78458 12.2747 5.37707 13.7941 6.46021 14.9338C7.54334 16.0735 9.03058 16.7425 10.6019 16.7969L11.3963 19.1801C9.68832 19.302 7.98385 18.8989 6.5113 18.025C5.03875 17.151 3.86847 15.8479 3.15725 14.2902C2.44604 12.7326 2.22787 10.9947 2.53197 9.30959C2.83607 7.62445 3.64792 6.0725 4.85875 4.86168C6.06957 3.65085 7.62152 2.839 9.30666 2.5349C10.9918 2.2308 12.7296 2.44897 14.2873 3.16018C15.845 3.8714 17.1481 5.04168 18.022 6.51423C18.896 7.98678 19.299 9.69125 19.1771 11.3993L16.7939 10.6049C16.7432 9.04834 16.0892 7.57253 14.9702 6.48937C13.8512 5.40621 12.3549 4.80057 10.7975 4.80047Z"
          fill={color}
        />
        <path
          d="M10.7992 9.6002C10.481 9.6002 10.1757 9.72662 9.95069 9.95167C9.72565 10.1767 9.59922 10.4819 9.59922 10.8002C9.59922 11.1185 9.72565 11.4237 9.95069 11.6487C10.1757 11.8738 10.481 12.0002 10.7992 12.0002V14.4002C10.0872 14.4002 9.39118 14.1891 8.79917 13.7935C8.20715 13.3979 7.74573 12.8357 7.47325 12.1779C7.20078 11.52 7.12949 10.7962 7.26839 10.0979C7.4073 9.39954 7.75017 8.75808 8.25364 8.25461C8.7571 7.75114 9.39856 7.40828 10.0969 7.26937C10.7952 7.13046 11.5191 7.20176 12.1769 7.47423C12.8347 7.74671 13.3969 8.20813 13.7925 8.80014C14.1881 9.39216 14.3992 10.0882 14.3992 10.8002H11.9992C11.9992 10.4819 11.8728 10.1767 11.6477 9.95167C11.4227 9.72662 11.1175 9.6002 10.7992 9.6002Z"
          fill={color}
        />
        <path
          d="M13.5796 12.0616C13.3682 11.9911 13.1413 11.9809 12.9244 12.0321C12.7075 12.0833 12.5091 12.1939 12.3515 12.3515C12.1939 12.5091 12.0833 12.7075 12.0321 12.9244C11.9809 13.1413 11.9911 13.3682 12.0616 13.5796L14.4616 20.7796C14.5411 21.0188 14.6939 21.227 14.8983 21.3744C15.1027 21.5219 15.3484 21.6013 15.6004 21.6013C15.8525 21.6013 16.0982 21.5219 16.3026 21.3744C16.507 21.227 16.6598 21.0188 16.7392 20.7796L17.7496 17.7496L20.7796 16.7392C21.0188 16.6598 21.227 16.507 21.3744 16.3026C21.5219 16.0982 21.6013 15.8525 21.6013 15.6004C21.6013 15.3484 21.5219 15.1027 21.3744 14.8983C21.227 14.6939 21.0188 14.5411 20.7796 14.4616L13.5796 12.0616Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarOrdersIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.58579 4.58579C5 5.17157 5 6.11438 5 8V17C5 18.8856 5 19.8284 5.58579 20.4142C6.17157 21 7.11438 21 9 21H15C16.8856 21 17.8284 21 18.4142 20.4142C19 19.8284 19 18.8856 19 17V8C19 6.11438 19 5.17157 18.4142 4.58579C17.8284 4 16.8856 4 15 4H9C7.11438 4 6.17157 4 5.58579 4.58579ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H15C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8H9ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H9ZM9 16C8.44772 16 8 16.4477 8 17C8 17.5523 8.44772 18 9 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H9Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarOutsideInventoryIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.6C0 3.91044 0.273928 3.24912 0.761522 2.76152C1.24912 2.27393 1.91044 2 2.6 2H21.4C22.0896 2 22.7509 2.27393 23.2385 2.76152C23.7261 3.24912 24 3.91044 24 4.6V5.4C24 6.08956 23.7261 6.75088 23.2385 7.23848C22.7509 7.72607 22.0896 8 21.4 8H21V18.6C21 19.93 19.93 21 18.6 21H5.4C4.07 21 3 19.93 3 18.6V8H2.6C1.91044 8 1.24912 7.72607 0.761522 7.23848C0.273928 6.75088 0 6.08956 0 5.4L0 4.6ZM2.6 4C2.44087 4 2.28826 4.06321 2.17574 4.17574C2.06321 4.28826 2 4.44087 2 4.6V5.4C2 5.55913 2.06321 5.71174 2.17574 5.82426C2.28826 5.93679 2.44087 6 2.6 6H21.4C21.5591 6 21.7117 5.93679 21.8243 5.82426C21.9368 5.71174 22 5.55913 22 5.4V4.6C22 4.44087 21.9368 4.28826 21.8243 4.17574C21.7117 4.06321 21.5591 4 21.4 4H2.6ZM8 10C7.73478 10 7.48043 10.1054 7.29289 10.2929C7.10536 10.4804 7 10.7348 7 11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73478 12 8 12H16C16.2652 12 16.5196 11.8946 16.7071 11.7071C16.8946 11.5196 17 11.2652 17 11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10H8Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarPackingOrderIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2021_7712)">
          <path
            d="M11.9638 12.9132V22.3851L19.5047 20.954V16.339C19.5047 16.1458 19.6729 15.9957 19.8649 16.0178L20.7926 16.1613C20.9558 16.1801 21.0791 16.3182 21.0791 16.4825V21.844C21.0791 21.9963 20.9727 22.128 20.8237 22.1601L12.5688 23.935C12.1699 24.0208 11.7574 24.0217 11.3581 23.9377L3.19182 22.2199C3.04523 22.1891 2.93904 22.0616 2.93515 21.9119L2.79406 16.4669C2.78966 16.2962 2.9188 16.1514 3.089 16.1364L10.0257 15.5269C10.146 15.5164 10.2504 15.4396 10.2964 15.3279L11.3414 12.7901C11.4763 12.4626 11.9638 12.559 11.9638 12.9132ZM2.71563 9.81191L0.538806 14.4649C0.432414 14.6923 0.614414 14.9488 0.864178 14.9236L9.03922 14.0975C9.15475 14.0859 9.25511 14.0132 9.30224 13.907L11.9326 7.98112L2.95006 9.63093C2.84727 9.64983 2.75994 9.71724 2.71563 9.81191ZM11.9326 7.98112L14.716 14.0923C14.7646 14.1991 14.8673 14.2712 14.9843 14.2806L23.1439 14.9368C23.3898 14.9566 23.5663 14.7048 23.464 14.4803L21.336 9.81504C21.292 9.71857 21.2034 9.64983 21.0991 9.63104L11.9326 7.98112ZM9.6455 3.1558L11.6657 6.65411C11.8213 6.92348 12.2101 6.92344 12.3656 6.65411L14.3854 3.1558C14.5409 2.88639 14.3465 2.54964 14.0355 2.54964H13.0257V0.404156C13.0257 0.180941 12.8448 0 12.6216 0H11.4093C11.1861 0 11.0052 0.180941 11.0052 0.404117V2.5496H9.99542C9.68436 2.5496 9.48993 2.88639 9.6455 3.1558Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2021_7712">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const SideBarProductIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.61035L21 6.8065V17.1988L12 22.395L3 17.1988V6.8065L12 1.61035ZM8.99995 11.3096L9 18.3536L11 19.5084V12.4644L8.99995 11.3096ZM5 9.00035V16.0441L6.99998 17.1989V10.155L5 9.00035ZM15.9371 6.1928L10.0506 9.60699L12 10.7325L17.9 7.32612L15.9371 6.1928ZM12 3.91975L6.1 7.32612L8.05289 8.45359L13.9394 5.03945L12 3.91975Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarReceiptIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 6.25C4 5.00736 5.00736 4 6.25 4H14.75C15.9926 4 17 5.00736 17 6.25V14H20.5V17.25C20.5 19.0449 19.0449 20.5 17.25 20.5H6.25C5.00736 20.5 4 19.4926 4 18.25V6.25ZM17 19H17.25C18.2165 19 19 18.2165 19 17.25V15.5H17V19ZM7.75 8C7.33579 8 7 8.33579 7 8.75C7 9.16421 7.33579 9.5 7.75 9.5H13.25C13.6642 9.5 14 9.16421 14 8.75C14 8.33579 13.6642 8 13.25 8H7.75ZM7.75 11.5C7.33579 11.5 7 11.8358 7 12.25C7 12.6642 7.33579 13 7.75 13H13.25C13.6642 13 14 12.6642 14 12.25C14 11.8358 13.6642 11.5 13.25 11.5H7.75ZM7.75 15C7.33579 15 7 15.3358 7 15.75C7 16.1642 7.33579 16.5 7.75 16.5H10.25C10.6642 16.5 11 16.1642 11 15.75C11 15.3358 10.6642 15 10.25 15H7.75Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};
export const SideBarTemplateIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7128 4.7998H6.28878C5.47278 4.7998 4.80078 5.4718 4.80078 6.2878V17.7118C4.80078 18.5278 5.47278 19.1998 6.28878 19.1998H17.7128C18.5288 19.1998 19.2008 18.5278 19.2008 17.7118V6.2878C19.2008 5.4718 18.5288 4.7998 17.7128 4.7998ZM10.1528 16.5838C10.1528 16.7758 9.96078 16.9198 9.76878 16.9198H7.34478H7.29678C7.10478 16.9198 6.96078 16.7278 6.96078 16.5358V11.7118C6.96078 11.5198 7.15278 11.3758 7.34478 11.3758H9.84078C10.0328 11.3758 10.1768 11.5678 10.1768 11.7598V16.5838H10.1528ZM16.9688 16.6318C16.9688 16.8238 16.7768 16.9678 16.5848 16.9678H11.9768C11.7848 16.9678 11.6408 16.7758 11.6408 16.5838V11.7118C11.6408 11.5198 11.8328 11.3758 12.0248 11.3758H16.6088H16.6568C16.8488 11.3758 16.9928 11.5678 16.9928 11.7598V16.6318H16.9688ZM17.0168 9.5758C17.0168 9.76781 16.8248 9.9118 16.6328 9.9118H7.34478H7.29678C7.10478 9.9118 6.96078 9.7198 6.96078 9.5278V7.3678C6.96078 7.1758 7.15278 7.0318 7.34478 7.0318H16.6808C16.8728 7.0318 17.0168 7.2238 17.0168 7.4158V9.5758Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarWareHousetIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.6014 7.99968C21.4795 8.00016 21.3591 7.9728 21.2494 7.91968L12.0014 3.19968L2.75338 7.88768C2.3425 8.08208 1.85178 7.90656 1.65738 7.49568C1.46298 7.0848 1.6385 6.59408 2.04938 6.39968L12.0014 1.47168L21.9534 6.39968C22.3951 6.49696 22.6747 6.93392 22.5774 7.37568C22.4801 7.81744 22.0431 8.09696 21.6014 7.99968ZM8.00138 15.9997H3.20138V20.7997H8.00138V15.9997ZM14.4014 15.9997H9.60138V20.7997H14.4014V15.9997ZM20.8014 15.9997H16.0014V20.7997H20.8014V15.9997ZM17.6014 9.59968H12.8014V14.3997H17.6014V9.59968ZM11.2014 9.59968H6.40138V14.3997H11.2014V9.59968Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarNotificationIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.1911 14.0608L19.0611 12.1808C18.8111 11.7708 18.5911 10.9808 18.5911 10.5008V8.63078C18.5911 5.00078 15.6411 2.05078 12.0211 2.05078C8.39118 2.06078 5.44118 5.00078 5.44118 8.63078V10.4908C5.44118 10.9708 5.22118 11.7608 4.98118 12.1708L3.85118 14.0508C3.42118 14.7808 3.32118 15.6108 3.59118 16.3308C3.86118 17.0608 4.47118 17.6408 5.27118 17.9008C6.35118 18.2608 7.44118 18.5208 8.55118 18.7108C8.66118 18.7308 8.77118 18.7408 8.88118 18.7608C9.02118 18.7808 9.17118 18.8008 9.32118 18.8208C9.58118 18.8608 9.84118 18.8908 10.1111 18.9108C10.7411 18.9708 11.3811 19.0008 12.0211 19.0008C12.6511 19.0008 13.2811 18.9708 13.9011 18.9108C14.1311 18.8908 14.3611 18.8708 14.5811 18.8408C14.7611 18.8208 14.9411 18.8008 15.1211 18.7708C15.2311 18.7608 15.3411 18.7408 15.4511 18.7208C16.5711 18.5408 17.6811 18.2608 18.7611 17.9008C19.5311 17.6408 20.1211 17.0608 20.4011 16.3208C20.6811 15.5708 20.6011 14.7508 20.1911 14.0608ZM12.7511 10.0008C12.7511 10.4208 12.4111 10.7608 11.9911 10.7608C11.5711 10.7608 11.2311 10.4208 11.2311 10.0008V6.90078C11.2311 6.48078 11.5711 6.14078 11.9911 6.14078C12.4111 6.14078 12.7511 6.48078 12.7511 6.90078V10.0008Z"
          fill={color}
        />
        <path
          d="M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarEditDeleteIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12V11.5C20 10.9477 20.4477 10.5 21 10.5C21.5523 10.5 22 10.9477 22 11.5V12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2H12.5C13.0523 2 13.5 2.44772 13.5 3C13.5 3.55228 13.0523 4 12.5 4H12Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2156 2.82088C17.7412 2.29528 18.4541 2 19.1974 2C19.9407 2 20.6535 2.29528 21.1791 2.82088C21.7047 3.34648 22 4.05934 22 4.80265C22 5.54596 21.7047 6.25883 21.1791 6.78443L20.396 7.56757C20.0055 7.9581 19.3723 7.9581 18.9818 7.56757L16.4324 5.01824C16.0419 4.62771 16.0419 3.99455 16.4324 3.60402L17.2156 2.82088ZM15.0182 6.43245C14.6277 6.04192 13.9945 6.04192 13.604 6.43245L9.14269 10.8938C9.01453 11.0219 8.92362 11.1825 8.87966 11.3583L8.02988 14.7575C7.94468 15.0982 8.04453 15.4587 8.29291 15.7071C8.54129 15.9555 8.90178 16.0553 9.24256 15.9701L12.6417 15.1204C12.8175 15.0764 12.9781 14.9855 13.1062 14.8573L17.5676 10.396C17.9581 10.0055 17.9581 9.37231 17.5676 8.98179L15.0182 6.43245Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const SideBarAccountIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const Update = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect x="2" y="2" width="20" height="20" rx="10" fill="white" />
        <path
          d="M12 22C6.47715 22 2 17.5229 2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5229 17.5229 22 12 22ZM13.8697 17.7042C15.0886 17.3081 16.0969 16.5578 16.8162 15.6073C16.8525 15.5732 16.8799 15.5309 16.8963 15.4839C16.9126 15.4369 16.9173 15.3866 16.91 15.3374C16.9096 15.3343 16.9092 15.3312 16.9088 15.3281L16.9086 15.3274C16.9008 15.2798 16.882 15.2346 16.8536 15.1957C16.8251 15.1567 16.7879 15.1249 16.745 15.103L15.8718 14.4605C15.8374 14.4253 15.795 14.3988 15.7483 14.3832C15.7016 14.3676 15.6519 14.3634 15.6032 14.371C15.6008 14.3712 15.5983 14.3715 15.5959 14.3719L15.5948 14.3721C15.5475 14.3798 15.5027 14.3983 15.4638 14.4263C15.4249 14.4542 15.393 14.4907 15.3706 14.533C14.8672 15.1947 14.167 15.7159 13.3138 15.9931C11.0983 16.7129 8.72801 15.5103 8.01055 13.3021C7.29309 11.094 8.50377 8.72781 10.7192 8.00797C12.7961 7.33316 14.9947 8.31695 15.8553 10.2575L14.4564 10.2418C14.316 10.221 14.1793 10.2981 14.1247 10.4289C14.098 10.4912 14.0925 10.5606 14.1093 10.6263C14.1261 10.6921 14.1641 10.7504 14.2175 10.7922L16.579 13.2612C16.6376 13.3224 16.7188 13.3569 16.8038 13.3565C16.8887 13.3561 16.9698 13.3209 17.0281 13.2591L19.39 10.754C19.4929 10.6721 19.5327 10.5345 19.4893 10.4108C19.4885 10.4087 19.4878 10.4067 19.487 10.4046C19.4818 10.3905 19.4756 10.3768 19.4685 10.3636L19.4679 10.3622C19.407 10.2503 19.2833 10.1873 19.1566 10.2038L17.7566 10.1942L17.7392 10.1406C16.7168 6.99385 13.3205 5.27051 10.1631 6.29641C7.00574 7.3223 5.27105 10.7128 6.29348 13.8595C7.3159 17.0062 10.7122 18.7296 13.8696 17.7037L13.8697 17.7042L13.8697 17.7042Z"
          fill="#9747FF"
        />
      </svg>
    </>
  );
};

export const UpdateIcon1 = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#9747FF" fillOpacity="0.1" />
        <rect x="7.50156" y="7.5" width="20" height="20" rx="10" fill="white" />
        <path
          d="M17.5016 27.5C11.9787 27.5 7.50156 23.0229 7.50156 17.5C7.50156 11.9771 11.9787 7.5 17.5016 7.5C23.0244 7.5 27.5016 11.9771 27.5016 17.5C27.5016 23.0229 23.0244 27.5 17.5016 27.5ZM19.3713 23.2042C20.5901 22.8081 21.5985 22.0578 22.3178 21.1073C22.354 21.0732 22.3815 21.0309 22.3978 20.9839C22.4141 20.9369 22.4188 20.8866 22.4115 20.8374C22.4112 20.8343 22.4108 20.8312 22.4103 20.8281L22.4102 20.8274C22.4024 20.7798 22.3835 20.7346 22.3551 20.6957C22.3267 20.6567 22.2895 20.6249 22.2465 20.603L21.3733 19.9605C21.3389 19.9253 21.2966 19.8988 21.2499 19.8832C21.2032 19.8676 21.1534 19.8634 21.1048 19.871C21.1023 19.8712 21.0999 19.8715 21.0975 19.8719L21.0963 19.8721C21.0491 19.8798 21.0043 19.8983 20.9654 19.9263C20.9265 19.9542 20.8946 19.9907 20.8722 20.033C20.3687 20.6947 19.6686 21.2159 18.8153 21.4931C16.5999 22.2129 14.2296 21.0103 13.5121 18.8021C12.7946 16.594 14.0053 14.2278 16.2208 13.508C18.2977 12.8332 20.4963 13.817 21.3568 15.7575L19.958 15.7418C19.8176 15.721 19.6808 15.7981 19.6263 15.9289C19.5995 15.9912 19.5941 16.0606 19.6109 16.1263C19.6276 16.1921 19.6657 16.2504 19.719 16.2922L22.0805 18.7612C22.1391 18.8224 22.2204 18.8569 22.3053 18.8565C22.3903 18.8561 22.4714 18.8209 22.5297 18.7591L24.8916 16.254C24.9944 16.1721 25.0342 16.0345 24.9909 15.9108C24.9901 15.9087 24.9893 15.9067 24.9885 15.9046C24.9834 15.8905 24.9772 15.8768 24.97 15.8636L24.9694 15.8622C24.9086 15.7503 24.7849 15.6873 24.6582 15.7038L23.2582 15.6942L23.2408 15.6406C22.2184 12.4938 18.8221 10.7705 15.6647 11.7964C12.5073 12.8223 10.7726 16.2128 11.795 19.3595C12.8175 22.5062 16.2137 24.2296 19.3711 23.2037L19.3713 23.2042L19.3713 23.2042Z"
          fill="#9747FF"
        />
      </svg>
    </React.Fragment>
  );
};
export const ActiveStatusIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="2" width="20" height="20" rx="10" fill="white" />
        <path
          d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
          fill="#34A853"
        />
      </svg>
    </React.Fragment>
  );
};

export const Disabled = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
      >
        <path
          d="M12.5016 21.5C17.4721 21.5 21.5016 17.4706 21.5016 12.5C21.5016 7.52944 17.4721 3.5 12.5016 3.5C7.53102 3.5 3.50159 7.52944 3.50159 12.5C3.50159 17.4706 7.53102 21.5 12.5016 21.5Z"
          stroke="#F93E3E"
          strokeWidth="2"
        />
        <path d="M18.5016 18.5L6.50159 6.5" stroke="#F93E3E" strokeWidth="2" />
      </svg>
    </>
  );
};

export const BlackListedIcon = ({ fill = "#fff" }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#F93E3E" fillOpacity="0.1" />
        <path
          d="M5.50156 17.4999C5.50156 24.1167 10.8847 29.4999 17.5015 29.4999C24.1182 29.4999 29.5013 24.1167 29.5013 17.4999C29.5013 10.8831 24.1182 5.5 17.5015 5.5C10.8847 5.5 5.50156 10.8831 5.50156 17.4999ZM17.5015 8.79443C22.3018 8.79443 26.2071 12.6998 26.2071 17.5001C26.2071 19.3062 25.6539 20.9854 24.7086 22.3776L12.6238 10.293C14.0162 9.34762 15.6954 8.79443 17.5015 8.79443ZM22.379 24.707C20.9867 25.6524 19.3076 26.2056 17.5015 26.2056C12.7012 26.2056 8.796 22.3002 8.796 17.4999C8.796 15.6938 9.34918 14.0148 10.2944 12.6224L22.379 24.707Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const NewNoBg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_3609_57097)">
          <rect width="24" height="24" rx="12" fill="white" />
          <path
            d="M19.3214 16.5178C18.7338 16.6935 18.1569 16.9988 17.5765 17.5764L17.5758 17.5771C16.8203 18.3383 16.5233 19.0946 16.392 19.8752C16.2628 20.6555 16.3267 21.4543 16.3403 22.2188C16.3417 22.3465 16.3425 22.4742 16.3396 22.6009L22.6009 16.3388C22.4022 16.3435 22.202 16.3406 21.9997 16.3356C21.1194 16.3093 20.2003 16.2555 19.3214 16.5178Z"
            fill="#4164E3"
          />
          <path
            d="M12.0003 0C5.37239 0 0 5.37202 0 11.9992C0 18.6272 5.37239 23.9996 12.0003 23.9996C12.9926 23.9996 13.9533 23.8712 14.876 23.6437C14.9943 23.5128 15.0697 23.3511 15.1185 23.0899C15.168 22.8162 15.1723 22.4513 15.1601 22.0302C15.14 21.1872 15.0568 20.1188 15.3897 18.9867C15.6114 18.2327 16.029 17.4578 16.7443 16.745C16.7443 16.745 16.7443 16.7446 16.745 16.7443C17.6799 15.8037 18.7238 15.385 19.6845 15.2311C20.6466 15.0751 21.5326 15.1554 22.2365 15.1641C22.705 15.1734 23.0867 15.1447 23.3342 15.0561C23.4648 15.0097 23.5588 14.9517 23.6442 14.8738C23.8716 13.9522 24 12.9912 24 11.9993C24 5.37201 18.6276 0 12.0003 0ZM9.47198 15.1141L8.68566 15.2691C8.63259 15.2791 8.59598 15.2659 8.56008 15.225L6.41414 12.7174L6.38114 12.7239L6.93572 15.5443C6.94359 15.5841 6.92208 15.6157 6.88266 15.6235L6.13575 15.7703C6.09628 15.7782 6.06473 15.7566 6.05681 15.7168L5.20017 11.3579C5.19159 11.3177 5.21311 11.2865 5.25258 11.2786L6.04537 11.1225C6.09202 11.1132 6.13505 11.1258 6.1702 11.167L8.31183 13.6821L8.34483 13.6756L7.7888 10.8485C7.78087 10.8086 7.80239 10.7775 7.84261 10.7692L8.58877 10.6225C8.62823 10.6146 8.65983 10.6354 8.6677 10.6755L9.52509 15.0349C9.53297 15.0751 9.51145 15.1066 9.47198 15.1141ZM13.3441 14.3526L10.4642 14.9193C10.4241 14.9269 10.3932 14.9057 10.3853 14.8659L9.52725 10.5069C9.52008 10.4668 9.54089 10.4352 9.58106 10.4273L12.461 9.86086C12.5004 9.85331 12.532 9.87455 12.5399 9.9143L12.6784 10.621C12.687 10.6605 12.6655 10.692 12.626 10.6999L10.6903 11.0805C10.6637 11.0855 10.653 11.1014 10.658 11.1279L10.8338 12.0197C10.8388 12.0459 10.8546 12.0566 10.8811 12.0516L12.4933 11.7345C12.5327 11.7269 12.5643 11.7485 12.5722 11.7876L12.71 12.4878C12.7178 12.5276 12.6963 12.5588 12.6569 12.5667L11.0447 12.8838C11.0189 12.8888 11.0074 12.9046 11.0124 12.9311L11.1961 13.8624C11.2011 13.889 11.2176 13.8993 11.2434 13.8939L13.1791 13.5133C13.2186 13.5054 13.2502 13.5273 13.2581 13.5667L13.3973 14.2734C13.4052 14.3135 13.3837 14.3451 13.3441 14.3526ZM18.1677 13.3352C18.1685 13.3768 18.1412 13.4098 18.0945 13.4184L17.4338 13.5483C17.3879 13.5576 17.3556 13.5361 17.3348 13.4991L16.006 10.8585L15.9931 10.8614L15.7563 13.8097C15.7513 13.8517 15.7297 13.8837 15.6839 13.8926L15.0231 14.0228C14.9836 14.0304 14.952 14.0089 14.9305 13.9719L12.9109 9.84108C12.8965 9.80269 12.9044 9.77362 12.951 9.76467L13.8026 9.59714C13.8492 9.58819 13.8808 9.60895 13.8945 9.64772L15.0969 12.3407L15.1105 12.3378L15.3222 9.36717C15.3272 9.32447 15.3487 9.29325 15.3946 9.28392L15.9693 9.17095C16.0088 9.16341 16.0404 9.18422 16.0619 9.22191L17.4086 11.8859L17.4222 11.8834L17.4882 8.94141C17.4861 8.89369 17.5083 8.86823 17.5549 8.85928L18.4001 8.69316C18.446 8.68383 18.4647 8.7075 18.4654 8.74875L18.1677 13.3352Z"
            fill="#4164E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_3609_57097">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const New = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#4164E3" fillOpacity="0.1" />
        <g clipPath="url(#clip0_14117_95943)">
          <path
            d="M24.8234 22.0178C24.2357 22.1935 23.6589 22.4988 23.0785 23.0764L23.0777 23.0771C22.3223 23.8383 22.0252 24.5946 21.894 25.3752C21.7648 26.1555 21.8286 26.9543 21.8423 27.7188C21.8437 27.8465 21.8444 27.9742 21.8416 28.1009L28.1029 21.8388C27.9041 21.8435 27.704 21.8406 27.5017 21.8356C26.6214 21.8093 25.7023 21.7555 24.8234 22.0178Z"
            fill="#4164E3"
          />
          <path
            d="M17.5023 5.5C10.8743 5.5 5.50195 10.872 5.50195 17.4992C5.50195 24.1272 10.8743 29.4996 17.5023 29.4996C18.4945 29.4996 19.4552 29.3712 20.3779 29.1437C20.4963 29.0128 20.5716 28.8511 20.6204 28.5899C20.6699 28.3162 20.6742 27.9513 20.662 27.5302C20.642 26.6872 20.5587 25.6188 20.8916 24.4867C21.1133 23.7327 21.5309 22.9578 22.2462 22.245C22.2462 22.245 22.2462 22.2446 22.247 22.2443C23.1818 21.3037 24.2257 20.885 25.1864 20.7311C26.1485 20.5751 27.0346 20.6554 27.7385 20.6641C28.207 20.6734 28.5886 20.6447 28.8362 20.5561C28.9667 20.5097 29.0608 20.4517 29.1461 20.3738C29.3736 19.4522 29.502 18.4912 29.502 17.4993C29.502 10.872 24.1296 5.5 17.5023 5.5ZM14.9739 20.6141L14.1876 20.7691C14.1345 20.7791 14.0979 20.7659 14.062 20.725L11.9161 18.2174L11.8831 18.2239L12.4377 21.0443C12.4455 21.0841 12.424 21.1157 12.3846 21.1235L11.6377 21.2703C11.5982 21.2782 11.5667 21.2566 11.5588 21.2168L10.7021 16.8579C10.6935 16.8177 10.7151 16.7865 10.7545 16.7786L11.5473 16.6225C11.594 16.6132 11.637 16.6258 11.6722 16.667L13.8138 19.1821L13.8468 19.1756L13.2907 16.3485C13.2828 16.3086 13.3043 16.2775 13.3446 16.2692L14.0907 16.1225C14.1302 16.1146 14.1618 16.1354 14.1697 16.1755L15.027 20.5349C15.0349 20.5751 15.0134 20.6066 14.9739 20.6141ZM18.8461 19.8526L15.9662 20.4193C15.926 20.4269 15.8951 20.4057 15.8873 20.3659L15.0292 16.0069C15.022 15.9668 15.0428 15.9352 15.083 15.9273L17.9629 15.3609C18.0024 15.3533 18.034 15.3745 18.0419 15.4143L18.1803 16.121C18.189 16.1605 18.1674 16.192 18.128 16.1999L16.1922 16.5805C16.1657 16.5855 16.155 16.6014 16.1599 16.6279L16.3358 17.5197C16.3407 17.5459 16.3565 17.5566 16.3831 17.5516L17.9952 17.2345C18.0347 17.2269 18.0663 17.2485 18.0742 17.2876L18.2119 17.9878C18.2198 18.0276 18.1983 18.0588 18.1588 18.0667L16.5467 18.3838C16.5209 18.3888 16.5094 18.4046 16.5144 18.4311L16.698 19.3624C16.7031 19.389 16.7196 19.3993 16.7454 19.3939L18.6811 19.0133C18.7206 19.0054 18.7522 19.0273 18.76 19.0667L18.8992 19.7734C18.9071 19.8135 18.8856 19.8451 18.8461 19.8526ZM23.6697 18.8352C23.6704 18.8768 23.6431 18.9098 23.5965 18.9184L22.9357 19.0483C22.8898 19.0576 22.8576 19.0361 22.8367 18.9991L21.5079 16.3585L21.495 16.3614L21.2582 19.3097C21.2533 19.3517 21.2317 19.3837 21.1858 19.3926L20.5251 19.5228C20.4855 19.5304 20.454 19.5089 20.4325 19.4719L18.4128 15.3411C18.3985 15.3027 18.4064 15.2736 18.453 15.2647L19.3046 15.0971C19.3512 15.0882 19.3828 15.109 19.3964 15.1477L20.5988 17.8407L20.6125 17.8378L20.8241 14.8672C20.8291 14.8245 20.8507 14.7932 20.8966 14.7839L21.4713 14.671C21.5107 14.6634 21.5423 14.6842 21.5639 14.7219L22.9105 17.3859L22.9242 17.3834L22.9902 14.4414C22.988 14.3937 23.0103 14.3682 23.0569 14.3593L23.902 14.1932C23.948 14.1838 23.9666 14.2075 23.9673 14.2487L23.6697 18.8352Z"
            fill="#4164E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_14117_95943">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(5.50195 5.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const Pending = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect width="24" height="24" rx="12" fill="white" />
        <path
          d="M8.40002 11.2C10.8301 11.2 12.8 13.1699 12.8 15.6C12.8 18.0301 10.8301 20 8.40002 20C5.96996 20 4.00002 18.0301 4.00002 15.6C4.00002 13.1699 5.96996 11.2 8.40002 11.2ZM8.40002 17.504C8.12409 17.504 7.90041 17.7277 7.90041 18.0036C7.90041 18.2795 8.12409 18.5032 8.40002 18.5032C8.67594 18.5032 8.89962 18.2795 8.89962 18.0036C8.89962 17.7277 8.67594 17.504 8.40002 17.504ZM17.4 4C18.836 4 20 5.16406 20 6.6V15.8C20 17.2359 18.836 18.4 17.4 18.4L12.7819 18.401C13.2998 17.5925 13.6 16.6313 13.6 15.6C13.6 14.3877 13.1852 13.2723 12.4887 12.3897L12.5436 12.3974L12.6 12.4H16.1986L16.28 12.3945C16.5729 12.3548 16.7986 12.1038 16.7986 11.8C16.7986 11.4962 16.5729 11.2452 16.28 11.2055L16.1986 11.2H13.2V7L13.1945 6.91858C13.1548 6.62572 12.9038 6.4 12.6 6.4C12.2963 6.4 12.0452 6.62572 12.0055 6.91858L12 7V11.8L12.0039 11.8514C11.0692 10.9526 9.79914 10.4 8.40002 10.4C7.36869 10.4 6.40749 10.7002 5.59905 11.2181L5.60002 6.6C5.60002 5.16406 6.76408 4 8.20002 4H17.4ZM8.40005 12.8025C7.56169 12.8025 6.90862 13.4564 6.91735 14.3659C6.91947 14.5868 7.10026 14.7642 7.32117 14.762C7.54207 14.7599 7.71943 14.5791 7.71731 14.3582C7.71286 13.895 8.00503 13.6025 8.40005 13.6025C8.77795 13.6025 9.08277 13.916 9.08277 14.3621C9.08277 14.5415 9.02254 14.675 8.82843 14.904L8.74922 14.9946L8.53692 15.2267C8.14947 15.6599 8.00005 15.9404 8.00005 16.4005C8.00005 16.6214 8.17914 16.8005 8.40005 16.8005C8.62096 16.8005 8.80005 16.6214 8.80005 16.4005C8.80005 16.2147 8.86118 16.0785 9.05905 15.845L9.13981 15.7526L9.3524 15.5202C9.73454 15.0928 9.88277 14.8149 9.88277 14.3621C9.88277 13.4791 9.22489 12.8025 8.40005 12.8025Z"
          fill="#FF9900"
        />
      </svg>
    </>
  );
};

export const PendingIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#FF9900" fillOpacity="0.1" />
        <path
          d="M12.0016 17.5C15.0392 17.5 17.5016 19.9624 17.5016 23C17.5016 26.0376 15.0392 28.5 12.0016 28.5C8.96402 28.5 6.50159 26.0376 6.50159 23C6.50159 19.9624 8.96402 17.5 12.0016 17.5ZM12.0016 25.38C11.6567 25.38 11.3771 25.6596 11.3771 26.0045C11.3771 26.3494 11.6567 26.629 12.0016 26.629C12.3465 26.629 12.6261 26.3494 12.6261 26.0045C12.6261 25.6596 12.3465 25.38 12.0016 25.38ZM23.2516 8.5C25.0465 8.5 26.5016 9.95507 26.5016 11.75V23.25C26.5016 25.0449 25.0465 26.5 23.2516 26.5L17.479 26.5012C18.1263 25.4907 18.5016 24.2892 18.5016 23C18.5016 21.4846 17.983 20.0904 17.1124 18.9871L17.1811 18.9967L17.2516 19H21.7498L21.8516 18.9932C22.2177 18.9435 22.4998 18.6297 22.4998 18.25C22.4998 17.8703 22.2177 17.5565 21.8516 17.5068L21.7498 17.5H18.0016V12.25L17.9947 12.1482C17.9451 11.7822 17.6313 11.5 17.2516 11.5C16.8719 11.5 16.5581 11.7822 16.5084 12.1482L16.5016 12.25V18.25L16.5064 18.3142C15.3381 17.1907 13.7505 16.5 12.0016 16.5C10.7124 16.5 9.51093 16.8753 8.50038 17.5226L8.50159 11.75C8.50159 9.95507 9.95666 8.5 11.7516 8.5H23.2516ZM12.0016 19.5031C10.9537 19.5031 10.1373 20.3205 10.1483 21.4574C10.1509 21.7335 10.3769 21.9552 10.653 21.9526C10.9292 21.9499 11.1509 21.7239 11.1482 21.4478C11.1426 20.8688 11.5079 20.5031 12.0016 20.5031C12.474 20.5031 12.855 20.895 12.855 21.4526C12.855 21.6769 12.7797 21.8437 12.5371 22.13L12.4381 22.2432L12.1727 22.5333C11.6884 23.0749 11.5016 23.4255 11.5016 24.0006C11.5016 24.2767 11.7255 24.5006 12.0016 24.5006C12.2778 24.5006 12.5016 24.2767 12.5016 24.0006C12.5016 23.7684 12.578 23.5981 12.8254 23.3063L12.9263 23.1908L13.1921 22.9003C13.6697 22.366 13.855 22.0186 13.855 21.4526C13.855 20.3489 13.0327 19.5031 12.0016 19.5031Z"
          fill="#FF9900"
        />
      </svg>
    </React.Fragment>
  );
};

export const Rejected = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2427 15.18C16.536 15.4725 16.536 15.9525 16.2427 16.245C15.9502 16.5375 15.4748 16.5375 15.1815 16.245L12.0045 13.065L8.80499 16.2675C8.50949 16.56 8.03102 16.56 7.73552 16.2675C7.44077 15.9675 7.44077 15.4875 7.73552 15.195L10.935 11.9925L7.758 8.82001C7.46475 8.52751 7.46475 8.04747 7.758 7.75497C8.04975 7.46247 8.52525 7.46247 8.8185 7.75497L11.9955 10.935L15.219 7.71002C15.5145 7.41752 15.9922 7.41752 16.2877 7.71002C16.5825 8.01002 16.5825 8.48247 16.2877 8.78247L13.065 12.0075L16.2427 15.18ZM12 0C5.37225 0 0 5.37 0 12C0 18.63 5.37225 24 12 24C18.6278 24 24 18.63 24 12C24 5.37 18.6278 0 12 0Z"
          fill="#F93E3E"
        />
      </svg>
    </>
  );
};

export const DealerInfoCardRejectedStatusIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_3609_60753)">
          <rect width="24" height="24" rx="12" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2427 15.18C16.536 15.4725 16.536 15.9525 16.2427 16.245C15.9502 16.5375 15.4748 16.5375 15.1815 16.245L12.0045 13.065L8.80499 16.2675C8.50949 16.56 8.03102 16.56 7.73552 16.2675C7.44077 15.9675 7.44077 15.4875 7.73552 15.195L10.935 11.9925L7.758 8.82001C7.46475 8.52751 7.46475 8.04747 7.758 7.75497C8.04975 7.46247 8.52525 7.46247 8.8185 7.75497L11.9955 10.935L15.219 7.71002C15.5145 7.41752 15.9922 7.41752 16.2877 7.71002C16.5825 8.01002 16.5825 8.48247 16.2877 8.78247L13.065 12.0075L16.2427 15.18ZM12 0C5.37225 0 0 5.37 0 12C0 18.63 5.37225 24 12 24C18.6278 24 24 18.63 24 12C24 5.37 18.6278 0 12 0Z"
            fill="#F93E3E"
          />
        </g>
        <defs>
          <clipPath id="clip0_3609_60753">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PhoneIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#F8F9FC" />
        <path
          opacity="0.4"
          d="M25.3 7.5H14.7C11.25 7.5 10 8.75 10 12.2625V27.7375C10 31.25 11.25 32.5 14.7 32.5H25.2875C28.75 32.5 30 31.25 30 27.7375V12.2625C30 8.75 28.75 7.5 25.3 7.5Z"
          fill="#4164E3"
        />
        <path
          d="M22.5 12.8125H17.5C16.9875 12.8125 16.5625 12.3875 16.5625 11.875C16.5625 11.3625 16.9875 10.9375 17.5 10.9375H22.5C23.0125 10.9375 23.4375 11.3625 23.4375 11.875C23.4375 12.3875 23.0125 12.8125 22.5 12.8125Z"
          fill="#4164E3"
        />
        <path
          d="M20 29.125C21.2081 29.125 22.1875 28.1456 22.1875 26.9375C22.1875 25.7294 21.2081 24.75 20 24.75C18.7919 24.75 17.8125 25.7294 17.8125 26.9375C17.8125 28.1456 18.7919 29.125 20 29.125Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};
export const PhoneIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#212327" />
        <path
          opacity="0.4"
          d="M25.3 7.5H14.7C11.25 7.5 10 8.75 10 12.2625V27.7375C10 31.25 11.25 32.5 14.7 32.5H25.2875C28.75 32.5 30 31.25 30 27.7375V12.2625C30 8.75 28.75 7.5 25.3 7.5Z"
          fill="white"
        />
        <path
          d="M22.5 12.8125H17.5C16.9875 12.8125 16.5625 12.3875 16.5625 11.875C16.5625 11.3625 16.9875 10.9375 17.5 10.9375H22.5C23.0125 10.9375 23.4375 11.3625 23.4375 11.875C23.4375 12.3875 23.0125 12.8125 22.5 12.8125Z"
          fill="white"
        />
        <path
          d="M20 29.125C21.2081 29.125 22.1875 28.1456 22.1875 26.9375C22.1875 25.7294 21.2081 24.75 20 24.75C18.7919 24.75 17.8125 25.7294 17.8125 26.9375C17.8125 28.1456 18.7919 29.125 20 29.125Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const CallIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#F8F9FC" />
        <path
          opacity="0.5"
          d="M17.547 11.6452L18.3583 13.0989C19.0904 14.4107 18.7965 16.1316 17.6434 17.2847C17.6434 17.2847 16.2449 18.6835 18.7806 21.2194C21.3156 23.7544 22.7153 22.3566 22.7153 22.3566C23.8684 21.2035 25.5893 20.9096 26.9011 21.6418L28.3548 22.453C30.3358 23.5585 30.5696 26.3365 28.8285 28.0778C27.7823 29.124 26.5005 29.9381 25.0836 29.9918C22.6985 30.0823 18.6479 29.4786 14.5846 25.4154C10.5214 21.3521 9.91777 17.3015 10.0082 14.9164C10.0619 13.4995 10.876 12.2178 11.9223 11.1715C13.6635 9.43035 16.4415 9.6643 17.547 11.6452Z"
          fill="#4164E3"
        />
        <path
          d="M21.5744 7.34979C21.6571 6.83868 22.1402 6.49197 22.6514 6.5747C22.683 6.58077 22.7849 6.59979 22.8381 6.61167C22.9449 6.63543 23.0936 6.67199 23.2791 6.72603C23.6501 6.83408 24.1684 7.01209 24.7904 7.29725C26.0357 7.8682 27.693 8.86695 29.4127 10.5867C31.1325 12.3065 32.1312 13.9637 32.7021 15.2091C32.9874 15.8311 33.1654 16.3493 33.2734 16.7203C33.3274 16.9058 33.364 17.0546 33.3877 17.1613C33.3996 17.2146 33.4084 17.2574 33.4144 17.2891L33.4216 17.3281C33.5042 17.8391 33.1607 18.3424 32.6496 18.4251C32.14 18.5076 31.6599 18.1625 31.5751 17.6539C31.5725 17.6401 31.5652 17.6035 31.5576 17.5689C31.5421 17.4996 31.5155 17.3899 31.4732 17.2447C31.3886 16.9542 31.2417 16.5226 30.9977 15.9905C30.5105 14.9276 29.6342 13.4599 28.0869 11.9125C26.5396 10.3652 25.0719 9.48897 24.009 9.00168C23.4769 8.75773 23.0452 8.61082 22.7547 8.52622C22.6096 8.48393 22.4271 8.44204 22.3579 8.42663C21.8491 8.34184 21.4919 7.85944 21.5744 7.34979Z"
          fill="#4164E3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8566 11.6607C21.9989 11.1628 22.5177 10.8745 23.0156 11.0168L22.7581 11.9182C23.0156 11.0168 23.0156 11.0168 23.0156 11.0168L23.0175 11.0173L23.0194 11.0179L23.0235 11.0191L23.0332 11.022L23.058 11.0297C23.0767 11.0357 23.1004 11.0435 23.1284 11.0535C23.1845 11.0734 23.2587 11.1018 23.3497 11.1408C23.5319 11.2188 23.7806 11.3393 24.0864 11.5202C24.6981 11.8823 25.5334 12.4838 26.5146 13.465C27.4959 14.4462 28.0972 15.2815 28.4594 15.8933C28.6402 16.1989 28.7607 16.4478 28.8389 16.6299C28.8779 16.7209 28.9062 16.7951 28.9261 16.8512C28.9361 16.8793 28.9439 16.9028 28.95 16.9217L28.9576 16.9464L28.9605 16.9561L28.9617 16.9602L28.9622 16.9622C28.9622 16.9622 28.9629 16.964 28.0614 17.2215L28.9629 16.964C29.1051 17.4618 28.8167 17.9807 28.319 18.1229C27.8254 18.2639 27.311 17.9818 27.1636 17.4917L27.159 17.4782C27.1524 17.4594 27.1386 17.4225 27.1155 17.3685C27.0692 17.2605 26.9854 17.084 26.8459 16.8483C26.5671 16.3773 26.0637 15.6658 25.1887 14.7908C24.3139 13.9159 23.6022 13.4125 23.1314 13.1338C22.8956 12.9943 22.7191 12.9104 22.6111 12.8642C22.5571 12.841 22.5201 12.8272 22.5014 12.8206L22.4879 12.8159C21.9979 12.6686 21.7156 12.1543 21.8566 11.6607Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};

export const DealerInfoCardCallDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M6.72831 19.6998C7.54831 18.8198 8.79828 18.8898 9.51828 19.8498L10.5283 21.1998C11.3383 22.2698 12.6483 22.2698 13.4583 21.1998L14.4683 19.8498C15.1883 18.8898 16.4384 18.8198 17.2584 19.6998C19.0384 21.5998 20.4883 20.9698 20.4883 18.3098V7.04974C20.4883 3.01974 19.5483 2.00977 15.7683 2.00977H8.20829C4.42829 2.00977 3.48828 3.01974 3.48828 7.04974V18.3098C3.49828 20.9698 4.95831 21.5898 6.72831 19.6998Z"
          fill="#E4E7EB"
        />
        <path
          d="M14.8429 9.99114L14.3429 10.5012H14.3329L11.3029 13.5312C11.1729 13.6612 10.9029 13.8012 10.7129 13.8212L9.36286 14.0212C8.87286 14.0912 8.53288 13.7412 8.60288 13.2612L8.79288 11.9012C8.82288 11.7112 8.95286 11.4512 9.08286 11.3112L12.1229 8.28115L12.6229 7.77114C12.9529 7.44114 13.3229 7.20117 13.7229 7.20117C14.0629 7.20117 14.4329 7.36114 14.8429 7.77114C15.7429 8.67114 15.4529 9.38114 14.8429 9.99114Z"
          fill="#E4E7EB"
        />
      </svg>
    </React.Fragment>
  );
};

export const WAIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#F8F9FC" />
        <path
          d="M25.685 22.2636L23.2888 20.8948C22.9925 20.7261 22.6325 20.7298 22.34 20.9061L20.5063 22.0048C19.25 21.4386 18.245 20.4336 17.6788 19.1773L18.7775 17.3436C18.9538 17.0511 18.9575 16.6911 18.7888 16.3948L17.42 13.9986C17.2775 13.7473 17.0075 13.5898 16.7188 13.5898C14.9112 13.5898 13.445 15.0486 13.4375 16.8561C13.4375 16.8636 13.4375 16.8748 13.4375 16.8823C13.445 22.0611 17.6487 26.2498 22.8275 26.2423C24.6313 26.2311 26.09 24.7648 26.0938 22.9611C26.0938 22.6761 25.9362 22.4061 25.685 22.2636Z"
          fill="#4164E3"
        />
        <path
          opacity="0.4"
          d="M25.7412 10.0086C24.005 8.97734 22.0213 8.43359 20 8.43359C13.7863 8.43359 8.75 13.4736 8.75 19.6873C8.75 21.7048 9.29375 23.6886 10.325 25.4248L9.215 29.3098C9.0725 29.8086 9.36125 30.3261 9.86 30.4686C10.0288 30.5173 10.205 30.5173 10.3738 30.4686L14.2587 29.3586C19.6025 32.5311 26.5063 30.7686 29.675 25.4248C32.8438 20.0811 31.085 13.1773 25.7412 10.0086ZM22.8238 26.2461C17.6488 26.2536 13.445 22.0611 13.4375 16.8823C13.4375 16.8748 13.4375 16.8636 13.4375 16.8561C13.445 15.0486 14.9113 13.5861 16.7188 13.5898C17.0075 13.5898 17.2775 13.7436 17.42 13.9986L18.7888 16.3948C18.9575 16.6911 18.9538 17.0511 18.7775 17.3436L17.6788 19.1773C18.245 20.4336 19.25 21.4386 20.5063 22.0048L22.34 20.9061C22.6325 20.7298 22.9925 20.7261 23.2888 20.8948L25.685 22.2636C25.9363 22.4061 26.0938 22.6761 26.0938 22.9648C26.0863 24.7686 24.6313 26.2348 22.8238 26.2461Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};

export const WAIconDark = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#212327" />
        <path
          d="M25.685 22.2626L23.2888 20.8939C22.9925 20.7251 22.6325 20.7289 22.34 20.9051L20.5063 22.0039C19.25 21.4376 18.245 20.4326 17.6788 19.1764L18.7775 17.3426C18.9538 17.0501 18.9575 16.6901 18.7888 16.3939L17.42 13.9976C17.2775 13.7464 17.0075 13.5889 16.7188 13.5889C14.9112 13.5889 13.445 15.0476 13.4375 16.8551C13.4375 16.8626 13.4375 16.8739 13.4375 16.8814C13.445 22.0601 17.6487 26.2489 22.8275 26.2414C24.6313 26.2301 26.09 24.7639 26.0938 22.9601C26.0938 22.6751 25.9362 22.4051 25.685 22.2626Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M25.7412 10.0076C24.005 8.97637 22.0213 8.43262 20 8.43262C13.7863 8.43262 8.75 13.4726 8.75 19.6864C8.75 21.7039 9.29375 23.6876 10.325 25.4239L9.215 29.3089C9.0725 29.8076 9.36125 30.3251 9.86 30.4676C10.0288 30.5164 10.205 30.5164 10.3738 30.4676L14.2587 29.3576C19.6025 32.5301 26.5063 30.7676 29.675 25.4239C32.8438 20.0801 31.085 13.1764 25.7412 10.0076ZM22.8238 26.2451C17.6488 26.2526 13.445 22.0601 13.4375 16.8814C13.4375 16.8739 13.4375 16.8626 13.4375 16.8551C13.445 15.0476 14.9113 13.5851 16.7188 13.5889C17.0075 13.5889 17.2775 13.7426 17.42 13.9976L18.7888 16.3939C18.9575 16.6901 18.9538 17.0501 18.7775 17.3426L17.6788 19.1764C18.245 20.4326 19.25 21.4376 20.5063 22.0039L22.34 20.9051C22.6325 20.7289 22.9925 20.7251 23.2888 20.8939L25.685 22.2626C25.9363 22.4051 26.0938 22.6751 26.0938 22.9639C26.0863 24.7676 24.6313 26.2339 22.8238 26.2451Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const DealerStatusCardIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10Z"
          stroke="#4164E3"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M12.5 4.3411C13.0375 3.53275 13.9565 3 15 3C16.6569 3 18 4.34315 18 6C18 7.65685 16.6569 9 15 9C13.9565 9 13.0375 8.46725 12.5 7.6589"
          stroke="#4164E3"
          strokeWidth="1.5"
        />
        <path
          d="M9 21C12.866 21 16 19.2091 16 17C16 14.7909 12.866 13 9 13C5.13401 13 2 14.7909 2 17C2 19.2091 5.13401 21 9 21Z"
          stroke="#4164E3"
          strokeWidth="1.5"
        />
        <path
          opacity="0.5"
          d="M18 14C19.7542 14.3847 21 15.3589 21 16.5C21 17.5293 19.9863 18.4229 18.5 18.8704"
          stroke="#4164E3"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const DealerStatusCardDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M6.72831 19.6998C7.54831 18.8198 8.79828 18.8898 9.51828 19.8498L10.5283 21.1998C11.3383 22.2698 12.6483 22.2698 13.4583 21.1998L14.4683 19.8498C15.1883 18.8898 16.4384 18.8198 17.2584 19.6998C19.0384 21.5998 20.4883 20.9698 20.4883 18.3098V7.04974C20.4883 3.01974 19.5483 2.00977 15.7683 2.00977H8.20829C4.42829 2.00977 3.48828 3.01974 3.48828 7.04974V18.3098C3.49828 20.9698 4.95831 21.5898 6.72831 19.6998Z"
          fill="#E4E7EB"
        />
        <path
          d="M14.8429 9.99114L14.3429 10.5012H14.3329L11.3029 13.5312C11.1729 13.6612 10.9029 13.8012 10.7129 13.8212L9.36286 14.0212C8.87286 14.0912 8.53288 13.7412 8.60288 13.2612L8.79288 11.9012C8.82288 11.7112 8.95286 11.4512 9.08286 11.3112L12.1229 8.28115L12.6229 7.77114C12.9529 7.44114 13.3229 7.20117 13.7229 7.20117C14.0629 7.20117 14.4329 7.36114 14.8429 7.77114C15.7429 8.67114 15.4529 9.38114 14.8429 9.99114Z"
          fill="#E4E7EB"
        />
      </svg>
    </React.Fragment>
  );
};

export const TestTopDotIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="9"
        height="8"
        viewBox="0 0 9 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="8" height="8" rx="4" fill={color} />
      </svg>
    </React.Fragment>
  );
};

export const TestTopBackArrowIcon = ({ color = "#4164E3" }) => {
  return (
    <React.Fragment>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        // style={{marginRight:"-15px"}}
      >
        <path
          d="M18 8.75L11.75 15L18 21.25"
          stroke={color}
          // strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const TestTopBackArrowIcon1 = ({ color = "#4164E3" }) => {
  return (
    <React.Fragment>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: "-15px" }}
      >
        <path
          d="M18 8.75L11.75 15L18 21.25"
          stroke={color}
          // strokeWidth="1.875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const TestTopAddDealerIcon = ({ color = "#ffffff" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12H18M12 6V18"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerLogOffIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2826 9.95865C11.2826 10.3563 11.605 10.6786 12.0026 10.6786C12.4002 10.6786 12.7226 10.3563 12.7226 9.95865H11.2826ZM12.7226 4.31961C12.7226 3.92197 12.4002 3.59961 12.0026 3.59961C11.605 3.59961 11.2826 3.92197 11.2826 4.31961H12.7226ZM9.42098 6.87471C9.78288 6.70992 9.94263 6.28295 9.77789 5.92106C9.61306 5.55917 9.1861 5.3994 8.82421 5.56419L9.42098 6.87471ZM5.2826 12.1532L4.5625 12.1495L4.56264 12.1616L5.2826 12.1532ZM12.0026 18.7196L12.0109 17.9996C12.0054 17.9996 11.9998 17.9996 11.9943 17.9996L12.0026 18.7196ZM18.7226 12.1532L19.4427 12.1616L19.4426 12.1495L18.7226 12.1532ZM15.181 5.56419C14.819 5.3994 14.3921 5.55917 14.2273 5.92106C14.0626 6.28295 14.2223 6.70992 14.5842 6.87471L15.181 5.56419ZM12.7226 9.95865V4.31961H11.2826V9.95865H12.7226ZM8.82421 5.56419C6.24109 6.74045 4.57737 9.31114 4.5625 12.1495L6.00259 12.157C6.01452 9.88028 7.34896 7.81823 9.42098 6.87471L8.82421 5.56419ZM4.56264 12.1616C4.60997 16.228 7.94447 19.4863 12.0109 19.4396L11.9943 17.9996C8.72308 18.0372 6.04062 15.4161 6.00255 12.1449L4.56264 12.1616ZM11.9943 19.4396C16.0607 19.4863 19.3955 16.228 19.4427 12.1616L18.0027 12.1449C17.9646 15.4161 15.2821 18.0372 12.0109 17.9996L11.9943 19.4396ZM19.4426 12.1495C19.4277 9.31114 17.7641 6.74045 15.181 5.56419L14.5842 6.87471C16.6562 7.81823 17.9907 9.88028 18.0026 12.157L19.4426 12.1495Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerLogOutIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 12L22 12M22 12L18.5 15M22 12L18.5 9"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.9998 8L1.9998 16C1.9998 18.8284 1.9998 20.2426 2.8785 21.1213C3.7571 22 5.1714 22 7.9998 22L8.9998 22C11.8282 22 13.2424 22 14.1211 21.1213C14.8895 20.3529 14.9859 19.175 14.998 17M14.998 7C14.9859 4.82497 14.8895 3.64706 14.1211 2.87868C13.2424 2 11.8282 2 8.9998 2L7.9998 2C5.1714 2 3.7571 2 2.8785 2.87868C2.5787 3.17848 2.3812 3.54062 2.251 4"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerCameraIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.5"
          y="1.5"
          width="37"
          height="37"
          rx="18.5"
          fill="#4164E3"
          stroke="white"
          strokeWidth="3"
        />
        <g clipPath="url(#clip0_796_24173)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 19C18.8954 19 18 19.8954 18 21C18 22.1046 18.8954 23 20 23C21.1046 23 22 22.1046 22 21C22 19.8954 21.1046 19 20 19Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.0002 17.5042C30.0002 17.5377 30.0001 17.5716 30.0001 17.6058V24.066C30.0002 24.9525 30.0002 25.7163 29.918 26.328C29.8299 26.9835 29.6311 27.6118 29.1215 28.1215C28.6118 28.6312 27.9834 28.8299 27.3279 28.918C26.7163 29.0003 25.9524 29.0002 25.0659 29.0002H14.9343C14.0478 29.0002 13.284 29.0003 12.6723 28.918C12.0168 28.8299 11.3885 28.6312 10.8788 28.1215C10.3692 27.6118 10.1704 26.9835 10.0823 26.328C10 25.7163 10.0001 24.9525 10.0001 24.066V17.6058C10.0001 17.5716 10.0001 17.5377 10.0001 17.5042C9.99962 17.043 9.99924 16.6455 10.0846 16.2935C10.3492 15.2017 11.2016 14.3493 12.2934 14.0846C12.6454 13.9993 13.043 13.9997 13.5041 14.0001C13.5376 14.0002 13.5715 14.0002 13.6057 14.0002C13.952 14.0002 14.0217 13.9976 14.078 13.9892C14.3061 13.955 14.5154 13.843 14.6704 13.6721C14.7087 13.63 14.7495 13.5734 14.9416 13.2853L15.1681 12.9455C15.191 12.9112 15.2136 12.8771 15.2361 12.8433C15.5639 12.3502 15.8529 11.9154 16.2632 11.6057C16.5114 11.4184 16.7872 11.2708 17.0807 11.1682C17.5659 10.9986 18.0881 10.9993 18.6801 11.0001C18.7207 11.0002 18.7617 11.0002 18.8029 11.0002H21.1974C21.2386 11.0002 21.2796 11.0002 21.3202 11.0001C21.9122 10.9993 22.4344 10.9986 22.9196 11.1682C23.2131 11.2708 23.4889 11.4184 23.7371 11.6057C24.1473 11.9154 24.4364 12.3502 24.7642 12.8433C24.7866 12.8771 24.8093 12.9112 24.8322 12.9455L25.0587 13.2853C25.2508 13.5734 25.2916 13.63 25.3299 13.6721C25.4849 13.843 25.6942 13.955 25.9223 13.9892C25.9786 13.9976 26.0483 14.0002 26.3946 14.0002C26.4288 14.0002 26.4627 14.0002 26.4962 14.0001C26.9573 13.9997 27.3549 13.9993 27.7068 14.0846C28.7986 14.3493 29.6511 15.2017 29.9157 16.2935C30.001 16.6455 30.0006 17.043 30.0002 17.5042ZM16.0003 21.0002C16.0003 18.7911 17.7911 17.0002 20.0003 17.0002C22.2094 17.0002 24.0003 18.7911 24.0003 21.0002C24.0003 23.2093 22.2094 25.0002 20.0003 25.0002C17.7911 25.0002 16.0003 23.2093 16.0003 21.0002Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_796_24173">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(8 8)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const ManagerLockIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
          fill="white"
        />
        <path
          d="M12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
          fill="white"
        />
        <path
          d="M6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C17.8174 10.0089 18.3135 10.022 18.75 10.0546V8C18.75 4.27208 15.7279 1.25 12 1.25C8.27208 1.25 5.25 4.27208 5.25 8V10.0546C5.68651 10.022 6.18264 10.0089 6.75 10.0036V8Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const CancelIcon2 = ({ color = "#FFFFFF" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          stroke={color}
          strokeWidth="2"
        />
        <path d="M18 18L6 6" stroke={color} strokeWidth="2" />
      </svg>
    </React.Fragment>
  );
};

export const NewManagerCreateIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0264 14.9979C11.1119 15.0834 11.1569 15.1997 11.1434 15.3174C11.0894 15.7847 10.8284 17.0484 9.56387 18.3129C8.76737 19.1094 6.38087 16.7229 4.78862 18.3152C2.88437 20.2194 5.71487 13.9734 9.37787 13.5512C9.49562 13.5377 9.61187 13.5827 9.69737 13.6682L11.0264 14.9979Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          opacity="0.5"
          d="M11.0264 14.9979C11.1119 15.0834 11.1569 15.1997 11.1434 15.3174C11.0894 15.7847 10.8284 17.0484 9.56387 18.3129C8.76737 19.1094 6.38087 16.7229 4.78862 18.3152C2.88437 20.2194 5.71487 13.9734 9.37787 13.5512C9.49562 13.5377 9.61187 13.5827 9.69737 13.6682L11.0264 14.9979Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M11.6726 14.5829L10.1119 13.0221C9.95963 12.8699 9.96638 12.6209 10.1269 12.4776L19.6429 3.96286C19.7914 3.83011 20.0171 3.83611 20.1581 3.97711L20.7169 4.53586C20.8579 4.67686 20.8639 4.90261 20.7311 5.05111L12.2171 14.5679C12.0731 14.7284 11.8249 14.7351 11.6726 14.5829Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const DragNDropIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.1988 21.5998C27.8614 21.5998 28.3988 21.0624 28.3988 20.3998V5.5998C28.3988 4.93723 27.8614 4.3998 27.1988 4.3998H5.59883C4.93625 4.3998 4.39883 4.93723 4.39883 5.5998V20.3998C4.39883 21.0624 4.93625 21.5998 5.59883 21.5998H27.1988ZM27.1988 23.1998H5.59883C4.05262 23.1998 2.79883 21.946 2.79883 20.3998V5.5998C2.79883 4.05359 4.05262 2.7998 5.59883 2.7998H27.1988C28.745 2.7998 29.9988 4.05359 29.9988 5.5998V20.3998C29.9988 21.946 28.745 23.1998 27.1988 23.1998Z"
          fill="#646B88"
        />
        <path
          opacity="0.5"
          d="M32.4293 18.3879L33.6913 18.6095C34.7805 18.8007 35.5076 19.8392 35.3148 20.928L32.9144 34.4857C32.7998 35.1326 32.1722 35.5721 31.5254 35.4584L10.3177 31.7344C9.66419 31.6197 9.22778 30.9964 9.34348 30.343L10.1767 25.637C10.2537 25.202 9.96348 24.7868 9.52841 24.7098C9.09333 24.6328 8.67821 24.923 8.60118 25.3581L7.76798 30.0641C7.49805 31.5884 8.51622 33.0427 10.041 33.3103L31.2486 37.0343C32.7649 37.3007 34.2213 36.2809 34.4899 34.7647L36.8903 21.207C37.2374 19.2471 35.9285 17.3777 33.968 17.0336L32.7061 16.812C32.2709 16.7356 31.8562 17.0264 31.7798 17.4616C31.7034 17.8967 31.9942 18.3114 32.4294 18.3879L32.4293 18.3879Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const DragNDropDarkIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.1988 21.6008C27.8614 21.6008 28.3988 21.0634 28.3988 20.4008V5.60078C28.3988 4.9382 27.8614 4.40078 27.1988 4.40078H5.59883C4.93625 4.40078 4.39883 4.9382 4.39883 5.60078V20.4008C4.39883 21.0634 4.93625 21.6008 5.59883 21.6008H27.1988ZM27.1988 23.2008H5.59883C4.05262 23.2008 2.79883 21.947 2.79883 20.4008V5.60078C2.79883 4.05457 4.05262 2.80078 5.59883 2.80078H27.1988C28.745 2.80078 29.9988 4.05457 29.9988 5.60078V20.4008C29.9988 21.947 28.745 23.2008 27.1988 23.2008Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M32.4293 18.3889L33.6913 18.6105C34.7805 18.8016 35.5076 19.8402 35.3148 20.929L32.9144 34.4867C32.7998 35.1336 32.1722 35.573 31.5254 35.4594L10.3177 31.7354C9.66419 31.6207 9.22778 30.9974 9.34348 30.344L10.1767 25.638C10.2537 25.2029 9.96348 24.7878 9.52841 24.7108C9.09333 24.6337 8.67821 24.924 8.60118 25.3591L7.76798 30.0651C7.49805 31.5894 8.51622 33.0436 10.041 33.3113L31.2486 37.0353C32.7649 37.3016 34.2213 36.2818 34.4899 34.7657L36.8903 21.208C37.2374 19.2481 35.9285 17.3786 33.968 17.0346L32.7061 16.813C32.2709 16.7366 31.8562 17.0274 31.7798 17.4625C31.7034 17.8977 31.9942 18.3124 32.4294 18.3888L32.4293 18.3889Z"
          fill="white"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
};

export const AddMoreRoleIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
          stroke="#4164E3"
          strokeWidth="1.5"
        />
        <path
          d="M15 12H12M12 12H9M12 12V9M12 12V15"
          stroke="#4164E3"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const RemoveTabIcon = ({ color = "#4164E3" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 7.99981L8 15.9998M8.00001 7.99981L16 15.9998"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerDevices3Dots = ({ color = "#1C274C" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19C10 17.8954 10.8954 17 12 17Z"
          fill={color}
        />
        <path
          d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
          fill={color}
        />
        <path
          d="M12 3C13.1046 3 14 3.8954 14 5C14 6.1046 13.1046 7 12 7C10.8954 7 10 6.1046 10 5C10 3.8954 10.8954 3 12 3Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerTickIcon = ({ color = "#4164E3" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.89258 13.2687L9.16677 17.5427L18.7094 8"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const EditManagerIcon = () => {
  return (
    <React.Fragment>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
            stroke="#ffffff"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{" "}
          <path
            d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
            stroke="#ffffff"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{" "}
        </g>
      </svg>
    </React.Fragment>
  );
};

export const ManagerSortByIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#E4E7EB" />
        <path
          d="M24 26V14M24 14L28 18.125M24 14L20 18.125"
          stroke="#646B88"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 14V26M16 26L20 21.875M16 26L12 21.875"
          stroke="#646B88"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerWareHouseIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="#E4E7EB" />
        <path
          d="M29.5994 15.9997C29.4775 16.0002 29.3572 15.9728 29.2474 15.9197L19.9994 11.1997L10.7514 15.8877C10.3405 16.0821 9.84983 15.9066 9.65543 15.4957C9.46103 15.0848 9.63655 14.5941 10.0474 14.3997L19.9994 9.47168L29.9514 14.3997C30.3932 14.497 30.6727 14.9339 30.5754 15.3757C30.4781 15.8174 30.0412 16.097 29.5994 15.9997ZM15.9994 23.9997H11.1994V28.7997H15.9994V23.9997ZM22.3994 23.9997H17.5994V28.7997H22.3994V23.9997ZM28.7994 23.9997H23.9994V28.7997H28.7994V23.9997ZM25.5994 17.5997H20.7994V22.3997H25.5994V17.5997ZM19.1994 17.5997H14.3994V22.3997H19.1994V17.5997Z"
          fill="#646B88"
        />
      </svg>
    </React.Fragment>
  );
};

export const ManagerDeleteIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#ffffff"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M4 7H20"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />{" "}
          <path
            d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />{" "}
          <path
            d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />{" "}
        </g>
      </svg>
    </React.Fragment>
  );
};

export const AddDesignationIcon = () => {
  return (
    <React.Fragment>
      <svg
        fill="#4164E3"
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          <path d="M2,21h8a1,1,0,0,0,0-2H3.071A7.011,7.011,0,0,1,10,13a5.044,5.044,0,1,0-3.377-1.337A9.01,9.01,0,0,0,1,20,1,1,0,0,0,2,21ZM10,5A3,3,0,1,1,7,8,3,3,0,0,1,10,5ZM23,16a1,1,0,0,1-1,1H19v3a1,1,0,0,1-2,0V17H14a1,1,0,0,1,0-2h3V12a1,1,0,0,1,2,0v3h3A1,1,0,0,1,23,16Z" />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const EyeBtn = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.92769 4.38319C10.8187 4.38319 11.5447 5.10994 11.5447 6.00019C11.5447 6.89044 10.8179 7.59394 9.92769 7.59394C9.03744 7.59394 8.33394 6.89044 8.33394 6.00019C8.33394 5.10994 9.03744 4.38319 9.92769 4.38319ZM9.92769 0.398438C15.2249 0.398438 19.0447 5.36719 19.0447 5.36719C19.3027 5.69569 19.3027 6.28144 19.0447 6.60919C19.0447 6.60919 15.2242 11.5779 9.92769 11.5779C4.63119 11.5779 0.810688 6.60919 0.810688 6.60919C0.552688 6.28069 0.552688 5.69494 0.810688 5.36719C0.810688 5.36719 4.63119 0.398438 9.92769 0.398438ZM9.92769 10.0082C12.1312 10.0082 13.9357 8.20369 13.9357 6.00019C13.9357 3.79669 12.1312 1.99219 9.92769 1.99219C7.72419 1.99219 5.91969 3.79669 5.91969 6.00019C5.91969 8.20369 7.72419 10.0082 9.92769 10.0082Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const OpenCollectionIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2600_106288)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.4113 5.625H18.75C18.2325 5.625 17.8125 6.045 17.8125 6.5625C17.8125 7.08094 18.2325 7.5 18.75 7.5H21.2138L16.7156 11.9991L18.0413 13.3247L22.5206 8.84531L22.5 11.25C22.5 11.7684 22.92 12.1875 23.4375 12.1875C23.955 12.1875 24.375 11.7684 24.375 11.25V6.5625C24.375 6.285 24.2597 6.06096 24.0788 5.90721C23.9081 5.73284 23.6728 5.625 23.4113 5.625ZM28.125 26.25C28.125 27.2812 27.285 28.125 26.25 28.125H3.75C2.715 28.125 1.875 27.2812 1.875 26.25V3.75C1.875 2.715 2.715 1.875 3.75 1.875H26.25C27.285 1.875 28.125 2.715 28.125 3.75V26.25ZM26.25 0H3.75C1.67906 0 0 1.67906 0 3.75V26.25C0 28.3219 1.67906 30 3.75 30H26.25C28.3209 30 30 28.3219 30 26.25V3.75C30 1.67906 28.3209 0 26.25 0ZM11.9587 16.6781L7.47937 21.1594L7.5 18.75C7.5 18.2344 7.08 17.8125 6.5625 17.8125C6.045 17.8125 5.625 18.2344 5.625 18.75V23.4375C5.625 23.7188 5.74031 23.9438 5.92124 24.0938C6.09093 24.2625 6.32719 24.375 6.58875 24.375H11.25C11.7675 24.375 12.1875 23.9531 12.1875 23.4375C12.1875 22.9219 11.7675 22.5 11.25 22.5H8.78624L13.2844 18L11.9587 16.6781ZM23.4375 17.8125C22.92 17.8125 22.5 18.2344 22.5 18.75L22.5206 21.1594L18.0413 16.6781L16.7156 18L21.2138 22.5H18.75C18.2325 22.5 17.8125 22.9219 17.8125 23.4375C17.8125 23.9531 18.2325 24.375 18.75 24.375H23.4113C23.6728 24.375 23.9091 24.2625 24.0788 24.0938C24.2597 23.9438 24.375 23.7188 24.375 23.4375V18.75C24.375 18.2344 23.955 17.8125 23.4375 17.8125ZM11.25 7.5C11.7675 7.5 12.1875 7.08094 12.1875 6.5625C12.1875 6.045 11.7675 5.625 11.25 5.625H6.58875C6.32719 5.625 6.09187 5.73284 5.92124 5.90721C5.74031 6.06096 5.625 6.285 5.625 6.5625V11.25C5.625 11.7684 6.045 12.1875 6.5625 12.1875C7.08 12.1875 7.5 11.7684 7.5 11.25L7.47937 8.84531L11.9587 13.3247L13.2844 11.9991L8.78624 7.5H11.25Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2600_106288">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const EditCollectionIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM10.95 17.51C10.66 17.8 10.11 18.08 9.71 18.14L7.25 18.49C7.16 18.5 7.07 18.51 6.98 18.51C6.57 18.51 6.19 18.37 5.92 18.1C5.59 17.77 5.45 17.29 5.53 16.76L5.88 14.3C5.94 13.89 6.21 13.35 6.51 13.06L10.97 8.6C11.05 8.81 11.13 9.02 11.24 9.26C11.34 9.47 11.45 9.69 11.57 9.89C11.67 10.06 11.78 10.22 11.87 10.34C11.98 10.51 12.11 10.67 12.19 10.76C12.24 10.83 12.28 10.88 12.3 10.9C12.55 11.2 12.84 11.48 13.09 11.69C13.16 11.76 13.2 11.8 13.22 11.81C13.37 11.93 13.52 12.05 13.65 12.14C13.81 12.26 13.97 12.37 14.14 12.46C14.34 12.58 14.56 12.69 14.78 12.8C15.01 12.9 15.22 12.99 15.43 13.06L10.95 17.51ZM17.37 11.09L16.45 12.02C16.39 12.08 16.31 12.11 16.23 12.11C16.2 12.11 16.16 12.11 16.14 12.1C14.11 11.52 12.49 9.9 11.91 7.87C11.88 7.76 11.91 7.64 11.99 7.57L12.92 6.64C14.44 5.12 15.89 5.15 17.38 6.64C18.14 7.4 18.51 8.13 18.51 8.89C18.5 9.61 18.13 10.33 17.37 11.09Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const ArowUpIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 14.0001L12 9.00006L7 14.0001"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const SaveTaxRateIcon = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.89 5.87891H5.11C3.4 5.87891 2 7.27891 2 8.98891V20.3489C2 21.7989 3.04 22.4189 4.31 21.7089L8.24 19.5189C8.66 19.2889 9.34 19.2889 9.75 19.5189L13.68 21.7089C14.96 22.4089 16 21.7989 16 20.3489V8.98891C16 7.27891 14.6 5.87891 12.89 5.87891Z"
          fill="white"
        />
        <path
          d="M21.9998 5.11V16.47C21.9998 17.92 20.9598 18.53 19.6898 17.83L17.7598 16.75C17.5998 16.66 17.4998 16.49 17.4998 16.31V8.99C17.4998 6.45 15.4298 4.38 12.8898 4.38H8.81984C8.44984 4.38 8.18984 3.99 8.35984 3.67C8.87984 2.68 9.91984 2 11.1098 2H18.8898C20.5998 2 21.9998 3.4 21.9998 5.11Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const CrossIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99407 7.00578C6.60354 7.39631 6.60354 8.02947 6.99407 8.42L10.5792 12.0051L6.99407 15.5903C6.60354 15.9808 6.60354 16.614 6.99407 17.0045C7.38459 17.395 8.01776 17.395 8.40828 17.0045L11.9934 13.4193L15.5786 17.0045C15.9691 17.395 16.6023 17.395 16.9928 17.0045C17.3833 16.614 17.3833 15.9808 16.9928 15.5903L13.4076 12.0051L16.9928 8.42001C17.3833 8.02949 17.3833 7.39632 16.9928 7.0058C16.6022 6.61527 15.9691 6.61527 15.5786 7.0058L11.9934 10.5909L8.40828 7.00578C8.01776 6.61526 7.38459 6.61526 6.99407 7.00578Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const ArrowRightIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 17L15 12L10 7"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const UserProfileIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="profile">
          <g id="profile_2">
            <path
              id="Combined Shape"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.2301 22.2985C30.2149 24.5691 27.2745 25.9998 24 25.9998C17.925 25.9998 13 21.0754 13 14.9998C13 8.92552 17.9257 3.9998 24 3.9998C30.0743 3.9998 35 8.92552 35 14.9998C35 17.0807 34.4222 19.0266 33.4184 20.6859C37.4029 23.2673 39.9994 27.4474 39.9994 32.1866V40.9786C39.9994 42.6369 38.6577 43.9786 36.9994 43.9786H10.9994C9.34257 43.9786 7.99939 42.6364 7.99939 40.9786V32.1866C7.99939 28.5756 9.51984 25.1783 12.201 22.5769C12.5974 22.1923 13.2305 22.2019 13.6151 22.5983C13.9997 22.9946 13.9901 23.6277 13.5937 24.0123C11.2906 26.2469 9.99939 29.132 9.99939 32.1866V40.9786C9.99939 41.5315 10.4468 41.9786 10.9994 41.9786H36.9994C37.5531 41.9786 37.9994 41.5323 37.9994 40.9786V32.1866C37.9994 28.1349 35.7312 24.5261 32.2301 22.2985ZM30.4104 21.3171C28.7782 22.9732 26.5089 23.9998 24 23.9998C19.0296 23.9998 15 19.9708 15 14.9998C15 10.0301 19.0303 5.9998 24 5.9998C28.9697 5.9998 33 10.0301 33 14.9998C33 16.7236 32.5154 18.3341 31.6751 19.7026C29.394 18.5927 26.7773 17.9626 23.9994 17.9626C23.4471 17.9626 22.9994 18.4103 22.9994 18.9626C22.9994 19.5149 23.4471 19.9626 23.9994 19.9626C26.313 19.9626 28.4918 20.452 30.4104 21.3171Z"
              fill={color}
            />
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const DispatchReloadIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4704_62952)">
          <path
            d="M19.2953 12.5C19.6837 12.4973 20 12.8154 20 13.2088V16.4132C20 16.8047 19.6867 17.122 19.3001 17.122C18.9136 17.122 18.6003 16.8047 18.6003 16.4132L18.6007 15.288C16.7783 18.3442 13.3981 20.5 9.75559 20.5C5.34669 20.5 1.65005 17.779 0.0473577 13.5848C-0.0921407 13.2197 0.0869918 12.8093 0.447461 12.668C0.807931 12.5267 1.21324 12.7081 1.35273 13.0732C2.7521 16.7353 5.94083 19.0824 9.75559 19.0824C13.127 19.0824 16.2764 16.901 17.7431 13.9293L16.2715 13.9386C15.885 13.9413 15.5695 13.6261 15.5669 13.2347C15.5642 12.8433 15.8754 12.5238 16.2619 12.5211L19.2953 12.5ZM10.2444 0.5C14.6533 0.5 18.3499 3.22098 19.9526 7.41521C20.0921 7.78027 19.913 8.19075 19.5525 8.33202C19.1921 8.4733 18.7868 8.29188 18.6473 7.92682C17.2479 4.26468 14.0592 1.91756 10.2444 1.91756C6.87296 1.91756 3.72363 4.09898 2.25692 7.07074L3.72849 7.0614C4.115 7.05871 4.43048 7.37386 4.43315 7.7653C4.43578 8.15674 4.1246 8.47624 3.73809 8.47893L0.704654 8.5C0.316268 8.50268 1.74095e-09 8.18457 1.74095e-09 7.79122V4.58678C1.74095e-09 4.19533 0.313337 3.878 0.699857 3.878C1.08638 3.878 1.39971 4.19533 1.39971 4.58678L1.39934 5.71199C3.22168 2.65583 6.60188 0.5 10.2444 0.5Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4704_62952">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const DispatchDownloadIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1665 8C15.979 8.01009 16.9606 8.09047 17.6009 8.73079C18.3332 9.46304 18.3332 10.6415 18.3332 12.9985V13.8319C18.3332 16.1889 18.3332 17.3675 17.6009 18.0996C16.8687 18.8319 15.6902 18.8319 13.3332 18.8319H6.6665C4.30948 18.8319 3.13097 18.8319 2.39874 18.0996C1.6665 17.3675 1.6665 16.1889 1.6665 13.8319V12.9985C1.6665 10.6415 1.6665 9.46304 2.39874 8.73078C3.03905 8.09047 4.02065 8.01009 5.83317 8"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M10 2.16406V12.9974M10 12.9974L7.5 10.0807M10 12.9974L12.5 10.0807"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const CancelIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#F93E3E" fillOpacity="0.1" />
        <g clipPath="url(#clip0_14117_95954)">
          <rect
            x="5.50195"
            y="5.5"
            width="24"
            height="24"
            rx="12"
            fill="#1B1D21"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.7447 20.68C22.0379 20.9725 22.0379 21.4525 21.7447 21.745C21.4522 22.0375 20.9767 22.0375 20.6835 21.745L17.5064 18.565L14.3069 21.7675C14.0114 22.06 13.533 22.06 13.2375 21.7675C12.9427 21.4675 12.9427 20.9875 13.2375 20.695L16.437 17.4925L13.2599 14.32C12.9667 14.0275 12.9667 13.5475 13.2599 13.255C13.5517 12.9625 14.0272 12.9625 14.3204 13.255L17.4975 16.435L20.7209 13.21C21.0164 12.9175 21.4942 12.9175 21.7897 13.21C22.0844 13.51 22.0844 13.9825 21.7897 14.2825L18.5669 17.5075L21.7447 20.68ZM17.502 5.5C10.8742 5.5 5.50195 10.87 5.50195 17.5C5.50195 24.13 10.8742 29.5 17.502 29.5C24.1297 29.5 29.502 24.13 29.502 17.5C29.502 10.87 24.1297 5.5 17.502 5.5Z"
            fill="#F93E3E"
          />
        </g>
        <defs>
          <clipPath id="clip0_14117_95954">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(5.50195 5.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const InProgressIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#FF9900" fillOpacity="0.1" />
        <g clipPath="url(#clip0_14117_95964)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.50195 15.5C5.50195 12.7386 7.74053 10.5 10.502 10.5H24.502C27.2634 10.5 29.502 12.7386 29.502 15.5V19.5C29.502 22.2614 27.2634 24.5 24.502 24.5H10.502C7.74053 24.5 5.50195 22.2614 5.50195 19.5V15.5ZM10.502 12.5C8.8451 12.5 7.50195 13.8432 7.50195 15.5V19.5C7.50195 21.1569 8.8451 22.5 10.502 22.5H24.502C26.1589 22.5 27.502 21.1569 27.502 19.5V15.5C27.502 13.8432 26.1589 12.5 24.502 12.5H10.502ZM15.502 16.5C15.502 15.3954 16.3974 14.5 17.502 14.5C18.6066 14.5 19.502 15.3954 19.502 16.5V18.5C19.502 19.6046 18.6066 20.5 17.502 20.5C16.3974 20.5 15.502 19.6046 15.502 18.5V16.5ZM11.502 14.5C10.3974 14.5 9.50195 15.3954 9.50195 16.5V18.5C9.50195 19.6046 10.3974 20.5 11.502 20.5C12.6065 20.5 13.502 19.6046 13.502 18.5V16.5C13.502 15.3954 12.6065 14.5 11.502 14.5Z"
            fill="#FF9900"
          />
        </g>
        <defs>
          <clipPath id="clip0_14117_95964">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(5.50195 5.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PackedIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#9747FF" fillOpacity="0.1" />
        <path
          d="M26.6816 11.5004L18.4316 6.77542C18.1469 6.61783 17.8269 6.53516 17.5016 6.53516C17.1762 6.53516 16.8562 6.61783 16.5716 6.77542L8.32157 11.5004C8.03349 11.665 7.79422 11.903 7.6282 12.1903C7.46218 12.4775 7.37535 12.8037 7.37657 13.1354V22.0004C7.39813 22.309 7.4957 22.6074 7.66059 22.8692C7.82547 23.1309 8.05254 23.3477 8.32157 23.5004L16.5716 28.1654C16.8562 28.323 17.1762 28.4057 17.5016 28.4057C17.8269 28.4057 18.1469 28.323 18.4316 28.1654L26.6816 23.5004C26.9506 23.3477 27.1777 23.1309 27.3426 22.8692C27.5074 22.6074 27.605 22.309 27.6266 22.0004V13.0754C27.6174 12.7539 27.5256 12.4401 27.3601 12.1643C27.1946 11.8885 26.961 11.6598 26.6816 11.5004ZM16.5716 26.0654L13.3766 24.2654V16.3154L16.5716 18.0554V26.0654ZM17.5016 16.4354L14.3816 14.7254L21.5966 10.7204L24.7316 12.4904L17.5016 16.4354ZM17.5016 8.41042L19.6916 9.64042L12.4316 13.6754L10.2716 12.4904L17.5016 8.41042ZM9.25157 14.0654L11.5016 15.2954V23.2004L9.25157 22.0004V14.0654ZM18.4316 26.0654V18.0554L25.7516 14.0654V22.0004L18.4316 26.0654Z"
          fill="#9747FF"
        />
      </svg>
    </React.Fragment>
  );
};

export const DispatchedIcon = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#F93E3E" fillOpacity="0.1" />
        <path
          d="M7.73893 7.78869C7.34598 7.6577 6.92124 7.87007 6.79025 8.26303C6.65927 8.65599 6.87164 9.08073 7.26459 9.21171L7.5295 9.30002C8.20591 9.52548 8.65311 9.67575 8.98256 9.82901C9.29452 9.97413 9.4294 10.0909 9.51582 10.2108C9.60224 10.3307 9.67039 10.4956 9.70941 10.8375C9.75063 11.1985 9.75176 11.6702 9.75176 12.3832V15.0551C9.75174 16.4226 9.75173 17.5249 9.86829 18.3919C9.9893 19.292 10.2482 20.0499 10.8501 20.6518C11.452 21.2537 12.2099 21.5126 13.11 21.6336C13.977 21.7502 15.0793 21.7502 16.4469 21.7502H23.5018C23.916 21.7502 24.2518 21.4144 24.2518 21.0002C24.2518 20.5859 23.916 20.2502 23.5018 20.2502H16.5018C15.0664 20.2502 14.0652 20.2486 13.3099 20.147C12.5761 20.0484 12.1875 19.8679 11.9108 19.5912C11.6756 19.356 11.51 19.04 11.405 18.5002H21.5238C22.4833 18.5002 22.963 18.5002 23.3387 18.2524C23.7144 18.0047 23.9033 17.5638 24.2813 16.6819L24.7098 15.6819C25.5193 13.7931 25.9241 12.8487 25.4795 12.1745C25.0349 11.5002 24.0074 11.5002 21.9524 11.5002H11.2468C11.2409 11.1925 11.228 10.9149 11.1997 10.6673C11.1444 10.1825 11.0238 9.73764 10.7327 9.33376C10.4416 8.92989 10.0577 8.6748 9.61526 8.46897C9.19902 8.27534 8.6697 8.09892 8.04332 7.89015L7.73893 7.78869Z"
          fill="#F93E3E"
        />
        <path
          d="M13.0016 23.5C13.83 23.5 14.5016 24.1716 14.5016 25C14.5016 25.8284 13.83 26.5 13.0016 26.5C12.1731 26.5 11.5016 25.8284 11.5016 25C11.5016 24.1716 12.1731 23.5 13.0016 23.5Z"
          fill="#F93E3E"
        />
        <path
          d="M22.0016 23.5C22.83 23.5 23.5016 24.1715 23.5016 25C23.5016 25.8284 22.83 26.5 22.0016 26.5C21.1732 26.5 20.5016 25.8284 20.5016 25C20.5016 24.1715 21.1732 23.5 22.0016 23.5Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const CreateVoucherIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5005 9.45964H18.1255V8.0013C18.1242 6.95189 17.7067 5.94584 16.9647 5.2038C16.2226 4.46175 15.2166 4.04429 14.1672 4.04297H5.83382C4.78441 4.04429 3.77836 4.46175 3.03632 5.2038C2.29427 5.94584 1.87681 6.95189 1.87549 8.0013V9.45964H2.50049C2.77676 9.45964 3.04171 9.56938 3.23706 9.76473C3.43241 9.96008 3.54215 10.225 3.54215 10.5013C3.54215 10.7776 3.43241 11.0425 3.23706 11.2379C3.04171 11.4332 2.77676 11.543 2.50049 11.543H1.87549V13.0013C1.87681 14.0507 2.29427 15.0568 3.03632 15.7988C3.77836 16.5408 4.78441 16.9583 5.83382 16.9596H14.1672C15.2166 16.9583 16.2226 16.5408 16.9647 15.7988C17.7067 15.0568 18.1242 14.0507 18.1255 13.0013V11.543H17.5005C17.2242 11.543 16.9593 11.4332 16.7639 11.2379C16.5686 11.0425 16.4588 10.7776 16.4588 10.5013C16.4588 10.225 16.5686 9.96008 16.7639 9.76473C16.9593 9.56938 17.2242 9.45964 17.5005 9.45964ZM16.8755 12.7096V13.0013C16.8746 13.7193 16.589 14.4077 16.0813 14.9154C15.5735 15.4231 14.8852 15.7088 14.1672 15.7096H13.1255V13.8346C13.1255 13.6689 13.0596 13.5099 12.9424 13.3927C12.8252 13.2755 12.6662 13.2096 12.5005 13.2096C12.3347 13.2096 12.1758 13.2755 12.0585 13.3927C11.9413 13.5099 11.8755 13.6689 11.8755 13.8346V15.7096H5.83382C5.1158 15.7088 4.42743 15.4231 3.91971 14.9154C3.412 14.4077 3.12637 13.7193 3.12549 13.0013V12.7063C3.60556 12.5704 4.02817 12.2815 4.32911 11.8835C4.63005 11.4856 4.79289 11.0002 4.79289 10.5013C4.79289 10.0024 4.63005 9.51704 4.32911 9.11907C4.02817 8.7211 3.60556 8.43222 3.12549 8.2963V8.0013C3.12637 7.28328 3.412 6.59492 3.91971 6.0872C4.42743 5.57948 5.1158 5.29385 5.83382 5.29297H11.8755V7.16797C11.8755 7.33373 11.9413 7.4927 12.0585 7.60991C12.1758 7.72712 12.3347 7.79297 12.5005 7.79297C12.6662 7.79297 12.8252 7.72712 12.9424 7.60991C13.0596 7.4927 13.1255 7.33373 13.1255 7.16797V5.29297H14.1672C14.8852 5.29385 15.5735 5.57948 16.0813 6.0872C16.589 6.59492 16.8746 7.28328 16.8755 8.0013V8.2963C16.3954 8.43222 15.9728 8.7211 15.6719 9.11907C15.3709 9.51704 15.2081 10.0024 15.2081 10.5013C15.2081 11.0002 15.3709 11.4856 15.6719 11.8835C15.9728 12.2815 16.3954 12.5704 16.8755 12.7063V12.7096ZM13.1255 9.66797V11.3346C13.1255 11.5004 13.0596 11.6594 12.9424 11.7766C12.8252 11.8938 12.6662 11.9596 12.5005 11.9596C12.3347 11.9596 12.1758 11.8938 12.0585 11.7766C11.9413 11.6594 11.8755 11.5004 11.8755 11.3346V9.66797C11.8755 9.50221 11.9413 9.34324 12.0585 9.22603C12.1758 9.10882 12.3347 9.04297 12.5005 9.04297C12.6662 9.04297 12.8252 9.10882 12.9424 9.22603C13.0596 9.34324 13.1255 9.50221 13.1255 9.66797Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const CallIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#212327" />
        <path
          opacity="0.5"
          d="M17.547 11.6452L18.3583 13.0989C19.0904 14.4107 18.7965 16.1316 17.6434 17.2847C17.6434 17.2847 16.2449 18.6835 18.7806 21.2194C21.3156 23.7544 22.7153 22.3566 22.7153 22.3566C23.8684 21.2035 25.5893 20.9096 26.9011 21.6418L28.3548 22.453C30.3358 23.5585 30.5696 26.3365 28.8285 28.0778C27.7823 29.124 26.5005 29.9381 25.0836 29.9918C22.6985 30.0823 18.6479 29.4786 14.5846 25.4154C10.5214 21.3521 9.91777 17.3015 10.0082 14.9164C10.0619 13.4995 10.876 12.2178 11.9223 11.1715C13.6635 9.43035 16.4415 9.6643 17.547 11.6452Z"
          fill="white"
        />
        <path
          d="M21.5744 7.34979C21.6571 6.83868 22.1402 6.49197 22.6514 6.5747C22.683 6.58077 22.7849 6.59979 22.8381 6.61167C22.9449 6.63543 23.0936 6.67199 23.2791 6.72603C23.6501 6.83408 24.1684 7.01209 24.7904 7.29725C26.0357 7.8682 27.693 8.86695 29.4127 10.5867C31.1325 12.3065 32.1312 13.9637 32.7021 15.2091C32.9874 15.8311 33.1654 16.3493 33.2734 16.7203C33.3274 16.9058 33.364 17.0546 33.3877 17.1613C33.3996 17.2146 33.4084 17.2574 33.4144 17.2891L33.4216 17.3281C33.5042 17.8391 33.1607 18.3424 32.6496 18.4251C32.14 18.5076 31.6599 18.1625 31.5751 17.6539C31.5725 17.6401 31.5652 17.6035 31.5576 17.5689C31.5421 17.4996 31.5155 17.3899 31.4732 17.2447C31.3886 16.9542 31.2417 16.5226 30.9977 15.9905C30.5105 14.9276 29.6342 13.4599 28.0869 11.9125C26.5396 10.3652 25.0719 9.48897 24.009 9.00168C23.4769 8.75773 23.0452 8.61082 22.7547 8.52622C22.6096 8.48393 22.4271 8.44204 22.3579 8.42663C21.8491 8.34184 21.4919 7.85944 21.5744 7.34979Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8566 11.6607C21.9989 11.1628 22.5177 10.8745 23.0156 11.0168L22.7581 11.9182C23.0156 11.0168 23.0156 11.0168 23.0156 11.0168L23.0175 11.0173L23.0194 11.0179L23.0235 11.0191L23.0332 11.022L23.058 11.0297C23.0767 11.0357 23.1004 11.0435 23.1284 11.0535C23.1845 11.0734 23.2587 11.1018 23.3497 11.1408C23.5319 11.2188 23.7806 11.3393 24.0864 11.5202C24.6981 11.8823 25.5334 12.4838 26.5146 13.465C27.4959 14.4462 28.0972 15.2815 28.4594 15.8933C28.6402 16.1989 28.7607 16.4478 28.8389 16.6299C28.8779 16.7209 28.9062 16.7951 28.9261 16.8512C28.9361 16.8793 28.9439 16.9028 28.95 16.9217L28.9576 16.9464L28.9605 16.9561L28.9617 16.9602L28.9622 16.9622C28.9622 16.9622 28.9629 16.964 28.0614 17.2215L28.9629 16.964C29.1051 17.4618 28.8167 17.9807 28.319 18.1229C27.8254 18.2639 27.311 17.9818 27.1636 17.4917L27.159 17.4782C27.1524 17.4594 27.1386 17.4225 27.1155 17.3685C27.0692 17.2605 26.9854 17.084 26.8459 16.8483C26.5671 16.3773 26.0637 15.6658 25.1887 14.7908C24.3139 13.9159 23.6022 13.4125 23.1314 13.1338C22.8956 12.9943 22.7191 12.9104 22.6111 12.8642C22.5571 12.841 22.5201 12.8272 22.5014 12.8206L22.4879 12.8159C21.9979 12.6686 21.7156 12.1543 21.8566 11.6607Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const ChatIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M8 10.5H16"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M8 14H13.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const RemoveIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 12C17 11.4477 16.5523 11 16 11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44771 13 8 13H16C16.5523 13 17 12.5523 17 12Z"
          fill="#F93E3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 20.9932C7.03321 20.9932 3.00683 16.9668 3.00683 12C3.00683 7.03321 7.03321 3.00683 12 3.00683C16.9668 3.00683 20.9932 7.03321 20.9932 12C20.9932 16.9668 16.9668 20.9932 12 20.9932Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const DividerIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="2"
        height="24"
        viewBox="0 0 2 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1L0.999999 23" stroke="#646B88" strokeLinecap="round" />
      </svg>
    </React.Fragment>
  );
};

export const SaveAsDraftIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.83871 3.53846C6.12608 3.53846 5.54839 4.11246 5.54839 4.82051V19.1795C5.54839 19.8875 6.12608 20.4615 6.83871 20.4615H17.1613C17.8739 20.4615 18.4516 19.8875 18.4516 19.1795V9.14049C18.4516 8.80672 18.3206 8.48611 18.0864 8.2468L13.8594 3.92682C13.6164 3.67854 13.2827 3.53846 12.9342 3.53846H6.83871ZM4 4.82051C4 3.26279 5.27093 2 6.83871 2H12.9342C13.701 2 14.4351 2.30817 14.9696 2.85439L19.1966 7.17437C19.7118 7.70085 20 8.4062 20 9.14049V19.1795C20 20.7372 18.7291 22 17.1613 22H6.83871C5.27093 22 4 20.7372 4 19.1795V4.82051Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12891 15.0778C8.12891 15.5027 8.47553 15.8471 8.90311 15.8471H15.0967C15.5242 15.8471 15.8709 15.5027 15.8709 15.0778C15.8709 14.653 15.5242 14.3086 15.0967 14.3086H8.90311C8.47553 14.3086 8.12891 14.653 8.12891 15.0778Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12891 10.9763C8.12891 11.4011 8.47553 11.7455 8.90311 11.7455H11.9999C12.4275 11.7455 12.7741 11.4011 12.7741 10.9763C12.7741 10.5514 12.4275 10.207 11.9999 10.207H8.90311C8.47553 10.207 8.12891 10.5514 8.12891 10.9763Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const RightArrowIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 7L9 12L14 17"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const LeftArrowIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 17L15 12L10 7"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const RupeeIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 6V4H6V6H9.5C10.802 6 11.901 6.838 12.315 8H6V10H12.315C12.1097 10.5832 11.7289 11.0886 11.2249 11.4467C10.7208 11.8048 10.1183 11.9981 9.5 12H6V14.414L11.586 20H14.414L8.414 14H9.5C10.652 13.9985 11.7682 13.5998 12.6604 12.8711C13.5526 12.1424 14.1663 11.1284 14.398 10H17V8H14.398C14.2447 7.2722 13.9288 6.58848 13.474 6H17Z"
          fill="#4164E3"
        />
      </svg>
    </React.Fragment>
  );
};

export const HamBurgerIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 16H30M14 22H24M14 28H19"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const ShareIcon = ({ color = "#FFFFFF" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1129_55124)">
          <path
            d="M24 12.0008L12.9865 3.06641V7.92144C12.1777 7.92144 11.2799 7.92144 10.2892 7.92144C0.511554 7.92144 -1.39907 15.1139 0.848866 20.3962C1.29821 15.5635 7.5076 15.6758 11.975 15.6758C12.3147 15.6758 12.6522 15.6758 12.9865 15.6758V20.9357L24 12.0008Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_1129_55124">
            <rect width="24" height="24" fill={color} />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PaymentWhatsAppIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="50" height="50" rx="25" fill={color} />
        <g clipPath="url(#clip0_1129_56693)">
          <path
            d="M18.0097 35.6948L18.4945 35.9372C20.5145 37.1492 22.7768 37.7148 25.0392 37.7148C32.1494 37.7148 37.9669 31.8973 37.9669 24.7871C37.9669 21.3936 36.5933 18.0808 34.1693 15.6569C31.7454 13.2329 28.5135 11.8594 25.0392 11.8594C17.9289 11.8594 12.1114 17.6768 12.1922 24.8679C12.1922 27.2918 12.9194 29.635 14.1314 31.6549L14.4546 32.1397L13.1618 36.9068L18.0097 35.6948Z"
            fill="#00E676"
          />
          <path
            d="M35.5425 14.3631C32.7954 11.5352 28.9979 10 25.1195 10C16.8781 10 10.2527 16.7063 10.3335 24.8669C10.3335 27.4524 11.0607 29.9572 12.2726 32.2195L10.1719 39.8953L18.0093 37.8754C20.1909 39.0874 22.6148 39.6529 25.0387 39.6529C33.1994 39.6529 39.8248 32.9467 39.8248 24.7861C39.8248 20.827 38.2896 17.1102 35.5425 14.3631ZM25.1195 37.1482C22.938 37.1482 20.7564 36.5826 18.8981 35.4514L18.4133 35.209L13.727 36.421L14.939 31.8155L14.6158 31.3307C11.0607 25.5941 12.7574 17.999 18.5749 14.4439C24.3924 10.8888 31.9066 12.5855 35.4617 18.403C39.0168 24.2205 37.3201 31.7347 31.5026 35.2898C29.6442 36.5018 27.3819 37.1482 25.1195 37.1482ZM32.2298 28.1796L31.341 27.7756C31.341 27.7756 30.0482 27.21 29.2403 26.806C29.1595 26.806 29.0787 26.7252 28.9979 26.7252C28.7555 26.7252 28.5939 26.806 28.4323 26.8868C28.4323 26.8868 28.3515 26.9676 27.2203 28.2604C27.1395 28.422 26.9779 28.5028 26.8163 28.5028H26.7355C26.6547 28.5028 26.4931 28.422 26.4123 28.3412L26.0083 28.1796C25.1195 27.7756 24.3116 27.2908 23.6652 26.6444C23.5036 26.4828 23.2612 26.3212 23.0996 26.1596C22.534 25.5941 21.9684 24.9477 21.5644 24.2205L21.4836 24.0589C21.4028 23.9781 21.4028 23.8973 21.322 23.7357C21.322 23.5741 21.322 23.4125 21.4028 23.3317C21.4028 23.3317 21.726 22.9277 21.9684 22.6853C22.13 22.5237 22.2108 22.2813 22.3724 22.1197C22.534 21.8773 22.6148 21.5541 22.534 21.3117C22.4532 20.9078 21.4836 18.7262 21.2412 18.2414C21.0796 17.999 20.918 17.9182 20.6756 17.8374H20.4332C20.2717 17.8374 20.0293 17.8374 19.7869 17.8374C19.6253 17.8374 19.4637 17.9182 19.3021 17.9182L19.2213 17.999C19.0597 18.0798 18.8981 18.2414 18.7365 18.3222C18.5749 18.4838 18.4941 18.6454 18.3325 18.807C17.7669 19.5342 17.4437 20.423 17.4437 21.3117C17.4437 21.9581 17.6053 22.6045 17.8477 23.1701L17.9285 23.4125C18.6557 24.9477 19.6253 26.3212 20.918 27.5332L21.2412 27.8564C21.4836 28.0988 21.726 28.2604 21.8876 28.5028C23.5844 29.9572 25.5235 31.0075 27.7051 31.5731C27.9475 31.6539 28.2707 31.6539 28.5131 31.7347C28.7555 31.7347 29.0787 31.7347 29.3211 31.7347C29.725 31.7347 30.2098 31.5731 30.533 31.4115C30.7754 31.2499 30.937 31.2499 31.0986 31.0883L31.2602 30.9267C31.4218 30.7651 31.5834 30.6843 31.745 30.5227C31.9066 30.3611 32.0682 30.1995 32.149 30.038C32.3106 29.7148 32.3914 29.3108 32.4722 28.9068C32.4722 28.7452 32.4722 28.5028 32.4722 28.3412C32.4722 28.3412 32.3914 28.2604 32.2298 28.1796Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_1129_56693">
            <rect
              width="30"
              height="30"
              fill={color}
              transform="translate(10 10)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PaymentChatIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M15 27.5C21.9035 27.5 27.5 21.9035 27.5 15C27.5 8.09644 21.9035 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 16.9996 2.96952 18.8895 3.80432 20.5656C4.02617 21.011 4.10001 21.5201 3.9714 22.0007L3.22689 24.7834C2.90369 25.9912 4.00876 27.0962 5.21669 26.7731L7.99924 26.0286C8.47991 25.9 8.98901 25.9739 9.43441 26.1956C11.1104 27.0305 13.0004 27.5 15 27.5Z"
          fill="#76777A"
        />
        <path
          d="M9.78125 16.0625C9.21171 16.0625 8.75 16.5242 8.75 17.0937C8.75 17.6632 9.21171 18.125 9.78125 18.125H17.3438C17.9132 18.125 18.375 17.6632 18.375 17.0937C18.375 16.5242 17.9132 16.0625 17.3438 16.0625H9.78125Z"
          fill={color}
        />
        <path
          d="M9.78125 11.25C9.21171 11.25 8.75 11.7117 8.75 12.2812C8.75 12.8507 9.21171 13.3125 9.78125 13.3125H20.7812C21.3507 13.3125 21.8125 12.8507 21.8125 12.2812C21.8125 11.7117 21.3507 11.25 20.7812 11.25H9.78125Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const CopyLinkIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.5462 7.72126L22.2787 3.45376C22.0763 3.24982 21.8354 3.08812 21.5699 2.97804C21.3045 2.86796 21.0199 2.81169 20.7325 2.81251H13.75C12.5072 2.81383 11.3157 3.30812 10.4369 4.18691C9.55811 5.0657 9.06382 6.25721 9.0625 7.50001V7.81251H7.5C6.2572 7.81383 5.06569 8.30812 4.1869 9.18691C3.30811 10.0657 2.81382 11.2572 2.8125 12.5V22.5C2.81382 23.7428 3.30811 24.9343 4.1869 25.8131C5.06569 26.6919 6.2572 27.1862 7.5 27.1875H16.25C17.4928 27.1862 18.6843 26.6919 19.5631 25.8131C20.4419 24.9343 20.9362 23.7428 20.9375 22.5V22.1875H22.5C23.7428 22.1862 24.9343 21.6919 25.8131 20.8131C26.6919 19.9343 27.1862 18.7428 27.1875 17.5V9.26751C27.1883 8.98015 27.1321 8.6955 27.022 8.43006C26.9119 8.16463 26.7502 7.9237 26.5462 7.72126ZM22.1875 6.01376L23.9862 7.81251H23.515C23.1631 7.81185 22.8259 7.67177 22.577 7.42296C22.3282 7.17415 22.1882 6.83688 22.1875 6.48501V6.01376ZM19.0625 22.5C19.0618 23.2457 18.7653 23.9607 18.238 24.488C17.7107 25.0153 16.9957 25.3118 16.25 25.3125H7.5C6.75428 25.3118 6.0393 25.0153 5.51199 24.488C4.98469 23.9607 4.68816 23.2457 4.6875 22.5V12.5C4.68816 11.7543 4.98469 11.0393 5.51199 10.512C6.0393 9.9847 6.75428 9.68817 7.5 9.68751H9.0625V17.5C9.06382 18.7428 9.55811 19.9343 10.4369 20.8131C11.3157 21.6919 12.5072 22.1862 13.75 22.1875H19.0625V22.5ZM22.5 20.3125H13.75C13.0043 20.3118 12.2893 20.0153 11.762 19.488C11.2347 18.9607 10.9382 18.2457 10.9375 17.5V7.50001C10.9382 6.75429 11.2347 6.0393 11.762 5.512C12.2893 4.9847 13.0043 4.68817 13.75 4.68751H20.3125V6.48501C20.3135 7.33406 20.6512 8.14805 21.2516 8.74842C21.852 9.34879 22.6659 9.68652 23.515 9.68751H25.3125V17.5C25.3118 18.2457 25.0153 18.9607 24.488 19.488C23.9607 20.0153 23.2457 20.3118 22.5 20.3125Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const PaymentMailIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1129_56714)">
          <path
            d="M25.5 0H4.5C2.01472 0 0 2.01472 0 4.5V25.5C0 27.9853 2.01472 30 4.5 30H25.5C27.9853 30 30 27.9853 30 25.5V4.5C30 2.01472 27.9853 0 25.5 0Z"
            fill={color}
          />
          <path
            d="M9.25781 22.9102V14.5898L4.45312 10.8984V21.1523C4.45312 22.3242 5.03906 22.9102 6.21094 22.9102"
            fill="#4285F4"
          />
          <path
            d="M9.02344 14.5312L15 19.043L20.9766 14.5312V8.78906L15 13.3008L9.02344 8.78906"
            fill="#EA4335"
          />
          <path
            d="M20.7422 22.9102V14.5898L25.5469 10.8984V21.1523C25.5469 22.3242 24.9609 22.9102 23.7891 22.9102"
            fill="#34A853"
          />
          <path
            d="M4.45312 11.0182L9.25781 14.7096V8.96742L7.5 7.61976C5.91797 6.38929 4.45312 7.61976 4.45312 9.1432"
            fill="#C5221F"
          />
          <path
            d="M25.5469 11.0182L20.7422 14.7096V8.96742L22.5 7.61976C24.082 6.38929 25.5469 7.61976 25.5469 9.1432"
            fill="#FBBC04"
          />
        </g>
        <defs>
          <clipPath id="clip0_1129_56714">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const PaymentMessageIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M2.5 16.2125V8.7375C2.5 5.2875 5.3 2.5 8.75 2.5H21.25C24.7 2.5 27.5 5.2875 27.5 8.7375V17.4625C27.5 20.9 24.7 23.6875 21.25 23.6875H19.375C18.9875 23.6875 18.6125 23.875 18.375 24.1875L16.5 26.675C15.675 27.775 14.325 27.775 13.5 26.675L11.625 24.1875C11.425 23.9125 10.975 23.6875 10.625 23.6875H8.75C5.3 23.6875 2.5 20.9 2.5 17.4625V16.2125Z"
          fill={color}
        />
        <path
          d="M21.25 10.9375H8.75C8.2375 10.9375 7.8125 10.5125 7.8125 10C7.8125 9.4875 8.2375 9.0625 8.75 9.0625H21.25C21.7625 9.0625 22.1875 9.4875 22.1875 10C22.1875 10.5125 21.7625 10.9375 21.25 10.9375Z"
          fill={color}
        />
        <path
          d="M16.25 17.1875H8.75C8.2375 17.1875 7.8125 16.7625 7.8125 16.25C7.8125 15.7375 8.2375 15.3125 8.75 15.3125H16.25C16.7625 15.3125 17.1875 15.7375 17.1875 16.25C17.1875 16.7625 16.7625 17.1875 16.25 17.1875Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const TaxRateIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.286 7.0715H8.35728V5.14307H7.0715V7.0715H5.14307V8.35729H7.0715V10.286H8.35728V8.35729H10.286V7.0715ZM13.7144 7.0715H18.8573V8.35729H13.7144V7.0715ZM6.35033 18.5585L7.71416 17.1949L9.07799 18.5585L9.98713 17.6496L8.6233 16.286L9.98713 14.9224L9.07799 14.0132L7.71416 15.3768L6.35033 14.0132L5.44143 14.9224L6.80502 16.286L5.44143 17.6496L6.35033 18.5585Z"
          fill="white"
        />
        <path
          d="M2.57153 2.57129V21.4284H13.7144V19.7142H12.8573V12.8571H19.7144V13.7142H21.4286V2.57129H2.57153ZM4.28599 4.28574H11.1431V11.1429H4.28599V4.28574ZM11.1431 19.7142H4.28599V12.8571H11.1431V19.7142ZM19.7144 11.1429H12.8573V4.28574H19.7144V11.1429Z"
          fill="white"
        />
        <path
          d="M14.645 15.5747V19.4515L18.0024 21.3901L21.3599 19.4515V15.5747L18.0024 13.6362L14.645 15.5747ZM19.4312 15.9458L18.0022 16.7705L16.5735 15.9458L18.0024 15.1208L19.4312 15.9458ZM15.9308 17.0593L17.3596 17.884V19.534L15.9308 18.7093V17.0593ZM18.6453 19.5343V17.884L20.0743 17.0593V18.7093L18.6453 19.5343Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const SkipIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.23173 1.96422C4.27933 1.34919 3.19995 1.44653 2.38431 2.00439C1.57885 2.55528 1.04199 3.53886 1.04199 4.69544V16.3073C1.04199 17.4639 1.57885 18.4475 2.38431 18.9984C3.19996 19.5562 4.27933 19.6535 5.23174 19.0385L14.2226 13.2326C15.1812 12.6136 15.6253 11.5298 15.6253 10.5014C15.6253 9.47288 15.1812 8.38917 14.2226 7.77014L5.23173 1.96422ZM2.29199 4.69544C2.29199 3.92769 2.64438 3.34091 3.08997 3.03615C3.52537 2.73837 4.05884 2.69479 4.55363 3.0143L13.5445 8.82023C14.0749 9.1628 14.3753 9.80438 14.3753 10.5014C14.3753 11.1983 14.0749 11.84 13.5445 12.1825L4.55363 17.9885C4.05885 18.308 3.52537 18.2644 3.08998 17.9665C2.64438 17.6618 2.29199 17.075 2.29199 16.3073V4.69544Z"
          fill="white"
        />
        <path
          d="M18.958 4.66797C18.958 4.32279 18.6782 4.04297 18.333 4.04297C17.9878 4.04297 17.708 4.32279 17.708 4.66797V16.3347C17.708 16.6798 17.9878 16.9597 18.333 16.9597C18.6782 16.9597 18.958 16.6798 18.958 16.3347V4.66797Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const TickIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5003 18.8346C15.0837 18.8346 18.8337 15.0846 18.8337 10.5013C18.8337 5.91797 15.0837 2.16797 10.5003 2.16797C5.91699 2.16797 2.16699 5.91797 2.16699 10.5013C2.16699 15.0846 5.91699 18.8346 10.5003 18.8346Z"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.95801 10.4989L9.31634 12.8573L14.0413 8.14062"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const SaveIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.83871 3.53846C6.12608 3.53846 5.54839 4.11246 5.54839 4.82051V19.1795C5.54839 19.8875 6.12608 20.4615 6.83871 20.4615H17.1613C17.8739 20.4615 18.4516 19.8875 18.4516 19.1795V9.14049C18.4516 8.80672 18.3206 8.48611 18.0864 8.2468L13.8594 3.92682C13.6164 3.67854 13.2827 3.53846 12.9342 3.53846H6.83871ZM4 4.82051C4 3.26279 5.27093 2 6.83871 2H12.9342C13.701 2 14.4351 2.30817 14.9696 2.85439L19.1966 7.17437C19.7118 7.70085 20 8.4062 20 9.14049V19.1795C20 20.7372 18.7291 22 17.1613 22H6.83871C5.27093 22 4 20.7372 4 19.1795V4.82051Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12891 15.0778C8.12891 15.5027 8.47553 15.8471 8.90311 15.8471H15.0967C15.5242 15.8471 15.8709 15.5027 15.8709 15.0778C15.8709 14.653 15.5242 14.3086 15.0967 14.3086H8.90311C8.47553 14.3086 8.12891 14.653 8.12891 15.0778Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.12891 10.9763C8.12891 11.4011 8.47553 11.7455 8.90311 11.7455H11.9999C12.4275 11.7455 12.7741 11.4011 12.7741 10.9763C12.7741 10.5514 12.4275 10.207 11.9999 10.207H8.90311C8.47553 10.207 8.12891 10.5514 8.12891 10.9763Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const CrossIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>cross-circle</title>
        <desc>Created with Sketch Beta.</desc>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-568, -1087)" fill="#FFFFFF">
            <path d="M584,1117 C576.268,1117 570,1110.73 570,1103 C570,1095.27 576.268,1089 584,1089 C591.732,1089 598,1095.27 598,1103 C598,1110.73 591.732,1117 584,1117 L584,1117 Z M584,1087 C575.163,1087 568,1094.16 568,1103 C568,1111.84 575.163,1119 584,1119 C592.837,1119 600,1111.84 600,1103 C600,1094.16 592.837,1087 584,1087 L584,1087 Z M589.717,1097.28 C589.323,1096.89 588.686,1096.89 588.292,1097.28 L583.994,1101.58 L579.758,1097.34 C579.367,1096.95 578.733,1096.95 578.344,1097.34 C577.953,1097.73 577.953,1098.37 578.344,1098.76 L582.58,1102.99 L578.314,1107.26 C577.921,1107.65 577.921,1108.29 578.314,1108.69 C578.708,1109.08 579.346,1109.08 579.74,1108.69 L584.006,1104.42 L588.242,1108.66 C588.633,1109.05 589.267,1109.05 589.657,1108.66 C590.048,1108.27 590.048,1107.63 589.657,1107.24 L585.42,1103.01 L589.717,1098.71 C590.11,1098.31 590.11,1097.68 589.717,1097.28 L589.717,1097.28 Z"></path>
          </g>
        </g>
      </svg>
    </React.Fragment>
  );
};

export const AddIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9V11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V12.75H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12.75V9Z"
          fill="#F8F9FC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62177 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62177 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z"
          fill="#F8F9FC"
        />
      </svg>
    </React.Fragment>
  );
};

export const UpdateIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7501 7.99856V2.69856L16.6251 4.82356C15.3222 3.30602 13.5387 2.28066 11.5717 1.91827C9.60466 1.55588 7.57284 1.87833 5.81466 2.83192C4.05648 3.78551 2.67806 5.31267 1.909 7.15904C1.13994 9.00541 1.02666 11.0595 1.58803 12.9793C2.1494 14.899 3.35153 16.5685 4.99419 17.7096C6.63685 18.8508 8.62089 19.3947 10.6158 19.2508C12.6108 19.1069 14.4962 18.2839 15.9581 16.9188C17.42 15.5537 18.3701 13.729 18.6501 11.7486H16.8876C16.6109 13.3295 15.8022 14.7683 14.5955 15.8265C13.3888 16.8847 11.8566 17.4986 10.2531 17.5665C8.64958 17.6343 7.07103 17.1521 5.77923 16.1996C4.48743 15.2472 3.55999 13.8818 3.1507 12.3299C2.74141 10.7781 2.87487 9.13289 3.52894 7.66726C4.18301 6.20163 5.31839 5.0036 6.74682 4.27183C8.17524 3.54006 9.81087 3.31852 11.3825 3.64395C12.9541 3.96938 14.3673 4.82223 15.3876 6.06106L13.4501 7.99856H18.7501Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const ReceiptIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_6195_81570)">
          <path
            d="M11.8269 17.7216C11.8269 17.6464 11.8306 17.5707 11.838 17.4937C11.872 17.1551 11.9557 16.8542 12.0809 16.595C12.1658 16.4181 12.2719 16.2617 12.3911 16.125H1.39563C1.14984 16.125 0.906641 16.1786 0.69918 16.2971C0.491367 16.4166 0.315195 16.5909 0.184883 16.8531C0.0984766 17.0285 0.0332813 17.2456 0.00609375 17.5167C0.00125 17.5652 -0.000976562 17.6129 -0.000976562 17.6598C-0.000976562 17.8386 0.0321484 18.0065 0.094375 18.1677C0.156914 18.3286 0.248555 18.4828 0.36625 18.6255C0.600469 18.9104 0.940899 19.1465 1.31629 19.2858C1.56621 19.3793 1.83023 19.4295 2.08496 19.4307H2.08457L12.5986 19.4366C12.3799 19.2318 12.1956 18.9912 12.0615 18.7204C11.9125 18.4191 11.8269 18.0799 11.8269 17.7216Z"
            fill="white"
          />
          <path
            d="M19.9706 1.5625H5.95062C5.95695 2.45371 5.97672 3.38922 5.97672 4.36797C5.97672 6.07035 5.91488 7.89707 5.60277 9.81805C5.31043 11.6187 4.79723 13.5024 3.91309 15.4394H13.9317V15.4446C14.2799 15.4491 14.6225 15.537 14.9227 15.705C15.2289 15.8766 15.4929 16.1355 15.6542 16.4711C15.7547 16.6815 15.8021 16.9142 15.8021 17.1481C15.8021 17.3407 15.7696 17.5351 15.6985 17.7187C15.627 17.9023 15.5153 18.0766 15.354 18.2144C15.1186 18.4159 14.833 18.5123 14.5607 18.5112C14.3228 18.5112 14.0941 18.4415 13.9001 18.3168C13.7057 18.192 13.544 18.0106 13.4479 17.7861L14.0766 17.5164C14.1161 17.6084 14.1831 17.6859 14.2695 17.741C14.3552 17.7965 14.4579 17.8274 14.5607 17.8274C14.6788 17.8266 14.7957 17.7902 14.9104 17.6937C14.9715 17.6416 15.024 17.5667 15.0609 17.471C15.0982 17.376 15.1186 17.2624 15.1186 17.1481C15.1186 17.0088 15.0877 16.8707 15.0378 16.7671C14.9432 16.5708 14.7871 16.4133 14.5879 16.3012C14.3894 16.1898 14.1496 16.1273 13.9075 16.128C13.6676 16.1276 13.4274 16.1876 13.2184 16.3109C13.0091 16.4349 12.8282 16.6192 12.6967 16.8904C12.6095 17.0714 12.5455 17.2922 12.5187 17.5607C12.513 17.6147 12.5109 17.668 12.5109 17.7201C12.5109 17.9696 12.5693 18.2021 12.6747 18.4158C12.7801 18.6296 12.9332 18.824 13.1224 18.9882C13.3566 19.1923 13.6445 19.3476 13.9547 19.4355L14.2973 19.4359C14.6303 19.4348 14.8661 19.3752 15.0873 19.2765C15.3074 19.1778 15.5163 19.0307 15.7539 18.8408C16.6961 18.0896 17.4317 17.1563 18.0089 16.0904C18.5862 15.0246 19.0022 13.8264 19.2982 12.5621C19.8913 10.0333 19.9997 7.24383 19.9989 4.74598C19.9989 3.6082 19.9773 2.53188 19.9706 1.5625ZM8.03695 3.74715H13.3504C13.3627 4.9609 13.3567 6.24426 13.2364 7.58496H7.92262C8.04297 6.24426 8.0493 4.96086 8.03695 3.74715ZM16.319 13.3788H6.82176V12.5807H16.319V13.3788ZM17.0616 10.3774H7.56437V9.57969H17.0616V10.3774Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_6195_81570">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const NewEyeIcon = ({ color = "#FFFFFF" }) => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9277 10.3832C12.8187 10.3832 13.5447 11.1099 13.5447 12.0002C13.5447 12.8904 12.8179 13.5939 11.9277 13.5939C11.0374 13.5939 10.3339 12.8904 10.3339 12.0002C10.3339 11.1099 11.0374 10.3832 11.9277 10.3832ZM11.9277 6.39844C17.2249 6.39844 21.0447 11.3672 21.0447 11.3672C21.3027 11.6957 21.3027 12.2814 21.0447 12.6092C21.0447 12.6092 17.2242 17.5779 11.9277 17.5779C6.63119 17.5779 2.81069 12.6092 2.81069 12.6092C2.55269 12.2807 2.55269 11.6949 2.81069 11.3672C2.81069 11.3672 6.63119 6.39844 11.9277 6.39844ZM11.9277 16.0082C14.1312 16.0082 15.9357 14.2037 15.9357 12.0002C15.9357 9.79669 14.1312 7.99219 11.9277 7.99219C9.72419 7.99219 7.91969 9.79669 7.91969 12.0002C7.91969 14.2037 9.72419 16.0082 11.9277 16.0082Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};
export const RoundedTickIcon = () => {
  return (
    <React.Fragment>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 12.0018L10.58 14.8318L16.25 9.17188"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};
export const RevertIcon = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          stroke={color}
          strokeWidth="2"
          d="M8,3 L3,8 L8,13 M12,20 L15,20 C18.3137085,20 21,17.3137085 21,14 C21,10.6862915 18.3137085,8 15,8 L4,8"
        />
      </svg>
    </React.Fragment>
  );
};
export const AppsIcon = () => {
  const { mode } = useAuth();
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_11024_76699)">
          <path
            d="M6.75 2.5C7.30812 2.5 7.86077 2.60993 8.37641 2.82351C8.89204 3.03709 9.36056 3.35015 9.75521 3.7448C10.1499 4.13945 10.4629 4.60796 10.6765 5.1236C10.8901 5.63923 11 6.19188 11 6.75V11H6.75C5.62283 11 4.54183 10.5522 3.7448 9.7552C2.94777 8.95817 2.5 7.87717 2.5 6.75C2.5 5.62283 2.94777 4.54183 3.7448 3.7448C4.54183 2.94777 5.62283 2.5 6.75 2.5ZM6.75 13H11V17.25C11 18.0906 10.7507 18.9123 10.2837 19.6112C9.81675 20.3101 9.15299 20.8548 8.37641 21.1765C7.59982 21.4982 6.74529 21.5823 5.92087 21.4183C5.09645 21.2543 4.33917 20.8496 3.7448 20.2552C3.15042 19.6608 2.74565 18.9036 2.58166 18.0791C2.41768 17.2547 2.50184 16.4002 2.82351 15.6236C3.14519 14.847 3.68992 14.1833 4.38883 13.7163C5.08774 13.2493 5.90943 13 6.75 13ZM17.25 2.5C18.3772 2.5 19.4582 2.94777 20.2552 3.7448C21.0522 4.54183 21.5 5.62283 21.5 6.75C21.5 7.87717 21.0522 8.95817 20.2552 9.7552C19.4582 10.5522 18.3772 11 17.25 11H13V6.75C13 5.62283 13.4478 4.54183 14.2448 3.7448C15.0418 2.94777 16.1228 2.5 17.25 2.5ZM13 13H17.25C18.0906 13 18.9123 13.2493 19.6112 13.7163C20.3101 14.1833 20.8548 14.847 21.1765 15.6236C21.4982 16.4002 21.5823 17.2547 21.4183 18.0791C21.2544 18.9036 20.8496 19.6608 20.2552 20.2552C19.6608 20.8496 18.9036 21.2543 18.0791 21.4183C17.2547 21.5823 16.4002 21.4982 15.6236 21.1765C14.847 20.8548 14.1833 20.3101 13.7163 19.6112C13.2493 18.9123 13 18.0906 13 17.25V13Z"
            fill={mode ? "#FFFFFF" : "#646B88"}
          />
        </g>
        <defs>
          <clipPath id="clip0_11024_76699">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const LeftArrowIcon2 = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M14 17L9 12L14 7"
          stroke="#0100E4"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const RightArrowIcon2 = ({ color = "#0100E4" }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M10 7L15 12L10 17"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const LinkIcon = ({ color = "#0100E4" }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.69653 4.69506C5.99828 3.39331 8.10883 3.39331 9.41057 4.69506L11.7676 7.05209C13.0693 8.35385 13.0693 10.4644 11.7676 11.7661C11.4422 12.0916 10.9145 12.0916 10.5891 11.7661C10.2637 11.4407 10.2637 10.913 10.5891 10.5876C11.24 9.93677 11.24 8.88144 10.5891 8.2306L8.23206 5.87357C7.58119 5.2227 6.52591 5.2227 5.87504 5.87357C5.22417 6.52445 5.22417 7.57972 5.87504 8.2306L6.46429 8.81985C6.78974 9.14527 6.78973 9.67294 6.46429 9.99835C6.13886 10.3238 5.61122 10.3238 5.28579 9.99835L4.69653 9.4091C3.39478 8.10736 3.39478 5.99681 4.69653 4.69506ZM9.41057 8.2306C9.73599 8.55602 9.73599 9.08369 9.41057 9.4091C8.75974 10.06 8.75974 11.1153 9.41057 11.7661L11.7676 14.1232C12.4185 14.774 13.4737 14.774 14.1247 14.1232C14.7755 13.4723 14.7755 12.417 14.1247 11.7661L13.5354 11.1769C13.2099 10.8514 13.2099 10.3238 13.5354 9.99835C13.8608 9.67294 14.3884 9.67294 14.7139 9.99835L15.3032 10.5876C16.6049 11.8894 16.6049 13.9999 15.3032 15.3017C14.0014 16.6034 11.8908 16.6034 10.5891 15.3017L8.23207 12.9447C6.93032 11.6429 6.93032 9.53235 8.23207 8.2306C8.55749 7.90516 9.08515 7.90516 9.41057 8.2306Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const TransactionsIcon = () => {
  const { mode } = useAuth();
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M17.9996 4.53906H5.51957C4.98938 4.53906 4.55957 4.96887 4.55957 5.49906V7.41906C4.55957 7.94926 4.98938 8.37906 5.51957 8.37906H17.9996C18.5298 8.37906 18.9596 7.94926 18.9596 7.41906V5.49906C18.9596 4.96887 18.5298 4.53906 17.9996 4.53906Z"
          fill={mode ? "#FFFFFF" : "#646B88"}
        />
        <path
          d="M10.0796 9.82031H5.51957C4.98938 9.82031 4.55957 10.2501 4.55957 10.7803V12.7003C4.55957 13.2305 4.98938 13.6603 5.51957 13.6603H10.0796C10.6098 13.6603 11.0396 13.2305 11.0396 12.7003V10.7803C11.0396 10.2501 10.6098 9.82031 10.0796 9.82031Z"
          fill={mode ? "#FFFFFF" : "#646B88"}
        />
        <path
          d="M10.0796 15.1016H5.51957C4.98938 15.1016 4.55957 15.5314 4.55957 16.0616V17.9816C4.55957 18.5118 4.98938 18.9416 5.51957 18.9416H10.0796C10.6098 18.9416 11.0396 18.5118 11.0396 17.9816V16.0616C11.0396 15.5314 10.6098 15.1016 10.0796 15.1016Z"
          fill={mode ? "#FFFFFF" : "#646B88"}
        />
        <path
          d="M15.5885 17.3971C15.621 17.4312 15.6601 17.4584 15.7034 17.4769C15.7467 17.4955 15.7933 17.5051 15.8405 17.5051C15.8876 17.5051 15.9342 17.4955 15.9776 17.4769C16.0209 17.4584 16.06 17.4312 16.0925 17.3971L18.8525 14.6611C18.8866 14.6286 18.9138 14.5895 18.9323 14.5461C18.9509 14.5028 18.9605 14.4562 18.9605 14.4091C18.9605 14.3619 18.9509 14.3153 18.9323 14.272C18.9138 14.2287 18.8866 14.1896 18.8525 14.1571L16.0805 11.3971C16.048 11.3629 16.0089 11.3358 15.9656 11.3172C15.9222 11.2986 15.8756 11.2891 15.8285 11.2891C15.7813 11.2891 15.7347 11.2986 15.6914 11.3172C15.6481 11.3358 15.609 11.3629 15.5765 11.3971L15.0725 11.9011C15.0383 11.9336 15.0112 11.9727 14.9926 12.016C14.974 12.0593 14.9645 12.1059 14.9645 12.1531C14.9645 12.2002 14.974 12.2468 14.9926 12.2901C15.0112 12.3335 15.0383 12.3726 15.0725 12.4051L15.9365 13.2691C15.9694 13.3026 15.9917 13.3451 16.0007 13.3912C16.0097 13.4373 16.0049 13.485 15.987 13.5285C15.9691 13.5719 15.9389 13.6091 15.9 13.6356C15.8612 13.662 15.8154 13.6764 15.7685 13.6771H12.8645C12.7671 13.6785 12.6739 13.7163 12.6029 13.7828C12.5319 13.8494 12.4882 13.94 12.4805 14.0371V14.7571C12.4916 14.853 12.5362 14.9419 12.6065 15.0082C12.6767 15.0745 12.7681 15.1139 12.8645 15.1195H15.7805C15.8274 15.1201 15.8732 15.1346 15.912 15.161C15.9509 15.1874 15.9811 15.2246 15.999 15.2681C16.0169 15.3115 16.0217 15.3592 16.0127 15.4053C16.0037 15.4515 15.9814 15.4939 15.9485 15.5275L15.0845 16.3915C15.0503 16.424 15.0232 16.4631 15.0046 16.5064C14.986 16.5497 14.9765 16.5963 14.9765 16.6435C14.9765 16.6906 14.986 16.7372 15.0046 16.7805C15.0232 16.8239 15.0503 16.863 15.0845 16.8955L15.5885 17.3971Z"
          fill={mode ? "#FFFFFF" : "#646B88"}
        />
      </svg>
    </React.Fragment>
  );
};

export const RefundIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M9 22.8555H15C20 22.8555 22 20.8555 22 15.8555V9.85547C22 4.85547 20 2.85547 15 2.85547H9C4 2.85547 2 4.85547 2 9.85547V15.8555C2 20.8555 4 22.8555 9 22.8555Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00039 16.2342H13.9204C15.6204 16.2342 17.0004 14.8542 17.0004 13.1542C17.0004 11.4542 15.6204 10.0742 13.9204 10.0742H7.15039"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.57 11.6265L7 10.0466L8.57 8.47656"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const RefundsIcon = () => {
  const { mode } = useAuth();
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_11596_102637)">
          <path
            d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C9.66849 22.0034 7.40966 21.1888 5.61701 19.698L5.37301 19.489L6.27501 17.587C7.56299 18.9071 9.26753 19.7416 11.1001 19.9493C12.9327 20.157 14.7808 19.7252 16.3316 18.7268C17.8823 17.7285 19.0405 16.225 19.6101 14.4708C20.1796 12.7166 20.1256 10.8195 19.4571 9.1006C18.7886 7.38168 17.5468 5.94654 15.9417 5.03807C14.3366 4.1296 12.467 3.80362 10.6492 4.1153C8.83135 4.42697 7.17707 5.35717 5.96632 6.74843C4.75556 8.1397 4.0627 9.90657 4.00501 11.75L4.00001 12H6.50001L3.79401 17.716C2.62322 16.0401 1.99685 14.0444 2.00001 12C2.00001 6.477 6.47701 2 12 2Z"
            fill={mode ? "#FFFFFF" : "#646B88"}
          />
          <g clipPath="url(#clip1_11596_102637)">
            <path
              d="M13.5444 9.33065H15.4397L16.1312 8.16016H9.46203L8.77053 9.33065H11.3321C11.897 9.49722 12.3562 9.8317 12.6101 10.2562H9.46203L8.77051 11.4267H12.7663C12.5293 12.2261 11.6129 12.8218 10.5176 12.8218H9.15167V13.8767L13.0277 17.1602H14.7154V16.752L11.1735 13.8192C12.6599 13.7603 13.8741 12.7431 14.0965 11.4267H15.4397L16.1312 10.2562H14.0274C13.9285 9.91846 13.7628 9.60606 13.5444 9.33065Z"
              fill={mode ? "#FFFFFF" : "#646B88"}
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_11596_102637">
            <rect width="24" height="24" fill="white" />
          </clipPath>
          <clipPath id="clip1_11596_102637">
            <rect
              width="9"
              height="9"
              fill="white"
              transform="translate(7.9502 8.16016)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const PaymentPendingIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect
          width="35"
          height="35"
          rx="10"
          transform="matrix(-1 0 0 1 35 0)"
          fill="#F46C25"
          fillOpacity="0.1"
        />
        <path
          d="M22.6004 12.8247C25.3973 12.8247 27.6729 15.1003 27.6729 17.8973C27.6729 20.6942 25.3973 22.9697 22.6004 22.9697C19.8034 22.9697 17.5279 20.6942 17.5279 17.8973C17.5279 15.1003 19.8034 12.8247 22.6004 12.8247ZM22.6004 24.7949C24.4428 24.7949 26.175 24.0775 27.4778 22.7747C28.7806 21.4719 29.498 19.7397 29.498 17.8973C29.498 16.0548 28.7806 14.3226 27.4778 13.0198C26.175 11.717 24.4428 10.9995 22.6004 10.9995C20.7579 10.9995 19.0257 11.717 17.7229 13.0198C16.4201 14.3226 15.7027 16.0548 15.7027 17.8973C15.7027 19.7397 16.4201 21.4719 17.7229 22.7747C19.0257 24.0775 20.7579 24.7949 22.6004 24.7949Z"
          fill="#F46C25"
        />
        <path
          d="M22.6009 18.7305C23.0608 18.7305 23.4336 18.3576 23.4336 17.8978V14.4093C23.4336 13.9493 23.0608 13.5764 22.6009 13.5764C22.1409 13.5764 21.7681 13.9493 21.7681 14.4093V17.8978C21.7681 18.3576 22.1409 18.7305 22.6009 18.7305Z"
          fill="#F46C25"
        />
        <path
          d="M25.0026 20.6484C25.2471 20.6484 25.4894 20.5412 25.6539 20.3351C25.9409 19.9758 25.8822 19.4517 25.5227 19.1648L23.1196 17.2463C22.7603 16.9594 22.2362 17.0182 21.9493 17.3776C21.6624 17.7371 21.721 18.261 22.0805 18.548L24.4836 20.4664C24.637 20.5889 24.8204 20.6484 25.0026 20.6484Z"
          fill="#F46C25"
        />
        <path
          d="M6.90209 24.4199H16.3683C16.7085 24.4199 16.9844 24.1442 16.9844 23.8039C16.9844 23.4637 16.7085 23.1879 16.3683 23.1879H6.90209C6.80734 23.1879 6.7302 23.1108 6.7302 23.016V12.7809C6.7302 12.6862 6.80734 12.6091 6.90209 12.6091H15.9849C16.3251 12.6091 16.6009 12.3333 16.6009 11.9931C16.6009 11.6529 16.3251 11.377 15.9849 11.377H6.90209C6.12796 11.377 5.49821 12.0068 5.49821 12.7809V23.016C5.49821 23.7902 6.12796 24.4199 6.90209 24.4199Z"
          fill="#F46C25"
        />
        <path
          d="M9.73088 14.8554H8.88557C8.63057 14.8554 8.42357 14.6487 8.42357 14.3934V14.3822C8.42357 14.1269 8.63057 13.9202 8.88557 13.9202H14.0924C14.3477 13.9202 14.5547 14.1272 14.5547 14.3824V14.3934C14.5547 14.6485 14.3478 14.8554 14.0926 14.8554H10.9367V15.8586H14.0924C14.2199 15.8586 14.3357 15.9104 14.4193 15.9939C14.5041 16.0788 14.5561 16.1965 14.5546 16.3262C14.5516 16.5811 14.3357 16.7827 14.0807 16.7827H10.9931C11.0533 17.1361 11.179 17.3914 11.3707 17.549C11.5623 17.7069 11.8535 17.8103 12.2441 17.8591C12.4939 17.8904 12.8343 17.9115 13.2651 17.9228C13.7192 17.9346 14.0812 18.3053 14.0812 18.7595V19.4763C14.0812 20.2354 13.8802 20.8251 13.4782 21.2457C13.0764 21.6666 12.4959 21.877 11.7369 21.877C11.6181 21.877 11.5037 21.8722 11.3938 21.8627C11.0294 21.8314 10.8178 21.4359 10.9954 21.1162C11.0952 20.9363 11.2942 20.8359 11.4983 20.8611C11.5667 20.8696 11.6387 20.8738 11.7145 20.8738C12.1352 20.8738 12.4339 20.7537 12.6105 20.5133C12.7871 20.2728 12.8754 19.946 12.8754 19.5326V19.0658C12.8754 18.9324 12.7686 18.823 12.6351 18.8197C12.075 18.8055 11.6105 18.7409 11.2412 18.6255C10.8204 18.4941 10.4955 18.2799 10.2662 17.983C10.0371 17.6864 9.88132 17.2862 9.79841 16.7827H8.88557C8.75802 16.7827 8.6426 16.7308 8.55891 16.6473C8.47436 16.5628 8.42222 16.4454 8.42357 16.3158C8.42626 16.0605 8.64221 15.8586 8.8974 15.8586H9.73088V14.8554Z"
          fill="#F46C25"
        />
      </svg>
    </>
  );
};

export const PaymentUnderVerificationIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#4AC095" fillOpacity="0.1" />
        <path
          d="M19.357 11.5389C16.9969 11.5389 15.0775 13.4588 15.0775 15.8188C15.0775 18.1786 16.9969 20.0986 19.357 20.0986C21.7171 20.0986 23.6365 18.1786 23.6365 15.8188C23.6365 13.4588 21.7171 11.5389 19.357 11.5389ZM19.357 21.6387C17.802 21.6387 16.3412 21.0332 15.2414 19.934C14.1426 18.8348 13.5371 17.3733 13.5371 15.8188C13.5371 14.2642 14.1426 12.8026 15.2414 11.7034C16.3412 10.6042 17.802 9.99885 19.357 9.99885C20.9112 9.99885 22.3729 10.6042 23.4726 11.7034C24.5715 12.8026 25.1769 14.2642 25.1769 15.8188C25.1769 17.3733 24.5715 18.8348 23.4726 19.934C22.3729 21.0332 20.9112 21.6387 19.357 21.6387Z"
          fill="#4AC095"
        />
        <path
          d="M14.6309 21.3203H7.18443C6.53134 21.3203 6 20.7889 6 20.1358V11.4999C6 10.8468 6.53134 10.3155 7.18443 10.3155H14.3078C14.5943 10.3155 14.8273 10.5482 14.8273 10.8352C14.8273 11.1223 14.5943 11.355 14.3078 11.355H7.18443C7.10457 11.355 7.03949 11.42 7.03949 11.4999V20.1358C7.03949 20.2157 7.10457 20.2807 7.18443 20.2807H14.6309C14.9182 20.2807 15.1511 20.5134 15.1511 20.8005C15.1511 21.0875 14.9182 21.3203 14.6309 21.3203Z"
          fill="#4AC095"
        />
        <path
          d="M12.0369 13.2514H12.7503C12.9653 13.2514 13.1398 13.077 13.1398 12.8616V12.8522C13.1398 12.6367 12.9653 12.4623 12.7503 12.4623H8.35687C8.14148 12.4623 7.96682 12.637 7.96682 12.8524V12.8616C7.96682 13.0769 8.1414 13.2514 8.35663 13.2514H11.0191V14.0979H8.35687C8.24925 14.0979 8.15162 14.1416 8.08093 14.212C8.00951 14.2837 7.96553 14.3829 7.96682 14.4924C7.96942 14.7076 8.15163 14.8775 8.36678 14.8775H10.9721C10.9209 15.1757 10.8146 15.3912 10.6531 15.5242C10.4916 15.6574 10.2457 15.7446 9.91618 15.7858C9.70517 15.8121 9.41835 15.8301 9.05484 15.8395C8.67177 15.8495 8.36629 16.1623 8.36629 16.5454V17.1503C8.36629 17.7907 8.53583 18.2884 8.87508 18.6431C9.21408 18.9984 9.70354 19.1758 10.3439 19.1758C10.4445 19.1758 10.5411 19.1718 10.6336 19.1639C10.9412 19.1373 11.1198 18.8037 10.9696 18.5339C10.886 18.3822 10.718 18.2974 10.546 18.3187C10.4884 18.3258 10.4275 18.3294 10.3634 18.3294C10.0079 18.3294 9.7563 18.2281 9.60697 18.0252C9.4582 17.8223 9.3837 17.5467 9.3837 17.1979V16.804C9.3837 16.6913 9.47378 16.5991 9.58668 16.5962C10.059 16.5843 10.451 16.5298 10.7627 16.4324C11.1173 16.3215 11.3917 16.1408 11.5848 15.8903C11.7788 15.6401 11.9103 15.3024 11.9801 14.8775H12.7503C12.8574 14.8775 12.9548 14.8339 13.0254 14.7634C13.0968 14.692 13.1406 14.5931 13.1398 14.4836C13.1374 14.2683 12.9556 14.0979 12.7397 14.0979H12.0369V13.2514Z"
          fill="#4AC095"
        />
        <path
          d="M29.0436 22.3704C29.0436 22.3705 29.0436 22.3705 29.0436 22.3706V22.3704ZM26.1008 21.4385L28.4041 23.204L28.7993 22.6884L26.4968 20.9228L26.1008 21.4385ZM28.4779 24.4043C28.3424 24.4043 28.206 24.3615 28.09 24.2728L25.1504 22.0198C25.0157 21.916 24.928 21.7657 24.9061 21.5965C24.8834 21.4272 24.9288 21.2595 25.0327 21.124L25.9149 19.9725C26.1292 19.6929 26.5309 19.6397 26.8109 19.8541L29.7497 22.107C29.8852 22.2107 29.9721 22.3611 29.9948 22.5303C30.0175 22.6995 29.9721 22.8673 29.8682 23.0027V23.0028L28.986 24.1544C28.8602 24.3183 28.6703 24.4043 28.4779 24.4043Z"
          fill="#4AC095"
        />
        <path
          d="M24.307 21.207C24.1714 21.207 24.0343 21.1642 23.919 21.0755L23.8671 21.0359C23.5879 20.8216 23.5343 20.4198 23.7486 20.1402L24.6316 18.9886C24.8458 18.709 25.2476 18.6559 25.5268 18.8701L25.5787 18.9097C25.8587 19.124 25.9115 19.5258 25.6972 19.8053V19.8055L24.8142 20.9571C24.6892 21.121 24.4985 21.207 24.307 21.207Z"
          fill="#4AC095"
        />
        <path
          d="M22.2468 16.5879C21.8216 16.5879 21.4766 16.2431 21.4766 15.8179C21.4766 14.802 20.7543 13.9263 19.7585 13.7357C19.3405 13.6558 19.067 13.2523 19.1466 12.8346C19.2269 12.417 19.6303 12.1432 20.0474 12.2231C21.768 12.5523 23.017 14.0642 23.017 15.8179C23.017 16.2431 22.6721 16.5879 22.2468 16.5879Z"
          fill="#4AC095"
        />
      </svg>
    </>
  );
};

export const DispatchPendingIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#F93E3E" fillOpacity="0.1" />
        <path
          d="M23.3836 25.0918H17.3636C13.9625 25.0918 12.0901 25.0918 10.7468 23.6759C9.41498 22.2703 9.35874 20.7241 9.35874 17.3604V14.4054C9.35874 13.6647 9.35873 13.0796 9.31783 12.7021C9.3076 12.6079 9.29612 12.5449 9.28845 12.5049C9.26161 12.4893 9.22325 12.4684 9.16957 12.4424C8.85771 12.2892 8.36179 12.1145 7.67544 11.8727L7.3802 11.769C6.30658 11.3903 5.74037 10.2093 6.11613 9.13611C6.49446 8.06134 7.67544 7.49475 8.74907 7.87038L9.09289 7.99117C9.82525 8.24871 9.81759 8.34303 10.3493 8.60518C11.1123 8.97864 11.6594 9.55942 12.0684 10.1569C12.517 10.811 12.6818 11.4932 12.756 12.0127H15.1154C15.7851 12.0127 16.3296 12.5564 16.3296 13.2269C16.3296 13.8975 15.7851 14.4411 15.1154 14.4411H11.7872V17.3604C11.7872 20.6985 11.8881 21.3497 12.5093 22.005C13.1088 22.6368 14.4303 22.6634 17.3636 22.6634H23.3836C24.7256 22.6634 25.6113 22.6634 25.9028 22.4261C26.1954 22.1882 26.3731 21.3211 26.6441 20.0086L27.2115 17.2542C27.4352 16.1324 27.6653 14.9741 27.549 14.6667C27.0863 14.4411 25.4465 14.4411 24.3473 14.4411H23.1918C22.5221 14.4411 21.9776 13.8975 21.9776 13.2269C21.9776 12.5564 22.5221 12.0127 23.1918 12.0127H24.3473C26.7131 12.0127 28.5817 12.0126 29.4495 13.1412C30.2893 14.2336 30.0272 15.5493 29.5927 17.7293L29.5901 17.7445L29.0226 20.4986C28.6341 22.386 28.3989 23.5255 27.4365 24.3089C26.4754 25.0918 25.3122 25.0918 23.3836 25.0918Z"
          fill="#F93E3E"
        />
        <path
          d="M13.4114 26.8531C14.3521 26.8531 15.1152 27.6157 15.1152 28.5564C15.1152 29.4971 14.3521 30.2598 13.4114 30.2598C12.4707 30.2598 11.709 29.4971 11.709 28.5564C11.709 27.6157 12.4707 26.8531 13.4114 26.8531Z"
          fill="#F93E3E"
        />
        <path
          d="M23.6321 26.8532C24.5728 26.8532 25.3359 27.6157 25.3359 28.5566C25.3359 29.4972 24.5728 30.2598 23.6321 30.2598C22.6914 30.2598 21.9297 29.4972 21.9297 28.5566C21.9297 27.6157 22.6914 26.8532 23.6321 26.8532Z"
          fill="#F93E3E"
        />
        <path
          d="M19.1922 14.9121C18.6925 14.9121 18.2758 14.529 18.2349 14.0311L17.7134 7.79142C17.707 7.70042 17.6968 7.56392 17.684 7.38178C17.6508 6.95911 17.6355 6.67946 17.6355 6.54295C17.6355 5.99017 17.7569 5.59523 18.001 5.35775C18.2451 5.1204 18.649 5.00179 19.2152 5.00179C19.7674 5.00179 20.1649 5.1204 20.4051 5.35775C20.6454 5.59523 20.7656 5.99017 20.7656 6.54295C20.7656 6.7316 20.7464 7.07299 20.7081 7.56711C20.7004 7.66463 20.694 7.7426 20.6876 7.80114L20.1495 14.0338C20.1061 14.5306 19.6907 14.9121 19.1922 14.9121ZM19.2152 19.9258C18.6171 19.9258 18.1697 19.8038 17.8745 19.56C17.5779 19.3161 17.4297 18.9503 17.4297 18.4626C17.4297 17.9749 17.5792 17.6077 17.8783 17.3603C18.1774 17.1133 18.6234 16.9897 19.2152 16.9897C19.8006 16.9897 20.239 17.1116 20.5317 17.3555C20.8244 17.5993 20.9714 17.9685 20.9714 18.4626C20.9714 18.9568 20.8244 19.3243 20.5317 19.5648C20.239 19.8054 19.8006 19.9258 19.2152 19.9258Z"
          fill="#F93E3E"
        />
      </svg>
    </>
  );
};

export const PackingInProgressIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <rect width="35" height="35" rx="10" fill="#9747FF" fillOpacity="0.1" />
        <path
          d="M30 16.1109L26.6962 13.1284C26.3846 12.8465 25.8859 13.0681 25.8859 13.4887V26.1872C25.8859 26.6501 25.5103 27.0254 25.0473 27.0254H10.9527C10.4897 27.0254 10.1141 26.6501 10.1141 26.1872V13.4887C10.1141 13.0681 9.6154 12.8465 9.30386 13.1284L6 16.1109"
          stroke="#9747FF"
          strokeWidth="2.33966"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M20.0601 12.4434H15.6172V8.54856C15.6172 8.24551 15.8622 7.99985 16.1652 7.99985H19.5121C19.815 7.99985 20.0601 8.24551 20.0601 8.54856V12.4434Z"
          fill="#9747FF"
        />
        <path
          d="M13.8297 12.1856H22.149C22.6379 12.1856 22.8829 12.7768 22.5369 13.1225L18.328 17.3315C18.1125 17.5475 17.7615 17.5455 17.5485 17.3268L13.4368 13.1179C13.097 12.7704 13.3433 12.1856 13.8297 12.1856Z"
          fill="#9747FF"
        />
      </svg>
    </>
  );
};

export const DownloadIcon2 = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M12.5535 16.5061C12.4114 16.6615 12.2106 16.75 12 16.75C11.7894 16.75 11.5886 16.6615 11.4465 16.5061L7.44648 12.1311C7.16698 11.8254 7.18822 11.351 7.49392 11.0715C7.79963 10.792 8.27402 10.8132 8.55352 11.1189L11.25 14.0682V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V14.0682L15.4465 11.1189C15.726 10.8132 16.2004 10.792 16.5061 11.0715C16.8118 11.351 16.833 11.8254 16.5535 12.1311L12.5535 16.5061Z"
            fill="#ffffff"
          />{" "}
          <path
            d="M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z"
            fill="#ffffff"
          />{" "}
        </g>
      </svg>
    </>
  );
};

export const LockIcon = ({ color }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_13074_95882)">
          <path
            d="M5.25 9.02936H15.96L16.3485 7.28861C17.0108 4.81886 15.861 2.35661 13.2292 1.65161C10.6245 0.954111 8.32875 2.44736 7.65525 4.95911L7.3365 6.22361C7.22925 6.62411 6.81825 6.86111 6.41775 6.75386C6.01725 6.64661 5.78025 6.23561 5.8875 5.83511L6.20625 4.56986C7.0965 1.24511 10.2 -0.713889 13.617 0.201861C17.0475 1.12136 18.6727 4.40711 17.7968 7.67636L17.4952 9.02861H18.75C20.4045 9.02861 21.75 10.3741 21.75 12.0286V21.0286C21.75 22.6831 20.4045 24.0286 18.75 24.0286H5.25C3.5955 24.0286 2.25 22.6831 2.25 21.0286V12.0286C2.25 10.3741 3.5955 9.02861 5.25 9.02861V9.02936ZM3.75 21.0301C3.75 21.8566 4.4235 22.5301 5.25 22.5301H18.75C19.5773 22.5301 20.25 21.8566 20.25 21.0301V12.0301C20.25 11.2036 19.5773 10.5301 18.75 10.5301H5.25C4.4235 10.5301 3.75 11.2036 3.75 12.0301V21.0301ZM12 13.5301C12.828 13.5301 13.5 14.2014 13.5 15.0301C13.5 15.5836 13.1962 16.0621 12.75 16.3224V18.7801C12.75 19.1941 12.414 19.5301 12 19.5301C11.586 19.5301 11.25 19.1941 11.25 18.7801V16.3224C10.8038 16.0629 10.5 15.5836 10.5 15.0301C10.5 14.2014 11.1713 13.5301 12 13.5301Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_13074_95882">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="matrix(-1 0 0 1 24 0)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const LockIcon2 = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M12 14V18"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};

export const RemoveAccountIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 4H6C4.89543 4 4 4.89543 4 6V14C4 15.1046 4.89543 16 6 16H18C19.1046 16 20 15.1046 20 14V13"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8787 3.875L18.3787 6.375M18.3787 6.375L15.8787 8.875M18.3787 6.375L15.8787 3.875M18.3787 6.375L20.8787 8.875"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16V20"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 20H16"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const InfoIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 512 512"
        version="1.1"
        fill="#4164E3"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>info-filled</title>{" "}
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            {" "}
            <g
              id="add"
              fill="#4164E3"
              transform="translate(42.666667, 42.666667)"
            >
              {" "}
              <path
                d="M213.333333,3.55271368e-14 C95.51296,3.55271368e-14 3.55271368e-14,95.51168 3.55271368e-14,213.333333 C3.55271368e-14,331.153707 95.51296,426.666667 213.333333,426.666667 C331.154987,426.666667 426.666667,331.153707 426.666667,213.333333 C426.666667,95.51168 331.154987,3.55271368e-14 213.333333,3.55271368e-14 Z M240.04672,128 C240.04672,143.46752 228.785067,154.666667 213.55008,154.666667 C197.698773,154.666667 186.713387,143.46752 186.713387,127.704107 C186.713387,112.5536 197.99616,101.333333 213.55008,101.333333 C228.785067,101.333333 240.04672,112.5536 240.04672,128 Z M192.04672,192 L234.713387,192 L234.713387,320 L192.04672,320 L192.04672,192 Z"
                id="Shape"
              >
                {" "}
              </path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    </>
  );
};

export const WarningIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 512 512"
        version="1.1"
        fill="#FF9B04"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>warning-filled</title>{" "}
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            {" "}
            <g
              id="add"
              fill="#FF9B04"
              transform="translate(32.000000, 42.666667)"
            >
              {" "}
              <path
                d="M246.312928,5.62892705 C252.927596,9.40873724 258.409564,14.8907053 262.189374,21.5053731 L444.667042,340.84129 C456.358134,361.300701 449.250007,387.363834 428.790595,399.054926 C422.34376,402.738832 415.04715,404.676552 407.622001,404.676552 L42.6666667,404.676552 C19.1025173,404.676552 7.10542736e-15,385.574034 7.10542736e-15,362.009885 C7.10542736e-15,354.584736 1.93772021,347.288125 5.62162594,340.84129 L188.099293,21.5053731 C199.790385,1.04596203 225.853517,-6.06216498 246.312928,5.62892705 Z M224,272 C208.761905,272 197.333333,283.264 197.333333,298.282667 C197.333333,313.984 208.415584,325.248 224,325.248 C239.238095,325.248 250.666667,313.984 250.666667,298.624 C250.666667,283.264 239.238095,272 224,272 Z M245.333333,106.666667 L202.666667,106.666667 L202.666667,234.666667 L245.333333,234.666667 L245.333333,106.666667 Z"
                id="Combined-Shape"
              >
                {" "}
              </path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    </>
  );
};

export const ErrorIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 512 512"
        version="1.1"
        fill="#F93E3E"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>error-filled</title>{" "}
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            {" "}
            <g
              id="add"
              fill="#F93E3E"
              transform="translate(42.666667, 42.666667)"
            >
              {" "}
              <path
                d="M213.333333,3.55271368e-14 C331.136,3.55271368e-14 426.666667,95.5306667 426.666667,213.333333 C426.666667,331.136 331.136,426.666667 213.333333,426.666667 C95.5306667,426.666667 3.55271368e-14,331.136 3.55271368e-14,213.333333 C3.55271368e-14,95.5306667 95.5306667,3.55271368e-14 213.333333,3.55271368e-14 Z M262.250667,134.250667 L213.333333,183.168 L164.416,134.250667 L134.250667,164.416 L183.168,213.333333 L134.250667,262.250667 L164.416,292.416 L213.333333,243.498667 L262.250667,292.416 L292.416,262.250667 L243.498667,213.333333 L292.416,164.416 L262.250667,134.250667 Z"
                id="Combined-Shape"
              >
                {" "}
              </path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    </>
  );
};

export const SuccessIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 512 512"
        version="1.1"
        fill="#31974D"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>success-filled</title>{" "}
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            {" "}
            <g
              id="add-copy-2"
              fill="#31974D"
              transform="translate(42.666667, 42.666667)"
            >
              {" "}
              <path
                d="M213.333333,3.55271368e-14 C95.51296,3.55271368e-14 3.55271368e-14,95.51296 3.55271368e-14,213.333333 C3.55271368e-14,331.153707 95.51296,426.666667 213.333333,426.666667 C331.153707,426.666667 426.666667,331.153707 426.666667,213.333333 C426.666667,95.51296 331.153707,3.55271368e-14 213.333333,3.55271368e-14 Z M293.669333,137.114453 L323.835947,167.281067 L192,299.66912 L112.916693,220.585813 L143.083307,190.4192 L192,239.335893 L293.669333,137.114453 Z"
                id="Shape"
              >
                {" "}
              </path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    </>
  );
};

export const AlertIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#ffffff"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#ffffff"
            strokeWidth="2"
          />{" "}
          <path
            d="M12 8L12 13"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
          />{" "}
          <path
            d="M12 16V15.9888"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
          />{" "}
        </g>
      </svg>
    </>
  );
};

export const SearchSmall = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.28125 10.8142C5.28128 8.1738 7.14649 5.90116 9.73613 5.38614C12.3258 4.87113 14.9187 6.25721 15.9289 8.69667C16.9392 11.1362 16.0855 13.9495 13.89 15.4162C11.6944 16.8829 8.76852 16.5944 6.90173 14.7271C5.86412 13.6893 5.28123 12.2817 5.28125 10.8142Z"
          stroke={color}
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3477 16.3477L18.7198 18.7198"
          stroke={color}
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const LeftArrow = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M15 7L10 12L15 17"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const Reset = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M19.4243 5.07256L17.3033 7.19347L15.1823 9.31457L17.3033 11.4355L18.9788 9.76006C19.5116 11.118 19.6369 12.6017 19.3393 14.0297C19.0417 15.4577 18.3341 16.768 17.3033 17.8C16.2713 18.8295 14.9617 19.536 13.5346 19.8331C12.1075 20.1301 10.6248 20.0048 9.26776 19.4725L7.01026 21.73C8.99856 22.8047 11.2806 23.2091 13.5171 22.8832C15.7537 22.5573 17.8253 21.5184 19.4243 19.921C20.3994 18.9459 21.1729 17.7884 21.7006 16.5145C22.2284 15.2405 22.5 13.875 22.5 12.496C22.5 11.1171 22.2284 9.75158 21.7006 8.47759C21.1729 7.2036 20.3994 6.04759 19.4243 5.07256ZM16.9913 3.26348C15.0028 2.18841 12.7205 1.78381 10.4836 2.10973C8.24674 2.43566 6.17478 3.47478 4.57576 5.07256C3.60063 6.04759 2.82711 7.20507 2.29937 8.47906C1.77163 9.75305 1.5 11.1185 1.5 12.4975C1.5 13.8765 1.77163 15.2419 2.29937 16.5159C2.82711 17.7899 3.60063 18.9476 4.57576 19.9226L6.69676 17.8L8.81776 15.6789L6.69676 13.558L5.02126 15.2335C4.48842 13.8756 4.36313 12.3918 4.66072 10.9638C4.95831 9.53578 5.66587 8.2255 6.69676 7.19347C7.72872 6.16398 9.03833 5.45749 10.4654 5.16045C11.8925 4.86342 13.3752 4.98873 14.7323 5.52099L16.9913 3.26348Z"
          fill="#F8F9FC"
        />
      </svg>
    </React.Fragment>
  );
};

export const CashPendingAtPartner = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_36)">
          <path
            d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
            fill="#ff9900"
            fillOpacity="0.1"
          />
          <path
            d="M17.7 18C15.2 18 13.3 16 13.3 13.6V10C13.3 8.2 14.7 6.8 16.5 6.8H19C20.8 6.8 22.2 8.2 22.2 10V13.6C22.1 16 20.1 18 17.7 18ZM16.4 7.8C15.2 7.8 14.2 8.8 14.2 10V13.6C14.2 15.5 15.7 17 17.6 17H17.7C19.6 17 21.1 15.5 21.1 13.6V10C21.1 8.8 20.1 7.8 18.9 7.8H16.4Z"
            fill="#ff9900"
          />
          <path
            d="M13.8 14.2C13.1 14.2 12.6 13.7 12.6 13C12.6 12.3 13.1 11.8 13.8 11.8V12.3C13.4 12.3 13.1 12.6 13.1 13C13.1 13.4 13.4 13.7 13.8 13.7V14.2Z"
            fill="#ff9900"
          />
          <path
            d="M21.6 14.2V13.7C22 13.7 22.3 13.4 22.3 13C22.3 12.6 22 12.3 21.6 12.3V11.8C22.3 11.8 22.8 12.3 22.8 13C22.8 13.7 22.2 14.2 21.6 14.2Z"
            fill="#ff9900"
          />
          <path
            d="M14.1 12.4L13.5 11.6C14.2 11.1 15.7 10.2 17.8 10.2C19.8 10.2 21.2 11.1 21.9 11.6L21.3 12.4C20.7 12 19.5 11.2 17.8 11.2C16 11.1 14.7 11.9 14.1 12.4Z"
            fill="#ff9900"
          />
          <path
            d="M20.6 13.5C20.4 13.5 20.3 13.5 20.1 13.4C19.6 13.1 18.8 12.8 17.8 12.8C16.6 12.8 15.7 13.1 15.1 13.4C14.7 13.6 14.2 13.5 13.9 13.2L13.3 12.6L14 11.9L14.6 12.5C15.3 12.2 16.4 11.7 17.8 11.8C18.7 11.8 19.6 12.1 20.5 12.5L21.2 11.9L21.9 12.6L21.2 13.2C21 13.4 20.8 13.5 20.6 13.5Z"
            fill="#ff9900"
          />
          <path
            d="M17.5 19.7C15.9 19.7 15 18.7 14.9 18.5L14.8 18.4V16.7H15.8V18C16 18.2 16.7 18.8 17.6 18.7C18.5 18.7 19.1 18.2 19.3 18V16.9H20.3V18.3L20.2 18.4C20 18.6 19.1 19.7 17.5 19.7Z"
            fill="#ff9900"
          />
          <path
            d="M9.70001 20.3L8.70001 20.1C9.10001 17.8 12 17.7 12.1 17.7H15.3V18.7H12.1C12.1 18.7 9.90001 18.8 9.70001 20.3Z"
            fill="#ff9900"
          />
          <path
            d="M25.3 20.3C25.1 18.8 22.9 18.8 22.9 18.8H19.8V17.8H23C23.1 17.8 26 17.9 26.4 20.2L25.3 20.3Z"
            fill="#ff9900"
          />
          <path
            d="M26 29.2H9C8.4 29.2 8 28.7 8 28.2V25.2H9V28.2H26V25.2H27V28.2C27 28.7 26.6 29.2 26 29.2Z"
            fill="#ff9900"
          />
          <path
            d="M26.9 22H26.2V20.7C26.2 20.6 26.1 20.5 26 20.5H8.99998C8.89998 20.5 8.79998 20.6 8.79998 20.7V22H8.09998V20.7C8.09998 20.2 8.49998 19.8 8.99998 19.8H26C26.5 19.8 26.9 20.2 26.9 20.7V22Z"
            fill="#ff9900"
          />
          <path
            d="M10.1 22.4L9.70001 21.8C10.2 21.4 10.5 20.8 10.5 20.2H11.2C11.2 21.1 10.8 21.9 10.1 22.4Z"
            fill="#ff9900"
          />
          <path
            d="M24.9 22.4C24.2 21.9 23.8 21.1 23.8 20.2H24.5C24.5 20.8 24.8 21.4 25.3 21.8L24.9 22.4Z"
            fill="#ff9900"
          />
          <path
            d="M11.2 28.7H10.5C10.5 27.6 9.6 26.7 8.5 26.7V26C10 25.9 11.2 27.2 11.2 28.7Z"
            fill="#ff9900"
          />
          <path
            d="M24.5 28.7H23.8C23.8 27.2 25 25.9 26.6 25.9V26.6C25.4 26.7 24.5 27.6 24.5 28.7Z"
            fill="#ff9900"
          />
          <path
            d="M8.4 25.6C7.9 25.6 7 25.4 7 23.7C7 22 7.9 21.8 8.4 21.8C8.5 21.8 8.6 21.9 8.6 22C8.6 22.1 8.5 22.2 8.4 22.2C8.2 22.2 7.5 22.2 7.5 23.6C7.5 25 8.2 25 8.4 25C8.5 25 8.6 25.1 8.6 25.2C8.6 25.4 8.5 25.6 8.4 25.6Z"
            fill="#ff9900"
          />
          <path
            d="M9.60001 23.1H8.80001C8.70001 23.1 8.60001 23 8.60001 22.9C8.60001 22.8 8.70001 22.7 8.80001 22.7H9.60001C9.70001 22.7 9.80001 22.6 9.80001 22.5C9.80001 22.4 9.70001 22.3 9.60001 22.3H8.40001C8.30001 22.3 8.20001 22.2 8.20001 22.1C8.20001 22 8.30001 21.9 8.40001 21.9H9.60001C10 21.9 10.3 22.2 10.3 22.6C10.3 22.8 10 23.1 9.60001 23.1Z"
            fill="#ff9900"
          />
          <path
            d="M9.89997 23.9H8.79998C8.69998 23.9 8.59998 23.8 8.59998 23.7C8.59998 23.6 8.69998 23.5 8.79998 23.5H9.89997C9.99997 23.5 10.1 23.4 10.1 23.3C10.1 23.2 9.99997 23.1 9.89997 23.1H8.79998C8.69998 23.1 8.59998 23 8.59998 22.9C8.59998 22.8 8.69998 22.7 8.79998 22.7H9.89997C10.3 22.7 10.6 23 10.6 23.4C10.5 23.6 10.2 23.9 9.89997 23.9Z"
            fill="#ff9900"
          />
          <path
            d="M9.69998 24.7H8.79998C8.69998 24.7 8.59998 24.6 8.59998 24.5C8.59998 24.4 8.69998 24.3 8.79998 24.3H9.69998C9.79998 24.3 9.89997 24.2 9.89997 24.1C9.89997 24 9.79998 23.9 9.69998 23.9H8.79998C8.69998 23.9 8.59998 23.8 8.59998 23.7C8.59998 23.6 8.69998 23.5 8.79998 23.5H9.69998C10.1 23.5 10.4 23.8 10.4 24.2C10.4 24.4 10.1 24.7 9.69998 24.7Z"
            fill="#ff9900"
          />
          <path
            d="M9.59998 25.6H8.29998C8.19998 25.6 8.09998 25.5 8.09998 25.4C8.09998 25.3 8.19998 25.2 8.29998 25.2H9.59998C9.69998 25.2 9.79998 25.1 9.79998 25C9.79998 24.9 9.69998 24.8 9.59998 24.8H8.79998C8.69998 24.8 8.59998 24.7 8.59998 24.6C8.59998 24.5 8.69998 24.4 8.79998 24.4H9.49998C9.89998 24.4 10.2 24.7 10.2 25.1C10.2 25.3 9.89998 25.6 9.59998 25.6Z"
            fill="#ff9900"
          />
          <path
            d="M26.6 25.6C26.5 25.6 26.4 25.5 26.4 25.4C26.4 25.3 26.5 25.2 26.6 25.2C26.8 25.2 27.5 25.2 27.5 23.8C27.5 22.4 26.9 22.4 26.6 22.4C26.5 22.4 26.4 22.3 26.4 22.2C26.4 22.1 26.5 22 26.6 22C27.2 22 28 22.3 28 23.9C28 25.2 27.3 25.6 26.6 25.6Z"
            fill="#ff9900"
          />
          <path
            d="M26.2 23.1H25.4C25 23.1 24.7 22.8 24.7 22.4C24.7 22 25 21.7 25.4 21.7H26.6C26.7 21.7 26.8 21.8 26.8 21.9C26.8 22 26.7 22.1 26.6 22.1H25.4C25.3 22.1 25.2 22.2 25.2 22.3C25.2 22.4 25.3 22.5 25.4 22.5H26.2C26.3 22.5 26.4 22.6 26.4 22.7C26.4 22.8 26.4 23.1 26.2 23.1Z"
            fill="#ff9900"
          />
          <path
            d="M26.2 23.9H25.1C24.7 23.9 24.4 23.6 24.4 23.2C24.4 22.8 24.7 22.5 25.1 22.5H26.2C26.3 22.5 26.4 22.6 26.4 22.7C26.4 22.8 26.3 22.9 26.2 22.9H25.1C25 22.9 24.9 23 24.9 23.1C24.9 23.2 25 23.3 25.1 23.3H26.2C26.3 23.3 26.4 23.4 26.4 23.5C26.4 23.6 26.4 23.9 26.2 23.9Z"
            fill="#ff9900"
          />
          <path
            d="M26.2 24.7H25.3C24.9 24.7 24.6 24.4 24.6 24C24.6 23.6 24.9 23.3 25.3 23.3H26.2C26.3 23.3 26.4 23.4 26.4 23.5C26.4 23.6 26.3 23.7 26.2 23.7H25.3C25.2 23.7 25.1 23.8 25.1 23.9C25.1 24 25.2 24.1 25.3 24.1H26.2C26.3 24.1 26.4 24.2 26.4 24.3C26.4 24.4 26.4 24.7 26.2 24.7Z"
            fill="#ff9900"
          />
          <path
            d="M26.7 25.6H25.4C25 25.6 24.7 25.3 24.7 24.9C24.7 24.5 25 24.2 25.4 24.2H26.1C26.2 24.2 26.3 24.3 26.3 24.4C26.3 24.5 26.2 24.6 26.1 24.6H25.4C25.3 24.6 25.2 24.7 25.2 24.8C25.2 24.9 25.3 25 25.4 25H26.7C26.8 25 26.9 25.1 26.9 25.2C26.9 25.3 26.8 25.6 26.7 25.6Z"
            fill="#ff9900"
          />
          <path
            d="M15.5 22.3H18.2V22.9V23H15.5V23.7H18.1C18.1 24 18 24.1 17.8 24.3C17.7 24.4 17.4 24.5 17.2 24.5C16.9 24.5 16.5 24.6 15.8 24.6V25.7C15.8 26.3 15.9 26.7 16.2 27C16.5 27.3 16.9 27.5 17.5 27.5C18.1 27.5 18.5 27.4 18.8 27.1C19.1 26.8 19.2 26.4 19.3 25.8H18.4C18.4 26.4 18.1 26.8 17.6 26.8C17.3 26.8 17.1 26.7 16.9 26.5C16.8 26.3 16.7 26.1 16.7 25.8V25.3C17.2 25.3 17.6 25.3 17.9 25.2C18.2 25.1 18.5 24.9 18.6 24.7C18.8 24.5 18.9 24.2 18.9 23.8H19.9V23.1H18.9V23V22.4H19.9V21.7H15.4V22.3H15.5Z"
            fill="#ff9900"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_36">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const PODPending = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_114)">
          <path
            d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
            fill="#ff9900"
            fillOpacity="0.1"
          />
          <path
            d="M29.2 22.4H26.5C25.8 22.4 25.3 21.8 25.3 21.2V15C25.3 14.3 25.9 13.8 26.5 13.8H29.2C29.9 13.8 30.4 14.4 30.4 15V21.2C30.5 21.8 29.9 22.4 29.2 22.4ZM26.5 21.1H29.2V14.9H26.5V21.1Z"
            fill="#ff9900"
          />
          <path
            d="M14.7 15.5L13.8 14.6L16.7 11.7C18.8 9.80001 21.4 11.1 21.6 11.1H21.7L26.4 13.9L25.8 15L21 12.3C20.8 12.2 18.9 11.4 17.5 12.7L14.7 15.5Z"
            fill="#ff9900"
          />
          <path
            d="M21.9 23.2C21.5 23.2 21 23.1 20.5 22.8L15.6 19.8C15 19.4 14.1 18.3 14.9 16.9C15.4 16 15.9 15.9 16.1 15.8L16.4 17C16.4 17 16.2 17.1 15.9 17.5C15.5 18.1 16 18.6 16.2 18.7L21.1 21.7C21.9 22.3 22.8 21.6 22.8 21.6H22.9L25.5 20L26.2 21.1L23.6 22.7C23.5 22.7 22.8 23.2 21.9 23.2Z"
            fill="#ff9900"
          />
          <path
            d="M17.1 25.3L4.5 17.4L8.5 10.9L21 18.6L20.5 19.5L8.8 12.3L5.9 17L16.8 23.9L18.9 20.9L19.7 21.5L17.1 25.3Z"
            fill="#ff9900"
          />
          <path
            d="M27.7 20.3C27.3 20.3 27 20 27 19.6C27 19.2 27.3 18.9 27.7 18.9C28.1 18.9 28.4 19.2 28.4 19.6C28.4 20 28.1 20.3 27.7 20.3ZM27.7 19.1C27.4 19.1 27.1 19.4 27.1 19.7C27.1 20 27.4 20.3 27.7 20.3C28 20.3 28.3 20 28.3 19.7C28.3 19.3 28 19.1 27.7 19.1Z"
            fill="#ff9900"
          />
          <path
            d="M12.8 20C11.8 20 11.1 19.2 11.1 18.3C11.1 17.3 11.9 16.6 12.8 16.6C13.7 16.6 14.5 17.4 14.5 18.3C14.5 19.2 13.7 20 12.8 20ZM12.8 17C12.1 17 11.6 17.6 11.6 18.2C11.6 18.8 12.2 19.4 12.8 19.4C13.4 19.4 14 18.8 14 18.2C14 17.6 13.5 17 12.8 17Z"
            fill="#ff9900"
          />
          <path
            d="M7.20001 18.4L6.70001 18.2C6.80001 17.9 7.00001 17.5 6.90001 16.9C6.80001 16.2 6.30001 15.7 6.20001 15.6L6.50001 15.2C6.80001 15.4 7.30001 16 7.40001 16.8C7.50001 17.5 7.30001 18.1 7.20001 18.4Z"
            fill="#ff9900"
          />
          <path
            d="M15.3 23.6L15 23.2C15.3 22.9 15.8 22.5 16.7 22.4C17.4 22.3 17.9 22.5 18.2 22.7L18 23.1C17.7 23 17.3 22.8 16.8 22.9C16 23 15.5 23.4 15.3 23.6Z"
            fill="#ff9900"
          />
          <path
            d="M8.79998 13.8C8.29998 13.8 7.79998 13.6 7.59998 13.5L7.79998 13.1C7.99998 13.1 8.49998 13.3 8.99998 13.2C9.69998 13.1 10.1 12.7 10.2 12.5L10.6 12.8C10.4 13 9.89998 13.5 9.09998 13.7C8.99998 13.7 8.89998 13.8 8.79998 13.8Z"
            fill="#ff9900"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_114">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const PendingForRefund = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_141)">
          <path
            d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
            fill="#ff9900"
            fillOpacity="0.1"
          />
          <path
            d="M21.2 14.3V14.4H22.2V15.1H21.2C21.1 15.5 21 15.8 20.9 16C20.7 16.2 20.5 16.4 20.2 16.5C19.9 16.6 19.5 16.6 19 16.6V17.1C19 17.4 19.1 17.6 19.2 17.8C19.3 18 19.6 18.1 19.9 18.1C20.5 18.1 20.8 17.8 20.8 17.1H21.7C21.7 17.7 21.5 18.1 21.2 18.4C20.9 18.7 20.5 18.8 19.9 18.8C19.3 18.8 18.9 18.6 18.6 18.3C18.3 18 18.2 17.6 18.2 17V15.9C18.8 15.9 19.3 15.9 19.6 15.8C19.9 15.8 20.1 15.7 20.2 15.6C20.3 15.5 20.4 15.3 20.5 15H17.9V14.3H20.6V14.2V13.6H17.9V12.9H22.4V13.6H21.4V14.3H21.2Z"
            fill="#ff9900"
          />
          <path
            d="M26.9 26.8H23V17.9H26.9V26.8ZM24.1 25.7H25.8V19H24.1V25.7Z"
            fill="#ff9900"
          />
          <path
            d="M23.5 25.9H14.7L8.89997 21.9C8.49997 21.6 8.19997 21.2 8.09997 20.6C7.99997 20.1 8.09997 19.6 8.49997 19.1C9.09997 18.3 10.2 18.1 11.1 18.6L16.1 21.8H17.3C16.9 21.2 16.9 20.4 16.9 19.9L17 19.5H23.5V20.6H18C18 21.1 18.3 21.7 19.1 21.9H20.8V23H15.7L10.4 19.6C9.99997 19.4 9.59997 19.5 9.29997 19.8C9.19997 20 9.09997 20.2 9.19997 20.4C9.29997 20.6 9.39997 20.8 9.49997 20.9L15 24.7H23.5V25.9Z"
            fill="#ff9900"
          />
          <path
            d="M11.4 14.7C11.9 16.3 13.5 17.3 15.2 17.1L15 16.3L17.3 17L15.6 18.7L15.4 17.9C15.2 17.9 14.9 18 14.7 18C12.1 18 9.99997 15.7 10.3 12.9C10.6 11.1 11.9 9.6 13.7 9.3C15.6 8.9 17.5 9.8 18.5 11.4C18.6 11.6 18.5 11.9 18.3 12C18.1 12.1 17.8 12 17.7 11.8C17.1 10.7 15.9 10 14.7 10C12.4 10 10.6 12.3 11.4 14.7Z"
            fill="#ff9900"
          />
          <path
            d="M13.4 14.9C13.2 14.7 13.2 14.4 13.4 14.3L14.1 13.6C14.2 13.5 14.2 13.4 14.2 13.3V11.7C14.2 11.5 14.4 11.3 14.6 11.3C14.8 11.3 15 11.5 15 11.7V13.7C15 13.8 15 13.9 14.9 14L14 14.9C13.9 15.1 13.6 15.1 13.4 14.9Z"
            fill="#ff9900"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_141">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const Refund = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_156)">
          <path
            d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
            fill="#F56221"
            fillOpacity="0.1"
          />
          <path
            d="M19.2 11.5V11.6H20.4V12.5H19.1C19 13 18.9 13.4 18.7 13.6C18.5 13.9 18.2 14.1 17.8 14.2C17.4 14.3 16.9 14.4 16.3 14.4V15.1C16.3 15.5 16.4 15.8 16.6 16C16.8 16.2 17 16.3 17.4 16.3C18.1 16.3 18.5 15.9 18.5 15.1H19.6C19.6 15.8 19.4 16.4 19 16.7C18.6 17.1 18.1 17.2 17.4 17.2C16.7 17.2 16.1 17 15.8 16.6C15.4 16.2 15.2 15.6 15.2 14.9V13.4C16 13.4 16.6 13.4 16.9 13.3C17.3 13.3 17.5 13.2 17.7 13C17.9 12.9 18 12.6 18.1 12.3H14.7V11.4H18V11.5V10.7H14.6V9.8H20.4V10.7H19.2V11.5Z"
            fill="#F56221"
          />
          <path
            d="M27.5 26.2H23.3V16.7H27.5V26.2ZM24.5 25H26.3V17.8H24.5V25Z"
            fill="#F56221"
          />
          <path
            d="M23.9 25.2H14.5L8.30002 20.9C7.80002 20.6 7.50002 20.1 7.40002 19.5C7.30002 18.9 7.40002 18.4 7.80002 17.9C8.40002 17 9.60002 16.8 10.6 17.4L15.9 20.8H17.2C16.8 20.1 16.7 19.3 16.8 18.8L16.9 18.3H23.9V19.5H18.1C18.2 20 18.4 20.7 19.3 20.9H21.1V22.1H15.7L10 18.5C9.60002 18.3 9.10002 18.3 8.90002 18.7C8.80002 18.9 8.70002 19.1 8.70002 19.3C8.70002 19.5 8.90002 19.7 9.10002 19.9L15 24H24V25.2H23.9Z"
            fill="#F56221"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_156">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const DeliveryPending = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_92)">
          <path
            d="M9.9 0.5H24.9C30.4 0.5 34.9 5 34.9 10.5V25.5C34.9 31 30.4 35.5 24.9 35.5H9.9C4.4 35.5 0 31 0 25.5V10.5C0 5 4.4 0.5 9.9 0.5Z"
            fill="#ff9900"
            fillOpacity="0.1"
          />
          <path
            d="M10.8 24.4H8.49998C7.69998 24.4 7.09998 23.8 7.09998 23V12.4C7.09998 11.6 7.69998 11 8.49998 11H9.59998C9.89998 11 10.2 11.3 10.2 11.6C10.2 11.9 9.89998 12.2 9.59998 12.2H8.49998C8.39998 12.2 8.29998 12.3 8.29998 12.4V23C8.29998 23.1 8.39998 23.2 8.49998 23.2H10.8C11.1 23.2 11.4 23.5 11.4 23.8C11.4 24.2 11.1 24.4 10.8 24.4Z"
            fill="#ff9900"
          />
          <path
            d="M21.2 24.4H14.6C14.3 24.4 14 24.1 14 23.8C14 23.5 14.3 23.2 14.6 23.2H21.2C21.3 23.2 21.4 23.1 21.4 23V12.4C21.4 12.3 21.3 12.2 21.2 12.2H19.9C19.6 12.2 19.3 11.9 19.3 11.6C19.3 11.3 19.6 11 19.9 11H21.2C22 11 22.6 11.6 22.6 12.4V23C22.6 23.8 22 24.4 21.2 24.4Z"
            fill="#ff9900"
          />
          <path
            d="M28.1 24.4H26.6V23.2H27.9V18.5C27.8 18.3 27.3 17.6 26.4 16.6C25.5 15.7 24.7 15.2 24.5 15.1H22.6V23.2H23.3V24.4H22.4C21.8 24.4 21.4 23.9 21.4 23.4V14.9C21.4 14.3 21.9 13.9 22.4 13.9H24.5C25 13.9 25.9 14.5 27.2 15.8C28.5 17.1 29.1 18 29.1 18.5V23.4C29.2 24 28.7 24.4 28.1 24.4Z"
            fill="#ff9900"
          />
          <path
            d="M12.6 25.9C11.4 25.9 10.5 25 10.5 23.8C10.5 22.6 11.4 21.7 12.6 21.7C13.8 21.7 14.7 22.6 14.7 23.8C14.7 25 13.8 25.9 12.6 25.9ZM12.6 22.7C12 22.7 11.4 23.2 11.4 23.9C11.4 24.5 11.9 25.1 12.6 25.1C13.2 25.1 13.8 24.6 13.8 23.9C13.8 23.2 13.2 22.7 12.6 22.7Z"
            fill="#ff9900"
          />
          <path
            d="M25 25.9C23.8 25.9 22.9 25 22.9 23.8C22.9 22.6 23.8 21.7 25 21.7C26.2 21.7 27.1 22.6 27.1 23.8C27.1 25 26.1 25.9 25 25.9ZM25 22.7C24.4 22.7 23.8 23.2 23.8 23.9C23.8 24.5 24.3 25.1 25 25.1C25.7 25.1 26.2 24.6 26.2 23.9C26.1 23.2 25.6 22.7 25 22.7Z"
            fill="#ff9900"
          />
          <path
            d="M28.5 19H24.7V17.5C24.7 16.7 25.4 16 26.2 16H26.9V16.5H26.2C25.7 16.5 25.2 16.9 25.2 17.5V18.5H28.5V19Z"
            fill="#ff9900"
          />
          <path
            d="M28.5 22H26.6V20.2H28.5V20.8H27.2V21.4H28.5V22Z"
            fill="#ff9900"
          />
          <path
            d="M14.8 20.7C11.8 20.7 9.40002 18.3 9.40002 15.3C9.40002 12.3 11.8 9.89999 14.8 9.89999C17.8 9.89999 20.2 12.3 20.2 15.3C20.2 18.3 17.8 20.7 14.8 20.7ZM14.8 11.3C12.5 11.3 10.7 13.1 10.7 15.4C10.7 17.7 12.5 19.5 14.8 19.5C17.1 19.5 18.9 17.7 18.9 15.4C18.9 13.1 17.1 11.3 14.8 11.3Z"
            fill="#ff9900"
          />
          <path
            d="M16.8 17.8C16.7 17.8 16.6 17.8 16.6 17.7L14.5 16V12.4C14.5 12.2 14.7 12 14.9 12C15.1 12 15.3 12.2 15.3 12.4V15.7L17.1 17.2C17.3 17.3 17.3 17.6 17.2 17.7C17 17.8 16.9 17.8 16.8 17.8Z"
            fill="#ff9900"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_92">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const CashPendingAtCollector = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_2)">
          <g opacity="0.1">
            <path
              d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 4.9 4.5 0.5 10 0.5Z"
              fill="#ff9900"
            />
          </g>
          <path
            d="M13.3 27.2H9.29999V23.2H13.3V27.2ZM10.5 25.9H12V24.4H10.5V25.9Z"
            fill="#ff9900"
          />
          <path
            d="M21.7 17.8C19.7 17.8 18 16.4 17.5 14.5C17.4 14.2 17.4 14 17.4 13.7V11.4C17.5 9.1 19.4 7.3 21.7 7.3C24 7.3 25.9 9.1 26 11.4C26 11.5 26 11.5 26 11.6V13.6C26 13.9 26 14.3 25.9 14.6C25.4 16.4 23.7 17.8 21.7 17.8ZM21.7 8.4C20 8.4 18.7 9.7 18.6 11.4V13.7C18.6 13.9 18.6 14.1 18.7 14.3C19 15.7 20.3 16.7 21.7 16.7C23.1 16.7 24.4 15.7 24.7 14.3C24.8 14.1 24.8 13.8 24.8 13.6V11.6V11.5C24.8 9.7 23.4 8.4 21.7 8.4Z"
            fill="#ff9900"
          />
          <path
            d="M17.6 13.8C17.1 13.8 16.7 13.4 16.7 12.9V12.2C16.7 11.7 17.1 11.3 17.6 11.3C18.1 11.3 18.5 11.7 18.5 12.2V12.9C18.5 13.4 18.1 13.8 17.6 13.8Z"
            fill="#ff9900"
          />
          <path
            d="M25.9 13.8C25.4 13.8 25 13.4 25 12.9V12.2C25 11.7 25.4 11.3 25.9 11.3C26.4 11.3 26.8 11.7 26.8 12.2V12.9C26.7 13.4 26.3 13.8 25.9 13.8Z"
            fill="#ff9900"
          />
          <path
            d="M31.4 27.4H22.9C22.3 27.4 21.8 27.2 21.4 26.8C21 26.4 20.9 25.8 20.9 25.2C21 23.9 22.1 23.4 22.7 23.4H25.2V22.5H26.4V24.5H22.8C22.6 24.5 22.2 24.6 22.1 25.2C22.1 25.5 22.1 25.7 22.3 25.9C22.4 26.1 22.7 26.1 22.9 26.1H31.4V27.4Z"
            fill="#ff9900"
          />
          <path
            d="M30.2 26.8H29V22.6L28 20.5L24.9 19.1L22.9 21.5C22.7 21.7 22.4 21.8 22.2 21.7C21.9 21.6 21.8 21.4 21.8 21.1V20.3H21.6V21.2C21.6 21.5 21.4 21.7 21.2 21.8C21 21.9 20.7 21.8 20.5 21.7L18 19.2L18.8 18.4L20.4 20V19.9C20.4 19.5 20.8 19.1 21.2 19.1H22.1C22.5 19.1 22.8 19.4 22.9 19.7L24.6 17.6L28.9 19.5L30.1 22.2V26.8H30.2Z"
            fill="#ff9900"
          />
          <path d="M22.4 19H21.1L20.6 17.9H23L22.4 19Z" fill="#ff9900" />
          <path
            d="M17.3 24.4H5.39999C4.49999 24.4 3.79999 23.7 3.79999 22.8V15.8C3.79999 14.9 4.49999 14.2 5.39999 14.2H17.3C18.2 14.2 18.9 14.9 18.9 15.8V22.8C18.9 23.7 18.1 24.4 17.3 24.4ZM5.39999 15.3C5.09999 15.3 4.99999 15.5 4.99999 15.8V22.8C4.99999 23 5.19999 23.2 5.39999 23.2H17.3C17.5 23.2 17.7 23 17.7 22.8V15.8C17.7 15.6 17.5 15.4 17.3 15.4H5.39999V15.3Z"
            fill="#ff9900"
          />
          <path d="M29.2 26.2H3.59998V27.4H29.2V26.2Z" fill="#ff9900" />
          <path
            d="M12.9 16.9V17.6H13.9V18.5H12.9C12.8 19.1 12.5 19.5 12.1 19.8C11.7 20.1 11.1 20.2 10.3 20.2V20.7C10.3 21 10.4 21.2 10.5 21.4C10.6 21.6 10.8 21.7 11.1 21.7C11.4 21.7 11.6 21.6 11.7 21.5C11.8 21.3 11.9 21.1 11.9 20.8H13.1C13.1 21.4 12.9 21.9 12.6 22.3C12.2 22.6 11.7 22.8 11.1 22.8C10.4 22.8 9.89995 22.6 9.49995 22.3C9.19995 21.9 8.99995 21.4 8.99995 20.7V19.4C9.69995 19.4 10.2 19.4 10.5 19.3C10.8 19.3 11.1 19.2 11.2 19.1C11.4 19 11.5 18.8 11.5 18.5H8.69995V17.6H11.6V16.9H8.69995V16H13.8V16.9H12.9Z"
            fill="#ff9900"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_2">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const Received = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_218)">
          <path
            d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
            fill="#34a853"
            fillOpacity="0.1"
          />
          <path
            d="M31.2001 13.8C31.0001 11.4 29 9.40001 26.6 9.20001C24.2 9.00001 22.1 10.4 21.3 12.5H6.00005C5.60005 12.5 5.30005 12.8 5.30005 13.2V25.7C5.30005 26.1 5.60005 26.4 6.00005 26.4H27.2001C27.6001 26.4 27.9 26.1 27.9 25.7V19.2C30 18.3 31.5001 16.2 31.2001 13.8ZM8.90005 13.4C8.90005 13.8 8.90005 14.5 8.50005 15.2C8.00005 15.9 7.20005 16.3 6.30005 16.3V14.2C6.30005 13.8 6.60005 13.5 7.00005 13.5H8.90005V13.4ZM6.30005 22.5C7.20005 22.5 8.00005 22.9 8.50005 23.6C9.00005 24.2 9.00005 24.9 8.90005 25.4H7.00005C6.60005 25.4 6.30005 25.1 6.30005 24.7V22.5ZM24.6 25.4C24.6 25 24.6 24.3 25 23.6C25.4 23 26.2 22.6 27 22.6V24.7C27 25.1 26.7 25.4 26.3 25.4H24.6ZM27 21.5C25.9 21.5 24.9001 22.1 24.2001 23C23.6001 23.8 23.5 24.7 23.6 25.4H9.90005C10 24.8 9.90005 23.9 9.30005 23C8.60005 22.1 7.50005 21.5 6.30005 21.5V17.2C6.30005 17.2 6.30005 17.2 6.40005 17.2C7.60005 17.2 8.70005 16.7 9.30005 15.7C9.90005 14.9 10 14 9.90005 13.3H21C20.9 13.6 20.9 13.9 20.9 14.2C20.9 17.1 23.2 19.4 26.1 19.4C26.4 19.4 26.7 19.4 27 19.3V21.5ZM26.1 18.5C23.8 18.5 21.9 16.6 21.9 14.3C21.9 12 23.8 10.1 26.1 10.1C28.4 10.1 30.3 12 30.3 14.3C30.3 16.6 28.4 18.5 26.1 18.5Z"
            fill="#34a853"
          />
          <path
            d="M13.8001 16.8H17.2001V17.6V17.7H13.8001V18.6H17.2001C17.1001 18.9 17.0001 19.2 16.8001 19.3C16.6001 19.4 16.3001 19.5 16.0001 19.6C15.6001 19.6 15.1001 19.7 14.3001 19.7V21.2C14.3001 21.9 14.5001 22.5 14.9001 22.9C15.3001 23.3 15.8001 23.5 16.5001 23.5C17.2001 23.5 17.8001 23.3 18.1001 23C18.5001 22.6 18.7001 22.1 18.7001 21.4H17.6001C17.6001 22.2 17.2001 22.6 16.5001 22.6C16.1001 22.6 15.8001 22.5 15.7001 22.3C15.5001 22.1 15.4001 21.8 15.4001 21.4V20.7C16.0001 20.7 16.5001 20.6 16.9001 20.5C17.3001 20.4 17.6001 20.2 17.8001 19.9C18.0001 19.6 18.2001 19.2 18.2001 18.8H19.5001V17.9H18.3001V17.8V17H19.5001V16.1H13.7001V16.8H13.8001Z"
            fill="#34a853"
          />
          <path
            d="M29.3001 12.9C29.2001 12.7 28.9001 12.6 28.6001 12.7C26.9001 13.5 25.7001 14.8 25.1001 15.6L24.0001 13.4C23.9001 13.2 23.6001 13 23.3001 13.2C23.1001 13.3 22.9001 13.6 23.1001 13.9L24.5001 16.9C24.6001 17.1 24.7001 17.2 24.9001 17.2C25.1001 17.2 25.2001 17.1 25.3001 17C25.3001 17 26.6001 14.9 28.9001 13.8C29.3001 13.5 29.4001 13.2 29.3001 12.9Z"
            fill="#34a853"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_218">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const Upload = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_183)">
          <path
            d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
            fill="#34a853"
            fillOpacity="0.1"
          />
          <path
            d="M23.7 27H10.8C9.69995 27 8.69995 26.1 8.69995 24.9V18C8.69995 16.9 9.59995 15.9 10.8 15.9H13.3C13.6 15.9 13.9 16.2 13.9 16.5C13.9 16.8 13.6 17.1 13.3 17.1H10.8C10.3 17.1 9.99995 17.5 9.99995 17.9V24.8C9.99995 25.3 10.4 25.6 10.8 25.6H23.7C24.2 25.6 24.5 25.2 24.5 24.8V17.9C24.5 17.4 24.1 17.1 23.7 17.1H21.2C20.9 17.1 20.6 16.8 20.6 16.5C20.6 16.2 20.9 15.9 21.2 15.9H23.7C24.8 15.9 25.7999 16.8 25.7999 18V24.9C25.7999 26 24.8 27 23.7 27Z"
            fill="#34a853"
          />
          <path
            d="M17.2 21.8C16.9 21.8 16.6 21.5 16.6 21.2V9.6C16.6 9.3 16.9 9 17.2 9C17.5 9 17.8 9.3 17.8 9.6V21.1C17.9 21.5 17.6 21.8 17.2 21.8Z"
            fill="#34a853"
          />
          <path
            d="M12.6999 13.9C12.4999 13.9 12.2999 13.8 12.1999 13.7C11.9999 13.4 11.9999 13 12.2999 12.8L16.8999 9.2C17.1999 9 17.5999 9 17.7999 9.3C17.9999 9.6 17.9999 10 17.6999 10.2L13.0999 13.8C12.8999 13.9 12.7999 13.9 12.6999 13.9Z"
            fill="#34a853"
          />
          <path
            d="M21.7999 13.9C21.6999 13.9 21.4999 13.9 21.3999 13.8L16.7999 10.2C16.4999 10 16.4999 9.6 16.6999 9.3C16.8999 9 17.2999 9 17.5999 9.2L22.1999 12.8C22.4999 13 22.4999 13.4 22.2999 13.7C22.1999 13.8 21.9999 13.9 21.7999 13.9Z"
            fill="#34a853"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_183">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const ReUpload = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_165)">
          <path
            d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
            fill="#34a853"
            fillOpacity="0.1"
          />
          <path
            d="M17.6 23.2C17.3 23.2 17.1 23 17.1 22.7V13C17.1 12.7 17.3 12.5 17.6 12.5C17.9 12.5 18.1 12.7 18.1 13V22.7C18.1 23 17.9 23.2 17.6 23.2Z"
            fill="#34a853"
          />
          <path
            d="M13.7 16.6C13.5 16.6 13.4 16.5 13.3 16.4C13.1 16.2 13.2 15.8 13.4 15.7L17.2 12.6C17.4 12.4 17.8 12.5 17.9 12.7C18.1 12.9 18 13.3 17.8 13.4L14.1 16.5C14 16.6 13.9 16.6 13.7 16.6Z"
            fill="#34a853"
          />
          <path
            d="M21.4 16.6C21.3 16.6 21.2 16.6 21.1 16.5L17.3 13.4C17.1 13.2 17 12.9 17.2 12.7C17.4 12.5 17.7 12.4 17.9 12.6L21.7 15.7C21.9 15.9 22 16.2 21.8 16.4C21.7 16.5 21.6 16.6 21.4 16.6Z"
            fill="#34a853"
          />
          <path
            d="M28.5 19.9L24.4 23.1L23.7 18L25.5 18.7C25.7 16.4 24.9 14.1 23.2 12.4C21.7 10.9 19.7 10.1 17.6 10.1C15.5 10.1 13.5 10.9 12 12.4C10.5 13.9 9.7 15.9 9.7 18C9.7 20.1 10.5 22.1 12 23.6C14.8 26.4 19.2 26.7 22.4 24.4C22.6 24.2 23 24.3 23.2 24.5C23.4 24.7 23.3 25.1 23.1 25.3C21.5 26.5 19.6 27.1 17.7 27.1C15.4 27.1 13 26.2 11.2 24.4C9.5 22.7 8.5 20.4 8.5 18C8.5 15.6 9.4 13.3 11.1 11.6C12.8 9.9 15.1 9 17.5 9C19.9 9 22.2 10 23.9 11.7C25.9 13.7 26.8 16.5 26.5 19.3L28.5 19.9Z"
            fill="#34a853"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_165">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const OrderReturn = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <g clipPath="url(#clip0_1001_209)">
          <path
            d="M10 0H25C30.5 0 35 4.5 35 10V25C35 30.5 30.5 35 25 35H10C4.5 35 0 30.5 0 25V10C0 4.5 4.5 0 10 0Z"
            fill="#ED1C24"
            fillOpacity="0.1"
          />
          <path
            d="M26.2 23.6C25.9 23.6 25.6 23.9 25.6 24.2V25.3H10.1V22.5C10.1 22.2 9.79996 21.9 9.49996 21.9C9.19996 21.9 8.89996 22.2 8.89996 22.5V25.9C8.89996 26.2 9.19996 26.5 9.49996 26.5H26.2C26.5 26.5 26.7 26.2 26.8 25.9V24.2C26.8 23.9 26.5 23.6 26.2 23.6Z"
            fill="#EF4142"
          />
          <path
            d="M28.8 17.5C28 16.6 26.8 16.6 26.7 16.6V13.7C26.7 13.6 26.7 13.5 26.6 13.4L24.8 9.8C24.7 9.6 24.5 9.5 24.3 9.5H11.2C11 9.5 10.8 9.6 10.8 9.9L9.09999 13.3C8.99999 13.4 8.89999 13.5 8.89999 13.7V18.6C8.89999 18.9 9.19999 19.2 9.49999 19.2C9.79999 19.2 9.99999 19 9.99999 18.6V14.4H15.2V17.9L17.9 16.7L20.6 17.9V14.3H25.6V20.6C25.6 20.9 25.9 21.2 26.2 21.2C26.5 21.2 26.7 21 26.7 20.6V17.8C26.7 17.8 27.5 17.8 27.9 18.3C28.2 18.7 28.3 19.3 28.1 20.1C28 21 27.1 21.5 26.4 21.8C22.4 23.4 13.6 22.6 6.89999 18.7L8.09999 17L2.79999 16.4L4.99999 21.3L6.19999 19.6C11 22.4 16.7 23.8 21.3 23.8C23.5 23.8 25.5 23.4 26.9 22.8C28.6 22.1 29.1 21 29.3 20.3C29.5 19.1 29.4 18.2 28.8 17.5ZM11.6 10.7H15.8L15.3 13.1H15.2H10.4L11.6 10.7ZM20 17L17.9 16.1L15.8 17V13.8L16.4 10.7H19.3L19.9 13.8V17H20ZM20.6 13.1H20.5L20 10.7H24L25.2 13.1H20.6Z"
            fill="#EF4142"
          />
        </g>
        <defs>
          <clipPath id="clip0_1001_209">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};
export const Urgent = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
      >
        <path
          d="M10 0.5H25C30.5 0.5 35 5 35 10.5V25.5C35 31 30.5 35.5 25 35.5H10C4.5 35.5 0 31 0 25.5V10.5C0 5 4.5 0.5 10 0.5Z"
          fill="#ED1C24"
          fillOpacity="0.1"
        />
        <path
          d="M25 13.8H23.6V10.5C23.6 10.1 23.3 9.7 22.9 9.5C22.5 9.3 22 9.4 21.7 9.7L20.5 10.9L19 9.3C18.8 9.1 18.5 9 18.2 9C17.9 9 17.6 9.1 17.4 9.3L15.8 11L14.2 9.3C14 9.1 13.7 9 13.4 9C13.1 9 12.8 9.1 12.6 9.3L11 10.9L9.8 9.7C9.5 9.4 9 9.3 8.6 9.5C8.2 9.7 8 10 8 10.5V26C8 26.6 8.5 27.1 9.1 27.1H22.6C23.2 27.1 23.7 26.6 23.7 26V23.5H25C26.1 23.5 26.9 22.6 26.9 21.6V15.8C26.9 14.7 26.1 13.8 25 13.8ZM22.4 25.8H9.2V10.9L10.2 11.9C10.4 12.1 10.7 12.2 11 12.2C11.3 12.2 11.6 12.1 11.8 11.9L13.4 10.2L15 11.9C15.2 12.1 15.5 12.2 15.8 12.2C16.1 12.2 16.4 12.1 16.6 11.9L18.2 10.2L19.8 11.9C20 12.1 20.3 12.2 20.6 12.2C20.9 12.2 21.2 12.1 21.4 11.9L22.4 10.9V13.9H17.7C16.6 13.9 15.8 14.8 15.8 15.8V21.6C15.8 22.4 16.3 23.1 17 23.4L16.6 24.7C16.5 24.9 16.6 25.1 16.8 25.3C16.9 25.3 17 25.4 17.1 25.4C17.2 25.4 17.3 25.4 17.4 25.3L19.2 23.6H22.3V25.8H22.4ZM26.2 21.6C26.2 22.3 25.7 22.8 25 22.8H23.6H22.4H19.2C19.1 22.8 19 22.8 18.9 22.9L17.7 24L17.9 23.3C17.9 23.2 17.9 23 17.9 22.9C17.8 22.8 17.7 22.7 17.6 22.7C17.1 22.6 16.7 22.1 16.7 21.6V15.8C16.7 15.1 17.2 14.6 17.9 14.6H22.6H23.8H25C25.7 14.6 26.2 15.1 26.2 15.8V21.6Z"
          fill="#EF4142"
        />
        <path
          d="M29 12.9C29.2 12.8 29.2 12.5 29 12.4C28.9 12.2 28.6 12.2 28.5 12.4L27 13.7C26.8 13.8 26.8 14.1 27 14.2C27.1 14.3 27.2 14.3 27.3 14.3C27.4 14.3 27.5 14.3 27.6 14.2L29 12.9Z"
          fill="#EF4142"
        />
        <path
          d="M29.2 14.7H27.6C27.4 14.7 27.2 14.9 27.2 15.1C27.2 15.3 27.4 15.5 27.6 15.5H29.2C29.4 15.5 29.6 15.3 29.6 15.1C29.6 14.9 29.5 14.7 29.2 14.7Z"
          fill="#EF4142"
        />
        <path
          d="M26.2 13.8C26.4 13.8 26.6 13.6 26.6 13.4V11.8C26.6 11.6 26.4 11.4 26.2 11.4C26 11.4 25.8 11.6 25.8 11.8V13.4C25.8 13.6 26 13.8 26.2 13.8Z"
          fill="#EF4142"
        />
        <path
          d="M21.7 20.4C21.2 20.4 20.9 20.7 20.9 21.1C20.9 21.5 21.2 21.8 21.6 21.8H21.7C22.1 21.8 22.4 21.5 22.4 21.1C22.4 20.7 22.1 20.4 21.7 20.4Z"
          fill="#EF4142"
        />
        <path
          d="M21.8 15.4H21.5C21.1 15.4 20.8 15.7 20.8 16.1L20.9 19C20.9 19.4 21.2 19.6 21.6 19.6C22 19.6 22.2 19.3 22.3 19L22.4 16.1C22.4 15.8 22.1 15.4 21.8 15.4Z"
          fill="#EF4142"
        />
        <path d="M14.6 15.4H9.90002V16.1H14.6V15.4Z" fill="#EF4142" />
        <path d="M14.6 17.4H9.90002V18.1H14.6V17.4Z" fill="#EF4142" />
        <path d="M14.6 19.3H9.90002V20H14.6V19.3Z" fill="#EF4142" />
        <path d="M13.8 22H10.3V22.7H13.8V22Z" fill="#EF4142" />
        <path d="M13.8 23.3H10.3V24H13.8V23.3Z" fill="#EF4142" />
      </svg>
    </React.Fragment>
  );
};

export const InfoRounded = ({ color = "#1C274C" }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          opacity="0.5"
          d="M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
          fill="#646B88"
        />
        <path
          d="M12.5 17.75C12.9142 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 12.9142 10.25 12.5 10.25C12.0858 10.25 11.75 10.5858 11.75 11V17C11.75 17.4142 12.0858 17.75 12.5 17.75Z"
          fill={color}
        />
        <path
          d="M12.5 7C13.0523 7 13.5 7.44771 13.5 8C13.5 8.55229 13.0523 9 12.5 9C11.9477 9 11.5 8.55229 11.5 8C11.5 7.44771 11.9477 7 12.5 7Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const Custom = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
      >
        <path
          d="M8.59996 20.0992C8.19996 19.9992 7.79996 19.7992 7.49996 19.5992C7.39996 19.5992 7.39996 19.6992 7.29996 19.6992C7.09996 19.8992 6.89996 20.0992 6.69996 20.2992C6.59996 20.3992 6.39996 20.5992 6.29996 20.6992C6.19996 20.7992 6.09996 20.8992 5.99996 20.9992C5.89996 21.0992 5.79996 21.0992 5.69996 21.1992C5.59996 21.1992 5.49996 21.1992 5.49996 21.2992C5.29996 21.3992 5.09996 21.2992 4.89996 21.2992C4.79996 21.2992 4.69996 21.2992 4.59996 21.1992C4.49996 21.1992 4.49996 21.1992 4.49996 21.0992C4.29996 20.9992 4.09996 20.8992 3.89996 20.7992C3.69996 20.5992 3.49996 20.3992 3.29996 20.1992C3.19996 20.0992 3.09996 19.8992 2.99996 19.7992C2.99996 19.6992 2.89996 19.5992 2.89996 19.4992C2.89996 19.4992 2.89996 19.4992 2.89996 19.3992V19.2992C2.89996 19.1992 2.89996 19.0992 2.89996 18.9992C2.89996 18.8992 2.89996 18.7992 2.89996 18.7992C2.89996 18.6992 2.89996 18.6992 2.89996 18.5992C2.89996 18.4992 2.89996 18.3992 2.99996 18.2992C2.99996 18.1992 3.09996 18.1992 3.09996 18.0992C3.19996 17.8992 3.29996 17.7992 3.49996 17.5992C3.69996 17.3992 3.89996 17.1992 4.19996 16.8992C4.29996 16.7992 4.39996 16.6992 4.59996 16.5992L4.69996 16.4992C4.59996 16.3992 4.59996 16.2992 4.49996 16.0992C4.09996 15.8992 3.99996 15.7992 3.99996 15.6992C3.99996 15.5992 3.89996 15.4992 3.89996 15.3992C3.89996 15.2992 3.89996 15.2992 3.79996 15.1992V15.0992C3.79996 14.9992 3.69996 14.9992 3.69996 14.8992C3.69996 14.7992 3.69996 14.7992 3.59996 14.6992C3.59996 14.6992 3.59996 14.5992 3.49996 14.5992H3.39996C2.79996 14.5992 2.19996 14.5992 1.69996 14.5992C1.59996 14.5992 1.59996 14.5992 1.59996 14.5992C1.49996 14.5992 1.39996 14.5992 1.39996 14.4992C1.39996 14.4992 1.29996 14.4992 1.29996 14.3992C1.19996 14.2992 0.999962 14.1992 0.899962 14.0992C0.799962 13.9992 0.599962 13.7992 0.499962 13.6992C0.399962 13.5992 0.399962 13.4992 0.299962 13.3992C0.299962 13.2992 0.199962 13.1992 0.199962 13.0992C0.199962 12.9992 0.199962 12.8992 0.199962 12.8992C0.099962 12.6992 0.199962 12.5992 0.199962 12.3992C0.199962 12.1992 0.199962 12.0992 0.199962 11.8992C0.199962 11.8992 0.199962 11.8992 0.199962 11.7992C0.199962 11.6992 0.199962 11.5992 0.299962 11.3992C0.299962 11.2992 0.299962 11.2992 0.399962 11.1992C0.399962 11.0992 0.499962 11.0992 0.499962 10.9992C0.499962 10.8992 0.599962 10.8992 0.599962 10.7992C0.699962 10.6992 0.799962 10.5992 0.899962 10.4992C0.999962 10.3992 1.19996 10.2992 1.29996 10.1992C1.39996 10.1992 1.49996 10.0992 1.59996 10.0992C1.69996 10.0992 1.79996 10.0992 1.89996 9.99922H1.99996C2.49996 9.99922 2.99996 9.99922 3.59996 9.99922C3.69996 9.99922 3.69996 9.99922 3.79996 9.99922C3.89996 9.99922 3.89996 9.99922 3.99996 9.89922C3.99996 9.79922 4.09996 9.69922 4.09996 9.59922C4.09996 9.49922 4.09996 9.49922 4.19996 9.39922C4.19996 9.29922 4.29996 9.29922 4.29996 9.19922C4.29996 9.19922 4.29996 9.09922 4.39996 9.09922C3.89996 8.99922 3.99996 8.89922 3.99996 8.79922C4.09996 8.59922 4.19996 8.49922 4.19996 8.29922C4.19996 8.29922 4.19996 8.19922 4.29996 8.19922L4.19996 8.09922C3.99996 7.89922 3.79996 7.69922 3.59996 7.39922C3.39996 7.29922 3.29996 7.09922 3.09996 6.89922C2.99996 6.79922 2.89996 6.69922 2.79996 6.49922C2.79996 6.39922 2.69996 6.29922 2.69996 6.19922C2.69996 6.09922 2.59996 5.99922 2.59996 5.79922C2.59996 5.69922 2.59996 5.59922 2.59996 5.49922C2.59996 5.39922 2.59996 5.39922 2.59996 5.29922C2.59996 5.19922 2.69996 4.99922 2.69996 4.89922C2.79996 4.69922 2.99996 4.49922 3.09996 4.29922C3.29996 4.19922 3.39996 4.09922 3.49996 3.99922C3.59996 3.89922 3.69996 3.79922 3.79996 3.69922C3.89996 3.59922 3.99996 3.59922 4.09996 3.49922C4.19996 3.49922 4.29996 3.39922 4.39996 3.39922C4.49996 3.39922 4.69996 3.29922 4.79996 3.29922C4.89996 3.29922 4.99996 3.29922 5.09996 3.29922C5.19996 3.29922 5.29996 3.29922 5.49996 3.39922C5.59996 3.39922 5.59996 3.39922 5.69996 3.49922C5.69996 3.49922 5.79996 3.49922 5.79996 3.59922C5.89996 3.59922 5.99996 3.59922 5.99996 3.69922C6.19996 3.79922 6.29996 3.89922 6.39996 3.99922C6.59996 4.19922 6.89996 4.49922 7.09996 4.69922C7.19996 4.79922 7.29996 4.89922 7.39996 4.99922C7.39996 4.99922 7.49996 4.99922 7.49996 5.09922C7.59996 4.99922 7.69996 4.89922 7.79996 4.89922C7.89996 4.79922 7.99996 4.79922 8.09996 4.69922C8.19996 4.69922 8.29996 4.59922 8.39996 4.59922C8.39996 4.59922 8.49996 4.59922 8.49996 4.49922C8.59996 4.49922 8.69996 4.39922 8.79996 4.39922C8.89996 4.39922 8.89996 4.39922 8.99996 4.29922C9.09996 4.29922 9.19996 4.29922 9.29996 4.19922C9.29996 4.19922 9.39996 4.19922 9.39996 4.09922V3.99922C9.39996 3.39922 9.39996 2.89922 9.39996 2.29922C9.39996 2.19922 9.39996 2.19922 9.39996 2.19922C9.39996 2.09922 9.49996 1.89922 9.49996 1.79922C9.49996 1.69922 9.59996 1.59922 9.69996 1.49922C9.79996 1.29922 9.99996 1.19922 10.2 0.999219C10.3 0.899219 10.4 0.899219 10.5 0.799219C10.6 0.799219 10.7 0.699219 10.8 0.699219H10.9H11C11.1 0.699219 11.1 0.699219 11.2 0.699219C11.4 0.699219 11.7 0.699219 11.9 0.699219H12C12 0.699219 12 0.699219 12.1 0.699219C12.2 0.699219 12.3 0.699219 12.4 0.799219C12.5 0.799219 12.6 0.899219 12.7 0.899219C12.9 0.999219 13.1 1.09922 13.2 1.29922C13.3 1.39922 13.3 1.39922 13.4 1.49922C13.5 1.59922 13.6 1.79922 13.6 1.89922C13.6 1.99922 13.7 2.09922 13.7 2.19922C13.7 2.29922 13.7 2.39922 13.7 2.49922C13.7 2.99922 13.7 3.49922 13.7 4.09922C13.7 4.19922 13.7 4.29922 13.9 4.29922C14 4.29922 14.2 4.39922 14.3 4.39922C14.4 4.39922 14.4 4.39922 14.5 4.49922C14.6 4.49922 14.6 4.49922 14.7 4.59922C14.8 4.69922 15 4.69922 15.1 4.79922C15.2 4.89922 15.4 4.89922 15.5 4.99922C15.6 4.99922 15.7 5.09922 15.8 5.09922C15.9 5.09922 15.9 4.99922 16 4.99922C16.2 4.79922 16.4 4.59922 16.5 4.49922C16.6 4.39922 16.8 4.19922 16.9 4.09922C17 3.99922 17.2 3.89922 17.3 3.79922C17.4 3.69922 17.6 3.69922 17.7 3.59922C18 3.49922 18.2 3.49922 18.5 3.49922C18.6 3.49922 18.7 3.49922 18.8 3.59922C18.9 3.59922 18.9 3.59922 19 3.69922C19 3.69922 19.1 3.69922 19.1 3.79922C19.3 3.89922 19.5 4.09922 19.7 4.29922C19.8 4.39922 20 4.59922 20.1 4.79922C20.2 4.89922 20.3 4.99922 20.3 5.19922C20.3 5.29922 20.4 5.29922 20.4 5.39922C20.4 5.49922 20.4 5.49922 20.4 5.59922C20.4 5.79922 20.5 6.09922 20.4 6.29922C20.4 6.39922 20.4 6.49922 20.3 6.49922H20.2C20.1 6.49922 20.1 6.49922 20 6.39922C20 6.39922 20 6.39922 19.9 6.39922C19.8 6.39922 19.7 6.39922 19.6 6.29922H19.5C19.4 6.29922 19.4 6.29922 19.3 6.29922C19.2 6.29922 19.2 6.29922 19.2 6.19922C19.2 6.09922 19.2 6.09922 19.2 5.99922C19.2 5.89922 19.1 5.69922 19.1 5.59922C19 5.49922 18.9 5.39922 18.8 5.29922C18.7 5.19922 18.6 5.09922 18.5 4.99922C18.4 4.89922 18.2 4.79922 18 4.79922H17.9C17.7 4.79922 17.6 4.89922 17.5 4.99922C17.4 5.09922 17.2 5.29922 17.1 5.39922C16.9 5.59922 16.7 5.69922 16.6 5.89922C16.4 6.09922 16.3 6.19922 16.1 6.39922C16 6.49922 15.9 6.59922 15.8 6.59922C15.7 6.59922 15.7 6.59922 15.6 6.59922C15.5 6.59922 15.4 6.59922 15.3 6.49922C15.2 6.49922 15.2 6.39922 15.1 6.39922C15 6.29922 14.9 6.29922 14.8 6.19922C14.7 6.09922 14.6 6.09922 14.5 5.99922C14.4 5.99922 14.3 5.89922 14.3 5.89922C14.2 5.89922 14.1 5.79922 14 5.79922C13.9 5.79922 13.9 5.79922 13.8 5.69922C13.7 5.69922 13.7 5.69922 13.6 5.59922C13.6 5.59922 13.6 5.59922 13.5 5.59922H13.4C13.4 5.59922 13.4 5.59922 13.3 5.59922H13.2C13.1 5.59922 13 5.59922 12.9 5.49922C12.8 5.49922 12.8 5.49922 12.7 5.39922C12.6 5.39922 12.6 5.29922 12.6 5.29922C12.5 5.19922 12.5 5.09922 12.5 4.99922C12.5 4.79922 12.5 4.49922 12.5 4.29922C12.5 3.89922 12.5 3.39922 12.5 2.99922C12.5 2.89922 12.5 2.89922 12.5 2.79922C12.5 2.59922 12.4 2.49922 12.3 2.39922C12.2 2.29922 12.1 2.19922 12 2.19922C11.9 2.19922 11.9 2.19922 11.8 2.19922C11.6 2.19922 11.4 2.19922 11.1 2.19922C11 2.19922 10.9 2.19922 10.8 2.29922C10.7 2.39922 10.6 2.39922 10.5 2.49922C10.4 2.59922 10.4 2.69922 10.4 2.79922C10.4 2.99922 10.4 3.09922 10.4 3.29922C10.4 3.79922 10.4 4.39922 10.4 4.89922C10.4 4.99922 10.4 4.99922 10.4 5.09922C10.4 5.29922 10.3 5.39922 10.1 5.49922C9.99996 5.49922 9.89996 5.59922 9.79996 5.59922C9.79996 5.59922 9.79996 5.59922 9.69996 5.59922H9.59996H9.49996C9.49996 5.59922 9.49996 5.59922 9.39996 5.59922H9.29996C9.19996 5.59922 9.09996 5.69922 8.99996 5.69922C9.09996 5.49922 8.99996 5.49922 8.89996 5.59922C8.79996 5.59922 8.69996 5.69922 8.59996 5.69922C8.49996 5.69922 8.39996 5.79922 8.29996 5.89922C8.19996 5.89922 8.09996 5.99922 7.99996 5.99922C7.89996 6.09922 7.79996 6.09922 7.69996 6.19922L7.59996 6.29922C7.49996 6.29922 7.49996 6.29922 7.39996 6.29922C7.19996 6.29922 7.09996 6.19922 6.99996 6.09922C6.69996 5.79922 6.39996 5.49922 6.09996 5.19922C5.89996 4.99922 5.69996 4.89922 5.49996 4.69922C5.39996 4.59922 5.19996 4.49922 4.99996 4.49922C4.89996 4.49922 4.89996 4.49922 4.79996 4.49922C4.69996 4.49922 4.59996 4.59922 4.49996 4.59922C4.39996 4.69922 4.29996 4.79922 4.19996 4.89922C4.09996 4.99922 3.99996 5.09922 3.89996 5.09922C3.89996 5.19922 3.89996 5.29922 3.79996 5.39922C3.69996 5.59922 3.69996 5.69922 3.79996 5.89922C3.79996 5.99922 3.79996 5.99922 3.89996 6.09922C3.89996 6.19922 3.99996 6.29922 4.09996 6.39922C4.29996 6.59922 4.49996 6.79922 4.69996 6.99922C4.89996 7.19922 5.09996 7.39922 5.29996 7.59922C5.39996 7.69922 5.39996 7.69922 5.49996 7.79922C5.59996 7.89922 5.59996 7.99922 5.59996 8.09922C5.59996 8.19922 5.59996 8.19922 5.59996 8.29922C5.59996 8.29922 5.59996 8.39922 5.49996 8.39922L5.39996 8.49922C5.39996 8.59922 5.29996 8.69922 5.19996 8.79922C5.19996 8.99922 5.09996 9.09922 5.09996 9.19922C4.99996 9.19922 4.99996 9.29922 4.99996 9.39922C4.99996 9.49922 4.89996 9.49922 4.89996 9.59922C4.89996 9.69922 4.89996 9.69922 4.79996 9.79922C4.79996 9.89922 4.69996 9.89922 4.69996 9.99922C4.69996 10.0992 4.69996 10.0992 4.59996 10.1992C4.59996 10.1992 4.59996 10.1992 4.59996 10.2992C4.59996 10.2992 4.59996 10.2992 4.59996 10.3992C4.59996 10.4992 4.59996 10.4992 4.59996 10.4992C4.59996 10.5992 4.59996 10.6992 4.49996 10.7992C4.49996 10.8992 4.49996 10.8992 4.39996 10.9992C4.39996 11.0992 4.29996 11.1992 4.19996 11.1992C4.09996 11.1992 4.09996 11.2992 3.99996 11.2992C3.89996 11.2992 3.79996 11.2992 3.69996 11.2992C3.09996 11.2992 2.59996 11.2992 1.99996 11.2992C1.89996 11.2992 1.89996 11.2992 1.79996 11.2992C1.59996 11.2992 1.49996 11.3992 1.39996 11.4992C1.29996 11.5992 1.29996 11.6992 1.19996 11.6992C1.19996 11.7992 1.09996 11.8992 1.09996 11.9992C1.09996 12.1992 1.09996 12.4992 1.09996 12.6992C1.09996 12.7992 1.09996 12.8992 1.19996 12.9992C1.29996 13.0992 1.39996 13.1992 1.49996 13.2992C1.49996 13.2992 1.59996 13.2992 1.59996 13.3992C1.69996 13.4992 1.79996 13.3992 1.89996 13.4992H1.99996C2.59996 13.4992 3.29996 13.4992 3.89996 13.4992C3.99996 13.4992 3.99996 13.4992 4.09996 13.4992C4.29996 13.4992 4.39996 13.5992 4.49996 13.6992C4.59996 13.7992 4.59996 13.8992 4.59996 13.9992C4.59996 13.9992 4.59996 13.9992 4.59996 14.0992V14.1992V14.2992C4.59996 14.2992 4.59996 14.2992 4.59996 14.3992V14.4992C4.59996 14.4992 4.59996 14.4992 4.59996 14.5992V14.6992C4.59996 14.7992 4.59996 14.7992 4.69996 14.8992C4.69996 14.9992 4.79996 14.9992 4.79996 15.0992C4.79996 15.0992 4.79996 15.1992 4.89996 15.1992C4.99996 15.3992 4.99996 15.4992 5.09996 15.6992C5.19996 15.7992 5.19996 15.8992 5.29996 16.0992C5.39996 16.1992 5.39996 16.2992 5.49996 16.3992C5.59996 16.4992 5.59996 16.5992 5.59996 16.6992C5.59996 16.8992 5.49996 16.9992 5.39996 17.0992C5.19996 17.2992 4.99996 17.4992 4.79996 17.6992C4.59996 17.8992 4.39996 18.0992 4.29996 18.1992C4.19996 18.2992 4.09996 18.3992 3.99996 18.4992C3.99996 18.4992 3.89996 18.5992 3.89996 18.6992C3.79996 18.8992 3.79996 19.0992 3.89996 19.1992C3.89996 19.2992 3.89996 19.2992 3.99996 19.3992C4.09996 19.4992 4.09996 19.5992 4.19996 19.6992C4.29996 19.7992 4.39996 19.9992 4.59996 20.0992C4.69996 20.1992 4.79996 20.2992 4.99996 20.2992C5.09996 20.2992 5.19996 20.2992 5.29996 20.2992C5.39996 20.2992 5.39996 20.2992 5.49996 20.1992C5.59996 20.0992 5.69996 19.9992 5.79996 19.8992C6.09996 19.5992 6.49996 19.1992 6.79996 18.8992C6.89996 18.7992 6.99996 18.6992 7.09996 18.5992C7.19996 18.4992 7.39996 18.3992 7.49996 18.4992C7.49996 18.4992 7.49996 18.4992 7.59996 18.4992C7.69996 18.4992 7.69996 18.4992 7.79996 18.5992C7.99996 18.6992 8.09996 18.7992 8.29996 18.8992C8.39996 18.9992 8.59996 18.9992 8.69996 19.0992L8.79996 19.1992C8.59996 19.3992 8.69996 19.6992 8.59996 20.0992Z"
          fill="white"
        />
        <path
          d="M9.59993 18.8976C9.59993 18.5976 9.59993 18.2976 9.59993 17.9976V17.8976C9.59993 17.7976 9.59993 17.6976 9.69993 17.5976C9.89993 17.3976 9.99993 17.1976 10.1999 16.9976C10.2999 16.8976 10.3999 16.6976 10.5999 16.5976C10.6999 16.3976 10.8999 16.2976 10.9999 16.0976C11.0999 15.8976 11.2999 15.7976 11.3999 15.5976C11.4999 15.3976 11.6999 15.1976 11.7999 15.0976C11.8999 14.9976 11.9999 14.8976 12.0999 14.7976C12.2999 14.5976 12.3999 14.3976 12.5999 14.1976C12.7999 13.9976 12.8999 13.7976 13.0999 13.5976C13.1999 13.4976 13.2999 13.3976 13.2999 13.2976C13.4999 13.0976 13.6999 12.8976 13.7999 12.5976C13.8999 12.3976 14.0999 12.2976 14.1999 12.0976C14.2999 11.9976 14.3999 11.7976 14.5999 11.6976C14.6999 11.5976 14.7999 11.3976 14.8999 11.2976C14.9999 11.1976 15.0999 10.9976 15.2999 10.8976C15.4999 10.6976 15.5999 10.4976 15.7999 10.2976C15.8999 10.1976 15.9999 9.99757 16.1999 9.89757C16.3999 9.69757 16.4999 9.49757 16.6999 9.29757C16.7999 9.09757 16.9999 8.99757 17.0999 8.79757C17.1999 8.69757 17.2999 8.49757 17.4999 8.39757C17.5999 8.29757 17.6999 8.09757 17.7999 7.99757C17.8999 7.79757 18.0999 7.69757 18.1999 7.49757C18.2999 7.39757 18.3999 7.29757 18.4999 7.19757C18.5999 7.19757 18.5999 7.09757 18.6999 7.09757C18.7999 7.09757 18.7999 6.99757 18.8999 6.99757C19.0999 6.99757 19.2999 6.89757 19.4999 6.99757C19.5999 6.99757 19.7999 7.09757 19.8999 7.09757C20.0999 7.19757 20.1999 7.19757 20.3999 7.29757C20.5999 7.39757 20.6999 7.49757 20.7999 7.59757C20.8999 7.69757 20.8999 7.69757 20.9999 7.79757C21.1999 7.99757 21.3999 8.09757 21.5999 8.29757C21.7999 8.39757 21.9999 8.59757 22.0999 8.69757C22.2999 8.79757 22.3999 8.99757 22.5999 9.09757C22.7999 9.19757 22.8999 9.39757 23.0999 9.49757C23.1999 9.59757 23.2999 9.69757 23.2999 9.79757C23.2999 9.89757 23.3999 9.89757 23.3999 9.99757C23.3999 9.99757 23.3999 10.0976 23.4999 10.0976C23.4999 10.1976 23.4999 10.1976 23.5999 10.2976C23.5999 10.2976 23.5999 10.2976 23.5999 10.3976C23.5999 10.4976 23.6999 10.5976 23.6999 10.7976C23.6999 10.8976 23.6999 10.9976 23.6999 11.0976C23.6999 11.2976 23.5999 11.4976 23.3999 11.6976C23.2999 11.8976 23.1999 11.9976 22.9999 12.1976C22.7999 12.3976 22.6999 12.5976 22.4999 12.7976C22.3999 12.9976 22.1999 13.0976 22.0999 13.2976C21.9999 13.4976 21.7999 13.5976 21.6999 13.7976C21.5999 13.8976 21.4999 14.0976 21.2999 14.1976C21.1999 14.2976 21.0999 14.4976 20.9999 14.5976C20.7999 14.7976 20.6999 14.9976 20.4999 15.1976C20.3999 15.2976 20.2999 15.4976 20.1999 15.5976C20.1999 15.6976 20.0999 15.6976 20.0999 15.7976C19.9999 15.8976 19.8999 16.0976 19.7999 16.1976C19.6999 16.3976 19.4999 16.4976 19.3999 16.6976C19.2999 16.7976 19.2999 16.8976 19.1999 16.9976C19.0999 17.1976 18.8999 17.2976 18.7999 17.4976C18.5999 17.6976 18.4999 17.8976 18.2999 18.0976C18.1999 18.1976 18.0999 18.2976 17.9999 18.4976C17.7999 18.6976 17.6999 18.8976 17.4999 19.0976C17.3999 19.1976 17.2999 19.3976 17.0999 19.4976C16.8999 19.6976 16.7999 19.8976 16.5999 20.0976C16.4999 20.1976 16.3999 20.3976 16.2999 20.4976C16.1999 20.6976 15.9999 20.7976 15.8999 20.9976C15.7999 21.0976 15.6999 21.2976 15.4999 21.3976C15.3999 21.4976 15.2999 21.6976 15.0999 21.7976C14.9999 21.8976 14.8999 22.0976 14.7999 22.1976C14.6999 22.2976 14.6999 22.2976 14.5999 22.2976C14.4999 22.2976 14.3999 22.2976 14.3999 22.3976H14.2999C14.1999 22.3976 14.0999 22.3976 13.9999 22.4976C13.8999 22.4976 13.6999 22.4976 13.5999 22.5976C13.5999 22.5976 13.5999 22.5976 13.4999 22.5976C13.3999 22.5976 13.3999 22.5976 13.2999 22.5976H13.1999C13.0999 22.5976 13.0999 22.5976 12.9999 22.5976C12.9999 22.5976 12.9999 22.5976 12.8999 22.5976C12.7999 22.5976 12.7999 22.5976 12.6999 22.5976C12.6999 22.5976 12.6999 22.5976 12.5999 22.5976C12.4999 22.5976 12.2999 22.6976 12.1999 22.6976C12.1999 22.6976 12.1999 22.6976 12.0999 22.6976C11.9999 22.6976 11.9999 22.6976 11.8999 22.6976C11.8999 22.6976 11.8999 22.6976 11.7999 22.6976H11.6999C11.5999 22.6976 11.4999 22.6976 11.3999 22.7976H11.2999C11.1999 22.7976 11.0999 22.7976 10.9999 22.8976H10.8999H10.7999C10.6999 22.8976 10.6999 22.8976 10.5999 22.8976H10.4999C10.3999 22.8976 10.3999 22.8976 10.2999 22.8976C10.1999 22.8976 9.99993 22.9976 9.89993 22.9976C9.89993 22.9976 9.89993 22.9976 9.79993 22.9976C9.79993 22.9976 9.79993 22.9976 9.69993 22.9976C9.59993 22.9976 9.49993 22.8976 9.39993 22.7976C9.39993 22.6976 9.39993 22.6976 9.29993 22.5976C9.29993 22.3976 9.29993 22.2976 9.29993 22.0976C9.29993 21.5976 9.29993 21.1976 9.29993 20.6976C9.29993 20.4976 9.29993 20.2976 9.29993 20.0976V19.9976C9.59993 19.5976 9.59993 19.1976 9.59993 18.8976ZM14.3999 20.6976C14.5999 20.4976 14.6999 20.2976 14.7999 20.1976C14.8999 19.9976 15.0999 19.8976 15.1999 19.6976C15.2999 19.5976 15.3999 19.4976 15.4999 19.2976C15.5999 19.1976 15.6999 19.0976 15.7999 18.8976C15.8999 18.6976 16.0999 18.5976 16.1999 18.3976C16.2999 18.2976 16.3999 18.0976 16.4999 17.9976C16.5999 17.8976 16.6999 17.6976 16.8999 17.5976C16.9999 17.4976 17.0999 17.2976 17.2999 17.1976C17.4999 16.9976 17.5999 16.7976 17.7999 16.5976C17.9999 16.3976 18.0999 16.1976 18.2999 15.9976C18.3999 15.7976 18.4999 15.6976 18.6999 15.4976C18.7999 15.3976 18.7999 15.2976 18.8999 15.1976C18.9999 15.0976 19.0999 14.8976 19.1999 14.7976C19.2999 14.5976 19.4999 14.4976 19.5999 14.2976C19.6999 14.1976 19.7999 13.9976 19.8999 13.8976C20.0999 13.6976 20.1999 13.4976 20.3999 13.2976V13.1976C20.3999 13.1976 20.2999 13.1976 20.2999 13.0976C20.1999 12.9976 19.9999 12.8976 19.8999 12.6976C19.6999 12.4976 19.4999 12.3976 19.2999 12.1976C19.1999 12.0976 18.9999 11.9976 18.8999 11.8976C18.7999 11.7976 18.5999 11.6976 18.4999 11.5976C18.2999 11.4976 18.1999 11.2976 17.9999 11.1976C17.7999 10.9976 17.5999 10.8976 17.3999 10.6976C17.2999 10.5976 17.0999 10.4976 16.9999 10.3976C16.8999 10.3976 16.8999 10.3976 16.8999 10.3976C16.7999 10.4976 16.6999 10.5976 16.5999 10.6976C16.4999 10.7976 16.3999 10.8976 16.2999 11.0976C16.1999 11.2976 15.9999 11.3976 15.8999 11.5976C15.7999 11.6976 15.6999 11.8976 15.5999 11.9976C15.3999 12.1976 15.2999 12.3976 15.0999 12.5976C14.9999 12.7976 14.7999 12.8976 14.6999 13.0976C14.5999 13.1976 14.5999 13.2976 14.4999 13.3976C14.3999 13.4976 14.2999 13.6976 14.1999 13.7976C14.0999 13.8976 13.9999 14.0976 13.7999 14.1976C13.6999 14.2976 13.5999 14.3976 13.5999 14.4976C13.3999 14.6976 13.2999 14.8976 13.0999 15.0976C12.9999 15.1976 12.8999 15.3976 12.6999 15.4976C12.5999 15.5976 12.4999 15.7976 12.2999 15.8976C12.1999 16.0976 11.9999 16.1976 11.8999 16.3976C11.7999 16.5976 11.5999 16.6976 11.4999 16.8976C11.4999 16.9976 11.3999 16.9976 11.3999 17.0976C11.2999 17.1976 11.1999 17.3976 11.0999 17.4976C10.9999 17.5976 10.9999 17.5976 10.8999 17.6976C10.8999 17.7976 10.8999 17.7976 10.8999 17.7976C10.9999 17.8976 10.9999 17.8976 11.0999 17.9976C11.1999 18.0976 11.3999 18.1976 11.4999 18.2976C11.6999 18.3976 11.7999 18.5976 11.9999 18.6976C12.1999 18.7976 12.2999 18.9976 12.4999 19.0976C12.5999 19.1976 12.7999 19.2976 12.8999 19.4976C12.9999 19.5976 13.1999 19.6976 13.2999 19.8976C13.4999 20.0976 13.6999 20.2976 13.9999 20.3976C14.1999 20.4976 14.2999 20.5976 14.3999 20.6976ZM22.5999 10.7976V10.6976C22.5999 10.5976 22.4999 10.4976 22.3999 10.3976C22.2999 10.2976 22.1999 10.1976 22.0999 10.0976C21.9999 9.99757 21.8999 9.89757 21.7999 9.69757C21.6999 9.59757 21.4999 9.49757 21.3999 9.39757C21.1999 9.19757 20.9999 9.09757 20.7999 8.89757C20.6999 8.79757 20.4999 8.69757 20.3999 8.49757C20.1999 8.29757 20.0999 8.19757 19.8999 8.09757C19.6999 7.99757 19.4999 7.99757 19.2999 7.99757C19.1999 7.99757 19.1999 7.99757 19.0999 8.09757C18.9999 8.19757 18.9999 8.19757 18.8999 8.29757C18.7999 8.49757 18.5999 8.59757 18.4999 8.79757C18.3999 8.89757 18.2999 9.09757 18.1999 9.19757C17.9999 9.39757 17.8999 9.59757 17.6999 9.69757V9.79757C17.6999 9.79757 17.7999 9.79757 17.7999 9.89757C17.8999 9.99757 18.0999 10.0976 18.1999 10.2976C18.2999 10.3976 18.4999 10.4976 18.5999 10.6976C18.7999 10.7976 18.8999 10.9976 19.0999 11.0976C19.1999 11.1976 19.2999 11.2976 19.4999 11.3976C19.5999 11.4976 19.7999 11.5976 19.8999 11.6976C20.0999 11.8976 20.3999 12.0976 20.5999 12.2976C20.6999 12.3976 20.8999 12.4976 20.9999 12.5976H21.0999C21.1999 12.4976 21.1999 12.4976 21.2999 12.3976C21.3999 12.2976 21.4999 12.0976 21.5999 11.9976C21.7999 11.7976 21.9999 11.4976 22.1999 11.2976C22.2999 11.1976 22.2999 11.0976 22.3999 11.0976C22.5999 10.8976 22.5999 10.8976 22.5999 10.7976ZM10.7999 19.1976C10.6999 19.1976 10.6999 19.1976 10.7999 19.1976C10.7999 19.2976 10.7999 19.2976 10.7999 19.2976C10.7999 19.8976 10.7999 20.3976 10.7999 20.9976C10.7999 21.1976 10.7999 21.3976 10.7999 21.5976V21.6976C10.8999 21.6976 10.9999 21.6976 10.9999 21.6976H11.0999C11.1999 21.6976 11.1999 21.6976 11.2999 21.6976C11.3999 21.6976 11.4999 21.6976 11.5999 21.5976C11.6999 21.5976 11.7999 21.4976 11.8999 21.4976C11.8999 21.4976 11.9999 21.4976 12.0999 21.4976C12.0999 21.4976 12.0999 21.4976 12.1999 21.4976C12.2999 21.4976 12.3999 21.3976 12.4999 21.3976C12.5999 21.3976 12.6999 21.3976 12.6999 21.3976C12.7999 21.3976 12.8999 21.3976 13.0999 21.2976C13.0999 21.2976 13.1999 21.2976 13.1999 21.1976C13.0999 21.0976 12.9999 20.9976 12.8999 20.9976C12.7999 20.8976 12.5999 20.7976 12.4999 20.5976C12.3999 20.4976 12.1999 20.3976 12.0999 20.2976C11.9999 20.1976 11.7999 20.0976 11.6999 19.9976C11.5999 19.8976 11.4999 19.7976 11.2999 19.6976C11.1999 19.5976 10.9999 19.4976 10.8999 19.3976C10.7999 19.1976 10.7999 19.1976 10.7999 19.1976Z"
          fill="white"
        />
        <path
          d="M15.6999 8.99766C15.4999 9.29766 15.1999 9.59766 14.9999 9.89766C14.8999 9.79766 14.7999 9.69766 14.7999 9.59766C14.5999 9.39766 14.4999 9.29766 14.2999 9.09766C14.0999 8.99766 13.9999 8.89766 13.7999 8.79766C13.6999 8.69766 13.5999 8.69766 13.4999 8.69766C13.3999 8.59766 13.2999 8.59766 13.1999 8.59766C13.0999 8.59766 13.0999 8.49766 12.9999 8.49766C12.8999 8.49766 12.8999 8.49766 12.7999 8.49766C12.6999 8.49766 12.6999 8.49766 12.5999 8.49766C12.4999 8.49766 12.4999 8.49766 12.3999 8.49766C12.0999 8.49766 11.6999 8.39766 11.3999 8.49766C11.2999 8.49766 11.1999 8.49766 10.9999 8.49766C10.8999 8.49766 10.7999 8.49766 10.6999 8.59766C10.6999 8.59766 10.6999 8.59766 10.5999 8.59766H10.4999H10.3999H10.2999C10.1999 8.59766 10.0999 8.69766 9.99993 8.69766C9.89993 8.69766 9.79993 8.79766 9.79993 8.79766C9.59993 8.69766 9.39993 8.79766 9.29993 8.89766C8.99993 9.09766 8.79993 9.29766 8.59993 9.49766C8.49993 9.59766 8.39993 9.79766 8.29993 9.89766C8.19993 9.99766 8.09993 10.1977 7.99993 10.2977C7.89993 10.3977 7.79993 10.5977 7.79993 10.7977C7.79993 10.8977 7.69993 10.9977 7.69993 11.0977C7.69993 11.1977 7.59993 11.2977 7.59993 11.2977C7.59993 11.3977 7.59993 11.4977 7.49993 11.5977C7.49993 11.6977 7.49993 11.6977 7.49993 11.7977V11.8977C7.49993 12.0977 7.49993 12.2977 7.49993 12.4977V12.5977C7.49993 12.5977 7.49993 12.5977 7.49993 12.6977C7.49993 12.7977 7.49993 12.9977 7.59993 13.0977C7.59993 13.1977 7.69993 13.2977 7.69993 13.3977C7.69993 13.4977 7.69993 13.4977 7.79993 13.5977C7.79993 13.6977 7.89993 13.7977 7.89993 13.8977C7.89993 13.9977 7.99993 14.0977 7.99993 14.0977C7.99993 14.2977 7.99993 14.2977 7.99993 14.3977C7.99993 14.4977 8.09993 14.4977 8.09993 14.5977C8.19993 14.6977 8.19993 14.7977 8.29993 14.8977C8.39993 15.0977 8.59993 15.1977 8.79993 15.3977C8.89993 15.4977 8.99993 15.5977 9.19993 15.6977C9.29993 15.7977 9.39993 15.7977 9.39993 15.8977C9.49993 15.9977 9.59993 15.9977 9.69993 16.0977C9.79993 16.0977 9.79993 16.0977 9.69993 16.1977C9.59993 16.3977 9.39993 16.4977 9.29993 16.6977C9.19993 16.7977 9.09993 16.8977 9.09993 16.9977H8.99993C8.89993 16.8977 8.69993 16.7977 8.59993 16.6977C8.49993 16.5977 8.29993 16.4977 8.19993 16.3977C8.09993 16.2977 7.89993 16.0977 7.79993 15.9977C7.69993 15.8977 7.59993 15.6977 7.49993 15.5977C7.39993 15.4977 7.29993 15.2977 7.19993 15.1977C7.09993 14.9977 6.99993 14.8977 6.89993 14.6977C6.79993 14.5977 6.79993 14.4977 6.69993 14.3977C6.69993 14.2977 6.59993 14.1977 6.59993 14.0977C6.59993 13.9977 6.49993 13.9977 6.49993 13.8977C6.49993 13.7977 6.49993 13.6977 6.39993 13.6977C6.39993 13.5977 6.39993 13.4977 6.29993 13.3977C6.29993 13.3977 6.29993 13.3977 6.29993 13.2977C6.29993 13.1977 6.29993 13.1977 6.29993 13.0977V12.9977C6.29993 12.8977 6.29993 12.6977 6.29993 12.5977C6.29993 12.3977 6.29993 12.2977 6.29993 12.0977C6.29993 11.9977 6.29993 11.7977 6.29993 11.6977V11.5977C6.29993 11.4977 6.29993 11.3977 6.39993 11.1977C6.39993 11.0977 6.39993 10.9977 6.49993 10.8977C6.49993 10.7977 6.49993 10.7977 6.59993 10.6977C6.59993 10.5977 6.59993 10.5977 6.69993 10.4977C6.69993 10.3977 6.69993 10.3977 6.79993 10.2977C6.79993 10.2977 6.79993 10.1977 6.89993 10.1977C6.89993 9.99766 6.89993 9.89766 6.99993 9.79766C6.99993 9.69766 7.09993 9.59766 7.19993 9.49766C7.29993 9.39766 7.39993 9.29766 7.39993 9.09766C7.59993 8.99766 7.69993 8.79766 7.89993 8.59766C7.99993 8.49766 8.09993 8.39766 8.19993 8.29766C8.39993 8.19766 8.49993 8.09766 8.69993 7.99766C8.79993 7.89766 8.89993 7.79766 8.99993 7.69766C9.09993 7.59766 9.19993 7.59766 9.29993 7.49766C9.39993 7.49766 9.49993 7.39766 9.59993 7.39766C9.69993 7.39766 9.69993 7.39766 9.79993 7.29766C9.79993 7.29766 9.79993 7.29766 9.89993 7.29766C9.89993 7.29766 9.89993 7.29766 9.99993 7.29766C9.99993 7.29766 9.99993 7.29766 10.0999 7.29766H10.1999C10.1999 7.29766 10.1999 7.29766 10.2999 7.29766H10.3999C10.4999 7.29766 10.5999 7.29766 10.6999 7.19766H10.7999C10.8999 7.19766 11.0999 7.19766 11.1999 7.09766C11.2999 7.09766 11.3999 7.09766 11.4999 7.09766C11.6999 7.09766 11.8999 7.09766 12.0999 7.09766C12.1999 7.09766 12.2999 7.09766 12.3999 7.09766C12.4999 7.09766 12.4999 7.09766 12.5999 7.09766H12.6999H12.7999C12.8999 7.09766 12.9999 7.19766 13.0999 7.19766C13.0999 7.19766 13.0999 7.19766 13.1999 7.19766H13.2999C13.2999 7.19766 13.2999 7.19766 13.3999 7.19766C13.3999 7.19766 13.3999 7.19766 13.4999 7.19766H13.5999C13.6999 7.19766 13.7999 7.29766 13.7999 7.29766C13.7999 7.29766 13.8999 7.29766 13.9999 7.39766C13.9999 7.39766 14.0999 7.39766 14.0999 7.49766C14.0999 7.49766 14.1999 7.49766 14.1999 7.59766C14.2999 7.69766 14.4999 7.69766 14.5999 7.79766C14.6999 7.89766 14.8999 7.99766 14.9999 8.09766C15.1999 8.29766 15.4999 8.49766 15.5999 8.69766C15.4999 8.79766 15.5999 8.89766 15.6999 8.99766Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const VerifyAndPrint = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5 17.25C22.5 18.078 21.828 18.75 21 18.75H19.3935C19.0598 17.4585 17.8965 16.5 16.5 16.5H7.5C6.1035 16.5 4.94025 17.4585 4.6065 18.75H3C2.172 18.75 1.5 18.078 1.5 17.25V15.75C1.5 14.922 2.172 14.25 3 14.25H21C21.828 14.25 22.5 14.922 22.5 15.75V17.25ZM16.5 21H7.5C6.672 21 6 20.328 6 19.5C6 18.672 6.672 18 7.5 18H16.5C17.328 18 18 18.672 18 19.5C18 20.328 17.328 21 16.5 21ZM6 4.5C6 3.672 6.672 3 7.5 3H16.5C17.328 3 18 3.672 18 4.5V12.75H6V4.5ZM21 12.75H19.5V4.5C19.5 2.84325 18.1568 1.5 16.5 1.5H7.5C5.84325 1.5 4.5 2.84325 4.5 4.5V12.75H3C1.34325 12.75 0 14.0932 0 15.75V17.25C0 18.9068 1.34325 20.25 3 20.25H4.6065C4.94025 21.5423 6.1035 22.5 7.5 22.5H16.5C17.8965 22.5 19.0598 21.5423 19.3935 20.25H21C22.6568 20.25 24 18.9068 24 17.25V15.75C24 14.0932 22.6568 12.75 21 12.75Z"
          fill="white"
        />
      </svg>
    </React.Fragment>
  );
};

export const WIFI = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M1.3331 8.07433C0.921568 8.44266 0.886547 9.07485 1.25488 9.48638C1.6232 9.89791 2.2554 9.93293 2.66692 9.5646L1.3331 8.07433ZM21.3331 9.5646C21.7446 9.93293 22.3768 9.89791 22.7451 9.48638C23.1135 9.07485 23.0784 8.44266 22.6669 8.07433L21.3331 9.5646ZM12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21V19ZM12.01 21C12.5623 21 13.01 20.5523 13.01 20C13.01 19.4477 12.5623 19 12.01 19V21ZM14.6905 17.04C15.099 17.4116 15.7315 17.3817 16.1031 16.9732C16.4748 16.5646 16.4448 15.9322 16.0363 15.5605L14.6905 17.04ZM18.0539 13.3403C18.4624 13.7119 19.0949 13.682 19.4665 13.2734C19.8381 12.8649 19.8082 12.2324 19.3997 11.8608L18.0539 13.3403ZM7.96373 15.5605C7.55518 15.9322 7.52525 16.5646 7.89688 16.9732C8.26851 17.3817 8.90096 17.4116 9.30951 17.04L7.96373 15.5605ZM4.60035 11.8608C4.1918 12.2324 4.16186 12.8649 4.53349 13.2734C4.90512 13.682 5.53757 13.7119 5.94612 13.3403L4.60035 11.8608ZM2.66692 9.5646C5.14445 7.34716 8.41372 6 12 6V4C7.90276 4 4.16313 5.54138 1.3331 8.07433L2.66692 9.5646ZM12 6C15.5863 6 18.8556 7.34716 21.3331 9.5646L22.6669 8.07433C19.8369 5.54138 16.0972 4 12 4V6ZM12 21H12.01V19H12V21ZM12 16C13.0367 16 13.9793 16.3931 14.6905 17.04L16.0363 15.5605C14.9713 14.5918 13.5536 14 12 14V16ZM12 11C14.3319 11 16.4546 11.8855 18.0539 13.3403L19.3997 11.8608C17.4466 10.0842 14.8487 9 12 9V11ZM9.30951 17.04C10.0207 16.3931 10.9633 16 12 16V14C10.4464 14 9.02873 14.5918 7.96373 15.5605L9.30951 17.04ZM5.94612 13.3403C7.54545 11.8855 9.66816 11 12 11V9C9.15128 9 6.55345 10.0842 4.60035 11.8608L5.94612 13.3403Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const Bluetooth = ({ color }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.476 2.83688C12.817 2.46361 12.0002 2.93967 12.0002 3.69706V9.7748L5.50826 6.35535C5.03257 6.07474 4.41948 6.23289 4.13887 6.70858C3.85826 7.18426 4.01641 7.79736 4.4921 8.07797L11.069 11.5476L4.50594 14.8474C4.02582 15.1203 3.85789 15.7308 4.13084 16.2109C4.4038 16.691 5.01429 16.859 5.4944 16.586L12.0002 13.3189V19.7167C12.0002 20.4905 12.8413 20.9711 13.5079 20.5782L20.1617 16.6569C20.9492 16.1929 20.9494 15.054 20.1622 14.5896L15.0596 11.5795L20.1341 8.69455C20.9441 8.23406 20.9431 7.06641 20.1324 6.60721L13.5085 2.8553C13.4978 2.84896 13.4869 2.84282 13.476 2.83688ZM14.0002 5.43235V9.88117L17.9201 7.65264L14.0002 5.43235ZM14.0002 13.2767V17.9666L17.9774 15.6228L14.0002 13.2767Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const Printers = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={color}
      >
        <g clipPath="url(#clip0_47_42)">
          <path
            d="M19 5.04361C18.4251 4.99987 17.7792 4.99994 17.1188 5.00001H6.88126C6.22079 4.99994 5.57492 4.99987 5 5.04361V5C5 3.34315 6.34315 2 8 2H16C17.6569 2 19 3.34315 19 5V5.04361Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9342 12C10.956 12 10.978 12 11 12H13C13.022 12 13.044 12 13.0658 12C13.9523 12 14.7161 11.9999 15.3278 12.0821C15.9833 12.1703 16.6117 12.369 17.1213 12.8787C17.631 13.3883 17.8297 14.0167 17.9179 14.6722C18.0001 15.2839 18.0001 16.0477 18 16.9342V17.0658C18.0001 17.9523 18.0001 18.7161 17.9179 19.3278C17.8297 19.9833 17.631 20.6117 17.1213 21.1213C16.6117 21.631 15.9833 21.8297 15.3278 21.9179C14.7161 22.0001 13.9523 22.0001 13.0658 22H10.9342C10.0477 22.0001 9.28387 22.0001 8.67221 21.9179C8.0167 21.8297 7.38835 21.631 6.87868 21.1213C6.36902 20.6117 6.17028 19.9833 6.08215 19.3278C5.99991 18.7161 5.99995 17.9523 6 17.0658C6 17.044 6 17.022 6 17C6 16.978 6 16.956 6 16.9342C5.99995 16.0477 5.99991 15.2839 6.08215 14.6722C6.17028 14.0167 6.36902 13.3883 6.87868 12.8787C7.38835 12.369 8.0167 12.1703 8.67221 12.0821C9.28387 11.9999 10.0477 12 10.9342 12Z"
            fill={color}
          />
          <path
            d="M6.93418 6C6.04769 5.99995 5.28388 5.99991 4.67222 6.08215C4.0167 6.17028 3.38835 6.36902 2.87869 6.87868C2.36902 7.38835 2.17028 8.0167 2.08215 8.67221C1.99991 9.28387 1.99995 10.0477 2 10.9342V13.0658C1.99995 13.9523 1.99991 14.7161 2.08215 15.3278C2.17028 15.9833 2.36902 16.6117 2.87869 17.1213C3.44648 17.6891 4.22701 17.8878 5.00334 17.9536C4.99995 17.6809 4.99998 17.4012 5.00001 17.1188C5.00001 16.2599 4.97638 15.3921 5.09107 14.539C5.19402 13.7732 5.44485 12.8983 6.17159 12.1716C6.89833 11.4448 7.77323 11.194 8.53897 11.0911C9.21759 10.9998 10.0375 10.9999 10.8813 11H13.1188C13.9625 10.9999 14.7824 10.9998 15.4611 11.0911C16.2268 11.194 17.1017 11.4448 17.8284 12.1716C18.5552 12.8983 18.806 13.7732 18.909 14.539C19.0236 15.392 19 16.2599 19 17.1187C19 17.4012 19.0001 17.6809 18.9967 17.9536C19.773 17.8878 20.5535 17.6891 21.1213 17.1213C21.631 16.6117 21.8297 15.9833 21.9179 15.3278C22.0001 14.7161 22.0001 13.9523 22 13.0658V10.9342C22.0001 10.0477 22.0001 9.28387 21.9179 8.67221C21.8297 8.0167 21.631 7.38835 21.1213 6.87869C20.6117 6.36902 19.9833 6.17028 19.3278 6.08215C18.7161 5.99991 17.9523 5.99995 17.0658 6H6.93418Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_47_42">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const Energy = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={color}
      >
        <g clipPath="url(#clip0_0_1)">
          <path d="M13 2L4 14H11L9 22L20 9H13L13 2Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_0_1">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const AI = ({ color = "#646B88" }) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={color}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 6V18H6V6H18ZM11.0508 9H9.88209L7.66331 15H8.71765L9.13655 13.827H11.7926L12.2025 15H13.3203L11.0508 9ZM15.1919 9H14.1418V15H15.1919V9ZM10.4576 10.0067L11.5035 13H9.42821L10.4576 10.0067ZM19 15H21V17H19V15ZM7 19H9V21H7V19ZM11 19H13V21H11V19ZM7 3H9V5H7V3ZM15 19H17V21H15V19ZM11 3H13V5H11V3ZM15 3H17V5H15V3ZM19 11H21V13H19V11ZM3 15H5V17H3V15ZM19 7H21V9H19V7ZM3 11H5V13H3V11ZM3 7H5V9H3V7Z"
          fill={color}
        />
      </svg>
    </React.Fragment>
  );
};

export const GreenTick = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          <path
            d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
            fill="#31974D"
          />

          <path
            d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
            fill="#31974D"
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export const Pack = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.18 6.00042L12.93 1.27542C12.6454 1.11783 12.3254 1.03516 12 1.03516C11.6747 1.03516 11.3546 1.11783 11.07 1.27542L2.82001 6.00042C2.53193 6.16498 2.29267 6.40303 2.12665 6.69027C1.96063 6.97751 1.87379 7.30366 1.87501 7.63542V16.5004C1.89658 16.809 1.99415 17.1074 2.15903 17.3692C2.32391 17.6309 2.55099 17.8477 2.82001 18.0004L11.07 22.6654C11.3546 22.823 11.6747 22.9057 12 22.9057C12.3254 22.9057 12.6454 22.823 12.93 22.6654L21.18 18.0004C21.449 17.8477 21.6761 17.6309 21.841 17.3692C22.0059 17.1074 22.1035 16.809 22.125 16.5004V7.57542C22.1158 7.25389 22.0241 6.94012 21.8586 6.66429C21.6931 6.38846 21.4594 6.15984 21.18 6.00042ZM11.07 20.5654L7.87501 18.7654V10.8154L11.07 12.5554V20.5654ZM12 10.9354L8.88001 9.22542L16.095 5.22042L19.23 6.99042L12 10.9354ZM12 2.91042L14.19 4.14042L6.93001 8.17542L4.77001 6.99042L12 2.91042ZM3.75001 8.56542L6.00001 9.79542V17.7004L3.75001 16.5004V8.56542ZM12.93 20.5654V12.5554L20.25 8.56542V16.5004L12.93 20.5654Z"
          fill="white"
          stroke="white"
          strokeWidth="0.00064"
        />
      </svg>
    </React.Fragment>
  );
};

export const PDF = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          d="M59.4294 14.7279V63.9997H5.97388V0H44.7016L51.5614 6.85988L59.4294 14.7279Z"
          fill="#B12A27"
        />
        <path
          d="M30.2077 4.28516H4.57056V15.7562H30.2077V4.28516Z"
          fill="#F2F2F2"
        />
        <path
          d="M13.7664 8.04684C13.6533 7.77359 13.5025 7.52859 13.2953 7.32134C13.088 7.11409 12.8335 6.94447 12.5414 6.83134C12.2399 6.70884 11.9007 6.65234 11.5238 6.65234H8.7063V13.9267H10.1292V11.1846H11.5238C11.9007 11.1846 12.2399 11.1281 12.5414 11.0056C12.8335 10.8925 13.0879 10.723 13.2953 10.5156C13.5027 10.3083 13.6534 10.0727 13.7664 9.79009C13.87 9.51684 13.9267 9.22472 13.9267 8.92322C13.9265 8.61222 13.87 8.32009 13.7664 8.04684ZM12.2304 9.63922C12.0419 9.81822 11.7782 9.91247 11.4578 9.91247H10.1292V7.91484H11.4578C11.7782 7.91484 12.042 8.00909 12.2304 8.19747C12.4094 8.37647 12.5037 8.62147 12.5037 8.92297C12.5038 9.21522 12.4095 9.46022 12.2304 9.63922Z"
          fill="#B12A27"
        />
        <path
          d="M20.5696 9.46972C20.5602 9.21534 20.5507 8.98922 20.5225 8.78184C20.4942 8.57447 20.4471 8.38609 20.3811 8.20709C20.3151 8.03747 20.2304 7.86784 20.1172 7.71709C19.8629 7.34959 19.5519 7.07634 19.2032 6.90672C18.8451 6.73709 18.4211 6.65234 17.9217 6.65234H15.3022V13.9267H17.9217C18.4211 13.9267 18.8451 13.842 19.2032 13.6723C19.5519 13.5027 19.8629 13.2295 20.1172 12.862C20.2304 12.7112 20.3151 12.5416 20.3811 12.372C20.4471 12.193 20.4942 12.0045 20.5225 11.7972C20.5507 11.59 20.5601 11.3637 20.5696 11.1093C20.579 10.8643 20.579 10.5911 20.579 10.2896C20.579 9.98809 20.579 9.71472 20.5696 9.46972ZM19.1467 11.0246C19.1467 11.2413 19.1279 11.411 19.109 11.5617C19.0901 11.7031 19.0619 11.835 19.0242 11.9292C18.9866 12.0328 18.93 12.1271 18.8641 12.2118C18.6285 12.5133 18.2705 12.6547 17.7994 12.6547H16.7157V7.91497H17.7994C18.2705 7.91497 18.6286 8.06572 18.8641 8.36722C18.9301 8.45197 18.9866 8.53684 19.0242 8.64047C19.0619 8.74409 19.0902 8.86659 19.109 9.01734C19.1279 9.15872 19.1467 9.33772 19.1467 9.54497C19.1561 9.75234 19.1561 10.0067 19.1561 10.2893C19.1562 10.5722 19.1562 10.8172 19.1467 11.0246Z"
          fill="#B12A27"
        />
        <path
          d="M26.6473 7.91497V6.65234H21.8511V13.9267H23.2739V10.9775H26.1479V9.70534H23.2739V7.91497H26.6473Z"
          fill="#B12A27"
        />
        <path
          d="M13.7664 8.04684C13.6533 7.77359 13.5025 7.52859 13.2953 7.32134C13.088 7.11409 12.8335 6.94447 12.5414 6.83134C12.2399 6.70884 11.9007 6.65234 11.5238 6.65234H8.7063V13.9267H10.1292V11.1846H11.5238C11.9007 11.1846 12.2399 11.1281 12.5414 11.0056C12.8335 10.8925 13.0879 10.723 13.2953 10.5156C13.5027 10.3083 13.6534 10.0727 13.7664 9.79009C13.87 9.51684 13.9267 9.22472 13.9267 8.92322C13.9265 8.61222 13.87 8.32009 13.7664 8.04684ZM12.2304 9.63922C12.0419 9.81822 11.7782 9.91247 11.4578 9.91247H10.1292V7.91484H11.4578C11.7782 7.91484 12.042 8.00909 12.2304 8.19747C12.4094 8.37647 12.5037 8.62147 12.5037 8.92297C12.5038 9.21522 12.4095 9.46022 12.2304 9.63922Z"
          fill="#B12A27"
        />
        <path
          opacity="0.08"
          d="M59.4294 14.7274V63.9992H5.97388V52.4469L30.9631 27.4576L32.4425 25.9783L33.2623 25.1584L34.6286 23.7921L36.2494 22.1714L51.5614 6.85938L59.4294 14.7274Z"
          fill="#040000"
        />
        <path d="M59.4292 14.7295H44.6997V0L59.4292 14.7295Z" fill="#771B1B" />
        <path
          d="M51.797 46.3325C51.486 45.786 51.062 45.2678 50.5344 44.7967C50.101 44.4009 49.5921 44.0334 49.0172 43.6942C46.6992 42.3279 43.3919 41.6683 38.8971 41.6683H38.4449C38.1999 41.4422 37.9455 41.216 37.6816 40.9804C35.9761 39.4445 34.6192 37.7767 33.5639 35.9204C35.6369 31.3503 36.6262 27.2797 36.5037 23.812C36.4849 23.2278 36.4001 22.6813 36.2494 22.1724C36.0232 21.3527 35.6464 20.627 35.1186 20.0334C35.1092 20.024 35.1092 20.024 35.0997 20.0145C34.2611 19.0723 33.0927 18.5352 31.9054 18.5352C30.7086 18.5352 29.6062 19.0534 28.8052 20.0052C28.0137 20.9474 27.5897 22.2384 27.5709 23.7554C27.5426 26.0734 27.731 28.2689 28.1269 30.2948C28.1645 30.455 28.1929 30.6152 28.2305 30.7753C28.6262 32.6128 29.2105 34.3559 29.9642 35.9767C29.0785 37.7764 28.1834 39.3312 27.5614 40.3865C27.0902 41.1875 26.572 42.0262 26.0349 42.8648C23.6132 43.2983 21.559 43.8259 19.7687 44.4855C17.3471 45.3619 15.406 46.4925 14.0114 47.84C13.1067 48.7069 12.4942 49.6304 12.1927 50.5915C11.8724 51.5809 11.8912 52.5703 12.2492 53.456C12.579 54.2758 13.1726 54.9637 13.9642 55.4348C14.1527 55.5479 14.3506 55.642 14.5579 55.7269C15.161 55.9719 15.8205 56.1038 16.5084 56.1038C18.1009 56.1038 19.7404 55.4159 21.1255 54.1815C23.7074 51.8729 26.374 48.1604 27.9476 45.814C29.2385 45.6162 30.6425 45.4465 32.2256 45.2769C34.0914 45.0884 35.7404 44.9754 37.2386 44.9188C37.7004 45.3334 38.1432 45.7292 38.5672 46.106C40.923 48.2073 42.7132 49.7244 44.334 50.7892C44.334 50.7985 44.3434 50.7985 44.3529 50.7985C44.9936 51.2225 45.6061 51.5712 46.2186 51.8539C46.9065 52.1743 47.6037 52.3439 48.3199 52.3439C49.2245 52.3439 50.0725 52.0707 50.7792 51.5713C51.4954 51.053 52.0136 50.3087 52.2492 49.47C52.5225 48.462 52.3624 47.3408 51.797 46.3325ZM30.9631 27.4587C30.8312 26.2902 30.7746 25.0747 30.7935 23.7932C30.8124 22.5777 31.2552 21.7578 31.9054 21.7578C32.3954 21.7578 32.9136 22.2007 33.1491 23.0487C33.2151 23.303 33.2622 23.5952 33.2716 23.9249C33.2905 24.3207 33.281 24.7353 33.2622 25.1593C33.2057 26.356 32.9984 27.628 32.6404 28.9944C32.4236 29.8708 32.141 30.7848 31.7924 31.7364C31.3966 30.3985 31.1139 28.9757 30.9631 27.4587ZM15.2459 52.2594C15.0856 51.8637 15.2647 51.1004 16.2447 50.1582C17.743 48.7259 20.0892 47.5952 23.359 46.7377C22.7371 47.5857 22.1246 48.3584 21.531 49.065C20.6264 50.158 19.7595 51.0815 18.9774 51.7788C18.3084 52.3818 17.5734 52.7588 16.8761 52.853C16.7536 52.8719 16.6311 52.8813 16.5086 52.8813C15.896 52.8814 15.3966 52.6364 15.2459 52.2594ZM30.3035 42.243L30.3695 42.1394L30.2659 42.1583C30.2847 42.1112 30.313 42.064 30.3412 42.0264C30.737 41.3574 31.2364 40.4999 31.7735 39.5105L31.8206 39.6142L31.9431 39.3598C32.3389 39.9252 32.7724 40.4812 33.2246 41.0182C33.4414 41.2725 33.6675 41.5175 33.8936 41.7625L33.7429 41.7719L33.8747 41.8944C33.4884 41.9227 33.0832 41.9604 32.678 41.998C32.4236 42.0263 32.1597 42.0452 31.8959 42.0734C31.3495 42.1299 30.8124 42.1865 30.3035 42.243ZM46.1621 48.1228C45.0407 47.4067 43.7876 46.3984 42.2422 45.0509C44.4377 45.277 46.1621 45.7577 47.3871 46.4738C47.9242 46.7848 48.3294 47.1052 48.6026 47.416C49.0549 47.8965 49.2151 48.33 49.1302 48.6222C49.0549 48.9143 48.7251 49.1122 48.3199 49.1122C48.0842 49.1122 47.8394 49.0557 47.5849 48.9332C47.1514 48.7259 46.6991 48.4714 46.2186 48.1605C46.1997 48.1605 46.181 48.1417 46.1621 48.1228Z"
          fill="#F2F2F2"
        />
      </svg>
    </React.Fragment>
  );
};

export const DownloadSmall = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_68_47)">
          <path
            d="M20.6667 20.668H3.33341C3.1566 20.668 2.98703 20.7382 2.86201 20.8632C2.73699 20.9883 2.66675 21.1578 2.66675 21.3346C2.66675 21.5114 2.73699 21.681 2.86201 21.806C2.98703 21.9311 3.1566 22.0013 3.33341 22.0013H20.6667C20.8436 22.0013 21.0131 21.9311 21.1382 21.806C21.2632 21.681 21.3334 21.5114 21.3334 21.3346C21.3334 21.1578 21.2632 20.9883 21.1382 20.8632C21.0131 20.7382 20.8436 20.668 20.6667 20.668Z"
            fill="white"
            stroke="white"
            strokeWidth="0.00064"
          />
          <path
            d="M11.9999 19.6546L19.0732 12.5813C19.1824 12.4538 19.2395 12.2897 19.233 12.1219C19.2266 11.9542 19.157 11.795 19.0383 11.6763C18.9195 11.5575 18.7604 11.488 18.5926 11.4815C18.4248 11.475 18.2608 11.5321 18.1332 11.6413L12.6666 17.1013V3.33464C12.6666 3.15782 12.5963 2.98826 12.4713 2.86323C12.3463 2.73821 12.1767 2.66797 11.9999 2.66797C11.8231 2.66797 11.6535 2.73821 11.5285 2.86323C11.4035 2.98826 11.3332 3.15782 11.3332 3.33464V17.1013L5.87322 11.6413C5.81346 11.5715 5.73991 11.5148 5.6572 11.4748C5.5745 11.4348 5.48441 11.4123 5.39259 11.4088C5.30078 11.4052 5.20923 11.4207 5.12368 11.4542C5.03813 11.4877 4.96043 11.5386 4.89546 11.6035C4.83049 11.6685 4.77965 11.7462 4.74613 11.8318C4.71262 11.9173 4.69715 12.0089 4.70069 12.1007C4.70424 12.1925 4.72673 12.2826 4.76674 12.3653C4.80676 12.448 4.86344 12.5215 4.93322 12.5813L11.9999 19.6546Z"
            fill="white"
            stroke="white"
            strokeWidth="0.00064"
          />
          <path d="M24 0H0V24H24V0Z" stroke="white" strokeWidth="0.00064" />
        </g>
        <defs>
          <clipPath id="clip0_68_47">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const Sent = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <g clipPath="url(#clip0_73_6)">
          <path
            opacity="0.1"
            d="M9.17 0H25.8256C30.8919 0 35 4.10813 35 9.17V25.8256C35 30.8919 30.8919 35 25.83 35H9.17C4.10813 35 0 30.8919 0 25.83V9.17C0 4.10813 4.10813 0 9.17 0Z"
            fill="#31974D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5 6.10156C11.2044 6.10156 6.10315 11.2028 6.10315 17.4984C6.10315 19.5678 6.6544 21.5103 7.62127 23.1816C7.81815 23.5228 7.85315 23.9384 7.6869 24.2928L6.71565 26.3884C6.11627 27.5172 6.9344 28.8953 8.2294 28.8953H17.5044C23.8 28.8953 28.9013 23.7941 28.9013 17.4984C28.8969 11.2028 23.7956 6.10156 17.5 6.10156ZM21.7 14.3878C22.1594 14.8166 22.1813 15.5384 21.7525 15.9978L17.4781 20.5566C17.0713 20.9941 16.3931 21.0378 15.9294 20.6616L13.3656 18.5922C12.8756 18.1984 12.8013 17.4809 13.195 16.9909C13.5888 16.5009 14.3063 16.4266 14.7963 16.8203L16.5375 18.2291L20.0856 14.4447C20.5188 13.9809 21.2406 13.9591 21.7 14.3878Z"
            fill="#31974D"
          />
        </g>
        <defs>
          <clipPath id="clip0_73_6">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  );
};

export const History = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#ffffff"
        strokeWidth="0.00024000000000000003"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M3 5.67541V3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3V7C1 8.10457 1.89543 9 3 9H7C7.55229 9 8 8.55229 8 8C8 7.44772 7.55229 7 7 7H4.52186C4.54218 6.97505 4.56157 6.94914 4.57995 6.92229C5.621 5.40094 7.11009 4.22911 8.85191 3.57803C10.9074 2.80968 13.173 2.8196 15.2217 3.6059C17.2704 4.3922 18.9608 5.90061 19.9745 7.8469C20.9881 9.79319 21.2549 12.043 20.7247 14.1724C20.1945 16.3018 18.9039 18.1638 17.0959 19.4075C15.288 20.6513 13.0876 21.1909 10.9094 20.9247C8.73119 20.6586 6.72551 19.605 5.27028 17.9625C4.03713 16.5706 3.27139 14.8374 3.06527 13.0055C3.00352 12.4566 2.55674 12.0079 2.00446 12.0084C1.45217 12.0088 0.995668 12.4579 1.04626 13.0078C1.25994 15.3309 2.2082 17.5356 3.76666 19.2946C5.54703 21.3041 8.00084 22.5931 10.6657 22.9188C13.3306 23.2444 16.0226 22.5842 18.2345 21.0626C20.4464 19.541 22.0254 17.263 22.6741 14.6578C23.3228 12.0526 22.9963 9.30013 21.7562 6.91897C20.5161 4.53782 18.448 2.69239 15.9415 1.73041C13.4351 0.768419 10.6633 0.756291 8.14853 1.69631C6.06062 2.47676 4.26953 3.86881 3 5.67541Z"
            fill="#ffffff"
          />{" "}
          <path
            d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2344 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.546 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z"
            fill="#ffffff"
          />{" "}
        </g>
      </svg>
    </React.Fragment>
  );
};

export const Send2 = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#ffffff"
        width="24"
        height="24"
        viewBox="0 0 256 256"
        id="Flat"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g id="SVGRepo_iconCarrier">
          {" "}
          <path d="M227.82129,47.9209,175.26758,234.249A15.86994,15.86994,0,0,1,161.207,245.84961q-.69581.05859-1.38379.05762a15.85235,15.85235,0,0,1-14.41406-9.15235l-36.916-77.93359,53.28223-53.28223a8.00052,8.00052,0,0,0-11.31445-11.31445L97.17871,147.50684l-77.93359-36.916A15.9995,15.9995,0,0,1,21.751,80.73242L208.0791,28.17871A15.99909,15.99909,0,0,1,227.82129,47.9209Z" />{" "}
        </g>
      </svg>
    </React.Fragment>
  );
};

export const Save2 = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12.89 5.87891H5.10999C3.39999 5.87891 2 7.2789 2 8.9889V20.3489C2 21.7989 3.04 22.4189 4.31 21.7089L8.23999 19.5189C8.65999 19.2889 9.34 19.2889 9.75 19.5189L13.68 21.7089C14.95 22.4189 15.99 21.7989 15.99 20.3489V8.9889C16 7.2789 14.6 5.87891 12.89 5.87891Z"
          stroke="white"
          strokeWidth="1.28"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 8.9889V20.3489C16 21.7989 14.96 22.4089 13.69 21.7089L9.76001 19.5189C9.34001 19.2889 8.65999 19.2889 8.23999 19.5189L4.31 21.7089C3.04 22.4089 2 21.7989 2 20.3489V8.9889C2 7.2789 3.39999 5.87891 5.10999 5.87891H12.89C14.6 5.87891 16 7.2789 16 8.9889Z"
          stroke="white"
          strokeWidth="1.28"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 5.10999V16.47C22 17.92 20.96 18.53 19.69 17.83L16 15.77V8.98999C16 7.27999 14.6 5.88 12.89 5.88H8V5.10999C8 3.39999 9.39999 2 11.11 2H18.89C20.6 2 22 3.39999 22 5.10999Z"
          stroke="white"
          strokeWidth="1.28"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  );
};

export const Dispatch = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2.23737 2.28869C1.84442 2.1577 1.41968 2.37007 1.28869 2.76303C1.15771 3.15599 1.37008 3.58073 1.76303 3.71171L2.02794 3.80002C2.70435 4.02548 3.15155 4.17575 3.481 4.32901C3.79296 4.47413 3.92784 4.59093 4.01426 4.71083C4.10068 4.83073 4.16883 4.99562 4.20785 5.33746C4.24907 5.69847 4.2502 6.17024 4.2502 6.88324V9.55508C4.25018 10.9226 4.25017 12.0249 4.36673 12.8919C4.48774 13.792 4.74664 14.5499 5.34855 15.1518C5.95047 15.7537 6.70834 16.0126 7.60845 16.1336C8.47542 16.2502 9.57773 16.2502 10.9453 16.2502H18.0002C18.4144 16.2502 18.7502 15.9144 18.7502 15.5002C18.7502 15.0859 18.4144 14.7502 18.0002 14.7502H11.0002C9.56479 14.7502 8.56367 14.7486 7.80832 14.647C7.07455 14.5484 6.68598 14.3679 6.40921 14.0912C6.17403 13.856 6.00839 13.54 5.9034 13.0002H16.0222C16.9817 13.0002 17.4614 13.0002 17.8371 12.7524C18.2128 12.5047 18.4017 12.0638 18.7797 11.1819L19.2082 10.1819C20.0177 8.29314 20.4225 7.34873 19.9779 6.67446C19.5333 6.0002 18.5058 6.0002 16.4508 6.0002H5.74526C5.73936 5.69251 5.72644 5.41491 5.69817 5.16732C5.64282 4.6825 5.52222 4.23764 5.23112 3.83376C4.94002 3.42989 4.55613 3.1748 4.1137 2.96897C3.69746 2.77534 3.16814 2.59892 2.54176 2.39015L2.23737 2.28869Z"
          fill="#F93E3E"
        />
        <path
          d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z"
          fill="#F93E3E"
        />
        <path
          d="M16.5 18C17.3284 18 18 18.6715 18 19.5C18 20.3284 17.3284 21 16.5 21C15.6716 21 15 20.3284 15 19.5C15 18.6715 15.6716 18 16.5 18Z"
          fill="#F93E3E"
        />
      </svg>
    </React.Fragment>
  );
};

export const Maintanance = () => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M24.9 35H10.1C4.5 35 0 30.5 0 24.9V10.1C0 4.5 4.5 0 10.1 0H24.9C30.5 0 35 4.5 35 10.1V24.9C35 30.5 30.5 35 24.9 35Z"
          fill="#416AB3"
          opacity="0.12"
        />

        <path
          d="M31.3 16.2c-.1-.7-.4-1.1-1-1.2-.4-.1-.8-.2-1.1-.4-.1 0-.2-.1-.2-.2-.3-.8-.7-1.6-1-2.4 0-.1 0-.2 0-.3.2-.4.4-.9.7-1.3.2-.4.2-.8-.1-1.1-.7-.9-1.5-1.8-2.4-2.5-.4-.3-.8-.3-1.2-.1-.4.2-.8.4-1.3.7-.1 0-.2 0-.3 0-.8-.4-1.6-.8-2.4-1-.2 0-.2-.1-.3-.3-.1-.5-.3-1-.5-1.4-.1-.4-.4-.6-.7-.7-1.2-.2-2.4-.2-3.6 0-.4.1-.7.3-.8.7-.1.4-.3.9-.4 1.3 0 .2-.1.2-.3.3-.8.3-1.6.7-2.4 1-.1 0-.2 0-.3 0-.4-.2-.9-.4-1.3-.7-.4-.2-.8-.2-1.2 0-1 .7-1.8 1.5-2.5 2.5-.2.4-.2.8 0 1.1.2.4.5.9.7 1.3 0 .1 0 .2 0 .3-.3.8-.7 1.6-1 2.4 0 .1-.1.2-.2.2-.4.2-.9.3-1.4.4-.5.1-.7.4-.8.9-.2 1.1-.1 2.1 0 3.2.1.6.3 1 1 1.2.4.1.8.2 1.2.4.1 0 .2.1.2.2.3.8.7 1.6 1 2.4 0 .1 0 .2 0 .3-.2.4-.4.9-.6 1.3-.2.4-.2.8.1 1.1.7.9 1.5 1.8 2.5 2.4.4.3.7.3 1.1.1.4-.2.9-.5 1.3-.7.1 0 .2 0 .3 0 .8.3 1.6.7 2.4 1 .2.1.2.1.3.3.1.5.3.9.4 1.4.1.4.4.6.7.7 1.2.2 2.4.2 3.6 0 .5-.1.8-.4.9-.8.1-.4.3-.9.4-1.3 0-.1.1-.2.2-.2.8-.3 1.6-.7 2.4-1 .1 0 .2 0 .3 0 .4.2.8.4 1.3.6.2.1.4.1.6.2.2-.1.4-.1.6-.3 1-.7 1.8-1.5 2.5-2.5.3-.4.3-.7.1-1.1-.2-.4-.5-.9-.7-1.3 0-.1-.1-.2 0-.3.4-.8.8-1.6 1-2.4 0-.1.1-.2.2-.2.5-.2.9-.3 1.4-.4.4-.1.7-.4.7-.9.1-1.1 0-2.2-.1-3.2ZM17.6 27.8c-5.6 0-10.1-4.5-10.1-10.1S12 7.5 17.6 7.5 27.7 12 27.7 17.6 23.1 27.8 17.6 27.8Z"
          fill="#416AB3"
        />

        <path
          d="M22.1 23.5c0 .1 0 .2.2.3l1.3.7.2.1v.1c-.3.1-.6.1-.9.1-.8 0-1.5-.3-2-1-.2-.3-.2-.6-.3-.9-.1-.5-.3-.9-.7-1.2l-.4-.4-.1-.1-.1-.1c-.9-.9-1.9-1.7-2.8-2.6l-.1-.1c-.9-.8-1.8-1.6-2.7-2.5-.4-.3-.8-.5-1.2-.5-1 0-1.7-.5-2.1-1.3-.1-.3-.2-.6-.3-.9.5.3 1 .5 1.5.8.2.1.3.1.5 0 .5-.4.7-.9.8-1.5 0-.1 0-.2-.2-.3l-1.3-.7-.2-.1v-.1c.3-.1.6-.1.9-.1.8 0 1.5.3 2 1 .2.3.2.6.3.9.1.5.3.9.7 1.2l4 3.7.3.3 1.8 1.7c.4.3.8.5 1.2.5 1 0 1.7.5 2.1 1.3.1.3.2.6.3.9-.5-.3-1-.5-1.5-.8-.2-.1-.3-.1-.5 0-.3.4-.5.9-.6 1.5Z"
          fill="#416AB3"
        />

        <path
          d="M17.9 15.9l1.3-1.3c.3-.4.5-.8.5-1.3 0-.6-.6-1.1-1.2-1.1-.6 0-1.3.1-1.9.1h-.4c-.2 0-.2-.1-.1-.3l.2-.2c1.5-.9 3-1.3 4.7-.7.5.2.9.4 1.2.8l1.3 1.3c.1.1.2.3.1.5-.1.2 0 .4.2.6.2.2.3.3.6.2.2-.1.3 0 .5.1l.7.7c.2.2.2.3 0 .4l-1.5 1.5c-.2.2-.3.2-.5 0l-.7-.7c-.1-.1-.1-.2-.1-.3.1-.5-.2-.9-.7-.9-.4 0-.6.2-.9.3-.6.3-1 .9-1.5 1.3l-.2.2-1.1-1.4Z"
          fill="#416AB3"
        />

        <path
          d="M15.1 18.4l1.7 1.6-1.1 1.1-2.6 2.6c-.6.6-1.4.5-1.8-.2-.3-.5-.2-1 .2-1.5l2.1-2.1 1.5-1.5Z"
          fill="#416AB3"
        />
      </svg>
    </React.Fragment>
  );
};
